(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("@sm360/widget-commons-core-services"), require("lodash"), require("@sm360/widget-commons-general"), require("@sm360/widget-commons-forms"), require("immutable"), require("@sm360/widget-commons-basic-components"));
	else if(typeof define === 'function' && define.amd)
		define("commons-vehicle", ["react", "@sm360/widget-commons-core-services", "_", "@sm360/widget-commons-general", "@sm360/widget-commons-forms", "immutable", "@sm360/widget-commons-basic-components"], factory);
	else if(typeof exports === 'object')
		exports["commons-vehicle"] = factory(require("react"), require("@sm360/widget-commons-core-services"), require("lodash"), require("@sm360/widget-commons-general"), require("@sm360/widget-commons-forms"), require("immutable"), require("@sm360/widget-commons-basic-components"));
	else
		root["CommonsVehicle"] = factory(root["React"], root["CommonsCoreServices"], root["_"], root["CommonsGeneral"], root["CommonsForms"], root["Immutable"], root["CommonsBasicComponents"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE__sm360_widget_commons_core_services__, __WEBPACK_EXTERNAL_MODULE_lodash__, __WEBPACK_EXTERNAL_MODULE__sm360_widget_commons_general__, __WEBPACK_EXTERNAL_MODULE__sm360_widget_commons_forms__, __WEBPACK_EXTERNAL_MODULE_immutable__, __WEBPACK_EXTERNAL_MODULE__sm360_widget_commons_basic_components__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ({

/***/ "../../node_modules/@sm360/lead-submission-fetch-clientapi/dist/api.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * Lead Submission
 * Lead Submission Microservice
 *
 * OpenAPI spec version: 0.1.3
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var url = __webpack_require__("../../node_modules/url/url.js");
var portableFetch = __webpack_require__("../../node_modules/portable-fetch/fetch-npm-browserify.js");
var BASE_PATH = "https://service-lead-submission.sm360.ca".replace(/\/+$/, "");
/**
 *
 * @export
 */
exports.COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};
/**
 *
 * @export
 * @class BaseAPI
 */
var BaseAPI = /** @class */ (function () {
    function BaseAPI(configuration, basePath, fetch) {
        if (basePath === void 0) { basePath = BASE_PATH; }
        if (fetch === void 0) { fetch = portableFetch; }
        this.basePath = basePath;
        this.fetch = fetch;
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
    return BaseAPI;
}());
exports.BaseAPI = BaseAPI;
;
/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
var RequiredError = /** @class */ (function (_super) {
    __extends(RequiredError, _super);
    function RequiredError(field, msg) {
        var _this = _super.call(this, msg) || this;
        _this.field = field;
        return _this;
    }
    return RequiredError;
}(Error));
exports.RequiredError = RequiredError;
/**
 * AttachmentApi - fetch parameter creator
 * @export
 */
exports.AttachmentApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Upload file to attach later on lead submission
         * @param {any} file File to upload
         * @param {number} organizationId Id of the organization in which the Lead is submitted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upload: function (file, organizationId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file', 'Required parameter file was null or undefined when calling upload.');
            }
            // verify required parameter 'organizationId' is not null or undefined
            if (organizationId === null || organizationId === undefined) {
                throw new RequiredError('organizationId', 'Required parameter organizationId was null or undefined when calling upload.');
            }
            var localVarPath = "/upload";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            var localVarFormParams = new url.URLSearchParams();
            // authentication oidc required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oidc", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }
            if (file !== undefined) {
                localVarFormParams.set('file', file);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams.toString();
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AttachmentApi - functional programming interface
 * @export
 */
exports.AttachmentApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Upload file to attach later on lead submission
         * @param {any} file File to upload
         * @param {number} organizationId Id of the organization in which the Lead is submitted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upload: function (file, organizationId, options) {
            var localVarFetchArgs = exports.AttachmentApiFetchParamCreator(configuration).upload(file, organizationId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * AttachmentApi - factory interface
 * @export
 */
exports.AttachmentApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary Upload file to attach later on lead submission
         * @param {any} file File to upload
         * @param {number} organizationId Id of the organization in which the Lead is submitted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upload: function (file, organizationId, options) {
            return exports.AttachmentApiFp(configuration).upload(file, organizationId, options)(fetch, basePath);
        },
    };
};
/**
 * AttachmentApi - object-oriented interface
 * @export
 * @class AttachmentApi
 * @extends {BaseAPI}
 */
var AttachmentApi = /** @class */ (function (_super) {
    __extends(AttachmentApi, _super);
    function AttachmentApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Upload file to attach later on lead submission
     * @param {any} file File to upload
     * @param {number} organizationId Id of the organization in which the Lead is submitted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentApi
     */
    AttachmentApi.prototype.upload = function (file, organizationId, options) {
        return exports.AttachmentApiFp(this.configuration).upload(file, organizationId, options)(this.fetch, this.basePath);
    };
    return AttachmentApi;
}(BaseAPI));
exports.AttachmentApi = AttachmentApi;
/**
 * LeadApi - fetch parameter creator
 * @export
 */
exports.LeadApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Submit a new lead
         * @param {LeadSubmissionRequest} leadSubmissionRequest Lead object to submit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        send: function (leadSubmissionRequest, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'leadSubmissionRequest' is not null or undefined
            if (leadSubmissionRequest === null || leadSubmissionRequest === undefined) {
                throw new RequiredError('leadSubmissionRequest', 'Required parameter leadSubmissionRequest was null or undefined when calling send.');
            }
            var localVarPath = "/send";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oidc required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oidc", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("LeadSubmissionRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(leadSubmissionRequest || {}) : (leadSubmissionRequest || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * LeadApi - functional programming interface
 * @export
 */
exports.LeadApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Submit a new lead
         * @param {LeadSubmissionRequest} leadSubmissionRequest Lead object to submit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        send: function (leadSubmissionRequest, options) {
            var localVarFetchArgs = exports.LeadApiFetchParamCreator(configuration).send(leadSubmissionRequest, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * LeadApi - factory interface
 * @export
 */
exports.LeadApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary Submit a new lead
         * @param {LeadSubmissionRequest} leadSubmissionRequest Lead object to submit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        send: function (leadSubmissionRequest, options) {
            return exports.LeadApiFp(configuration).send(leadSubmissionRequest, options)(fetch, basePath);
        },
    };
};
/**
 * LeadApi - object-oriented interface
 * @export
 * @class LeadApi
 * @extends {BaseAPI}
 */
var LeadApi = /** @class */ (function (_super) {
    __extends(LeadApi, _super);
    function LeadApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Submit a new lead
     * @param {LeadSubmissionRequest} leadSubmissionRequest Lead object to submit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadApi
     */
    LeadApi.prototype.send = function (leadSubmissionRequest, options) {
        return exports.LeadApiFp(this.configuration).send(leadSubmissionRequest, options)(this.fetch, this.basePath);
    };
    return LeadApi;
}(BaseAPI));
exports.LeadApi = LeadApi;


/***/ }),

/***/ "../../node_modules/@sm360/lead-submission-fetch-clientapi/dist/configuration.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// tslint:disable
/**
 * Lead Submission
 * Lead Submission Microservice
 *
 * OpenAPI spec version: 0.1.3
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Configuration = /** @class */ (function () {
    function Configuration(param) {
        if (param === void 0) { param = {}; }
        this.apiKey = param.apiKey;
        this.username = param.username;
        this.password = param.password;
        this.accessToken = param.accessToken;
        this.basePath = param.basePath;
    }
    return Configuration;
}());
exports.Configuration = Configuration;


/***/ }),

/***/ "../../node_modules/@sm360/lead-submission-fetch-clientapi/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// tslint:disable
/**
 * Lead Submission
 * Lead Submission Microservice
 *
 * OpenAPI spec version: 0.1.3
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__("../../node_modules/@sm360/lead-submission-fetch-clientapi/dist/api.js"));
__export(__webpack_require__("../../node_modules/@sm360/lead-submission-fetch-clientapi/dist/configuration.js"));


/***/ }),

/***/ "../../node_modules/axios/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("../../node_modules/axios/lib/axios.js");

/***/ }),

/***/ "../../node_modules/axios/lib/adapters/xhr.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");
var settle = __webpack_require__("../../node_modules/axios/lib/core/settle.js");
var buildURL = __webpack_require__("../../node_modules/axios/lib/helpers/buildURL.js");
var parseHeaders = __webpack_require__("../../node_modules/axios/lib/helpers/parseHeaders.js");
var isURLSameOrigin = __webpack_require__("../../node_modules/axios/lib/helpers/isURLSameOrigin.js");
var createError = __webpack_require__("../../node_modules/axios/lib/core/createError.js");
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__("../../node_modules/axios/lib/helpers/btoa.js");

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__("../../node_modules/axios/lib/helpers/cookies.js");

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ "../../node_modules/axios/lib/axios.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");
var bind = __webpack_require__("../../node_modules/axios/lib/helpers/bind.js");
var Axios = __webpack_require__("../../node_modules/axios/lib/core/Axios.js");
var defaults = __webpack_require__("../../node_modules/axios/lib/defaults.js");

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__("../../node_modules/axios/lib/cancel/Cancel.js");
axios.CancelToken = __webpack_require__("../../node_modules/axios/lib/cancel/CancelToken.js");
axios.isCancel = __webpack_require__("../../node_modules/axios/lib/cancel/isCancel.js");

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__("../../node_modules/axios/lib/helpers/spread.js");

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),

/***/ "../../node_modules/axios/lib/cancel/Cancel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ "../../node_modules/axios/lib/cancel/CancelToken.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__("../../node_modules/axios/lib/cancel/Cancel.js");

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ "../../node_modules/axios/lib/cancel/isCancel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ "../../node_modules/axios/lib/core/Axios.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__("../../node_modules/axios/lib/defaults.js");
var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");
var InterceptorManager = __webpack_require__("../../node_modules/axios/lib/core/InterceptorManager.js");
var dispatchRequest = __webpack_require__("../../node_modules/axios/lib/core/dispatchRequest.js");

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ "../../node_modules/axios/lib/core/InterceptorManager.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ "../../node_modules/axios/lib/core/createError.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__("../../node_modules/axios/lib/core/enhanceError.js");

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ "../../node_modules/axios/lib/core/dispatchRequest.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");
var transformData = __webpack_require__("../../node_modules/axios/lib/core/transformData.js");
var isCancel = __webpack_require__("../../node_modules/axios/lib/cancel/isCancel.js");
var defaults = __webpack_require__("../../node_modules/axios/lib/defaults.js");
var isAbsoluteURL = __webpack_require__("../../node_modules/axios/lib/helpers/isAbsoluteURL.js");
var combineURLs = __webpack_require__("../../node_modules/axios/lib/helpers/combineURLs.js");

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ "../../node_modules/axios/lib/core/enhanceError.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),

/***/ "../../node_modules/axios/lib/core/settle.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__("../../node_modules/axios/lib/core/createError.js");

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ "../../node_modules/axios/lib/core/transformData.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),

/***/ "../../node_modules/axios/lib/defaults.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");
var normalizeHeaderName = __webpack_require__("../../node_modules/axios/lib/helpers/normalizeHeaderName.js");

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__("../../node_modules/axios/lib/adapters/xhr.js");
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__("../../node_modules/axios/lib/adapters/xhr.js");
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../node_modules/process/browser.js")))

/***/ }),

/***/ "../../node_modules/axios/lib/helpers/bind.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/btoa.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/buildURL.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/combineURLs.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/cookies.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/isAbsoluteURL.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/isURLSameOrigin.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/normalizeHeaderName.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/parseHeaders.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/spread.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ "../../node_modules/axios/lib/utils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("../../node_modules/axios/lib/helpers/bind.js");
var isBuffer = __webpack_require__("../../node_modules/is-buffer/index.js");

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),

/***/ "../../node_modules/base-64/base64.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! http://mths.be/base64 v0.1.0 by @mathias | MIT license */
;(function(root) {

	// Detect free variables `exports`.
	var freeExports = typeof exports == 'object' && exports;

	// Detect free variable `module`.
	var freeModule = typeof module == 'object' && module &&
		module.exports == freeExports && module;

	// Detect free variable `global`, from Node.js or Browserified code, and use
	// it as `root`.
	var freeGlobal = typeof global == 'object' && global;
	if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
		root = freeGlobal;
	}

	/*--------------------------------------------------------------------------*/

	var InvalidCharacterError = function(message) {
		this.message = message;
	};
	InvalidCharacterError.prototype = new Error;
	InvalidCharacterError.prototype.name = 'InvalidCharacterError';

	var error = function(message) {
		// Note: the error messages used throughout this file match those used by
		// the native `atob`/`btoa` implementation in Chromium.
		throw new InvalidCharacterError(message);
	};

	var TABLE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	// http://whatwg.org/html/common-microsyntaxes.html#space-character
	var REGEX_SPACE_CHARACTERS = /[\t\n\f\r ]/g;

	// `decode` is designed to be fully compatible with `atob` as described in the
	// HTML Standard. http://whatwg.org/html/webappapis.html#dom-windowbase64-atob
	// The optimized base64-decoding algorithm used is based on @atk’s excellent
	// implementation. https://gist.github.com/atk/1020396
	var decode = function(input) {
		input = String(input)
			.replace(REGEX_SPACE_CHARACTERS, '');
		var length = input.length;
		if (length % 4 == 0) {
			input = input.replace(/==?$/, '');
			length = input.length;
		}
		if (
			length % 4 == 1 ||
			// http://whatwg.org/C#alphanumeric-ascii-characters
			/[^+a-zA-Z0-9/]/.test(input)
		) {
			error(
				'Invalid character: the string to be decoded is not correctly encoded.'
			);
		}
		var bitCounter = 0;
		var bitStorage;
		var buffer;
		var output = '';
		var position = -1;
		while (++position < length) {
			buffer = TABLE.indexOf(input.charAt(position));
			bitStorage = bitCounter % 4 ? bitStorage * 64 + buffer : buffer;
			// Unless this is the first of a group of 4 characters…
			if (bitCounter++ % 4) {
				// …convert the first 8 bits to a single ASCII character.
				output += String.fromCharCode(
					0xFF & bitStorage >> (-2 * bitCounter & 6)
				);
			}
		}
		return output;
	};

	// `encode` is designed to be fully compatible with `btoa` as described in the
	// HTML Standard: http://whatwg.org/html/webappapis.html#dom-windowbase64-btoa
	var encode = function(input) {
		input = String(input);
		if (/[^\0-\xFF]/.test(input)) {
			// Note: no need to special-case astral symbols here, as surrogates are
			// matched, and the input is supposed to only contain ASCII anyway.
			error(
				'The string to be encoded contains characters outside of the ' +
				'Latin1 range.'
			);
		}
		var padding = input.length % 3;
		var output = '';
		var position = -1;
		var a;
		var b;
		var c;
		var d;
		var buffer;
		// Make sure any padding is handled outside of the loop.
		var length = input.length - padding;

		while (++position < length) {
			// Read three bytes, i.e. 24 bits.
			a = input.charCodeAt(position) << 16;
			b = input.charCodeAt(++position) << 8;
			c = input.charCodeAt(++position);
			buffer = a + b + c;
			// Turn the 24 bits into four chunks of 6 bits each, and append the
			// matching character for each of them to the output.
			output += (
				TABLE.charAt(buffer >> 18 & 0x3F) +
				TABLE.charAt(buffer >> 12 & 0x3F) +
				TABLE.charAt(buffer >> 6 & 0x3F) +
				TABLE.charAt(buffer & 0x3F)
			);
		}

		if (padding == 2) {
			a = input.charCodeAt(position) << 8;
			b = input.charCodeAt(++position);
			buffer = a + b;
			output += (
				TABLE.charAt(buffer >> 10) +
				TABLE.charAt((buffer >> 4) & 0x3F) +
				TABLE.charAt((buffer << 2) & 0x3F) +
				'='
			);
		} else if (padding == 1) {
			buffer = input.charCodeAt(position);
			output += (
				TABLE.charAt(buffer >> 2) +
				TABLE.charAt((buffer << 4) & 0x3F) +
				'=='
			);
		}

		return output;
	};

	var base64 = {
		'encode': encode,
		'decode': decode,
		'version': '0.1.0'
	};

	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
			return base64;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}	else if (freeExports && !freeExports.nodeType) {
		if (freeModule) { // in Node.js or RingoJS v0.8.0+
			freeModule.exports = base64;
		} else { // in Narwhal or RingoJS v0.7.0-
			for (var key in base64) {
				base64.hasOwnProperty(key) && (freeExports[key] = base64[key]);
			}
		}
	} else { // in Rhino or a web browser
		root.base64 = base64;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../node_modules/webpack/buildin/module.js")(module), __webpack_require__("../../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../../node_modules/is-buffer/index.js":
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),

/***/ "../../node_modules/node-libs-browser/node_modules/punycode/punycode.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
			return punycode;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../node_modules/webpack/buildin/module.js")(module), __webpack_require__("../../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../../node_modules/performance-now/lib/performance-now.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
(function() {
  var getNanoSeconds, hrtime, loadTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - loadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    loadTime = getNanoSeconds();
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../node_modules/process/browser.js")))

/***/ }),

/***/ "../../node_modules/portable-fetch/fetch-npm-browserify.js":
/***/ (function(module, exports, __webpack_require__) {

// the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.
__webpack_require__("../../node_modules/whatwg-fetch/fetch.js");
module.exports = self.fetch.bind(self);


/***/ }),

/***/ "../../node_modules/process/browser.js":
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ "../../node_modules/prop-types/factoryWithThrowingShims.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__("../../node_modules/prop-types/lib/ReactPropTypesSecret.js");

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ "../../node_modules/prop-types/index.js":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__("../../node_modules/prop-types/factoryWithThrowingShims.js")();
}


/***/ }),

/***/ "../../node_modules/prop-types/lib/ReactPropTypesSecret.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ "../../node_modules/querystring-es3/decode.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};


/***/ }),

/***/ "../../node_modules/querystring-es3/encode.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};


/***/ }),

/***/ "../../node_modules/querystring-es3/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__("../../node_modules/querystring-es3/decode.js");
exports.encode = exports.stringify = __webpack_require__("../../node_modules/querystring-es3/encode.js");


/***/ }),

/***/ "../../node_modules/raf/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__("../../node_modules/raf/node_modules/performance-now/lib/performance-now.js")
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../../node_modules/raf/node_modules/performance-now/lib/performance-now.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../node_modules/process/browser.js")))

/***/ }),

/***/ "../../node_modules/react-collapse/lib/Collapse.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Collapse = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactMotion = __webpack_require__("../../node_modules/react-motion/lib/react-motion.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SPRING_PRECISION = 1;

var WAITING = 'WAITING';
var RESIZING = 'RESIZING';
var RESTING = 'RESTING';
var IDLING = 'IDLING';

var noop = function noop() {
  return null;
};
var css = {
  collapse: 'ReactCollapse--collapse',
  content: 'ReactCollapse--content'
};

var Collapse = exports.Collapse = function (_React$PureComponent) {
  _inherits(Collapse, _React$PureComponent);

  function Collapse(props) {
    _classCallCheck(this, Collapse);

    var _this = _possibleConstructorReturn(this, (Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      currentState: IDLING,
      from: 0,
      to: 0
    };
    return _this;
  }

  _createClass(Collapse, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          isOpened = _props.isOpened,
          forceInitialAnimation = _props.forceInitialAnimation,
          onRest = _props.onRest;

      if (isOpened) {
        var to = this.getTo();
        if (forceInitialAnimation) {
          var from = this.wrapper.clientHeight;
          this.setState({ currentState: RESIZING, from: from, to: to });
        } else {
          this.setState({ currentState: IDLING, from: to, to: to });
        }
      }
      onRest();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.hasNestedCollapse) {
        // For nested collapses we do not need to change to waiting state
        // and should keep `height:auto`
        // Because children will be animated and height will not jump anyway
        // See https://github.com/nkbt/react-collapse/issues/76 for more details
        if (nextProps.isOpened !== this.props.isOpened) {
          // Still go to WAITING state if own isOpened was changed
          this.setState({ currentState: WAITING });
        }
      } else if (this.state.currentState === IDLING && (nextProps.isOpened || this.props.isOpened)) {
        this.setState({ currentState: WAITING });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(_, prevState) {
      var _props2 = this.props,
          isOpened = _props2.isOpened,
          onRest = _props2.onRest,
          onMeasure = _props2.onMeasure;


      if (this.state.currentState === IDLING) {
        onRest();
        return;
      }

      if (prevState.to !== this.state.to) {
        onMeasure({ height: this.state.to, width: this.content.clientWidth });
      }

      var from = this.wrapper.clientHeight;
      var to = isOpened ? this.getTo() : 0;

      if (from !== to) {
        this.setState({ currentState: RESIZING, from: from, to: to });
        return;
      }

      if (this.state.currentState === RESTING || this.state.currentState === WAITING) {
        this.setState({ currentState: IDLING, from: from, to: to });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      cancelAnimationFrame(this.raf);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_reactMotion.Motion, _extends({}, this.getMotionProps(), {
        onRest: this.onRest,
        children: this.renderContent }));
    }
  }]);

  return Collapse;
}(_react2.default.PureComponent);

Collapse.propTypes = {
  isOpened: _propTypes2.default.bool.isRequired,
  springConfig: _propTypes2.default.objectOf(_propTypes2.default.number),
  forceInitialAnimation: _propTypes2.default.bool,

  hasNestedCollapse: _propTypes2.default.bool,

  fixedHeight: _propTypes2.default.number,

  theme: _propTypes2.default.objectOf(_propTypes2.default.string),
  style: _propTypes2.default.object,

  onRender: _propTypes2.default.func,
  onRest: _propTypes2.default.func,
  onMeasure: _propTypes2.default.func,

  children: _propTypes2.default.node.isRequired
};
Collapse.defaultProps = {
  forceInitialAnimation: false,
  hasNestedCollapse: false,
  fixedHeight: -1,
  style: {},
  theme: css,
  onRender: noop,
  onRest: noop,
  onMeasure: noop
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onContentRef = function (content) {
    _this2.content = content;
  };

  this.onWrapperRef = function (wrapper) {
    _this2.wrapper = wrapper;
  };

  this.onRest = function () {
    _this2.raf = requestAnimationFrame(_this2.setResting);
  };

  this.setResting = function () {
    _this2.setState({ currentState: RESTING });
  };

  this.getTo = function () {
    var fixedHeight = _this2.props.fixedHeight;

    return fixedHeight > -1 ? fixedHeight : _this2.content.clientHeight;
  };

  this.getWrapperStyle = function (height) {
    if (_this2.state.currentState === IDLING && _this2.state.to) {
      var fixedHeight = _this2.props.fixedHeight;

      if (fixedHeight > -1) {
        return { overflow: 'hidden', height: fixedHeight };
      }
      return { height: 'auto' };
    }

    if (_this2.state.currentState === WAITING && !_this2.state.to) {
      return { overflow: 'hidden', height: 0 };
    }

    return { overflow: 'hidden', height: Math.max(0, height) };
  };

  this.getMotionProps = function () {
    var springConfig = _this2.props.springConfig;


    return _this2.state.currentState === IDLING ? {
      // When completely stable, instantly jump to the position
      defaultStyle: { height: _this2.state.to },
      style: { height: _this2.state.to }
    } : {
      // Otherwise, animate
      defaultStyle: { height: _this2.state.from },
      style: { height: (0, _reactMotion.spring)(_this2.state.to, _extends({ precision: SPRING_PRECISION }, springConfig)) }
    };
  };

  this.renderContent = function (_ref) {
    var height = _ref.height;

    // eslint-disable-line
    var _props3 = _this2.props,
        _isOpened = _props3.isOpened,
        _springConfig = _props3.springConfig,
        _forceInitialAnimation = _props3.forceInitialAnimation,
        _hasNestedCollapse = _props3.hasNestedCollapse,
        _fixedHeight = _props3.fixedHeight,
        theme = _props3.theme,
        style = _props3.style,
        onRender = _props3.onRender,
        _onRest = _props3.onRest,
        _onMeasure = _props3.onMeasure,
        children = _props3.children,
        props = _objectWithoutProperties(_props3, ['isOpened', 'springConfig', 'forceInitialAnimation', 'hasNestedCollapse', 'fixedHeight', 'theme', 'style', 'onRender', 'onRest', 'onMeasure', 'children']);

    var _state = _this2.state,
        from = _state.from,
        to = _state.to;

    // DANGEROUS, use with caution, never do setState with it

    onRender({ current: height, from: from, to: to });

    return _react2.default.createElement(
      'div',
      _extends({
        ref: _this2.onWrapperRef,
        className: theme.collapse,
        style: _extends({}, _this2.getWrapperStyle(Math.max(0, height)), style)
      }, props),
      _react2.default.createElement(
        'div',
        { ref: _this2.onContentRef, className: theme.content },
        children
      )
    );
  };
};

/***/ }),

/***/ "../../node_modules/react-collapse/lib/UnmountClosed.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnmountClosed = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Collapse = __webpack_require__("../../node_modules/react-collapse/lib/Collapse.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UnmountClosed = exports.UnmountClosed = function (_React$PureComponent) {
  _inherits(UnmountClosed, _React$PureComponent);

  function UnmountClosed(props) {
    _classCallCheck(this, UnmountClosed);

    var _this = _possibleConstructorReturn(this, (UnmountClosed.__proto__ || Object.getPrototypeOf(UnmountClosed)).call(this, props));

    _this.componentWillReceiveProps = function (_ref) {
      var isOpened = _ref.isOpened;

      if (!_this.props.isOpened && isOpened) {
        _this.setState({
          forceInitialAnimation: true,
          shouldUnmount: false
        });
      }
    };

    _this.onRest = function () {
      var _this$props = _this.props,
          isOpened = _this$props.isOpened,
          onRest = _this$props.onRest;


      if (!isOpened) {
        _this.setState({ shouldUnmount: true });
      }
      if (onRest) {
        onRest.apply(undefined, arguments);
      }
    };

    _this.state = {
      shouldUnmount: !_this.props.isOpened,
      forceInitialAnimation: !_this.props.isOpened
    };
    return _this;
  }

  _createClass(UnmountClosed, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isOpened = _props.isOpened,
          _onRest = _props.onRest,
          props = _objectWithoutProperties(_props, ['isOpened', 'onRest']);

      var _state = this.state,
          forceInitialAnimation = _state.forceInitialAnimation,
          shouldUnmount = _state.shouldUnmount;


      return shouldUnmount ? null : _react2.default.createElement(_Collapse.Collapse, _extends({
        forceInitialAnimation: forceInitialAnimation,
        isOpened: isOpened,
        onRest: this.onRest
      }, props));
    }
  }]);

  return UnmountClosed;
}(_react2.default.PureComponent);

UnmountClosed.propTypes = {
  isOpened: _propTypes2.default.bool.isRequired,
  onRest: _propTypes2.default.func
};

/***/ }),

/***/ "../../node_modules/react-collapse/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__("../../node_modules/react-collapse/lib/Collapse.js"),
    Collapse = _require.Collapse;

var _require2 = __webpack_require__("../../node_modules/react-collapse/lib/UnmountClosed.js"),
    UnmountClosed = _require2.UnmountClosed;

UnmountClosed.Collapse = Collapse;
UnmountClosed.UnmountClosed = UnmountClosed;

module.exports = UnmountClosed;

/***/ }),

/***/ "../../node_modules/react-motion/lib/Motion.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__("../../node_modules/react-motion/lib/mapToZero.js");

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__("../../node_modules/react-motion/lib/stripStyle.js");

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__("../../node_modules/react-motion/lib/stepper.js");

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__("../../node_modules/performance-now/lib/performance-now.js");

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__("../../node_modules/raf/index.js");

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__("../../node_modules/react-motion/lib/shouldStopAnimation.js");

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

var Motion = (function (_React$Component) {
  _inherits(Motion, _React$Component);

  _createClass(Motion, null, [{
    key: 'propTypes',
    value: {
      // TOOD: warn against putting a config in here
      defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
      children: _propTypes2['default'].func.isRequired,
      onRest: _propTypes2['default'].func
    },
    enumerable: true
  }]);

  function Motion(props) {
    var _this = this;

    _classCallCheck(this, Motion);

    _React$Component.call(this, props);
    this.wasAnimating = false;
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyle = null;

    this.clearUnreadPropStyle = function (destStyle) {
      var dirty = false;
      var _state = _this.state;
      var currentStyle = _state.currentStyle;
      var currentVelocity = _state.currentVelocity;
      var lastIdealStyle = _state.lastIdealStyle;
      var lastIdealVelocity = _state.lastIdealVelocity;

      for (var key in destStyle) {
        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
          continue;
        }

        var styleValue = destStyle[key];
        if (typeof styleValue === 'number') {
          if (!dirty) {
            dirty = true;
            currentStyle = _extends({}, currentStyle);
            currentVelocity = _extends({}, currentVelocity);
            lastIdealStyle = _extends({}, lastIdealStyle);
            lastIdealVelocity = _extends({}, lastIdealVelocity);
          }

          currentStyle[key] = styleValue;
          currentVelocity[key] = 0;
          lastIdealStyle[key] = styleValue;
          lastIdealVelocity[key] = 0;
        }
      }

      if (dirty) {
        _this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
      }
    };

    this.startAnimationIfNecessary = function () {
      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        // check if we need to animate in the first place
        var propsStyle = _this.props.style;
        if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
          if (_this.wasAnimating && _this.props.onRest) {
            _this.props.onRest();
          }

          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.wasAnimating = false;
          _this.accumulatedTime = 0;
          return;
        }

        _this.wasAnimating = true;

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var newLastIdealStyle = {};
        var newLastIdealVelocity = {};
        var newCurrentStyle = {};
        var newCurrentVelocity = {};

        for (var key in propsStyle) {
          if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
            continue;
          }

          var styleValue = propsStyle[key];
          if (typeof styleValue === 'number') {
            newCurrentStyle[key] = styleValue;
            newCurrentVelocity[key] = 0;
            newLastIdealStyle[key] = styleValue;
            newLastIdealVelocity[key] = 0;
          } else {
            var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
            var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
            for (var i = 0; i < framesToCatchUp; i++) {
              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              newLastIdealStyleValue = _stepper[0];
              newLastIdealVelocityValue = _stepper[1];
            }

            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

            var nextIdealX = _stepper2[0];
            var nextIdealV = _stepper2[1];

            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
            newLastIdealStyle[key] = newLastIdealStyleValue;
            newLastIdealVelocity[key] = newLastIdealVelocityValue;
          }
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyle: newCurrentStyle,
          currentVelocity: newCurrentVelocity,
          lastIdealStyle: newLastIdealStyle,
          lastIdealVelocity: newLastIdealVelocity
        });

        _this.unreadPropStyle = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  Motion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyle = _props.defaultStyle;
    var style = _props.style;

    var currentStyle = defaultStyle || _stripStyle2['default'](style);
    var currentVelocity = _mapToZero2['default'](currentStyle);
    return {
      currentStyle: currentStyle,
      currentVelocity: currentVelocity,
      lastIdealStyle: currentStyle,
      lastIdealVelocity: currentVelocity
    };
  };

  // it's possible that currentStyle's value is stale: if props is immediately
  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
  // at 0 (didn't have time to tick and interpolate even once). If we naively
  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
  // In reality currentStyle should be 400

  Motion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyle != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyle);
    }

    this.unreadPropStyle = props.style;
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  Motion.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  Motion.prototype.render = function render() {
    var renderedChildren = this.props.children(this.state.currentStyle);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return Motion;
})(_react2['default'].Component);

exports['default'] = Motion;
module.exports = exports['default'];

// after checking for unreadPropStyle != null, we manually go set the
// non-interpolating values (those that are a number, without a spring
// config)

/***/ }),

/***/ "../../node_modules/react-motion/lib/StaggeredMotion.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__("../../node_modules/react-motion/lib/mapToZero.js");

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__("../../node_modules/react-motion/lib/stripStyle.js");

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__("../../node_modules/react-motion/lib/stepper.js");

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__("../../node_modules/performance-now/lib/performance-now.js");

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__("../../node_modules/raf/index.js");

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__("../../node_modules/react-motion/lib/shouldStopAnimation.js");

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
  for (var i = 0; i < currentStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
      return false;
    }
  }
  return true;
}

var StaggeredMotion = (function (_React$Component) {
  _inherits(StaggeredMotion, _React$Component);

  _createClass(StaggeredMotion, null, [{
    key: 'propTypes',
    value: {
      // TOOD: warn against putting a config in here
      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
      styles: _propTypes2['default'].func.isRequired,
      children: _propTypes2['default'].func.isRequired
    },
    enumerable: true
  }]);

  function StaggeredMotion(props) {
    var _this = this;

    _classCallCheck(this, StaggeredMotion);

    _React$Component.call(this, props);
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyles = null;

    this.clearUnreadPropStyle = function (unreadPropStyles) {
      var _state = _this.state;
      var currentStyles = _state.currentStyles;
      var currentVelocities = _state.currentVelocities;
      var lastIdealStyles = _state.lastIdealStyles;
      var lastIdealVelocities = _state.lastIdealVelocities;

      var someDirty = false;
      for (var i = 0; i < unreadPropStyles.length; i++) {
        var unreadPropStyle = unreadPropStyles[i];
        var dirty = false;

        for (var key in unreadPropStyle) {
          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
            continue;
          }

          var styleValue = unreadPropStyle[key];
          if (typeof styleValue === 'number') {
            if (!dirty) {
              dirty = true;
              someDirty = true;
              currentStyles[i] = _extends({}, currentStyles[i]);
              currentVelocities[i] = _extends({}, currentVelocities[i]);
              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
            }
            currentStyles[i][key] = styleValue;
            currentVelocities[i][key] = 0;
            lastIdealStyles[i][key] = styleValue;
            lastIdealVelocities[i][key] = 0;
          }
        }
      }

      if (someDirty) {
        _this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
      }
    };

    this.startAnimationIfNecessary = function () {
      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        var destStyles = _this.props.styles(_this.state.lastIdealStyles);

        // check if we need to animate in the first place
        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.accumulatedTime = 0;
          return;
        }

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var newLastIdealStyles = [];
        var newLastIdealVelocities = [];
        var newCurrentStyles = [];
        var newCurrentVelocities = [];

        for (var i = 0; i < destStyles.length; i++) {
          var destStyle = destStyles[i];
          var newCurrentStyle = {};
          var newCurrentVelocity = {};
          var newLastIdealStyle = {};
          var newLastIdealVelocity = {};

          for (var key in destStyle) {
            if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
              continue;
            }

            var styleValue = destStyle[key];
            if (typeof styleValue === 'number') {
              newCurrentStyle[key] = styleValue;
              newCurrentVelocity[key] = 0;
              newLastIdealStyle[key] = styleValue;
              newLastIdealVelocity[key] = 0;
            } else {
              var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
              var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
              for (var j = 0; j < framesToCatchUp; j++) {
                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

                newLastIdealStyleValue = _stepper[0];
                newLastIdealVelocityValue = _stepper[1];
              }

              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              var nextIdealX = _stepper2[0];
              var nextIdealV = _stepper2[1];

              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
              newLastIdealStyle[key] = newLastIdealStyleValue;
              newLastIdealVelocity[key] = newLastIdealVelocityValue;
            }
          }

          newCurrentStyles[i] = newCurrentStyle;
          newCurrentVelocities[i] = newCurrentVelocity;
          newLastIdealStyles[i] = newLastIdealStyle;
          newLastIdealVelocities[i] = newLastIdealVelocity;
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyles: newCurrentStyles,
          currentVelocities: newCurrentVelocities,
          lastIdealStyles: newLastIdealStyles,
          lastIdealVelocities: newLastIdealVelocities
        });

        _this.unreadPropStyles = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  StaggeredMotion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;

    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
    var currentVelocities = currentStyles.map(function (currentStyle) {
      return _mapToZero2['default'](currentStyle);
    });
    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: currentStyles,
      lastIdealVelocities: currentVelocities
    };
  };

  StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyles != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  StaggeredMotion.prototype.render = function render() {
    var renderedChildren = this.props.children(this.state.currentStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return StaggeredMotion;
})(_react2['default'].Component);

exports['default'] = StaggeredMotion;
module.exports = exports['default'];

// it's possible that currentStyle's value is stale: if props is immediately
// changed from 0 to 400 to spring(0) again, the async currentStyle is still
// at 0 (didn't have time to tick and interpolate even once). If we naively
// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
// In reality currentStyle should be 400

// after checking for unreadPropStyles != null, we manually go set the
// non-interpolating values (those that are a number, without a spring
// config)

/***/ }),

/***/ "../../node_modules/react-motion/lib/TransitionMotion.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__("../../node_modules/react-motion/lib/mapToZero.js");

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__("../../node_modules/react-motion/lib/stripStyle.js");

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__("../../node_modules/react-motion/lib/stepper.js");

var _stepper4 = _interopRequireDefault(_stepper3);

var _mergeDiff = __webpack_require__("../../node_modules/react-motion/lib/mergeDiff.js");

var _mergeDiff2 = _interopRequireDefault(_mergeDiff);

var _performanceNow = __webpack_require__("../../node_modules/performance-now/lib/performance-now.js");

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__("../../node_modules/raf/index.js");

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__("../../node_modules/react-motion/lib/shouldStopAnimation.js");

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

// the children function & (potential) styles function asks as param an
// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
// {key: string, data?: any, style: PlainStyle}. However, the way we keep
// internal states doesn't contain such a data structure (check the state and
// TransitionMotionState). So when children function and others ask for such
// data we need to generate them on the fly by combining mergedPropsStyles and
// currentStyles/lastIdealStyles
function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
  // Copy the value to a `const` so that Flow understands that the const won't
  // change and will be non-nullable in the callback below.
  var cUnreadPropStyles = unreadPropStyles;
  if (cUnreadPropStyles == null) {
    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
      return {
        key: mergedPropsStyle.key,
        data: mergedPropsStyle.data,
        style: plainStyles[i]
      };
    });
  }
  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
    for (var j = 0; j < cUnreadPropStyles.length; j++) {
      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
        return {
          key: cUnreadPropStyles[j].key,
          data: cUnreadPropStyles[j].data,
          style: plainStyles[i]
        };
      }
    }
    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
  });
}

function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
  if (mergedPropsStyles.length !== destStyles.length) {
    return false;
  }

  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (mergedPropsStyles[i].key !== destStyles[i].key) {
      return false;
    }
  }

  // we have the invariant that mergedPropsStyles and
  // currentStyles/currentVelocities/last* are synced in terms of cells, see
  // mergeAndSync comment for more info
  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
      return false;
    }
  }

  return true;
}

// core key merging logic

// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
// c}, previous current (interpolating) style is {a, b}
// **invariant**: current[i] corresponds to merged[i] in terms of key

// steps:
// turn merged style into {a?, b, c}
//    add c, value of c is destStyles.c
//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
// turn current (interpolating) style from {a, b} into {a?, b, c}
//    maybe remove a
//    certainly add c, value of c is willEnter(c)
// loop over merged and construct new current
// dest doesn't change, that's owner's
function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
    var leavingStyle = willLeave(oldMergedPropsStyle);
    if (leavingStyle == null) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
  });

  var newCurrentStyles = [];
  var newCurrentVelocities = [];
  var newLastIdealStyles = [];
  var newLastIdealVelocities = [];
  for (var i = 0; i < newMergedPropsStyles.length; i++) {
    var newMergedPropsStyleCell = newMergedPropsStyles[i];
    var foundOldIndex = null;
    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
        foundOldIndex = j;
        break;
      }
    }
    // TODO: key search code
    if (foundOldIndex == null) {
      var plainStyle = willEnter(newMergedPropsStyleCell);
      newCurrentStyles[i] = plainStyle;
      newLastIdealStyles[i] = plainStyle;

      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
      newCurrentVelocities[i] = velocity;
      newLastIdealVelocities[i] = velocity;
    } else {
      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
    }
  }

  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
}

var TransitionMotion = (function (_React$Component) {
  _inherits(TransitionMotion, _React$Component);

  _createClass(TransitionMotion, null, [{
    key: 'propTypes',
    value: {
      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
        key: _propTypes2['default'].string.isRequired,
        data: _propTypes2['default'].any,
        style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
      })),
      styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
        key: _propTypes2['default'].string.isRequired,
        data: _propTypes2['default'].any,
        style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
      }))]).isRequired,
      children: _propTypes2['default'].func.isRequired,
      willEnter: _propTypes2['default'].func,
      willLeave: _propTypes2['default'].func,
      didLeave: _propTypes2['default'].func
    },
    enumerable: true
  }, {
    key: 'defaultProps',
    value: {
      willEnter: function willEnter(styleThatEntered) {
        return _stripStyle2['default'](styleThatEntered.style);
      },
      // recall: returning null makes the current unmounting TransitionStyle
      // disappear immediately
      willLeave: function willLeave() {
        return null;
      },
      didLeave: function didLeave() {}
    },
    enumerable: true
  }]);

  function TransitionMotion(props) {
    var _this = this;

    _classCallCheck(this, TransitionMotion);

    _React$Component.call(this, props);
    this.unmounting = false;
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyles = null;

    this.clearUnreadPropStyle = function (unreadPropStyles) {
      var _mergeAndSync = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

      var mergedPropsStyles = _mergeAndSync[0];
      var currentStyles = _mergeAndSync[1];
      var currentVelocities = _mergeAndSync[2];
      var lastIdealStyles = _mergeAndSync[3];
      var lastIdealVelocities = _mergeAndSync[4];

      for (var i = 0; i < unreadPropStyles.length; i++) {
        var unreadPropStyle = unreadPropStyles[i].style;
        var dirty = false;

        for (var key in unreadPropStyle) {
          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
            continue;
          }

          var styleValue = unreadPropStyle[key];
          if (typeof styleValue === 'number') {
            if (!dirty) {
              dirty = true;
              currentStyles[i] = _extends({}, currentStyles[i]);
              currentVelocities[i] = _extends({}, currentVelocities[i]);
              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
              mergedPropsStyles[i] = {
                key: mergedPropsStyles[i].key,
                data: mergedPropsStyles[i].data,
                style: _extends({}, mergedPropsStyles[i].style)
              };
            }
            currentStyles[i][key] = styleValue;
            currentVelocities[i][key] = 0;
            lastIdealStyles[i][key] = styleValue;
            lastIdealVelocities[i][key] = 0;
            mergedPropsStyles[i].style[key] = styleValue;
          }
        }
      }

      // unlike the other 2 components, we can't detect staleness and optionally
      // opt out of setState here. each style object's data might contain new
      // stuff we're not/cannot compare
      _this.setState({
        currentStyles: currentStyles,
        currentVelocities: currentVelocities,
        mergedPropsStyles: mergedPropsStyles,
        lastIdealStyles: lastIdealStyles,
        lastIdealVelocities: lastIdealVelocities
      });
    };

    this.startAnimationIfNecessary = function () {
      if (_this.unmounting) {
        return;
      }

      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        // https://github.com/chenglou/react-motion/pull/420
        // > if execution passes the conditional if (this.unmounting), then
        // executes async defaultRaf and after that component unmounts and after
        // that the callback of defaultRaf is called, then setState will be called
        // on unmounted component.
        if (_this.unmounting) {
          return;
        }

        var propStyles = _this.props.styles;
        var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;

        // check if we need to animate in the first place
        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.accumulatedTime = 0;
          return;
        }

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var _mergeAndSync2 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

        var newMergedPropsStyles = _mergeAndSync2[0];
        var newCurrentStyles = _mergeAndSync2[1];
        var newCurrentVelocities = _mergeAndSync2[2];
        var newLastIdealStyles = _mergeAndSync2[3];
        var newLastIdealVelocities = _mergeAndSync2[4];

        for (var i = 0; i < newMergedPropsStyles.length; i++) {
          var newMergedPropsStyle = newMergedPropsStyles[i].style;
          var newCurrentStyle = {};
          var newCurrentVelocity = {};
          var newLastIdealStyle = {};
          var newLastIdealVelocity = {};

          for (var key in newMergedPropsStyle) {
            if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
              continue;
            }

            var styleValue = newMergedPropsStyle[key];
            if (typeof styleValue === 'number') {
              newCurrentStyle[key] = styleValue;
              newCurrentVelocity[key] = 0;
              newLastIdealStyle[key] = styleValue;
              newLastIdealVelocity[key] = 0;
            } else {
              var newLastIdealStyleValue = newLastIdealStyles[i][key];
              var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
              for (var j = 0; j < framesToCatchUp; j++) {
                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

                newLastIdealStyleValue = _stepper[0];
                newLastIdealVelocityValue = _stepper[1];
              }

              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              var nextIdealX = _stepper2[0];
              var nextIdealV = _stepper2[1];

              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
              newLastIdealStyle[key] = newLastIdealStyleValue;
              newLastIdealVelocity[key] = newLastIdealVelocityValue;
            }
          }

          newLastIdealStyles[i] = newLastIdealStyle;
          newLastIdealVelocities[i] = newLastIdealVelocity;
          newCurrentStyles[i] = newCurrentStyle;
          newCurrentVelocities[i] = newCurrentVelocity;
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyles: newCurrentStyles,
          currentVelocities: newCurrentVelocities,
          lastIdealStyles: newLastIdealStyles,
          lastIdealVelocities: newLastIdealVelocities,
          mergedPropsStyles: newMergedPropsStyles
        });

        _this.unreadPropStyles = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  TransitionMotion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;
    var willEnter = _props.willEnter;
    var willLeave = _props.willLeave;
    var didLeave = _props.didLeave;

    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;

    // this is special. for the first time around, we don't have a comparison
    // between last (no last) and current merged props. we'll compute last so:
    // say default is {a, b} and styles (dest style) is {b, c}, we'll
    // fabricate last as {a, b}
    var oldMergedPropsStyles = undefined;
    if (defaultStyles == null) {
      oldMergedPropsStyles = destStyles;
    } else {
      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
        // TODO: key search code
        for (var i = 0; i < destStyles.length; i++) {
          if (destStyles[i].key === defaultStyleCell.key) {
            return destStyles[i];
          }
        }
        return defaultStyleCell;
      });
    }
    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    });
    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    });

    var _mergeAndSync3 = mergeAndSync(
    // Because this is an old-style createReactClass component, Flow doesn't
    // understand that the willEnter and willLeave props have default values
    // and will always be present.
    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
    oldCurrentVelocities);

    var mergedPropsStyles = _mergeAndSync3[0];
    var currentStyles = _mergeAndSync3[1];
    var currentVelocities = _mergeAndSync3[2];
    var lastIdealStyles = _mergeAndSync3[3];
    var lastIdealVelocities = _mergeAndSync3[4];
    // oldLastIdealVelocities really

    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: lastIdealStyles,
      lastIdealVelocities: lastIdealVelocities,
      mergedPropsStyles: mergedPropsStyles
    };
  };

  // after checking for unreadPropStyles != null, we manually go set the
  // non-interpolating values (those that are a number, without a spring
  // config)

  TransitionMotion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyles) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    var styles = props.styles;
    if (typeof styles === 'function') {
      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
    } else {
      this.unreadPropStyles = styles;
    }

    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounting = true;
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  TransitionMotion.prototype.render = function render() {
    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
    var renderedChildren = this.props.children(hydratedStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return TransitionMotion;
})(_react2['default'].Component);

exports['default'] = TransitionMotion;
module.exports = exports['default'];

// list of styles, each containing interpolating values. Part of what's passed
// to children function. Notice that this is
// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
// contains the key & data info (so that we only have a single source of truth
// for these, and to save space). Check the comment for `rehydrateStyles` to
// see how we regenerate the entirety of what's passed to children function

// the array that keeps track of currently rendered stuff! Including stuff
// that you've unmounted but that's still animating. This is where it lives

// it's possible that currentStyle's value is stale: if props is immediately
// changed from 0 to 400 to spring(0) again, the async currentStyle is still
// at 0 (didn't have time to tick and interpolate even once). If we naively
// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
// In reality currentStyle should be 400

/***/ }),

/***/ "../../node_modules/react-motion/lib/mapToZero.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// currently used to initiate the velocity style object to 0


exports.__esModule = true;
exports['default'] = mapToZero;

function mapToZero(obj) {
  var ret = {};
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      ret[key] = 0;
    }
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),

/***/ "../../node_modules/react-motion/lib/mergeDiff.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// core keys merging algorithm. If previous render's keys are [a, b], and the
// next render's [c, b, d], what's the final merged keys and ordering?

// - c and a must both be before b
// - b before d
// - ordering between a and c ambiguous

// this reduces to merging two partially ordered lists (e.g. lists where not
// every item has a definite ordering, like comparing a and c above). For the
// ambiguous ordering we deterministically choose to place the next render's
// item after the previous'; so c after a

// this is called a topological sorting. Except the existing algorithms don't
// work well with js bc of the amount of allocation, and isn't optimized for our
// current use-case bc the runtime is linear in terms of edges (see wiki for
// meaning), which is huge when two lists have many common elements


exports.__esModule = true;
exports['default'] = mergeDiff;

function mergeDiff(prev, next, onRemove) {
  // bookkeeping for easier access of a key's index below. This is 2 allocations +
  // potentially triggering chrome hash map mode for objs (so it might be faster

  var prevKeyIndex = {};
  for (var i = 0; i < prev.length; i++) {
    prevKeyIndex[prev[i].key] = i;
  }
  var nextKeyIndex = {};
  for (var i = 0; i < next.length; i++) {
    nextKeyIndex[next[i].key] = i;
  }

  // first, an overly elaborate way of merging prev and next, eliminating
  // duplicates (in terms of keys). If there's dupe, keep the item in next).
  // This way of writing it saves allocations
  var ret = [];
  for (var i = 0; i < next.length; i++) {
    ret[i] = next[i];
  }
  for (var i = 0; i < prev.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
      // merge in keys that the user desires to kill
      var fill = onRemove(i, prev[i]);
      if (fill != null) {
        ret.push(fill);
      }
    }
  }

  // now all the items all present. Core sorting logic to have the right order
  return ret.sort(function (a, b) {
    var nextOrderA = nextKeyIndex[a.key];
    var nextOrderB = nextKeyIndex[b.key];
    var prevOrderA = prevKeyIndex[a.key];
    var prevOrderB = prevKeyIndex[b.key];

    if (nextOrderA != null && nextOrderB != null) {
      // both keys in next
      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
    } else if (prevOrderA != null && prevOrderB != null) {
      // both keys in prev
      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
    } else if (nextOrderA != null) {
      // key a in next, key b in prev

      // how to determine the order between a and b? We find a "pivot" (term
      // abuse), a key present in both prev and next, that is sandwiched between
      // a and b. In the context of our above example, if we're comparing a and
      // d, b's (the only) pivot
      for (var i = 0; i < next.length; i++) {
        var pivot = next[i].key;
        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
          continue;
        }

        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
          return -1;
        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
          return 1;
        }
      }
      // pluggable. default to: next bigger than prev
      return 1;
    }
    // prevOrderA, nextOrderB
    for (var i = 0; i < next.length; i++) {
      var pivot = next[i].key;
      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
        continue;
      }
      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
        return 1;
      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
        return -1;
      }
    }
    // pluggable. default to: next bigger than prev
    return -1;
  });
}

module.exports = exports['default'];
// to loop through and find a key's index each time), but I no longer care

/***/ }),

/***/ "../../node_modules/react-motion/lib/presets.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = {
  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
  gentle: { stiffness: 120, damping: 14 },
  wobbly: { stiffness: 180, damping: 12 },
  stiff: { stiffness: 210, damping: 20 }
};
module.exports = exports["default"];

/***/ }),

/***/ "../../node_modules/react-motion/lib/react-motion.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }

var _Motion = __webpack_require__("../../node_modules/react-motion/lib/Motion.js");

exports.Motion = _interopRequire(_Motion);

var _StaggeredMotion = __webpack_require__("../../node_modules/react-motion/lib/StaggeredMotion.js");

exports.StaggeredMotion = _interopRequire(_StaggeredMotion);

var _TransitionMotion = __webpack_require__("../../node_modules/react-motion/lib/TransitionMotion.js");

exports.TransitionMotion = _interopRequire(_TransitionMotion);

var _spring = __webpack_require__("../../node_modules/react-motion/lib/spring.js");

exports.spring = _interopRequire(_spring);

var _presets = __webpack_require__("../../node_modules/react-motion/lib/presets.js");

exports.presets = _interopRequire(_presets);

var _stripStyle = __webpack_require__("../../node_modules/react-motion/lib/stripStyle.js");

exports.stripStyle = _interopRequire(_stripStyle);

// deprecated, dummy warning function

var _reorderKeys = __webpack_require__("../../node_modules/react-motion/lib/reorderKeys.js");

exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ }),

/***/ "../../node_modules/react-motion/lib/reorderKeys.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = reorderKeys;

var hasWarned = false;

function reorderKeys() {
  if (false) {
    if (!hasWarned) {
      hasWarned = true;
      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
    }
  }
}

module.exports = exports['default'];

/***/ }),

/***/ "../../node_modules/react-motion/lib/shouldStopAnimation.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// usage assumption: currentStyle values have already been rendered but it says
// nothing of whether currentStyle is stale (see unreadPropStyle)


exports.__esModule = true;
exports['default'] = shouldStopAnimation;

function shouldStopAnimation(currentStyle, style, currentVelocity) {
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }

    if (currentVelocity[key] !== 0) {
      return false;
    }

    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
    // stepper will have already taken care of rounding precision errors, so
    // won't have such thing as 0.9999 !=== 1
    if (currentStyle[key] !== styleValue) {
      return false;
    }
  }

  return true;
}

module.exports = exports['default'];

/***/ }),

/***/ "../../node_modules/react-motion/lib/spring.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = spring;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _presets = __webpack_require__("../../node_modules/react-motion/lib/presets.js");

var _presets2 = _interopRequireDefault(_presets);

var defaultConfig = _extends({}, _presets2['default'].noWobble, {
  precision: 0.01
});

function spring(val, config) {
  return _extends({}, defaultConfig, config, { val: val });
}

module.exports = exports['default'];

/***/ }),

/***/ "../../node_modules/react-motion/lib/stepper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// stepper is used a lot. Saves allocation to return the same array wrapper.
// This is fine and danger-free against mutations because the callsite
// immediately destructures it and gets the numbers inside without passing the


exports.__esModule = true;
exports["default"] = stepper;

var reusedTuple = [0, 0];

function stepper(secondPerFrame, x, v, destX, k, b, precision) {
  // Spring stiffness, in kg / s^2

  // for animations, destX is really spring length (spring at rest). initial
  // position is considered as the stretched/compressed position of a spring
  var Fspring = -k * (x - destX);

  // Damping, in kg / s
  var Fdamper = -b * v;

  // usually we put mass here, but for animation purposes, specifying mass is a
  // bit redundant. you could simply adjust k and b accordingly
  // let a = (Fspring + Fdamper) / mass;
  var a = Fspring + Fdamper;

  var newV = v + a * secondPerFrame;
  var newX = x + newV * secondPerFrame;

  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
    reusedTuple[0] = destX;
    reusedTuple[1] = 0;
    return reusedTuple;
  }

  reusedTuple[0] = newX;
  reusedTuple[1] = newV;
  return reusedTuple;
}

module.exports = exports["default"];
// array reference around.

/***/ }),

/***/ "../../node_modules/react-motion/lib/stripStyle.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}



exports.__esModule = true;
exports['default'] = stripStyle;

function stripStyle(style) {
  var ret = {};
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }
    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),

/***/ "../../node_modules/react-responsive/dist/react-responsive.js":
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["MediaQuery"] = factory(require("react"));
	else
		root["MediaQuery"] = factory(root["react"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_15__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(15);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _matchmediaquery = __webpack_require__(11);
	
	var _matchmediaquery2 = _interopRequireDefault(_matchmediaquery);
	
	var _hyphenateStyleName = __webpack_require__(7);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	var _mediaQuery = __webpack_require__(5);
	
	var _mediaQuery2 = _interopRequireDefault(_mediaQuery);
	
	var _toQuery = __webpack_require__(9);
	
	var _toQuery2 = _interopRequireDefault(_toQuery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultTypes = {
	  component: _propTypes2.default.node,
	  query: _propTypes2.default.string,
	  values: _propTypes2.default.shape(_mediaQuery2.default.matchers),
	  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
	  onChange: _propTypes2.default.func,
	  onBeforeChange: _propTypes2.default.func
	};
	var mediaKeys = Object.keys(_mediaQuery2.default.all);
	var excludedQueryKeys = Object.keys(defaultTypes);
	var excludedPropKeys = excludedQueryKeys.concat(mediaKeys);
	
	function omit(object, keys) {
	  var newObject = _extends({}, object);
	  keys.forEach(function (key) {
	    return delete newObject[key];
	  });
	  return newObject;
	}
	
	var MediaQuery = function (_React$Component) {
	  _inherits(MediaQuery, _React$Component);
	
	  function MediaQuery() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MediaQuery);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MediaQuery.__proto__ || Object.getPrototypeOf(MediaQuery)).call.apply(_ref, [this].concat(args))), _this), _this.state = { matches: false }, _this.updateMatches = function () {
	      if (_this._mql.matches === _this.state.matches) {
	        return;
	      }
	      _this.setState({
	        matches: _this._mql.matches
	      });
	    }, _this.removeMql = function () {
	      if (_this._mql) {
	        _this._mql.removeListener(_this.updateMatches);
	        _this._mql.dispose();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(MediaQuery, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.updateQuery(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.updateQuery(nextProps);
	    }
	  }, {
	    key: 'updateQuery',
	    value: function updateQuery(props) {
	      var values = void 0;
	      if (props.query) {
	        this.query = props.query;
	      } else {
	        this.query = (0, _toQuery2.default)(omit(props, excludedQueryKeys));
	      }
	
	      if (!this.query) {
	        throw new Error('Invalid or missing MediaQuery!');
	      }
	
	      if (props.values) {
	        values = Object.keys(props.values).reduce(function (result, key) {
	          result[(0, _hyphenateStyleName2.default)(key)] = props.values[key];
	          return result;
	        }, {});
	      }
	
	      this.removeMql();
	
	      this._mql = (0, _matchmediaquery2.default)(this.query, values);
	      this._mql.addListener(this.updateMatches);
	      this.updateMatches();
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(_, nextState) {
	      if (this.props.onBeforeChange && this.state.matches !== nextState.matches) {
	        this.props.onBeforeChange(this.state.matches);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(_, prevState) {
	      if (this.props.onChange && prevState.matches !== this.state.matches) {
	        this.props.onChange(this.state.matches);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.removeMql();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (typeof this.props.children === 'function') {
	        return this.props.children(this.state.matches);
	      }
	
	      if (this.state.matches === false) {
	        return null;
	      }
	      var props = omit(this.props, excludedPropKeys);
	      var hasMergeProps = Object.keys(props).length > 0;
	      var childrenCount = _react2.default.Children.count(this.props.children);
	      var wrapChildren = this.props.component || childrenCount > 1 || typeof this.props.children === 'string' || Array.isArray(this.props.children) && childrenCount == 1 || this.props.children === undefined;
	      if (wrapChildren) {
	        return _react2.default.createElement(this.props.component || 'div', props, this.props.children);
	      } else if (hasMergeProps) {
	        return _react2.default.cloneElement(this.props.children, props);
	      } else if (childrenCount) {
	        return this.props.children;
	      } else {
	        return null;
	      }
	    }
	  }]);
	
	  return MediaQuery;
	}(_react2.default.Component);
	
	MediaQuery.displayName = 'MediaQuery';
	MediaQuery.defaultProps = {
	  values: {}
	};
	exports.default = MediaQuery;
	module.exports = exports['default'];

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 2 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (process.env.NODE_ENV !== 'production') {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stringOrNumber = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
	
	// properties that match media queries
	var matchers = {
	  orientation: _propTypes2.default.oneOf(['portrait', 'landscape']),
	
	  scan: _propTypes2.default.oneOf(['progressive', 'interlace']),
	
	  aspectRatio: _propTypes2.default.string,
	  deviceAspectRatio: _propTypes2.default.string,
	
	  height: stringOrNumber,
	  deviceHeight: stringOrNumber,
	
	  width: stringOrNumber,
	  deviceWidth: stringOrNumber,
	
	  color: _propTypes2.default.bool,
	
	  colorIndex: _propTypes2.default.bool,
	
	  monochrome: _propTypes2.default.bool,
	  resolution: stringOrNumber
	
	  // media features
	};var features = _extends({
	  minAspectRatio: _propTypes2.default.string,
	  maxAspectRatio: _propTypes2.default.string,
	  minDeviceAspectRatio: _propTypes2.default.string,
	  maxDeviceAspectRatio: _propTypes2.default.string,
	
	  minHeight: stringOrNumber,
	  maxHeight: stringOrNumber,
	  minDeviceHeight: stringOrNumber,
	  maxDeviceHeight: stringOrNumber,
	
	  minWidth: stringOrNumber,
	  maxWidth: stringOrNumber,
	  minDeviceWidth: stringOrNumber,
	  maxDeviceWidth: stringOrNumber,
	
	  minColor: _propTypes2.default.number,
	  maxColor: _propTypes2.default.number,
	
	  minColorIndex: _propTypes2.default.number,
	  maxColorIndex: _propTypes2.default.number,
	
	  minMonochrome: _propTypes2.default.number,
	  maxMonochrome: _propTypes2.default.number,
	
	  minResolution: stringOrNumber,
	  maxResolution: stringOrNumber
	
	}, matchers);
	
	// media types
	var types = {
	  all: _propTypes2.default.bool,
	  grid: _propTypes2.default.bool,
	  aural: _propTypes2.default.bool,
	  braille: _propTypes2.default.bool,
	  handheld: _propTypes2.default.bool,
	  print: _propTypes2.default.bool,
	  projection: _propTypes2.default.bool,
	  screen: _propTypes2.default.bool,
	  tty: _propTypes2.default.bool,
	  tv: _propTypes2.default.bool,
	  embossed: _propTypes2.default.bool
	};
	
	var all = _extends({}, types, features);
	
	// add the type property
	matchers.type = Object.keys(types);
	
	exports.default = {
	  all: all,
	  types: types,
	  matchers: matchers,
	  features: features
	};
	module.exports = exports['default'];

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(2);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (process.env.NODE_ENV !== 'production') {
	  (function () {
	    var printWarning = function printWarning(format) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    };
	
	    warning = function warning(condition, format) {
	      if (format === undefined) {
	        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	      }
	
	      if (format.indexOf('Failed Composite propType: ') === 0) {
	        return; // Ignore CompositeComponent proptype check.
	      }
	
	      if (!condition) {
	        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	          args[_key2 - 2] = arguments[_key2];
	        }
	
	        printWarning.apply(undefined, [format].concat(args));
	      }
	    };
	  })();
	}
	
	module.exports = warning;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	'use strict';
	
	var uppercasePattern = /[A-Z]/g;
	var msPattern = /^ms-/;
	var cache = {};
	
	function hyphenateStyleName(string) {
	    return string in cache
	    ? cache[string]
	    : cache[string] = string
	      .replace(uppercasePattern, '-$&')
	      .toLowerCase()
	      .replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	if (process.env.NODE_ENV !== 'production') {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = __webpack_require__(14)(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(13)();
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (obj) {
	  var rules = [];
	  Object.keys(_mediaQuery2.default.all).forEach(function (k) {
	    var v = obj[k];
	    if (v != null) {
	      rules.push(keyVal(k, v));
	    }
	  });
	  return join(rules);
	};
	
	var _hyphenateStyleName = __webpack_require__(7);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	var _mediaQuery = __webpack_require__(5);
	
	var _mediaQuery2 = _interopRequireDefault(_mediaQuery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var negate = function negate(cond) {
	  return 'not ' + cond;
	};
	
	function keyVal(k, v) {
	  var realKey = (0, _hyphenateStyleName2.default)(k);
	
	  // px shorthand
	  if (typeof v === 'number') {
	    v = v + 'px';
	  }
	  if (v === true) {
	    return k;
	  }
	  if (v === false) {
	    return negate(k);
	  }
	  return '(' + realKey + ': ' + v + ')';
	}
	
	function join(conds) {
	  return conds.join(' and ');
	}
	
	module.exports = exports['default'];

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	'use strict';
	
	exports.match = matchQuery;
	exports.parse = parseQuery;
	
	// -----------------------------------------------------------------------------
	
	var RE_MEDIA_QUERY     = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i,
	    RE_MQ_EXPRESSION   = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/,
	    RE_MQ_FEATURE      = /^(?:(min|max)-)?(.+)/,
	    RE_LENGTH_UNIT     = /(em|rem|px|cm|mm|in|pt|pc)?$/,
	    RE_RESOLUTION_UNIT = /(dpi|dpcm|dppx)?$/;
	
	function matchQuery(mediaQuery, values) {
	    return parseQuery(mediaQuery).some(function (query) {
	        var inverse = query.inverse;
	
	        // Either the parsed or specified `type` is "all", or the types must be
	        // equal for a match.
	        var typeMatch = query.type === 'all' || values.type === query.type;
	
	        // Quit early when `type` doesn't match, but take "not" into account.
	        if ((typeMatch && inverse) || !(typeMatch || inverse)) {
	            return false;
	        }
	
	        var expressionsMatch = query.expressions.every(function (expression) {
	            var feature  = expression.feature,
	                modifier = expression.modifier,
	                expValue = expression.value,
	                value    = values[feature];
	
	            // Missing or falsy values don't match.
	            if (!value) { return false; }
	
	            switch (feature) {
	                case 'orientation':
	                case 'scan':
	                    return value.toLowerCase() === expValue.toLowerCase();
	
	                case 'width':
	                case 'height':
	                case 'device-width':
	                case 'device-height':
	                    expValue = toPx(expValue);
	                    value    = toPx(value);
	                    break;
	
	                case 'resolution':
	                    expValue = toDpi(expValue);
	                    value    = toDpi(value);
	                    break;
	
	                case 'aspect-ratio':
	                case 'device-aspect-ratio':
	                case /* Deprecated */ 'device-pixel-ratio':
	                    expValue = toDecimal(expValue);
	                    value    = toDecimal(value);
	                    break;
	
	                case 'grid':
	                case 'color':
	                case 'color-index':
	                case 'monochrome':
	                    expValue = parseInt(expValue, 10) || 1;
	                    value    = parseInt(value, 10) || 0;
	                    break;
	            }
	
	            switch (modifier) {
	                case 'min': return value >= expValue;
	                case 'max': return value <= expValue;
	                default   : return value === expValue;
	            }
	        });
	
	        return (expressionsMatch && !inverse) || (!expressionsMatch && inverse);
	    });
	}
	
	function parseQuery(mediaQuery) {
	    return mediaQuery.split(',').map(function (query) {
	        query = query.trim();
	
	        var captures    = query.match(RE_MEDIA_QUERY),
	            modifier    = captures[1],
	            type        = captures[2],
	            expressions = captures[3] || '',
	            parsed      = {};
	
	        parsed.inverse = !!modifier && modifier.toLowerCase() === 'not';
	        parsed.type    = type ? type.toLowerCase() : 'all';
	
	        // Split expressions into a list.
	        expressions = expressions.match(/\([^\)]+\)/g) || [];
	
	        parsed.expressions = expressions.map(function (expression) {
	            var captures = expression.match(RE_MQ_EXPRESSION),
	                feature  = captures[1].toLowerCase().match(RE_MQ_FEATURE);
	
	            return {
	                modifier: feature[1],
	                feature : feature[2],
	                value   : captures[2]
	            };
	        });
	
	        return parsed;
	    });
	}
	
	// -- Utilities ----------------------------------------------------------------
	
	function toDecimal(ratio) {
	    var decimal = Number(ratio),
	        numbers;
	
	    if (!decimal) {
	        numbers = ratio.match(/^(\d+)\s*\/\s*(\d+)$/);
	        decimal = numbers[1] / numbers[2];
	    }
	
	    return decimal;
	}
	
	function toDpi(resolution) {
	    var value = parseFloat(resolution),
	        units = String(resolution).match(RE_RESOLUTION_UNIT)[1];
	
	    switch (units) {
	        case 'dpcm': return value / 2.54;
	        case 'dppx': return value * 96;
	        default    : return value;
	    }
	}
	
	function toPx(length) {
	    var value = parseFloat(length),
	        units = String(length).match(RE_LENGTH_UNIT)[1];
	
	    switch (units) {
	        case 'em' : return value * 16;
	        case 'rem': return value * 16;
	        case 'cm' : return value * 96 / 2.54;
	        case 'mm' : return value * 96 / 2.54 / 10;
	        case 'in' : return value * 96;
	        case 'pt' : return value * 72;
	        case 'pc' : return value * 72 / 12;
	        default   : return value;
	    }
	}


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var staticMatch = __webpack_require__(10).match;
	var dynamicMatch = typeof window !== 'undefined' ? window.matchMedia : null;
	
	// our fake MediaQueryList
	function Mql(query, values){
	  var self = this;
	  if(dynamicMatch){
	    var mql = dynamicMatch.call(window, query);
	    this.matches = mql.matches;
	    this.media = mql.media;
	    // TODO: is there a time it makes sense to remove this listener?
	    mql.addListener(update);
	  } else {
	    this.matches = staticMatch(query, values);
	    this.media = query;
	  }
	
	  this.addListener = addListener;
	  this.removeListener = removeListener;
	  this.dispose = dispose;
	
	  function addListener(listener){
	    if(mql){
	      mql.addListener(listener);
	    }
	  }
	
	  function removeListener(listener){
	    if(mql){
	      mql.removeListener(listener);
	    }
	  }
	
	  // update ourselves!
	  function update(evt){
	    self.matches = evt.matches;
	    self.media = evt.media;
	  }
	
	  function dispose(){
	    if(mql){
	      mql.removeListener(update);
	    }
	  }
	}
	
	function matchMedia(query, values){
	  return new Mql(query, values);
	}
	
	module.exports = matchMedia;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	if (process.env.NODE_ENV !== 'production') {
	  var invariant = __webpack_require__(3);
	  var warning = __webpack_require__(6);
	  var ReactPropTypesSecret = __webpack_require__(4);
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(2);
	var invariant = __webpack_require__(3);
	var ReactPropTypesSecret = __webpack_require__(4);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(2);
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(6);
	
	var ReactPropTypesSecret = __webpack_require__(4);
	var checkPropTypes = __webpack_require__(12);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning(
	          false,
	          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_15__;

/***/ })
/******/ ])
});
;
//# sourceMappingURL=react-responsive.js.map

/***/ }),

/***/ "../../node_modules/url/url.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var punycode = __webpack_require__("../../node_modules/node-libs-browser/node_modules/punycode/punycode.js");
var util = __webpack_require__("../../node_modules/url/util.js");

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    },
    querystring = __webpack_require__("../../node_modules/querystring-es3/index.js");

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter =
          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      util.isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host || srcPath.length > 1) &&
      (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};


/***/ }),

/***/ "../../node_modules/url/util.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  isString: function(arg) {
    return typeof(arg) === 'string';
  },
  isObject: function(arg) {
    return typeof(arg) === 'object' && arg !== null;
  },
  isNull: function(arg) {
    return arg === null;
  },
  isNullOrUndefined: function(arg) {
    return arg == null;
  }
};


/***/ }),

/***/ "../../node_modules/webpack/buildin/global.js":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "../../node_modules/webpack/buildin/module.js":
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "../../node_modules/whatwg-fetch/fetch.js":
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = options.status === undefined ? 200 : options.status
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),

/***/ "../widget-build-and-quote/src/constants/errorCodes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BAD_QUOTE_REVISION = exports.BAD_QUOTE_REVISION = 114;

/***/ }),

/***/ "../widget-commons-leads/src/config/dev.json":
/***/ (function(module, exports) {

module.exports = {"endpoint":{"widget":"https://service.backbones.widget-supplier.dev.office.n360.io","account":"https://service.backbones.account.dev.office.n360.io/api","showroom":"https://dev-api.showroom360.ca:9443","authentication":"https://service.authentication.dev.office.n360.io","leadSubmission":"https://service.lead-submission.dev.n360.io","graphql":"https://service.backbones.webauto-supplier.dev.office.n360.io/webauto/graphql"},"source":{"image":"http://img-dev.sm360.ca","widget":"https://service.backbones.widget-supplier.dev.office.n360.io/client"},"secureCookies":false,"sentry":{"url":"","sentryLevel":"NONE","consoleLevel":"DEBUG","whitelistUrls":["^.*(widgets-dev-cdn.sm360.ca).*$"],"includePaths":["^.*(widgets-dev-cdn.sm360.ca).*$"]},"secrets":{"authentication":"452e9145-29ab-4275-bca9-fa8ba7ae19d9"}}

/***/ }),

/***/ "../widget-commons-leads/src/config/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _dev = __webpack_require__("../widget-commons-leads/src/config/dev.json");

var _dev2 = _interopRequireDefault(_dev);

var _int = __webpack_require__("../widget-commons-leads/src/config/int.json");

var _int2 = _interopRequireDefault(_int);

var _local = __webpack_require__("../widget-commons-leads/src/config/local.json");

var _local2 = _interopRequireDefault(_local);

var _prod = __webpack_require__("../widget-commons-leads/src/config/prod.json");

var _prod2 = _interopRequireDefault(_prod);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = {};

if (true) {
    config = _prod2.default;
} else if (process.env.BUILD_ENV === 'development') {
    config = _dev2.default;
} else if (process.env.BUILD_ENV === 'integration') {
    config = _int2.default;
} else {
    config = _local2.default;
}

exports.default = _extends({}, config);

/***/ }),

/***/ "../widget-commons-leads/src/config/int.json":
/***/ (function(module, exports) {

module.exports = {"endpoint":{"widget":"https://widget-int.sm360.ca","account":"https://account-int.sm360.ca/api","showroom":"https://int-api.showroom360.ca:8443","authentication":"https://service-authentication-int.sm360.ca","leadSubmission":"https://service.lead-submission.int.n360.io","graphql":"https://webauto-supplier-api-int.sm360.ca/webauto/graphql"},"source":{"image":"http://img-int.sm360.ca","widget":"https://widget-int.sm360.ca/client"},"secureCookies":false,"sentry":{"url":"","sentryLevel":"NONE","consoleLevel":"DEBUG","whitelistUrls":["^.*(widgets-int-cdn.sm360.ca).*$"],"includePaths":["^.*(widgets-int-cdn.sm360.ca).*$"]},"secrets":{"authentication":"33934e6c-d3ba-41c1-b62f-334dee5f8d8f"}}

/***/ }),

/***/ "../widget-commons-leads/src/config/local.json":
/***/ (function(module, exports) {

module.exports = {"endpoint":{"widget":"https://widget-int.sm360.ca","account":"https://account-int.sm360.ca/api","showroom":"https://int-api.showroom360.ca:8443","authentication":"https://service-authentication-int.sm360.ca","leadSubmission":"https://service.lead-submission.int.n360.io","graphql":"https://webauto-supplier-api-int.sm360.ca/webauto/graphql"},"source":{"image":"http://img-int.sm360.ca","widget":"https://widget-int.sm360.ca/client"},"secureCookies":false,"sentry":{"url":"","sentryLevel":"NONE","consoleLevel":"DEBUG","whitelistUrls":["^.*(widgets-int-cdn.sm360.ca).*$"],"includePaths":["^.*(widgets-int-cdn.sm360.ca).*$"]},"secrets":{"authentication":"33934e6c-d3ba-41c1-b62f-334dee5f8d8f"}}

/***/ }),

/***/ "../widget-commons-leads/src/config/prod.json":
/***/ (function(module, exports) {

module.exports = {"endpoint":{"widget":"https://widget.sm360.ca","account":"https://account.sm360.ca/api","showroom":"https://api.showroom360.ca","authentication":"https://service-authentication.sm360.ca","leadSubmission":"https://service.lead-submission.prod.n360.io","graphql":"https://webauto-supplier-api.sm360.ca/webauto/graphql"},"source":{"image":"https://img.sm360.ca","widget":"https://widget.sm360.ca/client"},"secureCookies":true,"sentry":{"url":"","sentryLevel":"WARNING","consoleLevel":"ERROR","whitelistUrls":["^.*(widgets-cdn.sm360.ca).*$"],"includePaths":["^.*(widgets-cdn.sm360.ca).*$"]},"secrets":{"authentication":"6524a774-d33b-47c4-9f13-ea2ad2fb12ee"}}

/***/ }),

/***/ "../widget-commons-leads/src/constants/LeadTypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var LEAD_TYPES = {
    ACCOUNT_CREATION: 87,
    APPOINTMENT_NEW: 23,
    APPOINTMENT_USED: 24,
    CONFIRMATION_NEW: 76,
    CONFIRMATION_USED: 66,
    DEPOSIT_NEW: 75,
    DEPOSIT_USED: 65,
    FACEBOOK_CONNECTION: 53,
    FINANCING_NEW: 77,
    FINANCING_USED: 67,
    INFORMATION_REQUEST: 38,
    TRADE_IN_NEW: 4,
    TRADE_IN_USED: 8
};

exports.default = LEAD_TYPES;

/***/ }),

/***/ "../widget-commons-leads/src/constants/VehicleTypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var VEHICLE_TYPES = {
    CATALOG: 1,
    INVENTORY: 2
};

exports.default = VEHICLE_TYPES;

/***/ }),

/***/ "../widget-commons-leads/src/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.version = exports.LEAD_TYPES = exports.LeadSubmissionBuilder = undefined;

var _LeadTypes = __webpack_require__("../widget-commons-leads/src/constants/LeadTypes.js");

var _LeadTypes2 = _interopRequireDefault(_LeadTypes);

var _LeadSubmissionBuilder = __webpack_require__("../widget-commons-leads/src/services/LeadSubmissionBuilder.js");

var _LeadSubmissionBuilder2 = _interopRequireDefault(_LeadSubmissionBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var version = "6.25.3";

exports.LeadSubmissionBuilder = _LeadSubmissionBuilder2.default;
exports.LEAD_TYPES = _LeadTypes2.default;
exports.version = version;
exports.default = {
    LeadSubmissionBuilder: _LeadSubmissionBuilder2.default,
    LEAD_TYPES: _LeadTypes2.default,
    version: version
};

/***/ }),

/***/ "../widget-commons-leads/src/services/LeadSubmissionBuilder.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _leadSubmissionFetchClientapi = __webpack_require__("../../node_modules/@sm360/lead-submission-fetch-clientapi/dist/index.js");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _VehicleTypes = __webpack_require__("../widget-commons-leads/src/constants/VehicleTypes.js");

var _VehicleTypes2 = _interopRequireDefault(_VehicleTypes);

var _LeadTypes = __webpack_require__("../widget-commons-leads/src/constants/LeadTypes.js");

var _LeadTypes2 = _interopRequireDefault(_LeadTypes);

var _config = __webpack_require__("../widget-commons-leads/src/config/index.js");

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// temporary forced valdation for facebook account creation
//------------------
// function isLeadSubmissionRequestValid(leadSubmissionRequest) {
//     const { contact } = leadSubmissionRequest.lead;
//     const contactHasMinimumInfo = contact.firstname && contact.lastname && (contact.email1 || contact.homePhone);
//     return contactHasMinimumInfo;
// }
//------------------

var LeadSubmissionBuilder = function () {
    /**
     * Service to build and submit a lead
     * @example
     * new LeadSubmissionBuilder()
     *      .addContactInformation('Rick', 'Sanchez', '5141231234', 'valid_email')
     *      .addLeadType(LEAD_TYPES.ACCOUNT_CREATION)
     *      .addQuote(VALID_QUOTE)
     *      .addVehicle(VALID_QUOTE)
     *      .submit()
     */
    function LeadSubmissionBuilder() {
        _classCallCheck(this, LeadSubmissionBuilder);

        this.leadSubmissionRequest = {
            lead: {
                organizationId: _widgetCommonsCoreServices.ConfigsService.getOrganizationId(),
                organizationUnitId: _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId(),
                sourceTypeId: 0, // 0 = Web
                contact: {},
                tracking: {
                    websiteId: _widgetCommonsCoreServices.ConfigsService.getWebsiteId(),
                    url: _widgetCommonsCoreServices.WindowProxy.get() ? _widgetCommonsCoreServices.WindowProxy.location().href : undefined
                },
                vehicle: {},
                media: 'Showroom'
            },
            subscriptionInfo: {
                contexts: [],
                info: 'Showroom Sign Up Form'
            }
        };
    }

    /**
     * Setting up the contact information
     * @param {string} firstname
     * @param {string} lastname
     * @param {string} phone
     * @param {string} email
     * @param {number} [contactId]
     */


    _createClass(LeadSubmissionBuilder, [{
        key: 'addContactInformation',
        value: function addContactInformation(firstname, lastname, phone, email, contactId) {
            this.leadSubmissionRequest.lead.contact.firstname = firstname;
            this.leadSubmissionRequest.lead.contact.lastname = lastname;
            this.leadSubmissionRequest.lead.contact.homePhone = phone;
            this.leadSubmissionRequest.lead.contact.email1 = email;
            this.leadSubmissionRequest.lead.contact.id = contactId;
            return this;
        }

        /**
         * Setting up account creation information
         */

    }, {
        key: 'setIsAccountCreation',
        value: function setIsAccountCreation() {
            this.leadSubmissionRequest.accountCreation = true;
            return this;
        }

        /**
         * Setting up the lead type ID
         * @param {LEAD_TYPE} leadType
         */

    }, {
        key: 'addLeadType',
        value: function addLeadType(leadType) {
            if (!Object.values(_LeadTypes2.default).includes(leadType)) {
                throw new Error('Lead type [' + leadType + '] is not supported');
            }

            this.leadSubmissionRequest.lead.typeId = leadType;
            return this;
        }

        /**
         * Setting up opt-in email
         * @param {boolean} optInEmail
         */

    }, {
        key: 'addOptInEmail',
        value: function addOptInEmail(optInEmail) {
            if (optInEmail) {
                this.leadSubmissionRequest.subscriptionInfo.contexts.push('newsletter', 'marketing', 'service');
            }

            return this;
        }

        /**
         * Setting up quote information
         * @param {object} quote.id
         */

    }, {
        key: 'addQuote',
        value: function addQuote(quote) {
            if (quote) {
                this.leadSubmissionRequest.quoteId = quote.id;
            }

            return this;
        }

        /**
         * Setting up vehicle information
         * @param {object} quote
         */

    }, {
        key: 'addVehicle',
        value: function addVehicle(quote) {
            if (quote && quote.vehicle) {
                var vehicle = quote.vehicle,
                    vehicleId = quote.vehicleId;

                var vehicleInventoryId = vehicleId || vehicle.vehicleId;
                this.leadSubmissionRequest.lead.vehicle.vehicleInventoryId = vehicleInventoryId;
                this.leadSubmissionRequest.lead.vehicle.catalogVehicleId = vehicle.catalogVehicleId;
                this.leadSubmissionRequest.lead.vehicle.typeId = vehicleInventoryId ? _VehicleTypes2.default.INVENTORY : _VehicleTypes2.default.CATALOG;
            }

            return this;
        }

        /**
         * Setting up the trade in vehicle details
         * @param {number} year
         * @param {string} make
         * @param {string} model
         * @param {string} trim
         * @param {string} bodyStyle
         * @param {string} color
         * @param {number} kilometers
         * @param {string} vin
         */

    }, {
        key: 'addTradeInVehicle',
        value: function addTradeInVehicle(year, make, model, trim, bodyStyle, color, kilometers, vin) {
            if (!this.leadSubmissionRequest.lead.tradeIn) {
                this.leadSubmissionRequest.lead.tradeIn = {};
            }
            this.leadSubmissionRequest.lead.tradeIn.year = year;
            this.leadSubmissionRequest.lead.tradeIn.make = make;
            this.leadSubmissionRequest.lead.tradeIn.model = model;
            this.leadSubmissionRequest.lead.tradeIn.trim = trim;
            this.leadSubmissionRequest.lead.tradeIn.bodyStyle = bodyStyle;
            this.leadSubmissionRequest.lead.tradeIn.exteriorColor = color;
            this.leadSubmissionRequest.lead.tradeIn.kilometers = kilometers;
            this.leadSubmissionRequest.lead.tradeIn.vin = vin;
            // I know that sending the same info this is crappy, but to avoid
            // changing many core services, it's easier to just do it like this for now
            this.leadSubmissionRequest.lead.tradeIn.orgId = this.leadSubmissionRequest.lead.organizationId;
            this.leadSubmissionRequest.lead.tradeIn.orgUnitId = this.leadSubmissionRequest.lead.organizationUnitId;
            return this;
        }

        /**
         * Setting up the estimation's details
         * @param {number} value
         * @param {number} low
         * @param {number} high
         */

    }, {
        key: 'addTradeInEstimation',
        value: function addTradeInEstimation(value, low, high) {
            if (!this.leadSubmissionRequest.lead.tradeIn) {
                this.leadSubmissionRequest.lead.tradeIn = {};
            }
            this.leadSubmissionRequest.lead.tradeIn.estimation = {};
            this.leadSubmissionRequest.lead.tradeIn.estimation.amount = value;
            this.leadSubmissionRequest.lead.tradeIn.estimation.high = high;
            this.leadSubmissionRequest.lead.tradeIn.estimation.low = low;
            return this;
        }

        /**
         * Setting up the trade in questionnaire
         * @param {object} evaluation
         * @param {*} evaluation.questionKey Key represents the question and the value is the answer
         */

    }, {
        key: 'addTradeInEvaluation',
        value: function addTradeInEvaluation(evaluation) {
            if (!this.leadSubmissionRequest.lead.tradeIn) {
                this.leadSubmissionRequest.lead.tradeIn = {};
            }
            this.leadSubmissionRequest.lead.tradeIn.conditionForm = evaluation;
            return this;
        }
    }, {
        key: 'addFinancingInformation',
        value: function addFinancingInformation() {
            // TODO when migrating financing
            throw new Error('Not yet implemented');
        }
    }, {
        key: 'submit',
        value: function submit() {
            var _this = this;

            var accountPromise = _widgetCommonsGeneral.AccountService.isAuthenticated() ? _widgetCommonsGeneral.AccountService.getLoggedAccount() : Promise.resolve({});

            return accountPromise.then(function (_ref) {
                var contactId = _ref.contactId;

                if (!_this.leadSubmissionRequest.lead.contact.id) {
                    _this.leadSubmissionRequest.lead.contact.id = contactId;
                }
                // temporary forced valdation for facebook account creation
                // ------------------
                // if (!isLeadSubmissionRequestValid(this.leadSubmissionRequest)) {
                //     return Promise.reject(new Error('Lead is invalid. Missing contact information'));
                // }
                // -------------------

                return _widgetCommonsCoreServices.TokenService.fetch().then(function (accessToken) {
                    return (0, _leadSubmissionFetchClientapi.LeadApiFp)({
                        accessToken: accessToken
                    }).send(_this.leadSubmissionRequest)(undefined, _config2.default.endpoint.leadSubmission);
                });
            });
        }
    }]);

    return LeadSubmissionBuilder;
}();

exports.default = LeadSubmissionBuilder;

/***/ }),

/***/ "./src/ModelYear/actions/modelYearActionTypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var LOAD_MODEL_YEAR_SUCCESS = exports.LOAD_MODEL_YEAR_SUCCESS = 'LOAD_MODEL_YEAR_SUCCESS';
var CHANGE_BUILD_AND_QUOTE_SECTION = exports.CHANGE_BUILD_AND_QUOTE_SECTION = 'CHANGE_BUILD_AND_QUOTE_SECTION';

var SET_MODEL_YEARS = exports.SET_MODEL_YEARS = 'SET_MODEL_YEARS';
var SET_MODEL_TRIMS = exports.SET_MODEL_TRIMS = 'SET_MODEL_TRIMS';
var SET_DRIVE_POWER_TRAINS = exports.SET_DRIVE_POWER_TRAINS = 'SET_DRIVE_POWER_TRAINS';
var SET_OPTIONS_PACKAGES = exports.SET_OPTIONS_PACKAGES = 'SET_OPTIONS_PACKAGES';

exports.default = {
    LOAD_MODEL_YEAR_SUCCESS: LOAD_MODEL_YEAR_SUCCESS,
    SET_MODEL_YEARS: SET_MODEL_YEARS,
    SET_MODEL_TRIMS: SET_MODEL_TRIMS,
    SET_DRIVE_POWER_TRAINS: SET_DRIVE_POWER_TRAINS,
    SET_OPTIONS_PACKAGES: SET_OPTIONS_PACKAGES,
    CHANGE_BUILD_AND_QUOTE_SECTION: CHANGE_BUILD_AND_QUOTE_SECTION
};

/***/ }),

/***/ "./src/ModelYear/actions/modelYearActions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setModelYear = setModelYear;
exports.loadModelYearSuccess = loadModelYearSuccess;
exports.setModelYears = setModelYears;
exports.setModelTrims = setModelTrims;
exports.setDrivePowerTrains = setDrivePowerTrains;
exports.setOptionsPackages = setOptionsPackages;
exports.loadModelYears = loadModelYears;
exports.loadModelYearFromQuote = loadModelYearFromQuote;
exports.loadModelYear = loadModelYear;
exports.validateSelectedOptions = validateSelectedOptions;
exports.loadOptions = loadOptions;
exports.updateSelectedPackageAmounts = updateSelectedPackageAmounts;
exports.updateFromQuote = updateFromQuote;

var _modelYearActionTypes = __webpack_require__("./src/ModelYear/actions/modelYearActionTypes.js");

var _modelYearActionTypes2 = _interopRequireDefault(_modelYearActionTypes);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _purchaseMethods = __webpack_require__("./src/PurchaseMethods/constants/purchaseMethods.js");

var _dataOrigins = __webpack_require__("./src/constants/dataOrigins.js");

var DataOrigins = _interopRequireWildcard(_dataOrigins);

var _ShowroomService = __webpack_require__("./src/services/ShowroomService/ShowroomService.js");

var _ShowroomService2 = _interopRequireDefault(_ShowroomService);

var _quoteActions = __webpack_require__("./src/Quote/actions/quoteActions.js");

var QuoteActions = _interopRequireWildcard(_quoteActions);

var _ModelYearAPIService = __webpack_require__("./src/ModelYear/services/ModelYearAPIService/ModelYearAPIService.js");

var _ModelYearAPIService2 = _interopRequireDefault(_ModelYearAPIService);

var _ModelYearService = __webpack_require__("./src/ModelYear/services/ModelYearService/ModelYearService.js");

var _ModelYearService2 = _interopRequireDefault(_ModelYearService);

var _PurchaseMethodsModel = __webpack_require__("./src/PurchaseMethods/models/PurchaseMethodsModel.js");

var _PurchaseMethodsModel2 = _interopRequireDefault(_PurchaseMethodsModel);

var _purchaseMethodsActions = __webpack_require__("./src/PurchaseMethods/actions/purchaseMethodsActions.js");

var PurchaseMethodsActions = _interopRequireWildcard(_purchaseMethodsActions);

var _tradeInVehicleActions = __webpack_require__("./src/Vehicle/actions/tradeInVehicleActions.js");

var TradeInVehicleActions = _interopRequireWildcard(_tradeInVehicleActions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setModelYear(modelYear) {
    return { type: _modelYearActionTypes2.default.LOAD_MODEL_YEAR_SUCCESS, modelYear: modelYear };
}

function loadModelYearSuccess(modelYear) {
    return { type: _modelYearActionTypes2.default.LOAD_MODEL_YEAR_SUCCESS, modelYear: modelYear };
}

function setModelYears(modelYear) {
    return { type: _modelYearActionTypes2.default.SET_MODEL_YEARS, modelYear: modelYear };
}

function setModelTrims(modelYear) {
    return { type: _modelYearActionTypes2.default.SET_MODEL_TRIMS, modelYear: modelYear };
}

function setDrivePowerTrains(modelYear) {
    return { type: _modelYearActionTypes2.default.SET_DRIVE_POWER_TRAINS, modelYear: modelYear };
}

function setOptionsPackages(modelYear) {
    return { type: _modelYearActionTypes2.default.SET_OPTIONS_PACKAGES, modelYear: modelYear };
}

function loadModelYears(modelYearsParams, tradeInVehicleParams, initialLoad) {
    return function (dispatch, getState) {
        return _ModelYearAPIService2.default.loadModelYears(modelYearsParams, tradeInVehicleParams).then(function (results) {
            var state = getState();
            var currentPurchaseMethods = state.purchaseMethods;
            var selectedPurchaseMethod = currentPurchaseMethods.getSelectedPurchaseMethod();
            var modelYear = state.modelYear.modelTrims.size > 0 ? _ModelYearService2.default.resetPaymentsAndPurchaseAmounts(_ModelYearService2.default.resetModelYears(state.modelYear, results.years), currentPurchaseMethods) : _ModelYearService2.default.resetModelYears(state.modelYear, results.years);

            modelYear = _ModelYearService2.default.selectPurchaseMethod(modelYear, initialLoad ? _purchaseMethods.BEST_PAYMENT : selectedPurchaseMethod);

            dispatch(PurchaseMethodsActions.loadPurchaseMethodsSuccess(modelYear.getSelectedYearPurchaseMethods()));
            dispatch(setModelYear(modelYear));

            if (results.tradeInVehicle && results.tradeInVehicle.id) {
                dispatch(TradeInVehicleActions.setTradeInVehicle(results.tradeInVehicle));
                dispatch(PurchaseMethodsActions.setTradeIn(results.tradeInVehicle.getTradeInAmount()));
                dispatch(PurchaseMethodsActions.setLien(results.tradeInVehicle.getLienAmount()));
            } else {
                var defaultPurchaseMethods = new _PurchaseMethodsModel2.default();
                dispatch(PurchaseMethodsActions.setTradeIn(defaultPurchaseMethods.tradeIn));
                dispatch(PurchaseMethodsActions.setLien(defaultPurchaseMethods.lien));
            }

            var paymentFrequency = _widgetCommonsGeneral.LocalStorageService.get('paymentFrequency');
            if (paymentFrequency) {
                dispatch(PurchaseMethodsActions.selectPaymentFrequency({
                    value: parseInt(paymentFrequency, 10)
                }));
            }
        }).catch(function (error) {
            throw error;
        });
    };
}

function loadModelYearFromQuote(quote) {
    return function (dispatch) {
        var vehicle = quote.vehicle;

        var modelYearsParams = {
            year: vehicle.year,
            make: vehicle.make,
            model: vehicle.model,
            bodyStyleCode: vehicle.bodyStyleCode,
            modelTrimCode: vehicle.modelTrimCode,
            quoteId: quote.id
        };
        var tradeInVehicleParams = {
            id: ''
        };
        return _ModelYearAPIService2.default.loadModelYear(modelYearsParams, tradeInVehicleParams).then(function (results) {
            return dispatch(loadModelYearSuccess(results.modelYear));
        });
    };
}

function loadModelYear(modelYearsParams, tradeInVehicleParams) {
    return function (dispatch, getState) {
        return _ModelYearAPIService2.default.loadModelYear(modelYearsParams, tradeInVehicleParams).then(function (results) {
            var state = getState();
            var currentPurchaseMethods = state.purchaseMethods;
            var selectedPurchaseMethod = currentPurchaseMethods.getSelectedPurchaseMethod();
            var modelYear = state.modelYear.modelYearsAreLoaded() ? _ModelYearService2.default.resetPaymentsAndPurchaseAmounts(_ModelYearService2.default.resetModelYears(results.modelYear, state.modelYear.years, modelYearsParams.year), currentPurchaseMethods) : results.modelYear;
            modelYear = _ModelYearService2.default.selectPurchaseMethod(modelYear, selectedPurchaseMethod);

            dispatch(setModelYear(modelYear));
            var cabSizes = results.modelYear.cabSizes;

            if (cabSizes && cabSizes.length) {
                modelYear = _ModelYearService2.default.setSelectedCabSize(modelYear, cabSizes[0]);
            } else {
                var modelTrims = results.modelYear.modelTrims;

                if (modelTrims.size > 0) {
                    if (modelYearsParams.modelTrimCode) {
                        var newOptionsPackage = modelYear.optionsPackages.filter(function (optionsPackage) {
                            return optionsPackage.configuration.modelTrimCode === modelYearsParams.modelTrimCode;
                        }).first();
                        var modelTrimSelectionCode = newOptionsPackage ? newOptionsPackage.configuration.modelTrim.selectionCode : '';
                        var newModelTrim = modelTrimSelectionCode ? modelYear.modelTrims.filter(function (modelTrim) {
                            return modelTrim.selectionCode === modelTrimSelectionCode;
                        }).first() : state.modelYear.modelTrims.first();

                        modelYear = _ModelYearService2.default.setSelectedModelTrim(modelYear, newModelTrim);
                    } else {
                        modelYear = _ModelYearService2.default.setSelectedModelTrim(modelYear, modelTrims.first());
                    }
                }
            }
            var selectedOptionsPackage = modelYear.getSelectedOptionsPackage();

            var exteriorColour = null;
            if (selectedOptionsPackage) {
                dispatch(setModelYear(modelYear));
                dispatch(PurchaseMethodsActions.loadPurchaseMethodsSuccess(selectedOptionsPackage.configuration.purchaseMethods));

                var interiorColour = modelYear.getSelectedOptionsPackageInteriorColour();
                if (interiorColour) {
                    var interiorColourAmounts = {
                        retail: interiorColour.retail,
                        residualRetail: interiorColour.residualRetail
                    };
                    dispatch(PurchaseMethodsActions.setInteriorColourAmounts(interiorColourAmounts));
                }

                exteriorColour = modelYear.getSelectedOptionsPackageExteriorColour();
                if (exteriorColour) {
                    var exteriorColourAmounts = {
                        retail: exteriorColour.retail,
                        residualRetail: exteriorColour.residualRetail
                    };
                    dispatch(PurchaseMethodsActions.setExteriorColourAmounts(exteriorColourAmounts));
                }
            }

            if (results.tradeInVehicle && results.tradeInVehicle.id) {
                dispatch(TradeInVehicleActions.setTradeInVehicle(results.tradeInVehicle));
                dispatch(PurchaseMethodsActions.setTradeIn(results.tradeInVehicle.getTradeInAmount()));
                dispatch(PurchaseMethodsActions.setLien(results.tradeInVehicle.getLienAmount()));
            }

            var paymentFrequency = _widgetCommonsGeneral.LocalStorageService.get('paymentFrequency');
            if (!modelYearsParams.quoteId && paymentFrequency) {
                dispatch(PurchaseMethodsActions.selectPaymentFrequency({
                    value: parseInt(paymentFrequency, 10)
                }));
            }
        }).catch(function (error) {
            throw error;
        });
    };
}

function validateSelectedOptions(currentModelYear) {
    return function (dispatch, getState) {
        var modelYear = currentModelYear || getState().modelYear;
        var configuration = modelYear ? modelYear.getSelectedOptionsPackageConfiguration() : null;
        if (!configuration) {
            return Promise.reject();
        }

        var _modelYear = modelYear,
            year = _modelYear.year,
            make = _modelYear.make;

        var locale = _widgetCommonsCoreServices.LocaleService.getLocale();

        return _ShowroomService2.default.validateSelectedOptions(DataOrigins.OPTIONS_VALIDATION, year, make, configuration, locale, '', null).then(function (_ref) {
            var configurationToken = _ref.configurationToken,
                items = _ref.items;

            modelYear = _ModelYearService2.default.resetConfigurationToken(modelYear, configurationToken);
            modelYear = _ModelYearService2.default.resetOptionsAvailability(modelYear, items);
            dispatch(setOptionsPackages(modelYear));
        });
    };
}

function loadOptionsSuccess(options, modelYear) {
    return function (dispatch, getState) {
        var newModelYear = modelYear || getState().modelYear;
        newModelYear = _ModelYearService2.default.setAvailableOptions(newModelYear, options);
        var selectedOptionsPackage = modelYear.getSelectedOptionsPackage();

        if (selectedOptionsPackage) {
            dispatch(setOptionsPackages(newModelYear));
            dispatch(PurchaseMethodsActions.loadPurchaseMethodsSuccess(selectedOptionsPackage.configuration.purchaseMethods));
        }
        return newModelYear;
    };
}

function loadOptions(modelYear) {
    var year = modelYear.year,
        make = modelYear.make;

    var configuration = modelYear.getSelectedOptionsPackageConfiguration();
    return function (dispatch) {
        return _ShowroomService2.default.loadModelTrimOptions(year, make, configuration).then(function (options) {
            return dispatch(loadOptionsSuccess(options, modelYear));
        }).catch(function (error) {
            throw error;
        });
    };
}
function updateExteriorColourAmounts(skipOptionsValidation, currentModelYear) {
    return function (dispatch, getState) {
        var modelYear = currentModelYear || getState().modelYear;
        var exteriorColour = modelYear.getSelectedOptionsPackageExteriorColour();

        if (exteriorColour) {
            var exteriorColourAmounts = {
                retail: exteriorColour.retail,
                residualRetail: exteriorColour.residualRetail
            };
            dispatch(PurchaseMethodsActions.setExteriorColourAmounts(exteriorColourAmounts));
            if (!skipOptionsValidation) {
                dispatch(validateSelectedOptions(modelYear));
            }
        }
    };
}

function updateInteriorColourAmounts(skipOptionsValidation, currentModelYear) {
    return function (dispatch, getState) {
        var modelYear = currentModelYear || getState().modelYear;
        var interiorColour = modelYear.getSelectedOptionsPackageInteriorColour();

        if (interiorColour) {
            var interiorColourAmounts = {
                retail: interiorColour.retail,
                residualRetail: interiorColour.residualRetail
            };
            dispatch(PurchaseMethodsActions.setInteriorColourAmounts(interiorColourAmounts));
            if (!skipOptionsValidation) {
                dispatch(validateSelectedOptions(modelYear));
            }
        }
    };
}
function updateSelectedPackageAmounts(selectedOptionsPackage, skipOptionsValidation, currentModelYear) {
    return function (dispatch, getState) {
        var exteriorColour = selectedOptionsPackage.configuration.getSelectedExteriorColour();
        var interiorColour = selectedOptionsPackage.configuration.getSelectedInteriorColour();
        var modelYear = currentModelYear || getState().modelYear;

        if (exteriorColour || interiorColour) {
            if (exteriorColour) {
                modelYear = _ModelYearService2.default.setSelectedExteriorColour(modelYear, exteriorColour);
            }
            if (interiorColour) {
                modelYear = _ModelYearService2.default.setSelectedInteriorColour(modelYear, interiorColour);
            }
            dispatch({ type: _modelYearActionTypes2.default.LOAD_MODEL_YEAR_SUCCESS, modelYear: modelYear });
        }

        dispatch(PurchaseMethodsActions.loadPurchaseMethodsSuccess(selectedOptionsPackage.configuration.purchaseMethods));
        dispatch(updateInteriorColourAmounts(true, modelYear));
        dispatch(updateExteriorColourAmounts(skipOptionsValidation, modelYear));
    };
}

function updateFromQuote(quoteId, bqConfirmation) {
    return function (dispatch, getState) {
        var state = getState();
        if (state.quote && state.quote.id !== quoteId) {
            return Promise.resolve();
        }
        var newModelYear = _ModelYearService2.default.resetModelYearFromQuote(state.modelYear, state.quote);
        dispatch(loadModelYearSuccess(newModelYear));
        return dispatch(loadOptions(newModelYear)).then(function () {
            var selectedOptionsPackage = newModelYear.getSelectedOptionsPackage();
            if (selectedOptionsPackage) {
                state = getState();
                newModelYear = _ModelYearService2.default.resetModelYearOptionsFromQuote(state.modelYear, state.quote);
                dispatch(loadModelYearSuccess(newModelYear));
                if (bqConfirmation) {
                    dispatch(validateSelectedOptions(newModelYear, true)).then(function () {
                        dispatch(QuoteActions.setQuote(state.quote.set('modified', false)));
                    });
                }
                return dispatch(updateSelectedPackageAmounts(selectedOptionsPackage, true));
            }
            return Promise.resolve();
        });
    };
}

exports.default = {
    setModelYear: setModelYear,
    setModelYears: setModelYears,
    setModelTrims: setModelTrims,
    setDrivePowerTrains: setDrivePowerTrains,
    setOptionsPackages: setOptionsPackages,
    loadModelYears: loadModelYears,
    loadModelYear: loadModelYear,
    validateSelectedOptions: validateSelectedOptions,
    updateFromQuote: updateFromQuote,
    loadOptions: loadOptions,
    loadModelYearFromQuote: loadModelYearFromQuote,
    updateExteriorColourAmounts: updateExteriorColourAmounts,
    updateSelectedPackageAmounts: updateSelectedPackageAmounts
};

/***/ }),

/***/ "./src/ModelYear/constants/exteriorColourStatuses.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var IMAGE_STATUS = exports.IMAGE_STATUS = {
    NO_IMAGE: 0,
    IMAGE_FROM_PREVIOUS_YEAR: 1,
    IMAGE_FROM_PREVIOUS_TRIM: 2,
    MAIN_IMAGE: 3,
    PARTIAL_COLORIZED: 4,
    FULL_COLORIZED: 5
};

exports.default = {
    IMAGE_STATUS: IMAGE_STATUS
};

/***/ }),

/***/ "./src/ModelYear/i18n/en.json":
/***/ (function(module, exports) {

module.exports = {"engine":{"size":"%{displacement}L %{cylinders}cyl.","sizeTurbo":"%{displacement}L %{cylinders}cyl. turbo","power":"%{hp}hp / %{torque}lb. ft. torque"},"transmission":{"types":"%{type}","speeds":"%{speeds} speed","cvt":"%{type} CVT","typesSpeeds":"%{type} %{speeds} speed"},"fuel":{"city":"City: ","highway":"Hwy: ","100km":"L / 100km"}}

/***/ }),

/***/ "./src/ModelYear/i18n/fr.json":
/***/ (function(module, exports) {

module.exports = {"engine":{"size":"%{displacement}L %{cylinders}cyl.","sizeTurbo":"%{displacement}L %{cylinders}cyl. turbo","power":"%{hp}hp / %{torque}lb. pi. de couple"},"transmission":{"types":"%{type}","speeds":"%{speeds} vitesses","cvt":"%{type} CVT","typesSpeeds":"%{type} %{speeds} vitesses"},"fuel":{"city":"Ville: ","highway":"Route: ","100km":"L / 100km"}}

/***/ }),

/***/ "./src/ModelYear/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EXTERIOR_COLOUR_STATUSES = exports.YearService = exports.TransmissionService = exports.OptionsPackageService = exports.OptionService = exports.ModelYearService = exports.ModelTrimService = exports.ModelTrimItemsService = exports.ModelTrimConfigurationService = exports.EngineService = exports.DriveTrainService = exports.DrivePowerTrainService = exports.DataUtilitiesService = exports.ColourService = exports.ModelYearReducer = exports.YearModel = exports.TransmissionModel = exports.OptionsPackageModel = exports.OptionModel = exports.ModelYearModel = exports.ModelTrimModel = exports.ModelTrimConfigurationModel = exports.FeatureModel = exports.FeatureIconModel = exports.EngineModel = exports.DriveTrainModel = exports.DrivePowerTrainModel = exports.ColourModel = exports.BoxSizeModel = exports.CabSizeModel = exports.Translations = exports.ModelYearActionsTypes = exports.ModelYearActions = undefined;

var _modelYearActions = __webpack_require__("./src/ModelYear/actions/modelYearActions.js");

var _modelYearActions2 = _interopRequireDefault(_modelYearActions);

var _modelYearActionTypes = __webpack_require__("./src/ModelYear/actions/modelYearActionTypes.js");

var _modelYearActionTypes2 = _interopRequireDefault(_modelYearActionTypes);

var _en = __webpack_require__("./src/ModelYear/i18n/en.json");

var _en2 = _interopRequireDefault(_en);

var _fr = __webpack_require__("./src/ModelYear/i18n/fr.json");

var _fr2 = _interopRequireDefault(_fr);

var _CabSizeModel = __webpack_require__("./src/ModelYear/models/CabSizeModel.js");

var _CabSizeModel2 = _interopRequireDefault(_CabSizeModel);

var _BoxSizeModel = __webpack_require__("./src/ModelYear/models/BoxSizeModel.js");

var _BoxSizeModel2 = _interopRequireDefault(_BoxSizeModel);

var _ColourModel = __webpack_require__("./src/ModelYear/models/ColourModel.js");

var _ColourModel2 = _interopRequireDefault(_ColourModel);

var _DrivePowerTrainModel = __webpack_require__("./src/ModelYear/models/DrivePowerTrainModel.js");

var _DrivePowerTrainModel2 = _interopRequireDefault(_DrivePowerTrainModel);

var _DriveTrainModel = __webpack_require__("./src/ModelYear/models/DriveTrainModel.js");

var _DriveTrainModel2 = _interopRequireDefault(_DriveTrainModel);

var _EngineModel = __webpack_require__("./src/ModelYear/models/EngineModel.js");

var _EngineModel2 = _interopRequireDefault(_EngineModel);

var _FeatureIconModel = __webpack_require__("./src/ModelYear/models/FeatureIconModel.js");

var _FeatureIconModel2 = _interopRequireDefault(_FeatureIconModel);

var _FeatureModel = __webpack_require__("./src/ModelYear/models/FeatureModel.js");

var _FeatureModel2 = _interopRequireDefault(_FeatureModel);

var _ModelTrimConfigurationModel = __webpack_require__("./src/ModelYear/models/ModelTrimConfigurationModel.js");

var _ModelTrimConfigurationModel2 = _interopRequireDefault(_ModelTrimConfigurationModel);

var _ModelTrimModel = __webpack_require__("./src/ModelYear/models/ModelTrimModel.js");

var _ModelTrimModel2 = _interopRequireDefault(_ModelTrimModel);

var _ModelYearModel = __webpack_require__("./src/ModelYear/models/ModelYearModel.js");

var _ModelYearModel2 = _interopRequireDefault(_ModelYearModel);

var _OptionModel = __webpack_require__("./src/ModelYear/models/OptionModel.js");

var _OptionModel2 = _interopRequireDefault(_OptionModel);

var _OptionsPackageModel = __webpack_require__("./src/ModelYear/models/OptionsPackageModel.js");

var _OptionsPackageModel2 = _interopRequireDefault(_OptionsPackageModel);

var _TransmissionModel = __webpack_require__("./src/ModelYear/models/TransmissionModel.js");

var _TransmissionModel2 = _interopRequireDefault(_TransmissionModel);

var _YearModel = __webpack_require__("./src/ModelYear/models/YearModel.js");

var _YearModel2 = _interopRequireDefault(_YearModel);

var _modelYearReducer = __webpack_require__("./src/ModelYear/reducers/modelYearReducer.js");

var _modelYearReducer2 = _interopRequireDefault(_modelYearReducer);

var _ColourService = __webpack_require__("./src/ModelYear/services/ColourService/ColourService.js");

var _ColourService2 = _interopRequireDefault(_ColourService);

var _DataUtilitiesService = __webpack_require__("./src/ModelYear/services/DataUtilitiesService/DataUtilitiesService.js");

var _DataUtilitiesService2 = _interopRequireDefault(_DataUtilitiesService);

var _DrivePowerTrainService = __webpack_require__("./src/ModelYear/services/DrivePowerTrainService/DrivePowerTrainService.js");

var _DrivePowerTrainService2 = _interopRequireDefault(_DrivePowerTrainService);

var _DriveTrainService = __webpack_require__("./src/ModelYear/services/DriveTrainService/DriveTrainService.js");

var _DriveTrainService2 = _interopRequireDefault(_DriveTrainService);

var _EngineService = __webpack_require__("./src/ModelYear/services/EngineService/EngineService.js");

var _EngineService2 = _interopRequireDefault(_EngineService);

var _ModelTrimConfigurationService = __webpack_require__("./src/ModelYear/services/ModelTrimConfigurationService/ModelTrimConfigurationService.js");

var _ModelTrimConfigurationService2 = _interopRequireDefault(_ModelTrimConfigurationService);

var _ModelTrimItemsService = __webpack_require__("./src/ModelYear/services/ModelTrimItemsService/ModelTrimItemsService.js");

var _ModelTrimItemsService2 = _interopRequireDefault(_ModelTrimItemsService);

var _ModelTrimService = __webpack_require__("./src/ModelYear/services/ModelTrimService/ModelTrimService.js");

var _ModelTrimService2 = _interopRequireDefault(_ModelTrimService);

var _ModelYearService = __webpack_require__("./src/ModelYear/services/ModelYearService/ModelYearService.js");

var _ModelYearService2 = _interopRequireDefault(_ModelYearService);

var _OptionService = __webpack_require__("./src/ModelYear/services/OptionService/OptionService.js");

var _OptionService2 = _interopRequireDefault(_OptionService);

var _OptionsPackageService = __webpack_require__("./src/ModelYear/services/OptionsPackageService/OptionsPackageService.js");

var _OptionsPackageService2 = _interopRequireDefault(_OptionsPackageService);

var _TransmissionService = __webpack_require__("./src/ModelYear/services/TransmissionService/TransmissionService.js");

var _TransmissionService2 = _interopRequireDefault(_TransmissionService);

var _YearService = __webpack_require__("./src/ModelYear/services/YearService/YearService.js");

var _YearService2 = _interopRequireDefault(_YearService);

var _exteriorColourStatuses = __webpack_require__("./src/ModelYear/constants/exteriorColourStatuses.js");

var _exteriorColourStatuses2 = _interopRequireDefault(_exteriorColourStatuses);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Translations = {
    en: _en2.default,
    fr: _fr2.default
};

exports.ModelYearActions = _modelYearActions2.default;
exports.ModelYearActionsTypes = _modelYearActionTypes2.default;
exports.Translations = Translations;
exports.CabSizeModel = _CabSizeModel2.default;
exports.BoxSizeModel = _BoxSizeModel2.default;
exports.ColourModel = _ColourModel2.default;
exports.DrivePowerTrainModel = _DrivePowerTrainModel2.default;
exports.DriveTrainModel = _DriveTrainModel2.default;
exports.EngineModel = _EngineModel2.default;
exports.FeatureIconModel = _FeatureIconModel2.default;
exports.FeatureModel = _FeatureModel2.default;
exports.ModelTrimConfigurationModel = _ModelTrimConfigurationModel2.default;
exports.ModelTrimModel = _ModelTrimModel2.default;
exports.ModelYearModel = _ModelYearModel2.default;
exports.OptionModel = _OptionModel2.default;
exports.OptionsPackageModel = _OptionsPackageModel2.default;
exports.TransmissionModel = _TransmissionModel2.default;
exports.YearModel = _YearModel2.default;
exports.ModelYearReducer = _modelYearReducer2.default;
exports.ColourService = _ColourService2.default;
exports.DataUtilitiesService = _DataUtilitiesService2.default;
exports.DrivePowerTrainService = _DrivePowerTrainService2.default;
exports.DriveTrainService = _DriveTrainService2.default;
exports.EngineService = _EngineService2.default;
exports.ModelTrimConfigurationService = _ModelTrimConfigurationService2.default;
exports.ModelTrimItemsService = _ModelTrimItemsService2.default;
exports.ModelTrimService = _ModelTrimService2.default;
exports.ModelYearService = _ModelYearService2.default;
exports.OptionService = _OptionService2.default;
exports.OptionsPackageService = _OptionsPackageService2.default;
exports.TransmissionService = _TransmissionService2.default;
exports.YearService = _YearService2.default;
exports.EXTERIOR_COLOUR_STATUSES = _exteriorColourStatuses2.default;
exports.default = {
    ModelYearActions: _modelYearActions2.default,
    ModelYearActionsTypes: _modelYearActionTypes2.default,

    Translations: Translations,

    CabSizeModel: _CabSizeModel2.default,
    BoxSizeModel: _BoxSizeModel2.default,
    ColourModel: _ColourModel2.default,
    DrivePowerTrainModel: _DrivePowerTrainModel2.default,
    DriveTrainModel: _DriveTrainModel2.default,
    EngineModel: _EngineModel2.default,
    FeatureIconModel: _FeatureIconModel2.default,
    FeatureModel: _FeatureModel2.default,
    ModelTrimConfigurationModel: _ModelTrimConfigurationModel2.default,
    ModelTrimModel: _ModelTrimModel2.default,
    ModelYearModel: _ModelYearModel2.default,
    OptionModel: _OptionModel2.default,
    OptionsPackageModel: _OptionsPackageModel2.default,
    TransmissionModel: _TransmissionModel2.default,
    YearModel: _YearModel2.default,
    ModelYearReducer: _modelYearReducer2.default,

    ColourService: _ColourService2.default,
    DataUtilitiesService: _DataUtilitiesService2.default,
    DrivePowerTrainService: _DrivePowerTrainService2.default,
    DriveTrainService: _DriveTrainService2.default,
    EngineService: _EngineService2.default,
    ModelTrimConfigurationService: _ModelTrimConfigurationService2.default,
    ModelTrimItemsService: _ModelTrimItemsService2.default,
    ModelTrimService: _ModelTrimService2.default,
    ModelYearService: _ModelYearService2.default,
    OptionService: _OptionService2.default,
    OptionsPackageService: _OptionsPackageService2.default,
    TransmissionService: _TransmissionService2.default,
    YearService: _YearService2.default,

    EXTERIOR_COLOUR_STATUSES: _exteriorColourStatuses2.default
};

/***/ }),

/***/ "./src/ModelYear/models/BoxSizeModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = __webpack_require__("immutable");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BoxSizeRecord = (0, _immutable.Record)({
    trimsBitField: 0,
    trimsBitFields: [],
    selectionCode: '',
    enabled: true,
    visible: true,
    selected: false,
    userSelected: false,
    code: '',
    description: '',
    rank: 0,
    configurationIds: {}
});

var BoxSize = function (_BoxSizeRecord) {
    _inherits(BoxSize, _BoxSizeRecord);

    function BoxSize() {
        _classCallCheck(this, BoxSize);

        return _possibleConstructorReturn(this, (BoxSize.__proto__ || Object.getPrototypeOf(BoxSize)).apply(this, arguments));
    }

    return BoxSize;
}(BoxSizeRecord);

exports.default = BoxSize;

/***/ }),

/***/ "./src/ModelYear/models/CabSizeModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = __webpack_require__("immutable");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CabSizeRecord = (0, _immutable.Record)({
    trimsBitField: 0,
    trimsBitFields: [],
    selectionCode: '',
    enabled: true,
    visible: true,
    selected: false,
    userSelected: false,
    code: '',
    description: '',
    rank: 0,
    configurationIds: {}
});

var CabSize = function (_CabSizeRecord) {
    _inherits(CabSize, _CabSizeRecord);

    function CabSize() {
        _classCallCheck(this, CabSize);

        return _possibleConstructorReturn(this, (CabSize.__proto__ || Object.getPrototypeOf(CabSize)).apply(this, arguments));
    }

    return CabSize;
}(CabSizeRecord);

exports.default = CabSize;

/***/ }),

/***/ "./src/ModelYear/models/ColourModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = __webpack_require__("immutable");

var _dataTypes = __webpack_require__("./src/constants/dataTypes.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ColourRecord = (0, _immutable.Record)({
    colourCode: '',
    colourDescription: '',
    fabricDescription: '',
    selected: false,
    enabled: true,
    visible: true,
    colourTile: '',
    photo1: '',
    photo2: '',
    photo3: '',
    retail: 0,
    residualRetail: 0
});

var Colour = function (_ColourRecord) {
    _inherits(Colour, _ColourRecord);

    function Colour() {
        _classCallCheck(this, Colour);

        return _possibleConstructorReturn(this, (Colour.__proto__ || Object.getPrototypeOf(Colour)).apply(this, arguments));
    }

    _createClass(Colour, [{
        key: 'getColourCode',
        value: function getColourCode() {
            return this.get('colourCode');
        }
    }, {
        key: 'getColourSelectionCode',
        value: function getColourSelectionCode() {
            return this.colourCode + '>' + _dataTypes.SUPPLIER_OPTION;
        }
    }]);

    return Colour;
}(ColourRecord);

exports.default = Colour;

/***/ }),

/***/ "./src/ModelYear/models/DrivePowerTrainModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = __webpack_require__("immutable");

var _DriveTrainModel = __webpack_require__("./src/ModelYear/models/DriveTrainModel.js");

var _DriveTrainModel2 = _interopRequireDefault(_DriveTrainModel);

var _EngineModel = __webpack_require__("./src/ModelYear/models/EngineModel.js");

var _EngineModel2 = _interopRequireDefault(_EngineModel);

var _TransmissionModel = __webpack_require__("./src/ModelYear/models/TransmissionModel.js");

var _TransmissionModel2 = _interopRequireDefault(_TransmissionModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DrivePowerTrainRecord = (0, _immutable.Record)({
    trimsBitField: 0,
    trimsBitFields: [],
    selectionCode: '',
    enabled: true,
    visible: true,
    selected: false,
    userSelected: false,
    rank: 0,
    driveTrain: new _DriveTrainModel2.default(),
    engine: new _EngineModel2.default(),
    transmission: new _TransmissionModel2.default(),
    configurationIds: {},
    bestOptionsPackageCode: ''
});

var DrivePowerTrain = function (_DrivePowerTrainRecor) {
    _inherits(DrivePowerTrain, _DrivePowerTrainRecor);

    function DrivePowerTrain() {
        _classCallCheck(this, DrivePowerTrain);

        return _possibleConstructorReturn(this, (DrivePowerTrain.__proto__ || Object.getPrototypeOf(DrivePowerTrain)).apply(this, arguments));
    }

    _createClass(DrivePowerTrain, [{
        key: 'getSelectionCode',
        value: function getSelectionCode() {
            return this.get('selectionCode');
        }
    }]);

    return DrivePowerTrain;
}(DrivePowerTrainRecord);

exports.default = DrivePowerTrain;

/***/ }),

/***/ "./src/ModelYear/models/DriveTrainModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = __webpack_require__("immutable");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DriveTrainRecord = (0, _immutable.Record)({
    trimsBitField: 0,
    trimsBitFields: [],
    selectionCode: '',
    code: '',
    rank: 0,
    description: '',
    longDescription: ''
});

var DriveTrain = function (_DriveTrainRecord) {
    _inherits(DriveTrain, _DriveTrainRecord);

    function DriveTrain() {
        _classCallCheck(this, DriveTrain);

        return _possibleConstructorReturn(this, (DriveTrain.__proto__ || Object.getPrototypeOf(DriveTrain)).apply(this, arguments));
    }

    _createClass(DriveTrain, [{
        key: 'getSelectionCode',
        value: function getSelectionCode() {
            return this.get('selectionCode');
        }
    }]);

    return DriveTrain;
}(DriveTrainRecord);

exports.default = DriveTrain;

/***/ }),

/***/ "./src/ModelYear/models/EngineModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = __webpack_require__("immutable");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EngineRecord = (0, _immutable.Record)({
    selectionCode: '0L-0C-0',
    code: '',
    fuelTypeCode: 0,
    cylinders: 0,
    displacement: 0,
    isTurbo: false,
    hp: 0,
    hpRpm: 0,
    torque: 0,
    torqueRpm: 0
});

var Engine = function (_EngineRecord) {
    _inherits(Engine, _EngineRecord);

    function Engine() {
        _classCallCheck(this, Engine);

        return _possibleConstructorReturn(this, (Engine.__proto__ || Object.getPrototypeOf(Engine)).apply(this, arguments));
    }

    _createClass(Engine, [{
        key: 'getSelectionCode',
        value: function getSelectionCode() {
            return this.get('selectionCode');
        }
    }, {
        key: 'getSizeSpecifications',
        value: function getSizeSpecifications() {
            return this.get('isTurbo') ? _widgetCommonsCoreServices.LocaleService.t('engine.sizeTurbo', {
                displacement: this.get('displacement'),
                cylinders: this.get('cylinders')
            }) : _widgetCommonsCoreServices.LocaleService.t('engine.size', {
                displacement: this.get('displacement'),
                cylinders: this.get('cylinders')
            });
        }
    }, {
        key: 'getPowerSpecifications',
        value: function getPowerSpecifications() {
            if (this.hp === 0 || this.torque === 0) {
                return '';
            }
            return _widgetCommonsCoreServices.LocaleService.t('engine.power', { hp: this.get('hp'), torque: this.get('torque') });
        }
    }]);

    return Engine;
}(EngineRecord);

exports.default = Engine;

/***/ }),

/***/ "./src/ModelYear/models/FeatureIconModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = __webpack_require__("immutable");

var _dataTypes = __webpack_require__("./src/constants/dataTypes.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FeatureIconRecord = (0, _immutable.Record)({
    code: '',
    description: '',
    rank: _dataTypes.DEFAULT_KEY_ORDER,
    isFromModelTrim: true,
    modelTrimRank: _dataTypes.DEFAULT_KEY_ORDER
});

var FeatureIcon = function (_FeatureIconRecord) {
    _inherits(FeatureIcon, _FeatureIconRecord);

    function FeatureIcon() {
        _classCallCheck(this, FeatureIcon);

        return _possibleConstructorReturn(this, (FeatureIcon.__proto__ || Object.getPrototypeOf(FeatureIcon)).apply(this, arguments));
    }

    return FeatureIcon;
}(FeatureIconRecord);

exports.default = FeatureIcon;

/***/ }),

/***/ "./src/ModelYear/models/FeatureModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = __webpack_require__("immutable");

var _dataTypes = __webpack_require__("./src/constants/dataTypes.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FeatureRecord = (0, _immutable.Record)({
    code: '',
    description: '',
    dataTypeId: 0,
    typeIds: [],
    iconTypeCodes: [],
    isStandard: false,
    rank: _dataTypes.DEFAULT_KEY_ORDER,
    isFromModelTrim: true,
    modelTrimRank: _dataTypes.DEFAULT_KEY_ORDER
});

var Feature = function (_FeatureRecord) {
    _inherits(Feature, _FeatureRecord);

    function Feature() {
        _classCallCheck(this, Feature);

        return _possibleConstructorReturn(this, (Feature.__proto__ || Object.getPrototypeOf(Feature)).apply(this, arguments));
    }

    return Feature;
}(FeatureRecord);

exports.default = Feature;

/***/ }),

/***/ "./src/ModelYear/models/ModelTrimConfigurationModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = __webpack_require__("immutable");

var _lodash = __webpack_require__("lodash");

var _dataTypes = __webpack_require__("./src/constants/dataTypes.js");

var _modelTrimItemCategories = __webpack_require__("./src/Quote/constants/modelTrimItemCategories.js");

var _exteriorColourStatuses = __webpack_require__("./src/ModelYear/constants/exteriorColourStatuses.js");

var _DriveTrainModel = __webpack_require__("./src/ModelYear/models/DriveTrainModel.js");

var _DriveTrainModel2 = _interopRequireDefault(_DriveTrainModel);

var _EngineModel = __webpack_require__("./src/ModelYear/models/EngineModel.js");

var _EngineModel2 = _interopRequireDefault(_EngineModel);

var _TransmissionModel = __webpack_require__("./src/ModelYear/models/TransmissionModel.js");

var _TransmissionModel2 = _interopRequireDefault(_TransmissionModel);

var _PurchaseMethodsModel = __webpack_require__("./src/PurchaseMethods/models/PurchaseMethodsModel.js");

var _PurchaseMethodsModel2 = _interopRequireDefault(_PurchaseMethodsModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModelTrimConfigurationRecord = (0, _immutable.Record)({
    trimsBitField: 0,
    trimsBitFields: [],
    selectionCode: '',
    enabled: true,
    visible: true,
    selected: false,
    userSelected: false,
    code: '',
    description: '',
    id: 0,
    rank: 0,
    modelTrimCode: '',
    modelTrimCodeId: '',
    modelTrimRank: 0,
    packageSelectionCode: '',
    packageCode: '',
    modelTrim: {
        trimsBitField: 0,
        trimsBitFields: [],
        selectionCode: '',
        code: '',
        description: '',
        extensionCode: '',
        extensionDescription: ''
    },
    package: {
        code: '',
        description: ''
    },
    configurationToken: '',
    cabSizeSelectionCode: '',
    cabSize: null,
    boxSizeSelectionCode: '',
    boxSize: null,
    driveTrainSelectionCode: '',
    driveTrain: new _DriveTrainModel2.default(),
    engine: new _EngineModel2.default(),
    transmission: new _TransmissionModel2.default(),
    purchaseMethods: new _PurchaseMethodsModel2.default(),
    seating: 0,
    fuelCity: 0.0,
    fuelHighway: 0.0,
    modelTrimFeatures: {},
    features: {},
    featureIcons: (0, _immutable.List)([]),
    nonModelTrimFeatureIconsCount: 0,
    configurationOptions: [],
    exteriorColourStatus: _exteriorColourStatuses.IMAGE_STATUS.NO_IMAGE,
    exteriorColours: (0, _immutable.List)([]),
    interiorColours: (0, _immutable.List)([]),
    options: [],
    smNewTrimCarId: 0,
    smNewCarId: 0,
    configurationItemsAreLoaded: false,
    optionsTotalRetail: 0,
    optionsTotalResidualRetail: 0
});

var ModelTrimConfiguration = function (_ModelTrimConfigurati) {
    _inherits(ModelTrimConfiguration, _ModelTrimConfigurati);

    function ModelTrimConfiguration() {
        _classCallCheck(this, ModelTrimConfiguration);

        return _possibleConstructorReturn(this, (ModelTrimConfiguration.__proto__ || Object.getPrototypeOf(ModelTrimConfiguration)).apply(this, arguments));
    }

    _createClass(ModelTrimConfiguration, [{
        key: 'getSelectedExteriorColour',
        value: function getSelectedExteriorColour() {
            var availableExteriorColours = this.exteriorColours.filter(function (colour) {
                return colour.selected;
            });
            if (availableExteriorColours.size === 1) {
                return availableExteriorColours.first();
            }
            return '';
        }
    }, {
        key: 'getSelectedInteriorColour',
        value: function getSelectedInteriorColour() {
            var availableInteriorColours = this.interiorColours.filter(function (colour) {
                return colour.selected;
            });
            if (availableInteriorColours.size === 1) {
                return availableInteriorColours.first();
            }
            return '';
        }
    }, {
        key: 'getSelectedOptions',
        value: function getSelectedOptions() {
            return (0, _lodash.flatten)((0, _lodash.map)(this.options, function (option) {
                return option.getSelectedItemsAndPackages();
            }));
        }
    }, {
        key: 'getOptions',
        value: function getOptions() {
            return (0, _lodash.flatten)((0, _lodash.map)(this.options, function (option) {
                return (0, _lodash.concat)(option.itemsPackages, option.items);
            }));
        }
    }, {
        key: 'getExteriorColourOptions',
        value: function getExteriorColourOptions() {
            var exteriorColourItems = (0, _lodash.filter)(this.options, function (option) {
                return option.id === _modelTrimItemCategories.EXTERIOR_COLOUR;
            });
            return (0, _lodash.flatten)((0, _lodash.map)(exteriorColourItems, function (option) {
                return (0, _lodash.concat)(option.itemsPackages, option.items);
            }));
        }
    }, {
        key: 'getInteriorColourOptions',
        value: function getInteriorColourOptions() {
            var exteriorColourItems = (0, _lodash.filter)(this.options, function (option) {
                return option.id === _modelTrimItemCategories.INTERIOR_TRIM;
            });
            return (0, _lodash.flatten)((0, _lodash.map)(exteriorColourItems, function (option) {
                return (0, _lodash.concat)(option.itemsPackages, option.items);
            }));
        }
    }, {
        key: 'getValidationSelectedOptions',
        value: function getValidationSelectedOptions() {
            var selectedExteriorColour = this.getSelectedExteriorColour();
            var selectedInteriorColour = this.getSelectedInteriorColour();
            var isCashPurchase = this.purchaseMethods.cashPurchase.selected;
            var selectedOptions = (0, _lodash.map)(this.getSelectedOptions(), function (option) {
                return option.getValidationOption(isCashPurchase);
            });

            var selectedItems = [];
            if (selectedExteriorColour) {
                selectedItems.push({
                    code: selectedExteriorColour.colourCode,
                    supplier: _dataTypes.SUPPLIER_OPTION,
                    flag: _dataTypes.ITEM_FLAG.SELECTED | _dataTypes.ITEM_FLAG.USER_SELECTED,
                    amounts: {
                        retail: selectedExteriorColour.retail,
                        residualizingAmount: selectedExteriorColour.residualRetail
                    }
                });
            }
            if (selectedInteriorColour) {
                selectedItems.push({
                    code: selectedInteriorColour.colourCode,
                    supplier: _dataTypes.SUPPLIER_OPTION,
                    flag: _dataTypes.ITEM_FLAG.SELECTED | _dataTypes.ITEM_FLAG.USER_SELECTED,
                    amounts: {
                        retail: selectedInteriorColour.retail,
                        residualizingAmount: selectedInteriorColour.residualRetail
                    }
                });
            }

            return (0, _lodash.unionBy)(selectedOptions, selectedItems, 'code');
        }
    }, {
        key: 'getConfigurationOptionsSelectionCodes',
        value: function getConfigurationOptionsSelectionCodes() {
            return (0, _lodash.map)(this.configurationOptions, function (configurationOption) {
                return configurationOption.selectionCode;
            });
        }
    }, {
        key: 'getOptionsSelectionCodes',
        value: function getOptionsSelectionCodes() {
            var selectedExteriorColour = this.getSelectedExteriorColour();
            var selectedInteriorColour = this.getSelectedInteriorColour();
            var selectedOptions = (0, _lodash.map)(this.getSelectedOptions(), function (option) {
                return option.selectionCode;
            });

            var selectedItems = [];
            if (selectedExteriorColour) {
                selectedItems.push(selectedExteriorColour.getColourSelectionCode());
            }
            if (selectedInteriorColour) {
                selectedItems.push(selectedInteriorColour.getColourSelectionCode());
            }

            return (0, _lodash.union)(selectedOptions, selectedItems);
        }
    }, {
        key: 'getPurchaseMethodsSelectedOptions',
        value: function getPurchaseMethodsSelectedOptions() {
            var configurationOptionsCodes = (0, _lodash.map)(this.configurationOptions, function (configurationOption) {
                return configurationOption.selectionCode;
            });
            return (0, _lodash.filter)(this.purchaseMethods.selectedOptions, function (option) {
                return option.dataType === _dataTypes.DATA_TYPES.FEATURE.DATA_TYPE_ID && (option.typeID < _dataTypes.DATA_TYPES.FEATURE.TYPES.MODEL_TRIM || option.typeID > _dataTypes.DATA_TYPES.FEATURE.TYPES.INTERIOR_TRIM) && !(0, _lodash.includes)(configurationOptionsCodes, option.selectionCode);
            });
        }
    }, {
        key: 'getEmployeeRebate',
        value: function getEmployeeRebate() {
            return this.purchaseMethods.getEmployeeRebate();
        }
    }]);

    return ModelTrimConfiguration;
}(ModelTrimConfigurationRecord);

exports.default = ModelTrimConfiguration;

/***/ }),

/***/ "./src/ModelYear/models/ModelTrimModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = __webpack_require__("immutable");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModelTrimRecord = (0, _immutable.Record)({
    cabSizeTrimsBitField: 0,
    cabSizeTrimsBitFields: [],
    boxSizeTrimsBitField: 0,
    boxSizeTrimsBitFields: [],
    trimsBitField: 0,
    trimsBitFields: [],
    trimCode: '',
    selectionCode: '',
    enabled: true,
    visible: true,
    selected: false,
    userSelected: false,
    code: '',
    description: '',
    trimExtensionCode: '',
    trimExtensionDescription: '',
    rank: 0,
    configurationIds: {},
    features: {},
    featureIcons: {},
    comparisonModelTrimCode: '',
    comparisonModelTrim: '',
    comparisonModelTrimExtension: '',
    comparisonAddFeatures: {},
    comparisonRemoveFeatures: {},
    comparisonAddFeatureIcons: {}
});

var ModelTrim = function (_ModelTrimRecord) {
    _inherits(ModelTrim, _ModelTrimRecord);

    function ModelTrim() {
        _classCallCheck(this, ModelTrim);

        return _possibleConstructorReturn(this, (ModelTrim.__proto__ || Object.getPrototypeOf(ModelTrim)).apply(this, arguments));
    }

    _createClass(ModelTrim, [{
        key: 'getSelectionCode',
        value: function getSelectionCode() {
            return this.get('selectionCode');
        }
    }, {
        key: 'getModelTrimFullDescription',
        value: function getModelTrimFullDescription() {
            return this.trimExtensionDescription ? this.description + ' ' + this.trimExtensionDescription : this.description;
        }

        /**
         * Return the Model Trim description or an empty string if it repeats or contain the Model Name.
         * @param {string} modelName the name of the model
         * @returns {string} description
         */

    }, {
        key: 'getDescription',
        value: function getDescription(modelName) {
            if (!modelName) {
                return this.description;
            }

            return modelName === this.description || modelName.includes(this.description) ? '' : this.description;
        }
    }]);

    return ModelTrim;
}(ModelTrimRecord);

exports.default = ModelTrim;

/***/ }),

/***/ "./src/ModelYear/models/ModelYearModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = __webpack_require__("immutable");

var _lodash = __webpack_require__("lodash");

var _DataUtilitiesService = __webpack_require__("./src/ModelYear/services/DataUtilitiesService/DataUtilitiesService.js");

var _vehicle = __webpack_require__("./src/constants/vehicle.js");

var _vehicle2 = _interopRequireDefault(_vehicle);

var _YearModel = __webpack_require__("./src/ModelYear/models/YearModel.js");

var _YearModel2 = _interopRequireDefault(_YearModel);

var _VehicleModel = __webpack_require__("./src/Vehicle/models/VehicleModel.js");

var _VehicleModel2 = _interopRequireDefault(_VehicleModel);

var _purchaseMethods = __webpack_require__("./src/PurchaseMethods/constants/purchaseMethods.js");

var PurchaseMethods = _interopRequireWildcard(_purchaseMethods);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint no-bitwise: 0 */

var ModelYearRecord = (0, _immutable.Record)({
    year: 0,
    make: '',
    model: '',
    bodyStyleCode: '',
    isSingleConfiguration: false,
    hasOptions: true,
    cabSizes: [],
    boxSizes: [],
    modelTrims: (0, _immutable.List)([]),
    drivePowerTrains: (0, _immutable.List)([]),
    optionsPackages: (0, _immutable.List)([]),
    years: (0, _immutable.List)([new _YearModel2.default()])
});

var ModelYear = function (_ModelYearRecord) {
    _inherits(ModelYear, _ModelYearRecord);

    function ModelYear() {
        _classCallCheck(this, ModelYear);

        return _possibleConstructorReturn(this, (ModelYear.__proto__ || Object.getPrototypeOf(ModelYear)).apply(this, arguments));
    }

    _createClass(ModelYear, [{
        key: 'getAvailableModelTrims',
        value: function getAvailableModelTrims() {
            return this.modelTrims.filter(function (modelTrim) {
                return modelTrim.visible;
            });
        }
    }, {
        key: 'modelYearsAreLoaded',
        value: function modelYearsAreLoaded() {
            var selectedYear = this.getSelectedYear();
            return selectedYear && selectedYear.year !== 0;
        }
    }, {
        key: 'modelYearIsLoaded',
        value: function modelYearIsLoaded() {
            var selectedYear = this.getSelectedYear();
            var selectedYearAsTrimsAndPowers = selectedYear && selectedYear.modelTrims.size > 0;

            return selectedYearAsTrimsAndPowers && selectedYear.year === this.year;
        }
    }, {
        key: 'getSelectedYear',
        value: function getSelectedYear() {
            return this.years.filter(function (year) {
                return year.selected;
            }).first();
        }
    }, {
        key: 'getSelectedYearPurchaseMethods',
        value: function getSelectedYearPurchaseMethods() {
            var selectedYear = this.getSelectedYear();
            return selectedYear ? selectedYear.purchaseMethods : undefined;
        }
    }, {
        key: 'getSelectedCabSize',
        value: function getSelectedCabSize() {
            return (0, _lodash.find)(this.cabSizes, function (cabSize) {
                return cabSize.selected;
            });
        }
    }, {
        key: 'getSelectedBoxSize',
        value: function getSelectedBoxSize() {
            return (0, _lodash.find)(this.boxSizes, function (boxSize) {
                return boxSize.selected;
            });
        }
    }, {
        key: 'getSelectedModelTrim',
        value: function getSelectedModelTrim() {
            return this.getAvailableModelTrims().filter(function (modelTrim) {
                return modelTrim.selected;
            }).first();
        }
    }, {
        key: 'getAvailableDriveTrains',
        value: function getAvailableDriveTrains() {
            return this.drivePowerTrains.filter(function (drivePowerTrain) {
                return drivePowerTrain.visible;
            });
        }
    }, {
        key: 'getSelectedDrivePowerTrain',
        value: function getSelectedDrivePowerTrain() {
            return this.getAvailableDriveTrains().filter(function (drivePowerTrain) {
                return drivePowerTrain.selected;
            }).first();
        }
    }, {
        key: 'getAvailableOptionsPackages',
        value: function getAvailableOptionsPackages() {
            return this.optionsPackages.filter(function (optionsPackage) {
                return optionsPackage.visible;
            });
        }
    }, {
        key: 'getSelectedOptionsPackage',
        value: function getSelectedOptionsPackage() {
            return this.getAvailableOptionsPackages().filter(function (optionsPackage) {
                return optionsPackage.selected;
            }).first();
        }
    }, {
        key: 'getSelectedOptionsPackageConfiguration',
        value: function getSelectedOptionsPackageConfiguration() {
            var selectedOptionsPackage = this.getAvailableOptionsPackages().filter(function (optionsPackage) {
                return optionsPackage.selected;
            }).first();
            return selectedOptionsPackage ? selectedOptionsPackage.configuration : undefined;
        }
    }, {
        key: 'getOptionsPackageConfigurationFromCode',
        value: function getOptionsPackageConfigurationFromCode(optionsPackageCode) {
            var selectedOptionsPackage = this.optionsPackages.filter(function (optionsPackage) {
                return optionsPackage.selectionCode === optionsPackageCode;
            }).first();

            return selectedOptionsPackage ? selectedOptionsPackage.configuration : undefined;
        }
    }, {
        key: 'getOptionsPackageFromConfigurationId',
        value: function getOptionsPackageFromConfigurationId(configurationId) {
            return this.optionsPackages.filter(function (optionsPackage) {
                return optionsPackage.configuration.id === configurationId;
            }).first();
        }
    }, {
        key: 'getBestAvailableOptionsPackageFromTrimsBitField',
        value: function getBestAvailableOptionsPackageFromTrimsBitField(trimsBitField, engineSelectionCode, transmissionSelectionCode) {
            var availableOptionsPackages = this.optionsPackages.filter(function (optionsPackage) {
                return (0, _DataUtilitiesService.intersectModelTrimsBitFieldValue)(optionsPackage, trimsBitField, false) > 0 && optionsPackage.configuration.engine.selectionCode === engineSelectionCode && optionsPackage.configuration.transmission.selectionCode === transmissionSelectionCode;
            });

            if (availableOptionsPackages.size === 0) {
                return '';
            }
            return availableOptionsPackages.minBy(function (optionsPackage) {
                return optionsPackage.rank;
            }).selectionCode;
        }
    }, {
        key: 'getSelectedOptionsPackageExteriorColour',
        value: function getSelectedOptionsPackageExteriorColour() {
            var configuration = this.getSelectedOptionsPackageConfiguration();
            return configuration ? configuration.getSelectedExteriorColour() : '';
        }
    }, {
        key: 'getSelectedOptionsPackageInteriorColour',
        value: function getSelectedOptionsPackageInteriorColour() {
            var configuration = this.getSelectedOptionsPackageConfiguration();
            return configuration ? configuration.getSelectedInteriorColour() : '';
        }
    }, {
        key: 'getSelectedOptionsPackageBestAvailableExteriorColour',
        value: function getSelectedOptionsPackageBestAvailableExteriorColour() {
            var configuration = this.getSelectedOptionsPackageConfiguration();
            return configuration ? configuration.exteriorColours.minBy(function (colour) {
                return colour.retail;
            }) : '';
        }
    }, {
        key: 'getSelectedOptionsPackagePurchaseMethods',
        value: function getSelectedOptionsPackagePurchaseMethods() {
            var selectedOptionsPackage = this.getAvailableOptionsPackages().filter(function (optionsPackage) {
                return optionsPackage.selected;
            }).first();
            return selectedOptionsPackage ? selectedOptionsPackage.configuration.purchaseMethods : undefined;
        }
    }, {
        key: 'getSelectedPurchaseMethods',
        value: function getSelectedPurchaseMethods() {
            if (this.modelTrims.size > 0) {
                return this.getSelectedOptionsPackagePurchaseMethods();
            } else if (this.modelYearsAreLoaded()) {
                return this.getSelectedYearPurchaseMethods();
            }
            return '';
        }
    }, {
        key: 'getPaymentCalculationWithTerm',
        value: function getPaymentCalculationWithTerm(term) {
            var purchaseMethods = this.getSelectedPurchaseMethods();
            return purchaseMethods ? purchaseMethods.getPaymentCalculationWithTerm(term) : '';
        }
    }, {
        key: 'getPaymentCalculationWithPaymentFrequency',
        value: function getPaymentCalculationWithPaymentFrequency(paymentFrequency) {
            var purchaseMethods = this.getSelectedPurchaseMethods();
            return purchaseMethods ? purchaseMethods.getPaymentCalculationWithPaymentFrequency(paymentFrequency) : '';
        }
    }, {
        key: 'getPaymentCalculationWithCashDown',
        value: function getPaymentCalculationWithCashDown(cashDown) {
            var purchaseMethods = this.getSelectedPurchaseMethods();
            return purchaseMethods ? purchaseMethods.getPaymentCalculationWithCashDown(cashDown) : '';
        }
    }, {
        key: 'getPaymentCalculationWithTradeIn',
        value: function getPaymentCalculationWithTradeIn(tradeIn) {
            var purchaseMethods = this.getSelectedPurchaseMethods();
            return purchaseMethods ? purchaseMethods.getPaymentCalculationWithTradeIn(tradeIn) : '';
        }
    }, {
        key: 'getPaymentCalculationWithLien',
        value: function getPaymentCalculationWithLien(lien) {
            var purchaseMethods = this.getSelectedPurchaseMethods();
            return purchaseMethods ? purchaseMethods.getPaymentCalculationWithLien(lien) : '';
        }
    }, {
        key: 'getPaymentCalculationWithExteriorColour',
        value: function getPaymentCalculationWithExteriorColour(exteriorColourAmounts) {
            var purchaseMethods = this.getSelectedPurchaseMethods();
            return purchaseMethods ? purchaseMethods.getPaymentCalculationWithExteriorColour(exteriorColourAmounts) : '';
        }
    }, {
        key: 'getPaymentCalculationWithInteriorColour',
        value: function getPaymentCalculationWithInteriorColour(interiorColourAmounts) {
            var purchaseMethods = this.getSelectedPurchaseMethods();
            return purchaseMethods ? purchaseMethods.getPaymentCalculationWithInteriorColour(interiorColourAmounts) : '';
        }
    }, {
        key: 'getPaymentCalculationWithOptions',
        value: function getPaymentCalculationWithOptions(optionsAmounts) {
            var purchaseMethods = this.getSelectedPurchaseMethods();
            return purchaseMethods ? purchaseMethods.getPaymentCalculationWithOptions(optionsAmounts) : '';
        }
    }, {
        key: 'getPaymentCalculationWithTaxesIncluded',
        value: function getPaymentCalculationWithTaxesIncluded(taxesIncluded) {
            var purchaseMethods = this.getSelectedPurchaseMethods();
            return purchaseMethods ? purchaseMethods.getPaymentCalculationWithTaxesIncluded(taxesIncluded) : '';
        }
    }, {
        key: 'getSelectedExteriorColour',
        value: function getSelectedExteriorColour() {
            var configurationExteriorColour = this.getSelectedOptionsPackageExteriorColour();
            var configurationExteriorColourPhoto = configurationExteriorColour ? configurationExteriorColour.photo1 : '';
            var yearExteriorColour = this.getSelectedYear();
            var yearExteriorColourPhoto = yearExteriorColour ? yearExteriorColour.exteriorColours.photo1 : '';
            return configurationExteriorColourPhoto || yearExteriorColourPhoto;
        }
    }, {
        key: 'getBestPurchaseMethodYear',
        value: function getBestPurchaseMethodYear(purchaseMethod) {
            var availableYears = void 0;
            var bestYear = void 0;
            switch (purchaseMethod) {
                case PurchaseMethods.CASH_PURCHASE:
                    availableYears = this.years.toArray();
                    bestYear = (0, _lodash.minBy)(availableYears, function (year) {
                        return year.purchaseMethods.cashPurchase.getRetail();
                    });
                    break;

                case PurchaseMethods.LEASE:
                    availableYears = this.years.filter(function (year) {
                        return year.purchaseMethods.lease.getCalculatedPayment() > 0;
                    }).toArray();
                    bestYear = (0, _lodash.minBy)(availableYears, function (year) {
                        return year.purchaseMethods.lease.getCalculatedPayment();
                    });
                    break;

                case PurchaseMethods.FINANCE:
                    availableYears = this.years.filter(function (year) {
                        return year.purchaseMethods.finance.getCalculatedPayment() > 0;
                    }).toArray();
                    bestYear = (0, _lodash.minBy)(availableYears, function (year) {
                        return year.purchaseMethods.finance.getCalculatedPayment();
                    });
                    break;

                default:
                    return 0;
            }

            return bestYear ? bestYear.year : 0;
        }
    }, {
        key: 'getBestPurchaseMethodsYear',
        value: function getBestPurchaseMethodsYear() {
            return {
                cashPurchaseYear: this.getBestPurchaseMethodYear(PurchaseMethods.CASH_PURCHASE),
                leaseYear: this.getBestPurchaseMethodYear(PurchaseMethods.LEASE),
                financeYear: this.getBestPurchaseMethodYear(PurchaseMethods.FINANCE)
            };
        }
    }, {
        key: 'getVehicleFromConfiguration',
        value: function getVehicleFromConfiguration(vehicle) {
            var veh = vehicle && vehicle instanceof _VehicleModel2.default ? vehicle : new _VehicleModel2.default();
            var configuration = this.getSelectedOptionsPackageConfiguration();

            return veh.set('vehicleConditionType', _vehicle2.default.CONDITIONS.NEW).set('year', this.year).set('make', this.make).set('model', this.model).set('bodyStyleCode', this.bodyStyleCode).set('modelTrimCode', configuration.modelTrimCode).set('configurationId', configuration.id).set('catalogVehicleId', configuration.smNewCarId).set('configuration', configuration).set('purchaseMethods', configuration.purchaseMethods);
        }

        // Was made for specifics cases like `Mazda mazda3` [SHOWROOM-2152]

    }, {
        key: 'modelContainsMake',
        value: function modelContainsMake() {
            return this.model.includes(this.make);
        }
    }]);

    return ModelYear;
}(ModelYearRecord);

exports.default = ModelYear;

/***/ }),

/***/ "./src/ModelYear/models/OptionModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("lodash");

var _immutable = __webpack_require__("immutable");

var _dataConversions = __webpack_require__("./src/constants/dataConversions.js");

var _dataTypes = __webpack_require__("./src/constants/dataTypes.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FEATURE = _dataTypes.DATA_TYPES.FEATURE,
    FEE = _dataTypes.DATA_TYPES.FEE,
    TAX_AND_DUTY = _dataTypes.DATA_TYPES.TAX_AND_DUTY,
    REBATE = _dataTypes.DATA_TYPES.REBATE;


var OptionRecord = (0, _immutable.Record)({
    selectionCode: '',
    enabled: true,
    visible: true,
    selected: false,
    isConfigurationOption: false,
    dueAtDelivery: false,
    userSelected: false,
    code: '',
    keyOrder: _dataConversions.DEFAULT_KEY_ORDER,
    parentCode: '',
    includedCodes: [],
    label: '',
    description: '',
    note: '',
    dataType: 0,
    typeID: 0,
    typeDescription: '',
    typeNote: '',
    parentTypeID: null,
    parentTypeDescription: '',
    parentTypeNote: '',
    categoryID: 0,
    supplier: '',
    supplierCodes: [],
    flag: 0,
    retail: 0,
    residualizingAmount: 0,
    isTaxable: true,
    imageUrl: '',
    webUrl: '',
    htmlBlock: '',
    mostPopular: false,
    isGroup: false,
    isInstalledAtDealership: false,
    protectionCoverage: null,
    isIncludedInPriceOrPayment: false
});

var Option = function (_OptionRecord) {
    _inherits(Option, _OptionRecord);

    function Option() {
        _classCallCheck(this, Option);

        return _possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).apply(this, arguments));
    }

    _createClass(Option, [{
        key: 'getSelectionCode',
        value: function getSelectionCode() {
            return this.get('selectionCode');
        }
    }, {
        key: 'getShowroomQuoteItem',
        value: function getShowroomQuoteItem() {
            var dataType = this.dataType,
                typeID = this.typeID,
                code = this.code,
                supplier = this.supplier,
                flag = this.flag,
                retail = this.retail,
                residualizingAmount = this.residualizingAmount,
                selected = this.selected,
                userSelected = this.userSelected;
            // Reset flag based on selected field

            var selectionFlag = flag;
            if (selected) {
                selectionFlag = flag | _dataTypes.ITEM_FLAG.SELECTED | (userSelected ? _dataTypes.ITEM_FLAG.USER_SELECTED : 0);
            } else {
                selectionFlag = flag & ~_dataTypes.ITEM_FLAG.SELECTED;
            }

            return {
                dataType: dataType,
                typeID: typeID,
                code: code,
                supplier: supplier,
                flag: selectionFlag,
                amounts: {
                    retail: retail,
                    residualizingAmount: residualizingAmount
                }
            };
        }
    }, {
        key: 'calculateItemAmounts',
        value: function calculateItemAmounts(isLease, selectedFinanceTerm, taxesFactor) {
            var selectionCode = this.selectionCode,
                retail = this.retail,
                residualizingAmount = this.residualizingAmount,
                isTaxable = this.isTaxable;


            var payment = 0;
            if (selectedFinanceTerm) {
                payment = Math.round(selectedFinanceTerm.calculatePaymentAdjustment(retail, residualizingAmount) * 100) / 100;
            }

            var itemAmounts = {
                selectionCode: selectionCode,
                retail: retail,
                taxes: isTaxable ? Math.round(retail * taxesFactor * 100) / 100 : 0,
                payment: payment,
                paymentTaxes: isLease || isTaxable ? Math.round(payment * taxesFactor * 100) / 100 : 0
            };

            return itemAmounts;
        }
    }, {
        key: 'getValidationOption',
        value: function getValidationOption(isCashPurchase) {
            var retail = this.retail,
                residualizingAmount = this.residualizingAmount,
                code = this.code,
                supplier = this.supplier,
                userSelected = this.userSelected,
                dataType = this.dataType,
                typeID = this.typeID;


            var isDealerDiscount = isCashPurchase && this.isDealerCashPurchaseOnlyDiscount();
            var selectionFlag = this.selected && !this.isDealerCashPurchaseOnlyDiscount() || isDealerDiscount ? _dataTypes.ITEM_FLAG.SELECTED : _dataTypes.ITEM_FLAG.NOT_SELECTED;

            return {
                code: code,
                supplier: supplier,
                dataType: dataType,
                typeID: typeID,
                flag: selectionFlag | (userSelected ? _dataTypes.ITEM_FLAG.USER_SELECTED : 0),
                amounts: {
                    retail: retail,
                    residualizingAmount: residualizingAmount
                }
            };
        }
    }, {
        key: 'getOptionDescriptionWithAmounts',
        value: function getOptionDescriptionWithAmounts(isLease, selectedFinanceTerm, taxesFactor, isReduction) {
            var optionPricing = this.calculateItemAmounts(isLease, selectedFinanceTerm, taxesFactor, isReduction);

            if (isReduction) {
                optionPricing.retail *= -1;
                optionPricing.taxes *= -1;
                optionPricing.payment *= -1;
                optionPricing.paymentTaxes *= -1;
            }

            return _extends({
                description: this.description,
                imageUrl: this.imageUrl
            }, optionPricing);
        }
    }, {
        key: 'isDealerInventoryOption',
        value: function isDealerInventoryOption() {
            return this.supplier === _dataTypes.DEALER_OPTION && this.dataType === FEATURE.DATA_TYPE_ID && this.typeID === FEATURE.TYPES.DEALER_INVENTORY;
        }
    }, {
        key: 'isDealerDiscount',
        value: function isDealerDiscount() {
            return this.supplier === _dataTypes.DEALER_OPTION && this.dataType === REBATE.DATA_TYPE_ID && this.typeID === REBATE.TYPES.DEALER_DISCOUNT;
        }
    }, {
        key: 'isDealerFee',
        value: function isDealerFee() {
            return this.supplier === _dataTypes.DEALER_OPTION && (this.dataType === FEE.DATA_TYPE_ID || this.dataType === TAX_AND_DUTY.DATA_TYPE_ID);
        }
    }, {
        key: 'isDealerCashPurchaseOnlyDiscount',
        value: function isDealerCashPurchaseOnlyDiscount() {
            return this.isDealerDiscount() && (0, _lodash.includes)(this.supplierCodes, _dataConversions.CASH_PURCHASE_ONLY_DISCOUNT);
        }
    }]);

    return Option;
}(OptionRecord);

exports.default = Option;

/***/ }),

/***/ "./src/ModelYear/models/OptionsPackageModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = __webpack_require__("immutable");

var _ModelTrimConfigurationModel = __webpack_require__("./src/ModelYear/models/ModelTrimConfigurationModel.js");

var _ModelTrimConfigurationModel2 = _interopRequireDefault(_ModelTrimConfigurationModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OptionsPackageRecord = (0, _immutable.Record)({
    trimsBitField: 0,
    trimsBitFields: [],
    selectionCode: '',
    enabled: true,
    visible: true,
    selected: false,
    userSelected: false,
    code: '',
    description: '',
    rank: 0,
    configuration: new _ModelTrimConfigurationModel2.default()
});

var OptionsPackage = function (_OptionsPackageRecord) {
    _inherits(OptionsPackage, _OptionsPackageRecord);

    function OptionsPackage() {
        _classCallCheck(this, OptionsPackage);

        return _possibleConstructorReturn(this, (OptionsPackage.__proto__ || Object.getPrototypeOf(OptionsPackage)).apply(this, arguments));
    }

    _createClass(OptionsPackage, [{
        key: 'getSelectionCode',
        value: function getSelectionCode() {
            return this.get('selectionCode');
        }
    }]);

    return OptionsPackage;
}(OptionsPackageRecord);

exports.default = OptionsPackage;

/***/ }),

/***/ "./src/ModelYear/models/OptionsSelectionResolutionModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("lodash");

var _immutable = __webpack_require__("immutable");

var _dataTypes = __webpack_require__("./src/constants/dataTypes.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OptionsSelectionResolutionRecord = (0, _immutable.Record)({
    id: '',
    isCancel: false,
    addedOptions: [],
    removedOptions: [],
    resolutionActionOptions: [],
    selected: false,
    isExteriorColour: false,
    availableExteriorColours: [],
    isInteriorColour: false,
    availableInteriorColours: []
});

function getOptionsWithPricing(options, isLease, selectedFinanceTerm, taxesFactor, isRemoved) {
    var optionsPricing = (0, _lodash.map)(options, function (option) {
        return option.getOptionDescriptionWithAmounts(isLease, selectedFinanceTerm, taxesFactor, isRemoved);
    });
    return optionsPricing;
}

var OptionsSelectionResolution = function (_OptionsSelectionReso) {
    _inherits(OptionsSelectionResolution, _OptionsSelectionReso);

    function OptionsSelectionResolution() {
        _classCallCheck(this, OptionsSelectionResolution);

        return _possibleConstructorReturn(this, (OptionsSelectionResolution.__proto__ || Object.getPrototypeOf(OptionsSelectionResolution)).apply(this, arguments));
    }

    _createClass(OptionsSelectionResolution, [{
        key: 'getResolutionActionOptions',
        value: function getResolutionActionOptions(validationSelectedOptions) {
            var resolutionActionOptions = (0, _lodash.map)(this.resolutionActionOptions, function (resolutionActionOption) {
                return {
                    code: resolutionActionOption.code,
                    supplier: resolutionActionOption.supplier,
                    flag: resolutionActionOption.selected ? _dataTypes.ITEM_FLAG.SELECTED | _dataTypes.ITEM_FLAG.USER_SELECTED : _dataTypes.ITEM_FLAG.NOT_SELECTED,
                    amounts: {
                        retail: resolutionActionOption.retail,
                        residualizingAmount: resolutionActionOption.residualizingAmount
                    }
                };
            });
            return (0, _lodash.unionBy)(resolutionActionOptions, validationSelectedOptions, 'code');
        }
    }, {
        key: 'getResolution',
        value: function getResolution(triggerOption, isLease, selectedFinanceTerm, taxesFactor) {
            var id = this.id,
                selected = this.selected;


            var addedOptions = getOptionsWithPricing(this.addedOptions, isLease, selectedFinanceTerm, taxesFactor, false);
            var removedOptions = getOptionsWithPricing(this.removedOptions, isLease, selectedFinanceTerm, taxesFactor, true);

            var addedTotals = (0, _lodash.reduce)(addedOptions, function (result, option) {
                return {
                    retail: result.retail + option.retail,
                    taxes: result.taxes + option.taxes,
                    payment: result.payment + option.payment,
                    paymentTaxes: result.paymentTaxes + option.paymentTaxes
                };
            }, {
                retail: 0,
                taxes: 0,
                payment: 0,
                paymentTaxes: 0
            });

            var removedTotals = (0, _lodash.reduce)(removedOptions, function (result, option) {
                return {
                    retail: result.retail + option.retail,
                    taxes: result.taxes + option.taxes,
                    payment: result.payment + option.payment,
                    paymentTaxes: result.paymentTaxes + option.paymentTaxes
                };
            }, {
                retail: 0,
                taxes: 0,
                payment: 0,
                paymentTaxes: 0
            });

            var pricingDifferenceTotal = {
                retail: addedTotals.retail + removedTotals.retail + triggerOption.retail,
                taxes: addedTotals.taxes + removedTotals.taxes + triggerOption.taxes,
                payment: addedTotals.payment + removedTotals.payment + triggerOption.payment,
                paymentTaxes: addedTotals.paymentTaxes + removedTotals.paymentTaxes + triggerOption.paymentTaxes
            };

            return {
                id: id,
                addedOptions: addedOptions,
                removedOptions: removedOptions,
                pricingDifferenceTotal: pricingDifferenceTotal,
                selected: selected
            };
        }
    }]);

    return OptionsSelectionResolution;
}(OptionsSelectionResolutionRecord);

exports.default = OptionsSelectionResolution;

/***/ }),

/***/ "./src/ModelYear/models/OptionsSelectionResolutionsModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("lodash");

var _immutable = __webpack_require__("immutable");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OptionsSelectionResolutionsRecord = (0, _immutable.Record)({
    triggeredFromOptionAdd: true,
    resolutionTriggerOptionSelectionCode: '',
    resolutions: []
});

var OptionsSelectionResolutions = function (_OptionsSelectionReso) {
    _inherits(OptionsSelectionResolutions, _OptionsSelectionReso);

    function OptionsSelectionResolutions() {
        _classCallCheck(this, OptionsSelectionResolutions);

        return _possibleConstructorReturn(this, (OptionsSelectionResolutions.__proto__ || Object.getPrototypeOf(OptionsSelectionResolutions)).apply(this, arguments));
    }

    _createClass(OptionsSelectionResolutions, [{
        key: 'getResolutionActionOptions',
        value: function getResolutionActionOptions(validationSelectedOptions) {
            var selectedResolution = (0, _lodash.find)(this.resolutions, function (resolution) {
                return resolution.selected;
            });
            if (selectedResolution) {
                return selectedResolution.getResolutionActionOptions(validationSelectedOptions);
            }

            var cancelResolution = (0, _lodash.find)(this.resolutions, function (resolution) {
                return resolution.isCancel;
            });
            return cancelResolution.getResolutionActionOptions(validationSelectedOptions);
        }
    }, {
        key: 'getResolutions',
        value: function getResolutions(configuration, isLease, selectedFinanceTerm, taxesFactor) {
            var _this2 = this;

            var errorTriggerOption = (0, _lodash.find)(configuration.getOptions(), function (option) {
                return option.selectionCode === _this2.resolutionTriggerOptionSelectionCode;
            });
            if (!errorTriggerOption) {
                return null;
            }

            var triggerOption = errorTriggerOption.getOptionDescriptionWithAmounts(isLease, selectedFinanceTerm, taxesFactor, !this.triggeredFromOptionAdd);

            var selectableResolutions = (0, _lodash.filter)(this.resolutions, function (resolution) {
                return !resolution.isCancel;
            });

            var resolutions = (0, _lodash.map)(selectableResolutions, function (optionsResolution) {
                return optionsResolution.getResolution(triggerOption, isLease, selectedFinanceTerm, taxesFactor);
            });

            return {
                triggeredFromOptionAdd: this.triggeredFromOptionAdd,
                triggerOption: triggerOption,
                resolutions: resolutions,
                showPayments: !(0, _lodash.isUndefined)(selectedFinanceTerm)
            };
        }
    }]);

    return OptionsSelectionResolutions;
}(OptionsSelectionResolutionsRecord);

exports.default = OptionsSelectionResolutions;

/***/ }),

/***/ "./src/ModelYear/models/TransmissionModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = __webpack_require__("immutable");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TransmissionRecord = (0, _immutable.Record)({
    selectionCode: '',
    code: '',
    typeCode: '',
    rank: 0,
    type: 0,
    speeds: 0,
    isCVT: false,
    description: ''
});

var Transmission = function (_TransmissionRecord) {
    _inherits(Transmission, _TransmissionRecord);

    function Transmission() {
        _classCallCheck(this, Transmission);

        return _possibleConstructorReturn(this, (Transmission.__proto__ || Object.getPrototypeOf(Transmission)).apply(this, arguments));
    }

    _createClass(Transmission, [{
        key: 'getSelectionCode',
        value: function getSelectionCode() {
            return this.get('selectionCode');
        }
    }, {
        key: 'getTypeAndSpeeds',
        value: function getTypeAndSpeeds() {
            var speed = _widgetCommonsCoreServices.LocaleService.t('transmission.speeds', { speeds: this.get('speeds') });
            var types = _widgetCommonsCoreServices.LocaleService.t('transmission.types', { type: this.get('description') });
            return this.get('isCVT') ? _widgetCommonsCoreServices.LocaleService.t('transmission.cvt', { type: this.get('description') }) : types + ' <span class=\'speed\'>' + speed + '</span>';
        }
    }, {
        key: 'getTransmission',
        value: function getTransmission() {
            var speed = _widgetCommonsCoreServices.LocaleService.t('transmission.speeds', { speeds: this.get('speeds') });
            var types = _widgetCommonsCoreServices.LocaleService.t('transmission.types', { type: this.get('description') });
            return this.get('isCVT') ? _widgetCommonsCoreServices.LocaleService.t('transmission.cvt', { type: this.get('description') }) : types + ' ' + speed;
        }
    }]);

    return Transmission;
}(TransmissionRecord);

exports.default = Transmission;

/***/ }),

/***/ "./src/ModelYear/models/YearModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("lodash");

var _immutable = __webpack_require__("immutable");

var _exteriorColourStatuses = __webpack_require__("./src/ModelYear/constants/exteriorColourStatuses.js");

var _purchaseMethodsValues = __webpack_require__("./src/PurchaseMethods/constants/purchaseMethodsValues.js");

var _purchaseMethodsValues2 = _interopRequireDefault(_purchaseMethodsValues);

var _PurchaseMethodsModel = __webpack_require__("./src/PurchaseMethods/models/PurchaseMethodsModel.js");

var _PurchaseMethodsModel2 = _interopRequireDefault(_PurchaseMethodsModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var YearRecord = (0, _immutable.Record)({
    year: 0,
    selected: false,
    make: '',
    model: '',
    bodyStyleCode: '',
    bodyStyle: '',
    modelTrimPurchaseMethodIds: [],
    isSingleConfiguration: false,
    hasOptions: true,
    exteriorColours: {
        photo1: '',
        photo2: '',
        photo3: ''
    },
    exteriorColourStatus: _exteriorColourStatuses.IMAGE_STATUS.NO_IMAGE,
    highRebate: 0,
    highRebatePurchaseMethod: _purchaseMethodsValues2.default.CASH,
    modelTrims: (0, _immutable.List)([]),
    drivePowerTrains: (0, _immutable.List)([]),
    optionsPackages: (0, _immutable.List)([]),
    purchaseMethods: new _PurchaseMethodsModel2.default()
});

var Year = function (_YearRecord) {
    _inherits(Year, _YearRecord);

    function Year() {
        _classCallCheck(this, Year);

        return _possibleConstructorReturn(this, (Year.__proto__ || Object.getPrototypeOf(Year)).apply(this, arguments));
    }

    _createClass(Year, [{
        key: 'getModelTrimSelectedPurchaseMethodId',
        value: function getModelTrimSelectedPurchaseMethodId(selectedPurchaseMethod) {
            return (0, _lodash.find)(this.modelTrimPurchaseMethodIds, function (modelTrimPurchaseMethodId) {
                return modelTrimPurchaseMethodId.purchaseMethod === selectedPurchaseMethod;
            });
        }
    }]);

    return Year;
}(YearRecord);

exports.default = Year;

/***/ }),

/***/ "./src/ModelYear/reducers/modelYearReducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = modelYearReducer;

var _modelYearActionTypes = __webpack_require__("./src/ModelYear/actions/modelYearActionTypes.js");

var _modelYearActionTypes2 = _interopRequireDefault(_modelYearActionTypes);

var _purchaseMethodsActionTypes = __webpack_require__("./src/PurchaseMethods/actions/purchaseMethodsActionTypes.js");

var _purchaseMethodsActionTypes2 = _interopRequireDefault(_purchaseMethodsActionTypes);

var _ModelYearModel = __webpack_require__("./src/ModelYear/models/ModelYearModel.js");

var _ModelYearModel2 = _interopRequireDefault(_ModelYearModel);

var _ModelYearService = __webpack_require__("./src/ModelYear/services/ModelYearService/ModelYearService.js");

var _ModelYearService2 = _interopRequireDefault(_ModelYearService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function modelYearReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _ModelYearModel2.default();
    var action = arguments[1];

    switch (action.type) {
        case _modelYearActionTypes2.default.LOAD_MODEL_YEAR_SUCCESS:
            return action.modelYear;

        case _modelYearActionTypes2.default.SET_MODEL_YEARS:
            return state.set('year', action.modelYear.year).set('years', action.modelYear.years);

        case _modelYearActionTypes2.default.SET_MODEL_TRIMS:
            return state.set('modelTrims', action.modelYear.modelTrims).set('drivePowerTrains', action.modelYear.drivePowerTrains).set('optionsPackages', action.modelYear.optionsPackages);

        case _modelYearActionTypes2.default.SET_DRIVE_POWER_TRAINS:
            return state.set('drivePowerTrains', action.modelYear.drivePowerTrains).set('optionsPackages', action.modelYear.optionsPackages);

        case _modelYearActionTypes2.default.SET_OPTIONS_PACKAGES:
            return state.set('optionsPackages', action.modelYear.optionsPackages);

        case _purchaseMethodsActionTypes2.default.SELECT_PURCHASE_METHOD:
            return _ModelYearService2.default.selectPurchaseMethod(state, action.purchaseMethod);

        case _purchaseMethodsActionTypes2.default.SELECT_TERM:
            return _ModelYearService2.default.selectTerm(state, parseInt(action.term, 10));

        case _purchaseMethodsActionTypes2.default.SELECT_PAYMENT_FREQUENCY:
            return _ModelYearService2.default.selectPaymentFrequency(state, action.paymentFrequency.value);

        case _purchaseMethodsActionTypes2.default.SELECT_KM_PLAN:
            return _ModelYearService2.default.selectKMPlan(state, action.kmPlan.value);

        case _purchaseMethodsActionTypes2.default.SET_CASH_DOWN:
            return _ModelYearService2.default.setCashDown(state, action.cashDown);

        case _purchaseMethodsActionTypes2.default.SET_TRADE_IN:
            return _ModelYearService2.default.setTradeIn(state, action.tradeIn);

        case _purchaseMethodsActionTypes2.default.SET_LIEN:
            return _ModelYearService2.default.setLien(state, action.lien);

        case _purchaseMethodsActionTypes2.default.SET_EXTERIOR_COLOUR_AMOUNTS:
            return _ModelYearService2.default.setExteriorColourAmounts(state, action.exteriorColourAmounts);

        case _purchaseMethodsActionTypes2.default.SET_INTERIOR_COLOUR_AMOUNTS:
            return _ModelYearService2.default.setInteriorColourAmounts(state, action.interiorColourAmounts);

        case _purchaseMethodsActionTypes2.default.SET_OPTIONS_AMOUNTS:
            return _ModelYearService2.default.setOptionsAmounts(state, action.optionsAmounts);

        case _purchaseMethodsActionTypes2.default.SET_TAXES_INCLUDED:
            return _ModelYearService2.default.setTaxesIncluded(state, action.taxesIncluded);

        default:
            return state;
    }
}

/***/ }),

/***/ "./src/ModelYear/services/BoxSizeService/BoxSizeService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetBoxSizeFromOriginData = resetBoxSizeFromOriginData;

var _lodash = __webpack_require__("lodash");

var _dataOrigins = __webpack_require__("./src/constants/dataOrigins.js");

var DataOrigins = _interopRequireWildcard(_dataOrigins);

var _dataConversions = __webpack_require__("./src/constants/dataConversions.js");

var _DataUtilitiesService = __webpack_require__("./src/ModelYear/services/DataUtilitiesService/DataUtilitiesService.js");

var _BoxSizeModel = __webpack_require__("./src/ModelYear/models/BoxSizeModel.js");

var _BoxSizeModel2 = _interopRequireDefault(_BoxSizeModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/* eslint import/prefer-default-export: 0 */

function resetBoxSizeFromModelData(modelBoxSizeData) {
    if (modelBoxSizeData.length <= _dataConversions.BOX_SIZE_DATA.CODE) {
        return new _BoxSizeModel2.default();
    }

    var code = modelBoxSizeData[_dataConversions.BOX_SIZE_DATA.CODE];
    var rank = void 0;
    switch (code) {
        case _dataConversions.BOX_SIZE_SHORT:
            rank = 100;
            break;
        case _dataConversions.BOX_SIZE_LONG:
            rank = 200;
            break;
        default:
            rank = 300;
            break;
    }

    var description = (0, _DataUtilitiesService.getDescriptionData)(modelBoxSizeData[_dataConversions.BOX_SIZE_DATA.DESCRIPTION]);
    var boxLength = (0, _lodash.toNumber)((0, _lodash.first)(description));
    if ((0, _lodash.isFinite)(boxLength)) {
        rank += boxLength;
    }

    var _getModelTrimsBitFiel = (0, _DataUtilitiesService.getModelTrimsBitField)(modelBoxSizeData[_dataConversions.BOX_SIZE_DATA.BIT_FIELD]),
        trimsBitField = _getModelTrimsBitFiel.trimsBitField,
        trimsBitFields = _getModelTrimsBitFiel.trimsBitFields;

    return new _BoxSizeModel2.default({
        trimsBitField: trimsBitField,
        trimsBitFields: trimsBitFields,
        selectionCode: modelBoxSizeData[_dataConversions.BOX_SIZE_DATA.ID_CODE],
        code: code,
        rank: rank,
        description: description
    });
}

function resetBoxSizeFromOriginData(dataOrigin, originBoxSizeData) {
    if ((0, _lodash.isEmpty)(originBoxSizeData) || !(0, _lodash.isObjectLike)(originBoxSizeData)) {
        return new _BoxSizeModel2.default();
    }

    switch (dataOrigin) {
        case DataOrigins.MODELS_COLLECTION:
            return new _BoxSizeModel2.default();

        case DataOrigins.MODEL_YEAR_POWERS_TRIMS:
            return resetBoxSizeFromModelData(originBoxSizeData);

        default:
            return new _BoxSizeModel2.default();
    }
}

exports.default = {
    resetBoxSizeFromOriginData: resetBoxSizeFromOriginData
};

/***/ }),

/***/ "./src/ModelYear/services/CabSizeService/CabSizeService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetCabSizeFromOriginData = resetCabSizeFromOriginData;

var _lodash = __webpack_require__("lodash");

var _dataOrigins = __webpack_require__("./src/constants/dataOrigins.js");

var DataOrigins = _interopRequireWildcard(_dataOrigins);

var _dataConversions = __webpack_require__("./src/constants/dataConversions.js");

var _DataUtilitiesService = __webpack_require__("./src/ModelYear/services/DataUtilitiesService/DataUtilitiesService.js");

var _CabSizeModel = __webpack_require__("./src/ModelYear/models/CabSizeModel.js");

var _CabSizeModel2 = _interopRequireDefault(_CabSizeModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/* eslint import/prefer-default-export: 0 */

function resetCabSizeFromModelData(modelCabSizeData) {
    if (modelCabSizeData.length <= _dataConversions.CAB_SIZE_DATA.CODE) {
        return new _CabSizeModel2.default();
    }

    var code = modelCabSizeData[_dataConversions.CAB_SIZE_DATA.CODE];
    var rank = void 0;
    switch (code) {
        case _dataConversions.CAB_SIZE_REGULAR:
            rank = 1;
            break;
        case _dataConversions.CAB_SIZE_EXTENDED:
            rank = 2;
            break;
        case _dataConversions.CAB_SIZE_CREW:
            rank = 3;
            break;
        default:
            rank = 4;
            break;
    }

    var _getModelTrimsBitFiel = (0, _DataUtilitiesService.getModelTrimsBitField)(modelCabSizeData[_dataConversions.CAB_SIZE_DATA.BIT_FIELD]),
        trimsBitField = _getModelTrimsBitFiel.trimsBitField,
        trimsBitFields = _getModelTrimsBitFiel.trimsBitFields;

    return new _CabSizeModel2.default({
        trimsBitField: trimsBitField,
        trimsBitFields: trimsBitFields,
        selectionCode: modelCabSizeData[_dataConversions.CAB_SIZE_DATA.ID_CODE],
        code: code,
        rank: rank,
        description: (0, _DataUtilitiesService.getDescriptionData)(modelCabSizeData[_dataConversions.CAB_SIZE_DATA.DESCRIPTION])
    });
}

function resetCabSizeFromOriginData(dataOrigin, originCabSizeData) {
    if ((0, _lodash.isEmpty)(originCabSizeData) || !(0, _lodash.isObjectLike)(originCabSizeData)) {
        return new _CabSizeModel2.default();
    }

    switch (dataOrigin) {
        case DataOrigins.MODELS_COLLECTION:
            return new _CabSizeModel2.default();

        case DataOrigins.MODEL_YEAR_POWERS_TRIMS:
            return resetCabSizeFromModelData(originCabSizeData);

        default:
            return new _CabSizeModel2.default();
    }
}

exports.default = {
    resetCabSizeFromOriginData: resetCabSizeFromOriginData
};

/***/ }),

/***/ "./src/ModelYear/services/ColourService/ColourService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetColourFromConfigurationData = resetColourFromConfigurationData;

var _lodash = __webpack_require__("lodash");

var _dataConversions = __webpack_require__("./src/constants/dataConversions.js");

var _ColourModel = __webpack_require__("./src/ModelYear/models/ColourModel.js");

var _ColourModel2 = _interopRequireDefault(_ColourModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint import/prefer-default-export: 0 */

function resetColourFromConfigurationData(configurationColourData, features) {
    if ((0, _lodash.isEmpty)(configurationColourData) || configurationColourData.length <= _dataConversions.COLOUR_DATA.PRICING) {
        return new _ColourModel2.default();
    }

    var retail = 0;
    var residualRetail = 0;
    if (!(0, _lodash.isEmpty)(configurationColourData[_dataConversions.COLOUR_DATA.PRICING]) && configurationColourData[_dataConversions.COLOUR_DATA.PRICING].length === 2) {
        var configurationTrimPricing = configurationColourData[_dataConversions.COLOUR_DATA.PRICING];

        retail = configurationTrimPricing[_dataConversions.COLOUR_DATA.AMOUNTS.RETAIL];
        residualRetail = configurationTrimPricing[_dataConversions.COLOUR_DATA.AMOUNTS.RESIDUAL_RETAIL];
    }

    var colourCode = configurationColourData[_dataConversions.COLOUR_DATA.CODE];
    var colourDescription = (0, _lodash.isUndefined)(features) || (0, _lodash.isEmpty)(features) || (0, _lodash.isEmpty)(features[colourCode]) ? '' : features[colourCode].description;

    var fabricDescription = '';
    var seatColourDescription = '';
    if (!(0, _lodash.isEmpty)(features) && !(0, _lodash.isEmpty)(features[colourCode]) && !(0, _lodash.isEmpty)(features[colourCode].colourFeatures)) {
        fabricDescription = features[colourCode].colourFeatures[_dataConversions.COLOUR_DATA.FEATURE_FABRIC] || '';
        seatColourDescription = features[colourCode].colourFeatures[_dataConversions.COLOUR_DATA.FEATURE_SEAT] || features[colourCode].colourFeatures[_dataConversions.COLOUR_DATA.FEATURE_INTERIOR] || '';
    }

    return new _ColourModel2.default({
        colourCode: colourCode,
        colourDescription: seatColourDescription || colourDescription,
        fabricDescription: fabricDescription,
        selected: false,
        enabled: true,
        visible: true,
        colourTile: configurationColourData[_dataConversions.COLOUR_DATA.TILE],
        photo1: configurationColourData[_dataConversions.COLOUR_DATA.PHOTO_1],
        photo2: configurationColourData[_dataConversions.COLOUR_DATA.PHOTO_2],
        photo3: configurationColourData[_dataConversions.COLOUR_DATA.PHOTO_3],
        retail: retail,
        residualRetail: residualRetail
    });
}

exports.default = {
    resetColourFromConfigurationData: resetColourFromConfigurationData
};

/***/ }),

/***/ "./src/ModelYear/services/DataUtilitiesService/DataUtilitiesService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getDescriptionData = getDescriptionData;
exports.getModelTrimsBitField = getModelTrimsBitField;
exports.getBaseSelectionObject = getBaseSelectionObject;
exports.getSelectionObject = getSelectionObject;
exports.getDataObject = getDataObject;
exports.getIncentiveExpirationDays = getIncentiveExpirationDays;
exports.mergeModelTrimsBitField = mergeModelTrimsBitField;
exports.intersectModelTrimsBitFieldValue = intersectModelTrimsBitFieldValue;
exports.getObjectFromAvailabilityFlag = getObjectFromAvailabilityFlag;

var _lodash = __webpack_require__("lodash");

/* eslint no-bitwise: 0 */

function getDescriptionData(description) {
    return (0, _lodash.isEmpty)(description) ? '' : description[0];
}

function getModelTrimsBitField(trimsBitFieldsData) {
    var modelTrimsBitField = {
        trimsBitField: 0,
        trimsBitFields: []
    };
    if (!(0, _lodash.isArrayLike)(trimsBitFieldsData) && !(0, _lodash.isFinite)(trimsBitFieldsData)) {
        return modelTrimsBitField;
    }

    if ((0, _lodash.isArrayLike)(trimsBitFieldsData)) {
        if (trimsBitFieldsData.length === 1) {
            modelTrimsBitField.trimsBitField = trimsBitFieldsData[0];
        } else {
            modelTrimsBitField.trimsBitFields = trimsBitFieldsData;
        }
    } else {
        modelTrimsBitField.trimsBitField = trimsBitFieldsData;
    }
    return modelTrimsBitField;
}

function getBaseSelectionObject(trimFlag, selectionCode) {
    var _getModelTrimsBitFiel = getModelTrimsBitField(trimFlag),
        trimsBitField = _getModelTrimsBitFiel.trimsBitField,
        trimsBitFields = _getModelTrimsBitFiel.trimsBitFields;

    return {
        trimsBitField: trimsBitField,
        trimsBitFields: trimsBitFields,
        selectionCode: selectionCode,
        enabled: true,
        visible: true,
        selected: false,
        userSelected: false
    };
}

function getSelectionObject(trimFlag, selectionCode, code, description) {
    var selectionObj = getBaseSelectionObject(trimFlag, selectionCode);
    selectionObj.code = code;
    selectionObj.description = getDescriptionData(description);

    return selectionObj;
}

function getDataObject(dataItem, flagIndex, descriptionIndex) {
    var dataObject = {};

    if ((0, _lodash.isEmpty)(dataItem)) {
        return dataObject;
    }

    var code = getDescriptionData(dataItem[descriptionIndex]);
    dataObject = getSelectionObject(dataItem[flagIndex], code, code, dataItem[descriptionIndex]);

    return dataObject;
}

function getIncentiveExpirationDays(incentiveExpirationDate) {
    var today = new Date();
    var expirationDays = 30;
    if (incentiveExpirationDate) {
        var expirationConvertedDate = new Date(incentiveExpirationDate);
        if (expirationConvertedDate > today) {
            var expirationMonth = expirationConvertedDate.getMonth();
            if (today.getFullYear() < expirationConvertedDate.getFullYear()) {
                expirationMonth += 12;
            }

            var expirationDay = expirationConvertedDate.getDate();
            if (today.getMonth() < expirationMonth) {
                expirationDay += 30;
            }

            expirationDays = expirationDay - today.getDate() + 1;
        }
    }

    return expirationDays;
}

function mergeModelTrimsBitField(modelTrimsBitFieldObjectA, modelTrimsBitFieldObjectB, orOperation) {
    var mergedModelTrimsBitField = {
        trimsBitField: 0,
        trimsBitFields: []
    };
    if ((0, _lodash.isUndefined)(modelTrimsBitFieldObjectA.trimsBitField) || (0, _lodash.isUndefined)(modelTrimsBitFieldObjectB.trimsBitField)) {
        return mergedModelTrimsBitField;
    }

    if (modelTrimsBitFieldObjectA.trimsBitField || modelTrimsBitFieldObjectB.trimsBitField) {
        mergedModelTrimsBitField.trimsBitField = orOperation ? modelTrimsBitFieldObjectA.trimsBitField | modelTrimsBitFieldObjectB.trimsBitField : modelTrimsBitFieldObjectA.trimsBitField & modelTrimsBitFieldObjectB.trimsBitField;
        return mergedModelTrimsBitField;
    }

    var emptyObjectA = (0, _lodash.isEmpty)(modelTrimsBitFieldObjectA.trimsBitFields);
    var emptyObjectB = (0, _lodash.isEmpty)(modelTrimsBitFieldObjectB.trimsBitFields);
    if (orOperation && (emptyObjectA || emptyObjectB)) {
        if (emptyObjectA && emptyObjectB) {
            return mergedModelTrimsBitField;
        }
        mergedModelTrimsBitField.trimsBitFields = emptyObjectA ? modelTrimsBitFieldObjectB.trimsBitFields : modelTrimsBitFieldObjectA.trimsBitFields;

        return mergedModelTrimsBitField;
    } else if (emptyObjectA || emptyObjectB || modelTrimsBitFieldObjectA.trimsBitFields.length !== modelTrimsBitFieldObjectB.trimsBitFields.length) {
        return mergedModelTrimsBitField;
    }

    for (var i = 0; i < modelTrimsBitFieldObjectA.trimsBitFields.length; i += 1) {
        mergedModelTrimsBitField.trimsBitFields.push(orOperation ? modelTrimsBitFieldObjectA.trimsBitFields[i] | modelTrimsBitFieldObjectB.trimsBitFields[i] : modelTrimsBitFieldObjectA.trimsBitFields[i] & modelTrimsBitFieldObjectB.trimsBitFields[i]);
    }
    return mergedModelTrimsBitField;
}

function intersectModelTrimsBitFieldValue(modelTrimsBitFieldObjectA, modelTrimsBitFieldObjectB) {
    var mergedModelTrimsBitField = mergeModelTrimsBitField(modelTrimsBitFieldObjectA, modelTrimsBitFieldObjectB, false);

    if ((0, _lodash.isEmpty)(mergedModelTrimsBitField.trimsBitFields)) {
        return mergedModelTrimsBitField.trimsBitField;
    }

    return (0, _lodash.sum)(mergedModelTrimsBitField.trimsBitFields);
}

function getObjectFromAvailabilityFlag(objectList, availabilityBitField) {
    var availableObject = null;

    if ((0, _lodash.isEmpty)(objectList) || !(0, _lodash.isArrayLikeObject)(objectList) || !availabilityBitField.trimsBitField && (0, _lodash.isEmpty)(availabilityBitField.trimsBitFields)) {
        return availableObject;
    }

    availableObject = (0, _lodash.find)(objectList, function (item) {
        return intersectModelTrimsBitFieldValue(item, availabilityBitField) > 0;
    });

    return (0, _lodash.isUndefined)(availableObject) ? null : availableObject;
}

exports.default = {
    getDescriptionData: getDescriptionData,
    getBaseSelectionObject: getBaseSelectionObject,
    getSelectionObject: getSelectionObject,
    getDataObject: getDataObject,
    getObjectFromAvailabilityFlag: getObjectFromAvailabilityFlag,
    getIncentiveExpirationDays: getIncentiveExpirationDays,
    getModelTrimsBitField: getModelTrimsBitField,
    mergeModelTrimsBitField: mergeModelTrimsBitField,
    intersectModelTrimsBitFieldValue: intersectModelTrimsBitFieldValue
};

/***/ }),

/***/ "./src/ModelYear/services/DrivePowerTrainService/DrivePowerTrainService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetDrivePowerTrainFromOriginData = resetDrivePowerTrainFromOriginData;
exports.addDrivePowerTrainConfigurationId = addDrivePowerTrainConfigurationId;

var _lodash = __webpack_require__("lodash");

var _DataUtilitiesService = __webpack_require__("./src/ModelYear/services/DataUtilitiesService/DataUtilitiesService.js");

var _dataOrigins = __webpack_require__("./src/constants/dataOrigins.js");

var DataOrigins = _interopRequireWildcard(_dataOrigins);

var _DrivePowerTrainModel = __webpack_require__("./src/ModelYear/models/DrivePowerTrainModel.js");

var _DrivePowerTrainModel2 = _interopRequireDefault(_DrivePowerTrainModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/* eslint no-bitwise: 0 */

function resetDrivePowerTrainFromModelData(modelData) {
    var drivePowerTrainSelectionCode = modelData.driveTrain.selectionCode + '|' + (modelData.engine.getSelectionCode() + '|') + ('' + modelData.transmission.getSelectionCode());

    var drivePowerTrainRank = modelData.driveTrain.rank * 100000 + (modelData.engine.hp + 1000) * 10 + modelData.transmission.rank;

    return new _DrivePowerTrainModel2.default({
        trimsBitField: 0,
        trimsBitFields: [],
        selectionCode: drivePowerTrainSelectionCode,
        enabled: true,
        visible: true,
        selected: false,
        userSelected: false,
        rank: drivePowerTrainRank,
        driveTrain: modelData.driveTrain,
        engine: modelData.engine,
        transmission: modelData.transmission,
        configurationIds: {},
        bestOptionsPackageCode: ''
    });
}

function resetDrivePowerTrainFromOriginData(dataOrigin, originDrivePowerTrainData) {
    if ((0, _lodash.isEmpty)(originDrivePowerTrainData) || !(0, _lodash.isObjectLike)(originDrivePowerTrainData)) {
        return new _DrivePowerTrainModel2.default();
    }

    switch (dataOrigin) {
        case DataOrigins.MODELS_COLLECTION:
            return new _DrivePowerTrainModel2.default();

        case DataOrigins.MODEL_YEAR_POWERS_TRIMS:
            return resetDrivePowerTrainFromModelData(originDrivePowerTrainData);

        default:
            return new _DrivePowerTrainModel2.default();
    }
}

function addDrivePowerTrainConfigurationId(drivePowerTrain, configurationId, configuration) {
    var _mergeModelTrimsBitFi = (0, _DataUtilitiesService.mergeModelTrimsBitField)(drivePowerTrain, configuration, true),
        trimsBitField = _mergeModelTrimsBitFi.trimsBitField,
        trimsBitFields = _mergeModelTrimsBitFi.trimsBitFields;

    var configurationIds = drivePowerTrain.get('configurationIds');
    configurationIds[configurationId] = configuration.trimsBitField;

    return drivePowerTrain.set('trimsBitField', trimsBitField).set('trimsBitFields', trimsBitFields).set('configurationIds', configurationIds);
}

exports.default = {
    resetDrivePowerTrainFromModelData: resetDrivePowerTrainFromModelData,
    resetDrivePowerTrainFromOriginData: resetDrivePowerTrainFromOriginData,
    addDrivePowerTrainConfigurationId: addDrivePowerTrainConfigurationId
};

/***/ }),

/***/ "./src/ModelYear/services/DriveTrainService/DriveTrainService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetDriveTrainFromOriginData = resetDriveTrainFromOriginData;

var _lodash = __webpack_require__("lodash");

var _dataOrigins = __webpack_require__("./src/constants/dataOrigins.js");

var DataOrigins = _interopRequireWildcard(_dataOrigins);

var _dataConversions = __webpack_require__("./src/constants/dataConversions.js");

var _DataUtilitiesService = __webpack_require__("./src/ModelYear/services/DataUtilitiesService/DataUtilitiesService.js");

var _DriveTrainModel = __webpack_require__("./src/ModelYear/models/DriveTrainModel.js");

var _DriveTrainModel2 = _interopRequireDefault(_DriveTrainModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/* eslint import/prefer-default-export: 0 */

function resetDriveTrainFromModelData(modelDriveTrainData) {
    if (modelDriveTrainData.length <= _dataConversions.DRIVE_TRAIN_DATA.LONG_DESCRIPTION) {
        return new _DriveTrainModel2.default();
    }

    var _getModelTrimsBitFiel = (0, _DataUtilitiesService.getModelTrimsBitField)(modelDriveTrainData[_dataConversions.DRIVE_TRAIN_DATA.BIT_FIELD]),
        trimsBitField = _getModelTrimsBitFiel.trimsBitField,
        trimsBitFields = _getModelTrimsBitFiel.trimsBitFields;

    return new _DriveTrainModel2.default({
        trimsBitField: trimsBitField,
        trimsBitFields: trimsBitFields,
        selectionCode: modelDriveTrainData[_dataConversions.DRIVE_TRAIN_DATA.ID_CODE],
        code: modelDriveTrainData[_dataConversions.DRIVE_TRAIN_DATA.ID_CODE],
        rank: modelDriveTrainData[_dataConversions.DRIVE_TRAIN_DATA.CODE] === _dataConversions.DRIVE_TRAIN_4WD ? 2 : 1,
        description: (0, _DataUtilitiesService.getDescriptionData)(modelDriveTrainData[_dataConversions.DRIVE_TRAIN_DATA.DESCRIPTION]),
        longDescription: (0, _DataUtilitiesService.getDescriptionData)(modelDriveTrainData[_dataConversions.DRIVE_TRAIN_DATA.LONG_DESCRIPTION])
    });
}

function resetDriveTrainFromOriginData(dataOrigin, originDriveTrainData) {
    if ((0, _lodash.isEmpty)(originDriveTrainData) || !(0, _lodash.isObjectLike)(originDriveTrainData)) {
        return new _DriveTrainModel2.default();
    }

    switch (dataOrigin) {
        case DataOrigins.MODELS_COLLECTION:
            return new _DriveTrainModel2.default();

        case DataOrigins.MODEL_YEAR_POWERS_TRIMS:
            return resetDriveTrainFromModelData(originDriveTrainData);

        default:
            return new _DriveTrainModel2.default();
    }
}

exports.default = {
    resetDriveTrainFromOriginData: resetDriveTrainFromOriginData
};

/***/ }),

/***/ "./src/ModelYear/services/EngineService/EngineService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetEngineFromConfigurationData = resetEngineFromConfigurationData;

var _lodash = __webpack_require__("lodash");

var _dataConversions = __webpack_require__("./src/constants/dataConversions.js");

var _EngineModel = __webpack_require__("./src/ModelYear/models/EngineModel.js");

var _EngineModel2 = _interopRequireDefault(_EngineModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint import/prefer-default-export: 0 */

function resetEngineFromConfigurationData(configurationEngineData) {
    if ((0, _lodash.isEmpty)(configurationEngineData) || configurationEngineData.length <= _dataConversions.ENGINE_DATA.TORQUE_RPM) {
        return new _EngineModel2.default();
    }

    var selectionCode = configurationEngineData[_dataConversions.ENGINE_DATA.DISPLACEMENT] + 'L-' + (configurationEngineData[_dataConversions.ENGINE_DATA.CYLINDERS] + 'C-') + ('' + (configurationEngineData[_dataConversions.ENGINE_DATA.IS_TURBO] ? 'T-' : '')) + ('' + configurationEngineData[_dataConversions.ENGINE_DATA.FUEL]);

    return new _EngineModel2.default({
        selectionCode: selectionCode,
        code: '',
        fuelTypeCode: configurationEngineData[_dataConversions.ENGINE_DATA.FUEL],
        cylinders: configurationEngineData[_dataConversions.ENGINE_DATA.CYLINDERS],
        displacement: configurationEngineData[_dataConversions.ENGINE_DATA.DISPLACEMENT],
        isTurbo: configurationEngineData[_dataConversions.ENGINE_DATA.IS_TURBO],
        hp: configurationEngineData[_dataConversions.ENGINE_DATA.HP],
        hpRpm: configurationEngineData[_dataConversions.ENGINE_DATA.HP_RPM],
        torque: configurationEngineData[_dataConversions.ENGINE_DATA.TORQUE],
        torqueRpm: configurationEngineData[_dataConversions.ENGINE_DATA.TORQUE_RPM]
    });
}

exports.default = {
    resetEngineFromConfigurationData: resetEngineFromConfigurationData
};

/***/ }),

/***/ "./src/ModelYear/services/ModelTrimConfigurationService/ModelTrimConfigurationService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetModelTrimConfigurationFromModelData = resetModelTrimConfigurationFromModelData;

var _immutable = __webpack_require__("immutable");

var _lodash = __webpack_require__("lodash");

var _dataOrigins = __webpack_require__("./src/constants/dataOrigins.js");

var DataOrigins = _interopRequireWildcard(_dataOrigins);

var _exteriorColourStatuses = __webpack_require__("./src/ModelYear/constants/exteriorColourStatuses.js");

var _ModelTrimConfigurationModel = __webpack_require__("./src/ModelYear/models/ModelTrimConfigurationModel.js");

var _ModelTrimConfigurationModel2 = _interopRequireDefault(_ModelTrimConfigurationModel);

var _DataUtilitiesService = __webpack_require__("./src/ModelYear/services/DataUtilitiesService/DataUtilitiesService.js");

var UtilitiesService = _interopRequireWildcard(_DataUtilitiesService);

var _PurchaseMethodsService = __webpack_require__("./src/PurchaseMethods/services/PurchaseMethodsService/PurchaseMethodsService.js");

var _ModelTrimItemsService = __webpack_require__("./src/ModelYear/services/ModelTrimItemsService/ModelTrimItemsService.js");

var _EngineService = __webpack_require__("./src/ModelYear/services/EngineService/EngineService.js");

var _TransmissionService = __webpack_require__("./src/ModelYear/services/TransmissionService/TransmissionService.js");

var _ColourService = __webpack_require__("./src/ModelYear/services/ColourService/ColourService.js");

var _dataConversions = __webpack_require__("./src/constants/dataConversions.js");

var _dataTypes = __webpack_require__("./src/constants/dataTypes.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/* eslint import/prefer-default-export: 0 no-bitwise: 0 */

function getConfigurationColours(configurationColoursData, features) {
    var colours = {};
    (0, _lodash.forEach)(configurationColoursData, function (configurationColourData) {
        var colour = (0, _ColourService.resetColourFromConfigurationData)(configurationColourData, features);
        if (colour.colourCode !== '') {
            colours[colour.colourCode] = colour;
        }
    });

    return colours;
}

function getConfigurationFeaturesAndOptions(configurationFeatureCodesData, modelFeaturesAndOptions, configurationTrimsBitField) {
    var configurationFeaturesAndOptions = {
        modelTrimFeatures: {},
        features: {},
        options: {}
    };

    if ((0, _lodash.isEmpty)(configurationFeatureCodesData) || (0, _lodash.isEmpty)(modelFeaturesAndOptions) || !(0, _lodash.isObjectLike)(modelFeaturesAndOptions) || !configurationTrimsBitField.trimsBitField && (0, _lodash.isEmpty)(configurationTrimsBitField.trimsBitFields)) {
        return configurationFeaturesAndOptions;
    }

    var currentFeaturesAndOptions = (0, _lodash.find)(modelFeaturesAndOptions, function (featuresAndOptions) {
        return UtilitiesService.intersectModelTrimsBitFieldValue(featuresAndOptions, configurationTrimsBitField) > 0;
    });
    configurationFeaturesAndOptions.options = currentFeaturesAndOptions.options;

    if (currentFeaturesAndOptions && (!(0, _lodash.isEmpty)(currentFeaturesAndOptions.options) || !(0, _lodash.isEmpty)(currentFeaturesAndOptions.features))) {
        (0, _lodash.forEach)(configurationFeatureCodesData, function (featureCode) {
            if (!(0, _lodash.isUndefined)(currentFeaturesAndOptions.options[featureCode])) {
                configurationFeaturesAndOptions.features[featureCode] = currentFeaturesAndOptions.options[featureCode];

                configurationFeaturesAndOptions.features[featureCode].rank = currentFeaturesAndOptions.options[featureCode].keyOrder === 0 ? _dataTypes.DEFAULT_KEY_ORDER : currentFeaturesAndOptions.options[featureCode].keyOrder;
            } else if (!(0, _lodash.isUndefined)(currentFeaturesAndOptions.features[featureCode])) {
                configurationFeaturesAndOptions.modelTrimFeatures[featureCode] = currentFeaturesAndOptions.features[featureCode];

                configurationFeaturesAndOptions.modelTrimFeatures[featureCode].rank = currentFeaturesAndOptions.features[featureCode].keyOrder === 0 ? _dataTypes.DEFAULT_KEY_ORDER : currentFeaturesAndOptions.features[featureCode].keyOrder;
            }
        });
    }

    return configurationFeaturesAndOptions;
}

function getConfigurationFeatureRankedIcons(configuration, configurationFeatureIcons) {
    var configFeatureRankedIcons = [];
    (0, _lodash.forEach)(configurationFeatureIcons, function (iconType, iconTypeKey) {
        (0, _lodash.forEach)(iconType.featureCodes, function (iconFeatureCode) {
            configFeatureRankedIcons.push((0, _immutable.Map)((0, _ModelTrimItemsService.getIconFromFeatureCode)(configuration.features, configuration.modelTrimFeatures, iconType, iconTypeKey, iconFeatureCode)));
        });
    });

    return (0, _lodash.sortBy)(configFeatureRankedIcons, function (rankedIcon) {
        return rankedIcon.rank;
    });
}

function resetModelTrimConfigurationFromModelData(modelTrimConfiguration, modelOptions, modelTrim, driveTrains, cabSizes, boxSizes) {
    if ((0, _lodash.isEmpty)(modelTrimConfiguration) || !(0, _lodash.isObjectLike)(modelTrimConfiguration) || (0, _lodash.isEmpty)(modelTrim) || !(0, _lodash.isObjectLike)(modelTrim) || (0, _lodash.isEmpty)(driveTrains) || !(0, _lodash.isArrayLikeObject)(driveTrains)) {
        return new _ModelTrimConfigurationModel2.default();
    }

    var _UtilitiesService$get = UtilitiesService.getModelTrimsBitField(modelTrimConfiguration[_dataConversions.MODEL_CONFIGURATION.BIT_FIELD]),
        trimsBitField = _UtilitiesService$get.trimsBitField,
        trimsBitFields = _UtilitiesService$get.trimsBitFields;

    var configID = modelTrimConfiguration[_dataConversions.MODEL_CONFIGURATION.ID];
    var configStringID = (configID.length === 1 ? '0' : '') + configID;
    var configModelTrimCode = modelTrimConfiguration[_dataConversions.MODEL_CONFIGURATION.TRIM_CODE];
    var configPackageCode = modelTrimConfiguration[_dataConversions.MODEL_CONFIGURATION.PACKAGE_CODE];
    var configTrimsBitField = {
        trimsBitField: trimsBitField,
        trimsBitFields: trimsBitFields
    };

    var featuresAndOptions = getConfigurationFeaturesAndOptions(modelTrimConfiguration[_dataConversions.MODEL_CONFIGURATION.OPTION_CODES], modelOptions, configTrimsBitField);

    var configFeatureIcons = (0, _ModelTrimItemsService.getFeatureIcons)(featuresAndOptions.features, featuresAndOptions.modelTrimFeatures);
    if (!(0, _lodash.isEmpty)(configFeatureIcons) && !(0, _lodash.isEmpty)(featuresAndOptions.modelTrimFeatures)) {
        (0, _lodash.forEach)(featuresAndOptions.modelTrimFeatures, function (feature) {
            (0, _lodash.map)(feature.iconTypes, function (iconType, key) {
                var newIconType = iconType;
                if (!(0, _lodash.isEmpty)(configFeatureIcons[key]) && newIconType.featureCode !== configFeatureIcons[key].featureCode) {
                    newIconType.isInvalid = true;
                }
            });
        });
    }

    var featureIcons = getConfigurationFeatureRankedIcons(featuresAndOptions, configFeatureIcons);
    var nonModelTrimFeatureIcons = (0, _lodash.filter)(featureIcons, function (featureIcon) {
        return !featureIcon.isFromModelTrim;
    });

    // const configurationFeatureIcons = getFeatureRankedIcons(
    //    featuresAndOptions.features, featuresAndOptions.modelTrimFeatures, featureIcons
    // );

    var exteriorColourStatus = (0, _lodash.isUndefined)(modelTrimConfiguration[_dataConversions.MODEL_CONFIGURATION.EXTERIOR_COLOUR_STATUS]) ? _exteriorColourStatuses.IMAGE_STATUS.NO_IMAGE : modelTrimConfiguration[_dataConversions.MODEL_CONFIGURATION.EXTERIOR_COLOUR_STATUS];
    var driveTrain = UtilitiesService.getObjectFromAvailabilityFlag(driveTrains, configTrimsBitField);
    var driveTrainSelectionCode = driveTrain === null ? '' : driveTrain.selectionCode;
    var cabSize = UtilitiesService.getObjectFromAvailabilityFlag(cabSizes, configTrimsBitField);
    var cabSizeSelectionCode = cabSize === null ? '' : cabSize.selectionCode;
    var boxSize = UtilitiesService.getObjectFromAvailabilityFlag(boxSizes, configTrimsBitField);
    var boxSizeSelectionCode = boxSize === null ? '' : boxSize.selectionCode;

    var configurationDescription = UtilitiesService.getDescriptionData(modelTrimConfiguration[_dataConversions.MODEL_CONFIGURATION.DESCRIPTION]);
    return new _ModelTrimConfigurationModel2.default({
        trimsBitField: trimsBitField,
        trimsBitFields: trimsBitFields,
        selectionCode: configModelTrimCode + '|' + configStringID,
        enabled: true,
        visible: true,
        selected: false,
        userSelected: false,
        code: configPackageCode + '|' + configStringID,
        description: configurationDescription,
        id: configID,
        rank: modelTrimConfiguration[_dataConversions.MODEL_CONFIGURATION.RANK],
        modelTrimCode: configModelTrimCode,
        modelTrimCodeId: configModelTrimCode + '|' + configID,
        modelTrimRank: modelTrimConfiguration[_dataConversions.MODEL_CONFIGURATION.TRIM_RANK],
        packageSelectionCode: configPackageCode,
        packageCode: configPackageCode.substring(0, 3) === _dataTypes.SYSTEM_PACKAGE_CODE ? '' : configPackageCode,
        modelTrim: modelTrim,
        package: {
            code: configPackageCode.substring(0, 3) === _dataTypes.SYSTEM_PACKAGE_CODE ? '' : configPackageCode,
            description: configurationDescription
        },
        cabSizeSelectionCode: cabSizeSelectionCode,
        cabSize: cabSize,
        boxSizeSelectionCode: boxSizeSelectionCode,
        boxSize: boxSize,
        driveTrainSelectionCode: driveTrainSelectionCode,
        driveTrain: driveTrain,
        engine: (0, _EngineService.resetEngineFromConfigurationData)(modelTrimConfiguration[_dataConversions.MODEL_CONFIGURATION.ENGINE]),
        transmission: (0, _TransmissionService.resetTransmissionFromConfigurationData)(modelTrimConfiguration[_dataConversions.MODEL_CONFIGURATION.TRANSMISSION]),
        purchaseMethods: (0, _PurchaseMethodsService.resetPurchaseMethodsFromOriginData)(DataOrigins.MODEL_YEAR_POWERS_TRIMS, modelTrimConfiguration),
        seating: modelTrimConfiguration[_dataConversions.MODEL_CONFIGURATION.SEATING],
        fuelCity: modelTrimConfiguration[_dataConversions.MODEL_CONFIGURATION.FUEL_CONSUMPTION][0],
        fuelHighway: modelTrimConfiguration[_dataConversions.MODEL_CONFIGURATION.FUEL_CONSUMPTION][1],
        modelTrimFeatures: featuresAndOptions.modelTrimFeatures,
        features: featuresAndOptions.features,
        featureIcons: (0, _immutable.List)(featureIcons),
        nonModelTrimFeatureIconsCount: nonModelTrimFeatureIcons.length,
        exteriorColourStatus: exteriorColourStatus,
        exteriorColours: (0, _immutable.List)((0, _lodash.values)(getConfigurationColours(modelTrimConfiguration[_dataConversions.MODEL_CONFIGURATION.URL_EXTERIOR_COLOUR], featuresAndOptions.options))),
        interiorColours: (0, _immutable.List)((0, _lodash.values)(getConfigurationColours(modelTrimConfiguration[_dataConversions.MODEL_CONFIGURATION.URL_INTERIOR_TRIM], featuresAndOptions.options))),
        smNewTrimCarId: modelTrimConfiguration[_dataConversions.MODEL_CONFIGURATION.CAR_ID],
        smNewCarId: modelTrimConfiguration[_dataConversions.MODEL_CONFIGURATION.VEH_ID],
        configurationItemsAreLoaded: false
    });
}

exports.default = {
    getConfigurationColours: getConfigurationColours,
    getConfigurationFeaturesAndOptions: getConfigurationFeaturesAndOptions,
    getConfigurationFeatureRankedIcons: getConfigurationFeatureRankedIcons,
    resetModelTrimConfigurationFromModelData: resetModelTrimConfigurationFromModelData
};

/***/ }),

/***/ "./src/ModelYear/services/ModelTrimItemsService/ModelTrimItemsService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getBaseModelTrimItems = getBaseModelTrimItems;
exports.getModelTrimItemFromFeature = getModelTrimItemFromFeature;
exports.setModelTrimItems = setModelTrimItems;
exports.getFeatureIcons = getFeatureIcons;
exports.getIconFromFeatureCode = getIconFromFeatureCode;
exports.getFeatureRankedIcons = getFeatureRankedIcons;
exports.setModelTrimConfigurationFeatureIcons = setModelTrimConfigurationFeatureIcons;
exports.getModelYearFeaturesAndOptions = getModelYearFeaturesAndOptions;

var _immutable = __webpack_require__("immutable");

var _lodash = __webpack_require__("lodash");

var _apiDataConversionConstants = __webpack_require__("./src/constants/apiDataConversionConstants.js");

var Constants = _interopRequireWildcard(_apiDataConversionConstants);

var _DataUtilitiesService = __webpack_require__("./src/ModelYear/services/DataUtilitiesService/DataUtilitiesService.js");

var UtilitiesService = _interopRequireWildcard(_DataUtilitiesService);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var DATA_TYPES = Constants.VIEW_2_1.DATA_TYPES;

var FEATURES_CONSTANTS = Constants.VIEW_2_1.VEHICLE.FEATURES;
var FEATURE_CONSTANTS = Constants.VIEW_2_1.VEHICLE.FEATURES.FEATURE;
var MODEL_YEAR_FEATURES_CONSTANTS = Constants.VIEW_2_1.VEHICLE.MODEL_YEAR.FEATURES;
var DEFAULT_KEY_ORDER = 9999999;
var DEFINED_RANK = 10000000;
var UNDEFINED_RANK = 30000000;
var FEATURE_TYPE_ID_START = 100;
var FEATURE_TYPE_IGNORE = 5;
var DEFAULT_ICON = Constants.VIEW_2_1.DEFAULT_ICON;
function getBaseModelTrimItems() {
    return {
        modelTrimBase: {},
        optionsPackage: {},
        engine: {},
        transmission: {},
        features: {},
        options: {},
        exteriorColours: {},
        interiorTrims: {},
        accessories: {},
        fees: {},
        taxesAndDuties: {},
        rebates: {}
    };
}

function getModelTrimItemFromFeature(feature, isStandard) {
    var item = UtilitiesService.getBaseSelectionObject(0, (0, _lodash.isUndefined)(feature.selectionCode) ? feature.code : feature.selectionCode);

    item.code = feature.code;
    item.dataType = feature.dataType;
    item.typeID = feature.typeID;
    item.isStandard = isStandard;
    item.available = true;
    item.selected = true;
    item.userSelected = false;
    item.description = feature.description;
    item.note = '';
    item.retail = 0;
    item.retailUpdate = false;
    item.residualRetail = 0;
    item.groupItems = {};

    return item;
}

function setModelTrimItems(modelTrimItems, items) {
    if ((0, _lodash.isEmpty)(items) || (0, _lodash.isUndefined)(modelTrimItems)) {
        return modelTrimItems;
    }

    var newModelTrimItems = modelTrimItems;

    newModelTrimItems.selectedItems = {};
    (0, _lodash.forEach)(items, function (item, key) {
        if (item.isStandard) {
            newModelTrimItems.features[key] = item;
        } else {
            if (item.selected) {
                newModelTrimItems.selectedItems[key] = item;
            }

            switch (item.dataType) {
                case DATA_TYPES.FEATURE:
                    switch (item.typeID) {
                        case DATA_TYPES.FEATURE_TYPE_MODEL_TRIM:
                            newModelTrimItems.modelTrimBase = item;
                            break;

                        case DATA_TYPES.FEATURE_TYPE_PACKAGE:
                            newModelTrimItems.package = item;
                            break;

                        case DATA_TYPES.FEATURE_TYPE_ENGINE:
                            newModelTrimItems.engine = item;
                            break;

                        case DATA_TYPES.FEATURE_TYPE_TRANSMISSION:
                            newModelTrimItems.transmission = item;
                            break;

                        case DATA_TYPES.FEATURE_TYPE_EXTERIOR_COLOUR:
                            newModelTrimItems.exteriorColours[key] = item;
                            break;

                        case DATA_TYPES.FEATURE_TYPE_INTERIOR_TRIM:
                            newModelTrimItems.interiorTrims[key] = item;
                            break;

                        default:
                            newModelTrimItems.options[key] = item;
                            break;
                    }
                    break;

                case DATA_TYPES.FEE:
                    newModelTrimItems.fees[key] = item;
                    break;

                case DATA_TYPES.TAX_AND_DUTY:
                    newModelTrimItems.taxesAndDuties[key] = item;
                    break;

                case DATA_TYPES.REBATE:
                    newModelTrimItems.rebates[key] = item;
                    break;

                default:
                    break;
            }
        }
    });

    return newModelTrimItems;
}

function getFeatureIcons(features, modelTrimFeatures) {
    var featureIcons = {};
    var featureCode = '';
    var featureDesc = '';
    var featureKeyOrder = DEFAULT_KEY_ORDER;

    (0, _lodash.forEach)(features, function (feature) {
        var newFeature = feature;
        featureCode = newFeature.code;
        featureDesc = newFeature.description;
        featureKeyOrder = newFeature.keyOrder === 0 ? DEFAULT_KEY_ORDER : newFeature.keyOrder;

        if (newFeature.dataTypeID === DATA_TYPES.FEATURE && !(0, _lodash.isEmpty)(newFeature.iconTypes)) {
            (0, _lodash.forEach)(newFeature.iconTypes, function (iconType, iconKey) {
                if ((0, _lodash.isEmpty)(featureIcons[iconKey]) || iconType.value > featureIcons[iconKey].value) {
                    featureIcons[iconKey] = iconType;
                    featureIcons[iconKey].featureCode = featureCode;
                    featureIcons[iconKey].featureCodes = [];
                    featureIcons[iconKey].featureCodes.push(featureCode);
                }
            });
        } else if (newFeature.dataTypeID === DATA_TYPES.FEATURE && (newFeature.typeID > FEATURE_TYPE_ID_START || newFeature.typeID < FEATURE_TYPE_IGNORE)) {
            newFeature.iconTypes[DEFAULT_ICON] = {
                iconCode: DEFAULT_ICON,
                value: 0,
                rank: featureKeyOrder,
                keyOrder: featureKeyOrder,
                description: featureDesc,
                featureCode: featureCode
            };

            if ((0, _lodash.isUndefined)(featureIcons[DEFAULT_ICON])) {
                featureIcons[DEFAULT_ICON] = newFeature.iconTypes[DEFAULT_ICON];
                featureIcons[DEFAULT_ICON].featureCodes = [];
                featureIcons[DEFAULT_ICON].featureCodes.push(featureCode);
            } else {
                featureIcons[DEFAULT_ICON].featureCodes.push(featureCode);
            }
        }
    });

    (0, _lodash.forEach)(modelTrimFeatures, function (feature) {
        if (!(0, _lodash.isEmpty)(feature.iconTypes)) {
            (0, _lodash.forEach)(feature.iconTypes, function (iconType, key) {
                if ((0, _lodash.isEmpty)(featureIcons[key])) {
                    featureIcons[key] = iconType;
                    featureIcons[key].featureCode = feature.code;
                }
            });
        }
    });

    return featureIcons;
}

function getIconFromFeatureCode(features, modelTrimFeatures, iconType, iconTypeKey, featureCode) {
    var iconObject = {
        code: featureCode,
        description: iconType.description,
        typeDescription: iconType.description,
        value: iconType.value
    };

    var featureRank = DEFINED_RANK;
    var modelFeatureRank = DEFINED_RANK;
    var featureIsModelTrim = true;

    if (!(0, _lodash.isUndefined)(features[featureCode])) {
        featureRank += features[featureCode].rank;
        modelFeatureRank += features[featureCode].rank;
        featureIsModelTrim = false;
        iconObject.description = features[featureCode].description;
        iconObject.typeDescription = iconTypeKey === DEFAULT_ICON ? features[featureCode].description : iconType.description;
    } else if (!(0, _lodash.isUndefined)(modelTrimFeatures[featureCode])) {
        featureRank += DEFINED_RANK + modelTrimFeatures[featureCode].rank;
        modelFeatureRank += modelTrimFeatures[featureCode].rank;
        iconObject.description = modelTrimFeatures[featureCode].description;
        iconObject.typeDescription = iconTypeKey === DEFAULT_ICON ? modelTrimFeatures[featureCode].description : iconType.description;
    } else {
        featureRank = UNDEFINED_RANK;
        modelFeatureRank = UNDEFINED_RANK;
    }

    return {
        rank: featureRank,
        modelTrimRank: modelFeatureRank,
        code: iconTypeKey,
        isFromModelTrim: featureIsModelTrim,
        iconObject: (0, _immutable.Map)(iconObject)
    };
}

function getFeatureRankedIcons(features, modelTrimFeatures, featureIcons) {
    var featureRankedIcons = [];

    (0, _lodash.forEach)(featureIcons, function (iconType, iconTypeKey) {
        (0, _lodash.forEach)(iconType.featureCodes, function (featureCode) {
            featureRankedIcons.push(getIconFromFeatureCode(features, modelTrimFeatures, iconType, iconTypeKey, featureCode));
        });
    });

    return (0, _lodash.sortBy)(featureRankedIcons, function (rankedIcon) {
        return rankedIcon.rank;
    });
}

function setModelTrimConfigurationFeatureIcons(configuration) {
    var newConfiguration = configuration;
    var configFeatureIcons = getFeatureIcons(newConfiguration.features, newConfiguration.modelTrimFeatures);

    if (!(0, _lodash.isEmpty)(configFeatureIcons) && !(0, _lodash.isEmpty)(newConfiguration.modelTrimFeatures)) {
        (0, _lodash.forEach)(newConfiguration.modelTrimFeatures, function (feature) {
            var newFeature = feature;
            var delTypes = [];
            if (!(0, _lodash.isEmpty)(newFeature.iconTypes)) {
                (0, _lodash.forEach)(newFeature.iconTypes, function (iconType, key) {
                    if (!(0, _lodash.isEmpty)(configFeatureIcons[key]) && iconType.featureCode !== configFeatureIcons[key].featureCode) {
                        delTypes.push(key);
                    }
                });
            }
            if (!(0, _lodash.isEmpty)(delTypes)) {
                (0, _lodash.forEach)(delTypes, function (iconType) {
                    delete newFeature.iconTypes[iconType];
                });
            }
        });
    }

    newConfiguration.featureIcons = getFeatureRankedIcons(newConfiguration.features, newConfiguration.modelTrimFeatures, configFeatureIcons);

    var nonModelTrimFeatureIcons = (0, _lodash.filter)(newConfiguration.featureIcons, function (featureIcon) {
        return !featureIcon.isFromModelTrim;
    });
    newConfiguration.nonModelTrimFeatureIconsCount = nonModelTrimFeatureIcons.length;
}

function getModelFeatureOption(modelFeatureOptionData) {
    var modelFeatureOption = {};

    if ((0, _lodash.isEmpty)(modelFeatureOptionData)) {
        return modelFeatureOption;
    }

    modelFeatureOption.code = modelFeatureOptionData[FEATURE_CONSTANTS.CODE];
    modelFeatureOption.type = modelFeatureOptionData[FEATURE_CONSTANTS.TYPE];
    modelFeatureOption.keyOrder = modelFeatureOptionData[FEATURE_CONSTANTS.KEY_ORDER];
    modelFeatureOption.dataTypeID = modelFeatureOptionData[FEATURE_CONSTANTS.DATA_TYPE_ID];
    modelFeatureOption.typeID = modelFeatureOptionData[FEATURE_CONSTANTS.TYPE_ID];
    modelFeatureOption.description = modelFeatureOptionData[FEATURE_CONSTANTS.DESCRIPTION];
    modelFeatureOption.isStandard = modelFeatureOptionData[FEATURE_CONSTANTS.IS_STANDARD];
    modelFeatureOption.typeIDs = modelFeatureOptionData[FEATURE_CONSTANTS.TYPE_IDS];
    modelFeatureOption.colourFeatures = modelFeatureOptionData[FEATURE_CONSTANTS.COLOUR_FEATURES];

    modelFeatureOption.iconTypes = {};
    var icons = modelFeatureOptionData[FEATURE_CONSTANTS.TYPE_ICONS];
    if (!(0, _lodash.isEmpty)(icons)) {
        (0, _lodash.forEach)(icons, function (icon) {
            if ((0, _lodash.isEmpty)(modelFeatureOption.iconTypes[icon[FEATURE_CONSTANTS.ICON.CODE]])) {
                modelFeatureOption.iconTypes[icon[FEATURE_CONSTANTS.ICON.CODE]] = {
                    rank: icon[FEATURE_CONSTANTS.ICON.KEY_ORDER],
                    keyOrder: icon[FEATURE_CONSTANTS.ICON.KEY_ORDER],
                    value: icon[FEATURE_CONSTANTS.ICON.VALUE],
                    description: icon[FEATURE_CONSTANTS.ICON.DESCRIPTION],
                    featureCode: modelFeatureOption.code,
                    featureCodes: []
                };
                modelFeatureOption.iconTypes[icon[FEATURE_CONSTANTS.ICON.CODE]].featureCodes.push(modelFeatureOption.code);
                if (modelFeatureOption.keyOrder === 0 && modelFeatureOption.iconTypes[icon[FEATURE_CONSTANTS.ICON.CODE]].keyOrder > 0 || modelFeatureOption.iconTypes[icon[FEATURE_CONSTANTS.ICON.CODE]].keyOrder < modelFeatureOption.keyOrder) {
                    modelFeatureOption.keyOrder = modelFeatureOption.iconTypes[icon[FEATURE_CONSTANTS.ICON.CODE]].keyOrder;
                }
            }
        });
    } else if (modelFeatureOption.dataTypeID === DATA_TYPES.FEATURE && (modelFeatureOption.typeID > FEATURE_TYPE_ID_START || modelFeatureOption.typeID === 0)) {
        modelFeatureOption.iconTypes[DEFAULT_ICON] = {
            iconCode: DEFAULT_ICON,
            value: 0,
            rank: modelFeatureOption.keyOrder,
            keyOrder: modelFeatureOption.keyOrder,
            description: modelFeatureOption.description,
            featureCode: modelFeatureOption.code
        };
    }

    return modelFeatureOption;
}

function splitModelFeaturesAndOptions(modelFeaturesAndOptionsData) {
    var modelFeaturesAndOptions = {
        trimsBitField: 0,
        trimsBitFields: 0,
        features: {},
        options: {}
    };

    if ((0, _lodash.isEmpty)(modelFeaturesAndOptionsData)) {
        return modelFeaturesAndOptions;
    }

    var _UtilitiesService$get = UtilitiesService.getModelTrimsBitField(modelFeaturesAndOptionsData[FEATURES_CONSTANTS.BIT_FIELD]),
        trimsBitField = _UtilitiesService$get.trimsBitField,
        trimsBitFields = _UtilitiesService$get.trimsBitFields;

    modelFeaturesAndOptions.trimsBitField = trimsBitField;
    modelFeaturesAndOptions.trimsBitFields = trimsBitFields;
    (0, _lodash.forEach)(modelFeaturesAndOptionsData[FEATURES_CONSTANTS.LIST], function (modelFeatureOption) {
        var featureOption = getModelFeatureOption(modelFeatureOption);
        if (featureOption.isStandard) {
            modelFeaturesAndOptions.features[featureOption.code] = featureOption;
        } else {
            modelFeaturesAndOptions.options[featureOption.code] = featureOption;
        }
    });

    return modelFeaturesAndOptions;
}

function getModelYearFeaturesAndOptions(modelYearFeaturesAndOptionsData) {
    var featuresAndOptions = (0, _lodash.map)(modelYearFeaturesAndOptionsData[MODEL_YEAR_FEATURES_CONSTANTS], function (modelFeaturesAndOptions) {
        return splitModelFeaturesAndOptions(modelFeaturesAndOptions);
    });

    return featuresAndOptions;
}

exports.default = {
    getBaseModelTrimItems: getBaseModelTrimItems,
    getModelTrimItemFromFeature: getModelTrimItemFromFeature,
    setModelTrimItems: setModelTrimItems,
    getFeatureIcons: getFeatureIcons,
    getIconFromFeatureCode: getIconFromFeatureCode,
    getFeatureRankedIcons: getFeatureRankedIcons,
    setModelTrimConfigurationFeatureIcons: setModelTrimConfigurationFeatureIcons,
    getModelFeatureOption: getModelFeatureOption,
    splitModelFeaturesAndOptions: splitModelFeaturesAndOptions,
    getModelYearFeaturesAndOptions: getModelYearFeaturesAndOptions
};

/***/ }),

/***/ "./src/ModelYear/services/ModelTrimService/ModelTrimService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetModelTrimFromOriginData = resetModelTrimFromOriginData;
exports.addModelTrimConfigurationId = addModelTrimConfigurationId;
exports.resetModelTrimComparisonFeatures = resetModelTrimComparisonFeatures;

var _lodash = __webpack_require__("lodash");

var _immutable = __webpack_require__("immutable");

var _DataUtilitiesService = __webpack_require__("./src/ModelYear/services/DataUtilitiesService/DataUtilitiesService.js");

var _dataOrigins = __webpack_require__("./src/constants/dataOrigins.js");

var DataOrigins = _interopRequireWildcard(_dataOrigins);

var _ModelTrimItemsService = __webpack_require__("./src/ModelYear/services/ModelTrimItemsService/ModelTrimItemsService.js");

var _ModelTrimModel = __webpack_require__("./src/ModelYear/models/ModelTrimModel.js");

var _ModelTrimModel2 = _interopRequireDefault(_ModelTrimModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/* eslint no-bitwise: 0 */

function getModelTrimFeatureIcons(configurationFeatureIcons) {
    var featureIcons = {};
    (0, _lodash.forEach)(configurationFeatureIcons.toArray(), function (featureIcon) {
        if (featureIcon.isFromModelTrim && (0, _lodash.isUndefined)(featureIcons[featureIcon.iconObject.code])) {
            featureIcons[featureIcon.iconObject.code] = featureIcon;
        }
    });

    return featureIcons;
}

function getModelTrimAddFeatureRankedIcons(features, modelTrimFeatures, comparisonAddFeatures) {
    var modelTrimAddFeatureRankedIcons = [];
    var modelTrimCompareFeatureIcons = (0, _ModelTrimItemsService.getFeatureIcons)(comparisonAddFeatures);

    (0, _lodash.forEach)(modelTrimCompareFeatureIcons, function (iconType, iconTypeKey) {
        (0, _lodash.forEach)(iconType.featureCodes, function (featureCode) {
            modelTrimAddFeatureRankedIcons.push((0, _immutable.fromJS)((0, _ModelTrimItemsService.getIconFromFeatureCode)(features, modelTrimFeatures, iconType, iconTypeKey, featureCode)));
        });
    });

    return (0, _lodash.sortBy)(modelTrimAddFeatureRankedIcons, function (rankedIcon) {
        return rankedIcon.get('rank');
    });
}

function resetModelTrimFromModelData(modelData) {
    return new _ModelTrimModel2.default({
        trimCode: modelData.configuration.modelTrimCode,
        trimsBitField: modelData.configuration.modelTrim.trimsBitField,
        trimsBitFields: modelData.configuration.modelTrim.trimsBitFields,
        selectionCode: modelData.configuration.modelTrim.code,
        enabled: true,
        visible: true,
        selected: false,
        userSelected: false,
        code: modelData.configuration.modelTrim.code,
        description: modelData.configuration.modelTrim.description,
        trimExtensionCode: modelData.configuration.modelTrim.extensionCode,
        trimExtensionDescription: modelData.configuration.modelTrim.extensionDescription,
        rank: modelData.configuration.modelTrimRank,
        configurationIds: {},
        features: modelData.configuration.modelTrimFeatures,
        featureIcons: getModelTrimFeatureIcons(modelData.configuration.featureIcons),
        comparisonModelTrimCode: '',
        comparisonModelTrim: '',
        comparisonModelTrimExtension: '',
        comparisonAddFeatures: {},
        comparisonRemoveFeatures: {},
        comparisonAddFeatureIcons: {}
    });
}

function resetModelTrimFromOriginData(dataOrigin, originModelTrimData) {
    if ((0, _lodash.isEmpty)(originModelTrimData) || !(0, _lodash.isObjectLike)(originModelTrimData)) {
        return new _ModelTrimModel2.default();
    }

    switch (dataOrigin) {
        case DataOrigins.MODELS_COLLECTION:
            return new _ModelTrimModel2.default();

        case DataOrigins.MODEL_YEAR_POWERS_TRIMS:
            return resetModelTrimFromModelData(originModelTrimData);

        default:
            return new _ModelTrimModel2.default();
    }
}

function addModelTrimConfigurationId(modelTrim, configurationId, configuration) {
    var _mergeModelTrimsBitFi = (0, _DataUtilitiesService.mergeModelTrimsBitField)(modelTrim, configuration, true),
        trimsBitField = _mergeModelTrimsBitFi.trimsBitField,
        trimsBitFields = _mergeModelTrimsBitFi.trimsBitFields;

    var configurationIds = modelTrim.get('configurationIds');
    configurationIds[configurationId] = configuration.trimsBitField;

    return modelTrim.set('trimsBitField', trimsBitField).set('trimsBitFields', trimsBitFields).set('configurationIds', configurationIds);
}

function resetModelTrimComparisonFeatures(prevTrimID, prevTrim, prevTrimExtension, prevTrimFeatures, modelTrim) {
    var compareModelTrim = modelTrim;

    var comparisonAddFeatures = {};
    var comparisonAddFeatureIcons = {};
    var comparisonRemoveFeatures = {};

    (0, _lodash.forEach)(modelTrim.features, function (feature, key) {
        comparisonAddFeatures[key] = feature;
        if (!(0, _lodash.isEmpty)(modelTrim.featureIcons) && !(0, _lodash.isUndefined)(modelTrim.featureIcons[key])) {
            comparisonAddFeatureIcons[key] = modelTrim.featureIcons[key];
        }
    });

    if (!(0, _lodash.isEmpty)(prevTrimFeatures)) {
        compareModelTrim = compareModelTrim.set('comparisonModelTrimCode', prevTrimID).set('comparisonModelTrim', prevTrim).set('comparisonModelTrimExtension', prevTrimExtension);

        (0, _lodash.forEach)(prevTrimFeatures, function (prevTrimFeature, prevTrimKey) {
            if (!(0, _lodash.isEmpty)(comparisonAddFeatures[prevTrimKey])) {
                delete comparisonAddFeatures[prevTrimKey];
                if (!(0, _lodash.isEmpty)(compareModelTrim.featureIcons) && !(0, _lodash.isUndefined)(compareModelTrim.featureIcons[prevTrimKey])) {
                    delete comparisonAddFeatureIcons[prevTrimKey];
                }
            } else {
                comparisonRemoveFeatures[prevTrimKey] = prevTrimFeature;
            }
        });

        (0, _lodash.forEach)(comparisonAddFeatures, function (comparisonFeature, comparisonFeatureKey) {
            if (!(0, _lodash.isEmpty)(prevTrimFeatures[comparisonFeatureKey])) {
                delete comparisonAddFeatures[comparisonFeatureKey];
            }
        });
    }

    return compareModelTrim.set('comparisonAddFeatures', comparisonAddFeatures).set('comparisonAddFeatureIcons', (0, _immutable.List)(getModelTrimAddFeatureRankedIcons(modelTrim.features, modelTrim.modelTrimFeatures, comparisonAddFeatures))).set('comparisonRemoveFeatures', comparisonRemoveFeatures);
}

exports.default = {
    getModelTrimFeatureIcons: getModelTrimFeatureIcons,
    getModelTrimAddFeatureRankedIcons: getModelTrimAddFeatureRankedIcons,
    resetModelTrimFromModelData: resetModelTrimFromModelData,
    resetModelTrimFromOriginData: resetModelTrimFromOriginData,
    addModelTrimConfigurationId: addModelTrimConfigurationId,
    resetModelTrimComparisonFeatures: resetModelTrimComparisonFeatures
};

/***/ }),

/***/ "./src/ModelYear/services/ModelYearAPIService/ModelYearAPIService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ModelYearAPIService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__("lodash");

var _immutable = __webpack_require__("immutable");

var _axios = __webpack_require__("../../node_modules/axios/index.js");

var _axios2 = _interopRequireDefault(_axios);

var _index = __webpack_require__("./src/config/index.js");

var _index2 = _interopRequireDefault(_index);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _dataOrigins = __webpack_require__("./src/constants/dataOrigins.js");

var DataOrigins = _interopRequireWildcard(_dataOrigins);

var _ModelYearService = __webpack_require__("./src/ModelYear/services/ModelYearService/ModelYearService.js");

var _TradeInVehicleService = __webpack_require__("./src/Vehicle/services/TradeInVehicleService/TradeInVehicleService.js");

var _ShowroomAPIService = __webpack_require__("./src/services/ShowroomService/ShowroomAPIService.js");

var _ShowroomAPIService2 = _interopRequireDefault(_ShowroomAPIService);

var _TradeInVehicleAPIService = __webpack_require__("./src/Vehicle/services/TradeInVehicleAPIService/TradeInVehicleAPIService.js");

var _TradeInVehicleAPIService2 = _interopRequireDefault(_TradeInVehicleAPIService);

var _DisclaimerAPIService = __webpack_require__("./src/PurchaseMethods/services/PurchaseMethodsAPIService/DisclaimerAPIService.js");

var _DisclaimerAPIService2 = _interopRequireDefault(_DisclaimerAPIService);

var _ModelYearModel = __webpack_require__("./src/ModelYear/models/ModelYearModel.js");

var _ModelYearModel2 = _interopRequireDefault(_ModelYearModel);

var _PurchaseMethodsModel = __webpack_require__("./src/PurchaseMethods/models/PurchaseMethodsModel.js");

var _PurchaseMethodsModel2 = _interopRequireDefault(_PurchaseMethodsModel);

var _TradeInVehicleModel = __webpack_require__("./src/Vehicle/models/TradeInVehicleModel.js");

var _TradeInVehicleModel2 = _interopRequireDefault(_TradeInVehicleModel);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Util to merge Model Years API calls responses into a new models object and return the new merged object
 * @param {Object[]} results API response data array
 * @param {Boolean} requestTradeInVehicleLoad
 * @param {String} language
 */
function mergeLoadBuildAndQuoteModelYearsDataResults(results, requestTradeInVehicleLoad, language, disclaimers) {
    if ((0, _lodash.isEmpty)(results)) {
        return {
            years: (0, _immutable.List)([]),
            tradeInVehicle: new _TradeInVehicleModel2.default()
        };
    }
    var modelYearsData = results[0].data.view;
    var modelYearsConverted = (0, _ModelYearService.resetModelYearFromOriginData)(DataOrigins.MODEL_YEARS, modelYearsData, (0, _lodash.isEmpty)(language) ? 'en' : language, disclaimers);

    var tradeInVehicle = requestTradeInVehicleLoad && !(0, _lodash.isEmpty)(results[1]) ? (0, _TradeInVehicleService.resetTradeInVehicleFromShowroomTradeInVehicle)(results[1].data) : new _TradeInVehicleModel2.default();

    return {
        years: modelYearsConverted.years,
        tradeInVehicle: tradeInVehicle
    };
}

/**
 * Util to merge Model Year API calls responses into a new models object and return the new merged object
 * @param {Object[]} results API response data array
 * @param {Boolean} requestTradeInVehicleLoad
 * @param {String} language
 */
function mergeLoadBuildAndQuoteModelYearDataResults(results, requestTradeInVehicleLoad, language, disclaimers) {
    if ((0, _lodash.isEmpty)(results)) {
        return {
            modelYear: new _ModelYearModel2.default(),
            purchaseMethods: new _PurchaseMethodsModel2.default(),
            tradeInVehicle: new _TradeInVehicleModel2.default()
        };
    }
    var modelYearData = results[0].data.view;
    var modelYearConverted = (0, _ModelYearService.resetModelYearFromOriginData)(DataOrigins.MODEL_YEAR_POWERS_TRIMS, modelYearData, (0, _lodash.isEmpty)(language) ? 'en' : language, disclaimers);

    var tradeInVehicle = requestTradeInVehicleLoad && !(0, _lodash.isEmpty)(results[1]) ? (0, _TradeInVehicleService.resetTradeInVehicleFromShowroomTradeInVehicle)(results[1].data) : new _TradeInVehicleModel2.default();

    return _extends({}, modelYearConverted, {
        tradeInVehicle: tradeInVehicle
    });
}

/**
 * Groups Make Model Year api calls to ShowroomAPI
 */

var ModelYearAPIService = function () {
    function ModelYearAPIService() {
        _classCallCheck(this, ModelYearAPIService);

        /**
         * The base path for Make Model Year ShowroomAPI
         * @type {string}
         */
        this.basePathModelYear = _index2.default.endpoint.showroom + '/service/v1/view/2.1';

        /**
         * The base path for Make Model Years ShowroomAPI
         * @type {string}
         */
        this.basePathModelYears = _index2.default.endpoint.showroom + '/service/v1/view/1.1';
    }

    /**
     * Returns the axios request configuration object to load a Make Model Year Model for a given model year
     * @param {string} publicToken
     * @param {int} year
     * @param {string} make
     * @param {string} model
     * @param {string} bodyStyleCode
     */


    _createClass(ModelYearAPIService, [{
        key: 'getLoadModelYearRequestConfig',
        value: function getLoadModelYearRequestConfig(publicToken, year, make, model, bodyStyleCode) {
            var orgId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
            var orgUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
            var location = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitLocation();
            var language = _widgetCommonsCoreServices.LocaleService.getLocale();

            var requestConfig = {
                url: this.basePathModelYear,
                method: 'get'
            };

            requestConfig.headers = {
                'x-jwt': (0, _lodash.isString)(publicToken) ? publicToken : ''
            };

            requestConfig.params = {
                context: ((0, _lodash.isNull)(orgId) ? '' : orgId) + '.' + ((0, _lodash.isNull)(orgUnitId) ? '' : orgUnitId),
                location: (0, _lodash.isEmpty)(location) ? '' : location,
                language: (0, _lodash.isEmpty)(language) ? '' : language,
                year: (0, _lodash.isFinite)(year) ? year : 0,
                make: (0, _lodash.toUpper)((0, _lodash.isString)(make) ? make : ''),
                model: (0, _lodash.isString)(model) ? model : '',
                bodyStyleCode: (0, _lodash.toUpper)((0, _lodash.isString)(bodyStyleCode) ? bodyStyleCode : ''),
                datalevel: 256,
                unfiltered: true
            };

            return requestConfig;
        }

        /**
         * Returns the axios request configuration object to load a Make Model Year Model for all years of a given model
         * @param {string} publicToken
         * @param {string} make
         * @param {string} model
         * @param {string} bodyStyleCode
         */

    }, {
        key: 'getLoadModelYearsRequestConfig',
        value: function getLoadModelYearsRequestConfig(publicToken, make, model, bodyStyleCode) {
            var orgId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
            var orgUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
            var location = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitLocation();
            var language = _widgetCommonsCoreServices.LocaleService.getLocale();

            var requestConfig = {
                url: this.basePathModelYears,
                method: 'get'
            };

            requestConfig.headers = {
                'x-jwt': (0, _lodash.isString)(publicToken) ? publicToken : ''
            };

            requestConfig.params = {
                context: ((0, _lodash.isNull)(orgId) ? '' : orgId) + '.' + ((0, _lodash.isNull)(orgUnitId) ? '' : orgUnitId),
                location: (0, _lodash.isEmpty)(location) ? '' : location,
                language: (0, _lodash.isEmpty)(language) ? '' : language,
                make: (0, _lodash.toUpper)((0, _lodash.isString)(make) ? make : ''),
                model: (0, _lodash.isString)(model) ? model : '',
                bodyStyleCode: (0, _lodash.toUpper)((0, _lodash.isString)(bodyStyleCode) ? bodyStyleCode : ''),
                subGrouping: 'year',
                datalevel: 768
            };

            return requestConfig;
        }

        /**
         * Returns a Model Years Models Object from model and trade in parameters
         * @param {Object} modelYearsParams
         * @param {Object} tradeInVehicleParams
         */

    }, {
        key: 'loadModelYears',
        value: function loadModelYears(modelYearsParams, tradeInVehicleParams) {
            var _this = this;

            if (!(0, _lodash.isObjectLike)(modelYearsParams) || (0, _lodash.isEmpty)(modelYearsParams.make) || (0, _lodash.isEmpty)(modelYearsParams.model) || (0, _lodash.isEmpty)(modelYearsParams.bodyStyleCode)) {
                return Promise.reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('missing or invalid parameters'));
            }

            var token = _widgetCommonsGeneral.CookieService.getToken(_widgetCommonsGeneral.COOKIES.ACCOUNT.AUTHENTICATE_TOKEN);
            var requireTradeInVehicleLoad = ((0, _lodash.isEmpty)(tradeInVehicleParams) || (0, _lodash.isEmpty)(tradeInVehicleParams.tradeInVehicleId)) && !(0, _lodash.isEmpty)(token);
            var language = _widgetCommonsCoreServices.LocaleService.getLocale();

            return _ShowroomAPIService2.default.getPublicToken().then(function (publicToken) {
                return _DisclaimerAPIService2.default.getGenericDisclaimers().then(function (disclaimers) {
                    var promises = [];
                    var make = modelYearsParams.make,
                        model = modelYearsParams.model,
                        bodyStyleCode = modelYearsParams.bodyStyleCode;

                    var modelYearsRequestConfig = _this.getLoadModelYearsRequestConfig(publicToken.data, make, model, bodyStyleCode);
                    promises.push(_axios2.default.request(modelYearsRequestConfig));

                    if (requireTradeInVehicleLoad) {
                        var tradeInVehicleId = !(0, _lodash.isEmpty)(tradeInVehicleParams) ? tradeInVehicleParams.tradeInVehicleId : '';
                        var tradeInVehicleRequestConfig = _TradeInVehicleAPIService2.default.getLoadTradeInVehicleRequestConfig(tradeInVehicleId);
                        promises.push(_axios2.default.request(tradeInVehicleRequestConfig));
                    }

                    return _axios2.default.all(promises).then(function (results) {
                        return mergeLoadBuildAndQuoteModelYearsDataResults(results, requireTradeInVehicleLoad, language, disclaimers);
                    }).catch(function () {
                        console.error('Unable to load Model Years Data for ' + make + ' ' + model + ' ' + bodyStyleCode);
                        return Promise.reject();
                    });
                });
            });
        }

        /**
         * Returns a Model Year Models Object from model and trade in parameters
         * @param {Object} modelYearParams
         * @param {Object} tradeInVehicleParams
         */

    }, {
        key: 'loadModelYear',
        value: function loadModelYear(modelYearParams, tradeInVehicleParams) {
            var _this2 = this;

            if (!(0, _lodash.isObjectLike)(modelYearParams) || !(0, _lodash.isFinite)(modelYearParams.year) || (0, _lodash.isEmpty)(modelYearParams.make) || (0, _lodash.isEmpty)(modelYearParams.model) || (0, _lodash.isEmpty)(modelYearParams.bodyStyleCode)) {
                return Promise.reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('missing or invalid parameters'));
            }

            var token = _widgetCommonsGeneral.CookieService.getToken(_widgetCommonsGeneral.COOKIES.ACCOUNT.AUTHENTICATE_TOKEN);
            var requireTradeInVehicleLoad = ((0, _lodash.isEmpty)(tradeInVehicleParams) || (0, _lodash.isEmpty)(tradeInVehicleParams.tradeInVehicleId)) && !(0, _lodash.isEmpty)(token);
            var language = _widgetCommonsCoreServices.LocaleService.getLocale();

            return _ShowroomAPIService2.default.getPublicToken().then(function (publicToken) {
                return _DisclaimerAPIService2.default.getGenericDisclaimers().then(function (disclaimers) {
                    var promises = [];
                    var year = modelYearParams.year,
                        make = modelYearParams.make,
                        model = modelYearParams.model,
                        bodyStyleCode = modelYearParams.bodyStyleCode;

                    var modelYearsRequestConfig = _this2.getLoadModelYearRequestConfig(publicToken.data, year, make, model, bodyStyleCode);
                    promises.push(_axios2.default.request(modelYearsRequestConfig));

                    if (requireTradeInVehicleLoad) {
                        var tradeInVehicleId = !(0, _lodash.isEmpty)(tradeInVehicleParams) ? tradeInVehicleParams.tradeInVehicleId : '';
                        var tradeInVehicleRequestConfig = _TradeInVehicleAPIService2.default.getLoadTradeInVehicleRequestConfig(tradeInVehicleId);
                        promises.push(_axios2.default.request(tradeInVehicleRequestConfig));
                    }

                    return _axios2.default.all(promises).then(function (results) {
                        return mergeLoadBuildAndQuoteModelYearDataResults(results, requireTradeInVehicleLoad, language, disclaimers);
                    }).catch(function () {
                        console.error('Unable to load Model Year Data for ' + year + ' ' + make + ' ' + model + ' ' + bodyStyleCode);
                        return Promise.reject();
                    });
                });
            });
        }
    }]);

    return ModelYearAPIService;
}();

exports.ModelYearAPIService = ModelYearAPIService;
exports.default = new ModelYearAPIService();

/***/ }),

/***/ "./src/ModelYear/services/ModelYearService/ModelYearService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetModelYearFromOriginData = resetModelYearFromOriginData;
exports.setSelectedDrivePowerTrain = setSelectedDrivePowerTrain;
exports.setSelectedModelTrim = setSelectedModelTrim;
exports.setSelectedBoxSize = setSelectedBoxSize;
exports.setSelectedCabSize = setSelectedCabSize;
exports.setSelectedOptionsPackage = setSelectedOptionsPackage;
exports.setSelectedExteriorColour = setSelectedExteriorColour;
exports.setSelectedInteriorColour = setSelectedInteriorColour;
exports.resetModelYears = resetModelYears;
exports.resetModelYear = resetModelYear;
exports.resetConfigurationToken = resetConfigurationToken;
exports.resetOptionsAvailability = resetOptionsAvailability;
exports.resetOptionsSelectionResolutions = resetOptionsSelectionResolutions;
exports.setAvailableOptions = setAvailableOptions;
exports.setSelectedOptions = setSelectedOptions;
exports.resetPaymentsAndPurchaseAmounts = resetPaymentsAndPurchaseAmounts;
exports.selectPurchaseMethod = selectPurchaseMethod;
exports.selectPaymentFrequency = selectPaymentFrequency;
exports.selectTerm = selectTerm;
exports.selectKMPlan = selectKMPlan;
exports.setCashDown = setCashDown;
exports.setTradeIn = setTradeIn;
exports.setLien = setLien;
exports.setExteriorColourAmounts = setExteriorColourAmounts;
exports.setInteriorColourAmounts = setInteriorColourAmounts;
exports.setOptionsAmounts = setOptionsAmounts;
exports.setTaxesIncluded = setTaxesIncluded;
exports.resetModelYearFromQuote = resetModelYearFromQuote;
exports.resetModelYearOptionsFromQuote = resetModelYearOptionsFromQuote;
exports.setSelectedModelYear = setSelectedModelYear;
exports.resetEmployeeRebateAdjustment = resetEmployeeRebateAdjustment;
exports.resetPercentageRebateAdjustment = resetPercentageRebateAdjustment;

var _lodash = __webpack_require__("lodash");

var _immutable = __webpack_require__("immutable");

var _dataOrigins = __webpack_require__("./src/constants/dataOrigins.js");

var DataOrigins = _interopRequireWildcard(_dataOrigins);

var _apiDataConversionConstants = __webpack_require__("./src/constants/apiDataConversionConstants.js");

var Constants = _interopRequireWildcard(_apiDataConversionConstants);

var _dataTypes = __webpack_require__("./src/constants/dataTypes.js");

var dataTypes = _interopRequireWildcard(_dataTypes);

var _purchaseMethods = __webpack_require__("./src/PurchaseMethods/constants/purchaseMethods.js");

var PurchaseMethodsConstants = _interopRequireWildcard(_purchaseMethods);

var _exteriorColourStatuses = __webpack_require__("./src/ModelYear/constants/exteriorColourStatuses.js");

var _dataConversions = __webpack_require__("./src/PurchaseMethods/constants/dataConversions.js");

var _modelTrimItemCategories = __webpack_require__("./src/Quote/constants/modelTrimItemCategories.js");

var _ModelYearModel = __webpack_require__("./src/ModelYear/models/ModelYearModel.js");

var _ModelYearModel2 = _interopRequireDefault(_ModelYearModel);

var _DataUtilitiesService = __webpack_require__("./src/ModelYear/services/DataUtilitiesService/DataUtilitiesService.js");

var UtilitiesService = _interopRequireWildcard(_DataUtilitiesService);

var _ModelTrimConfigurationService = __webpack_require__("./src/ModelYear/services/ModelTrimConfigurationService/ModelTrimConfigurationService.js");

var _PurchaseMethodsService = __webpack_require__("./src/PurchaseMethods/services/PurchaseMethodsService/PurchaseMethodsService.js");

var _QuoteItemCategoryService = __webpack_require__("./src/Quote/services/QuoteItemCategoryService/QuoteItemCategoryService.js");

var _ModelTrimItemsService = __webpack_require__("./src/ModelYear/services/ModelTrimItemsService/ModelTrimItemsService.js");

var ModelTrimItemsService = _interopRequireWildcard(_ModelTrimItemsService);

var _CabSizeService = __webpack_require__("./src/ModelYear/services/CabSizeService/CabSizeService.js");

var _BoxSizeService = __webpack_require__("./src/ModelYear/services/BoxSizeService/BoxSizeService.js");

var _DriveTrainService = __webpack_require__("./src/ModelYear/services/DriveTrainService/DriveTrainService.js");

var _YearService = __webpack_require__("./src/ModelYear/services/YearService/YearService.js");

var YearService = _interopRequireWildcard(_YearService);

var _ModelTrimService = __webpack_require__("./src/ModelYear/services/ModelTrimService/ModelTrimService.js");

var ModelTrimService = _interopRequireWildcard(_ModelTrimService);

var _DrivePowerTrainService = __webpack_require__("./src/ModelYear/services/DrivePowerTrainService/DrivePowerTrainService.js");

var DrivePowerTrainService = _interopRequireWildcard(_DrivePowerTrainService);

var _OptionsPackageService = __webpack_require__("./src/ModelYear/services/OptionsPackageService/OptionsPackageService.js");

var OptionsPackageService = _interopRequireWildcard(_OptionsPackageService);

var _OptionService = __webpack_require__("./src/ModelYear/services/OptionService/OptionService.js");

var OptionService = _interopRequireWildcard(_OptionService);

var _OptionsSelectionResolutionsService = __webpack_require__("./src/ModelYear/services/OptionsSelectionResolutionsService/OptionsSelectionResolutionsService.js");

var OptionsSelectionResolutionsService = _interopRequireWildcard(_OptionsSelectionResolutionsService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/* eslint no-bitwise: 0 */

function getDefaultModelTrimConfiguration() {
    return {
        year: 0,
        make: '',
        model: '',
        bodyStyleCode: '',
        bodyStyle: '',
        cabSize: {},
        driveTrain: {},
        boxSize: {},
        modelTrim: {},
        configurationId: 0,
        configuration: {},
        exteriorColourStatus: _exteriorColourStatuses.IMAGE_STATUS.NO_IMAGE,
        package: {
            code: '',
            selectionCode: '',
            description: ''
        },
        engine: {
            code: '',
            selectionCode: '',
            fuelTypeCode: '',
            cylinders: 0,
            displacement: 0.0,
            isTurbo: false,
            hp: 0,
            hpRpm: 0,
            torque: 0,
            torqueRpm: 0,
            description: ''
        },
        transmission: {
            code: '',
            selectionCode: '',
            typeCode: '',
            rank: 99,
            label: '',
            type: '',
            speeds: 0,
            isCVT: false,
            description: ''
        },
        priceIds: {
            modelTrimCode: '',
            configurationId: 0
        },
        leaseIds: {
            modelTrimCode: '',
            configurationId: 0
        },
        financeIds: {
            modelTrimCode: '',
            configurationId: 0
        }
    };
}

function setModelTrimFeatures(modelTrimConfigurations, modelTrimFeatures) {
    var newModelTrimFeatures = modelTrimFeatures;

    (0, _lodash.forEach)(modelTrimConfigurations.modelTrimFeatures, function (modelTrimFeature, key) {
        if ((0, _lodash.isEmpty)(modelTrimFeatures[key])) {
            newModelTrimFeatures[key] = {
                trimsBitField: modelTrimConfigurations.trimsBitField,
                feature: modelTrimFeature
            };
        } else {
            var modelTrimTrimsBitField = newModelTrimFeatures[key].trimsBitField;
            newModelTrimFeatures[key].trimsBitField = modelTrimTrimsBitField | modelTrimConfigurations.trimsBitField;
        }
    });
}

function getModelTrimsConfigurationsFromModelData(modelData, modelTrimsData, modelOptions) {
    var configurations = [];

    if ((0, _lodash.isEmpty)(modelTrimsData) || (0, _lodash.isEmpty)(modelTrimsData[Constants.VIEW_2_1.VEHICLE.MODEL_YEAR.TRIMS])) {
        return configurations;
    }

    var cabSizes = [];
    (0, _lodash.forEach)(modelTrimsData[Constants.VIEW_2_1.VEHICLE.MODEL_YEAR.CABS], function (modelCabSize) {
        cabSizes.push((0, _CabSizeService.resetCabSizeFromOriginData)(DataOrigins.MODEL_YEAR_POWERS_TRIMS, modelCabSize));
    });

    var boxSizes = [];
    (0, _lodash.forEach)(modelTrimsData[Constants.VIEW_2_1.VEHICLE.MODEL_YEAR.BOXES], function (modelBoxSize) {
        boxSizes.push((0, _BoxSizeService.resetBoxSizeFromOriginData)(DataOrigins.MODEL_YEAR_POWERS_TRIMS, modelBoxSize));
    });

    var driveTrains = [];
    (0, _lodash.forEach)(modelTrimsData[Constants.VIEW_2_1.VEHICLE.MODEL_YEAR.DRIVES], function (modelDriveTrain) {
        driveTrains.push((0, _DriveTrainService.resetDriveTrainFromOriginData)(DataOrigins.MODEL_YEAR_POWERS_TRIMS, modelDriveTrain));
    });

    (0, _lodash.forEach)(modelTrimsData[Constants.VIEW_2_1.VEHICLE.MODEL_YEAR.TRIMS], function (trim) {
        var trimDescription = UtilitiesService.getDescriptionData(trim[Constants.VIEW_2_1.VEHICLE.TRIM.DESCRIPTION]);
        var trimExtensionCode = UtilitiesService.getDescriptionData(trim[Constants.VIEW_2_1.VEHICLE.TRIM.EXTENSION_CODE]);
        var trimSelectionCode = trimDescription + '|' + trimExtensionCode;

        var modelTrim = UtilitiesService.getSelectionObject(trim[Constants.VIEW_2_1.VEHICLE.TRIM.BIT_FIELD], trimSelectionCode, trimSelectionCode, trim[Constants.VIEW_2_1.VEHICLE.TRIM.DESCRIPTION]);

        modelTrim.extensionCode = UtilitiesService.getDescriptionData(trim[Constants.VIEW_2_1.VEHICLE.TRIM.EXTENSION_CODE]);
        modelTrim.extensionDescription = UtilitiesService.getDescriptionData(trim[Constants.VIEW_2_1.VEHICLE.TRIM.EXTENSION_DESCRIPTION]);

        modelTrim.hasOptions = trim[Constants.VIEW_2_1.VEHICLE.TRIM.HAS_OPTIONS];

        var modelTrimFeatures = {};
        var allConfigTrimsBitField = 0;
        if (!(0, _lodash.isEmpty)(trim[Constants.VIEW_2_1.VEHICLE.TRIM.CONFIGURATIONS])) {
            var modelTrimConfigs = [];
            (0, _lodash.forEach)(trim[Constants.VIEW_2_1.VEHICLE.TRIM.CONFIGURATIONS], function (modelTrimConfiguration) {
                if (modelTrimConfiguration.length === _dataConversions.MODEL_TAXES.TAXES_FACTOR - 1) {
                    modelTrimConfiguration.push(_exteriorColourStatuses.IMAGE_STATUS.NO_IMAGE);
                }
                modelTrimConfiguration.push(modelData.taxesFactor);
                modelTrimConfiguration.push(modelData.taxCodes);

                var conf = (0, _ModelTrimConfigurationService.resetModelTrimConfigurationFromModelData)(modelTrimConfiguration, modelOptions, modelTrim, driveTrains, cabSizes, boxSizes);
                setModelTrimFeatures(conf, modelTrimFeatures);
                var tempTrimsBitField = allConfigTrimsBitField;
                allConfigTrimsBitField = tempTrimsBitField | conf.trimsBitField;

                modelTrimConfigs.push(conf);
                configurations.push(conf);
            });

            // TODO pas utilisé, mais je dois valider qu'il ne le sera jamais avant de l'enlever
            // setModelTrimConfigurationFeatures(modelTrimConfigs,
            //    modelTrimFeatures,
            //    modelColors,
            //    modelInteriorTrims,
            //    allConfigTrimsBitField
            // );
        }
    });

    return configurations;
}

function getModelTrimsFromModelData(dataOrigin, modelTrimsData) {
    var vehicle = {
        year: 0,
        make: '',
        model: '',
        bodyStyleCode: '',
        bodyStyle: '',
        vehicles: []
    };

    switch (dataOrigin) {
        case DataOrigins.MODEL_YEAR_POWERS_TRIMS:
            {
                vehicle.make = modelTrimsData.make;
                vehicle.model = modelTrimsData.model;
                vehicle.bodyStyleCode = modelTrimsData.bodyStyleCode;
                vehicle.bodyStyle = modelTrimsData.bodyStyle[Constants.DESCRIPTION_LANGUAGE_INDEX];

                vehicle.year = modelTrimsData.years[0][Constants.VIEW_2_1.VEHICLE.MODEL_YEAR.YEAR];

                var modelOptions = ModelTrimItemsService.getModelYearFeaturesAndOptions(modelTrimsData.years[0]);
                var modelColors = {};
                var modelInteriorTrims = {};

                var modelTrimsConfigurations = getModelTrimsConfigurationsFromModelData(modelTrimsData, modelTrimsData.years[0], modelOptions, modelColors, modelInteriorTrims);

                vehicle.vehicles = (0, _lodash.map)(modelTrimsConfigurations, function (modelTrimConfiguration) {
                    var configurationVehicle = getDefaultModelTrimConfiguration();
                    configurationVehicle.year = vehicle.year;
                    configurationVehicle.make = vehicle.make;
                    configurationVehicle.model = vehicle.model;
                    configurationVehicle.bodyStyleCode = vehicle.bodyStyleCode;
                    configurationVehicle.bodyStyle = vehicle.bodyStyleCode;

                    configurationVehicle.cabSize = modelTrimConfiguration.cabSize;
                    configurationVehicle.boxSize = modelTrimConfiguration.boxSize;
                    configurationVehicle.driveTrain = modelTrimConfiguration.driveTrain;

                    configurationVehicle.modelTrimCode = modelTrimConfiguration.modelTrimCode;
                    configurationVehicle.modelTrim = modelTrimConfiguration.modelTrim;

                    configurationVehicle.configurationId = modelTrimConfiguration.id;
                    configurationVehicle.configuration = modelTrimConfiguration;
                    configurationVehicle.package = modelTrimConfiguration.package;
                    configurationVehicle.engine = modelTrimConfiguration.engine;
                    configurationVehicle.transmission = modelTrimConfiguration.transmission;

                    return {
                        vehicle: configurationVehicle,
                        purchaseMethods: modelTrimConfiguration.purchaseMethods
                    };
                });
                break;
            }
        default:
            break;
    }

    return vehicle;
}

function getModelTrimFromModelData(dataOrigin, modelTrimData) {
    var modelTrim = getDefaultModelTrimConfiguration();

    switch (dataOrigin) {
        case DataOrigins.MODELS_COLLECTION:
            modelTrim.make = modelTrimData.make;
            modelTrim.model = modelTrimData.model;
            modelTrim.bodyStyleCode = modelTrimData.bodyStyleCode;
            modelTrim.bodyStyle = modelTrimData.bodyStyle[Constants.DESCRIPTION_LANGUAGE_INDEX];

            if (modelTrimData[Constants.VIEW_1.VEHICLE.HIGH_PRICE]) {
                var highPriceObject = modelTrimData[Constants.VIEW_1.VEHICLE.HIGH_PRICE][Constants.VIEW_1.VEHICLE.HIGH_PRICE_INDEX];
                modelTrim.exteriorColours = {
                    photo1: highPriceObject[Constants.VIEW_1.VEHICLE.URL_EXTERIOR_COLOUR][Constants.VIEW_1.COLOUR_IMAGE.PHOTO_1],
                    photo2: highPriceObject[Constants.VIEW_1.VEHICLE.URL_EXTERIOR_COLOUR][Constants.VIEW_1.COLOUR_IMAGE.PHOTO_2],
                    photo3: highPriceObject[Constants.VIEW_1.VEHICLE.URL_EXTERIOR_COLOUR][Constants.VIEW_1.COLOUR_IMAGE.PHOTO_3]
                };

                if (!(0, _lodash.isUndefined)(highPriceObject[Constants.VIEW_1.VEHICLE.EXTERIOR_COLOUR_STATUS])) {
                    modelTrim.exteriorColourStatus = highPriceObject[Constants.VIEW_1.VEHICLE.EXTERIOR_COLOUR_STATUS];
                } else if (modelTrim.exteriorColours.photo1) {
                    modelTrim.exteriorColourStatus = _exteriorColourStatuses.IMAGE_STATUS.FULL_COLORIZED;
                }
            }

            if (modelTrimData[Constants.VIEW_1.VEHICLE.REBATE]) {
                var rebateObject = modelTrimData[Constants.VIEW_1.VEHICLE.REBATE][Constants.VIEW_1.VEHICLE.REBATE_INDEX];
                modelTrim.rebate = rebateObject[Constants.VIEW_1.VEHICLE.REBATE_RETAIL];
            }

            if (modelTrimData[Constants.VIEW_1.VEHICLE.HIGH_REBATE]) {
                var highRebateObject = modelTrimData[Constants.VIEW_1.VEHICLE.HIGH_REBATE][Constants.VIEW_1.VEHICLE.HIGH_REBATE_INDEX];
                var highRebateTaxes = highRebateObject[Constants.VIEW_1.VEHICLE.HIGH_REBATE_REBATES_TAXES] || 0;
                modelTrim.highRebate = highRebateObject[Constants.VIEW_1.VEHICLE.HIGH_REBATE_RETAIL] + highRebateTaxes;
                modelTrim.highRebatePurchaseMethod = highRebateObject[Constants.VIEW_1.VEHICLE.HIGH_REBATE_PURCHASE_METHOD];
            }

            if (modelTrimData[Constants.VIEW_1.VEHICLE.PRICE]) {
                var priceObject = modelTrimData[Constants.VIEW_1.VEHICLE.PRICE][Constants.VIEW_1.VEHICLE.PRICE_INDEX];
                if (priceObject[Constants.VIEW_1.VEHICLE.PRICE_DISCLAIMER]) {
                    modelTrim.priceModelDisclaimer = priceObject[Constants.VIEW_1.VEHICLE.PRICE_DISCLAIMER][Constants.VIEW_1.PRICE_DISCLAIMER.MODEL_SHORT];
                    modelTrim.priceExclusionsDisclaimer = priceObject[Constants.VIEW_1.VEHICLE.PRICE_DISCLAIMER][Constants.VIEW_1.PRICE_DISCLAIMER.EXCLUSIONS];
                }

                if (priceObject[Constants.VIEW_1.VEHICLE.PRICE_MODEL_TRIM_CODE] && priceObject[Constants.VIEW_1.VEHICLE.PRICE_MODEL_TRIM_CODE]) {
                    modelTrim.priceIds.year = priceObject[Constants.VIEW_1.VEHICLE.PRICE_YEAR];
                    modelTrim.priceIds.modelTrimCode = priceObject[Constants.VIEW_1.VEHICLE.PRICE_MODEL_TRIM_CODE];
                    modelTrim.priceIds.configurationId = priceObject[Constants.VIEW_1.VEHICLE.PRICE_CONFIGURATION_ID];
                }
            }

            modelTrim.leaseModelDisclaimer = '';
            if (modelTrimData[Constants.VIEW_1.VEHICLE.LEASE]) {
                var leaseObject = modelTrimData[Constants.VIEW_1.VEHICLE.LEASE][Constants.VIEW_1.VEHICLE.LEASE_INDEX];
                if (leaseObject[Constants.VIEW_1.VEHICLE.LEASE_DISCLAIMER]) {
                    modelTrim.leaseModelDisclaimer = leaseObject[Constants.VIEW_1.VEHICLE.LEASE_DISCLAIMER][Constants.VIEW_1.FINANCE_DISCLAIMER.MODEL_SHORT];
                }

                if (leaseObject[Constants.VIEW_1.VEHICLE.LEASE_MODEL_TRIM_CODE] && leaseObject[Constants.VIEW_1.VEHICLE.LEASE_CONFIGURATION_ID]) {
                    modelTrim.leaseIds.year = leaseObject[Constants.VIEW_1.VEHICLE.LEASE_YEAR];
                    modelTrim.leaseIds.modelTrimCode = leaseObject[Constants.VIEW_1.VEHICLE.LEASE_MODEL_TRIM_CODE];
                    modelTrim.leaseIds.configurationId = leaseObject[Constants.VIEW_1.VEHICLE.LEASE_CONFIGURATION_ID];
                }
            }

            modelTrim.financeModelDisclaimer = '';
            if (modelTrimData[Constants.VIEW_1.VEHICLE.FINANCE]) {
                var financeObject = modelTrimData[Constants.VIEW_1.VEHICLE.FINANCE][Constants.VIEW_1.VEHICLE.FINANCE_INDEX];
                if (financeObject[Constants.VIEW_1.VEHICLE.FINANCE_DISCLAIMER]) {
                    modelTrim.financeModelDisclaimer = financeObject[Constants.VIEW_1.VEHICLE.FINANCE_DISCLAIMER][Constants.VIEW_1.FINANCE_DISCLAIMER.MODEL_SHORT];
                }

                if (financeObject[Constants.VIEW_1.VEHICLE.FINANCE_MODEL_TRIM_CODE] && financeObject[Constants.VIEW_1.VEHICLE.FINANCE_CONFIGURATION_ID]) {
                    modelTrim.financeIds.year = financeObject[Constants.VIEW_1.VEHICLE.FINANCE_YEAR];
                    modelTrim.financeIds.modelTrimCode = financeObject[Constants.VIEW_1.VEHICLE.FINANCE_MODEL_TRIM_CODE];
                    modelTrim.financeIds.configurationId = financeObject[Constants.VIEW_1.VEHICLE.FINANCE_CONFIGURATION_ID];
                }
            }

            modelTrim.makeVisible = true;
            modelTrim.bodyStyleVisible = true;
            modelTrim.modelVisible = true;
            modelTrim.visible = true;
            break;

        default:
            break;
    }

    return modelTrim;
}

function resetModelComparisonFeatures(model) {
    var prevTrimID = '';
    var prevTrim = '';
    var prevTrimExtension = '';
    var prevTrimFeatures = {};

    return (0, _lodash.map)(model.modelTrims, function (modelTrim) {
        var newModelTrim = ModelTrimService.resetModelTrimComparisonFeatures(prevTrimID, prevTrim, prevTrimExtension, prevTrimFeatures, modelTrim);
        prevTrimID = modelTrim.selectionCode;
        prevTrim = modelTrim.description;
        prevTrimExtension = modelTrim.trimExtensionDescription;
        prevTrimFeatures = modelTrim.features;

        return newModelTrim;
    });
}

function getModelPowersAndTrimsFromModelData(modelPowersAndTrimsData, disclaimers) {
    var modelYear = {
        isSingleConfiguration: true,
        hasOptions: false,
        cabSizes: {},
        boxSizes: {},
        modelTrims: {},
        drivePowerTrains: {},
        optionsPackages: {}
    };

    if ((0, _lodash.isEmpty)(modelPowersAndTrimsData)) {
        return modelYear;
    }

    var modelTrimDrivePowerConfigurationCount = {};

    (0, _lodash.forEach)(modelPowersAndTrimsData, function (modelPowerAndTrimData) {
        var modelPowerAndTrim = modelPowerAndTrimData.vehicle;

        if (modelPowerAndTrim.configuration.modelTrim.hasOptions) {
            modelYear.hasOptions = true;
        }

        var drivePowerTrainSelectionCode = modelPowerAndTrim.driveTrain.selectionCode + '|' + (modelPowerAndTrim.engine.getSelectionCode() + '|') + ('' + modelPowerAndTrim.transmission.getSelectionCode());

        var cabSizeSelectionCode = (0, _lodash.isNull)(modelPowerAndTrim.cabSize) ? '' : modelPowerAndTrim.cabSize.selectionCode;
        var boxSizeSelectionCode = (0, _lodash.isNull)(modelPowerAndTrim.boxSize) ? '' : modelPowerAndTrim.boxSize.selectionCode;
        var modelTrimSelectionCode = modelPowerAndTrim.modelTrim.selectionCode;
        var packageSelectionCode = '' + cabSizeSelectionCode + modelPowerAndTrim.package.selectionCode + '|' + ('' + modelPowerAndTrim.configurationId);
        var modelTrimConfigurationId = modelPowerAndTrim.configuration.selectionCode;

        if (cabSizeSelectionCode && (0, _lodash.isEmpty)(modelYear.cabSizes[cabSizeSelectionCode])) {
            modelYear.cabSizes[cabSizeSelectionCode] = modelPowerAndTrim.cabSize;
        }

        if (boxSizeSelectionCode && (0, _lodash.isEmpty)(modelYear.boxSizes[boxSizeSelectionCode])) {
            modelYear.boxSizes[boxSizeSelectionCode] = modelPowerAndTrim.boxSize;
        }

        if ((0, _lodash.isEmpty)(modelYear.modelTrims[modelTrimSelectionCode])) {
            modelTrimDrivePowerConfigurationCount[modelTrimSelectionCode] = {};
            modelYear.modelTrims[modelTrimSelectionCode] = ModelTrimService.resetModelTrimFromOriginData(DataOrigins.MODEL_YEAR_POWERS_TRIMS, modelPowerAndTrim);
        } else if (modelYear.modelTrims[modelTrimSelectionCode].rank > modelPowerAndTrim.configuration.modelTrimRank) {
            modelYear.modelTrims[modelTrimSelectionCode] = modelYear.modelTrims[modelTrimSelectionCode].set('rank', modelPowerAndTrim.configuration.modelTrimRank);
        }

        if ((0, _lodash.isEmpty)(modelYear.drivePowerTrains[drivePowerTrainSelectionCode])) {
            modelYear.drivePowerTrains[drivePowerTrainSelectionCode] = DrivePowerTrainService.resetDrivePowerTrainFromOriginData(DataOrigins.MODEL_YEAR_POWERS_TRIMS, modelPowerAndTrim);
        }

        if ((0, _lodash.isUndefined)(modelTrimDrivePowerConfigurationCount[modelTrimSelectionCode][drivePowerTrainSelectionCode])) {
            modelTrimDrivePowerConfigurationCount[modelTrimSelectionCode][drivePowerTrainSelectionCode] = 0;
        } else {
            modelYear.isSingleConfiguration = false;
        }
        modelTrimDrivePowerConfigurationCount[modelTrimSelectionCode][drivePowerTrainSelectionCode] += 1;

        if ((0, _lodash.isEmpty)(modelYear.optionsPackages[packageSelectionCode])) {
            modelYear.optionsPackages[packageSelectionCode] = OptionsPackageService.resetOptionsPackageFromOriginData(DataOrigins.MODEL_YEAR_POWERS_TRIMS, modelPowerAndTrim, disclaimers);
        }

        if ((0, _lodash.isEmpty)(modelYear.drivePowerTrains[drivePowerTrainSelectionCode].configurationIds[modelTrimConfigurationId])) {
            modelYear.drivePowerTrains[drivePowerTrainSelectionCode] = DrivePowerTrainService.addDrivePowerTrainConfigurationId(modelYear.drivePowerTrains[drivePowerTrainSelectionCode], modelTrimConfigurationId, modelPowerAndTrim.configuration);
        }

        if ((0, _lodash.isEmpty)(modelYear.modelTrims[modelTrimSelectionCode].configurationIds[modelTrimConfigurationId])) {
            modelYear.modelTrims[modelTrimSelectionCode] = ModelTrimService.addModelTrimConfigurationId(modelYear.modelTrims[modelTrimSelectionCode], modelTrimConfigurationId, modelPowerAndTrim.configuration);
        }
    });

    modelYear.cabSizes = (0, _lodash.sortBy)(modelYear.cabSizes, function (cabSize) {
        return cabSize.rank;
    });

    modelYear.boxSizes = (0, _lodash.sortBy)(modelYear.boxSizes, function (boxSize) {
        return boxSize.rank;
    });

    modelYear.modelTrims = (0, _lodash.sortBy)(modelYear.modelTrims, function (modelTrim) {
        return modelTrim.rank;
    });

    modelYear.drivePowerTrains = (0, _lodash.sortBy)(modelYear.drivePowerTrains, function (drivePowerTrain) {
        return drivePowerTrain.rank;
    });

    modelYear.optionsPackages = (0, _lodash.sortBy)(modelYear.optionsPackages, function (optionsPackage) {
        return optionsPackage.rank;
    });

    modelYear.modelTrims = resetModelComparisonFeatures(modelYear);

    return modelYear;
}

function resetModelYearFromModelData(modelModelYearData, locale, disclaimers) {
    var vehicle = modelModelYearData[0].vehicle;

    var powersAndTrims = getModelPowersAndTrimsFromModelData(modelModelYearData, disclaimers);

    return new _ModelYearModel2.default({
        lang: locale,
        year: vehicle.year,
        make: vehicle.make,
        model: vehicle.model,
        bodyStyleCode: vehicle.bodyStyleCode,
        isSingleConfiguration: powersAndTrims.isSingleConfiguration,
        hasOptions: powersAndTrims.hasOptions,
        cabSizes: (0, _lodash.values)(powersAndTrims.cabSizes),
        boxSizes: (0, _lodash.values)(powersAndTrims.boxSizes),
        modelTrims: (0, _immutable.List)().concat((0, _lodash.values)(powersAndTrims.modelTrims).map(function (modelTrim) {
            return modelTrim;
        })),
        drivePowerTrains: (0, _immutable.List)().concat((0, _lodash.values)(powersAndTrims.drivePowerTrains).map(function (drivePowerTrain) {
            return drivePowerTrain;
        })),
        optionsPackages: (0, _immutable.List)().concat((0, _lodash.values)(powersAndTrims.optionsPackages).map(function (pack) {
            return pack;
        }))
    });
}

function getMergedModelTrimTrimsBitField(modelTrim) {
    var modelTrimTrimsBitField = {
        trimsBitField: modelTrim.trimsBitField,
        trimsBitFields: modelTrim.trimsBitFields
    };

    if (modelTrim.cabSizeTrimsBitField || !(0, _lodash.isEmpty)(modelTrim.cabSizeTrimsBitFields)) {
        modelTrimTrimsBitField = UtilitiesService.mergeModelTrimsBitField(modelTrimTrimsBitField, {
            trimsBitField: modelTrim.cabSizeTrimsBitField,
            trimsBitFields: modelTrim.cabSizeTrimsBitFields
        }, false);
    }
    if (modelTrim.boxSizeTrimsBitField || !(0, _lodash.isEmpty)(modelTrim.boxSizeTrimsBitFields)) {
        modelTrimTrimsBitField = UtilitiesService.mergeModelTrimsBitField(modelTrimTrimsBitField, {
            trimsBitField: modelTrim.boxSizeTrimsBitField,
            trimsBitFields: modelTrim.boxSizeTrimsBitFields
        }, false);
    }
    return modelTrimTrimsBitField;
}

function resetModelYearItemVisibility(modelYearItem, trimsBitField) {
    return modelYearItem.set('visible', UtilitiesService.intersectModelTrimsBitFieldValue(modelYearItem, trimsBitField) > 0).set('selected', false);
}

function resetModelYearOptionPackagesVisibility(modelYearOptionsPackage, trimsBitField, engineSelectionCode, transmissionSelectionCode) {
    return modelYearOptionsPackage.set('visible', UtilitiesService.intersectModelTrimsBitFieldValue(modelYearOptionsPackage, trimsBitField) > 0 && modelYearOptionsPackage.configuration.engine.selectionCode === engineSelectionCode && modelYearOptionsPackage.configuration.transmission.selectionCode === transmissionSelectionCode).set('selected', false);
}

function resetModelYearItemAvailability(modelYearItem, trimsBitField) {
    return modelYearItem.set('enabled', UtilitiesService.intersectModelTrimsBitFieldValue(modelYearItem, trimsBitField) > 0).set('selected', false);
}

function resetModelTrimsAvailabilityFromBoxSize(modelTrim, boxSizeTrimsBitField) {
    var mergedModelTrimAndCab = UtilitiesService.mergeModelTrimsBitField(modelTrim, {
        trimsBitField: modelTrim.cabSizeTrimsBitField,
        trimsBitFields: modelTrim.cabSizeTrimsBitFields
    }, false);

    return modelTrim.set('boxSizeTrimsBitField', boxSizeTrimsBitField.trimsBitField).set('boxSizeTrimsBitFields', boxSizeTrimsBitField.trimsBitFields).set('enabled', UtilitiesService.intersectModelTrimsBitFieldValue(mergedModelTrimAndCab, boxSizeTrimsBitField) > 0).set('selected', false);
}

function selectModelYearItemFromCode(modelYearItem, selectionCode) {
    return modelYearItem.set('selected', modelYearItem.selectionCode === selectionCode);
}

function resetModelYearFromOriginData(dataOrigin, originModelYearData, locale, disclaimers) {
    if ((0, _lodash.isEmpty)(originModelYearData) || !(0, _lodash.isObjectLike)(originModelYearData)) {
        return new _ModelYearModel2.default();
    }
    var vehicles = [];

    switch (dataOrigin) {
        case DataOrigins.MODELS_COLLECTION:
            vehicles = (0, _lodash.map)(originModelYearData, function (modelData) {
                var vehicle = {};
                vehicle.vehicle = getModelTrimFromModelData(dataOrigin, modelData);
                var purchaseMethods = (0, _PurchaseMethodsService.resetPurchaseMethodsFromOriginData)(dataOrigin, modelData);
                vehicle.purchaseMethods = disclaimers ? purchaseMethods.set('disclaimers', disclaimers) : purchaseMethods;

                return vehicle;
            });

            return vehicles;

        case DataOrigins.MODEL_YEARS:
            {
                var convertedVehicle = {
                    years: []
                };

                (0, _lodash.forEach)(originModelYearData, function (modelData) {
                    (0, _lodash.forEach)(modelData, function (modelYearData, key) {
                        convertedVehicle.years.push(YearService.resetYearFromOriginData(DataOrigins.MODELS_COLLECTION, modelYearData, parseInt(key, 10), disclaimers));
                    });
                });

                if (convertedVehicle.years.length > 2) {
                    convertedVehicle.years = (0, _lodash.takeRight)((0, _lodash.sortBy)(convertedVehicle.years, function (y) {
                        return y.year;
                    }), 2);
                }

                convertedVehicle.years = (0, _immutable.List)(convertedVehicle.years);
                return convertedVehicle;
            }
        case DataOrigins.MODEL_YEAR_POWERS_TRIMS:
            (0, _lodash.forEach)(originModelYearData, function (modelYearData) {
                var modelTrims = getModelTrimsFromModelData(dataOrigin, modelYearData);

                (0, _lodash.forEach)(modelTrims.vehicles, function (vehicle) {
                    vehicles.push({
                        vehicle: vehicle.vehicle,
                        purchaseMethods: vehicle.purchaseMethods
                    });
                });
            });

            return {
                modelYear: resetModelYearFromModelData(vehicles, locale, disclaimers),
                purchaseMethods: disclaimers ? vehicles[0].purchaseMethods.set('disclaimers', disclaimers) : vehicles[0].purchaseMethods
            };

        default:
            return new _ModelYearModel2.default();
    }
}

function resetSelectedExteriorColour(modelYear) {
    if (!modelYear.getSelectedOptionsPackageExteriorColour()) {
        var exteriorColor = modelYear.getSelectedOptionsPackageBestAvailableExteriorColour();
        if (!exteriorColor) {
            return modelYear;
        }
        var exteriorColourSelectionCode = exteriorColor.colourCode;
        return modelYear.set('optionsPackages', modelYear.optionsPackages.map(function (optionsPackage) {
            return OptionsPackageService.resetOptionsPackageExteriorColours(optionsPackage, exteriorColourSelectionCode);
        }));
    }

    return modelYear;
}

function resetSelectedOptionsPackage(modelYear) {
    var availableOptionsPackages = modelYear.optionsPackages.filter(function (optionsPackage) {
        return optionsPackage.visible;
    });

    if (availableOptionsPackages.size === 0) {
        return modelYear;
    }

    var optionsPackageSelectionCode = availableOptionsPackages.minBy(function (optionsPackage) {
        return optionsPackage.rank;
    }).selectionCode;
    var newModelYear = modelYear.set('optionsPackages', modelYear.optionsPackages.map(function (optionsPackage) {
        return selectModelYearItemFromCode(optionsPackage, optionsPackageSelectionCode);
    }));

    return resetSelectedExteriorColour(newModelYear);
}

function resetDrivePowerTrainWithOptionsPackage(modelYear, drivePowerTrain, drivePowerTrainSelectionCode, modelTrimTrimsBitField) {
    var drivePowerTrainTrimsBitField = UtilitiesService.mergeModelTrimsBitField(drivePowerTrain, modelTrimTrimsBitField, false);
    return selectModelYearItemFromCode(drivePowerTrain, drivePowerTrainSelectionCode).set('bestOptionsPackageCode', modelYear.getBestAvailableOptionsPackageFromTrimsBitField(drivePowerTrainTrimsBitField, drivePowerTrain.engine.selectionCode, drivePowerTrain.transmission.selectionCode));
}

function setSelectedDrivePowerTrain(modelYear, selectedDrivePowerTrain) {
    var selectedModelTrim = modelYear.getSelectedModelTrim();
    if (!selectedModelTrim) {
        return modelYear;
    }
    var modelTrimTrimsBitField = getMergedModelTrimTrimsBitField(selectedModelTrim);

    var drivePowerTrainSelectionCode = selectedDrivePowerTrain.selectionCode;
    var optionsPackageTrimsBitField = UtilitiesService.mergeModelTrimsBitField(modelTrimTrimsBitField, selectedDrivePowerTrain, false);

    var engineSelectionCode = selectedDrivePowerTrain.engine.selectionCode;
    var transmissionSelectionCode = selectedDrivePowerTrain.transmission.selectionCode;
    var newModelYear = modelYear.set('drivePowerTrains', modelYear.drivePowerTrains.map(function (drivePowerTrain) {
        return selectModelYearItemFromCode(drivePowerTrain, drivePowerTrainSelectionCode);
    })).set('optionsPackages', modelYear.optionsPackages.map(function (optionsPackage) {
        return resetModelYearOptionPackagesVisibility(optionsPackage, optionsPackageTrimsBitField, engineSelectionCode, transmissionSelectionCode);
    }));

    return resetSelectedOptionsPackage(newModelYear);
}

function resetSelectedDrivePowerTrain(modelYear, modelTrimTrimsBitField) {
    var availableDrivePowerTrains = modelYear.drivePowerTrains.filter(function (drivePowerTrain) {
        return drivePowerTrain.visible;
    });

    if (availableDrivePowerTrains.size === 0) {
        return modelYear;
    }

    var drivePowerTrainSelectionCode = availableDrivePowerTrains.minBy(function (drivePowerTrain) {
        return drivePowerTrain.rank;
    }).selectionCode;

    var newModelYear = modelYear.set('drivePowerTrains', modelYear.drivePowerTrains.map(function (drivePowerTrain) {
        return resetDrivePowerTrainWithOptionsPackage(modelYear, drivePowerTrain, drivePowerTrainSelectionCode, modelTrimTrimsBitField);
    }));

    var selectedDrivePowerTrain = newModelYear.getSelectedDrivePowerTrain();
    if (selectedDrivePowerTrain) {
        return setSelectedDrivePowerTrain(newModelYear, selectedDrivePowerTrain);
    }
    return resetSelectedOptionsPackage(newModelYear);
}

function setSelectedModelTrim(modelYear, selectedModelTrim) {
    var modelTrimSelectionCode = selectedModelTrim.selectionCode;
    var modelTrimTrimsBitField = getMergedModelTrimTrimsBitField(selectedModelTrim);

    var newModelYear = modelYear.set('modelTrims', modelYear.modelTrims.map(function (modelTrim) {
        return selectModelYearItemFromCode(modelTrim, modelTrimSelectionCode);
    })).set('drivePowerTrains', modelYear.drivePowerTrains.map(function (drivePowerTrain) {
        return resetModelYearItemVisibility(drivePowerTrain, modelTrimTrimsBitField);
    })).set('optionsPackages', modelYear.optionsPackages.map(function (optionsPackage) {
        return resetModelYearItemVisibility(optionsPackage, modelTrimTrimsBitField);
    }));

    return resetSelectedDrivePowerTrain(newModelYear, modelTrimTrimsBitField);
}

function resetSelectedModelTrim(modelYear) {
    var availableModelTrims = modelYear.modelTrims.filter(function (modelTrim) {
        return modelTrim.enabled;
    });

    if (availableModelTrims.size === 0) {
        return modelYear;
    }

    var selectedModelTrim = availableModelTrims.minBy(function (modelTrim) {
        return modelTrim.rank;
    });
    return setSelectedModelTrim(modelYear, selectedModelTrim);
}

function setSelectedBoxSize(modelYear, selectedBoxSize) {
    if (!selectedBoxSize.enabled) {
        return modelYear;
    }

    var boxSizeSelectionCode = selectedBoxSize.selectionCode;
    var boxSizeTrimsBitField = {
        trimsBitField: selectedBoxSize.trimsBitField,
        trimsBitFields: selectedBoxSize.trimsBitFields
    };

    var newModelYear = modelYear.set('boxSizes', modelYear.boxSizes.map(function (boxSize) {
        return selectModelYearItemFromCode(boxSize, boxSizeSelectionCode);
    })).set('modelTrims', modelYear.modelTrims.map(function (modelTrim) {
        return resetModelTrimsAvailabilityFromBoxSize(modelTrim, boxSizeTrimsBitField);
    }));

    return resetSelectedModelTrim(newModelYear);
}

function resetSelectedBoxSize(modelYear) {
    var availableBoxSizes = modelYear.boxSizes.filter(function (boxSize) {
        return boxSize.enabled;
    });

    if (availableBoxSizes.size === 0) {
        return modelYear;
    }

    var selectedBoxSize = (0, _lodash.min)(availableBoxSizes, function (boxSize) {
        return boxSize.rank;
    });
    return setSelectedBoxSize(modelYear, selectedBoxSize);
}

function setSelectedCabSize(modelYear, selectedCabSize) {
    var cabSizeSelectionCode = selectedCabSize.selectionCode;
    var cabSizeTrimsBitField = {
        trimsBitField: selectedCabSize.trimsBitField,
        trimsBitFields: selectedCabSize.trimsBitFields
    };

    var newModelYear = modelYear.set('cabSizes', modelYear.cabSizes.map(function (cabSize) {
        return selectModelYearItemFromCode(cabSize, cabSizeSelectionCode);
    })).set('boxSizes', modelYear.boxSizes.map(function (boxSize) {
        return resetModelYearItemAvailability(boxSize, cabSizeTrimsBitField);
    })).set('modelTrims', modelYear.modelTrims.map(function (modelTrim) {
        return modelTrim.set('cabSizeTrimsBitField', selectedCabSize.trimsBitField).set('cabSizeTrimsBitFields', selectedCabSize.trimsBitFields);
    }));

    return resetSelectedBoxSize(newModelYear, selectedCabSize);
}

function setSelectedOptionsPackage(modelYear, selectedOptionsPackage, forceSelect) {
    if (!forceSelect && (!modelYear.getSelectedModelTrim() || !modelYear.getSelectedDrivePowerTrain())) {
        return modelYear;
    }

    var optionsPackageSelectionCode = selectedOptionsPackage.selectionCode;
    return modelYear.set('optionsPackages', modelYear.optionsPackages.map(function (optionsPackage) {
        return selectModelYearItemFromCode(optionsPackage, optionsPackageSelectionCode);
    }));
}

function setSelectedExteriorColour(modelYear, exteriorColour) {
    var exteriorColourSelectionCode = exteriorColour.colourCode;

    return modelYear.set('optionsPackages', modelYear.optionsPackages.map(function (optionsPackage) {
        return OptionsPackageService.resetOptionsPackageExteriorColours(optionsPackage, exteriorColourSelectionCode);
    }));
}

function setSelectedInteriorColour(modelYear, interiorColour) {
    var interiorColourSelectionCode = (0, _lodash.isNull)(interiorColour) ? '' : interiorColour.colourCode;

    return modelYear.set('optionsPackages', modelYear.optionsPackages.map(function (optionsPackage) {
        return OptionsPackageService.resetOptionsPackageInteriorColours(optionsPackage, interiorColourSelectionCode);
    }));
}

function resetYear(year, modelYear) {
    if (year.year === modelYear.year) {
        return year.set('selected', true).set('isSingleConfiguration', modelYear.isSingleConfiguration).set('hasOptions', modelYear.hasOptions).set('modelTrims', modelYear.modelTrims).set('drivePowerTrains', modelYear.drivePowerTrains).set('optionsPackages', modelYear.optionsPackages);
    }

    return year.set('selected', false);
}

function resetModelYears(modelYear, modelYears, selectedYear) {
    var lastYear = modelYears.last();
    var newModelYear = modelYear.set('year', selectedYear || lastYear.year).set('make', lastYear.make).set('model', lastYear.model).set('bodyStyleCode', lastYear.bodyStyleCode);

    return newModelYear.set('years', modelYears.map(function (year) {
        return resetYear(year, newModelYear);
    }));
}

function resetModelYear(modelYear, year) {
    if (year) {
        var newModelYear = modelYear.set('modelTrims', year.modelTrims).set('drivePowerTrains', year.drivePowerTrains).set('optionsPackages', year.optionsPackages);

        return setSelectedModelTrim(newModelYear, newModelYear.modelTrims.first());
    }

    return modelYear.set('modelTrims', (0, _immutable.List)([])).set('drivePowerTrains', (0, _immutable.List)([])).set('optionsPackages', (0, _immutable.List)([]));
}

function resetConfigurationToken(modelYear, configurationToken) {
    if (!(0, _lodash.isString)(configurationToken)) {
        return modelYear;
    }

    return modelYear.set('optionsPackages', modelYear.optionsPackages.map(function (optionsPackage) {
        return optionsPackage.selected ? optionsPackage.setIn(['configuration', 'configurationToken'], configurationToken) : optionsPackage;
    }));
}

function resetOptionsAvailability(modelYear, options) {
    if (!(0, _lodash.isArrayLikeObject)(options)) {
        return modelYear;
    }

    var availableOptions = (0, _lodash.filter)(options, function (option) {
        return (option.flag & dataTypes.ITEM_FLAG.AVAILABLE) > 0 && option.supplier === dataTypes.SUPPLIER_OPTION;
    });
    var availableOptionsCodes = (0, _lodash.map)(availableOptions, function (option) {
        return option.code;
    });

    var selectedOptions = (0, _lodash.filter)(options, function (option) {
        return (option.flag & dataTypes.ITEM_FLAG.SELECTED) > 0 && (option.flag & dataTypes.ITEM_FLAG.CONFIGURATION_SELECTED) === 0;
    }).map(function (option) {
        return OptionService.resetOptionFromOptionData(option);
    });

    return modelYear.set('optionsPackages', modelYear.optionsPackages.map(function (optionsPackage) {
        return OptionsPackageService.resetOptionsPackageOptionsAvailability(optionsPackage, availableOptionsCodes, selectedOptions);
    }));
}

function resetOptionsSelectionResolutions(modelYear, resolutions) {
    if (!(0, _lodash.isObjectLike)(resolutions)) {
        return modelYear;
    }

    var configuration = modelYear.getSelectedOptionsPackageConfiguration();
    var optionsSelectionResolutions = OptionsSelectionResolutionsService.resetResolutionOptionsFromResolutionsData(resolutions.resolutions, configuration, resolutions.optionSelectionCode);

    return modelYear.set('optionsPackages', modelYear.optionsPackages.map(function (optionsPackage) {
        return OptionsPackageService.resetOptionsPackageOptionsSelectionResolutions(optionsPackage, optionsSelectionResolutions);
    }));
}

function setAvailableOptions(modelYear, options) {
    if (!(0, _lodash.isArrayLikeObject)(options)) {
        return modelYear;
    }

    var configurationOptions = (0, _lodash.filter)(options, function (option) {
        return (option.flag & dataTypes.ITEM_FLAG.SELECTED) > 0;
    }).map(function (option) {
        return OptionService.resetOptionFromProtectionItem(option);
    });
    var configurationOptionsCodes = (0, _lodash.map)(configurationOptions, function (configurationOption) {
        return configurationOption.selectionCode;
    });

    var configurationAvailableOptions = (0, _lodash.filter)(options, function (option) {
        return (option.flag & dataTypes.ITEM_FLAG.CONFIGURATION_AVAILABLE) > 0;
    });

    var availableOptions = (0, _lodash.filter)(configurationAvailableOptions, function (option) {
        return (option.flag & (dataTypes.ITEM_FLAG.CONFIGURATION_AVAILABLE | dataTypes.ITEM_FLAG.AVAILABLE)) > 0 && (option.flag & dataTypes.ITEM_FLAG.IGNORE_ITEM) === 0 && option.supplier === dataTypes.SUPPLIER_OPTION && option.dataType === dataTypes.DATA_TYPES.FEATURE.DATA_TYPE_ID && (option.typeID <= dataTypes.DATA_TYPES.FEATURE.TYPES.SAFETY || option.typeID >= dataTypes.DATA_TYPES.FEATURE.TYPES.EXTERIOR_COLOUR) && (!(0, _lodash.includes)(configurationOptionsCodes, option.code + '>' + option.supplier) || (option.flag & dataTypes.ITEM_FLAG.CONFIGURATION_SELECTED) > 0);
    }).map(function (option) {
        return OptionService.resetOptionFromProtectionItem(option);
    });

    return modelYear.set('optionsPackages', modelYear.optionsPackages.map(function (optionsPackage) {
        return OptionsPackageService.resetOptionsPackageAvailableOptions(optionsPackage, availableOptions, configurationOptions);
    }));
}

function setSelectedOptions(modelYear, options) {
    if (!(0, _lodash.isArrayLikeObject)(options)) {
        return modelYear;
    }

    return modelYear.set('optionsPackages', modelYear.optionsPackages.map(function (optionsPackage) {
        return OptionsPackageService.resetOptionsPackageOptions(optionsPackage, options);
    }));
}

function recalculatePayments(modelYear, paymentCalculationParameters) {
    return paymentCalculationParameters ? modelYear.set('years', modelYear.years.map(function (year) {
        return YearService.recalculateYearPayments(year, paymentCalculationParameters);
    })).set('optionsPackages', modelYear.optionsPackages.map(function (optionsPackage) {
        return OptionsPackageService.recalculateOptionsPackagePayments(optionsPackage, paymentCalculationParameters);
    })) : modelYear;
}

function recalculatePurchaseAmounts(modelYear, paymentCalculationParameters) {
    return paymentCalculationParameters ? modelYear.set('years', modelYear.years.map(function (year) {
        return YearService.recalculateYearPayments(year, paymentCalculationParameters);
    })).set('optionsPackages', modelYear.get('optionsPackages').map(function (optionsPackage) {
        return OptionsPackageService.recalculateOptionsPackagePurchaseAmounts(optionsPackage, paymentCalculationParameters);
    })) : modelYear;
}

function resetPaymentsAndPurchaseAmounts(modelYear, purchaseMethods) {
    var paymentCalculationParameters = purchaseMethods ? purchaseMethods.getPaymentCalculationParameters() : '';
    return recalculatePurchaseAmounts(modelYear, paymentCalculationParameters);
}

function selectPurchaseMethod(modelYear, purchaseMethod) {
    return modelYear.set('years', modelYear.years.map(function (year) {
        return YearService.resetYearPurchaseMethod(year, purchaseMethod);
    })).set('optionsPackages', modelYear.optionsPackages.map(function (optionsPackage) {
        return OptionsPackageService.resetOptionsPackagePurchaseMethod(optionsPackage, purchaseMethod);
    }));
}

function selectPaymentFrequency(modelYear, paymentFrequency) {
    var paymentCalculationParameters = modelYear.getPaymentCalculationWithPaymentFrequency(paymentFrequency);
    return recalculatePayments(modelYear, paymentCalculationParameters);
}

function selectTerm(modelYear, term) {
    var paymentCalculationParameters = modelYear.getPaymentCalculationWithTerm(term);
    return recalculatePayments(modelYear, paymentCalculationParameters);
}

function selectKMPlan(modelYear, kmPlan) {
    var purchaseMethods = modelYear.getSelectedOptionsPackagePurchaseMethods();
    if (!purchaseMethods) {
        return modelYear;
    }

    var paymentCalculationParameters = purchaseMethods.getPaymentCalculationParameters();
    var newOptionsPackages = modelYear.optionsPackages.map(function (optionsPackage) {
        return OptionsPackageService.selectOptionsPackageKMPlan(optionsPackage, kmPlan);
    });

    return modelYear.set('optionsPackages', newOptionsPackages.map(function (optionsPackage) {
        return OptionsPackageService.recalculateOptionsPackagePayments(optionsPackage, paymentCalculationParameters);
    }));
}

function setCashDown(modelYear, cashDown) {
    var paymentCalculationParameters = modelYear.getPaymentCalculationWithCashDown(cashDown);
    return recalculatePayments(modelYear, paymentCalculationParameters);
}

function setTradeIn(modelYear, tradeIn) {
    var paymentCalculationParameters = modelYear.getPaymentCalculationWithTradeIn(tradeIn);
    return recalculatePurchaseAmounts(modelYear, paymentCalculationParameters);
}

function setLien(modelYear, lien) {
    var paymentCalculationParameters = modelYear.getPaymentCalculationWithLien(lien);
    return recalculatePayments(modelYear, paymentCalculationParameters);
}

function setExteriorColourAmounts(modelYear, exteriorColourAmounts) {
    var paymentCalculationParameters = modelYear.getPaymentCalculationWithExteriorColour(exteriorColourAmounts);
    return recalculatePurchaseAmounts(modelYear, paymentCalculationParameters);
}

function setInteriorColourAmounts(modelYear, interiorColourAmounts) {
    var paymentCalculationParameters = modelYear.getPaymentCalculationWithInteriorColour(interiorColourAmounts);
    return recalculatePurchaseAmounts(modelYear, paymentCalculationParameters);
}

function setOptionsAmounts(modelYear, optionsAmounts) {
    var paymentCalculationParameters = modelYear.getPaymentCalculationWithOptions(optionsAmounts);
    return recalculatePayments(modelYear, paymentCalculationParameters);
}

function setTaxesIncluded(modelYear, taxesIncluded) {
    var paymentCalculationParameters = modelYear.getPaymentCalculationWithTaxesIncluded(taxesIncluded);
    return recalculatePayments(modelYear, paymentCalculationParameters);
}

function resetModelYearFromQuote(modelYear, quote) {
    if ((0, _lodash.isEmpty)(quote) || !(0, _lodash.isObjectLike)(quote)) {
        return modelYear;
    }

    var newModelYear = modelYear;
    var cabSizeCode = quote.vehicle.cabSizeCode;
    if (cabSizeCode && modelYear.cabSizes && modelYear.cabSizes.length) {
        var selectedCabSize = (0, _lodash.find)(modelYear.cabSizes, function (cabSize) {
            return cabSize.code === cabSizeCode;
        });
        if (!selectedCabSize) {
            return newModelYear;
        }
        newModelYear = setSelectedCabSize(newModelYear, selectedCabSize);

        var boxSizeCode = quote.vehicle.boxSizeCode;
        var boxSizeDesc = (0, _lodash.isEmpty)(quote.vehicle.boxSize) ? '' : quote.vehicle.boxSize[0];
        if (boxSizeCode && modelYear.boxSizes && modelYear.boxSizes.length) {
            var selectedBoxSize = (0, _lodash.find)(modelYear.boxSizes, function (boxSize) {
                return boxSize.code === boxSizeCode && boxSize.selectionCode === boxSizeCode + '-' + boxSizeDesc;
            });

            if (!selectedBoxSize) {
                return newModelYear;
            }
            newModelYear = setSelectedBoxSize(newModelYear, selectedBoxSize.set('enabled', true));
        }
    }
    var configurationId = quote.vehicle.modelTrimCode + '|' + quote.vehicle.configurationId;

    var selectedModelTrim = (0, _lodash.find)(newModelYear.modelTrims.toArray(), function (modelTrim) {
        return !(0, _lodash.isUndefined)(modelTrim.configurationIds[configurationId]);
    });

    if (!selectedModelTrim) {
        return newModelYear;
    }
    newModelYear = setSelectedModelTrim(newModelYear, selectedModelTrim);

    var selectedDrivePowerTrain = (0, _lodash.find)(newModelYear.drivePowerTrains.toArray(), function (drivePowerTrain) {
        return !(0, _lodash.isUndefined)(drivePowerTrain.configurationIds[configurationId]);
    });

    if (!selectedDrivePowerTrain) {
        return newModelYear;
    }
    newModelYear = setSelectedDrivePowerTrain(newModelYear, selectedDrivePowerTrain);

    var selectedOptionsPackage = (0, _lodash.find)(newModelYear.optionsPackages.toArray(), function (optionsPackage) {
        return optionsPackage.configuration.selectionCode === configurationId;
    });

    if (!selectedOptionsPackage) {
        return newModelYear;
    }
    newModelYear = setSelectedOptionsPackage(newModelYear, selectedOptionsPackage, true);

    var selectedExteriorColourCode = quote.vehicle.purchaseMethods.getSelectedExteriorColourCode();
    if (selectedExteriorColourCode) {
        var selectedExteriorColour = (0, _lodash.find)(selectedOptionsPackage.configuration.exteriorColours.toArray(), function (colour) {
            return colour.colourCode === selectedExteriorColourCode;
        });
        if (selectedExteriorColour) {
            newModelYear = setSelectedExteriorColour(newModelYear, selectedExteriorColour);
        }
    }

    var selectedInteriorColourCode = quote.vehicle.purchaseMethods.getSelectedInteriorColourCode();
    if (selectedInteriorColourCode) {
        var selectedInteriorColour = (0, _lodash.find)(selectedOptionsPackage.configuration.interiorColours.toArray(), function (colour) {
            return colour.colourCode === selectedInteriorColourCode;
        });
        if (selectedInteriorColour) {
            newModelYear = setSelectedInteriorColour(newModelYear, selectedInteriorColour);
        }
    }

    var paymentCalculationParameters = quote.vehicle.purchaseMethods.getPaymentCalculationParameters();
    newModelYear = selectPurchaseMethod(newModelYear, quote.vehicle.purchaseMethods.getSelectedPurchaseMethod());
    newModelYear = recalculatePayments(newModelYear, paymentCalculationParameters);
    var selectedFinance = quote.vehicle.purchaseMethods.getSelectedFinance();
    var annualKMAllowed = selectedFinance ? selectedFinance.annualKMAllowed : 0;
    if (annualKMAllowed > 0) {
        return selectKMPlan(newModelYear, annualKMAllowed);
    }

    newModelYear = resetConfigurationToken(newModelYear, quote.vehicle.configurationToken);
    return newModelYear;
}

function resetModelYearOptionsFromQuote(modelYear, quote) {
    if ((0, _lodash.isEmpty)(quote) || !(0, _lodash.isObjectLike)(quote)) {
        return modelYear;
    }

    var selectedOptionsPackage = modelYear.getSelectedOptionsPackage();
    if (!selectedOptionsPackage) {
        return modelYear;
    }

    var quoteOptions = [].concat(quote.vehicle.purchaseMethods.getSelectedOptionsAndColours(), quote.vehicle.purchaseMethods.getSelectedDealerFees());
    var quoteSelectedOptions = (0, _lodash.filter)(quoteOptions, function (option) {
        return option.selected;
    });
    var dealerSelectedOptions = (0, _lodash.filter)(quoteSelectedOptions, function (option) {
        return option.isDealerInventoryOption() || option.isDealerFee();
    });
    var dealerSelectedDiscounts = quote.vehicle.purchaseMethods.getSelectedDealerDiscounts(true);

    if (dealerSelectedOptions.length || dealerSelectedDiscounts.length) {
        var configurationOptions = (0, _lodash.map)(selectedOptionsPackage.configuration.options, function (option) {
            switch (option.id) {
                case _modelTrimItemCategories.DEALER_INVENTORY:
                    return option.set('itemsPackages', (0, _lodash.unionBy)(option.itemsPackages, dealerSelectedOptions, 'selectionCode'));
                case _modelTrimItemCategories.DEALER_DISCOUNT:
                    return option.set('itemsPackages', (0, _lodash.unionBy)(option.itemsPackages, dealerSelectedDiscounts, 'selectionCode'));
                default:
                    return option;
            }
        });

        selectedOptionsPackage = selectedOptionsPackage.setIn(['configuration', 'options'], configurationOptions);
    }
    var resetQuoteSelectedOptions = (0, _QuoteItemCategoryService.resetQuoteItemCategoriesFromOptionsValidation)(selectedOptionsPackage.configuration.options, quoteSelectedOptions);

    var newModelYear = setSelectedOptions(modelYear, resetQuoteSelectedOptions);
    var paymentCalculationParameters = quote.vehicle.purchaseMethods.getPaymentCalculationParameters();
    newModelYear = selectPurchaseMethod(newModelYear, quote.vehicle.purchaseMethods.getSelectedPurchaseMethod());
    return recalculatePayments(newModelYear, paymentCalculationParameters);
}

function setSelectedModelYear(modelYear, selectedYear) {
    var newModelYear = modelYear.set('year', selectedYear.year).set('modelTrims', selectedYear.modelTrims).set('drivePowerTrains', selectedYear.drivePowerTrains).set('optionsPackages', selectedYear.optionsPackages).set('years', modelYear.years.map(function (year) {
        return year.set('selected', year.year === selectedYear.year);
    }));

    if (!selectedYear.purchaseMethods.getSelectedPurchaseMethodIsValid()) {
        return selectPurchaseMethod(newModelYear, PurchaseMethodsConstants.CASH_PURCHASE);
    }
    return newModelYear;
}

function resetEmployeeRebateAdjustment(modelYear, rebateAdjustment) {
    return modelYear.set('optionsPackages', modelYear.optionsPackages.map(function (optionsPackage) {
        return OptionsPackageService.resetOptionsPackageEmployeeRebateAdjustment(optionsPackage, rebateAdjustment);
    }));
}

function resetPercentageRebateAdjustment(modelYear, rebateAdjustment) {
    return modelYear.set('optionsPackages', modelYear.optionsPackages.map(function (optionsPackage) {
        return OptionsPackageService.resetOptionsPackagePercentageRebateAdjustment(optionsPackage, rebateAdjustment);
    }));
}

exports.default = {
    resetModelYearFromOriginData: resetModelYearFromOriginData,
    setSelectedDrivePowerTrain: setSelectedDrivePowerTrain,
    setSelectedCabSize: setSelectedCabSize,
    setSelectedBoxSize: setSelectedBoxSize,
    setSelectedModelTrim: setSelectedModelTrim,
    setSelectedOptionsPackage: setSelectedOptionsPackage,
    setSelectedExteriorColour: setSelectedExteriorColour,
    setSelectedInteriorColour: setSelectedInteriorColour,
    setSelectedModelYear: setSelectedModelYear,
    resetModelYears: resetModelYears,
    resetModelYear: resetModelYear,
    resetConfigurationToken: resetConfigurationToken,
    resetOptionsAvailability: resetOptionsAvailability,
    resetOptionsSelectionResolutions: resetOptionsSelectionResolutions,
    setAvailableOptions: setAvailableOptions,
    setSelectedOptions: setSelectedOptions,
    resetPaymentsAndPurchaseAmounts: resetPaymentsAndPurchaseAmounts,
    selectPurchaseMethod: selectPurchaseMethod,
    selectPaymentFrequency: selectPaymentFrequency,
    selectTerm: selectTerm,
    selectKMPlan: selectKMPlan,
    setCashDown: setCashDown,
    setTradeIn: setTradeIn,
    setLien: setLien,
    setExteriorColourAmounts: setExteriorColourAmounts,
    setInteriorColourAmounts: setInteriorColourAmounts,
    setOptionsAmounts: setOptionsAmounts,
    setTaxesIncluded: setTaxesIncluded,
    resetModelYearFromQuote: resetModelYearFromQuote,
    resetModelYearOptionsFromQuote: resetModelYearOptionsFromQuote,
    resetEmployeeRebateAdjustment: resetEmployeeRebateAdjustment,
    resetPercentageRebateAdjustment: resetPercentageRebateAdjustment
};

/***/ }),

/***/ "./src/ModelYear/services/OptionService/OptionService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetOptionFromOptionData = resetOptionFromOptionData;
exports.resetOptionFromQuoteItem = resetOptionFromQuoteItem;
exports.resetOptionFromProtectionItem = resetOptionFromProtectionItem;

var _lodash = __webpack_require__("lodash");

var _dataConversions = __webpack_require__("./src/constants/dataConversions.js");

var _dataTypes = __webpack_require__("./src/constants/dataTypes.js");

var dataTypes = _interopRequireWildcard(_dataTypes);

var _OptionModel = __webpack_require__("./src/ModelYear/models/OptionModel.js");

var _OptionModel2 = _interopRequireDefault(_OptionModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/* eslint import/prefer-default-export: 0 no-bitwise: 0 */

function convertOptionFlags(option) {
    return {
        enabled: (option.flag & dataTypes.ITEM_FLAG.AVAILABLE) > 0,
        selected: (option.flag & dataTypes.ITEM_FLAG.SELECTED) > 0,
        isConfigurationOption: (option.flag & dataTypes.ITEM_FLAG.CONFIGURATION_SELECTED) > 0,
        isTaxable: (option.flag & (dataTypes.ITEM_FLAG.NON_TAXABLE_FEDERAL | dataTypes.ITEM_FLAG.NON_TAXABLE_PROVINCIAL)) === 0,
        dueAtDelivery: option.priceInclusion ? option.priceInclusion.epi === 0 : false
    };
}

function resetOptionFromOptionData(optionData) {
    if ((0, _lodash.isEmpty)(optionData) || !(0, _lodash.isObjectLike)(optionData)) {
        return new _OptionModel2.default();
    }

    var _convertOptionFlags = convertOptionFlags(optionData),
        enabled = _convertOptionFlags.enabled,
        selected = _convertOptionFlags.selected,
        isConfigurationOption = _convertOptionFlags.isConfigurationOption,
        isTaxable = _convertOptionFlags.isTaxable,
        dueAtDelivery = _convertOptionFlags.dueAtDelivery;

    return new _OptionModel2.default({
        selectionCode: optionData.code + '>' + optionData.supplier,
        enabled: enabled,
        visible: true,
        selected: selected,
        isConfigurationOption: isConfigurationOption,
        dueAtDelivery: dueAtDelivery,
        userSelected: false,
        code: optionData.code,
        parentCode: optionData.parentCode,
        description: optionData.description,
        dataType: optionData.dataType,
        typeID: optionData.typeID,
        supplier: optionData.supplier,
        flag: optionData.flag,
        residualizingAmount: optionData.residualizingAmount,
        retail: optionData.retail,
        isTaxable: isTaxable
    });
}

function resetOptionFromQuoteItem(quoteItem, isIncludedInPriceOrPayment) {
    if ((0, _lodash.isEmpty)(quoteItem) || !(0, _lodash.isObjectLike)(quoteItem)) {
        return new _OptionModel2.default();
    }

    var _convertOptionFlags2 = convertOptionFlags(quoteItem),
        enabled = _convertOptionFlags2.enabled,
        selected = _convertOptionFlags2.selected,
        isConfigurationOption = _convertOptionFlags2.isConfigurationOption,
        isTaxable = _convertOptionFlags2.isTaxable,
        dueAtDelivery = _convertOptionFlags2.dueAtDelivery;

    var hasDealerCashOnlyDiscount = (0, _lodash.includes)(quoteItem.supplierCodes, _dataConversions.CASH_PURCHASE_ONLY_DISCOUNT);

    return new _OptionModel2.default({
        selectionCode: quoteItem.code + '>' + quoteItem.supplier,
        enabled: enabled,
        visible: true,
        selected: selected || hasDealerCashOnlyDiscount,
        isConfigurationOption: isConfigurationOption,
        dueAtDelivery: dueAtDelivery,
        userSelected: false,
        code: quoteItem.code,
        description: (0, _lodash.isEmpty)(quoteItem.description) ? '' : quoteItem.description.descriptions[0],
        dataType: quoteItem.dataType,
        typeID: quoteItem.typeID,
        supplier: quoteItem.supplier,
        supplierCodes: quoteItem.supplierCodes,
        flag: quoteItem.flag,
        residualizingAmount: quoteItem.amounts.residualizingAmount,
        retail: quoteItem.amounts.retail,
        isTaxable: isTaxable,
        isIncludedInPriceOrPayment: isIncludedInPriceOrPayment || false
    });
}

function resetOptionFromProtectionItem(protectionItem) {
    if ((0, _lodash.isEmpty)(protectionItem) || !(0, _lodash.isObjectLike)(protectionItem)) {
        return new _OptionModel2.default();
    }

    var dataType = protectionItem.dataType,
        typeID = protectionItem.typeID,
        categoryID = protectionItem.categoryID,
        flag = protectionItem.flag,
        code = protectionItem.code,
        parentCode = protectionItem.parentCode,
        keyOrder = protectionItem.keyOrder,
        includedCodes = protectionItem.includedCodes,
        supplier = protectionItem.supplier,
        supplierCodes = protectionItem.supplierCodes,
        description = protectionItem.description,
        amounts = protectionItem.amounts,
        imageUrl = protectionItem.imageUrl,
        webUrl = protectionItem.webUrl,
        htmlTag = protectionItem.htmlTag,
        isPopular = protectionItem.isPopular,
        isDealerInstalled = protectionItem.isDealerInstalled,
        identificationType = protectionItem.identificationType,
        parentIdentificationType = protectionItem.parentIdentificationType,
        protectionCoverage = protectionItem.protectionCoverage;

    var _convertOptionFlags3 = convertOptionFlags(protectionItem),
        enabled = _convertOptionFlags3.enabled,
        selected = _convertOptionFlags3.selected,
        isConfigurationOption = _convertOptionFlags3.isConfigurationOption,
        isTaxable = _convertOptionFlags3.isTaxable,
        dueAtDelivery = _convertOptionFlags3.dueAtDelivery;

    var optionDesc = !(0, _lodash.isEmpty)(description) && !(0, _lodash.isEmpty)(description.description) ? description.description : description;

    return new _OptionModel2.default({
        selectionCode: code + '>' + supplier,
        enabled: enabled,
        selected: selected,
        isConfigurationOption: isConfigurationOption,
        dueAtDelivery: dueAtDelivery,
        code: code,
        parentCode: !(0, _lodash.isEmpty)(parentCode) ? parentCode : '',
        keyOrder: keyOrder,
        includedCodes: includedCodes,
        label: (0, _lodash.isEmpty)(optionDesc) ? '' : optionDesc.labels[0],
        description: (0, _lodash.isEmpty)(optionDesc) ? '' : optionDesc.descriptions[0],
        note: (0, _lodash.isEmpty)(optionDesc) ? '' : optionDesc.notes[0],
        dataType: dataType,
        typeID: typeID,
        typeDescription: !(0, _lodash.isEmpty)(identificationType) ? identificationType.description.descriptions[0] : '',
        typeNote: !(0, _lodash.isEmpty)(identificationType) ? identificationType.description.notes[0] : '',
        parentTypeID: !(0, _lodash.isEmpty)(parentIdentificationType) ? parentIdentificationType.typeID : null,
        parentTypeDescription: !(0, _lodash.isEmpty)(parentIdentificationType) ? parentIdentificationType.description.descriptions[0] : '',
        parentTypeNote: !(0, _lodash.isEmpty)(parentIdentificationType) ? parentIdentificationType.description.notes[0] : '',
        categoryID: categoryID,
        supplier: supplier,
        supplierCodes: supplierCodes,
        flag: flag,
        residualizingAmount: amounts.residualizingAmount,
        retail: amounts.retail,
        isTaxable: isTaxable,
        imageUrl: (0, _lodash.isEmpty)(imageUrl) ? '' : imageUrl[0],
        webUrl: (0, _lodash.isEmpty)(webUrl) ? '' : webUrl[0],
        htmlBlock: (0, _lodash.isEmpty)(htmlTag) ? '' : htmlTag[0],
        mostPopular: isPopular,
        isGroup: !(0, _lodash.isEmpty)(identificationType) ? identificationType.isGroup : false,
        isInstalledAtDealership: isDealerInstalled,
        protectionCoverage: !(0, _lodash.isEmpty)(protectionCoverage) ? protectionCoverage : null
    });
}

exports.default = {
    resetOptionFromOptionData: resetOptionFromOptionData,
    resetOptionFromQuoteItem: resetOptionFromQuoteItem,
    resetOptionFromProtectionItem: resetOptionFromProtectionItem
};

/***/ }),

/***/ "./src/ModelYear/services/OptionsPackageService/OptionsPackageService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetOptionsPackageFromOriginData = resetOptionsPackageFromOriginData;
exports.resetOptionsPackageExteriorColours = resetOptionsPackageExteriorColours;
exports.resetOptionsPackageInteriorColours = resetOptionsPackageInteriorColours;
exports.resetOptionsPackageOptionsAvailability = resetOptionsPackageOptionsAvailability;
exports.resetOptionsPackageOptionsSelectionResolutions = resetOptionsPackageOptionsSelectionResolutions;
exports.resetOptionsPackageAvailableOptions = resetOptionsPackageAvailableOptions;
exports.resetOptionsPackageOptions = resetOptionsPackageOptions;
exports.resetOptionsPackagePurchaseMethod = resetOptionsPackagePurchaseMethod;
exports.recalculateOptionsPackagePayments = recalculateOptionsPackagePayments;
exports.recalculateOptionsPackagePurchaseAmounts = recalculateOptionsPackagePurchaseAmounts;
exports.selectOptionsPackageKMPlan = selectOptionsPackageKMPlan;
exports.resetOptionsPackageEmployeeRebateAdjustment = resetOptionsPackageEmployeeRebateAdjustment;
exports.resetOptionsPackagePercentageRebateAdjustment = resetOptionsPackagePercentageRebateAdjustment;

var _lodash = __webpack_require__("lodash");

var _dataOrigins = __webpack_require__("./src/constants/dataOrigins.js");

var DataOrigins = _interopRequireWildcard(_dataOrigins);

var _dataTypes = __webpack_require__("./src/constants/dataTypes.js");

var _modelTrimItemCategories = __webpack_require__("./src/Quote/constants/modelTrimItemCategories.js");

var _OptionsPackageModel = __webpack_require__("./src/ModelYear/models/OptionsPackageModel.js");

var _OptionsPackageModel2 = _interopRequireDefault(_OptionsPackageModel);

var _PurchaseMethodsService = __webpack_require__("./src/PurchaseMethods/services/PurchaseMethodsService/PurchaseMethodsService.js");

var PurchaseMethodsService = _interopRequireWildcard(_PurchaseMethodsService);

var _QuoteItemCategoryService = __webpack_require__("./src/Quote/services/QuoteItemCategoryService/QuoteItemCategoryService.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var FEATURE = _dataTypes.DATA_TYPES.FEATURE;


function resetOptionsPackageFromModelData(modelData, disclaimers) {
    var selectionCode = '' + modelData.configuration.cabSizeSelectionCode + (modelData.configuration.packageSelectionCode + '|' + modelData.configuration.id);

    var optionsPackage = new _OptionsPackageModel2.default({
        trimsBitField: modelData.configuration.trimsBitField,
        trimsBitFields: modelData.configuration.trimsBitFields,
        selectionCode: selectionCode,
        enabled: true,
        visible: true,
        selected: false,
        userSelected: false,
        code: modelData.configuration.packageCode,
        description: modelData.configuration.package.description,
        rank: modelData.configuration.rank,
        configuration: modelData.configuration
    });

    return optionsPackage.setIn(['configuration', 'purchaseMethods', 'disclaimers'], disclaimers);
}

function resetOptionsPackageFromOriginData(dataOrigin, originOptionsPackageData, disclaimers) {
    if ((0, _lodash.isEmpty)(originOptionsPackageData) || !(0, _lodash.isObjectLike)(originOptionsPackageData)) {
        return new _OptionsPackageModel2.default();
    }

    switch (dataOrigin) {
        case DataOrigins.MODELS_COLLECTION:
            return new _OptionsPackageModel2.default();

        case DataOrigins.MODEL_YEAR_POWERS_TRIMS:
            return resetOptionsPackageFromModelData(originOptionsPackageData, disclaimers);

        default:
            return new _OptionsPackageModel2.default();
    }
}

function resetOptionsPackageExteriorColours(optionsPackage, exteriorColourSelectionCode) {
    var configuration = optionsPackage.configuration;
    var exteriorColourCategory = (0, _lodash.find)(configuration.options, function (optionCategory) {
        return optionCategory.id === _modelTrimItemCategories.EXTERIOR_COLOUR;
    });
    var selectedOption = exteriorColourCategory ? (0, _lodash.find)(exteriorColourCategory.itemsPackages, function (itemsPackage) {
        return itemsPackage.selectionCode === exteriorColourSelectionCode + '>' + _dataTypes.SUPPLIER_OPTION;
    }) : null;

    var exteriorColours = configuration.exteriorColours.map(function (colour) {
        return colour.set('selected', colour.colourCode === exteriorColourSelectionCode);
    });

    var options = configuration.options;
    if (!(0, _lodash.isNil)(selectedOption)) {
        options = (0, _QuoteItemCategoryService.selectQuoteItemPackage)(configuration.options, exteriorColourCategory, selectedOption);
    }

    return optionsPackage.setIn(['configuration', 'exteriorColours'], exteriorColours).setIn(['configuration', 'options'], options);
}

function resetOptionsPackageInteriorColours(optionsPackage, interiorColourSelectionCode) {
    var configuration = optionsPackage.configuration;
    var interiorColourCategory = (0, _lodash.find)(configuration.options, function (optionCategory) {
        return optionCategory.id === _modelTrimItemCategories.INTERIOR_TRIM;
    });
    var selectedOption = interiorColourCategory ? (0, _lodash.find)(interiorColourCategory.itemsPackages, function (itemsPackage) {
        return itemsPackage.selectionCode === interiorColourSelectionCode + '>' + _dataTypes.SUPPLIER_OPTION;
    }) : null;

    var interiorColours = configuration.interiorColours.map(function (colour) {
        return colour.set('selected', colour.colourCode === interiorColourSelectionCode);
    });

    var options = configuration.options;
    if (!(0, _lodash.isNil)(selectedOption)) {
        options = (0, _QuoteItemCategoryService.selectQuoteItemPackage)(configuration.options, interiorColourCategory, selectedOption);
    }

    return optionsPackage.setIn(['configuration', 'interiorColours'], interiorColours).setIn(['configuration', 'options'], options);
}

function resetOptionsPackageOptionsAvailability(optionsPackage, availableOptionsCodes, selectedOptions) {
    var validSelectedOptions = (0, _lodash.isEmpty)(selectedOptions) || (0, _lodash.isArrayLikeObject)(selectedOptions);
    if (!(0, _lodash.isArray)(availableOptionsCodes) || !validSelectedOptions) {
        return optionsPackage;
    }

    var selectedExteriorColour = (0, _lodash.find)(selectedOptions, function (selectedOption) {
        return selectedOption.typeID === FEATURE.TYPES.EXTERIOR_COLOUR;
    });
    var selectedExteriorColourCode = selectedExteriorColour ? selectedExteriorColour.code : '';
    var exteriorColourOptionsPackage = optionsPackage.configuration.exteriorColours.map(function (colour) {
        return colour.set('enabled', (0, _lodash.includes)(availableOptionsCodes, colour.colourCode)).set('selected', colour.colourCode === selectedExteriorColourCode);
    });

    var selectedInteriorColour = (0, _lodash.find)(selectedOptions, function (selectedOption) {
        return selectedOption.typeID === FEATURE.TYPES.INTERIOR_TRIM;
    });
    var selectedInteriorColourCode = selectedInteriorColour ? selectedInteriorColour.code : '';
    var interiorColourOptionsPackage = optionsPackage.configuration.interiorColours.map(function (colour) {
        return colour.set('enabled', (0, _lodash.includes)(availableOptionsCodes, colour.colourCode)).set('selected', colour.colourCode === selectedInteriorColourCode);
    });

    var options = (0, _QuoteItemCategoryService.resetQuoteItemCategoriesFromOptionsValidation)(optionsPackage.configuration.options, selectedOptions);

    if (optionsPackage.selected) {
        var newOptionsPackage = optionsPackage.setIn(['configuration', 'exteriorColours'], exteriorColourOptionsPackage).setIn(['configuration', 'interiorColours'], interiorColourOptionsPackage).setIn(['configuration', 'options'], options);

        var configPurchaseMethods = PurchaseMethodsService.resetSelectedOptions(newOptionsPackage.configuration.purchaseMethods, newOptionsPackage.configuration.getSelectedOptions(), newOptionsPackage.configuration.configurationOptions);

        configPurchaseMethods = configPurchaseMethods.set('optionsSelectionResolutions', null);
        return newOptionsPackage.setIn(['configuration', 'purchaseMethods'], configPurchaseMethods);
    }
    return optionsPackage.setIn(['configuration', 'exteriorColours'], exteriorColourOptionsPackage).setIn(['configuration', 'interiorColours'], interiorColourOptionsPackage).setIn(['configuration', 'purchaseMethods', 'optionsSelectionResolutions'], null);
}

function resetOptionsPackageOptionsSelectionResolutions(optionsPackage, resolutions) {
    if (!optionsPackage.selected || !(0, _lodash.isObjectLike)(resolutions) || (0, _lodash.isEmpty)(resolutions.resolutions)) {
        return optionsPackage.setIn(['configuration', 'purchaseMethods', 'optionsSelectionResolutions'], null);
    }

    return optionsPackage.setIn(['configuration', 'purchaseMethods', 'optionsSelectionResolutions'], resolutions);
}

function resetOptionsPackageAvailableOptions(optionsPackage, availableOptions, configurationOptions) {
    if (optionsPackage.selected) {
        return optionsPackage.setIn(['configuration', 'options'], (0, _QuoteItemCategoryService.resetQuoteItemCategoriesFromModelTrimOptions)(availableOptions)).setIn(['configuration', 'configurationOptions'], configurationOptions).setIn(['configuration', 'purchaseMethods', 'availableOptions'], availableOptions).setIn(['configuration', 'purchaseMethods', 'configurationOptions'], configurationOptions).setIn(['configuration', 'purchaseMethods', 'optionsSelectionResolutions'], null);
    }
    return optionsPackage;
}

function resetOptionsPackageOptions(optionsPackage, options) {
    if (optionsPackage.selected) {
        var newOptionsPackage = optionsPackage.setIn(['configuration', 'options'], options);
        var selectedOptions = newOptionsPackage.configuration.getSelectedOptions();
        var purchaseMethods = PurchaseMethodsService.resetSelectedOptions(optionsPackage.configuration.purchaseMethods, selectedOptions, optionsPackage.configuration.configurationOptions);

        return newOptionsPackage.setIn(['configuration', 'purchaseMethods'], purchaseMethods);
    }
    return optionsPackage;
}

function resetOptionsPackagePurchaseMethod(optionsPackage, purchaseMethod) {
    return optionsPackage.setIn(['configuration', 'purchaseMethods'], PurchaseMethodsService.selectPurchaseMethod(optionsPackage.configuration.purchaseMethods, purchaseMethod));
}

function recalculateOptionsPackagePayments(optionsPackage, paymentCalculationParameters) {
    return optionsPackage.setIn(['configuration', 'purchaseMethods'], PurchaseMethodsService.recalculatePayments(optionsPackage.configuration.purchaseMethods, paymentCalculationParameters));
}

function recalculateOptionsPackagePurchaseAmounts(optionsPackage, paymentCalculationParameters) {
    var newOptionsPackage = optionsPackage.setIn(['configuration', 'purchaseMethods'], PurchaseMethodsService.recalculatePurchaseAmounts(optionsPackage.configuration.purchaseMethods, paymentCalculationParameters));

    return recalculateOptionsPackagePayments(newOptionsPackage, paymentCalculationParameters);
}

function selectOptionsPackageKMPlan(optionsPackage, kmPlan) {
    var purchaseMethods = optionsPackage.configuration.purchaseMethods;
    var selectedFinance = purchaseMethods.getSelectedFinance();

    if (!selectedFinance) {
        return optionsPackage;
    }

    var newKMPlan = selectedFinance.getKMPlan(kmPlan);
    if (!newKMPlan) {
        return optionsPackage;
    }

    var newPurchaseMethods = purchaseMethods.lease.selected ? purchaseMethods.setIn(['lease', 'annualKMAllowed'], newKMPlan.annualKMAllowed).setIn(['lease', 'endTermKMCost'], newKMPlan.endTermKMCost).setIn(['lease', 'terms'], newKMPlan.terms) : purchaseMethods.setIn(['finance', 'annualKMAllowed'], newKMPlan.annualKMAllowed).setIn(['finance', 'endTermKMCost'], newKMPlan.endTermKMCost).setIn(['finance', 'terms'], newKMPlan.terms);

    return optionsPackage.setIn(['configuration', 'purchaseMethods'], newPurchaseMethods);
}

function resetOptionsPackageEmployeeRebateAdjustment(optionsPackage, rebateAdjustment) {
    if (optionsPackage.selected) {
        var purchaseMethods = PurchaseMethodsService.resetOptionsAmounts(optionsPackage.configuration.purchaseMethods.set('employeeRebateAdjustment', (0, _lodash.isFinite)(rebateAdjustment) ? rebateAdjustment : 0));

        return optionsPackage.setIn(['configuration', 'purchaseMethods'], purchaseMethods);
    }
    return optionsPackage;
}

function resetOptionsPackagePercentageRebateAdjustment(optionsPackage, rebateAdjustment) {
    if (optionsPackage.selected) {
        var purchaseMethods = PurchaseMethodsService.resetOptionsAmounts(optionsPackage.configuration.purchaseMethods.setIn(['cashPurchase', 'optionsAdjustmentDiscounts'], (0, _lodash.isFinite)(rebateAdjustment) ? rebateAdjustment : 0));

        return optionsPackage.setIn(['configuration', 'purchaseMethods'], purchaseMethods);
    }
    return optionsPackage;
}
exports.default = {
    resetOptionsPackageFromOriginData: resetOptionsPackageFromOriginData,
    resetOptionsPackageExteriorColours: resetOptionsPackageExteriorColours,
    resetOptionsPackageInteriorColours: resetOptionsPackageInteriorColours,
    resetOptionsPackageOptionsAvailability: resetOptionsPackageOptionsAvailability,
    resetOptionsPackageOptionsSelectionResolutions: resetOptionsPackageOptionsSelectionResolutions,
    resetOptionsPackageAvailableOptions: resetOptionsPackageAvailableOptions,
    resetOptionsPackageOptions: resetOptionsPackageOptions,
    resetOptionsPackagePurchaseMethod: resetOptionsPackagePurchaseMethod,
    recalculateOptionsPackagePayments: recalculateOptionsPackagePayments,
    recalculateOptionsPackagePurchaseAmounts: recalculateOptionsPackagePurchaseAmounts,
    selectOptionsPackageKMPlan: selectOptionsPackageKMPlan,
    resetOptionsPackageEmployeeRebateAdjustment: resetOptionsPackageEmployeeRebateAdjustment,
    resetOptionsPackagePercentageRebateAdjustment: resetOptionsPackagePercentageRebateAdjustment
};

/***/ }),

/***/ "./src/ModelYear/services/OptionsSelectionResolutionService/OptionsSelectionResolutionService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetResolutionOptionsFromResolutionData = resetResolutionOptionsFromResolutionData;

var _lodash = __webpack_require__("lodash");

var _OptionsSelectionResolutionModel = __webpack_require__("./src/ModelYear/models/OptionsSelectionResolutionModel.js");

var _OptionsSelectionResolutionModel2 = _interopRequireDefault(_OptionsSelectionResolutionModel);

var _OptionService = __webpack_require__("./src/ModelYear/services/OptionService/OptionService.js");

var OptionService = _interopRequireWildcard(_OptionService);

var _dataTypes = __webpack_require__("./src/constants/dataTypes.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint no-bitwise: 0 */

var FEATURE = _dataTypes.DATA_TYPES.FEATURE;
function resetResolutionOptionsFromResolutionData(resolution, configurationOptionsSelectionCodes, originalOptionsSelectionCodes, triggerSelectionCode) {
    var optionsSelectionResolution = new _OptionsSelectionResolutionModel2.default();
    if ((0, _lodash.isEmpty)(resolution) || !(0, _lodash.isArrayLikeObject)(resolution.items) || !(0, _lodash.isArrayLike)(configurationOptionsSelectionCodes) || !(0, _lodash.isArrayLike)(originalOptionsSelectionCodes)) {
        return optionsSelectionResolution;
    }

    var options = (0, _lodash.map)(resolution.items, function (option) {
        return OptionService.resetOptionFromOptionData(option);
    });

    var nonDefaultOptions = (0, _lodash.filter)(options, function (option) {
        return !(0, _lodash.includes)(configurationOptionsSelectionCodes, option.selectionCode);
    });

    var newlyAddedOptions = (0, _lodash.filter)(nonDefaultOptions, function (option) {
        return option.selected && !(0, _lodash.includes)(originalOptionsSelectionCodes, option.selectionCode);
    });
    var newlyAddedOptionsSelectionCodes = (0, _lodash.map)(newlyAddedOptions, function (newlyAddedOption) {
        return newlyAddedOption.selectionCode;
    });

    var newlyRemovedOptions = (0, _lodash.filter)(nonDefaultOptions, function (option) {
        return !option.selected && (0, _lodash.includes)(originalOptionsSelectionCodes, option.selectionCode);
    });
    var newlyRemovedOptionsSelectionCodes = (0, _lodash.map)(newlyRemovedOptions, function (newlyRemovedOption) {
        return newlyRemovedOption.selectionCode;
    });

    var resolvedOptionsSelectionCodes = (0, _lodash.map)(resolution.resolvedItems, function (option) {
        return option.item;
    });
    var actionOptions = (0, _lodash.filter)(nonDefaultOptions, function (nonDefaultOption) {
        return (0, _lodash.includes)(resolvedOptionsSelectionCodes, nonDefaultOption.selectionCode);
    });

    var addedCodes = (0, _lodash.join)((0, _lodash.map)(newlyAddedOptions, function (newlyAddedOption) {
        return newlyAddedOption.selectionCode;
    }), '|');
    var removedCodes = (0, _lodash.join)((0, _lodash.map)(newlyRemovedOptions, function (newlyRemovedOption) {
        return newlyRemovedOption.selectionCode;
    }), '|');

    var isCancel = newlyAddedOptionsSelectionCodes.length === 1 && (0, _lodash.includes)(newlyAddedOptionsSelectionCodes, triggerSelectionCode) || newlyRemovedOptionsSelectionCodes.length === 1 && (0, _lodash.includes)(newlyRemovedOptionsSelectionCodes, triggerSelectionCode);

    var id = '';
    if (addedCodes || removedCodes) {
        id = 'A' + addedCodes + '-R' + removedCodes;
    }

    var exteriorColourOptions = (0, _lodash.filter)(newlyRemovedOptions, function (option) {
        return option.dataType === FEATURE.DATA_TYPE_ID && option.typeID === FEATURE.TYPES.EXTERIOR_COLOUR;
    });
    var availableExteriorColours = [];
    if (!(0, _lodash.isEmpty)(exteriorColourOptions)) {
        availableExteriorColours = (0, _lodash.filter)(nonDefaultOptions, function (option) {
            return option.dataType === FEATURE.DATA_TYPE_ID && option.typeID === FEATURE.TYPES.EXTERIOR_COLOUR && (option.flag & _dataTypes.ITEM_FLAG.AVAILABLE) === _dataTypes.ITEM_FLAG.AVAILABLE;
        });
    }

    var interiorColourOptions = (0, _lodash.filter)(newlyRemovedOptions, function (option) {
        return option.dataType === FEATURE.DATA_TYPE_ID && option.typeID === FEATURE.TYPES.INTERIOR_TRIM;
    });
    var availableInteriorColours = [];
    if (!(0, _lodash.isEmpty)(interiorColourOptions)) {
        availableInteriorColours = (0, _lodash.filter)(nonDefaultOptions, function (option) {
            return option.dataType === FEATURE.DATA_TYPE_ID && option.typeID === FEATURE.TYPES.INTERIOR_TRIM && (option.flag & _dataTypes.ITEM_FLAG.AVAILABLE) === _dataTypes.ITEM_FLAG.AVAILABLE;
        });
    }

    return optionsSelectionResolution.set('id', id).set('isCancel', isCancel).set('addedOptions', newlyAddedOptions).set('removedOptions', newlyRemovedOptions).set('resolutionActionOptions', actionOptions).set('isExteriorColour', !(0, _lodash.isEmpty)(exteriorColourOptions)).set('availableExteriorColours', availableExteriorColours).set('isInteriorColour', !(0, _lodash.isEmpty)(interiorColourOptions)).set('availableInteriorColours', availableInteriorColours);
}

exports.default = {
    resetResolutionOptionsFromResolutionData: resetResolutionOptionsFromResolutionData
};

/***/ }),

/***/ "./src/ModelYear/services/OptionsSelectionResolutionsService/OptionsSelectionResolutionsService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetResolutionOptionsFromResolutionsData = resetResolutionOptionsFromResolutionsData;

var _lodash = __webpack_require__("lodash");

var _OptionsSelectionResolutionService = __webpack_require__("./src/ModelYear/services/OptionsSelectionResolutionService/OptionsSelectionResolutionService.js");

var _OptionsSelectionResolutionsModel = __webpack_require__("./src/ModelYear/models/OptionsSelectionResolutionsModel.js");

var _OptionsSelectionResolutionsModel2 = _interopRequireDefault(_OptionsSelectionResolutionsModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint no-bitwise: 0 */

function resetResolutionOptionsFromResolutionsData(resolutions, configuration, triggerSelectionCode) {
    var optionsSelectionResolutions = new _OptionsSelectionResolutionsModel2.default();
    if ((0, _lodash.isEmpty)(resolutions) || !(0, _lodash.isArrayLikeObject)(resolutions) || !(0, _lodash.isObjectLike)(configuration) || (0, _lodash.isEmpty)(configuration.selectionCode)) {
        return optionsSelectionResolutions;
    }
    var configurationOptionsSelectionCodes = configuration.getConfigurationOptionsSelectionCodes();
    var originalOptionsSelectionCodes = configuration.getOptionsSelectionCodes();

    var convertedResolutions = (0, _lodash.map)(resolutions, function (resolution) {
        return (0, _OptionsSelectionResolutionService.resetResolutionOptionsFromResolutionData)(resolution, configurationOptionsSelectionCodes, originalOptionsSelectionCodes, triggerSelectionCode);
    });

    // Failed resolution from bad data
    var validResolutions = (0, _lodash.find)(convertedResolutions, function (convertedResolution) {
        return !convertedResolution.isCancel;
    });
    if (!validResolutions) {
        var cancelResolution = convertedResolutions[0];
        var invalidResolution = cancelResolution.set('isCancel', false);

        return optionsSelectionResolutions.set('triggeredFromOptionAdd', (0, _lodash.includes)(originalOptionsSelectionCodes, triggerSelectionCode)).set('resolutionTriggerOptionSelectionCode', triggerSelectionCode).set('resolutions', [cancelResolution, invalidResolution]);
    }

    var nonColourResolutions = (0, _lodash.filter)(convertedResolutions, function (convertedResolution) {
        return !convertedResolution.isExteriorColour && !convertedResolution.isInteriorColour;
    });

    var exteriorColourResolutions = [];
    var exteriorColourResolution = (0, _lodash.find)(convertedResolutions, function (convertedResolution) {
        return convertedResolution.isExteriorColour;
    });
    if (exteriorColourResolution) {
        exteriorColourResolutions = (0, _lodash.isEmpty)(exteriorColourResolution.availableExteriorColours) ? [exteriorColourResolution] : (0, _lodash.map)(exteriorColourResolution.availableExteriorColours, function (availableExteriorColour) {
            return exteriorColourResolution.set('id', 'A' + availableExteriorColour.selectionCode + '-' + exteriorColourResolution.id).set('addedOptions', (0, _lodash.concat)(exteriorColourResolution.addedOptions, availableExteriorColour)).set('resolutionActionOptions', (0, _lodash.concat)(exteriorColourResolution.resolutionActionOptions, availableExteriorColour.set('selected', true)));
        });
    }

    var interiorColourResolutions = [];
    var interiorColourResolution = (0, _lodash.find)(convertedResolutions, function (convertedResolution) {
        return convertedResolution.isInteriorColour;
    });
    if (interiorColourResolution) {
        interiorColourResolutions = (0, _lodash.isEmpty)(interiorColourResolution.availableInteriorColours) ? [interiorColourResolution] : (0, _lodash.map)(interiorColourResolution.availableInteriorColours, function (availableInteriorColour) {
            return interiorColourResolution.set('id', 'A' + availableInteriorColour.selectionCode + '-' + interiorColourResolution.id).set('addedOptions', (0, _lodash.concat)(interiorColourResolution.addedOptions, availableInteriorColour)).set('resolutionActionOptions', (0, _lodash.concat)(interiorColourResolution.resolutionActionOptions, availableInteriorColour.set('selected', true)));
        });
    }

    return optionsSelectionResolutions.set('triggeredFromOptionAdd', (0, _lodash.includes)(originalOptionsSelectionCodes, triggerSelectionCode)).set('resolutionTriggerOptionSelectionCode', triggerSelectionCode).set('resolutions', (0, _lodash.concat)(nonColourResolutions, exteriorColourResolutions, interiorColourResolutions));
}

exports.default = {
    resetResolutionOptionsFromResolutionsData: resetResolutionOptionsFromResolutionsData
};

/***/ }),

/***/ "./src/ModelYear/services/TransmissionService/TransmissionService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetTransmissionFromConfigurationData = resetTransmissionFromConfigurationData;

var _lodash = __webpack_require__("lodash");

var _dataConversions = __webpack_require__("./src/constants/dataConversions.js");

var _DataUtilitiesService = __webpack_require__("./src/ModelYear/services/DataUtilitiesService/DataUtilitiesService.js");

var _TransmissionModel = __webpack_require__("./src/ModelYear/models/TransmissionModel.js");

var _TransmissionModel2 = _interopRequireDefault(_TransmissionModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint import/prefer-default-export: 0 */

function resetTransmissionFromConfigurationData(configurationTransmissionData) {
    if ((0, _lodash.isEmpty)(configurationTransmissionData) || configurationTransmissionData.length <= _dataConversions.TRANSMISSION_DATA.DESCRIPTION) {
        return new _TransmissionModel2.default();
    }

    var selectionCode = configurationTransmissionData[_dataConversions.TRANSMISSION_DATA.TYPE_CODE] + '-' + (configurationTransmissionData[_dataConversions.TRANSMISSION_DATA.SPEEDS] + '-') + ('' + configurationTransmissionData[_dataConversions.TRANSMISSION_DATA.IS_CVT]);

    return new _TransmissionModel2.default({
        selectionCode: selectionCode,
        code: '',
        typeCode: configurationTransmissionData[_dataConversions.TRANSMISSION_DATA.TYPE_CODE],
        rank: configurationTransmissionData[_dataConversions.TRANSMISSION_DATA.TYPE_CODE] === 'MA' ? 1 : 2,
        type: configurationTransmissionData[_dataConversions.TRANSMISSION_DATA.TYPE],
        speeds: configurationTransmissionData[_dataConversions.TRANSMISSION_DATA.SPEEDS],
        isCVT: configurationTransmissionData[_dataConversions.TRANSMISSION_DATA.IS_CVT],
        description: (0, _DataUtilitiesService.getDescriptionData)(configurationTransmissionData[_dataConversions.TRANSMISSION_DATA.DESCRIPTION])
    });
}

exports.default = {
    resetTransmissionFromConfigurationData: resetTransmissionFromConfigurationData
};

/***/ }),

/***/ "./src/ModelYear/services/YearService/YearService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetYearFromOriginData = resetYearFromOriginData;
exports.resetYearPurchaseMethod = resetYearPurchaseMethod;
exports.recalculateYearPayments = recalculateYearPayments;
exports.recalculateYearPurchaseAmounts = recalculateYearPurchaseAmounts;

var _lodash = __webpack_require__("lodash");

var _apiDataConversionConstants = __webpack_require__("./src/constants/apiDataConversionConstants.js");

var Constants = _interopRequireWildcard(_apiDataConversionConstants);

var _dataOrigins = __webpack_require__("./src/constants/dataOrigins.js");

var DataOrigins = _interopRequireWildcard(_dataOrigins);

var _exteriorColourStatuses = __webpack_require__("./src/ModelYear/constants/exteriorColourStatuses.js");

var _purchaseMethodsValues = __webpack_require__("./src/PurchaseMethods/constants/purchaseMethodsValues.js");

var _purchaseMethodsValues2 = _interopRequireDefault(_purchaseMethodsValues);

var _YearModel = __webpack_require__("./src/ModelYear/models/YearModel.js");

var _YearModel2 = _interopRequireDefault(_YearModel);

var _PurchaseMethodsService = __webpack_require__("./src/PurchaseMethods/services/PurchaseMethodsService/PurchaseMethodsService.js");

var PurchaseMethodsService = _interopRequireWildcard(_PurchaseMethodsService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function resetYearFromCollectionData(collectionData, year, disclaimers) {
    var exteriorColours = {
        photo1: '',
        photo2: '',
        photo3: ''
    };
    var exteriorColourStatus = 0;

    if (collectionData[Constants.VIEW_1.VEHICLE.HIGH_PRICE]) {
        var highPriceObject = collectionData[Constants.VIEW_1.VEHICLE.HIGH_PRICE][Constants.VIEW_1.VEHICLE.HIGH_PRICE_INDEX];
        exteriorColours.photo1 = highPriceObject[Constants.VIEW_1.VEHICLE.URL_EXTERIOR_COLOUR][Constants.VIEW_1.COLOUR_IMAGE.PHOTO_1];
        exteriorColours.photo2 = highPriceObject[Constants.VIEW_1.VEHICLE.URL_EXTERIOR_COLOUR][Constants.VIEW_1.COLOUR_IMAGE.PHOTO_2];
        exteriorColours.photo3 = highPriceObject[Constants.VIEW_1.VEHICLE.URL_EXTERIOR_COLOUR][Constants.VIEW_1.COLOUR_IMAGE.PHOTO_3];

        if (!(0, _lodash.isUndefined)(highPriceObject[Constants.VIEW_1.VEHICLE.EXTERIOR_COLOUR_STATUS])) {
            exteriorColourStatus = highPriceObject[Constants.VIEW_1.VEHICLE.EXTERIOR_COLOUR_STATUS];
        } else if (exteriorColours.photo1) {
            exteriorColourStatus = _exteriorColourStatuses.IMAGE_STATUS.FULL_COLORIZED;
        }
    }

    var highRebate = 0;
    var highRebatePurchaseMethod = _purchaseMethodsValues2.default.CASH;
    if (collectionData[Constants.VIEW_1.VEHICLE.HIGH_REBATE]) {
        var highRebateObject = collectionData[Constants.VIEW_1.VEHICLE.HIGH_REBATE][Constants.VIEW_1.VEHICLE.HIGH_REBATE_INDEX];
        var highRebateTaxes = highRebateObject[Constants.VIEW_1.VEHICLE.HIGH_REBATE_REBATES_TAXES] || 0;
        highRebate = highRebateObject[Constants.VIEW_1.VEHICLE.HIGH_REBATE_RETAIL] + highRebateTaxes;
        highRebatePurchaseMethod = highRebateObject[Constants.VIEW_1.VEHICLE.HIGH_REBATE_PURCHASE_METHOD];
    }

    var modelTrimPurchaseMethodIds = [];

    if (collectionData[Constants.VIEW_1.VEHICLE.PRICE] && collectionData[Constants.VIEW_1.VEHICLE.PRICE][Constants.VIEW_1.VEHICLE.PRICE_INDEX]) {
        var price = collectionData[Constants.VIEW_1.VEHICLE.PRICE][Constants.VIEW_1.VEHICLE.PRICE_INDEX];
        modelTrimPurchaseMethodIds.push({
            purchaseMethod: _purchaseMethodsValues2.default.CASH,
            modelTrimCode: price[Constants.VIEW_1.VEHICLE.PRICE_MODEL_TRIM_CODE],
            configurationId: price[Constants.VIEW_1.VEHICLE.PRICE_CONFIGURATION_ID]
        });
    }

    if (collectionData[Constants.VIEW_1.VEHICLE.FINANCE] && collectionData[Constants.VIEW_1.VEHICLE.FINANCE][Constants.VIEW_1.VEHICLE.FINANCE_INDEX]) {
        var finance = collectionData[Constants.VIEW_1.VEHICLE.FINANCE][Constants.VIEW_1.VEHICLE.FINANCE_INDEX];
        modelTrimPurchaseMethodIds.push({
            purchaseMethod: _purchaseMethodsValues2.default.FINANCE,
            modelTrimCode: finance[Constants.VIEW_1.VEHICLE.FINANCE_MODEL_TRIM_CODE],
            configurationId: finance[Constants.VIEW_1.VEHICLE.FINANCE_CONFIGURATION_ID]
        });
    }

    if (collectionData[Constants.VIEW_1.VEHICLE.LEASE] && collectionData[Constants.VIEW_1.VEHICLE.LEASE][Constants.VIEW_1.VEHICLE.LEASE_INDEX]) {
        var lease = collectionData[Constants.VIEW_1.VEHICLE.LEASE][Constants.VIEW_1.VEHICLE.LEASE_INDEX];
        modelTrimPurchaseMethodIds.push({
            purchaseMethod: _purchaseMethodsValues2.default.LEASE,
            modelTrimCode: lease[Constants.VIEW_1.VEHICLE.LEASE_MODEL_TRIM_CODE],
            configurationId: lease[Constants.VIEW_1.VEHICLE.LEASE_CONFIGURATION_ID]
        });
    }

    return new _YearModel2.default({
        year: year,
        make: collectionData.make,
        model: collectionData.model,
        bodyStyleCode: collectionData.bodyStyleCode,
        bodyStyle: collectionData.bodyStyle[Constants.DESCRIPTION_LANGUAGE_INDEX],
        modelTrimPurchaseMethodIds: modelTrimPurchaseMethodIds,
        exteriorColours: exteriorColours,
        exteriorColourStatus: exteriorColourStatus,
        highRebate: highRebate,
        highRebatePurchaseMethod: highRebatePurchaseMethod,
        purchaseMethods: PurchaseMethodsService.resetPurchaseMethodsFromOriginData(DataOrigins.MODELS_COLLECTION, collectionData, undefined, disclaimers)
    });
}

function resetYearFromOriginData(dataOrigin, originYearData, year, disclaimers) {
    if ((0, _lodash.isEmpty)(originYearData) || !(0, _lodash.isObjectLike)(originYearData)) {
        return new _YearModel2.default();
    }

    switch (dataOrigin) {
        case DataOrigins.MODELS_COLLECTION:
            return resetYearFromCollectionData(originYearData, year, disclaimers);

        case DataOrigins.MODEL_YEAR_POWERS_TRIMS:
            return new _YearModel2.default();

        default:
            return new _YearModel2.default();
    }
}

function resetYearPurchaseMethod(year, purchaseMethod) {
    return year.set('purchaseMethods', PurchaseMethodsService.selectPurchaseMethod(year.purchaseMethods, purchaseMethod));
}

function recalculateYearPayments(year, paymentCalculationParameters) {
    var newPaymentCalculationParameters = paymentCalculationParameters;
    var selectedLeaseTerm = void 0;
    var selectedFinanceTerm = void 0;
    if (!(0, _lodash.find)(year.purchaseMethods.lease.terms, function (term) {
        return term.term === paymentCalculationParameters.selectedLeaseTerm;
    })) {
        selectedLeaseTerm = (0, _lodash.last)(year.purchaseMethods.lease.terms).term;
    }
    if (!(0, _lodash.find)(year.purchaseMethods.finance.terms, function (term) {
        return term.term === paymentCalculationParameters.selectedFinanceTerm;
    })) {
        selectedFinanceTerm = (0, _lodash.last)(year.purchaseMethods.finance.terms).term;
    }
    if (selectedLeaseTerm || selectedFinanceTerm) {
        newPaymentCalculationParameters = (0, _lodash.clone)(paymentCalculationParameters);
        newPaymentCalculationParameters.selectedLeaseTerm = selectedLeaseTerm || newPaymentCalculationParameters.selectedLeaseTerm;
        newPaymentCalculationParameters.selectedFinanceTerm = selectedFinanceTerm || newPaymentCalculationParameters.selectedFinanceTerm;
    }

    return year.set('purchaseMethods', PurchaseMethodsService.recalculatePayments(year.purchaseMethods, newPaymentCalculationParameters));
}

function recalculateYearPurchaseAmounts(year, paymentCalculationParameters) {
    var newYear = year.set('purchaseMethods', PurchaseMethodsService.recalculatePurchaseAmounts(year.purchaseMethods, paymentCalculationParameters));

    return recalculateYearPayments(newYear, paymentCalculationParameters);
}

exports.default = {
    resetYearFromOriginData: resetYearFromOriginData,
    resetYearPurchaseMethod: resetYearPurchaseMethod,
    recalculateYearPayments: recalculateYearPayments,
    recalculateYearPurchaseAmounts: recalculateYearPurchaseAmounts
};

/***/ }),

/***/ "./src/PurchaseMethods/actions/purchaseMethodsActionTypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var LOAD_PURCHASE_METHODS_SUCCESS = exports.LOAD_PURCHASE_METHODS_SUCCESS = 'LOAD_PURCHASE_METHODS_SUCCESS';

var SELECT_PURCHASE_METHOD = exports.SELECT_PURCHASE_METHOD = 'SELECT_PURCHASE_METHOD';
var SELECT_PAYMENT_FREQUENCY = exports.SELECT_PAYMENT_FREQUENCY = 'SELECT_PAYMENT_FREQUENCY';
var SELECT_TERM = exports.SELECT_TERM = 'SELECT_TERM';
var SELECT_KM_PLAN = exports.SELECT_KM_PLAN = 'SELECT_KM_PLAN';

var SET_CASH_DOWN = exports.SET_CASH_DOWN = 'SET_CASH_DOWN';
var SET_TRADE_IN = exports.SET_TRADE_IN = 'SET_TRADE_IN';
var SET_LIEN = exports.SET_LIEN = 'SET_LIEN';
var SET_EXTERIOR_COLOUR_AMOUNTS = exports.SET_EXTERIOR_COLOUR_AMOUNTS = 'SET_EXTERIOR_COLOUR_AMOUNTS';
var SET_INTERIOR_COLOUR_AMOUNTS = exports.SET_INTERIOR_COLOUR_AMOUNTS = 'SET_INTERIOR_COLOUR_AMOUNTS';
var SET_OPTIONS_AMOUNTS = exports.SET_OPTIONS_AMOUNTS = 'SET_OPTIONS_AMOUNTS';

var SET_DELIVERY_FEE = exports.SET_DELIVERY_FEE = 'SET_DELIVERY_FEE';
var SET_DEPOSIT = exports.SET_DEPOSIT = 'SET_DEPOSIT';

var SET_TAXES_INCLUDED = exports.SET_TAXES_INCLUDED = 'SET_TAXES_INCLUDED';

var SELECT_OPTIONS_RESOLUTION = exports.SELECT_OPTIONS_RESOLUTION = 'SELECT_OPTIONS_RESOLUTION';

var RESET_SELECTED_INCENTIVE_REBATES = exports.RESET_SELECTED_INCENTIVE_REBATES = 'RESET_SELECTED_INCENTIVE_REBATES';

var QUOTE_UPDATE_TYPES = exports.QUOTE_UPDATE_TYPES = [SELECT_PURCHASE_METHOD, SELECT_PAYMENT_FREQUENCY, SELECT_TERM, SELECT_KM_PLAN, SET_CASH_DOWN, SET_TRADE_IN, SET_LIEN, SET_TAXES_INCLUDED, SELECT_OPTIONS_RESOLUTION];

exports.default = {
    LOAD_PURCHASE_METHODS_SUCCESS: LOAD_PURCHASE_METHODS_SUCCESS,
    SELECT_PURCHASE_METHOD: SELECT_PURCHASE_METHOD,
    SELECT_PAYMENT_FREQUENCY: SELECT_PAYMENT_FREQUENCY,
    SELECT_TERM: SELECT_TERM,
    SELECT_KM_PLAN: SELECT_KM_PLAN,
    SET_CASH_DOWN: SET_CASH_DOWN,
    SET_TRADE_IN: SET_TRADE_IN,
    SET_LIEN: SET_LIEN,
    SET_EXTERIOR_COLOUR_AMOUNTS: SET_EXTERIOR_COLOUR_AMOUNTS,
    SET_INTERIOR_COLOUR_AMOUNTS: SET_INTERIOR_COLOUR_AMOUNTS,
    SET_OPTIONS_AMOUNTS: SET_OPTIONS_AMOUNTS,
    SET_DELIVERY_FEE: SET_DELIVERY_FEE,
    SET_DEPOSIT: SET_DEPOSIT,
    SET_TAXES_INCLUDED: SET_TAXES_INCLUDED,
    SELECT_OPTIONS_RESOLUTION: SELECT_OPTIONS_RESOLUTION,
    RESET_SELECTED_INCENTIVE_REBATES: RESET_SELECTED_INCENTIVE_REBATES,
    QUOTE_UPDATE_TYPES: QUOTE_UPDATE_TYPES
};

/***/ }),

/***/ "./src/PurchaseMethods/actions/purchaseMethodsActions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadPurchaseMethodsSuccess = loadPurchaseMethodsSuccess;
exports.selectPurchaseMethod = selectPurchaseMethod;
exports.selectTerm = selectTerm;
exports.selectPaymentFrequency = selectPaymentFrequency;
exports.setCashDown = setCashDown;
exports.setTradeIn = setTradeIn;
exports.setLien = setLien;
exports.setExteriorColourAmounts = setExteriorColourAmounts;
exports.setInteriorColourAmounts = setInteriorColourAmounts;
exports.setOptionsAmounts = setOptionsAmounts;
exports.setDeliveryFee = setDeliveryFee;
exports.setDeposit = setDeposit;
exports.setTaxesIncluded = setTaxesIncluded;
exports.setKMPlan = setKMPlan;
exports.selectOptionsResolution = selectOptionsResolution;
exports.resetIncentivesRebates = resetIncentivesRebates;

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _modelYearActions = __webpack_require__("./src/ModelYear/actions/modelYearActions.js");

var _quoteActions = __webpack_require__("./src/Quote/actions/quoteActions.js");

var _purchaseMethodsActionTypes = __webpack_require__("./src/PurchaseMethods/actions/purchaseMethodsActionTypes.js");

var purchaseMethodsTypes = _interopRequireWildcard(_purchaseMethodsActionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function loadPurchaseMethodsSuccess(purchaseMethods) {
    return { type: purchaseMethodsTypes.LOAD_PURCHASE_METHODS_SUCCESS, purchaseMethods: purchaseMethods };
}

function selectPurchaseMethod(purchaseMethod) {
    return function (dispatch, getState) {
        dispatch({ type: purchaseMethodsTypes.SELECT_PURCHASE_METHOD, purchaseMethod: purchaseMethod });
        dispatch((0, _modelYearActions.validateSelectedOptions)()).then(function () {
            var state = getState();
            var selectedOptionsPackage = state.modelYear.getSelectedOptionsPackage();
            dispatch(loadPurchaseMethodsSuccess(selectedOptionsPackage.configuration.purchaseMethods));
            dispatch((0, _quoteActions.setQuoteModified)());
        });
    };
}

function selectTerm(term) {
    return { type: purchaseMethodsTypes.SELECT_TERM, term: term };
}

function selectPaymentFrequency(paymentFrequency) {
    return { type: purchaseMethodsTypes.SELECT_PAYMENT_FREQUENCY, paymentFrequency: paymentFrequency };
}

function setCashDown(cashDown) {
    return { type: purchaseMethodsTypes.SET_CASH_DOWN, cashDown: cashDown };
}

function setTradeIn(tradeIn) {
    var windowProxy = _widgetCommonsCoreServices.WindowProxy.get();
    if (windowProxy && windowProxy.localStorage) {
        windowProxy.localStorage.setItem('tradeIn', parseInt(tradeIn, 10));
    }
    return { type: purchaseMethodsTypes.SET_TRADE_IN, tradeIn: tradeIn };
}

function setLien(lien) {
    var windowProxy = _widgetCommonsCoreServices.WindowProxy.get();
    if (windowProxy && windowProxy.localStorage) {
        windowProxy.localStorage.setItem('lien', parseInt(lien, 10));
    }
    return { type: purchaseMethodsTypes.SET_LIEN, lien: lien };
}

function setExteriorColourAmounts(exteriorColourAmounts) {
    return { type: purchaseMethodsTypes.SET_EXTERIOR_COLOUR_AMOUNTS, exteriorColourAmounts: exteriorColourAmounts };
}

function setInteriorColourAmounts(interiorColourAmounts) {
    return { type: purchaseMethodsTypes.SET_INTERIOR_COLOUR_AMOUNTS, interiorColourAmounts: interiorColourAmounts };
}

function setOptionsAmounts(optionsAmounts) {
    return { type: purchaseMethodsTypes.SET_OPTIONS_AMOUNTS, optionsAmounts: optionsAmounts };
}

function setDeliveryFee(addFee) {
    return { type: purchaseMethodsTypes.SET_DELIVERY_FEE, addFee: addFee };
}

function setDeposit(deposit) {
    return { type: purchaseMethodsTypes.SET_DEPOSIT, deposit: deposit };
}

function setTaxesIncluded(taxesIncluded) {
    return { type: purchaseMethodsTypes.SET_TAXES_INCLUDED, taxesIncluded: taxesIncluded };
}

function setKMPlan(kmPlan) {
    return { type: purchaseMethodsTypes.SELECT_KM_PLAN, kmPlan: kmPlan };
}

function selectOptionsResolution(resolutionId) {
    return { type: purchaseMethodsTypes.SELECT_OPTIONS_RESOLUTION, resolutionId: resolutionId };
}

function resetIncentivesRebates() {
    return { type: purchaseMethodsTypes.RESET_SELECTED_INCENTIVE_REBATES };
}

exports.default = {
    loadPurchaseMethodsSuccess: loadPurchaseMethodsSuccess,
    selectPurchaseMethod: selectPurchaseMethod,
    selectTerm: selectTerm,
    selectPaymentFrequency: selectPaymentFrequency,
    setCashDown: setCashDown,
    setTradeIn: setTradeIn,
    setLien: setLien,
    setExteriorColourAmounts: setExteriorColourAmounts,
    setInteriorColourAmounts: setInteriorColourAmounts,
    setOptionsAmounts: setOptionsAmounts,
    setDeliveryFee: setDeliveryFee,
    setDeposit: setDeposit,
    setTaxesIncluded: setTaxesIncluded,
    setKMPlan: setKMPlan,
    selectOptionsResolution: selectOptionsResolution,
    resetIncentivesRebates: resetIncentivesRebates
};

/***/ }),

/***/ "./src/PurchaseMethods/constants/dataConversions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var MODEL_TERM = exports.MODEL_TERM = {
    APR: 0,
    TERM: 1,
    DISCOUNT: 3,
    REBATE: 4,
    REBATE_AT_DELIVERY: 5,
    CASH_DOWN: 6,
    PAYMENT_FREQUENCIES: 7,
    RESIDUAL_RATE: 8,
    FINANCED_AMOUNT: 9,
    FINANCED_AMOUNT_WITH_TAXES: 10,
    RESIDUAL_AMOUNT: 11,
    CREDIT_RATE: 12,
    CREDIT_RATE_WITH_CASH_REBATE_ADJUSTMENT: 13,
    CREDIT_RATE_WITH_CASH_REBATE_ADJUSTMENT_TAXES: 14,
    INCLUDED_CODES: 15,
    REBATES_DETAILS: 16,
    REBATE_TAXES: 17,
    REBATE_TAXES_AT_DELIVERY: 18,
    REBATE_AT_STANDARD_RATE: 19
};

var COLLECTION_FREQUENCY = exports.COLLECTION_FREQUENCY = {
    PAYMENT_FREQUENCY: 0,
    BASE_PAYMENT: 1,
    FEES_PAYMENT: 2,
    DUTIES_PAYMENT: 3,
    PAYMENT_TAXES: 4,
    FINANCE_FACTOR: 5,
    BALLOON_FACTOR: 6,
    DISCLAIMERS: 12
};

var CALCULATOR_FREQUENCY = exports.CALCULATOR_FREQUENCY = {
    PAYMENT_FREQUENCY: 'paymentPerYear',
    PAYMENT: 'payment',
    PAYMENT_TAXES: 'taxes',
    CASH_DOWN: 'cashDown',
    FINANCE_FACTOR: 'finFactor',
    BALLOON_FACTOR: 'balloonFactor',
    DISCLAIMER: 'disclaimer'
};

var MODEL_FREQUENCY = exports.MODEL_FREQUENCY = {
    PAYMENT_FREQUENCY: 0,
    PAYMENT: 1,
    PAYMENT_TAXES: 2,
    FINANCE_FACTOR: 3,
    BALLOON_FACTOR: 4
};

var COLLECTION_FINANCE = exports.COLLECTION_FINANCE = {
    FINANCE: 'finance',
    LEASE: 'lease',
    INDEX: 0,
    TERMS: 6,
    BEST_TERM: 7,
    BEST_TERM_INDEX: 8,
    BEST_TERM_WITH_CASH: 9,
    BEST_TERM_WITH_CASH_INDEX: 10,
    PHOTO_URLS: 11,
    FINANCE_DISCLAIMERS: 12,
    LEASE_DISCLAIMERS: 18,
    LEASE_ANNUAL_KM: 12,
    LEASE_MAX_EXCEEDING_KM: 13,
    LEASE_MAX_TERM_KM: 14,
    LEASE_ALLOW_EXCEEDING_KM: 15,
    LEASE_MAX_TERM_EXCEEDING_KM: 16,
    LEASE_END_TERM_KM_COST: 17
};

var CALCULATOR_FINANCE = exports.CALCULATOR_FINANCE = {
    VEHICLE: 'vehicle',
    FINANCE: 'finance',
    LEASE: 'lease'
};

var VEHICLE_FINANCE = exports.VEHICLE_FINANCE = {
    FINANCE: 'finance',
    LEASE: 'lease',
    INDEX: 0,
    TERMS: 0
};

var MODEL_FINANCE = exports.MODEL_FINANCE = {
    FINANCE: 16,
    LEASE: 17,
    INDEX: 0,
    TERMS: 0,
    LEASE_ANNUAL_KM: 1,
    LEASE_MAX_EXCEEDING_KM: 2,
    LEASE_MAX_TERM_KM: 3,
    LEASE_ALLOW_EXCEEDING_KM: 4,
    LEASE_MAX_TERM_EXCEEDING_KM: 5,
    LEASE_END_TERM_KM_COST: 6
};

var MODEL_CASH_PURCHASE = exports.MODEL_CASH_PURCHASE = {
    PRICING: 15,
    RETAIL: 0,
    DISCOUNTS: 1,
    REBATES: 2,
    REBATES_AT_DELIVERY: 3,
    INCLUDED_CODES: 4,
    REBATES_DETAILS: 5,
    REBATES_TAXES: 6,
    DEALER_FEES: 7
};

var VEHICLE_CASH_PURCHASE = exports.VEHICLE_CASH_PURCHASE = {
    PRICING: 'price'
};

var COLLECTION_CASH_PURCHASE = exports.COLLECTION_CASH_PURCHASE = {
    PRICING: 'price',
    INDEX: 0,
    RETAIL: 6,
    REBATES: 7,
    AMOUNTS: 9,
    MSRP: 0,
    FREIGHT_PDI: 1,
    TAXES_AND_DUTIES: 2,
    DISCLAIMERS: 10,
    REBATES_DETAILS: 11,
    DISCOUNTS: 12,
    REBATES_AT_DELIVERY: 13,
    REBATES_TAXES: 14
};

var MODEL_TAXES = exports.MODEL_TAXES = {
    TAXES_FACTOR: 21,
    TAX_CODES: 22
};

var REBATE_DETAILS = exports.REBATE_DETAILS = {
    REBATE_TYPE_ID: 0,
    REBATE_CODE: 1,
    REBATE_DESCRIPTION: 2,
    REBATE_AMOUNT: 3,
    REBATE_IS_AT_DELIVERY: 4,
    REBATE_IS_AFTER_TAXES: 5,
    REBATE_TAXES: 6,
    REBATE_TAXES_AT_DELIVERY: 7
};

exports.default = {
    MODEL_TERM: MODEL_TERM,
    COLLECTION_FREQUENCY: COLLECTION_FREQUENCY,
    CALCULATOR_FREQUENCY: CALCULATOR_FREQUENCY,
    MODEL_FREQUENCY: MODEL_FREQUENCY,
    COLLECTION_FINANCE: COLLECTION_FINANCE,
    CALCULATOR_FINANCE: CALCULATOR_FINANCE,
    VEHICLE_FINANCE: VEHICLE_FINANCE,
    MODEL_FINANCE: MODEL_FINANCE,
    MODEL_CASH_PURCHASE: MODEL_CASH_PURCHASE,
    VEHICLE_CASH_PURCHASE: VEHICLE_CASH_PURCHASE,
    COLLECTION_CASH_PURCHASE: COLLECTION_CASH_PURCHASE,
    MODEL_TAXES: MODEL_TAXES,
    REBATE_DETAILS: REBATE_DETAILS
};

/***/ }),

/***/ "./src/PurchaseMethods/constants/disclaimers.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var DISCLAIMERS = {
    CASH: {
        VEHICLE_DESCRIPTION: 1,
        SELLING_PRICE: 2,
        INCLUDED_REBATES: 3,
        INCLUDED_FEES: 4,
        EXCLUDED_FEES: 5
    },
    FINANCE: {
        VEHICLE_DESCRIPTION: 1,
        TERM: {
            SELLING_PRICE: 2,
            INCLUDED_REBATES: 3,
            INCLUDED_FEES: 4,
            EXCLUDED_FEES: 5,
            TERM_APR: 6
        },
        PAYMENT_FREQUENCY: {
            PAYMENT_CASH_DOWN: 7,
            TOTAL_OBLIGATION: 11,
            COST_OF_CREDIT: 12,
            CREDIT_RATE: 13
        },
        KM_PLAN: 0,
        CREDIT_APPROVAL: 14,
        CASH_DOWN_TAX_EXCLUDED: 15
    },
    LEASE: {
        VEHICLE_DESCRIPTION: 1,
        TERM: {
            SELLING_PRICE: 2,
            INCLUDED_REBATES: 3,
            INCLUDED_FEES: 4,
            EXCLUDED_FEES: 5,
            TERM_APR: 6
        },
        PAYMENT_FREQUENCY: {
            PAYMENT_CASH_DOWN: 7,
            TOTAL_OBLIGATION: 0,
            COST_OF_CREDIT: 0,
            CREDIT_RATE: 0
        },
        KM_PLAN: 11,
        CREDIT_APPROVAL: 12,
        CASH_DOWN_TAX_EXCLUDED: 13
    },
    GENERAL_FEES_EXCLUSION: 1,
    PRICES_SUBJECT_TO_CHANGE: 2,
    NOT_RESPONSIBLE: 3,
    HIGH_TRANSACTION_VOLUME: 4,
    ILLUSTRATION_PURPOSES: 6,
    OPTIONS_TRIMS_VARIATION: 7,
    EXCLUDED_TAXES: 9,
    PRICE_PAYMENTS_EXCLUDED_TAXES: 11
};

exports.default = DISCLAIMERS;

/***/ }),

/***/ "./src/PurchaseMethods/constants/paymentFrequencies.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var WEEKLY = exports.WEEKLY = 52;
var BI_WEEKLY = exports.BI_WEEKLY = 26;
var SEMI_MONTHLY = exports.SEMI_MONTHLY = 24;
var MONTHLY = exports.MONTHLY = 12;

exports.default = {
    WEEKLY: WEEKLY,
    BI_WEEKLY: BI_WEEKLY,
    SEMI_MONTHLY: SEMI_MONTHLY,
    MONTHLY: MONTHLY
};

/***/ }),

/***/ "./src/PurchaseMethods/constants/purchaseMethods.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var LEASE = exports.LEASE = 'lease';
var FINANCE = exports.FINANCE = 'finance';
var CASH_PURCHASE = exports.CASH_PURCHASE = 'cashPurchase';
var BEST_PAYMENT = exports.BEST_PAYMENT = 'bestPayment';

exports.default = {
    LEASE: LEASE,
    FINANCE: FINANCE,
    CASH_PURCHASE: CASH_PURCHASE,
    BEST_PAYMENT: BEST_PAYMENT
};

/***/ }),

/***/ "./src/PurchaseMethods/constants/purchaseMethodsValues.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var PURCHASE_METHODS = {
    CASH: 0x1,
    FINANCE: 0x100,
    FINANCE_WITH_BALLOON: 0x300,
    LEASE: 0x1000,
    SINGLE_PAYMENT_LEASE: 0x3000
};

exports.default = PURCHASE_METHODS;

/***/ }),

/***/ "./src/PurchaseMethods/i18n/en.json":
/***/ (function(module, exports) {

module.exports = {"purchaseMethods":{"lease":"Lease","finance":"Finance","cashPurchase":"Purchase","bestPayment":"Best Payment","leaseVerb":"Lease","financeVerb":"Finance","cashPurchaseVerb":"Purchase","msrp":"MSRP","cashDiscount":"Cash Discount","pdiFreight":"PDI & Freight","otherFees":"Other fees","QSTGST":"QST / GST","cashPurchaseTitle":"Cash Purchase","months":"months","monthsAbr":"mo"},"KM_PLANS":{"TITLE":"KM Plan","ANNUAL_KM_ALLOWED":"%{annualKMAllowed} km/year","ANNUAL_KM_INCLUDED":"%{annualKMAllowed} km per year included","END_TERM_KM_COST":"Charges of %{endTermKMCost} per exceeding kilometer will apply"},"paymentFrequencies":{"title":"Payment Frequency","weekly":"Weekly","biWeekly":"Bi-Weekly","semiMonthly":"Semi-Monthly","monthly":"Monthly","perWeek":"/ Week","perBiWeek":"/ Bi-Weekly","perSemiMonth":"/ Semi-Month","perMonth":"/ Month"},"DOWN_PAYMENTS":{"CASH_DOWN":"down payment","CASH_DOWN_LABEL":"Cash Down","DISCOUNT":"discount","REBATES":"rebates","CASH_DOWN_WITH_AMOUNT":"%{cashDown} cash down","DISCOUNT_WITH_AMOUNT":"%{discount} discount","REBATES_WITH_AMOUNT":"%{rebate} rebates"},"DISCLAIMERS":{"PLUS_TAXES_AND_LIC":"+ Taxes & Lic.","PLUS_TAXES_CODES_AND_LIC":"+ %{taxCodes} & Lic."},"DISCLAIMERS_DEFAULT_VALUES":{"ILLUSTRATION":"Models and pictures shown for illustration purposes only.","HIGH_VOLUME":"Due to a large number of transactions, it is possible that the vehicle you reserved is already sold. In the case of this occurring, we will contact you as soon as possible and your deposit will be refunded immediately.","OPTIONS_VARIATION":"Options and accessories may vary by trim.","DATA_RESPONSIBILITY":"While every reasonable effort is made to ensure the accuracy of this information, we are not responsible for any errors or omissions contained on these pages. Please verify all information and pricing with a sales representative or ask online.","PRICE_CHANGE":"Prices, payments and rates are subject to change without notice. Please validate the information with a sales representative.","PRICE_EXCLUSION":"License, insurance, registration, additional options and applicable taxes are extra.","TAXES_EXCLUDED":"+ %{taxCodes} & licence","PRICE_PAYMENTS_TAXES_EXCLUDED":"Price and payments don't include taxes and licence fee","CREDIT_APPROVAL":"Finance and lease offers on approved credit. Rates and requirements may vary depending on credit worthiness."}}

/***/ }),

/***/ "./src/PurchaseMethods/i18n/fr.json":
/***/ (function(module, exports) {

module.exports = {"purchaseMethods":{"lease":"Location","finance":"Financement","cashPurchase":"Achat","bestPayment":"Meilleur paiement","leaseVerb":"Louez","financeVerb":"Financez","cashPurchaseVerb":"Achetez","msrp":"PDSF","cashDiscount":"Rabais","pdiFreight":"Transport et préparation","otherFees":"Autres frais","QSTGST":"TPS / TVQ","cashPurchaseTitle":"Prix à l'achat","months":"mois","monthsAbr":"mo"},"KM_PLANS":{"TITLE":"Plan de km","ANNUAL_KM_ALLOWED":"%{annualKMAllowed} km/année","ANNUAL_KM_INCLUDED":"%{annualKMAllowed} km par année inclus","END_TERM_KM_COST":"Des frais de %{endTermKMCost} par kilomètre excédentaire s'appliqueront"},"paymentFrequencies":{"title":"Fréquence de paiement","weekly":"à la semaine","biWeekly":"aux 2 semaines","semiMonthly":"à la quinzaine","monthly":"au mois","perWeek":"/ sem.","perBiWeek":"/ 2 sem.","perSemiMonth":"/ quinz.","perMonth":"/ mois"},"DOWN_PAYMENTS":{"CASH_DOWN":"d'acompte","CASH_DOWN_LABEL":"Acompte","DISCOUNT":"escompte","REBATES":"rabais","CASH_DOWN_WITH_AMOUNT":"%{cashDown} d'acompte","DISCOUNT_WITH_AMOUNT":"%{discount} d'escompte","REBATES_WITH_AMOUNT":"%{rebate} de rabais"},"DISCLAIMERS":{"PLUS_TAXES_AND_LIC":"+ Taxes et droits","PLUS_TAXES_CODES_AND_LIC":"+ %{taxCodes} et droits"},"DISCLAIMERS_DEFAULT_VALUES":{"ILLUSTRATION":"Les modèles et images montrés à des fins d'illustration seulement.","HIGH_VOLUME":"En raison d'un grand nombre de transactions, il est possible que le véhicule que vous avez réservé soit déjà vendu. Dans ce cas, nous vous contacterons dès que possible et votre dépôt sera remboursé immédiatement.","OPTIONS_VARIATION":"Les options et accessoires peuvent varier selon la version.","DATA_RESPONSIBILITY":"Bien que tous les efforts raisonnables soient faits pour assurer l'exactitude de ces informations, nous ne sommes pas responsables des erreurs ou omissions contenues sur ces pages. S'il vous plaît vérifier toutes les informations et les prix avec un représentant des ventes ou demander en ligne.","PRICE_CHANGE":"Les prix, paiements et taux sont sujets à des changements sans préavis. Veuillez valider l'information auprès d'un représentant aux ventes.","PRICE_EXCLUSION":"Immatriculation, assurance, enregistrement, options additionnelles et taxes applicables sont en sus.","TAXES_EXCLUDED":"+ %{taxCodes} et immatriculation","PRICE_PAYMENTS_TAXES_EXCLUDED":"Les prix et paiements n'incluent pas les taxes et immatriculation","CREDIT_APPROVAL":"Offres de financement et location sur approbation de crédit. Les taux et les exigences peuvent varier en fonction de la solvabilité."}}

/***/ }),

/***/ "./src/PurchaseMethods/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DisclaimerAPIService = exports.TermService = exports.PurchaseMethodsService = exports.PaymentFrequencyService = exports.FinanceService = exports.CashPurchaseService = exports.PurchaseMethodsReducer = exports.TermModel = exports.PurchaseMethodsModel = exports.PaymentFrequencyModel = exports.FinanceModel = exports.CashPurchaseModel = exports.Translations = exports.PurchaseMethodsValues = exports.PurchaseMethodsConstant = exports.PaymentFrequencies = exports.DataConversions = exports.PurchaseMethodsActionsTypes = exports.PurchaseMethodsActions = undefined;

var _purchaseMethodsActions = __webpack_require__("./src/PurchaseMethods/actions/purchaseMethodsActions.js");

var _purchaseMethodsActions2 = _interopRequireDefault(_purchaseMethodsActions);

var _purchaseMethodsActionTypes = __webpack_require__("./src/PurchaseMethods/actions/purchaseMethodsActionTypes.js");

var _purchaseMethodsActionTypes2 = _interopRequireDefault(_purchaseMethodsActionTypes);

var _dataConversions = __webpack_require__("./src/PurchaseMethods/constants/dataConversions.js");

var _dataConversions2 = _interopRequireDefault(_dataConversions);

var _paymentFrequencies = __webpack_require__("./src/PurchaseMethods/constants/paymentFrequencies.js");

var _paymentFrequencies2 = _interopRequireDefault(_paymentFrequencies);

var _purchaseMethods = __webpack_require__("./src/PurchaseMethods/constants/purchaseMethods.js");

var _purchaseMethods2 = _interopRequireDefault(_purchaseMethods);

var _purchaseMethodsValues = __webpack_require__("./src/PurchaseMethods/constants/purchaseMethodsValues.js");

var _purchaseMethodsValues2 = _interopRequireDefault(_purchaseMethodsValues);

var _en = __webpack_require__("./src/PurchaseMethods/i18n/en.json");

var _en2 = _interopRequireDefault(_en);

var _fr = __webpack_require__("./src/PurchaseMethods/i18n/fr.json");

var _fr2 = _interopRequireDefault(_fr);

var _CashPurchaseModel = __webpack_require__("./src/PurchaseMethods/models/CashPurchaseModel.js");

var _CashPurchaseModel2 = _interopRequireDefault(_CashPurchaseModel);

var _FinanceModel = __webpack_require__("./src/PurchaseMethods/models/FinanceModel.js");

var _FinanceModel2 = _interopRequireDefault(_FinanceModel);

var _PaymentFrequencyModel = __webpack_require__("./src/PurchaseMethods/models/PaymentFrequencyModel.js");

var _PaymentFrequencyModel2 = _interopRequireDefault(_PaymentFrequencyModel);

var _PurchaseMethodsModel = __webpack_require__("./src/PurchaseMethods/models/PurchaseMethodsModel.js");

var _PurchaseMethodsModel2 = _interopRequireDefault(_PurchaseMethodsModel);

var _TermModel = __webpack_require__("./src/PurchaseMethods/models/TermModel.js");

var _TermModel2 = _interopRequireDefault(_TermModel);

var _purchaseMethodsReducer = __webpack_require__("./src/PurchaseMethods/reducers/purchaseMethodsReducer.js");

var _purchaseMethodsReducer2 = _interopRequireDefault(_purchaseMethodsReducer);

var _CashPurchaseService = __webpack_require__("./src/PurchaseMethods/services/CashPurchaseService/CashPurchaseService.js");

var _CashPurchaseService2 = _interopRequireDefault(_CashPurchaseService);

var _FinanceService = __webpack_require__("./src/PurchaseMethods/services/FinanceService/FinanceService.js");

var _FinanceService2 = _interopRequireDefault(_FinanceService);

var _PaymentFrequencyService = __webpack_require__("./src/PurchaseMethods/services/PaymentFrequencyService/PaymentFrequencyService.js");

var _PaymentFrequencyService2 = _interopRequireDefault(_PaymentFrequencyService);

var _PurchaseMethodsService = __webpack_require__("./src/PurchaseMethods/services/PurchaseMethodsService/PurchaseMethodsService.js");

var _PurchaseMethodsService2 = _interopRequireDefault(_PurchaseMethodsService);

var _TermService = __webpack_require__("./src/PurchaseMethods/services/TermService/TermService.js");

var _TermService2 = _interopRequireDefault(_TermService);

var _DisclaimerAPIService = __webpack_require__("./src/PurchaseMethods/services/PurchaseMethodsAPIService/DisclaimerAPIService.js");

var _DisclaimerAPIService2 = _interopRequireDefault(_DisclaimerAPIService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Translations = {
    en: _en2.default,
    fr: _fr2.default
};

exports.PurchaseMethodsActions = _purchaseMethodsActions2.default;
exports.PurchaseMethodsActionsTypes = _purchaseMethodsActionTypes2.default;
exports.DataConversions = _dataConversions2.default;
exports.PaymentFrequencies = _paymentFrequencies2.default;
exports.PurchaseMethodsConstant = _purchaseMethods2.default;
exports.PurchaseMethodsValues = _purchaseMethodsValues2.default;
exports.Translations = Translations;
exports.CashPurchaseModel = _CashPurchaseModel2.default;
exports.FinanceModel = _FinanceModel2.default;
exports.PaymentFrequencyModel = _PaymentFrequencyModel2.default;
exports.PurchaseMethodsModel = _PurchaseMethodsModel2.default;
exports.TermModel = _TermModel2.default;
exports.PurchaseMethodsReducer = _purchaseMethodsReducer2.default;
exports.CashPurchaseService = _CashPurchaseService2.default;
exports.FinanceService = _FinanceService2.default;
exports.PaymentFrequencyService = _PaymentFrequencyService2.default;
exports.PurchaseMethodsService = _PurchaseMethodsService2.default;
exports.TermService = _TermService2.default;
exports.DisclaimerAPIService = _DisclaimerAPIService2.default;
exports.default = {
    PurchaseMethodsActions: _purchaseMethodsActions2.default,
    PurchaseMethodsActionsTypes: _purchaseMethodsActionTypes2.default,
    DataConversions: _dataConversions2.default,
    PaymentFrequencies: _paymentFrequencies2.default,
    PurchaseMethodsConstant: _purchaseMethods2.default,
    PurchaseMethodsValues: _purchaseMethodsValues2.default,

    Translations: Translations,

    CashPurchaseModel: _CashPurchaseModel2.default,
    FinanceModel: _FinanceModel2.default,
    PaymentFrequencyModel: _PaymentFrequencyModel2.default,
    PurchaseMethodsModel: _PurchaseMethodsModel2.default,
    TermModel: _TermModel2.default,
    PurchaseMethodsReducer: _purchaseMethodsReducer2.default,

    CashPurchaseService: _CashPurchaseService2.default,
    FinanceService: _FinanceService2.default,
    PaymentFrequencyService: _PaymentFrequencyService2.default,
    PurchaseMethodsService: _PurchaseMethodsService2.default,
    TermService: _TermService2.default,
    DisclaimerAPIService: _DisclaimerAPIService2.default
};

/***/ }),

/***/ "./src/PurchaseMethods/models/CashPurchaseModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("lodash");

var _immutable = __webpack_require__("immutable");

var _purchaseMethods = __webpack_require__("./src/PurchaseMethods/constants/purchaseMethods.js");

var PurchaseMethods = _interopRequireWildcard(_purchaseMethods);

var _purchaseMethodsValues = __webpack_require__("./src/PurchaseMethods/constants/purchaseMethodsValues.js");

var _purchaseMethodsValues2 = _interopRequireDefault(_purchaseMethodsValues);

var _dataTypes = __webpack_require__("./src/constants/dataTypes.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CashPurchaseRecord = (0, _immutable.Record)({
    purchaseMethod: PurchaseMethods.CASH_PURCHASE,
    purchaseMethodValue: _purchaseMethodsValues2.default.CASH,
    selected: false,
    available: true,
    retail: 0,
    retailAdjustment: 0,
    discounts: 0,
    rebates: 0,
    rebatesTaxes: 0,
    rebatesAtDelivery: 0,
    pricingAmounts: {
        msrp: 0,
        freightPDI: 0,
        taxesAndDuties: 0
    },
    dealerFees: 0,
    optionsAdjustment: 0,
    optionsTaxesAdjustment: 0,
    netTradeInAdjustment: 0,
    tradeInTaxesAdjustment: 0,
    includedItemsCodes: [],
    rebatesDetails: [],
    optionsAdjustmentDiscounts: 0
});

var CashPurchase = function (_CashPurchaseRecord) {
    _inherits(CashPurchase, _CashPurchaseRecord);

    function CashPurchase() {
        _classCallCheck(this, CashPurchase);

        return _possibleConstructorReturn(this, (CashPurchase.__proto__ || Object.getPrototypeOf(CashPurchase)).apply(this, arguments));
    }

    _createClass(CashPurchase, [{
        key: 'getRetail',
        value: function getRetail() {
            return this.retail + this.optionsAdjustment;
        }
    }, {
        key: 'getTotalRebates',
        value: function getTotalRebates() {
            return this.discounts + this.rebates + this.optionsAdjustmentDiscounts;
        }
    }, {
        key: 'getTotalRebatesWithTaxes',
        value: function getTotalRebatesWithTaxes() {
            return this.discounts + this.rebates + this.rebatesTaxes + this.optionsAdjustmentDiscounts;
        }
    }, {
        key: 'getElectricRebate',
        value: function getElectricRebate() {
            var electricRebates = (0, _lodash.filter)(this.rebatesDetails, function (rebateDetails) {
                return rebateDetails.typeId === _dataTypes.DATA_TYPES.REBATE.TYPES.ELECTRIC;
            });

            if ((0, _lodash.isEmpty)(electricRebates)) {
                return null;
            }

            return {
                description: electricRebates[0].description,
                rebate: (0, _lodash.sumBy)(electricRebates, function (electricRebate) {
                    return electricRebate.amount;
                })
            };
        }
    }, {
        key: 'getEmployeeRebate',
        value: function getEmployeeRebate() {
            var employeeRebates = (0, _lodash.filter)(this.rebatesDetails, function (rebateDetails) {
                return rebateDetails.typeId === _dataTypes.DATA_TYPES.REBATE.TYPES.EMPLOYEE;
            });

            if ((0, _lodash.isEmpty)(employeeRebates)) {
                return null;
            }

            return {
                description: employeeRebates[0].description,
                rebate: (0, _lodash.sumBy)(employeeRebates, function (employeeRebate) {
                    return employeeRebate.amount;
                })
            };
        }
    }]);

    return CashPurchase;
}(CashPurchaseRecord);

exports.default = CashPurchase;

/***/ }),

/***/ "./src/PurchaseMethods/models/DisclaimersModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = __webpack_require__("immutable");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DisclaimersRecord = (0, _immutable.Record)({
    illustration: '',
    highVolume: '',
    optionsVariation: '',
    dataResponsibility: '',
    priceChange: '',
    priceExclusion: '',
    taxesExcluded: '',
    pricePaymentsTaxesExcluded: '',

    cashPurchase: {
        vehicleDescription: '',
        sellingPrice: '',
        priceInclusions: '',
        priceExclusions: ''
    },

    lease: {
        vehicleDescription: '',
        sellingPrice: '',
        priceInclusions: '',
        priceExclusions: '',
        termAndApr: '',
        paymentAndCash: '',
        obligationAndInterest: '',
        creditApproval: ''
    },

    finance: {
        vehicleDescription: '',
        sellingPrice: '',
        priceInclusions: '',
        priceExclusions: '',
        termAndApr: '',
        paymentAndCash: '',
        obligationAndInterest: '',
        creditApproval: ''
    }
});

var Disclaimers = function (_DisclaimersRecord) {
    _inherits(Disclaimers, _DisclaimersRecord);

    function Disclaimers() {
        _classCallCheck(this, Disclaimers);

        return _possibleConstructorReturn(this, (Disclaimers.__proto__ || Object.getPrototypeOf(Disclaimers)).apply(this, arguments));
    }

    return Disclaimers;
}(DisclaimersRecord);

exports.default = Disclaimers;

/***/ }),

/***/ "./src/PurchaseMethods/models/FinanceModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = __webpack_require__("immutable");

var _lodash = __webpack_require__("lodash");

var _paymentFrequencies = __webpack_require__("./src/PurchaseMethods/constants/paymentFrequencies.js");

var _purchaseMethods = __webpack_require__("./src/PurchaseMethods/constants/purchaseMethods.js");

var PurchaseMethods = _interopRequireWildcard(_purchaseMethods);

var _purchaseMethodsValues = __webpack_require__("./src/PurchaseMethods/constants/purchaseMethodsValues.js");

var _purchaseMethodsValues2 = _interopRequireDefault(_purchaseMethodsValues);

var _TermModel = __webpack_require__("./src/PurchaseMethods/models/TermModel.js");

var _TermModel2 = _interopRequireDefault(_TermModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FinanceRecord = (0, _immutable.Record)({
    purchaseMethod: PurchaseMethods.FINANCE,
    purchaseMethodValue: _purchaseMethodsValues2.default.FINANCE,
    annualKMAllowed: 0,
    endTermKMCost: 0,
    selected: false,
    available: false,
    terms: [new _TermModel2.default()],
    selectedTerm: 0,
    kmPlans: []
});

var Finance = function (_FinanceRecord) {
    _inherits(Finance, _FinanceRecord);

    function Finance() {
        _classCallCheck(this, Finance);

        return _possibleConstructorReturn(this, (Finance.__proto__ || Object.getPrototypeOf(Finance)).apply(this, arguments));
    }

    _createClass(Finance, [{
        key: 'getSelectedTerm',
        value: function getSelectedTerm() {
            var _this2 = this;

            return (0, _lodash.find)(this.terms, function (term) {
                return term.term === _this2.selectedTerm;
            });
        }
    }, {
        key: 'getBestPaymentTerm',
        value: function getBestPaymentTerm(maximumTerm) {
            return (0, _lodash.minBy)((0, _lodash.filter)(this.terms, function (filterTerm) {
                return maximumTerm === 0 || filterTerm.term <= maximumTerm;
            }), function (term) {
                return term.calculatedPayment;
            });
        }
    }, {
        key: 'getBestPaymentFrequency',
        value: function getBestPaymentFrequency() {
            if ((0, _lodash.isEmpty)(this.terms)) {
                return _paymentFrequencies.MONTHLY;
            }
            return this.terms[0].getBestPaymentFrequency();
        }
    }, {
        key: 'getAvailablePaymentFrequencies',
        value: function getAvailablePaymentFrequencies() {
            if ((0, _lodash.isEmpty)(this.terms) || !this.terms[0].term) {
                return [];
            }
            return this.terms[0].getAvailablePaymentFrequencies();
        }
    }, {
        key: 'getSelectedTermFrequency',
        value: function getSelectedTermFrequency() {
            var selectedTerm = this.getSelectedTerm();
            return selectedTerm ? selectedTerm.getPaymentFrequency() : '';
        }
    }, {
        key: 'getCalculatedPayment',
        value: function getCalculatedPayment() {
            var selectedTerm = this.getSelectedTerm();
            return selectedTerm ? selectedTerm.calculatedPayment : 0;
        }
    }, {
        key: 'getCashDown',
        value: function getCashDown() {
            var selectedTerm = this.getSelectedTerm();
            return selectedTerm ? selectedTerm.cashDown : 0;
        }

        // I18n argument is the LocalService class to translate

    }, {
        key: 'getKMPlansDropDownValues',
        value: function getKMPlansDropDownValues(I18n) {
            return this.kmPlans.map(function (kmPlan) {
                return {
                    value: kmPlan.annualKMAllowed,
                    label: I18n.t('KM_PLANS.ANNUAL_KM_ALLOWED', { annualKMAllowed: kmPlan.annualKMAllowed })
                };
            });
        }
    }, {
        key: 'getKMPlan',
        value: function getKMPlan(annualKMAllowed) {
            return (0, _lodash.find)(this.kmPlans, function (kmPlan) {
                return kmPlan.annualKMAllowed === annualKMAllowed;
            });
        }
    }, {
        key: 'getDisclaimerParameters',
        value: function getDisclaimerParameters() {
            var selectedTerm = this.getSelectedTerm();
            if (!selectedTerm || !selectedTerm.term) {
                return null;
            }

            var term = selectedTerm.term,
                paymentFrequency = selectedTerm.paymentFrequency,
                cashDown = selectedTerm.cashDown;


            return {
                purchaseMethod: this.purchaseMethodValue,
                cashDown: cashDown,
                terms: [term],
                paymentFrequencies: [paymentFrequency]
            };
        }
    }, {
        key: 'hasValidTerms',
        get: function get() {
            return this.terms.length > 0 && this.terms[0].payment > 0;
        }
    }]);

    return Finance;
}(FinanceRecord);

exports.default = Finance;

/***/ }),

/***/ "./src/PurchaseMethods/models/PaymentFrequencyModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = __webpack_require__("immutable");

var _paymentFrequencies = __webpack_require__("./src/PurchaseMethods/constants/paymentFrequencies.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaymentFrequencyRecord = (0, _immutable.Record)({
    paymentFrequency: _paymentFrequencies.MONTHLY,
    payment: 0,
    paymentTaxes: 0,
    financeFactor: 0,
    balloonFactor: 0,
    cashDownPaymentAdjustment: 0,
    netTradeInPaymentAdjustment: 0,
    netTradeInPaymentTaxesAdjustment: 0,
    calculatedNetPayment: 0,
    calculatedPayment: 0,
    disclaimers: []
});

var PaymentFrequency = function (_PaymentFrequencyReco) {
    _inherits(PaymentFrequency, _PaymentFrequencyReco);

    function PaymentFrequency() {
        _classCallCheck(this, PaymentFrequency);

        return _possibleConstructorReturn(this, (PaymentFrequency.__proto__ || Object.getPrototypeOf(PaymentFrequency)).apply(this, arguments));
    }

    _createClass(PaymentFrequency, [{
        key: 'getSelectionCode',
        value: function getSelectionCode() {
            return this.get('selectionCode');
        }
    }]);

    return PaymentFrequency;
}(PaymentFrequencyRecord);

exports.default = PaymentFrequency;

/***/ }),

/***/ "./src/PurchaseMethods/models/PurchaseMethodsModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = __webpack_require__("immutable");

var _lodash = __webpack_require__("lodash");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _dataTypes = __webpack_require__("./src/constants/dataTypes.js");

var dataTypes = _interopRequireWildcard(_dataTypes);

var _paymentFrequencies = __webpack_require__("./src/PurchaseMethods/constants/paymentFrequencies.js");

var PaymentFrequencies = _interopRequireWildcard(_paymentFrequencies);

var _purchaseMethodsValues = __webpack_require__("./src/PurchaseMethods/constants/purchaseMethodsValues.js");

var _purchaseMethodsValues2 = _interopRequireDefault(_purchaseMethodsValues);

var _FinanceModel = __webpack_require__("./src/PurchaseMethods/models/FinanceModel.js");

var _FinanceModel2 = _interopRequireDefault(_FinanceModel);

var _CashPurchaseModel = __webpack_require__("./src/PurchaseMethods/models/CashPurchaseModel.js");

var _CashPurchaseModel2 = _interopRequireDefault(_CashPurchaseModel);

var _DisclaimersModel = __webpack_require__("./src/PurchaseMethods/models/DisclaimersModel.js");

var _DisclaimersModel2 = _interopRequireDefault(_DisclaimersModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint no-bitwise: 0 */

var MODEL_TRIM_OPTION_CODE = '_MT';

var PurchaseMethodsRecord = (0, _immutable.Record)({
    taxesIncluded: false,
    taxesFactor: 0,
    taxCodes: [],
    tradeIn: 0,
    lien: 0,
    exteriorColourRetail: 0.0,
    exteriorColourResidualRetail: 0.0,
    interiorColourRetail: 0.0,
    interiorColourResidualRetail: 0.0,
    optionsTotalRetail: 0.0,
    optionsTotalResidualRetail: 0.0,
    employeeRebateAdjustment: 0.0,
    highRebate: 0,
    highRebatePurchaseMethod: _purchaseMethodsValues2.default.CASH,
    finance: new _FinanceModel2.default(),
    lease: new _FinanceModel2.default(),
    cashPurchase: new _CashPurchaseModel2.default(),
    availableOptions: [],
    selectedOptions: [],
    configurationOptions: [],
    optionsSelectionResolutions: null,
    disclaimers: new _DisclaimersModel2.default()
});

function checkIsOption(option) {
    return option.dataType === dataTypes.DATA_TYPES.FEATURE.DATA_TYPE_ID && (option.typeID < dataTypes.DATA_TYPES.FEATURE.TYPES.MODEL_TRIM || option.typeID > dataTypes.DATA_TYPES.FEATURE.TYPES.INTERIOR_TRIM);
}

var PurchaseMethods = function (_PurchaseMethodsRecor) {
    _inherits(PurchaseMethods, _PurchaseMethodsRecor);

    function PurchaseMethods(args) {
        _classCallCheck(this, PurchaseMethods);

        var newArgs = {};
        var windowProxy = _widgetCommonsCoreServices.WindowProxy.get();

        if (windowProxy && windowProxy.localStorage) {
            var _windowProxy$localSto = windowProxy.localStorage,
                tradeIn = _windowProxy$localSto.tradeIn,
                lien = _windowProxy$localSto.lien;


            if (tradeIn) {
                var parseTradeIn = parseInt(tradeIn, 10);

                // eslint-disable-next-line no-restricted-globals
                newArgs.tradeIn = !isNaN(parseTradeIn) ? parseTradeIn : 0;
            }

            if (lien) {
                var parseLien = parseInt(lien, 10);

                // eslint-disable-next-line no-restricted-globals
                newArgs.lien = !isNaN(parseLien) ? parseLien : 0;
            }
        }

        return _possibleConstructorReturn(this, (PurchaseMethods.__proto__ || Object.getPrototypeOf(PurchaseMethods)).call(this, _extends({}, args, newArgs)));
    }

    _createClass(PurchaseMethods, [{
        key: 'getPaymentCalculationParameters',
        value: function getPaymentCalculationParameters() {
            var isLease = this.lease.selected;
            var selectedFinanceTerm = isLease ? this.lease.getSelectedTerm() : this.finance.getSelectedTerm();

            var taxesIncluded = this.taxesIncluded,
                taxesFactor = this.taxesFactor,
                tradeIn = this.tradeIn,
                lien = this.lien,
                exteriorColourRetail = this.exteriorColourRetail,
                exteriorColourResidualRetail = this.exteriorColourResidualRetail,
                interiorColourRetail = this.interiorColourRetail,
                interiorColourResidualRetail = this.interiorColourResidualRetail,
                optionsTotalRetail = this.optionsTotalRetail,
                optionsTotalResidualRetail = this.optionsTotalResidualRetail,
                dealerFeesTotalRetail = this.dealerFeesTotalRetail;


            return {
                isLease: isLease,
                selectedFinanceTerm: this.finance.selectedTerm,
                selectedLeaseTerm: this.lease.selectedTerm,
                paymentFrequency: selectedFinanceTerm ? selectedFinanceTerm.paymentFrequency : PaymentFrequencies.MONTHLY,
                taxesIncluded: taxesIncluded,
                taxesFactor: taxesFactor,
                cashDown: selectedFinanceTerm ? selectedFinanceTerm.cashDown : 0,
                tradeIn: tradeIn,
                lien: lien,
                exteriorColourRetail: exteriorColourRetail,
                exteriorColourResidualRetail: exteriorColourResidualRetail,
                interiorColourRetail: interiorColourRetail,
                interiorColourResidualRetail: interiorColourResidualRetail,
                optionsTotalRetail: optionsTotalRetail,
                optionsTotalResidualRetail: optionsTotalResidualRetail,
                dealerFeesTotalRetail: dealerFeesTotalRetail
            };
        }
    }, {
        key: 'getPaymentCalculationWithTerm',
        value: function getPaymentCalculationWithTerm(term) {
            var paymentCalculationParameters = this.getPaymentCalculationParameters();
            if (paymentCalculationParameters.isLease) {
                paymentCalculationParameters.selectedLeaseTerm = parseInt(term, 10);
            } else {
                paymentCalculationParameters.selectedFinanceTerm = parseInt(term, 10);
            }
            return paymentCalculationParameters;
        }
    }, {
        key: 'getPaymentCalculationWithPaymentFrequency',
        value: function getPaymentCalculationWithPaymentFrequency(paymentFrequency) {
            var paymentCalculationParameters = this.getPaymentCalculationParameters();
            paymentCalculationParameters.paymentFrequency = paymentFrequency;
            return paymentCalculationParameters;
        }
    }, {
        key: 'getPaymentCalculationWithTargetPayment',
        value: function getPaymentCalculationWithTargetPayment(targetPayment) {
            var paymentCalculationParameters = this.getPaymentCalculationParameters();
            paymentCalculationParameters.targetPayment = (0, _lodash.isFinite)(targetPayment) ? targetPayment : 0;
            return paymentCalculationParameters;
        }
    }, {
        key: 'getPaymentCalculationWithCashDown',
        value: function getPaymentCalculationWithCashDown(cashDown) {
            var paymentCalculationParameters = this.getPaymentCalculationParameters();
            paymentCalculationParameters.cashDown = (0, _lodash.isFinite)(cashDown) ? cashDown : 0;
            return paymentCalculationParameters;
        }
    }, {
        key: 'getPaymentCalculationWithTradeIn',
        value: function getPaymentCalculationWithTradeIn(tradeIn) {
            var paymentCalculationParameters = this.getPaymentCalculationParameters();
            paymentCalculationParameters.tradeIn = (0, _lodash.isFinite)(tradeIn) ? tradeIn : 0;
            if (paymentCalculationParameters.tradeIn === 0) {
                paymentCalculationParameters.lien = 0;
            }
            return paymentCalculationParameters;
        }
    }, {
        key: 'getPaymentCalculationWithLien',
        value: function getPaymentCalculationWithLien(lien) {
            var paymentCalculationParameters = this.getPaymentCalculationParameters();
            if (paymentCalculationParameters.tradeIn === 0) {
                paymentCalculationParameters.lien = 0;
            } else {
                paymentCalculationParameters.lien = (0, _lodash.isFinite)(lien) ? lien : 0;
            }
            return paymentCalculationParameters;
        }
    }, {
        key: 'getPaymentCalculationWithExteriorColour',
        value: function getPaymentCalculationWithExteriorColour(exteriorColourAmounts) {
            var paymentCalculationParameters = this.getPaymentCalculationParameters();
            paymentCalculationParameters.exteriorColourRetail = (0, _lodash.isFinite)(exteriorColourAmounts.retail) ? exteriorColourAmounts.retail : 0;
            paymentCalculationParameters.exteriorColourResidualRetail = paymentCalculationParameters.exteriorColourRetail === 0 || !(0, _lodash.isFinite)(exteriorColourAmounts.residualRetail) ? 0 : exteriorColourAmounts.residualRetail;
            return paymentCalculationParameters;
        }
    }, {
        key: 'getPaymentCalculationWithInteriorColour',
        value: function getPaymentCalculationWithInteriorColour(interiorColourAmounts) {
            var paymentCalculationParameters = this.getPaymentCalculationParameters();
            paymentCalculationParameters.interiorColourRetail = (0, _lodash.isFinite)(interiorColourAmounts.retail) ? interiorColourAmounts.retail : 0;
            paymentCalculationParameters.interiorColourResidualRetail = paymentCalculationParameters.interiorColourRetail === 0 || !(0, _lodash.isFinite)(interiorColourAmounts.residualRetail) ? 0 : interiorColourAmounts.residualRetail;
            return paymentCalculationParameters;
        }
    }, {
        key: 'getPaymentCalculationWithOptions',
        value: function getPaymentCalculationWithOptions(optionsAmounts) {
            var paymentCalculationParameters = this.getPaymentCalculationParameters();
            paymentCalculationParameters.optionsTotalRetail = (0, _lodash.isFinite)(optionsAmounts.retail) ? optionsAmounts.retail : 0;
            paymentCalculationParameters.optionsTotalResidualRetail = paymentCalculationParameters.optionsTotalRetail === 0 || !(0, _lodash.isFinite)(optionsAmounts.residualRetail) ? 0 : optionsAmounts.residualRetail;
            return paymentCalculationParameters;
        }
    }, {
        key: 'getPaymentCalculationWithTaxesIncluded',
        value: function getPaymentCalculationWithTaxesIncluded(taxesIncluded) {
            var paymentCalculationParameters = this.getPaymentCalculationParameters();
            if (!(0, _lodash.isBoolean)(taxesIncluded)) {
                paymentCalculationParameters.taxesIncluded = false;
            } else {
                paymentCalculationParameters.taxesIncluded = taxesIncluded;
            }
            return paymentCalculationParameters;
        }
    }, {
        key: 'getSelectedFinance',
        value: function getSelectedFinance() {
            if (this.lease.selected) {
                return this.lease;
            } else if (this.finance.selected) {
                return this.finance;
            }
            return '';
        }
    }, {
        key: 'getSelectedPurchaseMethodValue',
        value: function getSelectedPurchaseMethodValue() {
            if (this.lease.selected) {
                return this.lease.purchaseMethodValue;
            } else if (this.finance.selected) {
                return this.finance.purchaseMethodValue;
            }
            return this.cashPurchase.purchaseMethodValue;
        }
    }, {
        key: 'getSelectedPurchaseMethod',
        value: function getSelectedPurchaseMethod() {
            if (this.lease.selected) {
                return this.lease.purchaseMethod;
            } else if (this.finance.selected) {
                return this.finance.purchaseMethod;
            }
            return this.cashPurchase.purchaseMethod;
        }
    }, {
        key: 'getSelectedPurchaseMethodIsValid',
        value: function getSelectedPurchaseMethodIsValid() {
            var finance = this.finance,
                lease = this.lease;

            if (finance.selected && (finance.terms.length === 0 || finance.terms.length === 1 && finance.terms[0].term === 0) || lease.selected && (lease.terms.length === 0 || lease.terms.length === 1 && lease.terms[0].term === 0)) {
                return false;
            }
            return true;
        }

        // I18n argument is the LocalService class to translate

    }, {
        key: 'getPurchaseMethodLabels',
        value: function getPurchaseMethodLabels(I18n) {
            var purchaseMethodLabels = {
                name: I18n.t('purchaseMethods.cashPurchase'),
                verb: I18n.t('purchaseMethods.cashPurchaseVerb')
            };

            if (this.lease.selected) {
                purchaseMethodLabels.name = I18n.t('purchaseMethods.lease');
                purchaseMethodLabels.verb = I18n.t('purchaseMethods.leaseVerb');
            } else if (this.finance.selected) {
                purchaseMethodLabels.name = I18n.t('purchaseMethods.finance');
                purchaseMethodLabels.verb = I18n.t('purchaseMethods.financeVerb');
            }

            return purchaseMethodLabels;
        }
    }, {
        key: 'getSelectedFinanceTerm',
        value: function getSelectedFinanceTerm() {
            var selectedFinanceTerm = void 0;
            if (this.lease.selected) {
                selectedFinanceTerm = this.lease.getSelectedTerm();
            } else if (this.finance.selected) {
                selectedFinanceTerm = this.finance.getSelectedTerm();
            }

            return selectedFinanceTerm;
        }
    }, {
        key: 'getFinancesBestPaymentFrequency',
        value: function getFinancesBestPaymentFrequency() {
            var financeBestPaymentFrequency = this.finance.getBestPaymentFrequency();
            var leaseBestPaymentFrequency = this.lease.getBestPaymentFrequency();
            return financeBestPaymentFrequency < leaseBestPaymentFrequency ? financeBestPaymentFrequency : leaseBestPaymentFrequency;
        }
    }, {
        key: 'getFinancesAvailablePaymentFrequencies',
        value: function getFinancesAvailablePaymentFrequencies() {
            var financePaymentFrequencies = this.finance.getAvailablePaymentFrequencies();
            var leasePaymentFrequencies = this.lease.getAvailablePaymentFrequencies();

            if (!(0, _lodash.isEmpty)(financePaymentFrequencies) && !(0, _lodash.isEmpty)(leasePaymentFrequencies)) {
                return (0, _lodash.intersection)(financePaymentFrequencies, leasePaymentFrequencies);
            } else if ((0, _lodash.isEmpty)(financePaymentFrequencies) && (0, _lodash.isEmpty)(leasePaymentFrequencies)) {
                return [PaymentFrequencies.MONTHLY];
            }
            return (0, _lodash.union)(financePaymentFrequencies, leasePaymentFrequencies);
        }
    }, {
        key: 'getSelectedFinancePaymentFrequency',
        value: function getSelectedFinancePaymentFrequency() {
            var selectedFinanceTerm = this.getSelectedFinanceTerm();
            return selectedFinanceTerm ? selectedFinanceTerm.paymentFrequency : PaymentFrequencies.MONTHLY;
        }
    }, {
        key: 'getSelectedFinanceTermValue',
        value: function getSelectedFinanceTermValue() {
            var selectedFinanceTerm = this.getSelectedFinanceTerm();
            return selectedFinanceTerm ? selectedFinanceTerm.term : 0;
        }

        // I18n argument is the LocalService class to translate

    }, {
        key: 'getPaymentFrequencyLabels',
        value: function getPaymentFrequencyLabels(allFinances, I18n) {
            var paymentFrequencyLabels = {
                periodically: '',
                perPeriod: ''
            };

            var selectedFinanceTerm = this.getSelectedFinanceTerm() || allFinances && this.finance.getSelectedTerm();
            if (!selectedFinanceTerm) {
                return paymentFrequencyLabels;
            }

            switch (selectedFinanceTerm.paymentFrequency) {
                case PaymentFrequencies.WEEKLY:
                    paymentFrequencyLabels.periodically = I18n.t('paymentFrequencies.weekly');
                    paymentFrequencyLabels.perPeriod = I18n.t('paymentFrequencies.perWeek');
                    break;
                case PaymentFrequencies.BI_WEEKLY:
                    paymentFrequencyLabels.periodically = I18n.t('paymentFrequencies.biWeekly');
                    paymentFrequencyLabels.perPeriod = I18n.t('paymentFrequencies.perBiWeek');
                    break;
                case PaymentFrequencies.SEMI_MONTHLY:
                    paymentFrequencyLabels.periodically = I18n.t('paymentFrequencies.semiMonthly');
                    paymentFrequencyLabels.perPeriod = I18n.t('paymentFrequencies.perSemiMonth');
                    break;
                case PaymentFrequencies.MONTHLY:
                    paymentFrequencyLabels.periodically = I18n.t('paymentFrequencies.monthly');
                    paymentFrequencyLabels.perPeriod = I18n.t('paymentFrequencies.perMonth');
                    break;
                default:
                    break;
            }

            return paymentFrequencyLabels;
        }
    }, {
        key: 'getBestPaymentFinance',
        value: function getBestPaymentFinance() {
            var leasePayment = this.lease.getCalculatedPayment();
            var financePayment = this.finance.getCalculatedPayment();

            return leasePayment > 0 && leasePayment < financePayment ? this.lease.purchaseMethodValue : this.finance.purchaseMethodValue;
        }
    }, {
        key: 'getBestPaymentTerm',
        value: function getBestPaymentTerm(maximumTerm) {
            var selectedFinance = this.getSelectedFinance();
            return selectedFinance ? selectedFinance.getBestPaymentTerm(maximumTerm) : undefined;
        }
    }, {
        key: 'getOrderValue',
        value: function getOrderValue(purchaseMethodValue) {
            var cashRetail = this.cashPurchase.getRetail();

            // we're using cashRetail value here if there's no calculatedPayment
            // so it will be sorted at the end of the list as it's a high value
            var leasePayment = this.lease.getCalculatedPayment() || cashRetail;
            var financePayment = this.finance.getCalculatedPayment() || cashRetail;

            switch (purchaseMethodValue) {
                case _purchaseMethodsValues2.default.LEASE:
                    return leasePayment;

                case _purchaseMethodsValues2.default.FINANCE:
                    return financePayment;

                case _purchaseMethodsValues2.default.FINANCE | _purchaseMethodsValues2.default.LEASE:
                    return this.getBestPaymentFinance() === _purchaseMethodsValues2.default.LEASE ? leasePayment : financePayment;

                default:
                    return cashRetail;
            }
        }
    }, {
        key: 'getTaxCodesString',
        value: function getTaxCodesString() {
            return (0, _lodash.isEmpty)(this.taxCodes) ? '' : this.taxCodes.join(' / ');
        }
    }, {
        key: 'getCashDownFromTargetPayment',
        value: function getCashDownFromTargetPayment(targetPayment) {
            var selectedFinanceTerm = this.getSelectedFinanceTerm();
            if (!selectedFinanceTerm || (0, _lodash.isEmpty)(selectedFinanceTerm.paymentFrequencies) || (0, _lodash.isUndefined)(selectedFinanceTerm.paymentFrequencies[selectedFinanceTerm.paymentFrequency])) {
                return 0;
            }

            var currentPaymentFrequency = selectedFinanceTerm.paymentFrequencies[selectedFinanceTerm.paymentFrequency];
            var financeFactor = currentPaymentFrequency.financeFactor;

            if (financeFactor <= 0) {
                return 0;
            }

            var netPayment = selectedFinanceTerm.get('calculatedNetPayment');
            // eslint-disable-next-line no-restricted-globals
            var targetPaymentValue = isNaN(targetPayment) ? 0 : targetPayment;

            var targetCashdown = (netPayment - targetPaymentValue) / financeFactor;
            if (targetCashdown < 0 || Math.round(targetCashdown) === 0) {
                targetCashdown = 0;
            }
            return targetCashdown;
        }

        // I18n argument is the LocalService class to translate

    }, {
        key: 'getSelectedFinanceKMPlanParameters',
        value: function getSelectedFinanceKMPlanParameters(I18n) {
            var selectedFinance = this.getSelectedFinance();

            var kmPlanOptions = void 0;
            var selectedKMPlan = void 0;
            if (selectedFinance) {
                kmPlanOptions = selectedFinance.getKMPlansDropDownValues(I18n);
                selectedKMPlan = (0, _lodash.find)(kmPlanOptions, { value: selectedFinance.annualKMAllowed });
            }

            return selectedFinance ? {
                annualKMAllowed: selectedFinance.annualKMAllowed,
                endTermKMCost: selectedFinance.endTermKMCost,
                kmPlanOptions: kmPlanOptions,
                selectedKMPlan: selectedKMPlan
            } : {
                annualKMAllowed: 0,
                endTermKMCost: 0,
                kmPlanOptions: '',
                selectedKMPlan: ''
            };
        }
    }, {
        key: 'getSelectedFinanceCalculatedPayments',
        value: function getSelectedFinanceCalculatedPayments() {
            var selectedFinanceTerm = this.getSelectedFinanceTerm();
            if (!selectedFinanceTerm) {
                return {
                    calculatedPaymentBeforeTaxes: 0,
                    calculatedPaymentTaxes: 0,
                    calculatedPayment: 0,
                    minimumPayment: 0,
                    maximumPayment: 0
                };
            }

            var calculatedPayments = selectedFinanceTerm.getCalculatedPayments(this.taxesIncluded);
            return {
                calculatedPaymentBeforeTaxes: calculatedPayments.calculatedPaymentBeforeTaxes,
                calculatedPaymentTaxes: calculatedPayments.calculatedPaymentTaxes,
                calculatedPayment: calculatedPayments.calculatedPayment,
                minimumPayment: 0,
                maximumPayment: selectedFinanceTerm.calculatedNetPayment
            };
        }
    }, {
        key: 'getSelectedFinanceCashDown',
        value: function getSelectedFinanceCashDown() {
            var selectedFinanceTerm = this.getSelectedFinanceTerm();
            return selectedFinanceTerm ? selectedFinanceTerm.cashDown : 0;
        }
    }, {
        key: 'getSelectedFinanceRebateTaxesAtDelivery',
        value: function getSelectedFinanceRebateTaxesAtDelivery() {
            var selectedFinanceTerm = this.getSelectedFinanceTerm();
            return selectedFinanceTerm ? selectedFinanceTerm.rebatesTaxesAtDelivery : 0;
        }
    }, {
        key: 'getSelectedRebatesAtStandardRate',
        value: function getSelectedRebatesAtStandardRate() {
            var selectedFinanceTerm = this.getSelectedFinanceTerm();
            return selectedFinanceTerm ? selectedFinanceTerm.rebatesAtStandardRate : 0;
        }
    }, {
        key: 'getSelectedPurchaseMethodDiscounts',
        value: function getSelectedPurchaseMethodDiscounts() {
            var selectedFinanceTerm = this.getSelectedFinanceTerm();
            return selectedFinanceTerm ? selectedFinanceTerm.discounts : this.cashPurchase.discounts + this.cashPurchase.optionsAdjustmentDiscounts;
        }
    }, {
        key: 'getSelectedPurchaseMethodRebates',
        value: function getSelectedPurchaseMethodRebates() {
            var selectedFinanceTerm = this.getSelectedFinanceTerm();
            return selectedFinanceTerm ? selectedFinanceTerm.rebates + selectedFinanceTerm.rebatesTaxes : this.cashPurchase.rebates + this.cashPurchase.rebatesTaxes;
        }
    }, {
        key: 'getSelectedPurchaseMethodRebatesTaxes',
        value: function getSelectedPurchaseMethodRebatesTaxes() {
            var isLease = this.lease.selected;
            if (isLease) {
                return 0;
            }
            var selectedFinanceTerm = this.getSelectedFinanceTerm();
            return selectedFinanceTerm ? selectedFinanceTerm.rebatesTaxes : this.cashPurchase.rebatesTaxes;
        }
    }, {
        key: 'getCashPurchaseAmounts',
        value: function getCashPurchaseAmounts() {
            var msrp = this.cashPurchase.getRetail();
            var taxes = msrp * this.taxesFactor;

            var rebates = 0;
            var dealerDiscounts = 0;
            var freightPDI = 0;
            var taxAndDuty = 0;
            var allSelectedOptions = this.getAllSelectedOptions();
            if (!(0, _lodash.isEmpty)(allSelectedOptions)) {
                rebates = this.getRebatesAmount(allSelectedOptions) + this.getDiscountsAmount(allSelectedOptions);
                dealerDiscounts = this.getDealerDiscountsAmount(allSelectedOptions);
                if (!rebates) {
                    rebates = this.cashPurchase.getTotalRebates();
                }

                freightPDI = this.getFreightAndPDIFeesAmount(allSelectedOptions, false);
                taxAndDuty = this.getTaxesAndDutiesAmount(allSelectedOptions, false) + this.getOtherFeesAmount(allSelectedOptions, false) + this.cashPurchase.dealerFees;
            } else {
                rebates = this.cashPurchase.getTotalRebates();
            }
            rebates += this.employeeRebateAdjustment;

            msrp -= freightPDI;
            msrp -= taxAndDuty;
            msrp -= rebates;

            return {
                msrp: msrp,
                rebates: rebates,
                dealerDiscounts: dealerDiscounts,
                freightPDI: freightPDI,
                taxAndDuty: taxAndDuty,
                taxes: taxes
            };
        }

        // The includeCashPurchaseOnlyDiscount flag is used to enforce the inclusion of the cash only dealer discount

    }, {
        key: 'getPurchaseMethodSelectedOptions',
        value: function getPurchaseMethodSelectedOptions(includeCashPurchaseOnlyDiscount) {
            return this.cashPurchase.selected ? this.selectedOptions : (0, _lodash.filter)(this.selectedOptions, function (selectedOption) {
                return includeCashPurchaseOnlyDiscount || !selectedOption.isDealerCashPurchaseOnlyDiscount();
            });
        }

        // The includeCashPurchaseOnlyDiscount flag is used to enforce the inclusion of the cash only dealer discount

    }, {
        key: 'getAllSelectedOptions',
        value: function getAllSelectedOptions(includeCashPurchaseOnlyDiscount) {
            return (0, _lodash.unionBy)(this.configurationOptions, this.getPurchaseMethodSelectedOptions(includeCashPurchaseOnlyDiscount), 'selectionCode');
        }
    }, {
        key: 'getNonConfigurationSelectedOptions',
        value: function getNonConfigurationSelectedOptions() {
            return (0, _lodash.differenceBy)(this.getPurchaseMethodSelectedOptions(), this.configurationOptions, 'selectionCode');
        }
    }, {
        key: 'getSelectedPurchaseMethodAmounts',
        value: function getSelectedPurchaseMethodAmounts() {
            var tradeIn = this.tradeIn,
                lien = this.lien;

            var cashDown = this.getSelectedFinanceCashDown();

            var modelTrim = this.cashPurchase.retail - this.cashPurchase.pricingAmounts.freightPDI - this.cashPurchase.pricingAmounts.taxesAndDuties;
            var exteriorColour = 0;
            var interiorColour = 0;
            var options = this.cashPurchase.optionsAdjustment;
            var discounts = this.getSelectedPurchaseMethodDiscounts() + this.employeeRebateAdjustment;
            var rebates = this.getSelectedPurchaseMethodRebates();
            var rebatesTaxes = this.getSelectedPurchaseMethodRebatesTaxes();
            var freightPDI = this.cashPurchase.pricingAmounts.freightPDI;

            var otherFees = 0;
            var taxAndDuty = this.cashPurchase.pricingAmounts.taxesAndDuties;
            var protections = 0;

            var taxes = this.getSelectedPurchaseMethodValue() === _purchaseMethodsValues2.default.LEASE ? 0 : this.getRoundedAmount(this.taxesFactor * (modelTrim + exteriorColour + interiorColour + options + freightPDI + otherFees + taxAndDuty + protections - (discounts + this.tradeIn)));

            if (this.cashPurchase.retailAdjustment) {
                modelTrim -= this.cashPurchase.retailAdjustment;
            }

            var allSelectedOptions = this.getAllSelectedOptions();
            if ((0, _lodash.isEmpty)(allSelectedOptions) || this.hasOnlyModelTrimOption(allSelectedOptions)) {
                return {
                    modelTrim: modelTrim,
                    exteriorColour: exteriorColour,
                    interiorColour: interiorColour,
                    options: options,
                    discounts: discounts,
                    freightPDI: freightPDI,
                    otherFees: otherFees,
                    taxAndDuty: taxAndDuty,
                    rebates: rebates,
                    protections: protections,
                    taxes: taxes < 0 ? 0 : taxes,
                    tradeIn: tradeIn,
                    lien: lien,
                    cashDown: cashDown
                };
            }
            var configurationOptionsDiscounts = (0, _lodash.isEmpty)(this.configurationOptions) ? 0 : discounts;

            modelTrim = this.getModelTrimAmount(allSelectedOptions);
            exteriorColour = this.getExteriorColourAmount(allSelectedOptions);
            interiorColour = this.getInteriorColourAmount(allSelectedOptions);
            options = this.getOptionsAmount(allSelectedOptions);
            var discountsFromOptions = this.getDiscountsAmount(allSelectedOptions) + this.getDealerDiscountsAmount(allSelectedOptions);
            discounts = discountsFromOptions > 0 ? discountsFromOptions + configurationOptionsDiscounts : discounts;
            var rebatesFromOptions = this.getRebatesAmount(allSelectedOptions);
            rebates = rebatesFromOptions > 0 ? rebatesFromOptions + rebatesTaxes : rebates;
            freightPDI = this.getFreightAndPDIFeesAmount(allSelectedOptions, false);
            otherFees = this.getOtherFeesAmount(allSelectedOptions, false);
            taxAndDuty = this.getTaxesAndDutiesAmount(allSelectedOptions, false);
            protections = this.getProtectionsAmount(allSelectedOptions);

            taxes = this.getSelectedPurchaseMethodValue() === _purchaseMethodsValues2.default.LEASE ? 0 : this.getRoundedAmount(this.taxesFactor * (modelTrim + exteriorColour + interiorColour + options + freightPDI + otherFees + taxAndDuty + protections - (discounts + this.tradeIn)));

            return {
                modelTrim: modelTrim,
                exteriorColour: exteriorColour,
                interiorColour: interiorColour,
                options: options,
                discounts: discounts,
                freightPDI: freightPDI,
                otherFees: otherFees,
                taxAndDuty: taxAndDuty,
                rebates: rebates,
                protections: protections,
                taxes: taxes < 0 ? 0 : taxes,
                tradeIn: tradeIn,
                lien: lien,
                cashDown: cashDown
            };
        }
    }, {
        key: 'getSelectedPurchaseMethodResidualAmounts',
        value: function getSelectedPurchaseMethodResidualAmounts() {
            var selectedFinanceTerm = this.getSelectedFinanceTerm();

            return selectedFinanceTerm ? selectedFinanceTerm.residualAmount + selectedFinanceTerm.optionsResidualRetail * (selectedFinanceTerm.residualRate / 100) : 0;
        }
    }, {
        key: 'getSelectedPurchaseMethodDeliveryAmounts',
        value: function getSelectedPurchaseMethodDeliveryAmounts() {
            var allSelectedOptions = this.getAllSelectedOptions();
            var deliveryFees = this.getFreightAndPDIFeesAmount(allSelectedOptions, true) + this.getTaxesAndDutiesAmount(allSelectedOptions, true) + this.getOtherFeesAmount(allSelectedOptions, true);
            var deliveryCashDown = this.getSelectedFinanceCashDown();
            var deliveryRebatesTaxes = this.getSelectedFinanceRebateTaxesAtDelivery();
            var deliveryTaxes = this.lease.selected ? this.getRoundedAmount(this.taxesFactor * (deliveryFees + deliveryCashDown)) : this.getRoundedAmount(this.taxesFactor * deliveryFees);

            var deposit = this.getDepositAmount(allSelectedOptions);

            var _getSelectedFinanceCa = this.getSelectedFinanceCalculatedPayments(),
                calculatedPayment = _getSelectedFinanceCa.calculatedPayment;

            var upfrontPayment = this.lease.selected ? calculatedPayment : 0;

            return {
                deliveryFees: deliveryFees,
                deliveryCashDown: deliveryCashDown,
                deliveryTaxes: deliveryTaxes,
                deliveryRebatesTaxes: deliveryRebatesTaxes,
                deposit: deposit,
                upfrontPayment: upfrontPayment
            };
        }
    }, {
        key: 'getRoundedAmount',
        value: function getRoundedAmount(amount) {
            return Math.round(amount * 100) / 100;
        }
    }, {
        key: 'getModelTrimAmount',
        value: function getModelTrimAmount(options) {
            return this.getRoundedAmount((0, _lodash.reduce)(options, function (sum, option) {
                return sum + (option.dataType === dataTypes.DATA_TYPES.FEATURE.DATA_TYPE_ID && option.typeID >= dataTypes.DATA_TYPES.FEATURE.TYPES.MODEL_TRIM && option.typeID <= dataTypes.DATA_TYPES.FEATURE.TYPES.TRANSMISSION ? option.retail : 0);
            }, 0));
        }
    }, {
        key: 'getDiscountsAmount',
        value: function getDiscountsAmount(options) {
            return this.getRoundedAmount((0, _lodash.reduce)(options, function (sum, option) {
                return sum + (option.dataType === dataTypes.DATA_TYPES.REBATE.DATA_TYPE_ID && option.typeID !== dataTypes.DATA_TYPES.REBATE.TYPES.DAA_CASH_DOWN && option.isTaxable && !option.isDealerDiscount() ? option.retail : 0);
            }, 0));
        }
    }, {
        key: 'getExteriorColourAmount',
        value: function getExteriorColourAmount(options) {
            return this.getRoundedAmount((0, _lodash.reduce)(options, function (sum, option) {
                return sum + (option.dataType === dataTypes.DATA_TYPES.FEATURE.DATA_TYPE_ID && option.typeID === dataTypes.DATA_TYPES.FEATURE.TYPES.EXTERIOR_COLOUR ? option.retail : 0);
            }, 0));
        }
    }, {
        key: 'getExteriorColourResidualizingAmount',
        value: function getExteriorColourResidualizingAmount(options) {
            return this.getRoundedAmount((0, _lodash.reduce)(options, function (sum, option) {
                return sum + (option.dataType === dataTypes.DATA_TYPES.FEATURE.DATA_TYPE_ID && option.typeID === dataTypes.DATA_TYPES.FEATURE.TYPES.EXTERIOR_COLOUR ? option.residualizingAmount : 0);
            }, 0));
        }
    }, {
        key: 'getInteriorColourAmount',
        value: function getInteriorColourAmount(options) {
            return this.getRoundedAmount((0, _lodash.reduce)(options, function (sum, option) {
                return sum + (option.dataType === dataTypes.DATA_TYPES.FEATURE.DATA_TYPE_ID && option.typeID === dataTypes.DATA_TYPES.FEATURE.TYPES.INTERIOR_TRIM ? option.retail : 0);
            }, 0));
        }
    }, {
        key: 'getInteriorColourResidualizingAmount',
        value: function getInteriorColourResidualizingAmount(options) {
            return this.getRoundedAmount((0, _lodash.reduce)(options, function (sum, option) {
                return sum + (option.dataType === dataTypes.DATA_TYPES.FEATURE.DATA_TYPE_ID && option.typeID === dataTypes.DATA_TYPES.FEATURE.TYPES.INTERIOR_TRIM ? option.residualizingAmount : 0);
            }, 0));
        }
    }, {
        key: 'getOptionsAmount',
        value: function getOptionsAmount(options) {
            return this.getRoundedAmount((0, _lodash.reduce)(options, function (sum, option) {
                return sum + (checkIsOption(option) && option.supplier !== 'D' ? option.retail : 0);
            }, 0));
        }
    }, {
        key: 'getOptionsResidualizingAmount',
        value: function getOptionsResidualizingAmount(options) {
            return this.getRoundedAmount((0, _lodash.reduce)(options, function (sum, option) {
                return sum + (option.dataType === dataTypes.DATA_TYPES.FEATURE.DATA_TYPE_ID && (option.typeID < dataTypes.DATA_TYPES.FEATURE.TYPES.MODEL_TRIM || option.typeID > dataTypes.DATA_TYPES.FEATURE.TYPES.INTERIOR_TRIM) ? option.residualizingAmount : 0);
            }, 0));
        }
    }, {
        key: 'getRebatesAmount',
        value: function getRebatesAmount(options) {
            return this.getRoundedAmount((0, _lodash.reduce)(options, function (sum, option) {
                return sum + (option.dataType === dataTypes.DATA_TYPES.REBATE.DATA_TYPE_ID && option.typeID !== dataTypes.DATA_TYPES.REBATE.TYPES.DAA_CASH_DOWN && !option.isTaxable && !option.isDealerDiscount() ? option.retail : 0);
            }, 0));
        }
    }, {
        key: 'getFreightAndPDIFeesAmount',
        value: function getFreightAndPDIFeesAmount(options, dueAtDelivery) {
            return this.getRoundedAmount((0, _lodash.reduce)(options, function (sum, option) {
                return sum + ((dueAtDelivery && option.dueAtDelivery || !dueAtDelivery && !option.dueAtDelivery) && option.dataType === dataTypes.DATA_TYPES.FEE.DATA_TYPE_ID && (option.typeID === dataTypes.DATA_TYPES.FEE.TYPES.FREIGHT || option.typeID === dataTypes.DATA_TYPES.FEE.TYPES.PREPARATION) ? option.retail : 0);
            }, 0));
        }
    }, {
        key: 'getOtherFeesAmount',
        value: function getOtherFeesAmount(options, dueAtDelivery) {
            var isShowroomV25Enabled = _widgetCommonsCoreServices.ConfigsService.isShowroomV25Enabled();
            return this.getRoundedAmount((0, _lodash.reduce)(options, function (sum, option) {
                if (isShowroomV25Enabled) {
                    return sum + ((dueAtDelivery && option.dueAtDelivery || !dueAtDelivery && !option.dueAtDelivery) && option.dataType === dataTypes.DATA_TYPES.FEE.DATA_TYPE_ID && option.typeID > dataTypes.DATA_TYPES.FEE.TYPES.PREPARATION && option.typeID !== dataTypes.DATA_TYPES.FEE.TYPES.CHECKOUT_DEPOSIT && option.typeID !== dataTypes.DATA_TYPES.FEE.TYPES.RESERVATION_DEPOSIT ? option.retail : 0);
                }
                return sum + ((dueAtDelivery && option.dueAtDelivery || !dueAtDelivery && !option.dueAtDelivery) && (option.dataType === dataTypes.DATA_TYPES.FEE.DATA_TYPE_ID && option.typeID > dataTypes.DATA_TYPES.FEE.TYPES.PREPARATION && option.typeID !== dataTypes.DATA_TYPES.FEE.TYPES.CHECKOUT_DEPOSIT && option.typeID !== dataTypes.DATA_TYPES.FEE.TYPES.RESERVATION_DEPOSIT || checkIsOption(option) && option.supplier === 'D') ? option.retail : 0);
            }, 0));
        }
    }, {
        key: 'getOtherFeesAmountIncluded',
        value: function getOtherFeesAmountIncluded(options) {
            return this.getRoundedAmount((0, _lodash.reduce)(options, function (sum, option) {
                return sum + (!option.dueAtDelivery && option.isIncludedInPriceOrPayment && option.dataType === dataTypes.DATA_TYPES.FEE.DATA_TYPE_ID && option.typeID > dataTypes.DATA_TYPES.FEE.TYPES.PREPARATION && option.typeID !== dataTypes.DATA_TYPES.FEE.TYPES.CHECKOUT_DEPOSIT && option.typeID !== dataTypes.DATA_TYPES.FEE.TYPES.RESERVATION_DEPOSIT ? option.retail : 0);
            }, 0));
        }
    }, {
        key: 'getProtectionsAmountIncluded',
        value: function getProtectionsAmountIncluded(options) {
            return this.getRoundedAmount((0, _lodash.reduce)(options, function (sum, option) {
                return sum + (!option.dueAtDelivery && option.isIncludedInPriceOrPayment && option.dataType === dataTypes.DATA_TYPES.PROTECTION.DATA_TYPE_ID ? option.retail : 0);
            }, 0));
        }
    }, {
        key: 'getTaxesAndDutiesAmount',
        value: function getTaxesAndDutiesAmount(options, dueAtDelivery) {
            return this.getRoundedAmount((0, _lodash.reduce)(options, function (sum, option) {
                return sum + ((dueAtDelivery && option.dueAtDelivery || !dueAtDelivery && !option.dueAtDelivery) && option.dataType === dataTypes.DATA_TYPES.TAX_AND_DUTY.DATA_TYPE_ID ? option.retail : 0);
            }, 0));
        }
    }, {
        key: 'getProtectionsAmount',
        value: function getProtectionsAmount(options) {
            return this.getRoundedAmount((0, _lodash.reduce)(options, function (sum, option) {
                return sum + (option.dataType === dataTypes.DATA_TYPES.PROTECTION.DATA_TYPE_ID ? option.retail : 0);
            }, 0));
        }
    }, {
        key: 'getDealerDiscountsAmount',
        value: function getDealerDiscountsAmount(options) {
            return this.getRoundedAmount((0, _lodash.reduce)(options, function (sum, option) {
                return sum + (option.isDealerDiscount() ? option.retail : 0);
            }, 0));
        }
    }, {
        key: 'getSelectedPurchaseMethodRetailOrPayment',
        value: function getSelectedPurchaseMethodRetailOrPayment() {
            var selectedFinanceTerm = this.getSelectedFinanceTerm();
            if (!selectedFinanceTerm) {
                return this.cashPurchase.getRetail() - this.cashPurchase.getTotalRebates();
            }
            return selectedFinanceTerm.calculatedPayment;
        }
    }, {
        key: 'getTradeInWithTaxCredits',
        value: function getTradeInWithTaxCredits() {
            return this.tradeIn + this.cashPurchase.tradeInTaxesAdjustment;
        }
    }, {
        key: 'getDepositAmount',
        value: function getDepositAmount(options) {
            return this.getRoundedAmount((0, _lodash.reduce)(options, function (sum, option) {
                return sum + (option.typeID === dataTypes.DATA_TYPES.FEE.TYPES.CHECKOUT_DEPOSIT || option.typeID === dataTypes.DATA_TYPES.FEE.TYPES.RESERVATION_DEPOSIT ? option.retail : 0);
            }, 0));
        }
    }, {
        key: 'getDeliveryFee',
        value: function getDeliveryFee() {
            var fee = (0, _lodash.find)(this.getAllSelectedOptions(), function (option) {
                return option.dataType === dataTypes.DATA_TYPES.FEE.DATA_TYPE_ID && option.typeID === dataTypes.DATA_TYPES.FEE.TYPES.DELIVERY;
            });

            if (!fee) {
                fee = (0, _lodash.find)(this.availableOptions, function (option) {
                    return option.dataType === dataTypes.DATA_TYPES.FEE.DATA_TYPE_ID && option.typeID === dataTypes.DATA_TYPES.FEE.TYPES.DELIVERY;
                });
            }
            return fee;
        }
    }, {
        key: 'getCheckoutDeposit',
        value: function getCheckoutDeposit() {
            var deposit = (0, _lodash.find)(this.getAllSelectedOptions(), function (option) {
                return option.dataType === dataTypes.DATA_TYPES.FEE.DATA_TYPE_ID && option.typeID === dataTypes.DATA_TYPES.FEE.TYPES.CHECKOUT_DEPOSIT;
            });

            if (!deposit) {
                deposit = (0, _lodash.find)(this.availableOptions, function (option) {
                    return option.dataType === dataTypes.DATA_TYPES.FEE.DATA_TYPE_ID && option.typeID === dataTypes.DATA_TYPES.FEE.TYPES.CHECKOUT_DEPOSIT;
                });
            }
            return deposit;
        }
    }, {
        key: 'getReservationDeposit',
        value: function getReservationDeposit() {
            var deposit = (0, _lodash.find)(this.getAllSelectedOptions(), function (option) {
                return option.dataType === dataTypes.DATA_TYPES.FEE.DATA_TYPE_ID && option.typeID === dataTypes.DATA_TYPES.FEE.TYPES.RESERVATION_DEPOSIT;
            });

            if (!deposit) {
                deposit = (0, _lodash.find)(this.availableOptions, function (option) {
                    return option.dataType === dataTypes.DATA_TYPES.FEE.DATA_TYPE_ID && option.typeID === dataTypes.DATA_TYPES.FEE.TYPES.RESERVATION_DEPOSIT;
                });
            }
            return deposit;
        }
    }, {
        key: 'getSelectedExteriorColourCode',
        value: function getSelectedExteriorColourCode() {
            var selectedOption = (0, _lodash.find)(this.getAllSelectedOptions(), function (option) {
                return option.dataType === dataTypes.DATA_TYPES.FEATURE.DATA_TYPE_ID && option.typeID === dataTypes.DATA_TYPES.FEATURE.TYPES.EXTERIOR_COLOUR;
            });
            return selectedOption ? selectedOption.code : '';
        }
    }, {
        key: 'getSelectedInteriorColourCode',
        value: function getSelectedInteriorColourCode() {
            var selectedOption = (0, _lodash.find)(this.getAllSelectedOptions(), function (option) {
                return option.dataType === dataTypes.DATA_TYPES.FEATURE.DATA_TYPE_ID && option.typeID === dataTypes.DATA_TYPES.FEATURE.TYPES.INTERIOR_TRIM;
            });
            return selectedOption ? selectedOption.code : '';
        }
    }, {
        key: 'getSelectedOptionsPackage',
        value: function getSelectedOptionsPackage() {
            return (0, _lodash.filter)(this.getAllSelectedOptions(), function (option) {
                return option.dataType === dataTypes.DATA_TYPES.FEATURE.DATA_TYPE_ID && option.typeID === dataTypes.DATA_TYPES.FEATURE.TYPES.PACKAGE;
            });
        }
    }, {
        key: 'getSelectedOptions',
        value: function getSelectedOptions() {
            return (0, _lodash.filter)(this.getAllSelectedOptions(), function (option) {
                return option.dataType === dataTypes.DATA_TYPES.FEATURE.DATA_TYPE_ID && (option.typeID < dataTypes.DATA_TYPES.FEATURE.TYPES.MODEL_TRIM || option.typeID > dataTypes.DATA_TYPES.FEATURE.TYPES.INTERIOR_TRIM);
            });
        }
    }, {
        key: 'getSelectedProtections',
        value: function getSelectedProtections() {
            return (0, _lodash.filter)(this.getAllSelectedOptions(), function (option) {
                return option.dataType === dataTypes.DATA_TYPES.PROTECTION.DATA_TYPE_ID;
            });
        }
    }, {
        key: 'getSelectedProtectionsPackages',
        value: function getSelectedProtectionsPackages() {
            var selectedProtections = this.getSelectedProtections();
            var selectedProtectionsPackages = (0, _lodash.filter)(selectedProtections, function (protection) {
                return !(0, _lodash.isEmpty)(protection.includedCodes);
            });
            if ((0, _lodash.isEmpty)(selectedProtectionsPackages)) {
                return selectedProtections;
            }

            var includedCodes = (0, _lodash.flatten)((0, _lodash.map)(selectedProtectionsPackages, function (protection) {
                return [].concat(_toConsumableArray(protection.includedCodes), [protection.selectionCode]);
            }));

            var selectedSingleProtections = (0, _lodash.filter)(selectedProtections, function (protection) {
                return !(0, _lodash.includes)(includedCodes, protection.selectionCode);
            });
            var packagedProtections = (0, _lodash.filter)(selectedProtections, function (protection) {
                return (0, _lodash.includes)(includedCodes, protection.selectionCode);
            });

            var selectedPackagedProtections = [];
            (0, _lodash.forEach)(selectedProtectionsPackages, function (protectionsPackage) {
                var packageIncludedProtections = (0, _lodash.filter)(packagedProtections, function (protection) {
                    return (0, _lodash.includes)(protectionsPackage.includedCodes, protection.selectionCode);
                });

                var packageDescription = (0, _lodash.isEmpty)(packageIncludedProtections) ? protectionsPackage.description : (0, _lodash.join)((0, _lodash.map)(packageIncludedProtections, function (protection) {
                    return protection.label;
                }), ', ');

                var packageIncludedProtectionsRetail = (0, _lodash.sumBy)(packageIncludedProtections, function (protection) {
                    return protection.retail;
                });
                var packageIncludedProtectionsResidual = (0, _lodash.sumBy)(packageIncludedProtections, function (protection) {
                    return protection.residualizingAmount;
                });

                selectedPackagedProtections.push(protectionsPackage.set('description', packageDescription).set('retail', protectionsPackage.retail + packageIncludedProtectionsRetail).set('residualizingAmount', protectionsPackage.residualizingAmount + packageIncludedProtectionsResidual));
            });

            return (0, _lodash.orderBy)((0, _lodash.concat)(selectedPackagedProtections, selectedSingleProtections), 'keyOrder');
        }
    }, {
        key: 'getSelectedOptionsAndColours',
        value: function getSelectedOptionsAndColours() {
            return (0, _lodash.filter)(this.getAllSelectedOptions(), function (option) {
                return option.dataType === dataTypes.DATA_TYPES.FEATURE.DATA_TYPE_ID && (option.typeID < dataTypes.DATA_TYPES.FEATURE.TYPES.MODEL_TRIM || option.typeID > dataTypes.DATA_TYPES.FEATURE.TYPES.TRANSMISSION);
            });
        }
    }, {
        key: 'getSelectedDealerFees',
        value: function getSelectedDealerFees() {
            return (0, _lodash.filter)(this.getAllSelectedOptions(), function (option) {
                return option.isDealerFee();
            });
        }

        // The includeCashPurchaseOnlyDiscount flag is used to enforce the inclusion of the cash only dealer discount

    }, {
        key: 'getSelectedDealerDiscounts',
        value: function getSelectedDealerDiscounts(includeCashPurchaseOnlyDiscount) {
            return (0, _lodash.filter)(this.getAllSelectedOptions(includeCashPurchaseOnlyDiscount), function (option) {
                return option.isDealerDiscount();
            });
        }
    }, {
        key: 'getElectricRebate',
        value: function getElectricRebate() {
            var selectedTerm = this.getSelectedFinanceTerm();
            var electricRebate = void 0;
            if (selectedTerm) {
                electricRebate = selectedTerm.getElectricRebate();
            }
            return (0, _lodash.isEmpty)(electricRebate) ? this.cashPurchase.getElectricRebate() : electricRebate;
        }
    }, {
        key: 'getBonusRebate',
        value: function getBonusRebate() {
            var bonusRebate = {
                amount: 0,
                cashPurchase: false,
                lease: false,
                finance: false
            };

            var leaseSelectedTerm = this.lease.getSelectedTerm();
            if (leaseSelectedTerm && leaseSelectedTerm.rebatesAtDelivery > 0) {
                bonusRebate.amount = leaseSelectedTerm.rebatesAtDelivery;
                bonusRebate.lease = true;
            }

            var financeSelectedTerm = this.finance.getSelectedTerm();
            if (financeSelectedTerm && financeSelectedTerm.rebatesAtDelivery > 0) {
                bonusRebate.amount = bonusRebate.amount > financeSelectedTerm.rebatesAtDelivery ? financeSelectedTerm.rebatesAtDelivery : bonusRebate.amount;
                bonusRebate.finance = true;
            }

            if (this.cashPurchase.rebatesAtDelivery > 0) {
                bonusRebate.amount = bonusRebate.amount > this.cashPurchase.rebatesAtDelivery ? this.cashPurchase.rebatesAtDelivery : bonusRebate.amount;
                bonusRebate.cashPurchase = true;
            }

            return bonusRebate;
        }
    }, {
        key: 'getEmployeeRebate',
        value: function getEmployeeRebate() {
            var selectedTerm = this.getSelectedFinanceTerm();
            return selectedTerm ? selectedTerm.getEmployeeRebate() : this.cashPurchase.getEmployeeRebate();
        }
    }, {
        key: 'getDisclaimerParameters',
        value: function getDisclaimerParameters() {
            var cashPurchase = this.cashPurchase,
                finance = this.finance,
                lease = this.lease;


            var cashPurchaseDisclaimer = {
                purchaseMethod: cashPurchase.purchaseMethodValue,
                terms: [0],
                frequencies: [0]
            };
            var financeDisclaimer = finance.getDisclaimerParameters();
            var leaseDisclaimer = lease.getDisclaimerParameters();

            var disclaimerParameters = [cashPurchaseDisclaimer];
            if (!(0, _lodash.isNull)(financeDisclaimer)) {
                disclaimerParameters.push(financeDisclaimer);
            }
            if (!(0, _lodash.isNull)(leaseDisclaimer)) {
                disclaimerParameters.push(leaseDisclaimer);
            }

            return disclaimerParameters;
        }
    }, {
        key: 'getDisclaimersForCurrentMethod',
        value: function getDisclaimersForCurrentMethod() {
            var disclaimers = this.disclaimers;

            switch (this.getSelectedPurchaseMethodValue()) {
                case _purchaseMethodsValues2.default.FINANCE:
                    return disclaimers.finance;
                case _purchaseMethodsValues2.default.LEASE:
                    return disclaimers.lease;
                case _purchaseMethodsValues2.default.CASH:
                    return disclaimers.cashPurchase;
                default:
                    return null;
            }
        }
    }, {
        key: 'hasOnlyModelTrimOption',
        value: function hasOnlyModelTrimOption(options) {
            return options && options.length === 1 && options[0].code === MODEL_TRIM_OPTION_CODE;
        }
    }]);

    return PurchaseMethods;
}(PurchaseMethodsRecord);

exports.default = PurchaseMethods;

/***/ }),

/***/ "./src/PurchaseMethods/models/TermModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("lodash");

var _immutable = __webpack_require__("immutable");

var _paymentFrequencies = __webpack_require__("./src/PurchaseMethods/constants/paymentFrequencies.js");

var _dataTypes = __webpack_require__("./src/constants/dataTypes.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TermRecord = (0, _immutable.Record)({
    term: 0,
    termIndex: 0,
    apr: 0,
    residualRate: 0,
    cashDown: 0,
    discounts: 0,
    rebates: 0,
    rebatesTaxes: 0,
    rebatesAtDelivery: 0,
    rebatesTaxesAtDelivery: 0,
    rebatesAtStandardRate: 0,
    paymentFrequencies: {},
    paymentFrequency: _paymentFrequencies.MONTHLY,
    payment: 0,
    paymentTaxes: 0,
    financedAmount: 0,
    financedAmountWithTaxes: 0,
    financedAmountAdjustment: 0,
    financedAmountWithTaxesAdjustment: 0,
    residualAmount: 0,
    optionsResidualRetail: 0,
    optionsPaymentAdjustment: 0,
    optionsPaymentTaxesAdjustment: 0,
    cashDownPaymentAdjustment: 0,
    netTradeInPaymentAdjustment: 0,
    netTradeInPaymentTaxesAdjustment: 0,
    calculatedNetPayment: 0,
    calculatedPayment: 0,
    includedItemsCodes: [],
    rebatesDetails: []
});

var Term = function (_TermRecord) {
    _inherits(Term, _TermRecord);

    function Term() {
        _classCallCheck(this, Term);

        return _possibleConstructorReturn(this, (Term.__proto__ || Object.getPrototypeOf(Term)).apply(this, arguments));
    }

    _createClass(Term, [{
        key: 'calculatePaymentAdjustment',
        value: function calculatePaymentAdjustment(financedAmount, residualRetailAmount) {
            var currentPaymentFrequency = this.paymentFrequencies[this.paymentFrequency];
            var residualAmount = residualRetailAmount * (this.residualRate / 100);

            return currentPaymentFrequency ? financedAmount * currentPaymentFrequency.financeFactor + residualAmount * currentPaymentFrequency.balloonFactor : 0;
        }
    }, {
        key: 'getBestPaymentFrequency',
        value: function getBestPaymentFrequency() {
            if ((0, _lodash.isEmpty)(this.paymentFrequencies)) {
                return _paymentFrequencies.MONTHLY;
            }
            var frequencies = (0, _lodash.values)(this.paymentFrequencies);
            return (0, _lodash.maxBy)(frequencies, 'paymentFrequency').paymentFrequency;
        }
    }, {
        key: 'getAvailablePaymentFrequencies',
        value: function getAvailablePaymentFrequencies() {
            if ((0, _lodash.isEmpty)(this.paymentFrequencies)) {
                return [_paymentFrequencies.MONTHLY];
            }
            var frequencies = (0, _lodash.values)(this.paymentFrequencies);
            return (0, _lodash.orderBy)((0, _lodash.map)(frequencies, function (frequency) {
                return frequency.paymentFrequency;
            }), ['paymentFrequency'], ['desc']);
        }
    }, {
        key: 'getPaymentFrequency',
        value: function getPaymentFrequency() {
            return this.paymentFrequencies[this.paymentFrequency];
        }
    }, {
        key: 'getCalculatedPayments',
        value: function getCalculatedPayments(taxesIncluded) {
            var calculatedPaymentRounded = Math.round(this.calculatedPayment * 100) / 100;
            var calculatedPaymentTaxes = Math.round((this.paymentTaxes + this.optionsPaymentTaxesAdjustment - this.netTradeInPaymentTaxesAdjustment) * 100) / 100;
            var calculatedPaymentBeforeTaxes = taxesIncluded ? calculatedPaymentRounded - calculatedPaymentTaxes : calculatedPaymentRounded;

            return {
                calculatedPaymentBeforeTaxes: calculatedPaymentBeforeTaxes,
                calculatedPaymentTaxes: calculatedPaymentTaxes,
                calculatedPayment: calculatedPaymentBeforeTaxes + calculatedPaymentTaxes
            };
        }
    }, {
        key: 'getFinancedAmount',
        value: function getFinancedAmount() {
            return this.financedAmount;
        }
    }, {
        key: 'getDiscountsAndRebates',
        value: function getDiscountsAndRebates() {
            return this.discounts + this.rebates;
        }
    }, {
        key: 'getDisclaimerAmounts',
        value: function getDisclaimerAmounts(taxesIncluded, financedAmountAdjustment, residualAmountAdjustment) {
            var calculatedPayments = this.getCalculatedPayments(false);
            var paymentsCount = this.term * this.paymentFrequency / _paymentFrequencies.MONTHLY;
            var financedAmount = (taxesIncluded ? this.financedAmountWithTaxes + this.financedAmountWithTaxesAdjustment : this.financedAmount + this.financedAmountAdjustment) + financedAmountAdjustment;
            var residualAmount = this.residualAmount + residualAmountAdjustment;

            var totalObligation = (taxesIncluded ? calculatedPayments.calculatedPayment : calculatedPayments.calculatedPaymentBeforeTaxes) * paymentsCount + residualAmount;
            var costOfCredit = totalObligation < financedAmount ? 0 : totalObligation - financedAmount;

            return {
                totalObligation: totalObligation,
                costOfCredit: costOfCredit,
                residualAmount: residualAmount
            };
        }
    }, {
        key: 'getElectricRebate',
        value: function getElectricRebate() {
            var electricRebates = (0, _lodash.filter)(this.rebatesDetails, function (rebateDetails) {
                return rebateDetails.typeId === _dataTypes.DATA_TYPES.REBATE.TYPES.ELECTRIC;
            });

            if ((0, _lodash.isEmpty)(electricRebates)) {
                return null;
            }

            return {
                description: electricRebates[0].description,
                rebate: (0, _lodash.sumBy)(electricRebates, function (electricRebate) {
                    return electricRebate.amount;
                })
            };
        }
    }, {
        key: 'getEmployeeRebate',
        value: function getEmployeeRebate() {
            var employeeRebates = (0, _lodash.filter)(this.rebatesDetails, function (rebateDetails) {
                return rebateDetails.typeId === _dataTypes.DATA_TYPES.REBATE.TYPES.EMPLOYEE;
            });

            if ((0, _lodash.isEmpty)(employeeRebates)) {
                return null;
            }

            return {
                description: employeeRebates[0].description,
                rebate: (0, _lodash.sumBy)(employeeRebates, function (employeeRebate) {
                    return employeeRebate.amount;
                })
            };
        }
    }]);

    return Term;
}(TermRecord);

exports.default = Term;

/***/ }),

/***/ "./src/PurchaseMethods/reducers/purchaseMethodsReducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = purchaseMethodReducer;

var _PurchaseMethodsModel = __webpack_require__("./src/PurchaseMethods/models/PurchaseMethodsModel.js");

var _PurchaseMethodsModel2 = _interopRequireDefault(_PurchaseMethodsModel);

var _purchaseMethodsActionTypes = __webpack_require__("./src/PurchaseMethods/actions/purchaseMethodsActionTypes.js");

var purchaseMethodsTypes = _interopRequireWildcard(_purchaseMethodsActionTypes);

var _PurchaseMethodsService = __webpack_require__("./src/PurchaseMethods/services/PurchaseMethodsService/PurchaseMethodsService.js");

var PurchaseMethodsService = _interopRequireWildcard(_PurchaseMethodsService);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function purchaseMethodReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _PurchaseMethodsModel2.default();
    var action = arguments[1];

    switch (action.type) {
        case purchaseMethodsTypes.LOAD_PURCHASE_METHODS_SUCCESS:
            return action.purchaseMethods || state;

        case purchaseMethodsTypes.SELECT_PURCHASE_METHOD:
            return PurchaseMethodsService.selectPurchaseMethod(state, action.purchaseMethod);

        case purchaseMethodsTypes.SELECT_TERM:
            return PurchaseMethodsService.selectTerm(state, action.term);

        case purchaseMethodsTypes.SELECT_PAYMENT_FREQUENCY:
            return PurchaseMethodsService.selectPaymentFrequency(state, action.paymentFrequency.value);

        case purchaseMethodsTypes.SET_CASH_DOWN:
            return PurchaseMethodsService.setCashDown(state, action.cashDown);

        case purchaseMethodsTypes.SET_TRADE_IN:
            return PurchaseMethodsService.setTradeIn(state, action.tradeIn);

        case purchaseMethodsTypes.SET_LIEN:
            return PurchaseMethodsService.setLien(state, action.lien);

        case purchaseMethodsTypes.SET_EXTERIOR_COLOUR_AMOUNTS:
            return PurchaseMethodsService.setExteriorColourAmounts(state, action.exteriorColourAmounts);

        case purchaseMethodsTypes.SET_INTERIOR_COLOUR_AMOUNTS:
            return PurchaseMethodsService.setInteriorColourAmounts(state, action.interiorColourAmounts);

        case purchaseMethodsTypes.SET_OPTIONS_AMOUNTS:
            return PurchaseMethodsService.setOptionsAmounts(state, action.optionsAmounts);

        case purchaseMethodsTypes.SET_DELIVERY_FEE:
            return PurchaseMethodsService.setDeliveryFee(state, action.addFee);

        case purchaseMethodsTypes.SET_DEPOSIT:
            return PurchaseMethodsService.setDeposit(state, action.deposit);

        case purchaseMethodsTypes.SET_TAXES_INCLUDED:
            return PurchaseMethodsService.setTaxesIncluded(state, action.taxesIncluded);

        case purchaseMethodsTypes.SELECT_KM_PLAN:
            return PurchaseMethodsService.selectKMPlan(state, action.kmPlan.value);

        case purchaseMethodsTypes.SELECT_OPTIONS_RESOLUTION:
            return PurchaseMethodsService.selectOptionsResolution(state, action.resolutionId);

        case purchaseMethodsTypes.RESET_SELECTED_INCENTIVE_REBATES:
            return PurchaseMethodsService.resetSelectedIncentiveRebates(state);

        default:
            return state;
    }
}

/***/ }),

/***/ "./src/PurchaseMethods/services/CashPurchaseService/CashPurchaseService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getRebatesDetailsFromData = getRebatesDetailsFromData;
exports.resetCashPurchaseFromOriginData = resetCashPurchaseFromOriginData;

var _lodash = __webpack_require__("lodash");

var _dataOrigins = __webpack_require__("./src/constants/dataOrigins.js");

var DataOrigins = _interopRequireWildcard(_dataOrigins);

var _dataConversions = __webpack_require__("./src/PurchaseMethods/constants/dataConversions.js");

var _purchaseMethods = __webpack_require__("./src/PurchaseMethods/constants/purchaseMethods.js");

var _CashPurchaseModel = __webpack_require__("./src/PurchaseMethods/models/CashPurchaseModel.js");

var _CashPurchaseModel2 = _interopRequireDefault(_CashPurchaseModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/* eslint import/prefer-default-export: 0 */

function getRebatesDetailsFromData(rebatesDetailsData) {
    return (0, _lodash.map)(rebatesDetailsData, function (rebatesDetail) {
        return {
            typeId: rebatesDetail[_dataConversions.REBATE_DETAILS.REBATE_TYPE_ID],
            code: rebatesDetail[_dataConversions.REBATE_DETAILS.REBATE_CODE],
            description: rebatesDetail[_dataConversions.REBATE_DETAILS.REBATE_DESCRIPTION],
            dueAtDelivery: rebatesDetail[_dataConversions.REBATE_DETAILS.REBATE_IS_AT_DELIVERY],
            isAfterTaxes: !rebatesDetail[_dataConversions.REBATE_DETAILS.REBATE_IS_AFTER_TAXES],
            amount: rebatesDetail[_dataConversions.REBATE_DETAILS.REBATE_AMOUNT],
            taxes: rebatesDetail[_dataConversions.REBATE_DETAILS.REBATE_TAXES] || 0,
            taxesAtDelivery: rebatesDetail[_dataConversions.REBATE_DETAILS.REBATE_TAXES_AT_DELIVERY] || 0
        };
    });
}

function resetCashPurchaseFromCollectionData(collectionCashPurchaseData, selected) {
    if (!collectionCashPurchaseData[_dataConversions.COLLECTION_CASH_PURCHASE.PRICING] || !collectionCashPurchaseData[_dataConversions.COLLECTION_CASH_PURCHASE.PRICING][_dataConversions.COLLECTION_CASH_PURCHASE.INDEX]) {
        return new _CashPurchaseModel2.default();
    }

    var pricingIndex = collectionCashPurchaseData[_dataConversions.COLLECTION_CASH_PURCHASE.PRICING][_dataConversions.COLLECTION_CASH_PURCHASE.INDEX];
    var pricingAmounts = pricingIndex[_dataConversions.COLLECTION_CASH_PURCHASE.AMOUNTS] ? {
        msrp: pricingIndex[_dataConversions.COLLECTION_CASH_PURCHASE.AMOUNTS][_dataConversions.COLLECTION_CASH_PURCHASE.MSRP],
        freightPDI: pricingIndex[_dataConversions.COLLECTION_CASH_PURCHASE.AMOUNTS][_dataConversions.COLLECTION_CASH_PURCHASE.FREIGHT_PDI],
        taxesAndDuties: pricingIndex[_dataConversions.COLLECTION_CASH_PURCHASE.AMOUNTS][_dataConversions.COLLECTION_CASH_PURCHASE.TAXES_AND_DUTIES]
    } : {
        msrp: pricingIndex[_dataConversions.COLLECTION_CASH_PURCHASE.RETAIL],
        freightPDI: 0,
        taxesAndDuties: 0
    };

    var rebatesDetailsData = (0, _lodash.isEmpty)(pricingIndex[_dataConversions.COLLECTION_CASH_PURCHASE.REBATES_DETAILS]) ? [] : pricingIndex[_dataConversions.COLLECTION_CASH_PURCHASE.REBATES_DETAILS];
    var rebatesDetails = getRebatesDetailsFromData(rebatesDetailsData);

    return new _CashPurchaseModel2.default({
        purchaseMethod: _purchaseMethods.CASH_PURCHASE,
        selected: selected,
        available: false,
        retail: pricingIndex[_dataConversions.COLLECTION_CASH_PURCHASE.RETAIL],
        discounts: pricingIndex[_dataConversions.COLLECTION_CASH_PURCHASE.DISCOUNTS] ? pricingIndex[_dataConversions.COLLECTION_CASH_PURCHASE.DISCOUNTS] : 0,
        rebates: pricingIndex[_dataConversions.COLLECTION_CASH_PURCHASE.REBATES],
        rebatesTaxes: pricingIndex[_dataConversions.COLLECTION_CASH_PURCHASE.REBATES_TAXES] || 0,
        rebatesAtDelivery: pricingIndex[_dataConversions.COLLECTION_CASH_PURCHASE.DISCOUNTS] ? pricingIndex[_dataConversions.COLLECTION_CASH_PURCHASE.REBATES_AT_DELIVERY] : 0,
        pricingAmounts: pricingAmounts,
        rebatesDetails: rebatesDetails
    });
}

function resetCashPurchaseFromCalculatorData(calculatorCashPurchaseData, selected) {
    if (!calculatorCashPurchaseData.vehicle) {
        return new _CashPurchaseModel2.default();
    }

    var retail = calculatorCashPurchaseData.vehicle.sellingPrice;
    var retailAdjustment = 0;
    if (!(0, _lodash.isEmpty)(calculatorCashPurchaseData.vehicle.price)) {
        var retailWithFees = calculatorCashPurchaseData.vehicle.price[_dataConversions.MODEL_CASH_PURCHASE.RETAIL];
        retailAdjustment = retailWithFees - retail;
        retail = retailWithFees;
    }

    return new _CashPurchaseModel2.default({
        purchaseMethod: _purchaseMethods.CASH_PURCHASE,
        selected: selected,
        available: false,
        retail: retail,
        retailAdjustment: retailAdjustment,
        discounts: 0,
        rebates: 0,
        rebatesTaxes: 0,
        rebatesAtDelivery: 0
    });
}

function resetCashPurchaseFromModelData(modelCashPurchaseData, selected) {
    var cashPurchaseData = modelCashPurchaseData[_dataConversions.MODEL_CASH_PURCHASE.PRICING] ? _dataConversions.MODEL_CASH_PURCHASE.PRICING : _dataConversions.VEHICLE_CASH_PURCHASE.PRICING;
    if (!modelCashPurchaseData[cashPurchaseData]) {
        return new _CashPurchaseModel2.default();
    }

    var includedItemsCodes = (0, _lodash.isEmpty)(modelCashPurchaseData[cashPurchaseData][_dataConversions.MODEL_CASH_PURCHASE.INCLUDED_CODES]) ? [] : modelCashPurchaseData[cashPurchaseData][_dataConversions.MODEL_CASH_PURCHASE.INCLUDED_CODES];
    var rebatesDetailsData = (0, _lodash.isEmpty)(modelCashPurchaseData[cashPurchaseData][_dataConversions.MODEL_CASH_PURCHASE.REBATES_DETAILS]) ? [] : modelCashPurchaseData[cashPurchaseData][_dataConversions.MODEL_CASH_PURCHASE.REBATES_DETAILS];
    var rebatesDetails = getRebatesDetailsFromData(rebatesDetailsData);

    var dealerFees = modelCashPurchaseData[cashPurchaseData][_dataConversions.MODEL_CASH_PURCHASE.DEALER_FEES] ? modelCashPurchaseData[cashPurchaseData][_dataConversions.MODEL_CASH_PURCHASE.DEALER_FEES] : 0;

    return new _CashPurchaseModel2.default({
        purchaseMethod: _purchaseMethods.CASH_PURCHASE,
        selected: selected,
        available: false,
        retail: modelCashPurchaseData[cashPurchaseData][_dataConversions.MODEL_CASH_PURCHASE.RETAIL],
        dealerFees: dealerFees,
        discounts: modelCashPurchaseData[cashPurchaseData][_dataConversions.MODEL_CASH_PURCHASE.DISCOUNTS],
        rebates: modelCashPurchaseData[cashPurchaseData][_dataConversions.MODEL_CASH_PURCHASE.REBATES],
        rebatesTaxes: modelCashPurchaseData[cashPurchaseData][_dataConversions.MODEL_CASH_PURCHASE.REBATES_TAXES] || 0,
        rebatesAtDelivery: modelCashPurchaseData[cashPurchaseData][_dataConversions.MODEL_CASH_PURCHASE.REBATES_AT_DELIVERY],
        includedItemsCodes: includedItemsCodes,
        rebatesDetails: rebatesDetails
    });
}

function resetCashPurchaseFromOriginData(dataOrigin, originCashPurchaseData, selected) {
    if (!(0, _lodash.isObjectLike)(originCashPurchaseData) || (0, _lodash.isEmpty)(originCashPurchaseData)) {
        return new _CashPurchaseModel2.default();
    }

    var updatedSelected = (0, _lodash.isBoolean)(selected) ? selected : false;

    switch (dataOrigin) {
        case DataOrigins.MODELS_COLLECTION:
            return resetCashPurchaseFromCollectionData(originCashPurchaseData, updatedSelected);

        case DataOrigins.PAYMENT_CALCULATOR:
            return resetCashPurchaseFromCalculatorData(originCashPurchaseData, updatedSelected);

        case DataOrigins.MODEL_YEAR_POWERS_TRIMS:
            return resetCashPurchaseFromModelData(originCashPurchaseData, updatedSelected);

        case DataOrigins.VEHICLE_PAYMENTS:
            return resetCashPurchaseFromModelData(originCashPurchaseData, updatedSelected);

        default:
            return new _CashPurchaseModel2.default();
    }
}

exports.default = {
    getRebatesDetailsFromData: getRebatesDetailsFromData,
    resetCashPurchaseFromCollectionData: resetCashPurchaseFromCollectionData,
    resetCashPurchaseFromCalculatorData: resetCashPurchaseFromCalculatorData,
    resetCashPurchaseFromModelData: resetCashPurchaseFromModelData,
    resetCashPurchaseFromOriginData: resetCashPurchaseFromOriginData
};

/***/ }),

/***/ "./src/PurchaseMethods/services/FinanceService/FinanceService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetFinanceFromOriginData = resetFinanceFromOriginData;

var _lodash = __webpack_require__("lodash");

var _dataOrigins = __webpack_require__("./src/constants/dataOrigins.js");

var DataOrigins = _interopRequireWildcard(_dataOrigins);

var _dataConversions = __webpack_require__("./src/PurchaseMethods/constants/dataConversions.js");

var _purchaseMethods = __webpack_require__("./src/PurchaseMethods/constants/purchaseMethods.js");

var PurchaseMethods = _interopRequireWildcard(_purchaseMethods);

var _purchaseMethodsValues = __webpack_require__("./src/PurchaseMethods/constants/purchaseMethodsValues.js");

var _purchaseMethodsValues2 = _interopRequireDefault(_purchaseMethodsValues);

var _FinanceModel = __webpack_require__("./src/PurchaseMethods/models/FinanceModel.js");

var _FinanceModel2 = _interopRequireDefault(_FinanceModel);

var _TermModel = __webpack_require__("./src/PurchaseMethods/models/TermModel.js");

var _TermModel2 = _interopRequireDefault(_TermModel);

var _TermService = __webpack_require__("./src/PurchaseMethods/services/TermService/TermService.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/* eslint import/prefer-default-export: 0 */

function getFinanceTerms(dataOrigin, termsData) {
    return (0, _lodash.map)(termsData, function (termData, index) {
        return (0, _TermService.resetTermFromOriginData)(dataOrigin, termData, index);
    });
}

function resetFinanceFromCollectionData(collectionFinanceData, purchaseMethod, selected) {
    var annualKMAllowed = 0;
    var endTermKMCost = 0;
    var financeData = void 0;

    var newPurchaseMethods = purchaseMethod;
    if (purchaseMethod === PurchaseMethods.LEASE && collectionFinanceData[_dataConversions.COLLECTION_FINANCE.LEASE]) {
        financeData = collectionFinanceData[_dataConversions.COLLECTION_FINANCE.LEASE][_dataConversions.COLLECTION_FINANCE.INDEX];
        if (financeData[_dataConversions.COLLECTION_FINANCE.LEASE_ANNUAL_KM]) {
            annualKMAllowed = financeData[_dataConversions.COLLECTION_FINANCE.LEASE_ANNUAL_KM];
        }
        if (financeData[_dataConversions.COLLECTION_FINANCE.LEASE_END_TERM_KM_COST]) {
            endTermKMCost = financeData[_dataConversions.COLLECTION_FINANCE.LEASE_END_TERM_KM_COST];
        }
    } else if (purchaseMethod === PurchaseMethods.FINANCE && collectionFinanceData[_dataConversions.COLLECTION_FINANCE.FINANCE]) {
        financeData = collectionFinanceData[_dataConversions.COLLECTION_FINANCE.FINANCE][_dataConversions.COLLECTION_FINANCE.INDEX];
    } else {
        newPurchaseMethods = PurchaseMethods.FINANCE;
    }

    var terms = [new _TermModel2.default()];
    var selectedTerm = 0;
    if (financeData) {
        terms = getFinanceTerms(DataOrigins.MODELS_COLLECTION, financeData[_dataConversions.COLLECTION_FINANCE.TERMS]);
        selectedTerm = financeData[_dataConversions.COLLECTION_FINANCE.BEST_TERM_WITH_CASH];
    }

    var purchaseMethodValue = newPurchaseMethods === PurchaseMethods.LEASE ? _purchaseMethodsValues2.default.LEASE : _purchaseMethodsValues2.default.FINANCE;

    return new _FinanceModel2.default({
        purchaseMethod: newPurchaseMethods,
        purchaseMethodValue: purchaseMethodValue,
        annualKMAllowed: annualKMAllowed,
        endTermKMCost: endTermKMCost,
        selected: selected && selectedTerm > 0,
        available: false,
        terms: terms,
        selectedTerm: selectedTerm
    });
}

function resetFinanceFromCalculatorData(calculatorFinanceData, purchaseMethod, selected) {
    var terms = [new _TermModel2.default()];
    var selectedTerm = 0;

    if (!calculatorFinanceData[_dataConversions.CALCULATOR_FINANCE.VEHICLE]) {
        return new _FinanceModel2.default({
            purchaseMethod: PurchaseMethods.FINANCE,
            purchaseMethodValue: _purchaseMethodsValues2.default.FINANCE,
            annualKMAllowed: 0,
            endTermKMCost: 0,
            selected: false,
            available: false,
            terms: terms,
            selectedTerm: selectedTerm
        });
    }

    var financeData = void 0;
    var newPurchaseMethods = purchaseMethod;
    if (purchaseMethod === PurchaseMethods.LEASE && calculatorFinanceData[_dataConversions.CALCULATOR_FINANCE.VEHICLE][_dataConversions.CALCULATOR_FINANCE.LEASE]) {
        financeData = calculatorFinanceData[_dataConversions.CALCULATOR_FINANCE.VEHICLE][_dataConversions.CALCULATOR_FINANCE.LEASE];
    } else if (purchaseMethod === PurchaseMethods.FINANCE && calculatorFinanceData[_dataConversions.CALCULATOR_FINANCE.VEHICLE][_dataConversions.CALCULATOR_FINANCE.FINANCE]) {
        financeData = calculatorFinanceData[_dataConversions.CALCULATOR_FINANCE.VEHICLE][_dataConversions.CALCULATOR_FINANCE.FINANCE];
    } else {
        newPurchaseMethods = PurchaseMethods.FINANCE;
    }

    if (financeData) {
        terms = getFinanceTerms(DataOrigins.PAYMENT_CALCULATOR, financeData);
        selectedTerm = terms.length > 0 ? terms[terms.length - 1].term : 0;
    }

    var purchaseMethodValue = newPurchaseMethods === PurchaseMethods.LEASE ? _purchaseMethodsValues2.default.LEASE : _purchaseMethodsValues2.default.FINANCE;

    return new _FinanceModel2.default({
        purchaseMethod: newPurchaseMethods,
        purchaseMethodValue: purchaseMethodValue,
        annualKMAllowed: 0,
        endTermKMCost: 0,
        selected: selected && selectedTerm > 0,
        available: false,
        terms: terms,
        selectedTerm: selectedTerm
    });
}

function resetFinanceFromModelData(modelFinanceData, purchaseMethod, selected) {
    var financeKMData = void 0;

    var financeDataLease = modelFinanceData[_dataConversions.MODEL_FINANCE.LEASE] ? _dataConversions.MODEL_FINANCE.LEASE : _dataConversions.VEHICLE_FINANCE.LEASE;
    var financeDataFinance = modelFinanceData[_dataConversions.MODEL_FINANCE.FINANCE] ? _dataConversions.MODEL_FINANCE.FINANCE : _dataConversions.VEHICLE_FINANCE.FINANCE;
    var newPurchaseMethods = purchaseMethod;
    if (purchaseMethod === PurchaseMethods.LEASE && modelFinanceData[financeDataLease]) {
        financeKMData = modelFinanceData[financeDataLease];
    } else if (purchaseMethod === PurchaseMethods.FINANCE && modelFinanceData[financeDataFinance]) {
        financeKMData = modelFinanceData[financeDataFinance];
    } else {
        newPurchaseMethods = PurchaseMethods.FINANCE;
    }

    var annualKMAllowed = 0;
    var endTermKMCost = 0;
    var financeData = void 0;
    if (financeKMData) {
        financeData = financeKMData[_dataConversions.MODEL_FINANCE.INDEX];
        if (financeData[_dataConversions.MODEL_FINANCE.LEASE_ANNUAL_KM]) {
            annualKMAllowed = financeData[_dataConversions.MODEL_FINANCE.LEASE_ANNUAL_KM];
        }
        if (financeData[_dataConversions.MODEL_FINANCE.LEASE_END_TERM_KM_COST]) {
            endTermKMCost = financeData[_dataConversions.MODEL_FINANCE.LEASE_END_TERM_KM_COST];
        }
    }

    var terms = [new _TermModel2.default()];
    var selectedTerm = 0;
    var kmPlans = [];
    if (financeData) {
        terms = getFinanceTerms(DataOrigins.MODEL_YEAR_POWERS_TRIMS, financeData[_dataConversions.MODEL_FINANCE.TERMS]);
        selectedTerm = terms.length > 0 ? terms[terms.length - 1].term : 0;

        if (financeKMData.length > 1) {
            (0, _lodash.forEach)(financeKMData, function (financeKM) {
                kmPlans.push({
                    annualKMAllowed: financeKM[_dataConversions.MODEL_FINANCE.LEASE_ANNUAL_KM] ? financeKM[_dataConversions.MODEL_FINANCE.LEASE_ANNUAL_KM] : 0,
                    endTermKMCost: financeKM[_dataConversions.MODEL_FINANCE.LEASE_END_TERM_KM_COST] ? financeKM[_dataConversions.MODEL_FINANCE.LEASE_END_TERM_KM_COST] : 0,
                    terms: getFinanceTerms(DataOrigins.MODEL_YEAR_POWERS_TRIMS, financeKM[_dataConversions.MODEL_FINANCE.TERMS])
                });
            });
        }
    }

    var purchaseMethodValue = newPurchaseMethods === PurchaseMethods.LEASE ? _purchaseMethodsValues2.default.LEASE : _purchaseMethodsValues2.default.FINANCE;

    return new _FinanceModel2.default({
        purchaseMethod: newPurchaseMethods,
        purchaseMethodValue: purchaseMethodValue,
        annualKMAllowed: annualKMAllowed,
        endTermKMCost: endTermKMCost,
        selected: selected && selectedTerm > 0,
        available: false,
        terms: terms,
        selectedTerm: selectedTerm,
        kmPlans: kmPlans
    });
}

function resetFinanceFromOriginData(dataOrigin, originFinanceData, purchaseMethod, selected) {
    if ((0, _lodash.isEmpty)(originFinanceData) || !(0, _lodash.isObjectLike)(originFinanceData)) {
        return new _FinanceModel2.default();
    }

    var updatedSelected = (0, _lodash.isBoolean)(selected) ? selected : false;

    switch (dataOrigin) {
        case DataOrigins.MODELS_COLLECTION:
            return resetFinanceFromCollectionData(originFinanceData, purchaseMethod, updatedSelected);

        case DataOrigins.PAYMENT_CALCULATOR:
            return resetFinanceFromCalculatorData(originFinanceData, purchaseMethod, updatedSelected);

        case DataOrigins.MODEL_YEAR_POWERS_TRIMS:
            return resetFinanceFromModelData(originFinanceData, purchaseMethod, updatedSelected);

        case DataOrigins.VEHICLE_PAYMENTS:
            return resetFinanceFromModelData(originFinanceData, purchaseMethod, updatedSelected);

        default:
            return new _FinanceModel2.default();
    }
}

exports.default = {
    getFinanceTerms: getFinanceTerms,
    resetFinanceFromCollectionData: resetFinanceFromCollectionData,
    resetFinanceFromCalculatorData: resetFinanceFromCalculatorData,
    resetFinanceFromModelData: resetFinanceFromModelData,
    resetFinanceFromOriginData: resetFinanceFromOriginData
};

/***/ }),

/***/ "./src/PurchaseMethods/services/PaymentFrequencyService/PaymentFrequencyService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetPaymentFrequencyFromCollectionData = resetPaymentFrequencyFromCollectionData;
exports.resetPaymentFrequencyFromCalculatorData = resetPaymentFrequencyFromCalculatorData;
exports.resetPaymentFrequencyFromModelData = resetPaymentFrequencyFromModelData;
exports.getPaymentFrequencyDropDownValues = getPaymentFrequencyDropDownValues;

var _lodash = __webpack_require__("lodash");

var _dataConversions = __webpack_require__("./src/PurchaseMethods/constants/dataConversions.js");

var _PaymentFrequencyModel = __webpack_require__("./src/PurchaseMethods/models/PaymentFrequencyModel.js");

var _PaymentFrequencyModel2 = _interopRequireDefault(_PaymentFrequencyModel);

var _paymentFrequencies = __webpack_require__("./src/PurchaseMethods/constants/paymentFrequencies.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function resetPaymentFrequencyFromCollectionData(collectionPaymentFrequencyData, cashDown) {
    if ((0, _lodash.isEmpty)(collectionPaymentFrequencyData) || !(0, _lodash.isObjectLike)(collectionPaymentFrequencyData) || collectionPaymentFrequencyData.length <= _dataConversions.COLLECTION_FREQUENCY.BALLOON_FACTOR) {
        return new _PaymentFrequencyModel2.default();
    }

    var updatedCashDown = (0, _lodash.isFinite)(cashDown) ? cashDown : 0;
    var payment = collectionPaymentFrequencyData[_dataConversions.COLLECTION_FREQUENCY.BASE_PAYMENT] + collectionPaymentFrequencyData[_dataConversions.COLLECTION_FREQUENCY.FEES_PAYMENT] + collectionPaymentFrequencyData[_dataConversions.COLLECTION_FREQUENCY.DUTIES_PAYMENT];
    var cashDownAdjustment = collectionPaymentFrequencyData[_dataConversions.COLLECTION_FREQUENCY.FINANCE_FACTOR] * updatedCashDown;

    var disclaimers = collectionPaymentFrequencyData[_dataConversions.COLLECTION_FREQUENCY.DISCLAIMERS] ? collectionPaymentFrequencyData[_dataConversions.COLLECTION_FREQUENCY.DISCLAIMERS] : [];

    return new _PaymentFrequencyModel2.default({
        paymentFrequency: collectionPaymentFrequencyData[_dataConversions.COLLECTION_FREQUENCY.PAYMENT_FREQUENCY],
        payment: payment,
        paymentTaxes: collectionPaymentFrequencyData[_dataConversions.COLLECTION_FREQUENCY.PAYMENT_TAXES],
        financeFactor: collectionPaymentFrequencyData[_dataConversions.COLLECTION_FREQUENCY.FINANCE_FACTOR],
        balloonFactor: collectionPaymentFrequencyData[_dataConversions.COLLECTION_FREQUENCY.BALLOON_FACTOR],
        cashDownPaymentAdjustment: cashDownAdjustment,
        netTradeInPaymentAdjustment: 0,
        netTradeInPaymentTaxesAdjustment: 0,
        calculatedNetPayment: payment,
        calculatedPayment: payment - cashDownAdjustment,
        disclaimers: disclaimers
    });
}

function resetPaymentFrequencyFromCalculatorData(calculatorPaymentFrequencyData, cashDown) {
    if ((0, _lodash.isEmpty)(calculatorPaymentFrequencyData) || !(0, _lodash.isObjectLike)(calculatorPaymentFrequencyData)) {
        return new _PaymentFrequencyModel2.default();
    }

    var frequencyCashDown = calculatorPaymentFrequencyData[_dataConversions.CALCULATOR_FREQUENCY.CASH_DOWN];
    var updatedCashDown = (0, _lodash.isFinite)(cashDown) ? cashDown : 0;
    var payment = calculatorPaymentFrequencyData[_dataConversions.CALCULATOR_FREQUENCY.PAYMENT] + calculatorPaymentFrequencyData[_dataConversions.CALCULATOR_FREQUENCY.FINANCE_FACTOR] * frequencyCashDown;

    var cashDownAdjustment = calculatorPaymentFrequencyData[_dataConversions.CALCULATOR_FREQUENCY.FINANCE_FACTOR] * updatedCashDown;

    var disclaimers = [];
    if (calculatorPaymentFrequencyData[_dataConversions.CALCULATOR_FREQUENCY.DISCLAIMER]) {
        disclaimers.push(calculatorPaymentFrequencyData[_dataConversions.CALCULATOR_FREQUENCY.DISCLAIMER]);
    }

    return new _PaymentFrequencyModel2.default({
        paymentFrequency: calculatorPaymentFrequencyData[_dataConversions.CALCULATOR_FREQUENCY.PAYMENT_FREQUENCY],
        payment: payment,
        paymentTaxes: calculatorPaymentFrequencyData[_dataConversions.CALCULATOR_FREQUENCY.PAYMENT_TAXES],
        financeFactor: calculatorPaymentFrequencyData[_dataConversions.CALCULATOR_FREQUENCY.FINANCE_FACTOR],
        balloonFactor: calculatorPaymentFrequencyData[_dataConversions.CALCULATOR_FREQUENCY.BALLOON_FACTOR],
        cashDownPaymentAdjustment: cashDownAdjustment,
        netTradeInPaymentAdjustment: 0,
        netTradeInPaymentTaxesAdjustment: 0,
        calculatedNetPayment: payment,
        calculatedPayment: payment - cashDownAdjustment,
        disclaimers: disclaimers
    });
}

function resetPaymentFrequencyFromModelData(modelPaymentFrequencyData, cashDown) {
    if ((0, _lodash.isEmpty)(modelPaymentFrequencyData) || !(0, _lodash.isObjectLike)(modelPaymentFrequencyData) || modelPaymentFrequencyData.length <= _dataConversions.MODEL_FREQUENCY.BALLOON_FACTOR) {
        return new _PaymentFrequencyModel2.default();
    }

    var updatedCashDown = (0, _lodash.isFinite)(cashDown) ? cashDown : 0;
    var payment = modelPaymentFrequencyData[_dataConversions.MODEL_FREQUENCY.PAYMENT];
    var cashDownAdjustment = modelPaymentFrequencyData[_dataConversions.MODEL_FREQUENCY.FINANCE_FACTOR] * updatedCashDown;

    return new _PaymentFrequencyModel2.default({
        paymentFrequency: modelPaymentFrequencyData[_dataConversions.MODEL_FREQUENCY.PAYMENT_FREQUENCY],
        payment: payment,
        paymentTaxes: modelPaymentFrequencyData[_dataConversions.MODEL_FREQUENCY.PAYMENT_TAXES],
        financeFactor: modelPaymentFrequencyData[_dataConversions.MODEL_FREQUENCY.FINANCE_FACTOR],
        balloonFactor: modelPaymentFrequencyData[_dataConversions.MODEL_FREQUENCY.BALLOON_FACTOR],
        cashDownPaymentAdjustment: cashDownAdjustment,
        netTradeInPaymentAdjustment: 0,
        netTradeInPaymentTaxesAdjustment: 0,
        calculatedNetPayment: payment,
        calculatedPayment: payment - cashDownAdjustment
    });
}

// I18n argument is the LocalService class to translate
function getPaymentFrequencyDropDownValues(I18n, purchaseMethods) {
    var paymentFrequencyDropDownValues = [{ value: _paymentFrequencies.WEEKLY, label: I18n.t('paymentFrequencies.weekly') }, { value: _paymentFrequencies.BI_WEEKLY, label: I18n.t('paymentFrequencies.biWeekly') }, { value: _paymentFrequencies.SEMI_MONTHLY, label: I18n.t('paymentFrequencies.semiMonthly') }, { value: _paymentFrequencies.MONTHLY, label: I18n.t('paymentFrequencies.monthly') }];

    if (purchaseMethods) {
        var availablePaymentFrequencies = purchaseMethods.getFinancesAvailablePaymentFrequencies();
        paymentFrequencyDropDownValues = (0, _lodash.filter)(paymentFrequencyDropDownValues, function (paymentFrequencyDropDownValue) {
            return (0, _lodash.includes)(availablePaymentFrequencies, paymentFrequencyDropDownValue.value);
        });
    }

    return paymentFrequencyDropDownValues;
}

exports.default = {
    resetPaymentFrequencyFromCollectionData: resetPaymentFrequencyFromCollectionData,
    resetPaymentFrequencyFromCalculatorData: resetPaymentFrequencyFromCalculatorData,
    resetPaymentFrequencyFromModelData: resetPaymentFrequencyFromModelData,
    getPaymentFrequencyDropDownValues: getPaymentFrequencyDropDownValues
};

/***/ }),

/***/ "./src/PurchaseMethods/services/PurchaseMethodsAPIService/DisclaimerAPIService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DisclaimerAPIService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _axios = __webpack_require__("../../node_modules/axios/index.js");

var _axios2 = _interopRequireDefault(_axios);

var _index = __webpack_require__("./src/config/index.js");

var _index2 = _interopRequireDefault(_index);

var _immutable = __webpack_require__("immutable");

var _lodash = __webpack_require__("lodash");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _ShowroomAPIService = __webpack_require__("./src/services/ShowroomService/ShowroomAPIService.js");

var _ShowroomAPIService2 = _interopRequireDefault(_ShowroomAPIService);

var _disclaimers = __webpack_require__("./src/PurchaseMethods/constants/disclaimers.js");

var _disclaimers2 = _interopRequireDefault(_disclaimers);

var _purchaseMethodsValues = __webpack_require__("./src/PurchaseMethods/constants/purchaseMethodsValues.js");

var _purchaseMethodsValues2 = _interopRequireDefault(_purchaseMethodsValues);

var _vehicle = __webpack_require__("./src/constants/vehicle.js");

var _vehicle2 = _interopRequireDefault(_vehicle);

var _VehicleModel = __webpack_require__("./src/Vehicle/models/VehicleModel.js");

var _VehicleModel2 = _interopRequireDefault(_VehicleModel);

var _ModelYearModel = __webpack_require__("./src/ModelYear/models/ModelYearModel.js");

var _ModelYearModel2 = _interopRequireDefault(_ModelYearModel);

var _DisclaimersModel = __webpack_require__("./src/PurchaseMethods/models/DisclaimersModel.js");

var _DisclaimersModel2 = _interopRequireDefault(_DisclaimersModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Util to create a request configuration object to load Generic Disclaimers for a given context
 * @param {String} publicToken
 */
function getGenericDisclaimersRequestConfig(publicToken) {
    var orgId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
    var orgUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
    var location = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitLocation();
    var language = _widgetCommonsCoreServices.LocaleService.getLocale();

    var requestConfig = {
        url: _index2.default.endpoint.showroom + '/service/v1/genericDisclaimers',
        method: 'get'
    };

    requestConfig.headers = {
        'x-jwt': (0, _lodash.isString)(publicToken) ? publicToken : ''
    };

    requestConfig.params = {
        context: ((0, _lodash.isNull)(orgId) ? '' : orgId) + '.' + ((0, _lodash.isNull)(orgUnitId) ? '' : orgUnitId),
        location: (0, _lodash.isEmpty)(location) ? '' : location,
        language: language
    };

    return requestConfig;
}

/**
 * Util to create a request configuration data and vehicle match object
 * @param {Object[]} vehicles
 */
function getVehiclesDisclaimersDataRequestConfig(vehicles) {
    var vehiclesAndRequestData = (0, _lodash.map)(vehicles, function (vehicle, index) {
        var year = vehicle.year,
            make = vehicle.make,
            model = vehicle.model,
            vehicleConditionType = vehicle.vehicleConditionType,
            modelTrimCode = vehicle.modelTrimCode,
            configurationID = vehicle.configurationID,
            configurationToken = vehicle.configurationToken,
            vehicleId = vehicle.vehicleId,
            odometer = vehicle.odometer,
            sellingPrice = vehicle.sellingPrice,
            purchaseMethods = vehicle.purchaseMethods;
        var tradeIn = purchaseMethods.tradeIn,
            lien = purchaseMethods.lien;


        var disclaimers = purchaseMethods.getDisclaimerParameters();

        var disclaimerData = void 0;
        if (vehicle.getIsVehicleNew()) {
            disclaimerData = {
                cookie: index.toString(),
                year: year,
                make: make,
                modelTrimCode: modelTrimCode,
                configurationID: configurationID,
                configurationToken: configurationToken,
                vehicleCondition: vehicleConditionType,
                vehicleId: vehicleId,
                tradeIn: tradeIn,
                lien: lien,
                disclaimers: disclaimers
            };
        } else {
            disclaimerData = {
                cookie: index.toString(),
                year: year,
                make: make,
                model: model,
                vehicleCondition: vehicleConditionType,
                vehicleId: vehicleId,
                odometer: odometer,
                retail: sellingPrice,
                tradeIn: tradeIn,
                lien: lien,
                disclaimers: disclaimers
            };
        }

        return {
            cookie: index.toString(),
            disclaimerData: disclaimerData,
            vehicle: vehicle
        };
    });

    return vehiclesAndRequestData;
}

/**
 * Util to create a request configuration data and options package match object
 * @param {Object} modelYear
 * @param {Object} optionsPackage
 */
function getOptionsPackageDisclaimersDataRequestConfig(modelYear, optionsPackage) {
    var year = modelYear.year,
        make = modelYear.make;
    var _optionsPackage$confi = optionsPackage.configuration,
        modelTrimCode = _optionsPackage$confi.modelTrimCode,
        id = _optionsPackage$confi.id,
        configurationToken = _optionsPackage$confi.configurationToken,
        purchaseMethods = _optionsPackage$confi.purchaseMethods;


    var cookie = year + '-' + make + '-' + modelTrimCode + '-' + id;

    var tradeIn = purchaseMethods.tradeIn,
        lien = purchaseMethods.lien;


    var disclaimers = purchaseMethods.getDisclaimerParameters();

    var disclaimerData = {
        cookie: cookie,
        year: year,
        make: make,
        modelTrimCode: modelTrimCode,
        configurationID: id,
        configurationToken: configurationToken,
        vehicleCondition: _vehicle2.default.CONDITIONS.NEW,
        tradeIn: tradeIn,
        lien: lien,
        disclaimers: disclaimers
    };

    return [{
        cookie: cookie,
        disclaimerData: disclaimerData,
        modelYear: modelYear,
        optionsPackage: optionsPackage
    }];
}

/**
 * Util to create a request configuration data and model match object
 * @param {Object} model
 */
function getModelsDisclaimersDataRequestConfig(models) {
    var modelsAndRequestData = (0, _lodash.map)(models, function (model) {
        var priceYear = model.priceYear,
            leaseYear = model.leaseYear,
            financeYear = model.financeYear,
            make = model.make,
            bodyStyleCode = model.bodyStyleCode,
            priceModelTrimCode = model.priceModelTrimCode,
            leaseModelTrimCode = model.leaseModelTrimCode,
            financeModelTrimCode = model.financeModelTrimCode,
            priceConfigurationId = model.priceConfigurationId,
            leaseConfigurationId = model.leaseConfigurationId,
            financeConfigurationId = model.financeConfigurationId,
            purchaseMethods = model.purchaseMethods;

        if (!purchaseMethods) {
            return [];
        }

        var cookie = make + '-' + model.model + '-' + bodyStyleCode;

        var tradeIn = purchaseMethods.tradeIn,
            lien = purchaseMethods.lien;


        var disclaimers = purchaseMethods.getDisclaimerParameters();

        var priceDisclaimerData = {
            cookie: cookie + '-price',
            year: priceYear,
            make: make,
            modelTrimCode: priceModelTrimCode,
            configurationID: priceConfigurationId,
            vehicleCondition: _vehicle2.default.CONDITIONS.NEW,
            tradeIn: tradeIn,
            lien: lien,
            disclaimers: disclaimers
        };

        var leaseDisclaimerData = {
            cookie: cookie + '-lease',
            year: leaseYear,
            make: make,
            modelTrimCode: leaseModelTrimCode,
            configurationID: leaseConfigurationId,
            vehicleCondition: _vehicle2.default.CONDITIONS.NEW,
            tradeIn: tradeIn,
            lien: lien,
            disclaimers: disclaimers
        };

        var financeDisclaimerData = {
            cookie: cookie + '-finance',
            year: financeYear,
            make: make,
            modelTrimCode: financeModelTrimCode,
            configurationID: financeConfigurationId,
            vehicleCondition: _vehicle2.default.CONDITIONS.NEW,
            tradeIn: tradeIn,
            lien: lien,
            disclaimers: disclaimers
        };

        var CASH = _purchaseMethodsValues2.default.CASH,
            FINANCE = _purchaseMethodsValues2.default.FINANCE,
            LEASE = _purchaseMethodsValues2.default.LEASE;

        return [{
            cookie: cookie + '-price',
            disclaimerData: priceDisclaimerData,
            model: model,
            purchaseMethod: CASH,
            purchaseMethods: purchaseMethods
        }, {
            cookie: cookie + '-lease',
            disclaimerData: leaseDisclaimerData,
            model: model,
            purchaseMethod: LEASE,
            purchaseMethods: purchaseMethods
        }, {
            cookie: cookie + '-finance',
            disclaimerData: financeDisclaimerData,
            model: model,
            purchaseMethod: FINANCE,
            purchaseMethods: purchaseMethods
        }];
    });

    return (0, _lodash.flatten)(modelsAndRequestData);
}

/**
 * Util to create a request configuration object to load Disclaimers for given data requests
 * @param {String} publicToken
 * @param {Object[]} requestsData
 */
function getDisclaimersRequestConfig(publicToken, requestsData) {
    var orgId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
    var orgUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
    var location = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitLocation();
    var language = _widgetCommonsCoreServices.LocaleService.getLocale();

    var requestConfig = {
        url: _index2.default.endpoint.showroom + '/service/v1/disclaimers',
        method: 'post'
    };

    requestConfig.headers = {
        'x-jwt': (0, _lodash.isString)(publicToken) ? publicToken : ''
    };

    requestConfig.params = {
        context: ((0, _lodash.isNull)(orgId) ? '' : orgId) + '.' + ((0, _lodash.isNull)(orgUnitId) ? '' : orgUnitId),
        location: (0, _lodash.isEmpty)(location) ? '' : location,
        language: language
    };

    requestConfig.data = (0, _lodash.map)(requestsData, function (vehicle) {
        return vehicle.disclaimerData;
    });

    return requestConfig;
}

/**
 * Util to create a term frequency disclaimers sentences object
 * @param {Object} paymentFrequency
 * @param {Object} disclaimersIds
 */
function createTermFrequencyDisclaimersSentences(paymentFrequency, disclaimersIds) {
    var sentences = {
        paymentFrequency: 0,
        paymentAndCash: '',
        obligationAndInterest: ''
    };
    if ((0, _lodash.isEmpty)(paymentFrequency) || (0, _lodash.isEmpty)(paymentFrequency.disclaimers)) {
        return sentences;
    }
    sentences.paymentFrequency = paymentFrequency.frequency;

    var PAYMENT_CASH_DOWN = disclaimersIds.PAYMENT_CASH_DOWN,
        TOTAL_OBLIGATION = disclaimersIds.TOTAL_OBLIGATION,
        COST_OF_CREDIT = disclaimersIds.COST_OF_CREDIT,
        CREDIT_RATE = disclaimersIds.CREDIT_RATE;


    var paymentAndCash = (0, _lodash.find)(paymentFrequency.disclaimers, function (disclaimer) {
        return disclaimer.id === PAYMENT_CASH_DOWN;
    });
    sentences.paymentAndCash = paymentAndCash ? paymentAndCash.disclaimer : '';

    var totalObligation = (0, _lodash.find)(paymentFrequency.disclaimers, function (disclaimer) {
        return disclaimer.id === TOTAL_OBLIGATION;
    });
    var costOfCredit = (0, _lodash.find)(paymentFrequency.disclaimers, function (disclaimer) {
        return disclaimer.id === COST_OF_CREDIT;
    });
    var creditRate = (0, _lodash.find)(paymentFrequency.disclaimers, function (disclaimer) {
        return disclaimer.id === CREDIT_RATE;
    });
    sentences.obligationAndInterest = (totalObligation ? totalObligation.disclaimer : '') + ' ' + ((costOfCredit ? costOfCredit.disclaimer : '') + ' ' + (creditRate ? creditRate.disclaimer : ''));

    return sentences;
}

/**
 * Util to create a term disclaimers sentences object
 * @param {Object} term
 * @param {String} priceExclusions
 * @param {Object} disclaimersIds
 */
function createTermDisclaimersSentences(term, priceExclusions, disclaimersIds) {
    var sentences = {
        term: 0,
        sellingPrice: '',
        priceInclusions: '',
        priceExclusions: priceExclusions,
        termAndApr: '',
        frequencies: []
    };
    if ((0, _lodash.isEmpty)(term) || (0, _lodash.isEmpty)(term.disclaimers)) {
        return sentences;
    }
    sentences.term = term.term;

    var SELLING_PRICE = disclaimersIds.SELLING_PRICE,
        INCLUDED_REBATES = disclaimersIds.INCLUDED_REBATES,
        INCLUDED_FEES = disclaimersIds.INCLUDED_FEES,
        EXCLUDED_FEES = disclaimersIds.EXCLUDED_FEES,
        TERM_APR = disclaimersIds.TERM_APR;


    var sellingPrice = (0, _lodash.find)(term.disclaimers, function (disclaimer) {
        return disclaimer.id === SELLING_PRICE;
    });
    sentences.sellingPrice = sellingPrice ? sellingPrice.disclaimer : '';

    var rebateInclusions = (0, _lodash.find)(term.disclaimers, function (disclaimer) {
        return disclaimer.id === INCLUDED_REBATES;
    });
    var feeInclusions = (0, _lodash.find)(term.disclaimers, function (disclaimer) {
        return disclaimer.id === INCLUDED_FEES;
    });
    var rebateInclusionsSentence = rebateInclusions ? rebateInclusions.disclaimer : '';
    var feeInclusionsSentence = feeInclusions ? feeInclusions.disclaimer : '';
    sentences.priceInclusions = rebateInclusionsSentence + ' ' + feeInclusionsSentence;

    var feeExclusions = (0, _lodash.find)(term.disclaimers, function (disclaimer) {
        return disclaimer.id === EXCLUDED_FEES;
    });
    sentences.priceExclusions = (feeExclusions ? feeExclusions.disclaimer : '') + ' ' + priceExclusions;

    var termAndApr = (0, _lodash.find)(term.disclaimers, function (disclaimer) {
        return disclaimer.id === TERM_APR;
    });
    sentences.termAndApr = termAndApr ? termAndApr.disclaimer : '';

    sentences.frequencies = (0, _lodash.map)(term.paymentFrequencies, function (paymentFrequency) {
        return createTermFrequencyDisclaimersSentences(paymentFrequency, _disclaimers2.default.FINANCE.PAYMENT_FREQUENCY);
    });

    return sentences;
}

/**
 * Util to create a finance plan disclaimers sentences object
 * @param {Object} finance
 * @param {String} priceExclusions
 * @param {Object} disclaimersIds
 */
function createFinanceDisclaimersSentences(finance, priceExclusions, disclaimersIds) {
    var sentences = {
        vehicleDescription: '',
        terms: [],
        creditApproval: _widgetCommonsCoreServices.LocaleService.t('DISCLAIMERS_DEFAULT_VALUES.CREDIT_APPROVAL')
    };
    if ((0, _lodash.isEmpty)(finance)) {
        return sentences;
    }

    var VEHICLE_DESCRIPTION = disclaimersIds.VEHICLE_DESCRIPTION,
        TERM = disclaimersIds.TERM,
        KM_PLAN = disclaimersIds.KM_PLAN,
        CASH_DOWN_TAX_EXCLUDED = disclaimersIds.CASH_DOWN_TAX_EXCLUDED,
        CREDIT_APPROVAL = disclaimersIds.CREDIT_APPROVAL;


    var vehicleDescription = (0, _lodash.find)(finance.disclaimers, function (disclaimer) {
        return disclaimer.id === VEHICLE_DESCRIPTION;
    });
    sentences.vehicleDescription = vehicleDescription ? vehicleDescription.disclaimer : '';

    sentences.terms = (0, _lodash.map)(finance.terms, function (term) {
        return createTermDisclaimersSentences(term, priceExclusions, TERM);
    });

    var kmPlan = (0, _lodash.find)(finance.disclaimers, function (disclaimer) {
        return disclaimer.id === KM_PLAN;
    });
    var cashDownTaxExcluded = (0, _lodash.find)(finance.disclaimers, function (disclaimer) {
        return disclaimer.id === CASH_DOWN_TAX_EXCLUDED;
    });
    var creditApproval = (0, _lodash.find)(finance.disclaimers, function (disclaimer) {
        return disclaimer.id === CREDIT_APPROVAL;
    });
    sentences.creditApproval = (kmPlan ? kmPlan.disclaimer : '') + ' ' + ((creditApproval ? creditApproval.disclaimer : '') + ' ') + ('' + (cashDownTaxExcluded ? cashDownTaxExcluded.disclaimer : ''));

    return sentences;
}

/**
 * Util to create a cash purchase disclaimers sentences object
 * @param {Object} cashPurchase
 * @param {String} priceExclusions
 * @param {Object} disclaimersIds
 */
function createCashPurchaseDisclaimersSentences(cashPurchase, priceExclusions, disclaimersIds) {
    var sentences = {
        vehicleDescription: '',
        sellingPrice: '',
        priceInclusions: '',
        priceExclusions: priceExclusions
    };
    if ((0, _lodash.isEmpty)(cashPurchase)) {
        return sentences;
    }

    var VEHICLE_DESCRIPTION = disclaimersIds.VEHICLE_DESCRIPTION,
        SELLING_PRICE = disclaimersIds.SELLING_PRICE,
        INCLUDED_REBATES = disclaimersIds.INCLUDED_REBATES,
        INCLUDED_FEES = disclaimersIds.INCLUDED_FEES,
        EXCLUDED_FEES = disclaimersIds.EXCLUDED_FEES;


    var vehicleDescription = (0, _lodash.find)(cashPurchase.disclaimers, function (disclaimer) {
        return disclaimer.id === VEHICLE_DESCRIPTION;
    });
    sentences.vehicleDescription = vehicleDescription ? vehicleDescription.disclaimer : '';

    var sellingPrice = (0, _lodash.find)(cashPurchase.disclaimers, function (disclaimer) {
        return disclaimer.id === SELLING_PRICE;
    });
    sentences.sellingPrice = sellingPrice ? sellingPrice.disclaimer : '';

    var rebateInclusions = (0, _lodash.find)(cashPurchase.disclaimers, function (disclaimer) {
        return disclaimer.id === INCLUDED_REBATES;
    });
    var feeInclusions = (0, _lodash.find)(cashPurchase.disclaimers, function (disclaimer) {
        return disclaimer.id === INCLUDED_FEES;
    });
    var rebateInclusionsSentence = rebateInclusions ? rebateInclusions.disclaimer : '';
    var feeInclusionsSentence = feeInclusions ? feeInclusions.disclaimer : '';
    sentences.priceInclusions = rebateInclusionsSentence + ' ' + feeInclusionsSentence;

    var feeExclusions = (0, _lodash.find)(cashPurchase.disclaimers, function (disclaimer) {
        return disclaimer.id === EXCLUDED_FEES;
    });
    sentences.priceExclusions = (feeExclusions ? feeExclusions.disclaimer : '') + ' ' + priceExclusions;

    return sentences;
}

/**
 * Util to create a purchase methods disclaimers sentences object
 * @param {Object} dataDisclaimers
 * @param {String} priceExclusions
 */
function createDisclaimersSentences(vehicleDisclaimers, priceExclusions) {
    if ((0, _lodash.isEmpty)(vehicleDisclaimers)) {
        return null;
    }

    var CASH = _purchaseMethodsValues2.default.CASH,
        FINANCE = _purchaseMethodsValues2.default.FINANCE,
        LEASE = _purchaseMethodsValues2.default.LEASE;


    var cashPurchase = (0, _lodash.find)(vehicleDisclaimers.purchaseMethods, function (purchaseMethod) {
        return purchaseMethod.purchaseMethod === CASH;
    });

    var finance = (0, _lodash.find)(vehicleDisclaimers.purchaseMethods, function (purchaseMethod) {
        return purchaseMethod.purchaseMethod === FINANCE;
    });

    var lease = (0, _lodash.find)(vehicleDisclaimers.purchaseMethods, function (purchaseMethod) {
        return purchaseMethod.purchaseMethod === LEASE;
    });

    return {
        cookie: vehicleDisclaimers.cookie,
        cashPurchase: createCashPurchaseDisclaimersSentences(cashPurchase, priceExclusions, _disclaimers2.default.CASH),
        finance: createFinanceDisclaimersSentences(finance, priceExclusions, _disclaimers2.default.FINANCE),
        lease: createFinanceDisclaimersSentences(lease, priceExclusions, _disclaimers2.default.LEASE)
    };
}

/**
 * Util to get the term and frequency finance disclaimers sentences object
 * @param {Object} finance
 * @param {Object} financeDisclaimers
 */
function getFinanceSentences(finance, financeDisclaimers) {
    var financeSentences = {
        vehicleDescription: '',
        sellingPrice: '',
        priceInclusions: '',
        priceExclusions: '',
        termAndApr: '',
        paymentAndCash: '',
        obligationAndInterest: '',
        creditApproval: ''
    };

    var financeTerm = finance.getSelectedTerm();
    var financeFrequency = finance.getSelectedTermFrequency();
    if (!financeTerm || !financeTerm.term || !financeFrequency || !financeFrequency.paymentFrequency) {
        return financeSentences;
    }

    var financeTermDisclaimers = (0, _lodash.find)(financeDisclaimers.terms, function (term) {
        return term.term === financeTerm.term;
    });
    if (!financeTermDisclaimers) {
        return financeSentences;
    }

    var financeFrequencyDisclaimers = (0, _lodash.find)(financeTermDisclaimers.frequencies, function (frequency) {
        return frequency.paymentFrequency === financeFrequency.paymentFrequency;
    });
    if (!financeFrequencyDisclaimers) {
        return financeSentences;
    }

    financeSentences = {
        vehicleDescription: financeDisclaimers.vehicleDescription,
        sellingPrice: financeTermDisclaimers.sellingPrice,
        priceInclusions: financeTermDisclaimers.priceInclusions,
        priceExclusions: financeTermDisclaimers.priceExclusions,
        termAndApr: financeTermDisclaimers.termAndApr,
        paymentAndCash: financeFrequencyDisclaimers.paymentAndCash,
        obligationAndInterest: financeFrequencyDisclaimers.obligationAndInterest,
        creditApproval: financeDisclaimers.creditApproval
    };

    return financeSentences;
}

/**
 * Util to get a basic disclaimers object
 * @param {Object} genericDisclaimers
 */
function getBasicDisclaimers(genericDisclaimers) {
    var sentences = {
        illustration: _widgetCommonsCoreServices.LocaleService.t('DISCLAIMERS_DEFAULT_VALUES.ILLUSTRATION'),
        highVolume: _widgetCommonsCoreServices.LocaleService.t('DISCLAIMERS_DEFAULT_VALUES.HIGH_VOLUME'),
        optionsVariation: _widgetCommonsCoreServices.LocaleService.t('DISCLAIMERS_DEFAULT_VALUES.OPTIONS_VARIATION'),
        dataResponsibility: _widgetCommonsCoreServices.LocaleService.t('DISCLAIMERS_DEFAULT_VALUES.DATA_RESPONSIBILITY'),
        priceChange: _widgetCommonsCoreServices.LocaleService.t('DISCLAIMERS_DEFAULT_VALUES.PRICE_CHANGE'),
        priceExclusion: _widgetCommonsCoreServices.LocaleService.t('DISCLAIMERS_DEFAULT_VALUES.PRICE_EXCLUSION'),
        taxesExcluded: _widgetCommonsCoreServices.LocaleService.t('DISCLAIMERS_DEFAULT_VALUES.TAXES_EXCLUDED', { taxCodes: ['Taxes'] }),
        pricePaymentsTaxesExcluded: _widgetCommonsCoreServices.LocaleService.t('DISCLAIMERS_DEFAULT_VALUES.PRICE_PAYMENTS_TAXES_EXCLUDED')
    };
    if ((0, _lodash.isEmpty)(genericDisclaimers)) {
        return new _DisclaimersModel2.default(sentences);
    }

    var ILLUSTRATION_PURPOSES = _disclaimers2.default.ILLUSTRATION_PURPOSES,
        HIGH_TRANSACTION_VOLUME = _disclaimers2.default.HIGH_TRANSACTION_VOLUME,
        OPTIONS_TRIMS_VARIATION = _disclaimers2.default.OPTIONS_TRIMS_VARIATION,
        NOT_RESPONSIBLE = _disclaimers2.default.NOT_RESPONSIBLE,
        PRICES_SUBJECT_TO_CHANGE = _disclaimers2.default.PRICES_SUBJECT_TO_CHANGE,
        GENERAL_FEES_EXCLUSION = _disclaimers2.default.GENERAL_FEES_EXCLUSION,
        EXCLUDED_TAXES = _disclaimers2.default.EXCLUDED_TAXES,
        PRICE_PAYMENTS_EXCLUDED_TAXES = _disclaimers2.default.PRICE_PAYMENTS_EXCLUDED_TAXES;


    var illustration = (0, _lodash.find)(genericDisclaimers, function (disclaimer) {
        return disclaimer.id === ILLUSTRATION_PURPOSES;
    });
    if (illustration) {
        sentences.illustration = illustration.disclaimer;
    }

    var highVolume = (0, _lodash.find)(genericDisclaimers, function (disclaimer) {
        return disclaimer.id === HIGH_TRANSACTION_VOLUME;
    });
    if (highVolume) {
        sentences.highVolume = highVolume.disclaimer;
    }

    var optionsVariation = (0, _lodash.find)(genericDisclaimers, function (disclaimer) {
        return disclaimer.id === OPTIONS_TRIMS_VARIATION;
    });
    if (optionsVariation) {
        sentences.optionsVariation = optionsVariation.disclaimer;
    }

    var dataResponsibility = (0, _lodash.find)(genericDisclaimers, function (disclaimer) {
        return disclaimer.id === NOT_RESPONSIBLE;
    });
    if (dataResponsibility) {
        sentences.dataResponsibility = dataResponsibility.disclaimer;
    }

    var priceChange = (0, _lodash.find)(genericDisclaimers, function (disclaimer) {
        return disclaimer.id === PRICES_SUBJECT_TO_CHANGE;
    });
    sentences.priceChange = priceChange ? priceChange.disclaimer : '';

    var priceExclusions = (0, _lodash.find)(genericDisclaimers, function (disclaimer) {
        return disclaimer.id === GENERAL_FEES_EXCLUSION;
    });
    if (priceExclusions) {
        sentences.priceExclusion = priceExclusions.disclaimer;
    }

    var taxesExcluded = (0, _lodash.find)(genericDisclaimers, function (disclaimer) {
        return disclaimer.id === EXCLUDED_TAXES;
    });
    if (taxesExcluded) {
        sentences.taxesExcluded = taxesExcluded.disclaimer;
    }

    var pricePaymentsTaxesExcluded = (0, _lodash.find)(genericDisclaimers, function (disclaimer) {
        return disclaimer.id === PRICE_PAYMENTS_EXCLUDED_TAXES;
    });
    if (pricePaymentsTaxesExcluded) {
        sentences.pricePaymentsTaxesExcluded = pricePaymentsTaxesExcluded.disclaimer;
    }

    return new _DisclaimersModel2.default(sentences);
}

/**
 * Util to merge Disclaimers API call response and target vehicles and return the new vehicles array
 * @param {Object} disclaimersData
 * @param {Object[]} vehiclesAndRequestData
 */
function mergeVehiclesAndDisclaimersDataResults(disclaimersData, vehiclesAndRequestData) {
    if ((0, _lodash.isEmpty)(disclaimersData) || (0, _lodash.isEmpty)(disclaimersData.disclaimers)) {
        return (0, _lodash.map)(vehiclesAndRequestData, function (vehicleAndRequestData) {
            return vehicleAndRequestData.vehicle;
        });
    }

    var disclaimers = disclaimersData.disclaimers;


    var baseDisclaimers = vehiclesAndRequestData[0].vehicle.purchaseMethods.disclaimers;
    var vehicleDisclaimers = (0, _lodash.map)(disclaimers, function (disclaimer) {
        return createDisclaimersSentences(disclaimer, baseDisclaimers.priceExclusion);
    });

    var vehiclesAndDisclaimers = (0, _lodash.map)(vehiclesAndRequestData, function (vehicleAndRequestData) {
        var cookie = vehicleAndRequestData.cookie,
            vehicle = vehicleAndRequestData.vehicle;


        var vehicleAndDisclaimer = (0, _lodash.find)(vehicleDisclaimers, function (vehicleDisclaimer) {
            return vehicleDisclaimer.cookie === cookie;
        });

        if (!vehicleAndDisclaimer) {
            return vehicle.setIn(['purchaseMethods', 'disclaimers'], baseDisclaimers);
        }

        var purchaseMethods = vehicle.purchaseMethods;
        var lease = vehicleAndDisclaimer.lease,
            finance = vehicleAndDisclaimer.finance;


        var financeSentences = getFinanceSentences(purchaseMethods.finance, finance);
        var leaseSentences = getFinanceSentences(purchaseMethods.lease, lease);

        var purchaseMethodsDisclaimers = baseDisclaimers.set('cashPurchase', vehicleAndDisclaimer.cashPurchase).set('finance', financeSentences).set('lease', leaseSentences);

        return vehicle.setIn(['purchaseMethods', 'disclaimers'], purchaseMethodsDisclaimers);
    });

    return vehiclesAndDisclaimers;
}

/**
 * Util to merge Disclaimers API call response and target options package and return the new model year
 * @param {Object} disclaimersData
 * @param {Object[]} optionsPackageAndRequestData
 */
function mergeOptionsPackageAndDisclaimersDataResults(disclaimersData, optionsPackageAndRequestData) {
    if ((0, _lodash.isEmpty)(disclaimersData) || (0, _lodash.isEmpty)(disclaimersData.disclaimers)) {
        return optionsPackageAndRequestData.modelYear;
    }

    var disclaimers = disclaimersData.disclaimers,
        genericDisclaimers = disclaimersData.genericDisclaimers;


    var baseDisclaimers = getBasicDisclaimers(genericDisclaimers);
    var vehicleDisclaimers = (0, _lodash.map)(disclaimers, function (disclaimer) {
        return createDisclaimersSentences(disclaimer, baseDisclaimers.priceExclusion);
    });

    var cookie = optionsPackageAndRequestData.cookie,
        modelYear = optionsPackageAndRequestData.modelYear,
        optionsPackage = optionsPackageAndRequestData.optionsPackage;


    var vehicleAndDisclaimer = (0, _lodash.find)(vehicleDisclaimers, function (vehicleDisclaimer) {
        return vehicleDisclaimer.cookie === cookie;
    });

    if (!vehicleAndDisclaimer) {
        return modelYear;
    }

    var _optionsPackage$confi2 = optionsPackage.configuration,
        modelTrimCodeId = _optionsPackage$confi2.modelTrimCodeId,
        purchaseMethods = _optionsPackage$confi2.purchaseMethods;
    var lease = vehicleAndDisclaimer.lease,
        finance = vehicleAndDisclaimer.finance;


    var financeSentences = getFinanceSentences(purchaseMethods.finance, finance);
    var leaseSentences = getFinanceSentences(purchaseMethods.lease, lease);

    var purchaseMethodsDisclaimers = baseDisclaimers.set('cashPurchase', vehicleAndDisclaimer.cashPurchase).set('finance', financeSentences).set('lease', leaseSentences);

    var newOptionsPackage = optionsPackage.setIn(['configuration', 'purchaseMethods', 'disclaimers'], purchaseMethodsDisclaimers);

    return modelYear.set('optionsPackages', (0, _immutable.List)((0, _lodash.map)(modelYear.optionsPackages.toArray(), function (modelOptionsPackage) {
        var currentModelTrimCodeId = modelOptionsPackage.configuration.modelTrimCodeId;
        return currentModelTrimCodeId === modelTrimCodeId ? newOptionsPackage : modelOptionsPackage;
    })));
}

/**
 * Util to merge Disclaimers API call response and target model and return the model and purchase methods
 * @param {Object} disclaimersData
 * @param {Object[]} modelsAndRequestData
 */
function mergeModelAndDisclaimersDataResults(disclaimersData, modelsAndRequestData) {
    var CASH = _purchaseMethodsValues2.default.CASH,
        FINANCE = _purchaseMethodsValues2.default.FINANCE,
        LEASE = _purchaseMethodsValues2.default.LEASE;

    var priceModelsAndRequestData = (0, _lodash.filter)(modelsAndRequestData, function (modelAndRequestPurchaseMethodData) {
        return modelAndRequestPurchaseMethodData.purchaseMethod === CASH;
    });

    if ((0, _lodash.isEmpty)(disclaimersData) || (0, _lodash.isEmpty)(disclaimersData.disclaimers)) {
        return (0, _lodash.map)(priceModelsAndRequestData, function (priceModelAndRequestData) {
            return priceModelAndRequestData.model;
        });
    }

    var disclaimers = disclaimersData.disclaimers,
        genericDisclaimers = disclaimersData.genericDisclaimers;


    var baseDisclaimers = getBasicDisclaimers(genericDisclaimers);
    var vehicleDisclaimers = (0, _lodash.map)(disclaimers, function (disclaimer) {
        return createDisclaimersSentences(disclaimer, baseDisclaimers.priceExclusion);
    });

    var priceModelsAndDisclaimers = (0, _lodash.map)(priceModelsAndRequestData, function (priceModelAndRequestData) {
        var model = priceModelAndRequestData.model;


        var leasePurchaseMethods = (0, _lodash.find)(modelsAndRequestData, function (modelAndRequestData) {
            return modelAndRequestData.purchaseMethod === LEASE && modelAndRequestData.model.make === model.make && modelAndRequestData.model.model === model.model && modelAndRequestData.model.bodyStyleCode === model.bodyStyleCode;
        });
        var financePurchaseMethods = (0, _lodash.find)(modelsAndRequestData, function (modelAndRequestData) {
            return modelAndRequestData.purchaseMethod === FINANCE && modelAndRequestData.model.make === model.make && modelAndRequestData.model.model === model.model && modelAndRequestData.model.bodyStyleCode === model.bodyStyleCode;
        });

        var priceVehicleAndDisclaimer = (0, _lodash.find)(vehicleDisclaimers, function (vehicleDisclaimer) {
            return vehicleDisclaimer.cookie === priceModelAndRequestData.cookie;
        });
        var leaseVehicleAndDisclaimer = (0, _lodash.find)(vehicleDisclaimers, function (vehicleDisclaimer) {
            return vehicleDisclaimer.cookie === leasePurchaseMethods.cookie;
        });
        var financeVehicleAndDisclaimer = (0, _lodash.find)(vehicleDisclaimers, function (vehicleDisclaimer) {
            return vehicleDisclaimer.cookie === financePurchaseMethods.cookie;
        });

        if (!priceVehicleAndDisclaimer && !leaseVehicleAndDisclaimer && !financeVehicleAndDisclaimer) {
            return priceModelAndRequestData.model;
        }

        var lease = leaseVehicleAndDisclaimer.lease;
        var finance = financeVehicleAndDisclaimer.finance;


        var financeSentences = getFinanceSentences(financePurchaseMethods.purchaseMethods.finance, finance);
        var leaseSentences = getFinanceSentences(leasePurchaseMethods.purchaseMethods.lease, lease);

        var purchaseMethodsDisclaimers = baseDisclaimers.set('cashPurchase', priceVehicleAndDisclaimer.cashPurchase).set('finance', financeSentences).set('lease', leaseSentences);

        return priceModelAndRequestData.model.setIn(['purchaseMethods', 'disclaimers'], purchaseMethodsDisclaimers);
    });

    return priceModelsAndDisclaimers;
}

/**
 * Groups Disclaimer api calls to ShowroomAPI
 */

var DisclaimerAPIService = function () {
    function DisclaimerAPIService() {
        _classCallCheck(this, DisclaimerAPIService);
    }

    _createClass(DisclaimerAPIService, [{
        key: 'getGenericDisclaimers',

        /**
         * Gets the generic disclaimers for a context
         */
        value: function getGenericDisclaimers() {
            return _ShowroomAPIService2.default.getPublicToken().then(function (publicToken) {
                var disclaimersRequestConfig = getGenericDisclaimersRequestConfig(publicToken.data);

                return _axios2.default.request(disclaimersRequestConfig).then(function (result) {
                    return getBasicDisclaimers(result.data);
                }).catch(function () {
                    return Promise.reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('Unable to load disclaimers'));
                });
            });
        }

        /**
         * Gets the disclaimers for a list of vehicles
         * @param {Object[]} vehicles
         */

    }, {
        key: 'getVehiclesDisclaimers',
        value: function getVehiclesDisclaimers(vehicles) {
            if ((0, _lodash.isEmpty)(vehicles) || !(0, _lodash.isArrayLikeObject)(vehicles) || !(vehicles[0] instanceof _VehicleModel2.default)) {
                return Promise.reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('param [vehicles] must be an array'));
            }

            var vehiclesAndRequestData = getVehiclesDisclaimersDataRequestConfig(vehicles);

            return _ShowroomAPIService2.default.getPublicToken().then(function (publicToken) {
                var disclaimersRequestConfig = getDisclaimersRequestConfig(publicToken.data, vehiclesAndRequestData);

                return _axios2.default.request(disclaimersRequestConfig).then(function (result) {
                    return mergeVehiclesAndDisclaimersDataResults(result.data, vehiclesAndRequestData);
                }).catch(function () {
                    return Promise.reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('Unable to load disclaimers'));
                });
            });
        }

        /**
         * Gets the disclaimers for the selected options package of a Model Year
         * @param {Object} modelYear
         * @param {Object} selectedOptionsPackage
         */

    }, {
        key: 'getModelYearSelectedOptionsPackageDisclaimers',
        value: function getModelYearSelectedOptionsPackageDisclaimers(modelYear, selectedOptionsPackage, configurationToken) {
            if ((0, _lodash.isEmpty)(modelYear) || !(modelYear instanceof _ModelYearModel2.default) || (0, _lodash.isUndefined)(selectedOptionsPackage)) {
                return Promise.reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('param modelYear must be a valid Model Year'));
            }

            var optionsPackageAndRequestData = getOptionsPackageDisclaimersDataRequestConfig(modelYear, selectedOptionsPackage);

            optionsPackageAndRequestData[0].disclaimerData.configurationToken = configurationToken || '';

            return _ShowroomAPIService2.default.getPublicToken().then(function (publicToken) {
                var disclaimersRequestConfig = getDisclaimersRequestConfig(publicToken.data, optionsPackageAndRequestData);

                return _axios2.default.request(disclaimersRequestConfig).then(function (result) {
                    return mergeOptionsPackageAndDisclaimersDataResults(result.data, optionsPackageAndRequestData[0]);
                }).catch(function () {
                    return Promise.reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('Unable to load disclaimers'));
                });
            });
        }

        /**
         * Gets the disclaimers for a list of models
         * @param {Object[]} models
         */

    }, {
        key: 'getModelsDisclaimers',
        value: function getModelsDisclaimers(models) {
            if ((0, _lodash.isEmpty)(models) || !(0, _lodash.isArrayLikeObject)(models)) {
                return Promise.reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('param models must be valid'));
            }

            var modelsAndRequestData = getModelsDisclaimersDataRequestConfig(models);

            return _ShowroomAPIService2.default.getPublicToken().then(function (publicToken) {
                var disclaimersRequestConfig = getDisclaimersRequestConfig(publicToken.data, modelsAndRequestData);
                return _axios2.default.request(disclaimersRequestConfig).then(function (result) {
                    return mergeModelAndDisclaimersDataResults(result.data, modelsAndRequestData);
                }).catch(function () {
                    return Promise.reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('Unable to load disclaimers'));
                });
            });
        }
    }]);

    return DisclaimerAPIService;
}();

exports.DisclaimerAPIService = DisclaimerAPIService;
exports.default = new DisclaimerAPIService();

/***/ }),

/***/ "./src/PurchaseMethods/services/PurchaseMethodsService/PurchaseMethodsService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.recalculatePayments = recalculatePayments;
exports.recalculatePurchaseAmounts = recalculatePurchaseAmounts;
exports.splitRetailAndIncludedOptions = splitRetailAndIncludedOptions;
exports.resetOptionsAmounts = resetOptionsAmounts;
exports.resetPurchaseMethodsFromOriginData = resetPurchaseMethodsFromOriginData;
exports.resetPurchaseMethodsOptionsFromQuoteItems = resetPurchaseMethodsOptionsFromQuoteItems;
exports.selectPurchaseMethod = selectPurchaseMethod;
exports.selectKMPlan = selectKMPlan;
exports.selectTerm = selectTerm;
exports.setTargetPayment = setTargetPayment;
exports.selectPaymentFrequency = selectPaymentFrequency;
exports.setCashDown = setCashDown;
exports.setTradeIn = setTradeIn;
exports.setLien = setLien;
exports.setExteriorColourAmounts = setExteriorColourAmounts;
exports.setInteriorColourAmounts = setInteriorColourAmounts;
exports.setOptionsAmounts = setOptionsAmounts;
exports.setTaxesIncluded = setTaxesIncluded;
exports.selectOptionsResolution = selectOptionsResolution;
exports.setSelectedFinanceBestPaymentTerm = setSelectedFinanceBestPaymentTerm;
exports.setDeliveryFee = setDeliveryFee;
exports.setDeposit = setDeposit;
exports.getFormattedCurrencySplit = getFormattedCurrencySplit;
exports.resetProtections = resetProtections;
exports.resetSelectedOptions = resetSelectedOptions;
exports.resetSelectedIncentiveRebates = resetSelectedIncentiveRebates;

var _lodash = __webpack_require__("lodash");

var _purchaseMethods = __webpack_require__("./src/PurchaseMethods/constants/purchaseMethods.js");

var PurchaseMethodsConstants = _interopRequireWildcard(_purchaseMethods);

var _dataOrigins = __webpack_require__("./src/constants/dataOrigins.js");

var DataOrigins = _interopRequireWildcard(_dataOrigins);

var _dataTypes = __webpack_require__("./src/constants/dataTypes.js");

var dataTypes = _interopRequireWildcard(_dataTypes);

var _dataConversions = __webpack_require__("./src/constants/dataConversions.js");

var _dataConversions2 = __webpack_require__("./src/PurchaseMethods/constants/dataConversions.js");

var _apiDataConversionConstants = __webpack_require__("./src/constants/apiDataConversionConstants.js");

var _purchaseMethodsValues = __webpack_require__("./src/PurchaseMethods/constants/purchaseMethodsValues.js");

var _purchaseMethodsValues2 = _interopRequireDefault(_purchaseMethodsValues);

var _PurchaseMethodsModel = __webpack_require__("./src/PurchaseMethods/models/PurchaseMethodsModel.js");

var _PurchaseMethodsModel2 = _interopRequireDefault(_PurchaseMethodsModel);

var _FinanceService = __webpack_require__("./src/PurchaseMethods/services/FinanceService/FinanceService.js");

var FinanceService = _interopRequireWildcard(_FinanceService);

var _CashPurchaseService = __webpack_require__("./src/PurchaseMethods/services/CashPurchaseService/CashPurchaseService.js");

var CashPurchaseService = _interopRequireWildcard(_CashPurchaseService);

var _TermService = __webpack_require__("./src/PurchaseMethods/services/TermService/TermService.js");

var _OptionService = __webpack_require__("./src/ModelYear/services/OptionService/OptionService.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var VEHICLE = _apiDataConversionConstants.VIEW_1.VEHICLE;
/* eslint no-bitwise: 0 */

function recalculatePayments(purchaseMethods, paymentCalculationParameters) {
    return purchaseMethods.set('taxesIncluded', paymentCalculationParameters.taxesIncluded).set('tradeIn', paymentCalculationParameters.tradeIn).set('lien', paymentCalculationParameters.lien).set('exteriorColourRetail', paymentCalculationParameters.exteriorColourRetail).set('exteriorColourResidualRetail', paymentCalculationParameters.exteriorColourResidualRetail).set('interiorColourRetail', paymentCalculationParameters.interiorColourRetail).set('interiorColourResidualRetail', paymentCalculationParameters.interiorColourResidualRetail).set('optionsTotalRetail', paymentCalculationParameters.optionsTotalRetail).set('optionsTotalResidualRetail', paymentCalculationParameters.optionsTotalResidualRetail).setIn(['finance', 'terms'], purchaseMethods.getIn(['finance', 'terms']).map(function (term) {
        return (0, _TermService.recalculateTermPayment)(term, paymentCalculationParameters);
    })).setIn(['lease', 'terms'], purchaseMethods.getIn(['lease', 'terms']).map(function (term) {
        return (0, _TermService.recalculateTermPayment)(term, paymentCalculationParameters);
    })).setIn(['finance', 'selectedTerm'], paymentCalculationParameters.selectedFinanceTerm).setIn(['lease', 'selectedTerm'], paymentCalculationParameters.selectedLeaseTerm);
}

function recalculatePurchaseAmounts(purchaseMethods, amountsCalculationParameters) {
    var retail = purchaseMethods.getIn(['cashPurchase', 'retail']);
    var optionsAdjustment = amountsCalculationParameters.exteriorColourRetail + amountsCalculationParameters.interiorColourRetail + amountsCalculationParameters.optionsTotalRetail;
    var optionsTaxesAdjustment = optionsAdjustment * amountsCalculationParameters.taxesFactor;
    var netTradeInAdjustment = amountsCalculationParameters.tradeIn - amountsCalculationParameters.lien > retail + optionsAdjustment ? retail + optionsAdjustment : amountsCalculationParameters.tradeIn - amountsCalculationParameters.lien;
    var tradeInTaxesAdjustment = amountsCalculationParameters.tradeIn > retail + optionsAdjustment ? (retail + optionsAdjustment) * amountsCalculationParameters.taxesFactor : amountsCalculationParameters.tradeIn * amountsCalculationParameters.taxesFactor;
    return purchaseMethods.setIn(['cashPurchase', 'netTradeInAdjustment'], netTradeInAdjustment).setIn(['cashPurchase', 'tradeInTaxesAdjustment'], tradeInTaxesAdjustment).setIn(['cashPurchase', 'optionsAdjustment'], optionsAdjustment).setIn(['cashPurchase', 'optionsTaxesAdjustment'], optionsTaxesAdjustment);
}

function splitRetailAndIncludedOptions(purchaseMethods) {
    var selectedItemCodes = purchaseMethods.getSelectedOptionsAndColours();
    if ((0, _lodash.isEmpty)(purchaseMethods.getAllSelectedOptions()) || (0, _lodash.isEmpty)(selectedItemCodes)) {
        return purchaseMethods;
    }
    var optionsToReduceFromRetail = (0, _lodash.filter)(selectedItemCodes, function (selectedItemCode) {
        return (0, _lodash.includes)(purchaseMethods.cashPurchase.includedItemsCodes, selectedItemCode.selectionCode);
    });
    var optionsAdjustment = (0, _lodash.sumBy)(optionsToReduceFromRetail, function (option) {
        return option.retail;
    });
    var retail = purchaseMethods.cashPurchase.retail - optionsAdjustment;

    return purchaseMethods.set('cashPurchase', purchaseMethods.cashPurchase.set('retail', retail).set('optionsAdjustment', optionsAdjustment));
}

function resetOptionsAmounts(purchaseMethods) {
    var allSelectedOptions = purchaseMethods.getNonConfigurationSelectedOptions();
    var includedOtherFees = purchaseMethods.getOtherFeesAmountIncluded(allSelectedOptions);
    var includedProtection = purchaseMethods.getProtectionsAmountIncluded(allSelectedOptions);
    var optionsRetail = purchaseMethods.getOptionsAmount(allSelectedOptions);
    var optionsResidualizingAmount = purchaseMethods.getOptionsResidualizingAmount(allSelectedOptions);
    var otherFeesRetail = purchaseMethods.getOtherFeesAmount(allSelectedOptions, false) - includedOtherFees;
    var protectionsRetail = purchaseMethods.getProtectionsAmount(allSelectedOptions) - includedProtection;
    var dealerDiscounts = purchaseMethods.getDealerDiscountsAmount(allSelectedOptions);
    var employeeRebateAdjustment = purchaseMethods.employeeRebateAdjustment;

    var optionsAmounts = {
        retail: optionsRetail + otherFeesRetail + protectionsRetail - dealerDiscounts - employeeRebateAdjustment,
        residualRetail: optionsResidualizingAmount
    };

    var calculationParameters = purchaseMethods.getPaymentCalculationWithOptions(optionsAmounts);
    var newPurchaseMethods = recalculatePurchaseAmounts(purchaseMethods, calculationParameters);
    newPurchaseMethods = recalculatePayments(newPurchaseMethods, calculationParameters);

    var exteriorColourRetail = purchaseMethods.getExteriorColourAmount(allSelectedOptions);
    var exteriorColourResidualizingAmount = purchaseMethods.getExteriorColourResidualizingAmount(allSelectedOptions);

    var exteriorColourAmounts = {
        retail: exteriorColourRetail,
        residualRetail: exteriorColourResidualizingAmount
    };

    calculationParameters = newPurchaseMethods.getPaymentCalculationWithExteriorColour(exteriorColourAmounts);
    newPurchaseMethods = recalculatePurchaseAmounts(newPurchaseMethods, calculationParameters);
    newPurchaseMethods = recalculatePayments(newPurchaseMethods, calculationParameters);

    var interiorColourRetail = purchaseMethods.getInteriorColourAmount(allSelectedOptions);
    var interiorColourResidualizingAmount = purchaseMethods.getInteriorColourResidualizingAmount(allSelectedOptions);

    var interiorColourAmounts = {
        retail: interiorColourRetail,
        residualRetail: interiorColourResidualizingAmount
    };

    calculationParameters = newPurchaseMethods.getPaymentCalculationWithInteriorColour(interiorColourAmounts);
    newPurchaseMethods = recalculatePurchaseAmounts(newPurchaseMethods, calculationParameters);
    return recalculatePayments(newPurchaseMethods, calculationParameters);
}

function resetOptions(purchaseMethods, resetOption, add) {
    var selectedOptions = (0, _lodash.filter)(purchaseMethods.getAllSelectedOptions(), function (option) {
        return option.selectionCode !== resetOption.selectionCode;
    });
    var availableOptions = (0, _lodash.filter)(purchaseMethods.availableOptions, function (option) {
        return option.selectionCode !== resetOption.selectionCode;
    });

    if (add) {
        selectedOptions.push(resetOption.set('selected', true));
    } else {
        availableOptions.push(resetOption.set('selected', false));
    }

    return resetOptionsAmounts(purchaseMethods.set('selectedOptions', selectedOptions).set('availableOptions', availableOptions));
}

function resetPurchaseMethodsFromOriginData(dataOrigin, originPurchaseMethodsData, defaultPurchaseMethod, disclaimers) {
    if ((0, _lodash.isEmpty)(originPurchaseMethodsData) || !(0, _lodash.isArrayLikeObject)(originPurchaseMethodsData) && !(0, _lodash.isObjectLike)(originPurchaseMethodsData)) {
        return new _PurchaseMethodsModel2.default();
    }
    var lease = FinanceService.resetFinanceFromOriginData(dataOrigin, originPurchaseMethodsData, PurchaseMethodsConstants.LEASE, true);
    var finance = FinanceService.resetFinanceFromOriginData(dataOrigin, originPurchaseMethodsData, PurchaseMethodsConstants.FINANCE, !lease.selected);
    var cashPurchase = CashPurchaseService.resetCashPurchaseFromOriginData(dataOrigin, originPurchaseMethodsData, !lease.selected && !finance.selected);

    var taxesFactor = 0;
    var taxCodes = [];
    switch (dataOrigin) {
        case DataOrigins.MODELS_COLLECTION:
            taxesFactor = originPurchaseMethodsData.taxesFactor;
            taxCodes = originPurchaseMethodsData.taxCodes;
            break;
        case DataOrigins.PAYMENT_CALCULATOR:
            taxesFactor = originPurchaseMethodsData.taxesFactor;
            taxCodes = originPurchaseMethodsData.taxCodes;
            break;
        case DataOrigins.MODEL_YEAR_POWERS_TRIMS:
            taxesFactor = originPurchaseMethodsData[_dataConversions2.MODEL_TAXES.TAXES_FACTOR];
            taxCodes = originPurchaseMethodsData[_dataConversions2.MODEL_TAXES.TAX_CODES];
            break;
        case DataOrigins.VEHICLE_PAYMENTS:
            taxesFactor = originPurchaseMethodsData.taxesFactor;
            taxCodes = originPurchaseMethodsData.taxCodes;
            break;
        default:
            break;
    }

    if (defaultPurchaseMethod) {
        lease = lease.set('selected', defaultPurchaseMethod === PurchaseMethodsConstants.LEASE);
        finance = finance.set('selected', defaultPurchaseMethod === PurchaseMethodsConstants.FINANCE);
        cashPurchase = cashPurchase.set('selected', defaultPurchaseMethod !== PurchaseMethodsConstants.LEASE && defaultPurchaseMethod !== PurchaseMethodsConstants.FINANCE);
    }

    var highRebate = 0;
    var highRebatePurchaseMethod = _purchaseMethodsValues2.default.CASH;
    if (originPurchaseMethodsData[VEHICLE.HIGH_REBATE]) {
        var highRebateObject = originPurchaseMethodsData[VEHICLE.HIGH_REBATE][VEHICLE.HIGH_REBATE_INDEX];
        var highRebateTaxes = highRebateObject[VEHICLE.HIGH_REBATE_REBATES_TAXES] || 0;
        highRebate = highRebateObject[VEHICLE.HIGH_REBATE_RETAIL] + highRebateTaxes;
        highRebatePurchaseMethod = highRebateObject[VEHICLE.HIGH_REBATE_PURCHASE_METHOD];
    }

    var purchaseMethods = new _PurchaseMethodsModel2.default({
        taxesFactor: taxesFactor,
        taxCodes: taxCodes,
        highRebate: highRebate,
        highRebatePurchaseMethod: highRebatePurchaseMethod,
        lease: lease,
        finance: finance,
        cashPurchase: cashPurchase
    });

    var newPurchaseMethods = disclaimers ? purchaseMethods.set('disclaimers', disclaimers) : purchaseMethods;
    return dataOrigin === DataOrigins.VEHICLE_PAYMENTS ? splitRetailAndIncludedOptions(newPurchaseMethods) : newPurchaseMethods;
}

function resetPurchaseMethodsOptionsFromQuoteItems(purchaseMethods, quoteItems, availableQuoteItems) {
    if (!(0, _lodash.isArrayLikeObject)(quoteItems)) {
        return purchaseMethods;
    }

    var selectedQuoteItems = (0, _lodash.filter)(quoteItems, function (quoteItem) {
        var selected = (quoteItem.flag & dataTypes.ITEM_FLAG.SELECTED) > 0;
        var hasDealerCashOnlyDiscount = (0, _lodash.includes)(quoteItem.supplierCodes, _dataConversions.CASH_PURCHASE_ONLY_DISCOUNT);
        return selected || hasDealerCashOnlyDiscount;
    });

    var availableItems = (0, _lodash.map)(availableQuoteItems, function (quoteItem) {
        return (0, _OptionService.resetOptionFromQuoteItem)(quoteItem, false);
    });

    var includedItemCodes = purchaseMethods.cashPurchase.includedItemsCodes;
    var selectedTerm = purchaseMethods.getSelectedFinanceTerm();
    if (selectedTerm) {
        includedItemCodes = selectedTerm.includedItemsCodes;
    }
    return purchaseMethods.set('availableOptions', availableItems).set('selectedOptions', (0, _lodash.map)(selectedQuoteItems, function (selectedQuoteItem) {
        var itemCode = selectedQuoteItem.code + '>' + selectedQuoteItem.supplier;
        return (0, _OptionService.resetOptionFromQuoteItem)(selectedQuoteItem, (0, _lodash.includes)(includedItemCodes, itemCode));
    }));
}

function setBestPaymentFinance(purchaseMethods) {
    var bestPaymentFinance = purchaseMethods.getBestPaymentFinance();
    return purchaseMethods.setIn(['lease', 'selected'], bestPaymentFinance === _purchaseMethodsValues2.default.LEASE).setIn(['finance', 'selected'], bestPaymentFinance === _purchaseMethodsValues2.default.FINANCE).setIn(['cashPurchase', 'selected'], false);
}

function selectPurchaseMethod(purchaseMethods, purchaseMethod) {
    return purchaseMethod === PurchaseMethodsConstants.BEST_PAYMENT ? setBestPaymentFinance(purchaseMethods) : purchaseMethods.setIn(['finance', 'selected'], purchaseMethod === PurchaseMethodsConstants.FINANCE).setIn(['lease', 'selected'], purchaseMethod === PurchaseMethodsConstants.LEASE).setIn(['cashPurchase', 'selected'], purchaseMethod === PurchaseMethodsConstants.CASH_PURCHASE);
}

function selectKMPlan(purchaseMethods, kmPlan) {
    var calculationParameters = purchaseMethods.getPaymentCalculationParameters();
    var selectedFinance = purchaseMethods.getSelectedFinance();
    if (!selectedFinance) {
        return purchaseMethods;
    }
    var newKMPlan = selectedFinance.getKMPlan(kmPlan);
    if (!newKMPlan) {
        return purchaseMethods;
    }
    var newPurchaseMethods = purchaseMethods.getIn(['lease', 'selected']) ? purchaseMethods.setIn(['lease', 'annualKMAllowed'], newKMPlan.annualKMAllowed).setIn(['lease', 'endTermKMCost'], newKMPlan.endTermKMCost).setIn(['lease', 'terms'], newKMPlan.terms) : purchaseMethods.setIn(['finance', 'annualKMAllowed'], newKMPlan.annualKMAllowed).setIn(['finance', 'endTermKMCost'], newKMPlan.endTermKMCost).setIn(['finance', 'terms'], newKMPlan.terms);
    return recalculatePayments(newPurchaseMethods, calculationParameters);
}

function selectTerm(purchaseMethods, term) {
    var calculationParameters = purchaseMethods.getPaymentCalculationWithTerm(term);
    return recalculatePayments(purchaseMethods, calculationParameters);
}

function setTargetPayment(purchaseMethods, targetPayment) {
    var calculationParameters = purchaseMethods.getPaymentCalculationWithTargetPayment(targetPayment);
    return recalculatePayments(purchaseMethods, calculationParameters);
}

function selectPaymentFrequency(purchaseMethods, paymentFrequency) {
    var calculationParameters = purchaseMethods.getPaymentCalculationWithPaymentFrequency(paymentFrequency);
    return recalculatePayments(purchaseMethods, calculationParameters);
}

function setCashDown(purchaseMethods, cashDown) {
    var calculationParameters = purchaseMethods.getPaymentCalculationWithCashDown(parseFloat(cashDown));
    return recalculatePayments(purchaseMethods, calculationParameters);
}

function setTradeIn(purchaseMethods, tradeIn) {
    var calculationParameters = purchaseMethods.getPaymentCalculationWithTradeIn(tradeIn);
    var newPurchaseMethods = recalculatePurchaseAmounts(purchaseMethods, calculationParameters);
    return recalculatePayments(newPurchaseMethods, calculationParameters);
}

function setLien(purchaseMethods, lien) {
    var calculationParameters = purchaseMethods.getPaymentCalculationWithLien(lien);
    var newPurchaseMethods = recalculatePurchaseAmounts(purchaseMethods, calculationParameters);
    return recalculatePayments(newPurchaseMethods, calculationParameters);
}

function setExteriorColourAmounts(purchaseMethods, exteriorColourAmounts) {
    var calculationParameters = purchaseMethods.getPaymentCalculationWithExteriorColour(exteriorColourAmounts);
    var newPurchaseMethods = recalculatePurchaseAmounts(purchaseMethods, calculationParameters);
    return recalculatePayments(newPurchaseMethods, calculationParameters);
}

function setInteriorColourAmounts(purchaseMethods, interiorColourAmounts) {
    var calculationParameters = purchaseMethods.getPaymentCalculationWithInteriorColour(interiorColourAmounts);
    var newPurchaseMethods = recalculatePurchaseAmounts(purchaseMethods, calculationParameters);
    return recalculatePayments(newPurchaseMethods, calculationParameters);
}

function setOptionsAmounts(purchaseMethods, optionsAmounts) {
    var calculationParameters = purchaseMethods.getPaymentCalculationWithOptions(optionsAmounts);
    var newPurchaseMethods = recalculatePurchaseAmounts(purchaseMethods, calculationParameters);
    return recalculatePayments(newPurchaseMethods, calculationParameters);
}

function setTaxesIncluded(purchaseMethods, taxesIncluded) {
    var calculationParameters = purchaseMethods.getPaymentCalculationWithTaxesIncluded(taxesIncluded);
    var newPurchaseMethods = recalculatePurchaseAmounts(purchaseMethods, calculationParameters);
    return recalculatePayments(newPurchaseMethods, calculationParameters);
}

function selectOptionsResolution(purchaseMethods, resolutionId) {
    return purchaseMethods.setIn(['optionsSelectionResolutions', 'resolutions'], (0, _lodash.map)(purchaseMethods.optionsSelectionResolutions.resolutions, function (resolution) {
        return resolution.set('selected', resolution.id === resolutionId);
    }));
}

function setSelectedFinanceBestPaymentTerm(purchaseMethods, maximumTerm) {
    var selectedFinance = purchaseMethods.getSelectedFinance();
    var bestPaymentTerm = selectedFinance ? selectedFinance.getBestPaymentTerm(maximumTerm) : undefined;
    if (!bestPaymentTerm) {
        return purchaseMethods;
    }
    return selectTerm(purchaseMethods, bestPaymentTerm.term);
}

function setDeliveryFee(purchaseMethods, addFee) {
    var deliveryFee = purchaseMethods.getDeliveryFee();
    if (!deliveryFee) {
        return purchaseMethods;
    }

    return resetOptions(purchaseMethods, deliveryFee, addFee);
}

function setDeposit(purchaseMethods, deposit) {
    var depositItem = deposit.checkout ? purchaseMethods.getCheckoutDeposit() : purchaseMethods.getReservationDeposit();
    if (!depositItem) {
        return purchaseMethods;
    }
    var depositAmount = -1 * deposit.override;

    return resetOptions(purchaseMethods, depositItem.set('retail', depositAmount).set('dueAtDelivery', true), true);
}

function getFormattedCurrencySplit(formattedCurrency) {
    var formattedCurrencySplit = {
        beforeDecimal: '',
        afterDecimal: ''
    };
    var decimalPoint = formattedCurrency.indexOf('.');
    if (decimalPoint === -1) {
        decimalPoint = formattedCurrency.indexOf(',');
    }
    if (decimalPoint > -1) {
        formattedCurrencySplit.beforeDecimal = formattedCurrency.substring(0, decimalPoint);
        formattedCurrencySplit.afterDecimal = formattedCurrency.substring(decimalPoint + 1, formattedCurrency.length);
    } else {
        formattedCurrencySplit.beforeDecimal = formattedCurrency;
    }
    return formattedCurrencySplit;
}

function resetProtections(purchaseMethods, protections) {
    var selectedOptions = (0, _lodash.filter)(purchaseMethods.getAllSelectedOptions(), function (option) {
        return option.dataType !== dataTypes.DATA_TYPES.PROTECTION.DATA_TYPE_ID;
    });

    var selectedProtections = [];
    (0, _lodash.forEach)(protections, function (protection) {
        selectedProtections = (0, _lodash.concat)(selectedProtections, protection.getSelectedItemsAndPackages());
    });

    return resetOptionsAmounts(purchaseMethods.set('selectedOptions', (0, _lodash.concat)(selectedOptions, selectedProtections)));
}

function resetSelectedOptions(purchaseMethods, options, configurationOptions) {
    var hasSelectedExtColour = !(0, _lodash.isUndefined)((0, _lodash.find)(options, function (option) {
        return option.dataType === dataTypes.DATA_TYPES.FEATURE.DATA_TYPE_ID && option.typeID === dataTypes.DATA_TYPES.FEATURE.TYPES.EXTERIOR_COLOUR;
    }));
    var hasSelectedIntColour = !(0, _lodash.isUndefined)((0, _lodash.find)(options, function (option) {
        return option.dataType === dataTypes.DATA_TYPES.FEATURE.DATA_TYPE_ID && option.typeID === dataTypes.DATA_TYPES.FEATURE.TYPES.INTERIOR_TRIM;
    }));

    var purchaseMethodsOptions = purchaseMethods.selectedOptions;
    if (hasSelectedExtColour) {
        purchaseMethodsOptions = (0, _lodash.filter)(purchaseMethodsOptions, function (purchaseMethodsOption) {
            return !(purchaseMethodsOption.dataType === dataTypes.DATA_TYPES.FEATURE.DATA_TYPE_ID && purchaseMethodsOption.typeID === dataTypes.DATA_TYPES.FEATURE.TYPES.EXTERIOR_COLOUR);
        });
    }
    if (hasSelectedIntColour) {
        purchaseMethodsOptions = (0, _lodash.filter)(purchaseMethodsOptions, function (purchaseMethodsOption) {
            return !(purchaseMethodsOption.dataType === dataTypes.DATA_TYPES.FEATURE.DATA_TYPE_ID && purchaseMethodsOption.typeID === dataTypes.DATA_TYPES.FEATURE.TYPES.INTERIOR_TRIM);
        });
    }
    purchaseMethodsOptions = (0, _lodash.intersectionBy)(options, purchaseMethodsOptions, 'selectionCode');

    return resetOptionsAmounts(purchaseMethods.set('configurationOptions', configurationOptions).set('selectedOptions', (0, _lodash.unionBy)(purchaseMethodsOptions, options, 'selectionCode')));
}

function resetSelectedIncentiveRebates(purchaseMethods) {
    var purchaseMethodsOptions = (0, _lodash.filter)(purchaseMethods.selectedOptions, function (selectedOption) {
        return selectedOption.supplier !== dataTypes.SUPPLIER_INCENTIVE || selectedOption.userSelected;
    });

    return purchaseMethods.set('selectedOptions', purchaseMethodsOptions);
}

exports.default = {
    getFormattedCurrencySplit: getFormattedCurrencySplit,
    recalculatePayments: recalculatePayments,
    recalculatePurchaseAmounts: recalculatePurchaseAmounts,
    resetOptions: resetOptions,
    resetOptionsAmounts: resetOptionsAmounts,
    resetProtections: resetProtections,
    resetPurchaseMethodsFromOriginData: resetPurchaseMethodsFromOriginData,
    resetPurchaseMethodsOptionsFromQuoteItems: resetPurchaseMethodsOptionsFromQuoteItems,
    resetSelectedOptions: resetSelectedOptions,
    resetSelectedIncentiveRebates: resetSelectedIncentiveRebates,
    selectKMPlan: selectKMPlan,
    selectOptionsResolution: selectOptionsResolution,
    selectPaymentFrequency: selectPaymentFrequency,
    selectPurchaseMethod: selectPurchaseMethod,
    selectTerm: selectTerm,
    setBestPaymentFinance: setBestPaymentFinance,
    setCashDown: setCashDown,
    setDeliveryFee: setDeliveryFee,
    setDeposit: setDeposit,
    setExteriorColourAmounts: setExteriorColourAmounts,
    setInteriorColourAmounts: setInteriorColourAmounts,
    setLien: setLien,
    setOptionsAmounts: setOptionsAmounts,
    setSelectedFinanceBestPaymentTerm: setSelectedFinanceBestPaymentTerm,
    setTargetPayment: setTargetPayment,
    setTaxesIncluded: setTaxesIncluded,
    setTradeIn: setTradeIn,
    splitRetailAndIncludedOptions: splitRetailAndIncludedOptions
};

/***/ }),

/***/ "./src/PurchaseMethods/services/TermService/TermService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetTermFromOriginData = resetTermFromOriginData;
exports.recalculateTermPayment = recalculateTermPayment;

var _lodash = __webpack_require__("lodash");

var _dataOrigins = __webpack_require__("./src/constants/dataOrigins.js");

var DataOrigins = _interopRequireWildcard(_dataOrigins);

var _dataConversions = __webpack_require__("./src/PurchaseMethods/constants/dataConversions.js");

var _paymentFrequencies = __webpack_require__("./src/PurchaseMethods/constants/paymentFrequencies.js");

var _TermModel = __webpack_require__("./src/PurchaseMethods/models/TermModel.js");

var _TermModel2 = _interopRequireDefault(_TermModel);

var _PaymentFrequencyService = __webpack_require__("./src/PurchaseMethods/services/PaymentFrequencyService/PaymentFrequencyService.js");

var PaymentFrequencyService = _interopRequireWildcard(_PaymentFrequencyService);

var _CashPurchaseService = __webpack_require__("./src/PurchaseMethods/services/CashPurchaseService/CashPurchaseService.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function resetTermFromCollectionData(collectionTermData, termIndex) {
    var term = collectionTermData.term,
        apr = collectionTermData.apr,
        frequenciesPayments = collectionTermData.frequenciesPayments,
        cashDown = collectionTermData.cashDown,
        discount = collectionTermData.discount,
        rebate = collectionTermData.rebate,
        rebateTaxes = collectionTermData.rebateTaxes,
        rebateAtDelivery = collectionTermData.rebateAtDelivery,
        rebateAtStandardRate = collectionTermData.rebateAtStandardRate,
        rebates = collectionTermData.rebates,
        financedAmount = collectionTermData.financedAmount,
        financedAmountWithTaxes = collectionTermData.financedAmountWithTaxes,
        residualAmount = collectionTermData.residualAmount;


    var paymentFrequencies = {};
    var defaultFrequency = void 0;
    (0, _lodash.forEach)(frequenciesPayments, function (frequency) {
        var paymentFrequency = PaymentFrequencyService.resetPaymentFrequencyFromCollectionData(frequency, cashDown);
        paymentFrequencies[paymentFrequency.paymentFrequency] = paymentFrequency;
        defaultFrequency = paymentFrequency.paymentFrequency;
    });

    if (paymentFrequencies[_paymentFrequencies.WEEKLY]) {
        defaultFrequency = _paymentFrequencies.WEEKLY;
    }

    var rebatesDetailsData = (0, _lodash.isEmpty)(rebates) ? [] : rebates;
    var rebatesDetails = (0, _CashPurchaseService.getRebatesDetailsFromData)(rebatesDetailsData);

    var financedAmountAdjustment = cashDown ? Math.round(cashDown * 100) / 100 * -1 : 0;

    return new _TermModel2.default({
        term: term,
        termIndex: termIndex,
        apr: apr,
        residualRate: 0,
        cashDown: cashDown,
        discounts: discount || 0,
        rebates: rebate,
        rebatesTaxes: rebateTaxes || 0,
        rebatesAtDelivery: rebateAtDelivery,
        rebatesAtStandardRate: rebateAtStandardRate || 0,
        paymentFrequencies: paymentFrequencies,
        paymentFrequency: defaultFrequency,
        payment: paymentFrequencies[defaultFrequency].payment,
        paymentTaxes: paymentFrequencies[defaultFrequency].paymentTaxes,
        financedAmount: financedAmount,
        financedAmountWithTaxes: financedAmountWithTaxes,
        financedAmountAdjustment: financedAmountAdjustment,
        financedAmountWithTaxesAdjustment: financedAmountAdjustment,
        residualAmount: residualAmount,
        cashDownPaymentAdjustment: paymentFrequencies[defaultFrequency].cashDownPaymentAdjustment,
        netTradeInPaymentAdjustment: paymentFrequencies[defaultFrequency].netTradeInPaymentAdjustment,
        netTradeInPaymentTaxesAdjustment: paymentFrequencies[defaultFrequency].netTradeInPaymentTaxesAdjustment,
        calculatedNetPayment: paymentFrequencies[defaultFrequency].calculatedNetPayment,
        calculatedPayment: paymentFrequencies[defaultFrequency].calculatedPayment,
        rebatesDetails: rebatesDetails
    });
}

function resetTermFromCalculatorData(calculatorTermData, termIndex) {
    var term = calculatorTermData.term,
        apr = calculatorTermData.apr,
        frequencies = calculatorTermData.frequencies,
        financedAmount = calculatorTermData.financedAmount,
        financedAmountWithTaxes = calculatorTermData.financedAmountWithTaxes,
        residualAmount = calculatorTermData.residualAmount;


    var paymentFrequencies = {};
    var cashDown = 0;
    (0, _lodash.forEach)(frequencies, function (frequency) {
        if (cashDown < frequency.cashDown) {
            cashDown = frequency.cashDown;
        }
    });

    var defaultFrequency = void 0;
    (0, _lodash.forEach)(frequencies, function (frequency) {
        var paymentFrequency = PaymentFrequencyService.resetPaymentFrequencyFromCalculatorData(frequency, cashDown);
        paymentFrequencies[paymentFrequency.paymentFrequency] = paymentFrequency;
        defaultFrequency = paymentFrequency.paymentFrequency;
    });

    if (paymentFrequencies[_paymentFrequencies.WEEKLY]) {
        defaultFrequency = _paymentFrequencies.WEEKLY;
    }

    var financedAmountAdjustment = cashDown ? Math.round(cashDown * 100) / 100 * -1 : 0;

    return new _TermModel2.default({
        term: term,
        termIndex: termIndex,
        apr: apr,
        residualRate: 0,
        cashDown: cashDown,
        discounts: 0,
        rebates: 0,
        rebatesTaxes: 0,
        rebatesAtDelivery: 0,
        rebatesTaxesAtDelivery: 0,
        rebatesAtStandardRate: 0,
        paymentFrequencies: paymentFrequencies,
        paymentFrequency: defaultFrequency,
        payment: paymentFrequencies[defaultFrequency].payment,
        paymentTaxes: paymentFrequencies[defaultFrequency].paymentTaxes,
        financedAmount: financedAmount,
        financedAmountWithTaxes: financedAmountWithTaxes,
        financedAmountAdjustment: financedAmountAdjustment,
        financedAmountWithTaxesAdjustment: financedAmountAdjustment,
        residualAmount: residualAmount,
        cashDownPaymentAdjustment: paymentFrequencies[defaultFrequency].cashDownPaymentAdjustment,
        netTradeInPaymentAdjustment: paymentFrequencies[defaultFrequency].netTradeInPaymentAdjustment,
        netTradeInPaymentTaxesAdjustment: paymentFrequencies[defaultFrequency].netTradeInPaymentTaxesAdjustment,
        calculatedNetPayment: paymentFrequencies[defaultFrequency].calculatedNetPayment,
        calculatedPayment: paymentFrequencies[defaultFrequency].calculatedPayment
    });
}

function resetTermFromModelData(modelTermData, termIndex) {
    if (modelTermData.length <= _dataConversions.MODEL_TERM.PAYMENT_FREQUENCIES) {
        return new _TermModel2.default();
    }

    var paymentFrequencies = {};
    var defaultFrequency = void 0;
    (0, _lodash.forEach)(modelTermData[_dataConversions.MODEL_TERM.PAYMENT_FREQUENCIES], function (frequency) {
        var paymentFrequency = PaymentFrequencyService.resetPaymentFrequencyFromModelData(frequency, modelTermData[_dataConversions.MODEL_TERM.CASH_DOWN]);
        paymentFrequencies[paymentFrequency.paymentFrequency] = paymentFrequency;
        defaultFrequency = paymentFrequency.paymentFrequency;
    });

    if (paymentFrequencies[_paymentFrequencies.WEEKLY]) {
        defaultFrequency = _paymentFrequencies.WEEKLY;
    }

    var rebatesDetailsData = (0, _lodash.isEmpty)(modelTermData[_dataConversions.MODEL_TERM.REBATES_DETAILS]) ? [] : modelTermData[_dataConversions.MODEL_TERM.REBATES_DETAILS];
    var rebatesDetails = (0, _CashPurchaseService.getRebatesDetailsFromData)(rebatesDetailsData);

    var includedItemsCodes = modelTermData[_dataConversions.MODEL_TERM.INCLUDED_CODES] || [];

    var cashDown = modelTermData[_dataConversions.MODEL_TERM.CASH_DOWN];
    var financedAmountAdjustment = cashDown ? Math.round(cashDown * 100) / 100 * -1 : 0;

    return new _TermModel2.default({
        term: modelTermData[_dataConversions.MODEL_TERM.TERM],
        termIndex: termIndex,
        apr: modelTermData[_dataConversions.MODEL_TERM.APR],
        residualRate: modelTermData[_dataConversions.MODEL_TERM.RESIDUAL_RATE],
        cashDown: cashDown,
        discounts: modelTermData[_dataConversions.MODEL_TERM.DISCOUNT],
        rebates: modelTermData[_dataConversions.MODEL_TERM.REBATE],
        rebatesTaxes: modelTermData[_dataConversions.MODEL_TERM.REBATE_TAXES] || 0,
        rebatesAtDelivery: modelTermData[_dataConversions.MODEL_TERM.REBATE_AT_DELIVERY],
        rebatesTaxesAtDelivery: modelTermData[_dataConversions.MODEL_TERM.REBATE_TAXES_AT_DELIVERY] || 0,
        rebatesAtStandardRate: modelTermData[_dataConversions.MODEL_TERM.REBATE_AT_STANDARD_RATE] || 0,
        paymentFrequencies: paymentFrequencies,
        paymentFrequency: defaultFrequency,
        payment: paymentFrequencies[defaultFrequency].payment,
        paymentTaxes: paymentFrequencies[defaultFrequency].paymentTaxes,
        financedAmount: modelTermData[_dataConversions.MODEL_TERM.FINANCED_AMOUNT],
        financedAmountWithTaxes: modelTermData[_dataConversions.MODEL_TERM.FINANCED_AMOUNT_WITH_TAXES],
        financedAmountAdjustment: financedAmountAdjustment,
        financedAmountWithTaxesAdjustment: financedAmountAdjustment,
        residualAmount: modelTermData[_dataConversions.MODEL_TERM.RESIDUAL_AMOUNT],
        cashDownPaymentAdjustment: paymentFrequencies[defaultFrequency].cashDownPaymentAdjustment,
        netTradeInPaymentAdjustment: paymentFrequencies[defaultFrequency].netTradeInPaymentAdjustment,
        netTradeInPaymentTaxesAdjustment: paymentFrequencies[defaultFrequency].netTradeInPaymentTaxesAdjustment,
        calculatedNetPayment: paymentFrequencies[defaultFrequency].calculatedNetPayment,
        calculatedPayment: paymentFrequencies[defaultFrequency].calculatedPayment,
        includedItemsCodes: includedItemsCodes,
        rebatesDetails: rebatesDetails
    });
}

function resetTermFromOriginData(dataOrigin, originTermData, termIndex) {
    if ((0, _lodash.isEmpty)(originTermData) || !(0, _lodash.isObjectLike)(originTermData)) {
        return new _TermModel2.default();
    }

    switch (dataOrigin) {
        case DataOrigins.MODELS_COLLECTION:
            return resetTermFromCollectionData(originTermData, termIndex);

        case DataOrigins.PAYMENT_CALCULATOR:
            return resetTermFromCalculatorData(originTermData, termIndex);

        case DataOrigins.MODEL_YEAR_POWERS_TRIMS:
            return resetTermFromModelData(originTermData, termIndex);

        default:
            return new _TermModel2.default();
    }
}

function recalculateTermPayment(term, paymentCalculationParameters) {
    if (term.get('term') === 0 || !(0, _lodash.isObjectLike)(paymentCalculationParameters)) {
        return term;
    }

    var paymentFrequency = paymentCalculationParameters.paymentFrequency,
        taxesIncluded = paymentCalculationParameters.taxesIncluded,
        taxesFactor = paymentCalculationParameters.taxesFactor,
        cashDown = paymentCalculationParameters.cashDown,
        tradeIn = paymentCalculationParameters.tradeIn,
        lien = paymentCalculationParameters.lien,
        exteriorColourRetail = paymentCalculationParameters.exteriorColourRetail,
        exteriorColourResidualRetail = paymentCalculationParameters.exteriorColourResidualRetail,
        interiorColourRetail = paymentCalculationParameters.interiorColourRetail,
        interiorColourResidualRetail = paymentCalculationParameters.interiorColourResidualRetail,
        optionsTotalRetail = paymentCalculationParameters.optionsTotalRetail,
        optionsTotalResidualRetail = paymentCalculationParameters.optionsTotalResidualRetail;


    var paymentFrequencies = term.get('paymentFrequencies');
    var currentPaymentFrequency = paymentFrequencies[paymentFrequency];
    if (!currentPaymentFrequency) {
        return term;
    }
    var payment = currentPaymentFrequency.payment;
    var paymentTaxes = currentPaymentFrequency.paymentTaxes;

    // This variable is used as a multiplier for taxes calculations
    var taxesIncludedFactor = taxesIncluded ? 1 : 0;

    var newTerm = term.set('paymentFrequency', currentPaymentFrequency.paymentFrequency);

    var optionsResidualRetail = exteriorColourResidualRetail + interiorColourResidualRetail + optionsTotalResidualRetail;
    var optionsPaymentAdjustment = newTerm.calculatePaymentAdjustment(exteriorColourRetail + interiorColourRetail + optionsTotalRetail, optionsResidualRetail);
    var optionsPaymentTaxesAdjustment = optionsPaymentAdjustment * taxesFactor;

    var netTradeInPaymentAdjustment = newTerm.calculatePaymentAdjustment(tradeIn - lien, 0);
    if (netTradeInPaymentAdjustment > payment + optionsPaymentAdjustment) {
        netTradeInPaymentAdjustment = payment + optionsPaymentAdjustment;
    }

    var netTradeInPaymentTaxesAdjustment = newTerm.calculatePaymentAdjustment(tradeIn * taxesFactor, 0);
    if (netTradeInPaymentTaxesAdjustment > paymentTaxes + optionsPaymentTaxesAdjustment) {
        netTradeInPaymentTaxesAdjustment = paymentTaxes + optionsPaymentTaxesAdjustment;
    }

    var calculatedNetPayment = payment + optionsPaymentAdjustment - netTradeInPaymentAdjustment + (paymentTaxes + optionsPaymentTaxesAdjustment - netTradeInPaymentTaxesAdjustment) * taxesIncludedFactor;

    var cashDownPaymentAdjustment = newTerm.calculatePaymentAdjustment(cashDown, 0);
    if (cashDownPaymentAdjustment > calculatedNetPayment) {
        cashDownPaymentAdjustment = calculatedNetPayment;
    }

    var financedAmountAdjustment = exteriorColourRetail + interiorColourRetail + optionsTotalRetail - (tradeIn - lien) - cashDown;
    var financedAmountWithTxAdjustment = financedAmountAdjustment + (exteriorColourRetail + interiorColourRetail + optionsTotalRetail - tradeIn) * taxesFactor;

    var calculatedPayment = calculatedNetPayment - cashDownPaymentAdjustment;

    return newTerm.set('cashDown', cashDown).set('payment', payment).set('paymentTaxes', paymentTaxes).set('optionsResidualRetail', optionsResidualRetail).set('optionsPaymentAdjustment', optionsPaymentAdjustment).set('optionsPaymentTaxesAdjustment', optionsPaymentTaxesAdjustment).set('netTradeInPaymentAdjustment', netTradeInPaymentAdjustment).set('netTradeInPaymentTaxesAdjustment', netTradeInPaymentTaxesAdjustment).set('calculatedNetPayment', calculatedNetPayment).set('cashDownPaymentAdjustment', cashDownPaymentAdjustment).set('calculatedPayment', calculatedPayment).set('financedAmountAdjustment', financedAmountAdjustment).set('financedAmountWithTaxesAdjustment', financedAmountWithTxAdjustment);
}

exports.default = {
    resetTermFromCollectionData: resetTermFromCollectionData,
    resetTermFromCalculatorData: resetTermFromCalculatorData,
    resetTermFromModelData: resetTermFromModelData,
    resetTermFromOriginData: resetTermFromOriginData,
    recalculateTermPayment: recalculateTermPayment
};

/***/ }),

/***/ "./src/Quote/actions/quoteActionTypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var SET_QUOTE = exports.SET_QUOTE = 'SET_QUOTE';
var SET_QUOTE_MODIFIED = exports.SET_QUOTE_MODIFIED = 'SET_QUOTE_MODIFIED';
var SET_QUOTE_REVISION = exports.SET_QUOTE_REVISION = 'SET_QUOTE_REVISION';
var SET_QUOTE_VEHICLE = exports.SET_QUOTE_VEHICLE = 'SET_QUOTE_VEHICLE';
var SET_QUOTE_MODEL_YEAR = exports.SET_QUOTE_MODEL_YEAR = 'SET_QUOTE_MODEL_YEAR';
var SET_LEAD_TYPE = exports.SET_LEAD_TYPE = 'SET_LEAD_TYPE';
var SET_STATUS = exports.SET_STATUS = 'SET_STATUS';
var SET_SECURITY_TOKEN = exports.SET_SECURITY_TOKEN = 'SET_SECURITY_TOKEN';
var SET_QUOTE_PURCHASE_METHODS = exports.SET_QUOTE_PURCHASE_METHODS = 'SET_QUOTE_PURCHASE_METHODS';

exports.default = {
    SET_QUOTE: SET_QUOTE,
    SET_QUOTE_MODIFIED: SET_QUOTE_MODIFIED,
    SET_QUOTE_REVISION: SET_QUOTE_REVISION,
    SET_QUOTE_VEHICLE: SET_QUOTE_VEHICLE,
    SET_QUOTE_MODEL_YEAR: SET_QUOTE_MODEL_YEAR,
    SET_LEAD_TYPE: SET_LEAD_TYPE,
    SET_STATUS: SET_STATUS,
    SET_SECURITY_TOKEN: SET_SECURITY_TOKEN,
    SET_QUOTE_PURCHASE_METHODS: SET_QUOTE_PURCHASE_METHODS
};

/***/ }),

/***/ "./src/Quote/actions/quoteActions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setQuote = setQuote;
exports.setQuoteModified = setQuoteModified;
exports.setQuoteRevision = setQuoteRevision;
exports.setQuoteVehicle = setQuoteVehicle;
exports.setQuoteModelYear = setQuoteModelYear;
exports.setQuoteLeadType = setQuoteLeadType;
exports.setQuoteStatus = setQuoteStatus;
exports.setQuoteSecurityToken = setQuoteSecurityToken;
exports.setQuotePurchaseMethods = setQuotePurchaseMethods;

var _lodash = __webpack_require__("lodash");

var _quoteActionTypes = __webpack_require__("./src/Quote/actions/quoteActionTypes.js");

var _quoteActionTypes2 = _interopRequireDefault(_quoteActionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setQuote(quote) {
    return { type: _quoteActionTypes2.default.SET_QUOTE, quote: quote };
}

function setQuoteModified() {
    return { type: _quoteActionTypes2.default.SET_QUOTE_MODIFIED };
}

function setQuoteRevision(quoteRevisions) {
    return function (dispatch, getState) {
        var state = getState();
        if (state.quote && state.quote.id && !(0, _lodash.isEmpty)(quoteRevisions)) {
            var currentQuoteRevision = (0, _lodash.find)(quoteRevisions, function (quoteRevision) {
                return quoteRevision.id === state.quote.id;
            });

            if (currentQuoteRevision) {
                // eslint-disable no-underscore-dangle
                var revision = currentQuoteRevision.__revision;
                dispatch({ type: _quoteActionTypes2.default.SET_QUOTE_REVISION, revision: revision });
            }
        }
    };
}

function setQuoteVehicle(vehicle) {
    return { type: _quoteActionTypes2.default.SET_QUOTE_VEHICLE, vehicle: vehicle };
}

function setQuoteModelYear(modelYear) {
    return { type: _quoteActionTypes2.default.SET_QUOTE_MODEL_YEAR, modelYear: modelYear };
}

function setQuoteLeadType(leadType) {
    return { type: _quoteActionTypes2.default.SET_LEAD_TYPE, leadType: leadType };
}

function setQuoteStatus(status) {
    return { type: _quoteActionTypes2.default.SET_STATUS, status: status };
}

function setQuoteSecurityToken(securityToken) {
    return { type: _quoteActionTypes2.default.SET_SECURITY_TOKEN, securityToken: securityToken };
}

function setQuotePurchaseMethods(purchaseMethods) {
    return { type: _quoteActionTypes2.default.SET_QUOTE_PURCHASE_METHODS, purchaseMethods: purchaseMethods };
}

exports.default = {
    setQuote: setQuote,
    setQuoteModified: setQuoteModified,
    setQuoteRevision: setQuoteRevision,
    setQuoteVehicle: setQuoteVehicle,
    setQuoteModelYear: setQuoteModelYear,
    setQuoteLeadType: setQuoteLeadType,
    setQuoteStatus: setQuoteStatus,
    setQuoteSecurityToken: setQuoteSecurityToken,
    setQuotePurchaseMethods: setQuotePurchaseMethods
};

/***/ }),

/***/ "./src/Quote/components/AddToGarage/AddToGarageButton.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _widgetCommonsLeads = __webpack_require__("../widget-commons-leads/src/index.js");

var _QuoteModel = __webpack_require__("./src/Quote/models/QuoteModel.js");

var _QuoteModel2 = _interopRequireDefault(_QuoteModel);

var _VehicleService = __webpack_require__("./src/Vehicle/services/VehicleService/VehicleService.js");

var _VehicleService2 = _interopRequireDefault(_VehicleService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddToGarageButton = function (_React$Component) {
    _inherits(AddToGarageButton, _React$Component);

    function AddToGarageButton(props) {
        _classCallCheck(this, AddToGarageButton);

        var _this = _possibleConstructorReturn(this, (AddToGarageButton.__proto__ || Object.getPrototypeOf(AddToGarageButton)).call(this, props));

        _this.onClick = _this.onClick.bind(_this);
        _this.saveToGarage = _this.saveToGarage.bind(_this);
        _this.addToGarageLeadUpdate = _this.addToGarageLeadUpdate.bind(_this);
        return _this;
    }

    _createClass(AddToGarageButton, [{
        key: 'onClick',
        value: function onClick() {
            var quote = this.props.quote;


            if (quote.vehicle) {
                _widgetCommonsGeneral.AnalyticsService.gaTrigger(_VehicleService2.default.isVehicleNew(quote.vehicle) ? _widgetCommonsGeneral.TRACKING_TAGS.ADD_TO_GARAGE_CTA_NEW(quote.vehicle.model) : _widgetCommonsGeneral.TRACKING_TAGS.ADD_TO_GARAGE_CTA_USED(quote.vehicle.model));
            }

            if (!_widgetCommonsGeneral.AccountService.isAuthenticated()) {
                var LoginModal = _widgetCommonsGeneral.ModalService.get('login/SignUpModal');
                LoginModal.addCallbacks({
                    onClose: this.saveToGarage
                });
                LoginModal.open({ quote: quote });
            } else {
                this.saveToGarage(false);
            }
        }
    }, {
        key: 'addToGarageLeadUpdate',
        value: function addToGarageLeadUpdate(quote) {
            return new _widgetCommonsLeads.LeadSubmissionBuilder().addLeadType(_widgetCommonsLeads.LEAD_TYPES.ACCOUNT_CREATION).addQuote(quote).submit();
        }
    }, {
        key: 'saveToGarage',
        value: function saveToGarage() {
            var withAuthentication = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            var quote = this.props.quote;

            if (_widgetCommonsGeneral.AccountService.isAuthenticated()) {
                if (!withAuthentication && quote.vehicle && !_VehicleService2.default.isVehicleNew(quote.vehicle)) {
                    this.addToGarageLeadUpdate(quote);
                }
                this.props.onClick(withAuthentication);
            }
            return true;
        }
    }, {
        key: 'render',
        value: function render() {
            var quote = this.props.quote;

            var isQuoteInGarage = quote.isQuoteInGarage();
            var garageTitle = isQuoteInGarage ? _widgetCommonsCoreServices.LocaleService.t('QUOTE.BTN_APPLY_QUOTE_CHANGES') : _widgetCommonsCoreServices.LocaleService.t('QUOTE.BTN_ADD_TO_GARAGE');
            var garageButtonClasses = ['widget-vehicle-quote-btn-secondary', 'sr-button-outline-2'];
            var showButton = quote.isDirty() || !isQuoteInGarage;

            if (this.props.buttonClass) {
                garageButtonClasses.push(this.props.buttonClass);
            }
            if (quote.isDirty()) {
                garageButtonClasses.push('is-modify');
            }

            return showButton && _react2.default.createElement(
                'button',
                {
                    className: garageButtonClasses.join(' '),
                    onClick: this.onClick,
                    title: garageTitle,
                    type: 'button'
                },
                _react2.default.createElement('icon', { className: 'icon-Mon-Garage' }),
                _react2.default.createElement(
                    'span',
                    null,
                    garageTitle
                )
            );
        }
    }]);

    return AddToGarageButton;
}(_react2.default.Component);

AddToGarageButton.defaultProps = {
    buttonClass: ''
};

AddToGarageButton.propTypes = {
    buttonClass: _propTypes2.default.string,
    onClick: _propTypes2.default.func.isRequired,
    quote: _propTypes2.default.instanceOf(_QuoteModel2.default).isRequired
};

AddToGarageButton.displayName = 'AddToGarageButton';

exports.default = AddToGarageButton;

/***/ }),

/***/ "./src/Quote/components/AddToGarageV25/AddToGarageV25.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _widgetCommonsLeads = __webpack_require__("../widget-commons-leads/src/index.js");

var _QuoteService = __webpack_require__("./src/Quote/services/QuoteService/QuoteService.js");

var _QuoteService2 = _interopRequireDefault(_QuoteService);

var _ShowroomService = __webpack_require__("./src/services/ShowroomService/ShowroomService.js");

var _ShowroomService2 = _interopRequireDefault(_ShowroomService);

var _VehicleService = __webpack_require__("./src/Vehicle/services/VehicleService/VehicleService.js");

var _VehicleService2 = _interopRequireDefault(_VehicleService);

var _errorCodes = __webpack_require__("../widget-build-and-quote/src/constants/errorCodes.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// SHOWROOM V2.5
var AddToGarageV25 = function () {
    function AddToGarageV25() {
        _classCallCheck(this, AddToGarageV25);

        this.quote = null;

        this.onClick = this.onClick.bind(this);
        this.loadQuote = this.loadQuote.bind(this);
        this.addToGarageLeadUpdate = this.addToGarageLeadUpdate.bind(this);
        this.saveToGarage = this.saveToGarage.bind(this);
        this.setQuoteLead = this.setQuoteLead.bind(this);
        this.isQuoteInGarage = this.isQuoteInGarage.bind(this);
        this.LoginModal = _widgetCommonsGeneral.ModalService.get('login/SignUpModal');
        this.LoginModal.addCallbacks({
            onClose: this.saveToGarage
        });
    }

    _createClass(AddToGarageV25, [{
        key: 'onClick',
        value: function onClick(quoteId) {
            var _this = this;

            if (!quoteId) return;

            _ShowroomService2.default.loadQuoteV25(quoteId).then(function (quote) {
                _this.quote = quote;

                var mappingQuote = quote;

                if (mappingQuote.vehicle) {
                    _widgetCommonsGeneral.AnalyticsService.gaTrigger(_VehicleService2.default.isVehicleNew(mappingQuote.vehicle) ? _widgetCommonsGeneral.TRACKING_TAGS.ADD_TO_GARAGE_CTA_NEW(mappingQuote.vehicle.model) : _widgetCommonsGeneral.TRACKING_TAGS.ADD_TO_GARAGE_CTA_USED(mappingQuote.vehicle.model));
                }

                if (!_widgetCommonsGeneral.AccountService.isAuthenticated()) {
                    _this.LoginModal.open({ mappingQuote: mappingQuote });
                } else {
                    _this.saveToGarage(false);
                }
            }).catch(function (error) {
                throw error;
            });
        }
    }, {
        key: 'setQuoteLead',
        value: function setQuoteLead(leadType) {
            var _this2 = this;

            var location = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitLocation().toLowerCase();

            var mappingQuote = _QuoteService2.default.resetQuoteFromVehicle(this.quote, location, leadType, this.quote.vehicle);

            if (_widgetCommonsGeneral.AccountService.isAuthenticated()) {
                return _ShowroomService2.default.saveQuote(mappingQuote.getShowroomQuote()).then(function (showroomQuote) {
                    var mappedQuote = _QuoteService2.default.resetQuoteFromShowroomSave(mappingQuote, showroomQuote);

                    _this2.quote = mappedQuote;

                    _this2.dispatchAddToGarage();

                    // TODO: Effectuer les modifications avec le nouveau systeme de lead unique lors de la futur migration (SHOWROOM-3618)
                    setTimeout(function () {
                        new _widgetCommonsLeads.LeadSubmissionBuilder().addLeadType(_widgetCommonsLeads.LEAD_TYPES.ACCOUNT_CREATION).addQuote(mappedQuote).submit();

                        _this2.dispatchVdp(mappedQuote.id);
                    }, 2000);
                }).catch(function (error) {
                    if (error && error.response && error.response.data && error.response.data.error === _errorCodes.BAD_QUOTE_REVISION) {
                        _this2.reloadAndSaveQuote(_this2.quote);
                    } else {
                        throw error;
                    }
                });
            }
            return true;
        }
    }, {
        key: 'loadQuote',
        value: function loadQuote(quoteId) {
            var _this3 = this;

            if (this.quote === null) {
                return _ShowroomService2.default.loadQuoteV25(quoteId).then(function (quote) {
                    _this3.quote = quote;
                }).catch(function (error) {
                    throw error;
                });
            }
            return null;
        }
    }, {
        key: 'dispatchAddToGarage',
        value: function dispatchAddToGarage() {
            var $window = _widgetCommonsCoreServices.WindowProxy.get();
            if ($window) {
                $window.document.dispatchEvent(new Event('sm360.widgets.garage.added'));
            }
        }
    }, {
        key: 'dispatchVdp',
        value: function dispatchVdp(quoteId) {
            var $window = _widgetCommonsCoreServices.WindowProxy.get();
            var event = new CustomEvent('add-to-garage:success', {
                bubbles: true,
                cancelable: false,
                detail: { quoteId: quoteId }
            });

            if ($window) {
                $window.document.dispatchEvent(event);
                window.location.href = this.quote.getVehicleRedirectionFromQuote();
            }
        }
    }, {
        key: 'reloadAndSaveQuote',
        value: function reloadAndSaveQuote(quote) {
            var _this4 = this;

            _ShowroomService2.default.loadQuote(quote.id).then(function (upToDateQuote) {
                var mergedQuote = quote.set('leadId', upToDateQuote.leadId).set('revision', upToDateQuote.revision);

                return _ShowroomService2.default.saveQuote(mergedQuote.getShowroomQuote()).then(function (showroomQuote) {
                    _this4.dispatchAddToGarage();
                    _this4.quote = showroomQuote;
                });
            });
        }
    }, {
        key: 'addToGarageLeadUpdate',
        value: function addToGarageLeadUpdate(quote) {
            // TODO: Effectuer les modifications avec le nouveau systeme de lead unique lors de la futur migration (SHOWROOM-3618)
            return new _widgetCommonsLeads.LeadSubmissionBuilder().addLeadType(_widgetCommonsLeads.LEAD_TYPES.ACCOUNT_CREATION).addQuote(quote).submit();
        }
    }, {
        key: 'saveToGarage',
        value: function saveToGarage() {
            var withAuthentication = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            var mappingQuote = this.quote;

            if (_widgetCommonsGeneral.AccountService.isAuthenticated()) {
                if (!withAuthentication && mappingQuote.vehicle && !_VehicleService2.default.isVehicleNew(mappingQuote.vehicle)) {
                    this.addToGarageLeadUpdate(mappingQuote);
                }
                this.setQuoteLead('SAVE_TO_GARAGE');
            }
            return true;
        }
    }, {
        key: 'isQuoteInGarage',
        value: function isQuoteInGarage(quoteId) {
            var response = false;
            if (!_widgetCommonsGeneral.AccountService.isAuthenticated()) return false;
            return _ShowroomService2.default.loadQuotes().then(function (res) {
                if (res) {
                    res.forEach(function (e) {
                        if (e.id === quoteId) response = true;
                    });
                }
                return response;
            });
        }
    }]);

    return AddToGarageV25;
}();

exports.default = AddToGarageV25;

/***/ }),

/***/ "./src/Quote/components/TransactionSummary/AccessoriesListing/AccessoriesListing.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _reactCollapse = __webpack_require__("../../node_modules/react-collapse/lib/index.js");

var _reactCollapse2 = _interopRequireDefault(_reactCollapse);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _index = __webpack_require__("./src/PurchaseMethods/index.js");

var _AmountLineItem = __webpack_require__("./src/Quote/components/TransactionSummary/AmountLineItem/AmountLineItem.jsx");

var _AmountLineItem2 = _interopRequireDefault(_AmountLineItem);

var _AmountLineItemWithIcon = __webpack_require__("./src/Quote/components/TransactionSummary/AmountLineItem/AmountLineItemWithIcon.jsx");

var _AmountLineItemWithIcon2 = _interopRequireDefault(_AmountLineItemWithIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AccessoriesListing = function (_React$Component) {
    _inherits(AccessoriesListing, _React$Component);

    function AccessoriesListing(props) {
        _classCallCheck(this, AccessoriesListing);

        var _this = _possibleConstructorReturn(this, (AccessoriesListing.__proto__ || Object.getPrototypeOf(AccessoriesListing)).call(this, props));

        _this.state = {
            showAccessoriesDetails: false
        };

        _this.showAccessoriesDetails = _this.showAccessoriesDetails.bind(_this);
        return _this;
    }

    _createClass(AccessoriesListing, [{
        key: 'showAccessoriesDetails',
        value: function showAccessoriesDetails() {
            this.setState(function (prevState) {
                return { showAccessoriesDetails: !prevState.showAccessoriesDetails };
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                accessoriesOptions = _props.accessoriesOptions,
                purchaseMethods = _props.purchaseMethods;

            var totalOptionsAmount = purchaseMethods.getOptionsAmount(accessoriesOptions);
            var accessoriesOptionsRenderBlock = accessoriesOptions.map(function (accessoryOption) {
                return _react2.default.createElement(_AmountLineItemWithIcon2.default, {
                    label: accessoryOption.description,
                    amount: accessoryOption.retail,
                    icon: 'plus'
                });
            });
            return _react2.default.createElement(
                'div',
                { className: 'SidebarSummary__accessoriesDetails' },
                _react2.default.createElement(
                    'div',
                    { className: 'SidebarSummary__groupTitle' },
                    _react2.default.createElement(
                        'h3',
                        { className: 'sr-title SidebarSummary__groupTitle--title' },
                        _widgetCommonsCoreServices.LocaleService.t('SUMMARY.SUMMARY_ACCESSORIES_TITLE'),
                        !this.state.showAccessoriesDetails && _react2.default.createElement(
                            'span',
                            { className: 'SidebarSummary__groupTitle--subtitle' },
                            _widgetCommonsCoreServices.LocaleService.t('SUMMARY.SELECTED_ACCESSORIES_AMOUNT', {
                                amount: accessoriesOptions.length
                            })
                        )
                    ),
                    accessoriesOptions.length > 0 && _react2.default.createElement(
                        'button',
                        { className: 'sr-link', onClick: this.showAccessoriesDetails },
                        !this.state.showAccessoriesDetails ? _widgetCommonsCoreServices.LocaleService.t('SUMMARY.SEE_DETAILS') : _widgetCommonsCoreServices.LocaleService.t('SUMMARY.CLOSE_DETAILS')
                    )
                ),
                _react2.default.createElement(
                    _reactCollapse2.default,
                    { isOpened: this.state.showAccessoriesDetails },
                    _react2.default.createElement(
                        'ul',
                        { className: 'protectionsListing' },
                        accessoriesOptionsRenderBlock
                    )
                ),
                _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.TOTAL'), amount: totalOptionsAmount })
            );
        }
    }]);

    return AccessoriesListing;
}(_react2.default.Component);

AccessoriesListing.defaultProps = {
    accessoriesOptions: []
};

AccessoriesListing.propTypes = {
    accessoriesOptions: _propTypes2.default.shape({
        name: _propTypes2.default.string.isRequired
    }),
    purchaseMethods: _propTypes2.default.instanceOf(_index.PurchaseMethodsModel)
};

AccessoriesListing.displayName = 'AccessoriesListing';

exports.default = AccessoriesListing;

/***/ }),

/***/ "./src/Quote/components/TransactionSummary/AmountLineItem/AmountLineItem.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _currencyFormats = __webpack_require__("./src/constants/currencyFormats.js");

var _currencyFormats2 = _interopRequireDefault(_currencyFormats);

__webpack_require__("./src/Quote/components/TransactionSummary/AmountLineItem/AmountLineItem.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AmountLineItem = function AmountLineItem(_ref) {
    var amount = _ref.amount,
        label = _ref.label,
        showZero = _ref.showZero;

    return amount !== 0 || showZero ? _react2.default.createElement(
        'li',
        { className: 'SidebarSummary__listingAmount--item sr-text-regular amountLineItem' },
        _react2.default.createElement(
            'span',
            { className: 'label' },
            label
        ),
        _react2.default.createElement(
            'span',
            { className: 'value' },
            _widgetCommonsCoreServices.LocaleService.l(amount, _currencyFormats2.default.CURRENCY_0)
        )
    ) : null;
};

AmountLineItem.defaultProps = {
    showZero: false
};

AmountLineItem.propTypes = {
    amount: _propTypes2.default.number.isRequired,
    label: _propTypes2.default.string.isRequired,
    showZero: _propTypes2.default.bool
};

AmountLineItem.displayName = 'AmountLineItem';

exports.default = AmountLineItem;

/***/ }),

/***/ "./src/Quote/components/TransactionSummary/AmountLineItem/AmountLineItem.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/Quote/components/TransactionSummary/AmountLineItem/AmountLineItemWithIcon.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _currencyFormats = __webpack_require__("./src/constants/currencyFormats.js");

var _currencyFormats2 = _interopRequireDefault(_currencyFormats);

__webpack_require__("./src/Quote/components/TransactionSummary/AmountLineItem/AmountLineItem.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AmountLineItemWithIcon = function AmountLineItemWithIcon(_ref) {
    var amount = _ref.amount,
        icon = _ref.icon,
        label = _ref.label;

    var iconClass = 'icon-' + icon;
    var iconElem = _react2.default.createElement('icon', { className: iconClass });

    return amount !== 0 ? _react2.default.createElement(
        'li',
        { className: 'amountLineItemWithIcon clearfix' },
        _react2.default.createElement(
            'span',
            { className: 'label' },
            iconElem,
            label
        ),
        _react2.default.createElement(
            'span',
            { className: 'value sr-text-bold' },
            _widgetCommonsCoreServices.LocaleService.l(amount, _currencyFormats2.default.CURRENCY_0)
        )
    ) : _react2.default.createElement(
        'li',
        { className: 'amountLineItemWithIcon clearfix' },
        _react2.default.createElement(
            'span',
            { className: 'label' },
            iconElem,
            label
        ),
        _react2.default.createElement(
            'span',
            { className: 'value sr-text-bold' },
            _widgetCommonsCoreServices.LocaleService.t('SUMMARY.PRICE_ON_DEMAND')
        )
    );
};

AmountLineItemWithIcon.propTypes = {
    icon: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string.isRequired,
    amount: _propTypes2.default.number.isRequired
};

AmountLineItemWithIcon.displayName = 'AmountLineItemWithIcon';

exports.default = AmountLineItemWithIcon;

/***/ }),

/***/ "./src/Quote/components/TransactionSummary/CashPurchase/CashPurchase.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _index = __webpack_require__("./src/PurchaseMethods/index.js");

var _AmountLineItem = __webpack_require__("./src/Quote/components/TransactionSummary/AmountLineItem/AmountLineItem.jsx");

var _AmountLineItem2 = _interopRequireDefault(_AmountLineItem);

var _AmountLineItemWithIcon = __webpack_require__("./src/Quote/components/TransactionSummary/AmountLineItem/AmountLineItemWithIcon.jsx");

var _AmountLineItemWithIcon2 = _interopRequireDefault(_AmountLineItemWithIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CashPurchase = function CashPurchase(_ref) {
    var purchaseMethods = _ref.purchaseMethods;

    var purchaseMethodAmounts = purchaseMethods.getSelectedPurchaseMethodAmounts();
    var purchaseMethodDeliveryAmounts = purchaseMethods.getSelectedPurchaseMethodDeliveryAmounts();
    var accessoriesOptionsPackages = purchaseMethods.getSelectedOptions();

    var cashDown = purchaseMethodAmounts.cashDown,
        discounts = purchaseMethodAmounts.discounts,
        exteriorColour = purchaseMethodAmounts.exteriorColour,
        freightPDI = purchaseMethodAmounts.freightPDI,
        interiorColour = purchaseMethodAmounts.interiorColour,
        lien = purchaseMethodAmounts.lien,
        modelTrim = purchaseMethodAmounts.modelTrim,
        options = purchaseMethodAmounts.options,
        otherFees = purchaseMethodAmounts.otherFees,
        protections = purchaseMethodAmounts.protections,
        rebates = purchaseMethodAmounts.rebates,
        taxAndDuty = purchaseMethodAmounts.taxAndDuty,
        taxes = purchaseMethodAmounts.taxes,
        tradeIn = purchaseMethodAmounts.tradeIn;


    var allInPrice = modelTrim + exteriorColour + interiorColour + options + freightPDI + otherFees + taxAndDuty + protections - discounts;

    var totalPriceBeforeTaxes = modelTrim + exteriorColour + interiorColour + options + freightPDI + otherFees + taxAndDuty + protections - (discounts + tradeIn);

    var totalPriceAfterTaxes = totalPriceBeforeTaxes + taxes + lien - (rebates + cashDown);

    var deliveryCashDown = purchaseMethodDeliveryAmounts.deliveryCashDown,
        deliveryFees = purchaseMethodDeliveryAmounts.deliveryFees,
        deliveryTaxes = purchaseMethodDeliveryAmounts.deliveryTaxes,
        deposit = purchaseMethodDeliveryAmounts.deposit,
        upfrontPayment = purchaseMethodDeliveryAmounts.upfrontPayment;


    var totalDueAtDelivery = totalPriceAfterTaxes + deliveryFees + deliveryTaxes + deposit;
    var protectionsWithIcons = accessoriesOptionsPackages.map(function (protectionPackage) {
        return _react2.default.createElement(_AmountLineItemWithIcon2.default, {
            label: protectionPackage.description,
            amount: protectionPackage.retail,
            icon: 'plus'
        });
    });

    return _react2.default.createElement(
        'div',
        { className: 'CashPurchaseSummary' },
        _react2.default.createElement(
            'div',
            { className: 'vehicle__salePrice' },
            _react2.default.createElement(_AmountLineItemWithIcon2.default, {
                label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.TOTAL_PRICE_BEFORE_TAXES'),
                amount: allInPrice - protections,
                icon: 'review'
            }),
            protectionsWithIcons
        ),
        _react2.default.createElement(
            'ul',
            { className: 'SidebarSummary__listingAmount' },
            _react2.default.createElement(
                'h3',
                { className: 'sr-title' },
                _widgetCommonsCoreServices.LocaleService.t('SUMMARY.TRANSACTION_TITLE_CASH_PURCHASE')
            ),
            _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.SELLING_PRICE'), amount: modelTrim }),
            _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.DISCOUNTS'), amount: discounts }),
            _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.EXTERIOR_COLOUR'), amount: exteriorColour }),
            _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.OPTIONS'), amount: interiorColour + options }),
            _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.FREIGHT_PDI'), amount: freightPDI }),
            _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.TAXES_AND_DUTIES'), amount: taxAndDuty }),
            _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.OTHER_FEES'), amount: otherFees }),
            _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.PROTECTIONS'), amount: protections }),
            _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.TRADE_IN'), amount: tradeIn }),
            _react2.default.createElement(_AmountLineItem2.default, {
                label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.TOTAL_PRICE_BEFORE_TAXES'),
                amount: totalPriceBeforeTaxes
            }),
            _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.TAXES'), amount: taxes }),
            _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.LIEN'), amount: lien }),
            _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.REBATES'), amount: rebates }),
            _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.CASHDOWN'), amount: cashDown }),
            _react2.default.createElement(_AmountLineItem2.default, {
                label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.TOTAL_PRICE_AFTER_TAXES'),
                amount: totalPriceAfterTaxes
            })
        ),
        _react2.default.createElement(
            'div',
            { className: 'deliver-infos' },
            _react2.default.createElement(
                'h3',
                { className: 'sr-title' },
                _widgetCommonsCoreServices.LocaleService.t('SUMMARY.SIDEBAR_DELIVERY_TITLE')
            ),
            _react2.default.createElement(
                'ul',
                { className: 'SidebarSummary__listingAmount' },
                _react2.default.createElement(_AmountLineItem2.default, {
                    label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.TOTAL_PRICE_AFTER_TAXES'),
                    amount: totalPriceAfterTaxes
                }),
                _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.OTHER_FEES'), amount: deliveryFees }),
                _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.CASHDOWN'), amount: deliveryCashDown }),
                _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.TAXES'), amount: deliveryTaxes }),
                _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.UPFRON_PAYMENT'), amount: upfrontPayment }),
                _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.DEPOSIT'), amount: deposit }),
                totalDueAtDelivery >= 0 ? _react2.default.createElement(_AmountLineItem2.default, {
                    label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.TOTAL_DUE_AT_DELIVERY'),
                    amount: totalDueAtDelivery,
                    showZero: true
                }) : _react2.default.createElement(_AmountLineItem2.default, {
                    label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.TOTAL_REFUND_AT_DELIVERY'),
                    amount: -1 * totalDueAtDelivery
                })
            )
        )
    );
};

CashPurchase.propTypes = {
    purchaseMethods: _propTypes2.default.instanceOf(_index.PurchaseMethodsModel).isRequired
};

CashPurchase.displayName = 'CashPurchase';

exports.default = CashPurchase;

/***/ }),

/***/ "./src/Quote/components/TransactionSummary/DeliveryDetails/DeliveryDetails.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _reactCollapse = __webpack_require__("../../node_modules/react-collapse/lib/index.js");

var _reactCollapse2 = _interopRequireDefault(_reactCollapse);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _AmountLineItem = __webpack_require__("./src/Quote/components/TransactionSummary/AmountLineItem/AmountLineItem.jsx");

var _AmountLineItem2 = _interopRequireDefault(_AmountLineItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var deliveryDetails = function (_React$Component) {
    _inherits(deliveryDetails, _React$Component);

    function deliveryDetails(props) {
        _classCallCheck(this, deliveryDetails);

        var _this = _possibleConstructorReturn(this, (deliveryDetails.__proto__ || Object.getPrototypeOf(deliveryDetails)).call(this, props));

        _this.state = {
            showDeliveryDetails: false
        };

        _this.showDeliveryDetails = _this.showDeliveryDetails.bind(_this);
        return _this;
    }

    _createClass(deliveryDetails, [{
        key: 'showDeliveryDetails',
        value: function showDeliveryDetails() {
            this.setState(function (prevState) {
                return { showDeliveryDetails: !prevState.showDeliveryDetails };
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props$purchaseMethod = this.props.purchaseMethodDeliveryAmounts,
                deliveryCashDown = _props$purchaseMethod.deliveryCashDown,
                deliveryFees = _props$purchaseMethod.deliveryFees,
                deliveryTaxes = _props$purchaseMethod.deliveryTaxes,
                deposit = _props$purchaseMethod.deposit,
                upfrontPayment = _props$purchaseMethod.upfrontPayment;


            var totalDueAtDelivery = deliveryCashDown + upfrontPayment + deliveryFees + deliveryTaxes + deposit;
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'SidebarSummary__groupTitle' },
                    _react2.default.createElement(
                        'h3',
                        { className: 'sr-title SidebarSummary__groupTitle--title' },
                        _widgetCommonsCoreServices.LocaleService.t('SUMMARY.SIDEBAR_DELIVERY_TITLE')
                    ),
                    _react2.default.createElement(
                        'button',
                        { className: 'sr-link', onClick: this.showDeliveryDetails },
                        !this.state.showDeliveryDetails ? _widgetCommonsCoreServices.LocaleService.t('SUMMARY.SEE_DETAILS') : _widgetCommonsCoreServices.LocaleService.t('SUMMARY.CLOSE_DETAILS')
                    )
                ),
                _react2.default.createElement(
                    _reactCollapse2.default,
                    { isOpened: this.state.showDeliveryDetails },
                    _react2.default.createElement(
                        'ul',
                        { className: 'SidebarSummary__listingAmount' },
                        _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.OTHER_FEES'), amount: deliveryFees }),
                        _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.CASHDOWN'), amount: deliveryCashDown }),
                        _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.TAXES'), amount: deliveryTaxes }),
                        _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.UPFRON_PAYMENT'), amount: upfrontPayment }),
                        _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.DEPOSIT'), amount: deposit }),
                        totalDueAtDelivery >= 0 ? _react2.default.createElement(_AmountLineItem2.default, {
                            label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.TOTAL_DUE_AT_DELIVERY'),
                            amount: totalDueAtDelivery,
                            showZero: true
                        }) : _react2.default.createElement(_AmountLineItem2.default, {
                            label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.TOTAL_REFUND_AT_DELIVERY'),
                            amount: -1 * totalDueAtDelivery
                        })
                    )
                )
            );
        }
    }]);

    return deliveryDetails;
}(_react2.default.Component);

deliveryDetails.defaultProps = {
    purchaseMethodDeliveryAmounts: []
};

deliveryDetails.propTypes = {
    purchaseMethodDeliveryAmounts: _propTypes2.default.shape({
        deliveryCashDown: _propTypes2.default.number.isRequired,
        deliveryFees: _propTypes2.default.number.isRequired,
        deliveryTaxes: _propTypes2.default.number.isRequired,
        deposit: _propTypes2.default.number.isRequired,
        upfrontPayment: _propTypes2.default.number.isRequired
    })
};

deliveryDetails.displayName = 'deliveryDetails';

exports.default = deliveryDetails;

/***/ }),

/***/ "./src/Quote/components/TransactionSummary/Finance/Finance.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _index = __webpack_require__("./src/PurchaseMethods/index.js");

var _AccessoriesListing = __webpack_require__("./src/Quote/components/TransactionSummary/AccessoriesListing/AccessoriesListing.jsx");

var _AccessoriesListing2 = _interopRequireDefault(_AccessoriesListing);

var _AmountLineItemWithIcon = __webpack_require__("./src/Quote/components/TransactionSummary/AmountLineItem/AmountLineItemWithIcon.jsx");

var _AmountLineItemWithIcon2 = _interopRequireDefault(_AmountLineItemWithIcon);

var _DeliveryDetails = __webpack_require__("./src/Quote/components/TransactionSummary/DeliveryDetails/DeliveryDetails.jsx");

var _DeliveryDetails2 = _interopRequireDefault(_DeliveryDetails);

var _FinanceListing = __webpack_require__("./src/Quote/components/TransactionSummary/FinanceListing/FinanceListing.jsx");

var _FinanceListing2 = _interopRequireDefault(_FinanceListing);

var _ProtectionsListing = __webpack_require__("./src/Quote/components/TransactionSummary/ProtectionsListing/ProtectionsListing.jsx");

var _ProtectionsListing2 = _interopRequireDefault(_ProtectionsListing);

__webpack_require__("./src/Quote/components/TransactionSummary/Finance/Finance.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Finance = function Finance(_ref) {
    var purchaseMethods = _ref.purchaseMethods;

    var purchaseMethodAmounts = purchaseMethods.getSelectedPurchaseMethodAmounts();
    var purchaseMethodDeliveryAmounts = purchaseMethods.getSelectedPurchaseMethodDeliveryAmounts();
    var selectedFinanceTerm = purchaseMethods.getSelectedFinanceTerm();
    var purchaseMethodLabels = purchaseMethods.getPurchaseMethodLabels(_widgetCommonsCoreServices.LocaleService);
    var paymentFrequencyLabels = purchaseMethods.getPaymentFrequencyLabels(false, _widgetCommonsCoreServices.LocaleService);
    var protectionsPackages = purchaseMethods.getSelectedProtectionsPackages();
    var accessoiresOptionsPackages = purchaseMethods.getSelectedOptions();

    var discounts = purchaseMethodAmounts.discounts,
        exteriorColour = purchaseMethodAmounts.exteriorColour,
        freightPDI = purchaseMethodAmounts.freightPDI,
        interiorColour = purchaseMethodAmounts.interiorColour,
        modelTrim = purchaseMethodAmounts.modelTrim,
        options = purchaseMethodAmounts.options,
        otherFees = purchaseMethodAmounts.otherFees,
        protections = purchaseMethodAmounts.protections,
        taxAndDuty = purchaseMethodAmounts.taxAndDuty;


    var allInPrice = modelTrim + exteriorColour + interiorColour + options + freightPDI + otherFees + taxAndDuty + protections - discounts;

    return _react2.default.createElement(
        'div',
        { className: 'FinanceSummary' },
        _react2.default.createElement(
            'div',
            { className: 'vehicle__salePrice' },
            _react2.default.createElement(_AmountLineItemWithIcon2.default, {
                label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.TOTAL_PRICE_BEFORE_TAXES'),
                amount: allInPrice - protections,
                icon: 'review'
            }),
            _react2.default.createElement(_ProtectionsListing2.default, {
                purchaseMethodLabels: purchaseMethodLabels,
                protectionsPackages: protectionsPackages,
                purchaseMethods: purchaseMethods
            })
        ),
        _react2.default.createElement(_AccessoriesListing2.default, { accessoriesOptions: accessoiresOptionsPackages, purchaseMethods: purchaseMethods }),
        _react2.default.createElement(_FinanceListing2.default, {
            selectedFinanceTerm: selectedFinanceTerm,
            paymentFrequencyLabels: paymentFrequencyLabels,
            purchaseMethodLabels: purchaseMethodLabels,
            purchaseMethodAmounts: purchaseMethodAmounts
        }),
        _react2.default.createElement(_DeliveryDetails2.default, { purchaseMethodDeliveryAmounts: purchaseMethodDeliveryAmounts })
    );
};

Finance.defaultProps = {};

Finance.propTypes = {
    purchaseMethods: _propTypes2.default.instanceOf(_index.PurchaseMethodsModel).isRequired
};

Finance.displayName = 'Finance';

exports.default = Finance;

/***/ }),

/***/ "./src/Quote/components/TransactionSummary/Finance/Finance.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/Quote/components/TransactionSummary/FinanceListing/FinanceListing.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _reactCollapse = __webpack_require__("../../node_modules/react-collapse/lib/index.js");

var _reactCollapse2 = _interopRequireDefault(_reactCollapse);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _index = __webpack_require__("./src/PurchaseMethods/index.js");

var _currencyFormats = __webpack_require__("./src/constants/currencyFormats.js");

var _currencyFormats2 = _interopRequireDefault(_currencyFormats);

var _AmountLineItem = __webpack_require__("./src/Quote/components/TransactionSummary/AmountLineItem/AmountLineItem.jsx");

var _AmountLineItem2 = _interopRequireDefault(_AmountLineItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FinanceListing = function (_React$Component) {
    _inherits(FinanceListing, _React$Component);

    function FinanceListing(props) {
        _classCallCheck(this, FinanceListing);

        var _this = _possibleConstructorReturn(this, (FinanceListing.__proto__ || Object.getPrototypeOf(FinanceListing)).call(this, props));

        _this.state = {
            showFinanceDetails: false
        };

        _this.showFinanceDetails = _this.showFinanceDetails.bind(_this);
        return _this;
    }

    _createClass(FinanceListing, [{
        key: 'showFinanceDetails',
        value: function showFinanceDetails() {
            this.setState(function (prevState) {
                return { showFinanceDetails: !prevState.showFinanceDetails };
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var frequency = this.props.paymentFrequencyLabels.periodically;

            var _props$selectedFinanc = this.props.selectedFinanceTerm.getCalculatedPayments(false),
                calculatedPayment = _props$selectedFinanc.calculatedPayment,
                calculatedPaymentBeforeTaxes = _props$selectedFinanc.calculatedPaymentBeforeTaxes,
                calculatedPaymentTaxes = _props$selectedFinanc.calculatedPaymentTaxes;

            var _props$purchaseMethod = this.props.purchaseMethodAmounts,
                cashDown = _props$purchaseMethod.cashDown,
                lien = _props$purchaseMethod.lien,
                rebates = _props$purchaseMethod.rebates,
                tradeIn = _props$purchaseMethod.tradeIn;


            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'ul',
                    { className: 'SidebarSummary__financialDetails' },
                    _react2.default.createElement(
                        'div',
                        { className: 'SidebarSummary__groupTitle' },
                        _react2.default.createElement(
                            'h3',
                            { className: 'sr-title SidebarSummary__groupTitle--title' },
                            _widgetCommonsCoreServices.LocaleService.t('SUMMARY.SUMMARY_FINANCE_TITLE', {
                                finance: this.props.purchaseMethodLabels.name
                            })
                        ),
                        _react2.default.createElement(
                            'button',
                            { className: 'sr-link', onClick: this.showFinanceDetails },
                            !this.state.showFinanceDetails ? _widgetCommonsCoreServices.LocaleService.t('SUMMARY.SEE_DETAILS') : _widgetCommonsCoreServices.LocaleService.t('SUMMARY.CLOSE_DETAILS')
                        )
                    ),
                    _react2.default.createElement(
                        _reactCollapse2.default,
                        { isOpened: this.state.showFinanceDetails },
                        _react2.default.createElement(
                            'li',
                            { className: 'SidebarSummary__financialDetails--item vehicle__terms sr-text-regular' },
                            _react2.default.createElement(
                                'span',
                                { className: 'label' },
                                _widgetCommonsCoreServices.LocaleService.t('SUMMARY.TERM'),
                                ' '
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'value' },
                                this.props.selectedFinanceTerm.term
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            { className: 'SidebarSummary__financialDetails--item vehicle__rate' },
                            _react2.default.createElement(
                                'span',
                                { className: 'label sr-text-bold' },
                                _widgetCommonsCoreServices.LocaleService.t('SUMMARY.APR'),
                                ' '
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'value sr-important-price' },
                                this.props.selectedFinanceTerm.apr,
                                '%'
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            { className: 'SidebarSummary__financialDetails--item vehicle__payments' },
                            _react2.default.createElement(
                                'span',
                                { className: 'label sr-text-bold' },
                                _widgetCommonsCoreServices.LocaleService.t('SUMMARY.PAYMENT'),
                                ' '
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'value sr-text-regular' },
                                _widgetCommonsCoreServices.LocaleService.l(calculatedPaymentBeforeTaxes, _currencyFormats2.default.CURRENCY_2)
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            { className: 'SidebarSummary__financialDetails--item vehicle__taxes sr-text-regular' },
                            _react2.default.createElement(
                                'span',
                                { className: 'label' },
                                _widgetCommonsCoreServices.LocaleService.t('SUMMARY.TAXES'),
                                ' '
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'value' },
                                _widgetCommonsCoreServices.LocaleService.l(calculatedPaymentTaxes, _currencyFormats2.default.CURRENCY_2)
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'li',
                        { className: 'SidebarSummary__financialDetails--item vehicle__totalPayment' },
                        _react2.default.createElement(
                            'span',
                            { className: 'label sr-text-bold' },
                            _widgetCommonsCoreServices.LocaleService.t('SUMMARY.PAYMENT_WITH_FREQUENCY', { frequency: frequency }),
                            ' ',
                            _react2.default.createElement('br', null)
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: 'value' },
                            _react2.default.createElement(
                                'span',
                                { className: 'sr-important-price' },
                                _widgetCommonsCoreServices.LocaleService.l(calculatedPayment, _currencyFormats2.default.CURRENCY_2)
                            ),
                            ' ',
                            _react2.default.createElement('br', null),
                            _react2.default.createElement(
                                'span',
                                { className: 'sr-text-thin' },
                                _widgetCommonsCoreServices.LocaleService.t('taxes.taxesIncluded')
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'ul',
                    { className: 'SidebarSummary__listingAmount' },
                    _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.TRADE_IN'), amount: tradeIn }),
                    _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.LIEN'), amount: lien }),
                    _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.REBATES'), amount: rebates }),
                    _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.CASHDOWN'), amount: cashDown })
                )
            );
        }
    }]);

    return FinanceListing;
}(_react2.default.Component);

FinanceListing.defaultProps = {
    paymentFrequencyLabels: [],
    purchaseMethodAmounts: [],
    purchaseMethodLabels: [],
    selectedFinanceTerm: []
};

FinanceListing.propTypes = {
    paymentFrequencyLabels: _propTypes2.default.shape({
        periodically: _propTypes2.default.string.isRequired
    }),
    purchaseMethodAmounts: _propTypes2.default.shape({
        cashDown: _propTypes2.default.number.isRequired,
        lien: _propTypes2.default.number.isRequired,
        rebates: _propTypes2.default.number.isRequired,
        tradeIn: _propTypes2.default.number.isRequired
    }),
    purchaseMethodLabels: _propTypes2.default.shape({
        name: _propTypes2.default.string.isRequired
    }),
    selectedFinanceTerm: _propTypes2.default.instanceOf(_index.TermModel)
};

FinanceListing.displayName = 'FinanceListing';

exports.default = FinanceListing;

/***/ }),

/***/ "./src/Quote/components/TransactionSummary/ProtectionsListing/ProtectionsListing.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _reactCollapse = __webpack_require__("../../node_modules/react-collapse/lib/index.js");

var _reactCollapse2 = _interopRequireDefault(_reactCollapse);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _index = __webpack_require__("./src/PurchaseMethods/index.js");

var _index2 = __webpack_require__("./src/ModelYear/index.js");

var _index3 = _interopRequireDefault(_index2);

var _AmountLineItem = __webpack_require__("./src/Quote/components/TransactionSummary/AmountLineItem/AmountLineItem.jsx");

var _AmountLineItem2 = _interopRequireDefault(_AmountLineItem);

var _AmountLineItemWithIcon = __webpack_require__("./src/Quote/components/TransactionSummary/AmountLineItem/AmountLineItemWithIcon.jsx");

var _AmountLineItemWithIcon2 = _interopRequireDefault(_AmountLineItemWithIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProtectionsListing = function (_React$Component) {
    _inherits(ProtectionsListing, _React$Component);

    function ProtectionsListing(props) {
        _classCallCheck(this, ProtectionsListing);

        var _this = _possibleConstructorReturn(this, (ProtectionsListing.__proto__ || Object.getPrototypeOf(ProtectionsListing)).call(this, props));

        _this.state = {
            showProtectionsDetails: false
        };

        _this.showProtectionsDetails = _this.showProtectionsDetails.bind(_this);
        return _this;
    }

    _createClass(ProtectionsListing, [{
        key: 'showProtectionsDetails',
        value: function showProtectionsDetails() {
            this.setState(function (prevState) {
                return { showProtectionsDetails: !prevState.showProtectionsDetails };
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                protectionsPackages = _props.protectionsPackages,
                purchaseMethodLabels = _props.purchaseMethodLabels,
                purchaseMethods = _props.purchaseMethods;

            var totalProtectionsAmount = purchaseMethods.getProtectionsAmount(protectionsPackages);
            var protectionsRenderBlock = protectionsPackages.map(function (protectionPackage) {
                var label = protectionPackage.label || protectionPackage.description;
                var description = protectionPackage.label && protectionPackage.description ? ' (' + protectionPackage.description + ')' : '';
                return _react2.default.createElement(_AmountLineItemWithIcon2.default, {
                    label: '' + label + description,
                    amount: protectionPackage.retail,
                    icon: 'plus'
                });
            });

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'SidebarSummary__groupTitle' },
                    _react2.default.createElement(
                        'h3',
                        { className: 'sr-title SidebarSummary__groupTitle--title' },
                        _widgetCommonsCoreServices.LocaleService.t('SUMMARY.SUMMARY_PROTECTIONS_TITLE', { finance: purchaseMethodLabels.name }),
                        !this.state.showProtectionsDetails && _react2.default.createElement(
                            'span',
                            { className: 'SidebarSummary__groupTitle--subtitle' },
                            _widgetCommonsCoreServices.LocaleService.t('SUMMARY.SELECTED_PROTECTIONS_AMOUNT', {
                                amount: protectionsPackages.length
                            })
                        )
                    ),
                    protectionsPackages.length > 0 && _react2.default.createElement(
                        'button',
                        { className: 'sr-link', onClick: this.showProtectionsDetails },
                        !this.state.showProtectionsDetails ? _widgetCommonsCoreServices.LocaleService.t('SUMMARY.SEE_DETAILS') : _widgetCommonsCoreServices.LocaleService.t('SUMMARY.CLOSE_DETAILS')
                    )
                ),
                _react2.default.createElement(
                    _reactCollapse2.default,
                    { isOpened: this.state.showProtectionsDetails },
                    _react2.default.createElement(
                        'ul',
                        { className: 'protectionsListing' },
                        protectionsRenderBlock
                    )
                ),
                _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.TOTAL'), amount: totalProtectionsAmount })
            );
        }
    }]);

    return ProtectionsListing;
}(_react2.default.Component);

ProtectionsListing.defaultProps = {
    purchaseMethodLabels: [],
    protectionsPackages: []
};

ProtectionsListing.propTypes = {
    purchaseMethodLabels: _propTypes2.default.shape({
        name: _propTypes2.default.string.isRequired
    }),
    purchaseMethods: _propTypes2.default.instanceOf(_index.PurchaseMethodsModel),
    protectionsPackages: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        items: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_index3.default.OptionModel)),
        itemsPackage: _propTypes2.default.instanceOf(_index3.default.OptionModel),
        payment: _propTypes2.default.number.isRequired,
        paymentTaxes: _propTypes2.default.number.isRequired,
        retail: _propTypes2.default.number.isRequired,
        taxes: _propTypes2.default.number.isRequired
    }))
};

ProtectionsListing.displayName = 'ProtectionsListing';

exports.default = ProtectionsListing;

/***/ }),

/***/ "./src/Quote/constants/leadTypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var TEST_DRIVE = exports.TEST_DRIVE = 'TEST_DRIVE';
var APPOINTMENT = exports.APPOINTMENT = 'APPOINTMENT';
var SAVE_TO_GARAGE = exports.SAVE_TO_GARAGE = 'SAVE_TO_GARAGE';
var GET_STARTED = exports.GET_STARTED = 'GET_STARTED';
var ASK_QUESTIONS = exports.ASK_QUESTIONS = 'ASK_QUESTIONS';

exports.default = {
    TEST_DRIVE: TEST_DRIVE,
    APPOINTMENT: APPOINTMENT,
    SAVE_TO_GARAGE: SAVE_TO_GARAGE,
    GET_STARTED: GET_STARTED,
    ASK_QUESTIONS: ASK_QUESTIONS
};

/***/ }),

/***/ "./src/Quote/constants/modelTrimItemCategories.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var OPTION = exports.OPTION = 1;
var ACCESSORY = exports.ACCESSORY = 2;
var DEALER_INVENTORY = exports.DEALER_INVENTORY = 3;
var DEALER_DISCOUNT = exports.DEALER_DISCOUNT = 4;
var EXTERIOR_COLOUR = exports.EXTERIOR_COLOUR = 5;
var INTERIOR_TRIM = exports.INTERIOR_TRIM = 6;

var ITEM_SOURCE = exports.ITEM_SOURCE = {
    DEALER: 4,
    SUPPLIER: 7
};

exports.default = {
    OPTION: OPTION,
    ACCESSORY: ACCESSORY,
    DEALER_INVENTORY: DEALER_INVENTORY,
    DEALER_DISCOUNT: DEALER_DISCOUNT,
    EXTERIOR_COLOUR: EXTERIOR_COLOUR,
    INTERIOR_TRIM: INTERIOR_TRIM,
    ITEM_SOURCE: ITEM_SOURCE
};

/***/ }),

/***/ "./src/Quote/constants/statuses.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var DELETED = exports.DELETED = 5;
var CUSTOMER_REVIEW = exports.CUSTOMER_REVIEW = 288;
var CHECKOUT = exports.CHECKOUT = 67239936;
var CHECKOUT_WITH_DEPOSIT = exports.CHECKOUT_WITH_DEPOSIT = 100794368;
var CREDIT_APPROVAL = exports.CREDIT_APPROVAL = 1048576;
var TRADE_IN_EVALUATION = exports.TRADE_IN_EVALUATION = 262144;
var MANAGER_APPROVAL = exports.MANAGER_APPROVAL = 65536;

var ACTIVE_FLAGS = exports.ACTIVE_FLAGS = {
    ACTIVE: 0x0,
    INACTIVE: 0x1,
    LOST: 0x2,
    DELETED: 0x4
};

var ORIGIN_FLAGS = exports.ORIGIN_FLAGS = {
    LEAD: 0x10,
    CUSTOMER_WEB: 0x20
};

var OWNER_FLAGS = exports.OWNER_FLAGS = {
    CUSTOMER: 0x100,
    SALESPERSON: 0x200,
    MANAGER: 0x400,
    FNI: 0x800,
    ACCOUNTING: 0x1000
};

var PENDING_APPROVAL_FLAGS = exports.PENDING_APPROVAL_FLAGS = {
    QUOTE_COMPLETION: 0x10000,
    OFFER_APPROVAL: 0x20000,
    TRADE_IN_EVALUATION: 0x40000,
    SALE_COMPLETION: 0x80000,
    CREDIT_APPROVAL: 0x100000,
    STOCK_MATCH: 0x200000,
    VEHICLE_DELIVERED_BOOKED: 0x400000,
    VEHICLE_TRIAL: 0x800000,
    ACCOUNTING_POST_VERIFIED: 0x1000000
};

var OFFER_FLAGS = exports.OFFER_FLAGS = {
    OFFER_WITH_DEPOSIT: 0x2000000,
    OFFER_CUSTOMER_WEB: 0x4000000
};

var STOCK_MATCH_FLAGS = exports.STOCK_MATCH_FLAGS = {
    LOCATE: 0x8000000
};

var DELIVERY_FLAGS = exports.DELIVERY_FLAGS = {
    NO_FNI: 0x10000000
};

var DECLINED_FLAGS = exports.DECLINED_FLAGS = {
    OFFER_DECLINED: 0x20000000,
    CREDIT_DECLINED: 0x40000000,
    VEHICLE_TRIAL_RETURNED: 0x80000000
};

var APPROVED_COMPLETED_FLAGS = exports.APPROVED_COMPLETED_FLAGS = {
    QUOTE_COMPLETED: 0x100000000,
    OFFER_APPROVED_SOLD: 0x200000000,
    TRADE_IN_EVALUATION_COMPLETED: 0x400000000,
    SALE_COMPLETED: 0x800000000,
    CREDIT_APPROVED: 0x1000000000,
    STOCK_MATCHED: 0x2000000000,
    VEHICLE_DELIVERED: 0x4000000000,
    VEHICLE_TRIAL_ENDED: 0x8000000000,
    ACCOUNTING_POST_POSTED: 0x10000000000
};

exports.default = {
    DELETED: DELETED,
    CUSTOMER_REVIEW: CUSTOMER_REVIEW,
    CHECKOUT: CHECKOUT,
    CHECKOUT_WITH_DEPOSIT: CHECKOUT_WITH_DEPOSIT,
    CREDIT_APPROVAL: CREDIT_APPROVAL,
    TRADE_IN_EVALUATION: TRADE_IN_EVALUATION,
    MANAGER_APPROVAL: MANAGER_APPROVAL,
    ACTIVE_FLAGS: ACTIVE_FLAGS,
    ORIGIN_FLAGS: ORIGIN_FLAGS,
    OWNER_FLAGS: OWNER_FLAGS,
    PENDING_APPROVAL_FLAGS: PENDING_APPROVAL_FLAGS,
    OFFER_FLAGS: OFFER_FLAGS,
    STOCK_MATCH_FLAGS: STOCK_MATCH_FLAGS,
    DELIVERY_FLAGS: DELIVERY_FLAGS,
    DECLINED_FLAGS: DECLINED_FLAGS,
    APPROVED_COMPLETED_FLAGS: APPROVED_COMPLETED_FLAGS
};

/***/ }),

/***/ "./src/Quote/constants/warnings.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var DUE_AT_DELIVERY_MISMATCH = exports.DUE_AT_DELIVERY_MISMATCH = 1023;
var RETAIL_MISMATCH = exports.RETAIL_MISMATCH = 1027;
var PAYMENT_MISMATCH = exports.PAYMENT_MISMATCH = 1036;
var PAYMENT_TAXES_MISMATCH = exports.PAYMENT_TAXES_MISMATCH = 1042;
var FINANCED_AMOUNT_MISMATCH = exports.FINANCED_AMOUNT_MISMATCH = 1043;
var FINANCED_AMOUNT_WITH_TAXES_MISMATCH = exports.FINANCED_AMOUNT_WITH_TAXES_MISMATCH = 1044;

exports.default = {
    RETAIL_MISMATCH: RETAIL_MISMATCH,
    PAYMENT_MISMATCH: PAYMENT_MISMATCH,
    PAYMENT_TAXES_MISMATCH: PAYMENT_TAXES_MISMATCH,
    FINANCED_AMOUNT_MISMATCH: FINANCED_AMOUNT_MISMATCH,
    FINANCED_AMOUNT_WITH_TAXES_MISMATCH: FINANCED_AMOUNT_WITH_TAXES_MISMATCH,
    DUE_AT_DELIVERY_MISMATCH: DUE_AT_DELIVERY_MISMATCH
};

/***/ }),

/***/ "./src/Quote/i18n/en.json":
/***/ (function(module, exports) {

module.exports = {"QUOTE":{"BTN_ADD_TO_GARAGE":"Add to Garage","BTN_APPLY_QUOTE_CHANGES":"Apply Changes"}}

/***/ }),

/***/ "./src/Quote/i18n/fr.json":
/***/ (function(module, exports) {

module.exports = {"QUOTE":{"BTN_ADD_TO_GARAGE":"Ajouter au garage","BTN_APPLY_QUOTE_CHANGES":"Appliquer les changements"}}

/***/ }),

/***/ "./src/Quote/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Translation = exports.exteriorColourStatuses = exports.Finance = exports.CashPurchase = exports.AddToGarageV25 = exports.AddToGarageButton = exports.QuoteItemCategoryService = exports.QuoteService = exports.QuoteReducer = exports.QuoteItemCategoryModel = exports.QuoteModel = exports.ModelTrimItemCategories = exports.Statuses = exports.LeadTypes = exports.QuoteActionsTypes = exports.QuoteActions = undefined;

var _quoteActions = __webpack_require__("./src/Quote/actions/quoteActions.js");

var _quoteActions2 = _interopRequireDefault(_quoteActions);

var _quoteActionTypes = __webpack_require__("./src/Quote/actions/quoteActionTypes.js");

var _quoteActionTypes2 = _interopRequireDefault(_quoteActionTypes);

var _leadTypes = __webpack_require__("./src/Quote/constants/leadTypes.js");

var _leadTypes2 = _interopRequireDefault(_leadTypes);

var _statuses = __webpack_require__("./src/Quote/constants/statuses.js");

var _statuses2 = _interopRequireDefault(_statuses);

var _modelTrimItemCategories = __webpack_require__("./src/Quote/constants/modelTrimItemCategories.js");

var _modelTrimItemCategories2 = _interopRequireDefault(_modelTrimItemCategories);

var _exteriorColourStatuses = __webpack_require__("./src/ModelYear/constants/exteriorColourStatuses.js");

var _exteriorColourStatuses2 = _interopRequireDefault(_exteriorColourStatuses);

var _QuoteModel = __webpack_require__("./src/Quote/models/QuoteModel.js");

var _QuoteModel2 = _interopRequireDefault(_QuoteModel);

var _QuoteItemCategoryModel = __webpack_require__("./src/Quote/models/QuoteItemCategoryModel.js");

var _QuoteItemCategoryModel2 = _interopRequireDefault(_QuoteItemCategoryModel);

var _quoteReducer = __webpack_require__("./src/Quote/reducers/quoteReducer.js");

var _quoteReducer2 = _interopRequireDefault(_quoteReducer);

var _QuoteService = __webpack_require__("./src/Quote/services/QuoteService/QuoteService.js");

var _QuoteService2 = _interopRequireDefault(_QuoteService);

var _QuoteItemCategoryService = __webpack_require__("./src/Quote/services/QuoteItemCategoryService/QuoteItemCategoryService.js");

var _QuoteItemCategoryService2 = _interopRequireDefault(_QuoteItemCategoryService);

var _AddToGarageButton = __webpack_require__("./src/Quote/components/AddToGarage/AddToGarageButton.jsx");

var _AddToGarageButton2 = _interopRequireDefault(_AddToGarageButton);

var _AddToGarageV = __webpack_require__("./src/Quote/components/AddToGarageV25/AddToGarageV25.jsx");

var _AddToGarageV2 = _interopRequireDefault(_AddToGarageV);

var _Finance = __webpack_require__("./src/Quote/components/TransactionSummary/Finance/Finance.jsx");

var _Finance2 = _interopRequireDefault(_Finance);

var _CashPurchase = __webpack_require__("./src/Quote/components/TransactionSummary/CashPurchase/CashPurchase.jsx");

var _CashPurchase2 = _interopRequireDefault(_CashPurchase);

var _en = __webpack_require__("./src/Quote/i18n/en.json");

var _en2 = _interopRequireDefault(_en);

var _fr = __webpack_require__("./src/Quote/i18n/fr.json");

var _fr2 = _interopRequireDefault(_fr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Translation = { en: _en2.default, fr: _fr2.default };

exports.QuoteActions = _quoteActions2.default;
exports.QuoteActionsTypes = _quoteActionTypes2.default;
exports.LeadTypes = _leadTypes2.default;
exports.Statuses = _statuses2.default;
exports.ModelTrimItemCategories = _modelTrimItemCategories2.default;
exports.QuoteModel = _QuoteModel2.default;
exports.QuoteItemCategoryModel = _QuoteItemCategoryModel2.default;
exports.QuoteReducer = _quoteReducer2.default;
exports.QuoteService = _QuoteService2.default;
exports.QuoteItemCategoryService = _QuoteItemCategoryService2.default;
exports.AddToGarageButton = _AddToGarageButton2.default;
exports.AddToGarageV25 = _AddToGarageV2.default;
exports.CashPurchase = _CashPurchase2.default;
exports.Finance = _Finance2.default;
exports.exteriorColourStatuses = _exteriorColourStatuses2.default;
exports.Translation = Translation;
exports.default = {
    QuoteActions: _quoteActions2.default,
    QuoteActionsTypes: _quoteActionTypes2.default,
    LeadTypes: _leadTypes2.default,
    Statuses: _statuses2.default,
    ModelTrimItemCategories: _modelTrimItemCategories2.default,

    QuoteModel: _QuoteModel2.default,
    QuoteItemCategoryModel: _QuoteItemCategoryModel2.default,
    QuoteReducer: _quoteReducer2.default,
    QuoteService: _QuoteService2.default,
    QuoteItemCategoryService: _QuoteItemCategoryService2.default,

    exteriorColourStatuses: _exteriorColourStatuses2.default,

    AddToGarageButton: _AddToGarageButton2.default,
    AddToGarageV25: _AddToGarageV2.default, // SHOWROOM V2.5
    CashPurchase: _CashPurchase2.default,
    Finance: _Finance2.default,

    Translation: Translation
};

/***/ }),

/***/ "./src/Quote/models/QuoteItemCategoryModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = __webpack_require__("immutable");

var _lodash = __webpack_require__("lodash");

var _dataConversions = __webpack_require__("./src/constants/dataConversions.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var QuoteItemCategoryRecord = (0, _immutable.Record)({
    enabled: false,
    visible: true,
    selected: false,
    declined: false,
    singlePackageSelection: true,
    id: 0,
    order: _dataConversions.DEFAULT_KEY_ORDER,
    description: '',
    note: '',
    dataType: 0,
    imageUrl: '',
    webUrl: '',
    itemsPackages: [],
    items: []
});

function getSelectedItems(items) {
    return (0, _lodash.filter)(items, function (item) {
        return item.selected;
    });
}

var QuoteItemCategory = function (_QuoteItemCategoryRec) {
    _inherits(QuoteItemCategory, _QuoteItemCategoryRec);

    function QuoteItemCategory() {
        _classCallCheck(this, QuoteItemCategory);

        return _possibleConstructorReturn(this, (QuoteItemCategory.__proto__ || Object.getPrototypeOf(QuoteItemCategory)).apply(this, arguments));
    }

    _createClass(QuoteItemCategory, [{
        key: 'getItemsPackageContent',
        value: function getItemsPackageContent(itemsPackageSelectionCode) {
            if ((0, _lodash.isEmpty)(itemsPackageSelectionCode)) {
                return [];
            }

            var selectedItemsPackage = (0, _lodash.find)(this.itemsPackages, function (itemsPackage) {
                return itemsPackage.selectionCode === itemsPackageSelectionCode;
            });
            if (!selectedItemsPackage || (0, _lodash.isEmpty)(selectedItemsPackage.includedCodes)) {
                return [];
            }

            return (0, _lodash.filter)(this.items, function (item) {
                return (0, _lodash.includes)(selectedItemsPackage.includedCodes, item.selectionCode);
            });
        }
    }, {
        key: 'getSelectedItemsCount',
        value: function getSelectedItemsCount() {
            return getSelectedItems(this.items).length;
        }
    }, {
        key: 'getSelectedItemsPackagesCount',
        value: function getSelectedItemsPackagesCount() {
            return getSelectedItems(this.itemsPackages).length;
        }
    }, {
        key: 'getSelectedItemsAndPackages',
        value: function getSelectedItemsAndPackages() {
            return (0, _lodash.concat)(getSelectedItems(this.itemsPackages), getSelectedItems(this.items));
        }
    }, {
        key: 'getSelectedItemsPackagesAmountsWithContent',
        value: function getSelectedItemsPackagesAmountsWithContent(isLease, taxesFactor, selectedFinanceTerm) {
            var _this2 = this;

            var selectedPackages = getSelectedItems(this.itemsPackages);

            var selectedPackagesWithContent = (0, _lodash.map)(selectedPackages, function (itemsPackage) {
                var items = _this2.getItemsPackageContent(itemsPackage.selectionCode);

                var _itemsPackage$calcula = itemsPackage.calculateItemAmounts(isLease, selectedFinanceTerm, taxesFactor),
                    retail = _itemsPackage$calcula.retail,
                    taxes = _itemsPackage$calcula.taxes,
                    payment = _itemsPackage$calcula.payment,
                    paymentTaxes = _itemsPackage$calcula.paymentTaxes;

                (0, _lodash.forEach)(items, function (item) {
                    var itemAmounts = item.calculateItemAmounts(isLease, selectedFinanceTerm, taxesFactor, itemsPackage);
                    retail += itemAmounts.retail;
                    taxes += itemAmounts.taxes;
                    payment += itemAmounts.payment;
                    paymentTaxes += itemAmounts.paymentTaxes;
                });

                return {
                    itemsPackage: itemsPackage,
                    items: items,
                    retail: retail,
                    taxes: taxes,
                    payment: payment,
                    paymentTaxes: paymentTaxes
                };
            });

            return selectedPackagesWithContent;
        }
    }]);

    return QuoteItemCategory;
}(QuoteItemCategoryRecord);

exports.default = QuoteItemCategory;

/***/ }),

/***/ "./src/Quote/models/QuoteModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = __webpack_require__("immutable");

var _lodash = __webpack_require__("lodash");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _vehicle = __webpack_require__("./src/constants/vehicle.js");

var _vehicle2 = _interopRequireDefault(_vehicle);

var _leadTypes = __webpack_require__("./src/Quote/constants/leadTypes.js");

var _leadTypes2 = _interopRequireDefault(_leadTypes);

var _VehicleModel = __webpack_require__("./src/Vehicle/models/VehicleModel.js");

var _VehicleModel2 = _interopRequireDefault(_VehicleModel);

var _statuses = __webpack_require__("./src/Quote/constants/statuses.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var QuoteRecord = (0, _immutable.Record)({
    revision: '',
    id: '',
    location: '',
    status: 0,
    creationDate: 0,
    modifiedDate: 0,
    expirationDate: 0,
    dealerId: '',
    accountId: '',
    leadType: _leadTypes2.default.APPOINTMENT,
    leadId: '',
    creditCardChargeId: '',
    creditApplicationId: '',
    vehicle: new _VehicleModel2.default(),
    vehicleId: '',
    tradeInVehicles: [],
    isValid: true,
    warnings: [],
    errors: [],
    showroomItems: [],
    securityToken: '',
    modified: false
});

var Quote = function (_QuoteRecord) {
    _inherits(Quote, _QuoteRecord);

    function Quote(vehicle, modelYear) {
        _classCallCheck(this, Quote);

        var quoteVehicle = vehicle instanceof _VehicleModel2.default ? vehicle : new _VehicleModel2.default(vehicle);

        if (modelYear) {
            var configuration = modelYear.getSelectedOptionsPackageConfiguration();

            quoteVehicle = quoteVehicle.set('vehicleConditionType', _vehicle2.default.CONDITIONS.NEW).set('year', modelYear.year).set('make', modelYear.make).set('model', modelYear.model).set('bodyStyleCode', modelYear.bodyStyleCode).set('configuration', configuration).set('purchaseMethods', configuration.purchaseMethods);
        }

        return _possibleConstructorReturn(this, (Quote.__proto__ || Object.getPrototypeOf(Quote)).call(this, { vehicle: quoteVehicle }));
    }

    _createClass(Quote, [{
        key: 'getShowroomQuote',
        value: function getShowroomQuote() {
            return {
                __revision: this.revision,
                id: String(this.id),
                location: String(this.location) || _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitLocation().toLowerCase(),
                status: this.status,
                creationDate: this.creationDate,
                modifiedDate: this.modifiedDate,
                expirationDate: this.expirationDate,
                dealerId: this.dealerId,
                accountId: this.accountId,
                leadId: this.leadId,
                creditCardChargeId: this.creditCardChargeId,
                creditApplicationId: this.creditApplicationId,
                purchaseMethod: this.vehicle.purchaseMethods.getSelectedPurchaseMethodValue(),
                pricingSummary: this.getShowroomQuotePricingSummary(),
                financingSummary: this.getShowroomQuoteFinancingSummary(),
                vehicle: this.getShowroomVehicle(this.vehicle),
                vehicleId: String(this.vehicleId),
                tradeIns: this.getShowroomTradeIns(),
                securityToken: String(this.securityToken),
                items: (0, _lodash.map)(this.vehicle.purchaseMethods.getAllSelectedOptions(), function (option) {
                    return option.getShowroomQuoteItem();
                })
            };
        }
    }, {
        key: 'getShowroomQuotePricingSummary',
        value: function getShowroomQuotePricingSummary() {
            var _vehicle$purchaseMeth = this.vehicle.purchaseMethods.getSelectedPurchaseMethodAmounts(),
                modelTrim = _vehicle$purchaseMeth.modelTrim,
                exteriorColour = _vehicle$purchaseMeth.exteriorColour,
                interiorColour = _vehicle$purchaseMeth.interiorColour,
                options = _vehicle$purchaseMeth.options,
                discounts = _vehicle$purchaseMeth.discounts,
                freightPDI = _vehicle$purchaseMeth.freightPDI,
                otherFees = _vehicle$purchaseMeth.otherFees,
                taxAndDuty = _vehicle$purchaseMeth.taxAndDuty,
                rebates = _vehicle$purchaseMeth.rebates,
                protections = _vehicle$purchaseMeth.protections,
                taxes = _vehicle$purchaseMeth.taxes;

            var retail = modelTrim + exteriorColour + interiorColour + options + freightPDI + taxAndDuty + otherFees - (discounts + rebates);

            return {
                retail: retail,
                protections: protections,
                taxes: taxes,
                discount: discounts,
                rebate: rebates,
                rebateAtDelivery: 0,
                cashDown: this.vehicle.purchaseMethods.getSelectedFinanceCashDown()
            };
        }
    }, {
        key: 'getShowroomQuoteFinancingSummary',
        value: function getShowroomQuoteFinancingSummary() {
            var selectedFinance = this.vehicle.purchaseMethods.getSelectedFinance();
            var selectedFinanceTerm = this.vehicle.purchaseMethods.getSelectedFinanceTerm();
            var calculatedPayments = selectedFinanceTerm ? selectedFinanceTerm.getCalculatedPayments() : '';

            return !selectedFinanceTerm ? {
                paymentsPerYear: 0,
                term: 0,
                apr: 0,
                financedAmount: 0,
                financedAmountWithTaxes: 0,
                validationFinancedAmountMinimum: 0,
                validationFinancedAmountMaximum: 0,
                residualizingAmount: 0,
                residualRate: 0,
                residualAmountTotal: 0,
                annualKMAllowed: 0,
                endTermKMCost: 0,
                dueAtDelivery: 0,
                payment: 0,
                paymentTaxes: 0,
                protectionsPayment: 0
            } : {
                paymentsPerYear: selectedFinanceTerm.paymentFrequency,
                term: selectedFinanceTerm.term,
                apr: selectedFinanceTerm.apr,
                financedAmount: selectedFinanceTerm.financedAmount,
                financedAmountWithTaxes: selectedFinanceTerm.financedAmountWithTaxes,
                validationFinancedAmountMinimum: 0,
                validationFinancedAmountMaximum: 0,
                residualizingAmount: 0,
                residualRate: selectedFinanceTerm.residualRate,
                residualAmountTotal: selectedFinanceTerm.residualAmount,
                annualKMAllowed: selectedFinance.annualKMAllowed,
                endTermKMCost: selectedFinance.endTermKMCost,
                dueAtDelivery: 0,
                payment: calculatedPayments.calculatedPaymentBeforeTaxes,
                paymentTaxes: calculatedPayments.calculatedPaymentTaxes,
                protectionsPayment: 0
            };
        }
    }, {
        key: 'getShowroomVehicle',
        value: function getShowroomVehicle(vehicle) {
            return {
                id: vehicle.id,
                vehicleId: String(vehicle.vehicleId),
                catalogVehicleId: String(vehicle.catalogVehicleId),
                newCarTrimId: String(vehicle.newCarTrimId), // V2.5
                vehicleCondition: vehicle.vehicleConditionType,
                vin: vehicle.vin,
                year: vehicle.year,
                make: vehicle.make,
                model: vehicle.model,
                modelTrimCode: vehicle.configuration !== null ? vehicle.configuration.modelTrimCode : vehicle.modelTrimCode,
                configurationID: vehicle.configuration !== null ? vehicle.configuration.id : vehicle.configurationId,
                configurationToken: vehicle.configurationToken || '',
                inventory: {
                    stock: vehicle.stockNumber
                }
            };
        }
    }, {
        key: 'getShowroomTradeInVehicle',
        value: function getShowroomTradeInVehicle(tradeInVehicle) {
            return {
                vehicle: this.getShowroomVehicle(tradeInVehicle.vehicle),
                lien: tradeInVehicle.lien,
                amount: tradeInVehicle.amount,
                evaluationQuestion: tradeInVehicle.evaluationQuestion
            };
        }
    }, {
        key: 'getShowroomTradeIns',
        value: function getShowroomTradeIns() {
            var _this2 = this;

            var tradeIns = {
                amountSummary: {
                    tradeIn: this.vehicle.purchaseMethods.tradeIn,
                    lien: this.vehicle.purchaseMethods.lien
                },
                tradeInVehicles: [{
                    vehicle: {
                        vehicleCondition: _vehicle2.default.CONDITIONS.USED,
                        year: 0,
                        make: '',
                        model: ''
                    },
                    lien: {
                        owner: '',
                        amount: this.vehicle.purchaseMethods.lien
                    },
                    amount: this.vehicle.purchaseMethods.tradeIn
                }]
            };

            if (!(0, _lodash.isEmpty)(this.tradeInVehicles)) {
                tradeIns.tradeInVehicles = (0, _lodash.map)(this.tradeInVehicles, function (tradeInVehicle) {
                    return _this2.getShowroomTradeInVehicle(tradeInVehicle);
                });
            }

            return tradeIns;
        }
    }, {
        key: 'getVehicleRedirectionFromQuote',
        value: function getVehicleRedirectionFromQuote(vdpUrl) {
            var vehicle = this.vehicle;
            var locale = _widgetCommonsCoreServices.LocaleService.getSimpleLocale();
            var isQuoteInPending = (this.status & _statuses.CHECKOUT_WITH_DEPOSIT) === _statuses.CHECKOUT_WITH_DEPOSIT;
            var isInManagerApprovalStatus = this.isQuoteInApproval();
            var isShowroomV25Enabled = _widgetCommonsCoreServices.ConfigsService.isShowroomV25Enabled();
            var redirections = _widgetCommonsGeneral.REDIRECTIONS[locale];

            var shortUrl = redirections.checkout;
            var vehicleId = vehicle.vehicleId;

            if (!isQuoteInPending) {
                if (vehicle.getIsVehicleNew()) {
                    if (isShowroomV25Enabled) {
                        shortUrl = redirections.catalogMarketplace;
                        vehicleId = vehicle.newCarTrimId;
                    } else {
                        shortUrl = redirections.buildAndQuote;
                    }
                } else {
                    shortUrl = vdpUrl && !(0, _lodash.isNull)(vdpUrl) && (0, _lodash.isString)(vdpUrl) ? vdpUrl : redirections.vdp;
                }

                shortUrl = _widgetCommonsCoreServices.UrlService.replaceParamWithValue(shortUrl, '{make}', vehicle.make);
                shortUrl = _widgetCommonsCoreServices.UrlService.replaceParamWithValue(shortUrl, '{model}', vehicle.model);
                shortUrl = _widgetCommonsCoreServices.UrlService.replaceParamWithValue(shortUrl, '{year}', vehicle.year);
                shortUrl = _widgetCommonsCoreServices.UrlService.replaceParamWithValue(shortUrl, '{vehicleId}', vehicleId);
                shortUrl = _widgetCommonsCoreServices.UrlService.replaceParamWithValue(shortUrl, '{bodyStyle}', vehicle.bodyStyleCode);
                shortUrl = shortUrl.toLowerCase().replace(/\s/g, '-');
            }

            return !isInManagerApprovalStatus ? this.buildUrl(shortUrl) : null;
        }
    }, {
        key: 'getVDPUrl',
        value: function getVDPUrl() {
            var vehicle = this.vehicle;

            var locale = _widgetCommonsCoreServices.LocaleService.getSimpleLocale();
            var isShowroomV25Enabled = _widgetCommonsCoreServices.ConfigsService.isShowroomV25Enabled();
            var redirections = _widgetCommonsGeneral.REDIRECTIONS[locale];

            var vdpURL = redirections.vdp;
            var vehicleId = vehicle.vehicleId;
            if (vehicle.getIsVehicleNew()) {
                if (isShowroomV25Enabled) {
                    vdpURL = redirections.catalogMarketplace;
                    vehicleId = vehicle.newCarTrimId;
                } else {
                    vdpURL = redirections.buildAndQuote;
                }
            }

            vdpURL = _widgetCommonsCoreServices.UrlService.replaceParamWithValue(vdpURL, '{make}', vehicle.make);
            vdpURL = _widgetCommonsCoreServices.UrlService.replaceParamWithValue(vdpURL, '{model}', vehicle.model);
            vdpURL = _widgetCommonsCoreServices.UrlService.replaceParamWithValue(vdpURL, '{year}', vehicle.year);
            vdpURL = _widgetCommonsCoreServices.UrlService.replaceParamWithValue(vdpURL, '{vehicleId}', vehicleId);
            vdpURL = _widgetCommonsCoreServices.UrlService.replaceParamWithValue(vdpURL, '{bodyStyle}', vehicle.bodyStyleCode);
            vdpURL = vdpURL.toLowerCase().replace(/\s/g, '-');

            return this.buildUrl(vdpURL);
        }
    }, {
        key: 'isQuoteInPending',
        value: function isQuoteInPending() {
            var pendingStatus = _statuses.CUSTOMER_REVIEW | _statuses.CHECKOUT_WITH_DEPOSIT;
            return (this.status & pendingStatus) === pendingStatus;
        }
    }, {
        key: 'isQuoteInApproval',
        value: function isQuoteInApproval() {
            return (this.status & _statuses.MANAGER_APPROVAL) === _statuses.MANAGER_APPROVAL;
        }
    }, {
        key: 'isQuoteInGarage',
        value: function isQuoteInGarage() {
            return !!(this.id && !this.securityToken);
        }
    }, {
        key: 'isDepositDone',
        value: function isDepositDone() {
            return (this.status & _statuses.OFFER_FLAGS.OFFER_WITH_DEPOSIT) === _statuses.OFFER_FLAGS.OFFER_WITH_DEPOSIT;
        }
    }, {
        key: 'isDirty',
        value: function isDirty() {
            return !!(this.isQuoteInGarage() && this.modified);
        }
    }, {
        key: 'isQuoteVehicleFromInventory',
        value: function isQuoteVehicleFromInventory() {
            return !!this.vehicleId;
        }
    }, {
        key: 'buildUrl',
        value: function buildUrl(url) {
            var id = this.id,
                securityToken = this.securityToken;

            var prefix = !(0, _lodash.includes)(url, '?') ? '?' : '&';

            if (!url) {
                return '';
            }

            var fullUrl = '' + url + prefix + 'quoteId=' + id;

            if (securityToken) {
                fullUrl += '&writeToken=' + securityToken;
            }

            return fullUrl;
        }
    }]);

    return Quote;
}(QuoteRecord);

exports.default = Quote;

/***/ }),

/***/ "./src/Quote/reducers/quoteReducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = quoteReducer;

var _lodash = __webpack_require__("lodash");

var _quoteActionTypes = __webpack_require__("./src/Quote/actions/quoteActionTypes.js");

var _quoteActionTypes2 = _interopRequireDefault(_quoteActionTypes);

var _purchaseMethodsActionTypes = __webpack_require__("./src/PurchaseMethods/actions/purchaseMethodsActionTypes.js");

var _purchaseMethodsActionTypes2 = _interopRequireDefault(_purchaseMethodsActionTypes);

var _PurchaseMethodsService = __webpack_require__("./src/PurchaseMethods/services/PurchaseMethodsService/PurchaseMethodsService.js");

var PurchaseMethodsService = _interopRequireWildcard(_PurchaseMethodsService);

var _QuoteModel = __webpack_require__("./src/Quote/models/QuoteModel.js");

var _QuoteModel2 = _interopRequireDefault(_QuoteModel);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function quoteReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _QuoteModel2.default();
    var action = arguments[1];

    switch (action.type) {
        case _quoteActionTypes2.default.SET_QUOTE:
            return action.quote;

        case _quoteActionTypes2.default.SET_QUOTE_MODIFIED:
            return state.set('modified', true);

        case _quoteActionTypes2.default.SET_QUOTE_REVISION:
            return state.set('revision', action.revision);

        case _quoteActionTypes2.default.SET_QUOTE_MODEL_YEAR:
            return state.set('vehicle', action.modelYear.getVehicleFromConfiguration());

        case _quoteActionTypes2.default.SET_QUOTE_VEHICLE:
            return state.set('vehicle', action.vehicle);

        case _quoteActionTypes2.default.SET_LEAD_TYPE:
            return state.set('leadType', action.leadType);

        case _quoteActionTypes2.default.SET_STATUS:
            return state.set('status', action.status);

        case _quoteActionTypes2.default.SET_SECURITY_TOKEN:
            return state.set('securityToken', action.securityToken);

        case _quoteActionTypes2.default.SET_QUOTE_PURCHASE_METHODS:
            return state.setIn(['vehicle', 'purchaseMethods'], action.purchaseMethods);

        case _purchaseMethodsActionTypes2.default.SELECT_PURCHASE_METHOD:
            return state.setIn(['vehicle', 'purchaseMethods'], PurchaseMethodsService.selectPurchaseMethod(state.vehicle.purchaseMethods, action.purchaseMethod)).set('modified', true);

        case _purchaseMethodsActionTypes2.default.SELECT_TERM:
            return state.setIn(['vehicle', 'purchaseMethods'], PurchaseMethodsService.selectTerm(state.vehicle.purchaseMethods, action.term)).set('modified', true);

        case _purchaseMethodsActionTypes2.default.SELECT_PAYMENT_FREQUENCY:
            return state.setIn(['vehicle', 'purchaseMethods'], PurchaseMethodsService.selectPaymentFrequency(state.vehicle.purchaseMethods, action.paymentFrequency.value)).set('modified', true);

        case _purchaseMethodsActionTypes2.default.SET_CASH_DOWN:
            return state.setIn(['vehicle', 'purchaseMethods'], PurchaseMethodsService.setCashDown(state.vehicle.purchaseMethods, action.cashDown)).set('modified', true);

        case _purchaseMethodsActionTypes2.default.SET_TRADE_IN:
            return state.setIn(['vehicle', 'purchaseMethods'], PurchaseMethodsService.setTradeIn(state.vehicle.purchaseMethods, action.tradeIn)).set('modified', true);

        case _purchaseMethodsActionTypes2.default.SET_LIEN:
            return state.setIn(['vehicle', 'purchaseMethods'], PurchaseMethodsService.setLien(state.vehicle.purchaseMethods, action.lien)).set('modified', true);

        case _purchaseMethodsActionTypes2.default.SET_TAXES_INCLUDED:
            return state.setIn(['vehicle', 'purchaseMethods'], PurchaseMethodsService.setTaxesIncluded(state, action.taxesIncluded)).set('modified', true);

        case _purchaseMethodsActionTypes2.default.SELECT_KM_PLAN:
            return state.setIn(['vehicle', 'purchaseMethods'], PurchaseMethodsService.selectKMPlan(state.vehicle.purchaseMethods, action.kmPlan.value)).set('modified', true);

        default:
            if ((0, _lodash.includes)(_purchaseMethodsActionTypes2.default.QUOTE_UPDATE_TYPES, action.type)) {
                return state.set('modified', true);
            }
            return state;
    }
}

/***/ }),

/***/ "./src/Quote/services/QuoteItemCategoryService/QuoteItemCategoryService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetQuoteItemCategoriesFromQuoteProtections = resetQuoteItemCategoriesFromQuoteProtections;
exports.resetQuoteItemCategoryFromCategory = resetQuoteItemCategoryFromCategory;
exports.resetQuoteItemCategoriesFromModelTrimOptions = resetQuoteItemCategoriesFromModelTrimOptions;
exports.selectQuoteItemCategory = selectQuoteItemCategory;
exports.selectNextPreviousQuoteItemCategory = selectNextPreviousQuoteItemCategory;
exports.selectQuoteItemPackage = selectQuoteItemPackage;
exports.resetQuoteItemCategoriesFromOptionsValidation = resetQuoteItemCategoriesFromOptionsValidation;

var _lodash = __webpack_require__("lodash");

var _OptionService = __webpack_require__("./src/ModelYear/services/OptionService/OptionService.js");

var _dataTypes = __webpack_require__("./src/constants/dataTypes.js");

var _modelTrimItemCategories = __webpack_require__("./src/Quote/constants/modelTrimItemCategories.js");

var _QuoteItemCategoryModel = __webpack_require__("./src/Quote/models/QuoteItemCategoryModel.js");

var _QuoteItemCategoryModel2 = _interopRequireDefault(_QuoteItemCategoryModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PROTECTION = _dataTypes.DATA_TYPES.PROTECTION,
    FEATURE = _dataTypes.DATA_TYPES.FEATURE,
    REBATE = _dataTypes.DATA_TYPES.REBATE;


function splitItemsAndPackages(quoteItemCategories, quoteItemsPackages, quoteItems) {
    return (0, _lodash.filter)((0, _lodash.map)(quoteItemCategories, function (itemCategory) {
        var itemsPackages = (0, _lodash.orderBy)((0, _lodash.filter)(quoteItemsPackages, function (item) {
            return item.categoryID === itemCategory.id;
        }), ['keyOrder']);
        var items = (0, _lodash.orderBy)((0, _lodash.filter)(quoteItems, function (item) {
            return item.categoryID === itemCategory.id;
        }), ['keyOrder']);

        var noItems = (0, _lodash.isEmpty)(items) && (0, _lodash.isEmpty)(itemsPackages);
        return itemCategory.set('visible', !noItems).set('itemsPackages', itemsPackages).set('items', items);
    }), 'visible');
}

function getItemCategoryFromType(item, categoryId) {
    var notColour = item.typeID !== FEATURE.TYPES.EXTERIOR_COLOUR && item.typeID !== FEATURE.TYPES.INTERIOR_TRIM;

    if (item.typeID === FEATURE.TYPES.EXTERIOR_COLOUR && categoryId === _modelTrimItemCategories.EXTERIOR_COLOUR) {
        return _modelTrimItemCategories.EXTERIOR_COLOUR;
    } else if (item.typeID === FEATURE.TYPES.INTERIOR_TRIM && categoryId === _modelTrimItemCategories.INTERIOR_TRIM) {
        return _modelTrimItemCategories.INTERIOR_TRIM;
    } else if (notColour && item.isInstalledAtDealership && categoryId === _modelTrimItemCategories.ACCESSORY) {
        return _modelTrimItemCategories.ACCESSORY;
    } else if (notColour && !item.isInstalledAtDealership && categoryId === _modelTrimItemCategories.OPTION) {
        return _modelTrimItemCategories.OPTION;
    }
    return 0;
}

function splitModelTrimItemsAndPackages(quoteItemCategories, modelItemsPackages, modelItems) {
    var parentCodeInclusions = {};
    (0, _lodash.forEach)(modelItems, function (item) {
        if (!parentCodeInclusions[item.parentCode]) {
            parentCodeInclusions[item.parentCode] = [];
        }
        parentCodeInclusions[item.parentCode].push(item.selectionCode);
    });
    var newModelItemsPackages = (0, _lodash.map)(modelItemsPackages, function (itemsPackage) {
        return parentCodeInclusions[itemsPackage.code] ? itemsPackage.set('includedCodes', parentCodeInclusions[itemsPackage.code]) : itemsPackage;
    });

    return (0, _lodash.map)(quoteItemCategories, function (itemCategory) {
        var itemsPackages = (0, _lodash.orderBy)((0, _lodash.filter)(newModelItemsPackages, function (item) {
            return getItemCategoryFromType(item, itemCategory.id) > 0;
        }), ['description']);
        var items = (0, _lodash.orderBy)((0, _lodash.filter)(modelItems, function (item) {
            return getItemCategoryFromType(item, itemCategory.id) > 0;
        }), ['description']);

        var noItems = (0, _lodash.isEmpty)(items) && (0, _lodash.isEmpty)(itemsPackages);
        return itemCategory.set('visible', !noItems && itemCategory.id <= _modelTrimItemCategories.ACCESSORY).set('itemsPackages', itemsPackages).set('items', items);
    });
}

function extractCategoriesWebUrls(quoteItemCategories) {
    return (0, _lodash.map)(quoteItemCategories, function (itemCategory) {
        var webUrls = (0, _lodash.uniqBy)(itemCategory.itemsPackages, 'webUrl');
        if (!itemCategory.webUrl && webUrls.length === 1) {
            return itemCategory.set('webUrl', webUrls[0].webUrl).set('itemsPackages', (0, _lodash.map)(itemCategory.itemsPackages, function (itemsPackage) {
                return itemsPackage.set('webUrl', '');
            }));
        }
        return itemCategory;
    });
}

function extractCategoriesNotes(quoteItemCategories) {
    return (0, _lodash.map)(quoteItemCategories, function (itemCategory) {
        var typeNotes = (0, _lodash.uniqBy)(itemCategory.itemsPackages, 'note');
        if (!itemCategory.note && typeNotes.length === 1) {
            return itemCategory.set('note', typeNotes[0].note).set('itemsPackages', (0, _lodash.map)(itemCategory.itemsPackages, function (itemsPackage) {
                return itemsPackage.set('note', '');
            }));
        }
        return itemCategory;
    });
}

function unselectItemsAndPackages(quoteItemCategory) {
    return quoteItemCategory.set('items', (0, _lodash.map)(quoteItemCategory.items, function (item) {
        return item.set('selected', false);
    })).set('itemsPackages', (0, _lodash.map)(quoteItemCategory.itemsPackages, function (item) {
        return item.set('selected', false);
    }));
}

function resetItemsAndPackagesAmountsFromOptions(quoteItemCategory, options) {
    var itemsPackages = (0, _lodash.map)(quoteItemCategory.itemsPackages, function (item) {
        var itemOption = (0, _lodash.find)(options, function (option) {
            return option.selectionCode === item.selectionCode;
        });
        return item.set('retail', itemOption ? itemOption.retail : item.retail).set('residualizingAmount', itemOption ? itemOption.residualizingAmount : item.residualizingAmount);
    });

    var items = (0, _lodash.map)(quoteItemCategory.items, function (item) {
        var itemOption = (0, _lodash.find)(options, function (option) {
            return option.selectionCode === item.selectionCode;
        });
        return item.set('retail', itemOption ? itemOption.retail : item.retail).set('residualizingAmount', itemOption ? itemOption.residualizingAmount : item.residualizingAmount);
    });

    return quoteItemCategory.set('itemsPackages', itemsPackages).set('items', items);
}

function selectItemsAndPackagesFromCodes(quoteItemCategory, itemsPackageSelectionCodes) {
    var itemsPackages = (0, _lodash.map)(quoteItemCategory.itemsPackages, function (item) {
        if (quoteItemCategory.id === _modelTrimItemCategories.DEALER_INVENTORY && quoteItemCategory.dataType === FEATURE.DATA_TYPE_ID || quoteItemCategory.id === _modelTrimItemCategories.DEALER_DISCOUNT && quoteItemCategory.dataType === REBATE.DATA_TYPE_ID) {
            return item.set('selected', true);
        }
        return item.set('selected', (0, _lodash.includes)(itemsPackageSelectionCodes, item.selectionCode));
    });

    var selectedItemsPackages = (0, _lodash.filter)(itemsPackages, 'selected');
    var includedCodes = (0, _lodash.flatten)((0, _lodash.map)(selectedItemsPackages, function (itemsPackage) {
        return itemsPackage.includedCodes;
    }));

    var items = (0, _lodash.map)(quoteItemCategory.items, function (item) {
        return item.set('selected', (0, _lodash.includes)(includedCodes, item.selectionCode) || (0, _lodash.includes)(itemsPackageSelectionCodes, item.selectionCode));
    });

    return quoteItemCategory.set('itemsPackages', itemsPackages).set('items', items);
}

function disableCategory(quoteItemCategory) {
    var unselectedItemCategory = unselectItemsAndPackages(quoteItemCategory);
    return unselectedItemCategory.set('selected', false).set('enabled', false).set('declined', false);
}

function setCategoryDone(quoteItemCategory, declineProtections) {
    var quoteItemCatSelected = quoteItemCategory;
    if (declineProtections) {
        quoteItemCatSelected = unselectItemsAndPackages(quoteItemCategory);
    }

    var declined = declineProtections || quoteItemCatSelected.getSelectedItemsCount() === 0 && quoteItemCatSelected.getSelectedItemsPackagesCount() === 0;

    return quoteItemCatSelected.set('selected', false).set('declined', declined);
}

function setSelectedItemsAndPackages(quoteItemCategory, selectedOptions) {
    var selectedOptionsCodes = (0, _lodash.map)(selectedOptions, function (selectedOption) {
        return selectedOption.selectionCode;
    });
    var newQuoteItemCategory = unselectItemsAndPackages(quoteItemCategory);
    newQuoteItemCategory = resetItemsAndPackagesAmountsFromOptions(newQuoteItemCategory, selectedOptions);
    return selectItemsAndPackagesFromCodes(newQuoteItemCategory, selectedOptionsCodes);
}

function resetQuoteItemCategoriesFromQuoteProtections(quoteItemCategories, quoteProtections) {
    if (!(0, _lodash.isArrayLikeObject)(quoteItemCategories) || (0, _lodash.isEmpty)(quoteItemCategories)) {
        return [];
    }
    if (!(0, _lodash.isArrayLikeObject)(quoteProtections) || (0, _lodash.isEmpty)(quoteProtections)) {
        return quoteItemCategories;
    }

    var protectionPackages = [];
    var protections = [];

    (0, _lodash.forEach)(quoteProtections, function (protection) {
        if (protection.dataType === PROTECTION.DATA_TYPE_ID) {
            if (!(0, _lodash.isEmpty)(protection.identificationType) && (protection.identificationType.isGroup || protection.categoryID === 6)) {
                protectionPackages.push((0, _OptionService.resetOptionFromProtectionItem)(protection));
            } else {
                protections.push((0, _OptionService.resetOptionFromProtectionItem)(protection));
            }
        }
    });

    var quoteItemCatSplitItems = splitItemsAndPackages(quoteItemCategories, protectionPackages, protections);
    var quoteItemCatUrls = extractCategoriesWebUrls(quoteItemCatSplitItems);
    var quoteItemCatNotes = extractCategoriesNotes(quoteItemCatUrls);

    return (0, _lodash.map)(quoteItemCatNotes, function (protectionCategory, index) {
        return protectionCategory.set('selected', index === 0).set('enabled', index === 0);
    });
}

function resetQuoteItemCategoryFromCategory(quoteItemCategory, dataType, category) {
    if (!(0, _lodash.isObjectLike)(category) || (0, _lodash.isUndefined)(category.categoryID)) {
        return quoteItemCategory;
    }
    return quoteItemCategory.set('id', category.categoryID).set('singlePackageSelection', category.categoryID !== PROTECTION.CATEGORIES.INSURANCE && category.categoryID !== PROTECTION.CATEGORIES.PROTECTION).set('description', (0, _lodash.isEmpty)(category.description) ? '' : category.description.descriptions[0]).set('note', (0, _lodash.isEmpty)(category.description) ? '' : category.description.notes[0]).set('dataType', dataType).set('order', category.rank);
}

function resetQuoteItemCategoriesFromModelTrimOptions(modelOptions) {
    if (!(0, _lodash.isArrayLikeObject)(modelOptions) || (0, _lodash.isEmpty)(modelOptions)) {
        return [];
    }

    var quoteItemCategories = [new _QuoteItemCategoryModel2.default({
        id: _modelTrimItemCategories.OPTION,
        dataType: FEATURE.DATA_TYPE_ID,
        singlePackageSelection: false,
        order: _modelTrimItemCategories.OPTION
    }), new _QuoteItemCategoryModel2.default({
        id: _modelTrimItemCategories.ACCESSORY,
        dataType: FEATURE.DATA_TYPE_ID,
        singlePackageSelection: false,
        order: _modelTrimItemCategories.ACCESSORY
    }), new _QuoteItemCategoryModel2.default({
        id: _modelTrimItemCategories.DEALER_INVENTORY,
        dataType: FEATURE.DATA_TYPE_ID,
        singlePackageSelection: false,
        order: _modelTrimItemCategories.DEALER_INVENTORY
    }), new _QuoteItemCategoryModel2.default({
        id: _modelTrimItemCategories.DEALER_DISCOUNT,
        dataType: REBATE.DATA_TYPE_ID,
        singlePackageSelection: false,
        order: _modelTrimItemCategories.DEALER_DISCOUNT
    }), new _QuoteItemCategoryModel2.default({
        id: _modelTrimItemCategories.EXTERIOR_COLOUR,
        dataType: FEATURE.DATA_TYPE_ID,
        singlePackageSelection: true,
        order: _modelTrimItemCategories.EXTERIOR_COLOUR
    }), new _QuoteItemCategoryModel2.default({
        id: _modelTrimItemCategories.INTERIOR_TRIM,
        dataType: FEATURE.DATA_TYPE_ID,
        singlePackageSelection: true,
        order: _modelTrimItemCategories.INTERIOR_TRIM
    })];

    var optionsAccessoriesPackages = [];
    var optionsAccessories = [];

    (0, _lodash.forEach)(modelOptions, function (optionAccessory) {
        if ((0, _lodash.isEmpty)(optionAccessory.parentCode)) {
            optionsAccessoriesPackages.push(optionAccessory);
        } else {
            optionsAccessories.push(optionAccessory);
        }
    });

    var quoteItemCatSplitItems = splitModelTrimItemsAndPackages(quoteItemCategories, optionsAccessoriesPackages, optionsAccessories);
    return (0, _lodash.map)(quoteItemCatSplitItems, function (protectionCategory, index) {
        return protectionCategory.set('selected', index === 0).set('enabled', index === 0);
    });
}

function selectQuoteItemCategory(quoteItemCategories, quoteItemCategory, declineProtections) {
    if (!(0, _lodash.isArrayLikeObject)(quoteItemCategories) || (0, _lodash.isEmpty)(quoteItemCategories)) {
        return [];
    }
    if ((!(0, _lodash.isObjectLike)(quoteItemCategory) || (0, _lodash.isUndefined)(quoteItemCategory.id)) && !(0, _lodash.isNull)(quoteItemCategory)) {
        return quoteItemCategories;
    }

    var categoriesIds = (0, _lodash.map)(quoteItemCategories, function (itemCategory) {
        return itemCategory.id;
    });
    var categoriesCount = categoriesIds.length;
    var currentIndex = categoriesCount;
    if (quoteItemCategory !== null) {
        currentIndex = (0, _lodash.findIndex)(quoteItemCategories, function (itemCategory) {
            return itemCategory.id === quoteItemCategory.id;
        });
    }
    var previousIds = (0, _lodash.dropRight)(categoriesIds, categoriesCount - currentIndex);

    return (0, _lodash.map)(quoteItemCategories, function (itemCategory) {
        if ((0, _lodash.includes)(previousIds, itemCategory.id)) {
            return itemCategory.selected ? setCategoryDone(itemCategory, declineProtections) : itemCategory;
        } else if (itemCategory.id === quoteItemCategory.id) {
            return itemCategory.set('selected', true).set('enabled', true).set('declined', false);
        }
        return disableCategory(itemCategory);
    });
}

function selectNextPreviousQuoteItemCategory(quoteItemCategories, quoteItemCategory, previous, declineProtections) {
    if (!(0, _lodash.isArrayLikeObject)(quoteItemCategories) || (0, _lodash.isEmpty)(quoteItemCategories)) {
        return [];
    }

    var nextIndex = (0, _lodash.findIndex)(quoteItemCategories, function (itemCategory) {
        return itemCategory.id === quoteItemCategory.id;
    }) + (previous ? -1 : 1);

    if (nextIndex < 0) {
        return selectQuoteItemCategory(quoteItemCategories, quoteItemCategory, declineProtections);
    } else if (nextIndex >= quoteItemCategories.length) {
        return selectQuoteItemCategory(quoteItemCategories, null, declineProtections);
    }
    return selectQuoteItemCategory(quoteItemCategories, quoteItemCategories[nextIndex], declineProtections);
}

function selectQuoteItemPackage(quoteItemCategories, quoteItemCategory, itemsPackage) {
    if (!(0, _lodash.isArrayLikeObject)(quoteItemCategories) || (0, _lodash.isEmpty)(quoteItemCategories)) {
        return [];
    }
    if (!(0, _lodash.isObjectLike)(quoteItemCategory) || (0, _lodash.isUndefined)(quoteItemCategory.id) || !(0, _lodash.isObjectLike)(itemsPackage) || (0, _lodash.isUndefined)(itemsPackage.selectionCode)) {
        return quoteItemCategories;
    }

    var itemsPackages = (0, _lodash.map)(quoteItemCategory.itemsPackages, function (item) {
        if (quoteItemCategory.singlePackageSelection) {
            var selected = item.selectionCode === itemsPackage.selectionCode && !itemsPackage.selected;
            return item.set('selected', selected).set('userSelected', selected);
        }
        var multiSelected = item.selectionCode === itemsPackage.selectionCode && !itemsPackage.selected || item.selectionCode !== itemsPackage.selectionCode && item.selected;
        return item.set('selected', multiSelected).set('userSelected', multiSelected);
    });

    var items = (0, _lodash.map)(quoteItemCategory.items, function (item) {
        if (quoteItemCategory.singlePackageSelection) {
            var selected = !itemsPackage.selected && (0, _lodash.includes)(itemsPackage.includedCodes, item.selectionCode);
            return item.set('selected', selected).set('userSelected', selected);
        }
        var multiSelected = (0, _lodash.includes)(itemsPackage.includedCodes, item.selectionCode) && !itemsPackage.selected || !(0, _lodash.includes)(itemsPackage.includedCodes, item.selectionCode) && item.selected;
        return item.set('selected', multiSelected).set('userSelected', multiSelected);
    });

    var newQuoteItemCategory = quoteItemCategory.set('itemsPackages', itemsPackages).set('items', items);

    return (0, _lodash.map)(quoteItemCategories, function (itemCategory) {
        return itemCategory.id === newQuoteItemCategory.id ? newQuoteItemCategory : itemCategory;
    });
}

function resetQuoteItemCategoriesFromOptionsValidation(quoteItemCategories, selectedOptions) {
    if (!(0, _lodash.isArrayLikeObject)(quoteItemCategories) || (0, _lodash.isEmpty)(quoteItemCategories)) {
        return [];
    }
    if (!(0, _lodash.isArrayLikeObject)(selectedOptions) || (0, _lodash.isEmpty)(selectedOptions)) {
        return quoteItemCategories;
    }

    return (0, _lodash.map)(quoteItemCategories, function (itemCategory) {
        return setSelectedItemsAndPackages(itemCategory, selectedOptions);
    });
}

exports.default = {
    resetQuoteItemCategoriesFromQuoteProtections: resetQuoteItemCategoriesFromQuoteProtections,
    resetQuoteItemCategoryFromCategory: resetQuoteItemCategoryFromCategory,
    resetQuoteItemCategoriesFromModelTrimOptions: resetQuoteItemCategoriesFromModelTrimOptions,
    selectNextPreviousQuoteItemCategory: selectNextPreviousQuoteItemCategory,
    selectQuoteItemCategory: selectQuoteItemCategory,
    selectQuoteItemPackage: selectQuoteItemPackage,
    resetQuoteItemCategoriesFromOptionsValidation: resetQuoteItemCategoriesFromOptionsValidation
};

/***/ }),

/***/ "./src/Quote/services/QuoteService/QuoteService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.resetQuoteFromModelYear = resetQuoteFromModelYear;
exports.resetQuoteFromVehicle = resetQuoteFromVehicle;
exports.resetQuoteFromShowroomSave = resetQuoteFromShowroomSave;
exports.resetQuoteFromShowroomLoad = resetQuoteFromShowroomLoad;
exports.resetQuoteDepositLead = resetQuoteDepositLead;
exports.resetQuoteCreditApplication = resetQuoteCreditApplication;
exports.getEmployeeRebateFromShowroomQuote = getEmployeeRebateFromShowroomQuote;
exports.quoteHasVehicle = quoteHasVehicle;

var _axios = __webpack_require__("../../node_modules/axios/index.js");

var _axios2 = _interopRequireDefault(_axios);

var _index = __webpack_require__("./src/config/index.js");

var _index2 = _interopRequireDefault(_index);

var _lodash = __webpack_require__("lodash");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _dataOrigins = __webpack_require__("./src/constants/dataOrigins.js");

var DataOrigins = _interopRequireWildcard(_dataOrigins);

var _dataTypes = __webpack_require__("./src/constants/dataTypes.js");

var _purchaseMethodsValues = __webpack_require__("./src/PurchaseMethods/constants/purchaseMethodsValues.js");

var _purchaseMethodsValues2 = _interopRequireDefault(_purchaseMethodsValues);

var _purchaseMethods = __webpack_require__("./src/PurchaseMethods/constants/purchaseMethods.js");

var _warnings = __webpack_require__("./src/Quote/constants/warnings.js");

var WARNINGS = _interopRequireWildcard(_warnings);

var _statuses = __webpack_require__("./src/Quote/constants/statuses.js");

var _PurchaseMethodsService = __webpack_require__("./src/PurchaseMethods/services/PurchaseMethodsService/PurchaseMethodsService.js");

var _VehicleService = __webpack_require__("./src/Vehicle/services/VehicleService/VehicleService.js");

var _ShowroomService = __webpack_require__("./src/services/ShowroomService/ShowroomService.js");

var _ShowroomService2 = _interopRequireDefault(_ShowroomService);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var criticalWarnings = [WARNINGS.RETAIL_MISMATCH, WARNINGS.PAYMENT_MISMATCH, WARNINGS.PAYMENT_TAXES_MISMATCH, WARNINGS.FINANCED_AMOUNT_MISMATCH, WARNINGS.FINANCED_AMOUNT_WITH_TAXES_MISMATCH, WARNINGS.DUE_AT_DELIVERY_MISMATCH];

var QuoteService = function () {
    function QuoteService() {
        _classCallCheck(this, QuoteService);

        this.basePath = _index2.default.endpoint.showroom + '/service/v1';
    }

    _createClass(QuoteService, [{
        key: 'saveQuote',
        value: function saveQuote(quote, conf) {
            var _this = this;

            if (!conf || !quote) {
                return Promise.reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('missing parameters'));
            }

            var orgId = conf.organizationId;
            var orgUnitId = conf.organizationUnitId;
            var location = conf.location;
            var context = 'refresh=1&location=' + location + '&datalevel=1&context=' + orgId + '.' + orgUnitId + '&userName=public&password=public';

            return _ShowroomService2.default.getPublicToken().then(function (response) {
                var userCookie = _widgetCommonsGeneral.CookieService.getToken(_widgetCommonsGeneral.COOKIES.ACCOUNT.AUTHENTICATE_TOKEN);

                return _axios2.default.put(_this.basePath + '/Quote?' + context, quote, {
                    headers: {
                        'x-jwt': userCookie || response.data
                    }
                });
            });
        }
    }, {
        key: 'getQuote',
        value: function getQuote(quoteId) {
            var token = _widgetCommonsGeneral.CookieService.getToken(_widgetCommonsGeneral.COOKIES.ACCOUNT.AUTHENTICATE_TOKEN);

            return _axios2.default.get(this.basePath + '/Quote/' + quoteId + '?datalevel=1', {
                headers: {
                    'x-jwt': token
                }
            });
        }
    }, {
        key: 'getQuoteIds',
        value: function getQuoteIds() {
            var token = _widgetCommonsGeneral.CookieService.getToken(_widgetCommonsGeneral.COOKIES.ACCOUNT.AUTHENTICATE_TOKEN);

            return _axios2.default.get(this.basePath + '/Quotes', {
                headers: {
                    'x-jwt': token
                }
            });
        }
    }]);

    return QuoteService;
}();

function resetQuoteFromModelYear(quote, location, leadType, modelYear) {
    return quote.set('location', location).set('leadType', leadType).set('vehicle', modelYear.getVehicleFromConfiguration(quote.vehicle));
}

function resetQuoteFromVehicle(quote, location, leadType, vehicle) {
    return quote.set('location', location).set('leadType', leadType).set('vehicle', vehicle);
}

function resetQuoteFromShowroomSave(quote, showroomQuote) {
    var warningCodes = (0, _lodash.map)(showroomQuote.warnings, function (warning) {
        return warning.error;
    });
    var availableItems = showroomQuote.availableItems || quote.vehicle.purchaseMethods.availableOptions.map(function (option) {
        return option.getShowroomQuoteItem();
    });
    var writeToken = _widgetCommonsCoreServices.UrlService.getUrlParameter('writeToken');

    if (!(0, _lodash.isEmpty)(writeToken) && showroomQuote.accountId === 'public') {
        showroomQuote.securityToken = writeToken;
    }

    return quote.set('id', showroomQuote.id).set('revision', showroomQuote.__revision) // eslint-disable-line no-underscore-dangle
    .set('accountId', showroomQuote.accountId).set('leadId', showroomQuote.leadId).set('dealerId', showroomQuote.dealerId).set('isValid', (0, _lodash.isEmpty)((0, _lodash.intersection)(criticalWarnings, warningCodes))).set('showroomItems', showroomQuote.items).set('warnings', showroomQuote.warnings).set('errors', showroomQuote.errors).set('securityToken', showroomQuote.securityToken || '').set('modified', false).set('vehicleId', String(showroomQuote.vehicleId || '')).setIn(['vehicle', 'purchaseMethods'], (0, _PurchaseMethodsService.resetOptionsAmounts)((0, _PurchaseMethodsService.resetPurchaseMethodsOptionsFromQuoteItems)(quote.vehicle.purchaseMethods, showroomQuote.items, availableItems)));
}

function resetQuoteFromShowroomLoad(quote, showroomQuote, disclaimers) {
    var pricingSummary = showroomQuote.pricingSummary,
        financingSummary = showroomQuote.financingSummary,
        tradeIns = showroomQuote.tradeIns,
        purchaseMethod = showroomQuote.purchaseMethod,
        purchaseMethods = showroomQuote.purchaseMethods;


    var vehicle = (0, _VehicleService.resetVehicleFromShowroomQuoteVehicle)(showroomQuote);
    if (!(0, _lodash.isEmpty)(purchaseMethods)) {
        var selectedPurchaseMethod = _purchaseMethods.CASH_PURCHASE;
        if (purchaseMethod === _purchaseMethodsValues2.default.LEASE || purchaseMethod === _purchaseMethodsValues2.default.SINGLE_PAYMENT_LEASE) {
            selectedPurchaseMethod = _purchaseMethods.LEASE;
        } else if (purchaseMethod === _purchaseMethodsValues2.default.FINANCE || purchaseMethod === _purchaseMethodsValues2.default.FINANCE_WITH_BALLOON) {
            selectedPurchaseMethod = _purchaseMethods.FINANCE;
        }

        var quotePurchaseMethods = selectedPurchaseMethod === _purchaseMethods.CASH_PURCHASE ? (0, _PurchaseMethodsService.selectPurchaseMethod)((0, _PurchaseMethodsService.resetPurchaseMethodsFromOriginData)(DataOrigins.VEHICLE_PAYMENTS, purchaseMethods, null, disclaimers), selectedPurchaseMethod) : (0, _PurchaseMethodsService.selectPurchaseMethod)((0, _PurchaseMethodsService.resetPurchaseMethodsFromOriginData)(DataOrigins.VEHICLE_PAYMENTS, purchaseMethods, null, disclaimers), selectedPurchaseMethod);

        if (selectedPurchaseMethod !== _purchaseMethods.CASH_PURCHASE) {
            quotePurchaseMethods = (0, _PurchaseMethodsService.selectTerm)(quotePurchaseMethods, financingSummary.term);
            quotePurchaseMethods = (0, _PurchaseMethodsService.selectPaymentFrequency)(quotePurchaseMethods, financingSummary.paymentsPerYear);
            quotePurchaseMethods = (0, _PurchaseMethodsService.setCashDown)(quotePurchaseMethods, pricingSummary.cashDown);
            if (financingSummary.annualKMAllowed > 0) {
                quotePurchaseMethods = (0, _PurchaseMethodsService.selectKMPlan)(quotePurchaseMethods, financingSummary.annualKMAllowed);
            }
        }
        quotePurchaseMethods = (0, _PurchaseMethodsService.setTradeIn)(quotePurchaseMethods, tradeIns.amountSummary.tradeIn);
        quotePurchaseMethods = (0, _PurchaseMethodsService.setLien)(quotePurchaseMethods, tradeIns.amountSummary.lien);

        vehicle = vehicle.set('purchaseMethods', quotePurchaseMethods);
    }

    var newQuote = quote.set('location', showroomQuote.location).set('status', showroomQuote.status).set('creditApplicationId', showroomQuote.creditApplicationId).set('vehicleId', String(showroomQuote.vehicleId || '')).set('vehicle', vehicle);

    return resetQuoteFromShowroomSave(newQuote, showroomQuote);
}

function resetQuoteDepositLead(quote, depositResponse) {
    return quote.set('status', quote.status | _statuses.CHECKOUT_WITH_DEPOSIT).set('leadId', String(depositResponse.leadId)).set('creditCardChargeId', depositResponse.stripeChargeId).setIn(['vehicle', 'purchaseMethods'], (0, _PurchaseMethodsService.setDeposit)(quote.vehicle.purchaseMethods, {
        checkout: true,
        override: depositResponse.depositAmount
    }));
}

function resetQuoteCreditApplication(quote, creditApplicationId) {
    return quote.set('creditApplicationId', creditApplicationId);
}

function getEmployeeRebateFromShowroomQuote(showroomQuote) {
    if (!(0, _lodash.isObjectLike)(showroomQuote) || (0, _lodash.isEmpty)(showroomQuote) || (0, _lodash.isEmpty)(showroomQuote.items)) {
        return null;
    }

    var employeeRebates = (0, _lodash.filter)(showroomQuote.items, function (item) {
        return item.dataType === _dataTypes.DATA_TYPES.REBATE.DATA_TYPE_ID && item.typeID === _dataTypes.DATA_TYPES.REBATE.TYPES.EMPLOYEE;
    });

    if ((0, _lodash.isEmpty)(employeeRebates)) {
        return null;
    }

    return {
        description: employeeRebates[0].description.descriptions[0],
        rebate: (0, _lodash.sumBy)(employeeRebates, function (employeeRebate) {
            return employeeRebate.amounts.retail;
        })
    };
}

function quoteHasVehicle(quote) {
    return quote && quote.vehicle && quote.vehicle.year && !(0, _lodash.isEmpty)(quote.vehicle.make) && !(0, _lodash.isEmpty)(quote.vehicle.model);
}

exports.default = {
    QuoteService: new QuoteService(),
    resetQuoteFromModelYear: resetQuoteFromModelYear,
    resetQuoteFromVehicle: resetQuoteFromVehicle,
    resetQuoteFromShowroomSave: resetQuoteFromShowroomSave,
    resetQuoteFromShowroomLoad: resetQuoteFromShowroomLoad,
    resetQuoteDepositLead: resetQuoteDepositLead,
    resetQuoteCreditApplication: resetQuoteCreditApplication,
    getEmployeeRebateFromShowroomQuote: getEmployeeRebateFromShowroomQuote,
    quoteHasVehicle: quoteHasVehicle
};

/***/ }),

/***/ "./src/Vehicle/actions/tradeInVehicleActionTypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var SET_TRADE_IN_VEHICLE = exports.SET_TRADE_IN_VEHICLE = 'SET_TRADE_IN_VEHICLE';

exports.default = {
    SET_TRADE_IN_VEHICLE: SET_TRADE_IN_VEHICLE
};

/***/ }),

/***/ "./src/Vehicle/actions/tradeInVehicleActions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setTradeInVehicle = setTradeInVehicle;
exports.saveTradeInVehicle = saveTradeInVehicle;
exports.loadTradeInVehicle = loadTradeInVehicle;

var _tradeInVehicleActionTypes = __webpack_require__("./src/Vehicle/actions/tradeInVehicleActionTypes.js");

var tradeInVehicleTypes = _interopRequireWildcard(_tradeInVehicleActionTypes);

var _TradeInVehicleAPIService = __webpack_require__("./src/Vehicle/services/TradeInVehicleAPIService/TradeInVehicleAPIService.js");

var _TradeInVehicleAPIService2 = _interopRequireDefault(_TradeInVehicleAPIService);

var _TradeInVehicleService = __webpack_require__("./src/Vehicle/services/TradeInVehicleService/TradeInVehicleService.js");

var TradeInVehicleService = _interopRequireWildcard(_TradeInVehicleService);

var _quoteActions = __webpack_require__("./src/Quote/actions/quoteActions.js");

var _PurchaseMethodsModel = __webpack_require__("./src/PurchaseMethods/models/PurchaseMethodsModel.js");

var _PurchaseMethodsModel2 = _interopRequireDefault(_PurchaseMethodsModel);

var _purchaseMethodsActions = __webpack_require__("./src/PurchaseMethods/actions/purchaseMethodsActions.js");

var PurchaseMethodsActions = _interopRequireWildcard(_purchaseMethodsActions);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _tradeInVehicleStatuses = __webpack_require__("./src/Vehicle/constants/tradeInVehicleStatuses.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function setTradeInVehicle(tradeInVehicle) {
    return { type: tradeInVehicleTypes.SET_TRADE_IN_VEHICLE, tradeInVehicle: tradeInVehicle };
}

function saveTradeInVehicle(tradeInVehicle) {
    return function (dispatch) {
        _TradeInVehicleAPIService2.default.saveTradeInVehicle(tradeInVehicle).then(function (result) {
            var $window = _widgetCommonsCoreServices.WindowProxy.get();
            if ($window) {
                $window.document.dispatchEvent(new CustomEvent(_widgetCommonsGeneral.EVENTS.TRADEIN_CREATED));
            }
            dispatch((0, _quoteActions.setQuoteRevision)(result.data.updatedQuotes));
            dispatch(setTradeInVehicle(tradeInVehicle.set('modified', false)));
        });
    };
}

function loadTradeInVehicle(stateTradeInVehicle, tradeInVehicleId) {
    return function (dispatch) {
        return _TradeInVehicleAPIService2.default.loadTradeInVehicle(tradeInVehicleId).then(function (tradeInVehicle) {
            var isEmptyTradeIn = !stateTradeInVehicle.id;
            var newTradeInVehicle = tradeInVehicle;
            var defaultPurchaseMethods = new _PurchaseMethodsModel2.default();
            var stateTradeInAmount = isEmptyTradeIn ? defaultPurchaseMethods.tradeIn : stateTradeInVehicle.getTradeInAmount();
            var stateLienAmount = isEmptyTradeIn ? defaultPurchaseMethods.lien : stateTradeInVehicle.getLienAmount();
            var loadedTradeInAmount = tradeInVehicle.getTradeInAmount();
            var loadedLienAmount = tradeInVehicle.getLienAmount();
            var isActivatedTradeIn = newTradeInVehicle.getUpdateStatus() === _tradeInVehicleStatuses.UPDATE_STATUS.ACTIVATED;
            var isDescribedTradeIn = newTradeInVehicle.getUpdateStatus() === _tradeInVehicleStatuses.UPDATE_STATUS.DESCRIBED;

            if (stateTradeInAmount !== loadedTradeInAmount || stateLienAmount !== loadedLienAmount) {
                if (stateTradeInAmount > 0 && (isActivatedTradeIn || isDescribedTradeIn)) {
                    newTradeInVehicle = TradeInVehicleService.setTradeIn(newTradeInVehicle, stateTradeInAmount);
                    newTradeInVehicle = TradeInVehicleService.setLien(newTradeInVehicle, stateLienAmount);
                    if (isEmptyTradeIn) {
                        dispatch(PurchaseMethodsActions.setTradeIn(stateTradeInAmount));
                        dispatch(PurchaseMethodsActions.setLien(stateLienAmount));
                    }
                } else {
                    dispatch(PurchaseMethodsActions.setTradeIn(newTradeInVehicle.getTradeInAmount()));
                    dispatch(PurchaseMethodsActions.setLien(newTradeInVehicle.getLienAmount()));
                }
            } else if (isEmptyTradeIn && isActivatedTradeIn && !stateTradeInAmount && !loadedTradeInAmount && !stateLienAmount && !loadedLienAmount) {
                newTradeInVehicle = TradeInVehicleService.setTradeIn(newTradeInVehicle, 0);
                newTradeInVehicle = TradeInVehicleService.setLien(newTradeInVehicle, 0);
                dispatch(PurchaseMethodsActions.setTradeIn(0));
                dispatch(PurchaseMethodsActions.setLien(0));
            }

            dispatch(setTradeInVehicle(newTradeInVehicle));
            if (newTradeInVehicle.id && newTradeInVehicle.modified) {
                dispatch(saveTradeInVehicle(newTradeInVehicle));
            }
        });
    };
}

exports.default = {
    setTradeInVehicle: setTradeInVehicle,
    saveTradeInVehicle: saveTradeInVehicle,
    loadTradeInVehicle: loadTradeInVehicle
};

/***/ }),

/***/ "./src/Vehicle/actions/vehicleActionTypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var SET_VEHICLE = exports.SET_VEHICLE = 'SET_VEHICLE';
var SET_VEHICLE_PURCHASE_METHODS = exports.SET_VEHICLE_PURCHASE_METHODS = 'SET_VEHICLE_PURCHASE_METHODS';

exports.default = {
    SET_VEHICLE: SET_VEHICLE,
    SET_VEHICLE_PURCHASE_METHODS: SET_VEHICLE_PURCHASE_METHODS
};

/***/ }),

/***/ "./src/Vehicle/actions/vehicleActions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setVehicle = setVehicle;
exports.setPurchaseMethods = setPurchaseMethods;

var _vehicleActionTypes = __webpack_require__("./src/Vehicle/actions/vehicleActionTypes.js");

var vehicleTypes = _interopRequireWildcard(_vehicleActionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function setVehicle(vehicle) {
    return { type: vehicleTypes.SET_VEHICLE, vehicle: vehicle };
}

function setPurchaseMethods(purchaseMethods) {
    return { type: vehicleTypes.SET_VEHICLE_PURCHASE_METHODS, purchaseMethods: purchaseMethods };
}

exports.default = {
    setVehicle: setVehicle,
    setPurchaseMethods: setPurchaseMethods
};

/***/ }),

/***/ "./src/Vehicle/components/CallToAction/Appointment/AppointmentCTA.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("lodash");

var _base = __webpack_require__("../../node_modules/base-64/base64.js");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _QuoteModel = __webpack_require__("./src/Quote/models/QuoteModel.js");

var _QuoteModel2 = _interopRequireDefault(_QuoteModel);

var _QuoteService = __webpack_require__("./src/Quote/services/QuoteService/QuoteService.js");

var _QuoteService2 = _interopRequireDefault(_QuoteService);

var _ShowroomService = __webpack_require__("./src/services/ShowroomService/ShowroomService.js");

var _ShowroomService2 = _interopRequireDefault(_ShowroomService);

__webpack_require__("./src/Vehicle/components/CallToAction/VehicleCtaBar/VehicleCtaBar.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AppointmentCTA = function (_React$Component) {
    _inherits(AppointmentCTA, _React$Component);

    function AppointmentCTA(props) {
        _classCallCheck(this, AppointmentCTA);

        var _this = _possibleConstructorReturn(this, (AppointmentCTA.__proto__ || Object.getPrototypeOf(AppointmentCTA)).call(this, props));

        _this.onAppointmentClick = _this.onAppointmentClick.bind(_this);
        return _this;
    }

    _createClass(AppointmentCTA, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var locale = _widgetCommonsCoreServices.LocaleService.getSimpleLocale();
            this.redirect = _widgetCommonsGeneral.REDIRECTIONS[locale].appointment;
        }
    }, {
        key: 'onAppointmentClick',
        value: function onAppointmentClick() {
            var _props = this.props,
                quote = _props.quote,
                onClick = _props.onClick,
                onEndProcessGaTag = _props.onEndProcessGaTag;


            onClick();

            var locale = _widgetCommonsCoreServices.LocaleService.getSimpleLocale();
            var url = _widgetCommonsGeneral.REDIRECTIONS[locale].appointment;
            var mappedQuote = quote.getShowroomQuote();
            return _ShowroomService2.default.saveQuote(mappedQuote).then(function (showroomQuote) {
                var newQuote = _QuoteService2.default.resetQuoteFromShowroomSave(quote, showroomQuote);
                var windowProxy = _widgetCommonsCoreServices.WindowProxy.get();

                if (windowProxy) {
                    var historyUrl = newQuote.buildUrl(windowProxy.location.href);

                    windowProxy.history.replaceState({
                        quote: mappedQuote
                    }, 'tradeIn', historyUrl);

                    var fullUrl = newQuote.buildUrl(url);
                    if (onEndProcessGaTag) {
                        fullUrl += '&' + _widgetCommonsCoreServices.UrlService.encodeUriParameter('onEndProcessGaTag', (0, _base.encode)(JSON.stringify(onEndProcessGaTag)));
                    }

                    if (_widgetCommonsCoreServices.ConfigsService.isInMobileApp() && !_widgetCommonsGeneral.AccountService.isAuthenticated()) {
                        windowProxy.location.href = 'ca.solutionsmedias360.showroom-' + _widgetCommonsCoreServices.ConfigsService.getWebsiteId() + '://' + ('?action=login&redirectUrl=' + encodeURIComponent(fullUrl));
                    } else {
                        windowProxy.location.href = fullUrl;
                    }
                }
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                iconClass = _props2.iconClass,
                buttonClass = _props2.buttonClass,
                alternativeLabel = _props2.alternativeLabel;

            var currentClass = [buttonClass, 'vehicle-cta-btn'];
            return _react2.default.createElement(
                'button',
                { className: currentClass.join(' '), onClick: this.onAppointmentClick },
                iconClass && _react2.default.createElement('icon', { className: iconClass }),
                _react2.default.createElement(
                    'span',
                    null,
                    alternativeLabel || _widgetCommonsCoreServices.LocaleService.t('CALL_TO_ACTION.BTN_BOOK_APPOINTMENT_TITLE')
                )
            );
        }
    }]);

    return AppointmentCTA;
}(_react2.default.Component);

AppointmentCTA.defaultProps = {
    alternativeLabel: '',
    buttonClass: 'sr-button-2',
    iconClass: null,
    onClick: _lodash.noop,
    onEndProcessGaTag: null
};

AppointmentCTA.propTypes = {
    alternativeLabel: _propTypes2.default.string,
    buttonClass: _propTypes2.default.string,
    quote: _propTypes2.default.instanceOf(_QuoteModel2.default).isRequired,
    iconClass: _propTypes2.default.string,
    onClick: _propTypes2.default.func,
    onEndProcessGaTag: _propTypes2.default.shape({
        category: _propTypes2.default.string.isRequired,
        action: _propTypes2.default.string.isRequired,
        label: _propTypes2.default.string.isRequired
    })
};

AppointmentCTA.displayName = 'AppointmentCTA';

exports.default = AppointmentCTA;

/***/ }),

/***/ "./src/Vehicle/components/CallToAction/BuyOnline/BuyOnlineCTA.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _base = __webpack_require__("../../node_modules/base-64/base64.js");

var _lodash = __webpack_require__("lodash");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _QuoteModel = __webpack_require__("./src/Quote/models/QuoteModel.js");

var _QuoteModel2 = _interopRequireDefault(_QuoteModel);

var _QuoteService = __webpack_require__("./src/Quote/services/QuoteService/QuoteService.js");

var _QuoteService2 = _interopRequireDefault(_QuoteService);

var _ShowroomService = __webpack_require__("./src/services/ShowroomService/ShowroomService.js");

var _ShowroomService2 = _interopRequireDefault(_ShowroomService);

__webpack_require__("./src/Vehicle/components/CallToAction/VehicleCtaBar/VehicleCtaBar.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BuyOnlineCTA = function (_React$Component) {
    _inherits(BuyOnlineCTA, _React$Component);

    function BuyOnlineCTA(props) {
        _classCallCheck(this, BuyOnlineCTA);

        var _this = _possibleConstructorReturn(this, (BuyOnlineCTA.__proto__ || Object.getPrototypeOf(BuyOnlineCTA)).call(this, props));

        _this.buyOnline = _this.buyOnline.bind(_this);
        _this.onBuyOnline = _this.onBuyOnline.bind(_this);
        _this.saveQuote = _this.saveQuote.bind(_this);
        return _this;
    }

    _createClass(BuyOnlineCTA, [{
        key: 'onBuyOnline',
        value: function onBuyOnline() {
            this.props.onClick();
            if (_widgetCommonsCoreServices.ConfigsService.isInMobileApp()) {
                this.saveQuote();
            } else if (!_widgetCommonsGeneral.AccountService.isAuthenticated()) {
                var LoginModal = _widgetCommonsGeneral.ModalService.get('login/SignUpModal');
                LoginModal.addCallbacks({
                    onClose: this.buyOnline
                });
                LoginModal.open();
            } else {
                this.saveQuote();
            }
        }
    }, {
        key: 'buyOnline',
        value: function buyOnline() {
            if (_widgetCommonsGeneral.AccountService.isAuthenticated()) {
                this.saveQuote();
            }
            return true;
        }
    }, {
        key: 'saveQuote',
        value: function saveQuote() {
            var _props = this.props,
                quote = _props.quote,
                onEndProcessGaTag = _props.onEndProcessGaTag;

            var locale = _widgetCommonsCoreServices.LocaleService.getSimpleLocale();
            var url = _widgetCommonsGeneral.REDIRECTIONS[locale].checkout;
            var mappedQuote = quote.getShowroomQuote();

            return _ShowroomService2.default.saveQuote(mappedQuote).then(function (showroomQuote) {
                var windowProxy = _widgetCommonsCoreServices.WindowProxy.get();

                if (windowProxy) {
                    var newQuote = _QuoteService2.default.resetQuoteFromShowroomSave(quote, showroomQuote);
                    var historyUrl = newQuote.buildUrl(windowProxy.location.href);

                    windowProxy.history.replaceState({
                        quote: mappedQuote
                    }, 'tradeIn', historyUrl);

                    var fullUrl = newQuote.buildUrl(url);
                    if (onEndProcessGaTag) {
                        fullUrl += '&' + _widgetCommonsCoreServices.UrlService.encodeUriParameter('onEndProcessGaTag', (0, _base.encode)(JSON.stringify(onEndProcessGaTag)));
                    }

                    if (_widgetCommonsCoreServices.ConfigsService.isInMobileApp() && !_widgetCommonsGeneral.AccountService.isAuthenticated()) {
                        windowProxy.location.href = 'ca.solutionsmedias360.showroom-' + _widgetCommonsCoreServices.ConfigsService.getWebsiteId() + '://' + ('?action=login&redirectUrl=' + encodeURIComponent(fullUrl));
                    } else {
                        windowProxy.location.href = fullUrl;
                    }
                }
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var iconClass = this.props.iconClass;

            var currentClass = ['btn-get-started', this.props.buttonClass, 'vehicle-cta-btn'];
            return _react2.default.createElement(
                'button',
                { className: currentClass.join(' '), type: 'button', onClick: this.onBuyOnline },
                iconClass && _react2.default.createElement('icon', { className: iconClass }),
                _react2.default.createElement(
                    'span',
                    null,
                    this.props.alternativeLabel || _widgetCommonsCoreServices.LocaleService.t('CALL_TO_ACTION.BTN_BUY_ONLINE_TITLE')
                )
            );
        }
    }]);

    return BuyOnlineCTA;
}(_react2.default.Component);

BuyOnlineCTA.defaultProps = {
    alternativeLabel: '',
    buttonClass: 'sr-button-1',
    iconClass: null,
    onClick: _lodash.noop,
    onEndProcessGaTag: null
};

BuyOnlineCTA.propTypes = {
    alternativeLabel: _propTypes2.default.string,
    buttonClass: _propTypes2.default.string,
    quote: _propTypes2.default.instanceOf(_QuoteModel2.default).isRequired,
    iconClass: _propTypes2.default.string,
    onClick: _propTypes2.default.func,
    onEndProcessGaTag: _propTypes2.default.shape({
        category: _propTypes2.default.string.isRequired,
        action: _propTypes2.default.string.isRequired,
        label: _propTypes2.default.string.isRequired
    })
};

BuyOnlineCTA.displayName = 'BuyOnlineCTA';

exports.default = BuyOnlineCTA;

/***/ }),

/***/ "./src/Vehicle/components/CallToAction/PriceQuote/PriceQuoteCTA.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _vehicle = __webpack_require__("./src/constants/vehicle.js");

var _vehicle2 = _interopRequireDefault(_vehicle);

var _VehicleModel = __webpack_require__("./src/Vehicle/models/VehicleModel.js");

var _VehicleModel2 = _interopRequireDefault(_VehicleModel);

__webpack_require__("./src/Vehicle/components/CallToAction/VehicleCtaBar/VehicleCtaBar.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PriceQuoteCTA = function PriceQuoteCTA(_ref) {
    var vehicle = _ref.vehicle,
        buttonClass = _ref.buttonClass,
        alternativeLabel = _ref.alternativeLabel,
        iconClass = _ref.iconClass;

    var locale = _widgetCommonsCoreServices.LocaleService.getSimpleLocale();
    var isVehicleNew = vehicle.vehicleConditionType === _vehicle2.default.CONDITIONS.NEW;
    var priceQuoteUrl = isVehicleNew ? _widgetCommonsGeneral.REDIRECTIONS[locale].priceQuoteFormNew : _widgetCommonsGeneral.REDIRECTIONS[locale].priceQuoteFormUsed;
    priceQuoteUrl = _widgetCommonsCoreServices.UrlService.replaceParamWithValue(priceQuoteUrl, '{make}', vehicle.make);
    priceQuoteUrl = _widgetCommonsCoreServices.UrlService.replaceParamWithValue(priceQuoteUrl, '{model}', vehicle.model);
    priceQuoteUrl = _widgetCommonsCoreServices.UrlService.replaceParamWithValue(priceQuoteUrl, '{year}', vehicle.year);
    priceQuoteUrl = _widgetCommonsCoreServices.UrlService.replaceParamWithValue(priceQuoteUrl, '{trim}', vehicle.modelTrim);
    priceQuoteUrl = _widgetCommonsCoreServices.UrlService.replaceParamWithValue(priceQuoteUrl, '{stock}', vehicle.stockNumber);
    priceQuoteUrl = _widgetCommonsCoreServices.UrlService.replaceParamWithValue(priceQuoteUrl, '{id}', vehicle.vehicleId);
    priceQuoteUrl = priceQuoteUrl.replace(/\s/g, '-');

    var currentClass = [buttonClass, 'vehicle-cta-btn'];
    return _react2.default.createElement(
        'a',
        { href: priceQuoteUrl, className: currentClass.join(' ') },
        iconClass && _react2.default.createElement('icon', { className: iconClass }),
        _react2.default.createElement(
            'span',
            null,
            alternativeLabel || _widgetCommonsCoreServices.LocaleService.t('CALL_TO_ACTION.BTN_PRICE_QUOTE_TEXT')
        )
    );
};

PriceQuoteCTA.defaultProps = {
    buttonClass: 'sr-button-1',
    alternativeLabel: null,
    iconClass: null
};

PriceQuoteCTA.propTypes = {
    vehicle: _propTypes2.default.instanceOf(_VehicleModel2.default).isRequired,
    buttonClass: _propTypes2.default.string,
    alternativeLabel: _propTypes2.default.string,
    iconClass: _propTypes2.default.string
};

PriceQuoteCTA.displayName = 'PriceQuoteCTA';

exports.default = PriceQuoteCTA;

/***/ }),

/***/ "./src/Vehicle/components/CallToAction/TradeIn/TradeInCTA.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _QuoteModel = __webpack_require__("./src/Quote/models/QuoteModel.js");

var _QuoteModel2 = _interopRequireDefault(_QuoteModel);

var _QuoteService = __webpack_require__("./src/Quote/services/QuoteService/QuoteService.js");

var _QuoteService2 = _interopRequireDefault(_QuoteService);

var _ShowroomService = __webpack_require__("./src/services/ShowroomService/ShowroomService.js");

var _ShowroomService2 = _interopRequireDefault(_ShowroomService);

__webpack_require__("./src/Vehicle/components/CallToAction/VehicleCtaBar/VehicleCtaBar.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TradeInCTA = function (_React$Component) {
    _inherits(TradeInCTA, _React$Component);

    function TradeInCTA(props) {
        _classCallCheck(this, TradeInCTA);

        var _this = _possibleConstructorReturn(this, (TradeInCTA.__proto__ || Object.getPrototypeOf(TradeInCTA)).call(this, props));

        _this.onTradeInClick = _this.onTradeInClick.bind(_this);
        _this.redirectToTradeIn = _this.redirectToTradeIn.bind(_this);
        _this.saveQuoteAndRedirect = _this.saveQuoteAndRedirect.bind(_this);
        return _this;
    }

    _createClass(TradeInCTA, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var locale = _widgetCommonsCoreServices.LocaleService.getSimpleLocale();
            this.redirect = _widgetCommonsGeneral.REDIRECTIONS[locale].tradeIn;
        }
    }, {
        key: 'onTradeInClick',
        value: function onTradeInClick() {
            var _this2 = this;

            if (!_widgetCommonsGeneral.AccountService.isAuthenticated()) {
                var LoginModal = _widgetCommonsGeneral.ModalService.get('login/SignUpModal');
                LoginModal.addCallbacks({
                    onClose: function onClose() {
                        if (_widgetCommonsGeneral.AccountService.isAuthenticated()) {
                            return _this2.saveQuoteAndRedirect();
                        }
                        return true;
                    }
                });
                LoginModal.open();
            } else {
                this.saveQuoteAndRedirect();
            }
        }
    }, {
        key: 'redirectToTradeIn',
        value: function redirectToTradeIn(showroomQuote) {
            var locale = _widgetCommonsCoreServices.LocaleService.getSimpleLocale();
            var url = _widgetCommonsGeneral.REDIRECTIONS[locale].tradeIn;
            var windowProxy = _widgetCommonsCoreServices.WindowProxy.get();

            var fullUrl = url;
            if (windowProxy && showroomQuote) {
                var newQuote = _QuoteService2.default.resetQuoteFromShowroomSave(this.props.quote, showroomQuote);
                var historyUrl = newQuote.buildUrl(windowProxy.location.href);

                windowProxy.history.replaceState({
                    quote: this.props.quote.getShowroomQuote()
                }, 'tradeIn', historyUrl);

                fullUrl = newQuote.buildUrl(url);
            }

            if (_widgetCommonsCoreServices.ConfigsService.isInMobileApp() && !_widgetCommonsGeneral.AccountService.isAuthenticated()) {
                windowProxy.location.href = 'ca.solutionsmedias360.showroom-' + _widgetCommonsCoreServices.ConfigsService.getWebsiteId() + '://' + ('?action=login&redirectUrl=' + encodeURIComponent(fullUrl));
            } else {
                windowProxy.location.href = fullUrl;
            }
        }
    }, {
        key: 'saveQuoteAndRedirect',
        value: function saveQuoteAndRedirect() {
            if (this.props.quote) {
                _ShowroomService2.default.saveQuote(this.props.quote.getShowroomQuote()).then(this.redirectToTradeIn);
            } else {
                this.redirectToTradeIn();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var currentClass = [this.props.buttonClass, 'vehicle-cta-btn'];
            return _react2.default.createElement(
                'button',
                { className: currentClass.join(' '), onClick: this.onTradeInClick },
                _react2.default.createElement(
                    'span',
                    null,
                    _widgetCommonsCoreServices.LocaleService.t('CALL_TO_ACTION.BTN_EXCHANGE_TITLE')
                )
            );
        }
    }]);

    return TradeInCTA;
}(_react2.default.Component);

TradeInCTA.defaultProps = {
    buttonClass: 'sr-button-2'
};

TradeInCTA.propTypes = {
    buttonClass: _propTypes2.default.string,
    quote: _propTypes2.default.instanceOf(_QuoteModel2.default).isRequired
};

TradeInCTA.displayName = 'TradeInCTA';

exports.default = TradeInCTA;

/***/ }),

/***/ "./src/Vehicle/components/CallToAction/VehicleCtaBar/VehicleCtaBar.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactResponsive = __webpack_require__("../../node_modules/react-responsive/dist/react-responsive.js");

var _reactResponsive2 = _interopRequireDefault(_reactResponsive);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _QuoteModel = __webpack_require__("./src/Quote/models/QuoteModel.js");

var _QuoteModel2 = _interopRequireDefault(_QuoteModel);

var _AddToGarageButton = __webpack_require__("./src/Quote/components/AddToGarage/AddToGarageButton.jsx");

var _AddToGarageButton2 = _interopRequireDefault(_AddToGarageButton);

var _AppointmentCTA = __webpack_require__("./src/Vehicle/components/CallToAction/Appointment/AppointmentCTA.jsx");

var _AppointmentCTA2 = _interopRequireDefault(_AppointmentCTA);

var _BuyOnlineCTA = __webpack_require__("./src/Vehicle/components/CallToAction/BuyOnline/BuyOnlineCTA.jsx");

var _BuyOnlineCTA2 = _interopRequireDefault(_BuyOnlineCTA);

var _TradeInCTA = __webpack_require__("./src/Vehicle/components/CallToAction/TradeIn/TradeInCTA.jsx");

var _TradeInCTA2 = _interopRequireDefault(_TradeInCTA);

__webpack_require__("./src/Vehicle/components/CallToAction/VehicleCtaBar/VehicleCtaBar.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VehicleCtaBar = function VehicleCtaBar(_ref) {
    var quote = _ref.quote,
        actions = _ref.actions;

    var trackBuyOnlineCta = function trackBuyOnlineCta() {
        return _widgetCommonsGeneral.AnalyticsService.gaTrigger(_widgetCommonsGeneral.TRACKING_TAGS.RESERVE_IT_NOW_CTA_NEW(quote.vehicle.model));
    };

    var trackBuyOnlineCtaOnEndProcessGaTag = _widgetCommonsGeneral.TRACKING_TAGS.RESERVE_IT_NOW_PROCESS_ENDED_NEW(undefined.props.quote.vehicle.model);

    var trackAppointmentCta = function trackAppointmentCta() {
        return _widgetCommonsGeneral.AnalyticsService.gaTrigger(_widgetCommonsGeneral.TRACKING_TAGS.PREPARE_YOUR_VISIT_CTA_NEW(quote.vehicle.model));
    };

    var appointmentCtaOnEndProcessGaTag = _widgetCommonsGeneral.TRACKING_TAGS.PREPARE_YOUR_VISIT_PROCESS_ENDED_NEW(undefined.props.selectedModel.model);
    return _react2.default.createElement(
        'div',
        { className: 'build-and-quote-sticky-cta-link' },
        _react2.default.createElement(
            _reactResponsive2.default,
            { maxWidth: 768 },
            _react2.default.createElement(_AddToGarageButton2.default, { quote: quote, onClick: actions.setQuoteLead })
        ),
        _react2.default.createElement(_TradeInCTA2.default, { quote: quote }),
        _react2.default.createElement(_AppointmentCTA2.default, {
            quote: quote,
            iconClass: 'icon-calendar',
            onClick: trackAppointmentCta,
            onEndProcessGaTag: appointmentCtaOnEndProcessGaTag
        }),
        _react2.default.createElement(_BuyOnlineCTA2.default, {
            quote: quote,
            iconClass: 'icon-shopping-cart',
            onClick: trackBuyOnlineCta,
            onEndProcessGaTag: trackBuyOnlineCtaOnEndProcessGaTag
        })
    );
};

VehicleCtaBar.propTypes = {
    actions: _propTypes2.default.shape({
        setQuoteLead: _propTypes2.default.func.isRequired
    }).isRequired,
    quote: _propTypes2.default.instanceOf(_QuoteModel2.default).isRequired
};

VehicleCtaBar.displayName = 'VehicleCtaBar';

exports.default = VehicleCtaBar;

/***/ }),

/***/ "./src/Vehicle/components/CallToAction/VehicleCtaBar/VehicleCtaBar.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/Vehicle/components/LightboxCarrousel/LightboxCarrousel.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LightboxCarrousel = function (_React$Component) {
    _inherits(LightboxCarrousel, _React$Component);

    function LightboxCarrousel(props) {
        _classCallCheck(this, LightboxCarrousel);

        var _this = _possibleConstructorReturn(this, (LightboxCarrousel.__proto__ || Object.getPrototypeOf(LightboxCarrousel)).call(this, props));

        _this.state = {
            currentImageIndex: props.imageIndex
        };

        _this.gotoNext = _this.gotoNext.bind(_this);
        _this.gotoPrevious = _this.gotoPrevious.bind(_this);
        _this.openLightBox = _this.openLightBox.bind(_this);
        return _this;
    }

    _createClass(LightboxCarrousel, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(newProps) {
            if (this.props === newProps) {
                return;
            }

            this.setState({
                currentImageIndex: newProps.imageIndex
            });
        }

        // TODO: #improvement - Check if this method is still relevant/necessary

    }, {
        key: 'openLightBox',
        value: function openLightBox(index, event) {
            event.preventDefault();
            this.setState({
                currentImageIndex: index
            });
        }
    }, {
        key: 'gotoPrevious',
        value: function gotoPrevious() {
            var _this2 = this;

            this.setState(function (prevState) {
                var prevIndex = prevState.currentImageIndex > 0 ? prevState.currentImageIndex - 1 : _this2.props.pictures.length - 1;
                return { currentImageIndex: prevIndex };
            });
        }
    }, {
        key: 'gotoNext',
        value: function gotoNext() {
            var _this3 = this;

            this.setState(function (prevState) {
                var nextIndex = prevState.currentImageIndex < _this3.props.pictures.length - 1 ? prevState.currentImageIndex + 1 : 0;
                return { currentImageIndex: nextIndex };
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                pictures = _props.pictures,
                toggleLightBox = _props.toggleLightBox;
            var currentImageIndex = this.state.currentImageIndex;

            var lightBoxImages = pictures.map(function (image) {
                return image.src;
            });
            var nextImageIndex = currentImageIndex < pictures.length - 1 ? currentImageIndex + 1 : 0;
            var prevImageIndex = currentImageIndex > 0 ? currentImageIndex - 1 : pictures.length - 1;

            return _react2.default.createElement(_widgetCommonsGeneral.LightBox, {
                mainSrc: lightBoxImages[currentImageIndex],
                nextSrc: lightBoxImages[nextImageIndex],
                prevSrc: lightBoxImages[prevImageIndex],
                onCloseRequest: toggleLightBox,
                onMovePrevRequest: this.gotoPrevious,
                onMoveNextRequest: this.gotoNext,
                enableZoom: false
            });
        }
    }]);

    return LightboxCarrousel;
}(_react2.default.Component);

LightboxCarrousel.defaultProps = {
    pictures: []
};

LightboxCarrousel.propTypes = {
    imageIndex: _propTypes2.default.number.isRequired,
    pictures: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        src: _propTypes2.default.string
    })),
    toggleLightBox: _propTypes2.default.func.isRequired
};

LightboxCarrousel.displayName = 'LightboxCarrousel';

exports.default = LightboxCarrousel;

/***/ }),

/***/ "./src/Vehicle/components/Overview/Overview.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _PaymentSummary = __webpack_require__("./src/Vehicle/components/Overview/PaymentSummary/PaymentSummary.jsx");

var _PaymentSummary2 = _interopRequireDefault(_PaymentSummary);

var _QuoteModel = __webpack_require__("./src/Quote/models/QuoteModel.js");

var _QuoteModel2 = _interopRequireDefault(_QuoteModel);

__webpack_require__("./src/Vehicle/components/Overview/Overview.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Overview = function Overview(_ref) {
    var imageUrl = _ref.imageUrl,
        isUsed = _ref.isUsed,
        isReserved = _ref.isReserved,
        optionalButton = _ref.optionalButton,
        optionalBuyCta = _ref.optionalBuyCta,
        optionalAppointmentCta = _ref.optionalAppointmentCta,
        packageName = _ref.packageName,
        purchaseMethods = _ref.purchaseMethods,
        quote = _ref.quote,
        taxCodes = _ref.taxCodes,
        title = _ref.title,
        sectionTitle = _ref.sectionTitle,
        subTitleElement = _ref.subTitleElement;

    return _react2.default.createElement(
        'div',
        { className: 'vehicle-overview__wrapper' },
        _react2.default.createElement(
            'p',
            { className: 'sr-title-2 is-centered vehicle-overview__title' },
            sectionTitle
        ),
        subTitleElement,
        _react2.default.createElement(_PaymentSummary2.default, {
            title: title,
            imageUrl: imageUrl,
            packageName: packageName,
            isReserved: isReserved,
            purchaseMethods: purchaseMethods,
            taxCodes: taxCodes,
            optionalButton: optionalButton,
            quote: quote,
            optionalBuyCta: optionalBuyCta,
            optionalAppointmentCta: optionalAppointmentCta,
            isUsed: isUsed
        })
    );
};

Overview.defaultProps = {
    imageUrl: 'null',
    isUsed: false,
    isReserved: false,
    optionalButton: false,
    optionalBuyCta: '',
    optionalAppointmentCta: '',
    packageName: '',
    quote: '',
    sectionTitle: 'Title of section in XMS',
    subTitleElement: null
};

Overview.propTypes = {
    imageUrl: _propTypes2.default.string,
    isUsed: _propTypes2.default.bool,
    isReserved: _propTypes2.default.bool,
    optionalButton: _propTypes2.default.func,
    optionalBuyCta: _propTypes2.default.string,
    optionalAppointmentCta: _propTypes2.default.string,
    packageName: _propTypes2.default.string,
    purchaseMethods: _propTypes2.default.shape({
        cashPurchase: _propTypes2.default.object.isRequired,
        financing: _propTypes2.default.object.isRequired
    }).isRequired,
    quote: _propTypes2.default.instanceOf(_QuoteModel2.default.QuoteModel),
    taxCodes: _propTypes2.default.string.isRequired,
    title: _propTypes2.default.string.isRequired,
    sectionTitle: _propTypes2.default.string,
    subTitleElement: _propTypes2.default.element
};

Overview.displayName = 'Overview';

exports.default = Overview;

/***/ }),

/***/ "./src/Vehicle/components/Overview/Overview.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/Vehicle/components/Overview/PaymentSummary/PaymentSummary.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__("lodash");

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _QuoteModel = __webpack_require__("./src/Quote/models/QuoteModel.js");

var _QuoteModel2 = _interopRequireDefault(_QuoteModel);

var _AppointmentCTA = __webpack_require__("./src/Vehicle/components/CallToAction/Appointment/AppointmentCTA.jsx");

var _AppointmentCTA2 = _interopRequireDefault(_AppointmentCTA);

var _BuyOnlineCTA = __webpack_require__("./src/Vehicle/components/CallToAction/BuyOnline/BuyOnlineCTA.jsx");

var _BuyOnlineCTA2 = _interopRequireDefault(_BuyOnlineCTA);

var _VehicleSummary = __webpack_require__("./src/Vehicle/components/Overview/VehicleSummary/VehicleSummary.jsx");

var _VehicleSummary2 = _interopRequireDefault(_VehicleSummary);

var _url = __webpack_require__("./src/Vehicle/constants/url.js");

var _url2 = _interopRequireDefault(_url);

var _widgetCommonsBasicComponents = __webpack_require__("@sm360/widget-commons-basic-components");

var _index = __webpack_require__("./src/config/index.js");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONTENT_ZONE_NAME = {
    LISTING: 'widget.listing.used',
    VDP: 'widget.vdp.used.similar.cars'
};

var getFallbackImageUrl = function getFallbackImageUrl() {
    var defaultPicture = 'default.picture';
    var contentZoneDefaultPicture = _widgetCommonsCoreServices.ContentZonesService.getContentZone(CONTENT_ZONE_NAME.VDP, defaultPicture);
    if (!contentZoneDefaultPicture || !contentZoneDefaultPicture.getValue()) {
        contentZoneDefaultPicture = _widgetCommonsCoreServices.ContentZonesService.getContentZone(CONTENT_ZONE_NAME.LISTING, defaultPicture);
    }
    return contentZoneDefaultPicture && contentZoneDefaultPicture.getValue() || _index2.default.source.image + '/ir/w360h197c/images/' + _url2.default.NO_PHOTO;
};

var PaymentSummary = function PaymentSummary(_ref) {
    var imageUrl = _ref.imageUrl,
        isUsed = _ref.isUsed,
        isReserved = _ref.isReserved,
        optionalButton = _ref.optionalButton,
        optionalBuyCta = _ref.optionalBuyCta,
        optionalAppointmentCta = _ref.optionalAppointmentCta,
        packageName = _ref.packageName,
        purchaseMethods = _ref.purchaseMethods,
        quote = _ref.quote,
        taxCodes = _ref.taxCodes,
        title = _ref.title;

    var trackBuyOnlineCta = function trackBuyOnlineCta() {
        var tag = isUsed ? _widgetCommonsGeneral.TRACKING_TAGS.RESERVE_IT_NOW_CTA_USED : _widgetCommonsGeneral.TRACKING_TAGS.RESERVE_IT_NOW_CTA_NEW;
        _widgetCommonsGeneral.AnalyticsService.gaTrigger(tag(quote.vehicle.model));
    };

    var trackBuyOnlineCtaOnEndProcessGaTag = isUsed ? _widgetCommonsGeneral.TRACKING_TAGS.RESERVE_IT_NOW_PROCESS_ENDED_USED(quote.vehicle.model) : _widgetCommonsGeneral.TRACKING_TAGS.RESERVE_IT_NOW_PROCESS_ENDED_NEW(quote.vehicle.model);

    var trackAppointmentCta = function trackAppointmentCta() {
        var tag = isUsed ? _widgetCommonsGeneral.TRACKING_TAGS.PREPARE_YOUR_VISIT_CTA_USED : _widgetCommonsGeneral.TRACKING_TAGS.PREPARE_YOUR_VISIT_CTA_NEW;
        _widgetCommonsGeneral.AnalyticsService.gaTrigger(tag(quote.vehicle.model));
    };

    var appointmentCtaOnEndProcessGaTag = isUsed ? _widgetCommonsGeneral.TRACKING_TAGS.PREPARE_YOUR_VISIT_PROCESS_ENDED_USED(quote.vehicle.model) : _widgetCommonsGeneral.TRACKING_TAGS.PREPARE_YOUR_VISIT_PROCESS_ENDED_NEW(quote.vehicle.model);

    var ctaBlock = !isReserved && _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_BuyOnlineCTA2.default, {
            quote: quote,
            buttonClass: 'sr-button-1 is-fluid',
            alternativeLabel: optionalBuyCta,
            onClick: trackBuyOnlineCta,
            onEndProcessGaTag: trackBuyOnlineCtaOnEndProcessGaTag
        }),
        _react2.default.createElement(_AppointmentCTA2.default, {
            quote: quote,
            buttonClass: 'sr-button-2 is-fluid',
            alternativeLabel: optionalAppointmentCta,
            onClick: trackAppointmentCta,
            onEndProcessGaTag: appointmentCtaOnEndProcessGaTag
        })
    );

    return _react2.default.createElement(
        'div',
        { className: 'vehicle-overview__summary has-primary-background' },
        _react2.default.createElement(
            'div',
            { className: 'vehicle-overview__image' },
            _react2.default.createElement(_widgetCommonsBasicComponents.ImageWithFallback, { alt: title, imageUrl: imageUrl, fallbackImageUrl: getFallbackImageUrl() })
        ),
        _react2.default.createElement(_VehicleSummary2.default, {
            title: title,
            packageName: packageName,
            purchaseMethods: purchaseMethods,
            taxCodes: taxCodes,
            isUsed: isUsed,
            vehicle: quote.vehicle
        }),
        _react2.default.createElement(
            'div',
            { className: 'vehicle-overview__cta' },
            ctaBlock
        ),
        _react2.default.createElement(
            'div',
            { className: 'vehicle-overview__optionalButton' },
            optionalButton
        )
    );
};

PaymentSummary.defaultProps = {
    imageUrl: 'https://img.sm360.ca/ir/w420h280c/images/widget/showroom/asset/non-photo.png',
    isUsed: false,
    isReserved: false,
    optionalButton: _lodash.noop,
    optionalBuyCta: '',
    optionalAppointmentCta: '',
    packageName: '',
    quote: ''
};

PaymentSummary.propTypes = {
    imageUrl: _propTypes2.default.string,
    isUsed: _propTypes2.default.bool,
    isReserved: _propTypes2.default.bool,
    optionalButton: _propTypes2.default.func,
    optionalBuyCta: _propTypes2.default.string,
    optionalAppointmentCta: _propTypes2.default.string,
    packageName: _propTypes2.default.string,
    purchaseMethods: _propTypes2.default.shape({
        cashPurchase: _propTypes2.default.object.isRequired,
        financing: _propTypes2.default.object.isRequired
    }).isRequired,
    quote: _propTypes2.default.instanceOf(_QuoteModel2.default.QuoteModel),
    taxCodes: _propTypes2.default.string.isRequired,
    title: _propTypes2.default.string.isRequired
};

PaymentSummary.displayName = 'PaymentSummary';

exports.default = PaymentSummary;

/***/ }),

/***/ "./src/Vehicle/components/Overview/VehicleSummary/VehicleSummary.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__("lodash");

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _VehicleTitle = __webpack_require__("./src/Vehicle/components/Overview/VehicleTitle/VehicleTitle.jsx");

var _VehicleTitle2 = _interopRequireDefault(_VehicleTitle);

var _TileTag = __webpack_require__("./src/Vehicle/components/TileTag/TileTag.jsx");

var _TileTag2 = _interopRequireDefault(_TileTag);

var _PaymentDetail = __webpack_require__("./src/Vehicle/components/Payment/PaymentDetail/PaymentDetail.jsx");

var _PaymentDetail2 = _interopRequireDefault(_PaymentDetail);

__webpack_require__("./src/Vehicle/components/Overview/Overview.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VehicleSummary = function VehicleSummary(_ref) {
    var isUsed = _ref.isUsed,
        optionalButton = _ref.optionalButton,
        packageName = _ref.packageName,
        purchaseMethods = _ref.purchaseMethods,
        taxCodes = _ref.taxCodes,
        title = _ref.title,
        vehicleStockNo = _ref.vehicleStockNo,
        isReserved = _ref.isReserved;

    return _react2.default.createElement(
        'div',
        { className: 'vehicle-overview' },
        _react2.default.createElement(_TileTag2.default, {
            shouldRender: isReserved,
            icon: 'icon-lock',
            background: '#F5273F',
            color: '#fff',
            text: _widgetCommonsCoreServices.LocaleService.t('VEHICLE_STATUS.RESERVED')
        }),
        _react2.default.createElement(_VehicleTitle2.default, { title: title, packageName: packageName, vehicleStockNo: vehicleStockNo }),
        _react2.default.createElement(_PaymentDetail2.default, { purchaseMethods: purchaseMethods, isUsed: isUsed, taxCodes: taxCodes }),
        optionalButton
    );
};

VehicleSummary.defaultProps = {
    isReserved: false,
    packageName: '',
    vehicleStockNo: '',
    optionalButton: _lodash.noop
};

VehicleSummary.propTypes = {
    isUsed: _propTypes2.default.bool.isRequired,
    optionalButton: _propTypes2.default.func,
    packageName: _propTypes2.default.string,
    vehicleStockNo: _propTypes2.default.string,
    purchaseMethods: _propTypes2.default.shape({
        cashPurchase: _propTypes2.default.object.isRequired,
        financing: _propTypes2.default.object.isRequired
    }).isRequired,
    taxCodes: _propTypes2.default.string.isRequired,
    title: _propTypes2.default.string.isRequired,
    isReserved: _propTypes2.default.bool
};

VehicleSummary.displayName = 'VehicleSummary';

exports.default = VehicleSummary;

/***/ }),

/***/ "./src/Vehicle/components/Overview/VehicleTitle/VehicleTitle.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-danger */

var VehicleTitle = function VehicleTitle(_ref) {
    var packageName = _ref.packageName,
        vehicleStockNo = _ref.vehicleStockNo,
        title = _ref.title;

    var currentPackage = packageName !== '' && _react2.default.createElement('p', {
        className: 'current-package',
        dangerouslySetInnerHTML: {
            __html: packageName
        }
    });
    var stockNo = vehicleStockNo !== '' && _react2.default.createElement(
        'p',
        { className: 'vehicle-stockno' },
        _widgetCommonsCoreServices.LocaleService.t('SUMMARY.STOCK_NUMBER', {
            stock: vehicleStockNo
        })
    );

    return _react2.default.createElement(
        'div',
        { className: 'vehicle-overview__vehicle-title' },
        _react2.default.createElement('h3', { className: 'trim is-bold', dangerouslySetInnerHTML: { __html: title } }),
        currentPackage,
        stockNo
    );
};

VehicleTitle.defaultProps = {
    packageName: '',
    vehicleStockNo: ''
};

VehicleTitle.propTypes = {
    packageName: _propTypes2.default.string,
    vehicleStockNo: _propTypes2.default.string,
    title: _propTypes2.default.string.isRequired
};

VehicleTitle.displayName = 'VehicleTitle';

exports.default = VehicleTitle;

/***/ }),

/***/ "./src/Vehicle/components/Payment/CashPayment/CashPayment.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _currencyFormats = __webpack_require__("./src/constants/currencyFormats.js");

var _currencyFormats2 = _interopRequireDefault(_currencyFormats);

__webpack_require__("./src/Vehicle/components/Payment/CashPayment/CashPayment.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CashPayment = function CashPayment(_ref) {
    var children = _ref.children,
        isUsed = _ref.isUsed,
        msrp = _ref.msrp;

    return _react2.default.createElement(
        'div',
        { className: 'cash-section tile-payment-info' },
        _react2.default.createElement(
            'div',
            { className: 'payment-row price-row' },
            _react2.default.createElement(
                'p',
                { className: 'payment-row-title sr-text is-bold' },
                _widgetCommonsCoreServices.LocaleService.t(isUsed ? 'VEHICLE_TILE.USED_PDSF' : 'VEHICLE_TILE.PDSF')
            ),
            _react2.default.createElement(
                'div',
                { className: 'payment-row-section' },
                _react2.default.createElement(
                    'p',
                    { className: 'payment-row-price sr-text is-bold' },
                    _widgetCommonsCoreServices.LocaleService.l(msrp, _currencyFormats2.default.CURRENCY_0)
                )
            )
        ),
        children
    );
};

CashPayment.defaultProps = {
    isUsed: false
};

CashPayment.propTypes = {
    children: _propTypes2.default.element.isRequired,
    isUsed: _propTypes2.default.bool,
    msrp: _propTypes2.default.number.isRequired
};

CashPayment.displayName = 'CashPayment';

exports.default = CashPayment;

/***/ }),

/***/ "./src/Vehicle/components/Payment/CashPayment/CashPayment.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/Vehicle/components/Payment/Financing/Financing.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _PurchaseMethodsModel = __webpack_require__("./src/PurchaseMethods/models/PurchaseMethodsModel.js");

var _PurchaseMethodsModel2 = _interopRequireDefault(_PurchaseMethodsModel);

var _currencyFormats = __webpack_require__("./src/constants/currencyFormats.js");

var _PurchaseMethodsService = __webpack_require__("./src/PurchaseMethods/services/PurchaseMethodsService/PurchaseMethodsService.js");

__webpack_require__("./src/Vehicle/components/Payment/Financing/Financing.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Financing = function Financing(_ref) {
    var children = _ref.children,
        purchaseMethods = _ref.purchaseMethods,
        taxCodes = _ref.taxCodes,
        isUsed = _ref.isUsed;

    var term = purchaseMethods.getSelectedFinanceTerm();
    if (!term || term.calculatedPayment <= 0) {
        return _react2.default.createElement(
            'div',
            { className: 'financing-section tile-payment-info' },
            _react2.default.createElement(
                'div',
                { className: 'tile-frequency is-bold' },
                purchaseMethods.getPurchaseMethodLabels(_widgetCommonsCoreServices.LocaleService).verb
            ),
            _react2.default.createElement(
                'span',
                { className: 'tile-payment-info-unavailable' },
                _widgetCommonsCoreServices.LocaleService.t('NOT_AVAILABLE')
            )
        );
    }

    var calculatedPaymentSplit = (0, _PurchaseMethodsService.getFormattedCurrencySplit)(_widgetCommonsCoreServices.LocaleService.l(term.calculatedPayment, _currencyFormats.CURRENCY_2));
    var aprSplit = term.apr.toFixed(2).split('.');

    var includedDisclaimer = void 0;
    if (isUsed) {
        includedDisclaimer = _widgetCommonsCoreServices.ContentZonesService.getContentZone('widget.commons', 'disclaimer.price.included.used.finance') ? _widgetCommonsCoreServices.ContentZonesService.getContentZone('widget.commons', 'disclaimer.price.included.used.finance').getValue() : '';
    }

    return _react2.default.createElement(
        'div',
        { className: 'financing-section tile-payment-info' },
        _react2.default.createElement(
            'div',
            { className: 'tile-frequency is-bold' },
            purchaseMethods.getPurchaseMethodLabels(_widgetCommonsCoreServices.LocaleService).verb,
            _react2.default.createElement(
                'span',
                null,
                '/ ',
                term.term,
                ' ',
                _widgetCommonsCoreServices.LocaleService.t('TERMS.MONTH')
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'tile-payment' },
            _react2.default.createElement(
                'div',
                { className: 'tile-payment-amount is-bold is-price' },
                calculatedPaymentSplit.beforeDecimal,
                _react2.default.createElement(
                    'sup',
                    null,
                    calculatedPaymentSplit.afterDecimal
                ),
                _react2.default.createElement(
                    'span',
                    null,
                    purchaseMethods.getPaymentFrequencyLabels(false, _widgetCommonsCoreServices.LocaleService).perPeriod
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'tile-term' },
                    _react2.default.createElement(
                        'span',
                        { className: 'is-small is-light' },
                        _widgetCommonsCoreServices.LocaleService.t('VEHICLE_TILE.TAXES_AND_PRICE', {
                            taxe: purchaseMethods.getSelectedFinanceCalculatedPayments().calculatedPaymentTaxes.toFixed(2),
                            taxCodes: taxCodes,
                            totalPrice: purchaseMethods.getSelectedFinanceCalculatedPayments().calculatedPayment.toFixed(2)
                        })
                    )
                )
            ),
            _react2.default.createElement(
                'div',
                { className: 'tile-payment-rate' },
                aprSplit[0],
                _react2.default.createElement(
                    'sup',
                    null,
                    aprSplit[1],
                    '%'
                ),
                _react2.default.createElement(
                    'span',
                    { className: 'frequency-highlight' },
                    '/ ',
                    term.term,
                    ' ',
                    _widgetCommonsCoreServices.LocaleService.t('TERMS.MONTH')
                )
            ),
            includedDisclaimer && _react2.default.createElement(
                'div',
                { className: 'tile-payment-disclaimer-included' },
                includedDisclaimer
            ),
            _react2.default.createElement(
                'div',
                { className: 'tile-payment-cashdown' },
                _react2.default.createElement(
                    'div',
                    { className: 'tile-payment-cashdown-wrapper' },
                    _react2.default.createElement(
                        'span',
                        { className: 'tile-payment-cashdown-note' },
                        _widgetCommonsCoreServices.LocaleService.t('DOWN_PAYMENTS.CASH_DOWN_LABEL')
                    ),
                    _widgetCommonsCoreServices.LocaleService.l(term.cashDown, _currencyFormats.CURRENCY_0)
                )
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'payment-rebates' },
            children
        )
    );
};

Financing.defaultProps = {
    children: null,
    isUsed: false
};

Financing.propTypes = {
    children: _propTypes2.default.element,
    purchaseMethods: _propTypes2.default.instanceOf(_PurchaseMethodsModel2.default).isRequired,
    taxCodes: _propTypes2.default.string.isRequired,
    isUsed: _propTypes2.default.bool
};

Financing.displayName = 'Financing';

exports.default = Financing;

/***/ }),

/***/ "./src/Vehicle/components/Payment/Financing/Financing.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/Vehicle/components/Payment/PaymentDetail/PaymentDetail.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("lodash");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _CashPayment = __webpack_require__("./src/Vehicle/components/Payment/CashPayment/CashPayment.jsx");

var _CashPayment2 = _interopRequireDefault(_CashPayment);

var _Financing = __webpack_require__("./src/Vehicle/components/Payment/Financing/Financing.jsx");

var _Financing2 = _interopRequireDefault(_Financing);

var _Price = __webpack_require__("./src/Vehicle/components/Payment/Price/Price.jsx");

var _Price2 = _interopRequireDefault(_Price);

var _PaymentDetailRebate = __webpack_require__("./src/Vehicle/components/Payment/PaymentDetail/PaymentDetailRebate.jsx");

var _PaymentDetailRebate2 = _interopRequireDefault(_PaymentDetailRebate);

var _purchaseMethodsValues = __webpack_require__("./src/PurchaseMethods/constants/purchaseMethodsValues.js");

var _purchaseMethodsValues2 = _interopRequireDefault(_purchaseMethodsValues);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaymentDetail = function PaymentDetail(_ref) {
    var purchaseMethods = _ref.purchaseMethods,
        forcedPurchaseMethod = _ref.forcedPurchaseMethod,
        isUsed = _ref.isUsed,
        taxCodes = _ref.taxCodes;

    var currentMethod = forcedPurchaseMethod || purchaseMethods.getSelectedPurchaseMethodValue();
    var cashPurchaseObject = purchaseMethods.getSelectedPurchaseMethodAmounts();

    var tradeIn = cashPurchaseObject.tradeIn > 0 && _react2.default.createElement(_PaymentDetailRebate2.default, {
        amount: cashPurchaseObject.tradeIn,
        i18nKey: 'PAYMENTS_REBATES.TRADEIN',
        data: { 'data-sr': 'TradeIn' },
        iconClass: 'icon-refresh'
    });

    var modelElectricRebate = purchaseMethods.cashPurchase.getElectricRebate();
    var isThereElectricRebate = !(0, _lodash.isEmpty)(modelElectricRebate) && !!modelElectricRebate.rebate && !Number.isNaN(modelElectricRebate.rebate);
    var electricRebate = isThereElectricRebate && _react2.default.createElement(_PaymentDetailRebate2.default, {
        amount: modelElectricRebate.rebate,
        i18nKey: 'PAYMENTS_REBATES.ELECTRIC_REBATE',
        data: { 'data-sr': 'ElectricRebate' },
        iconClass: 'icon-electric-vehicle'
    });

    var paymentMethod = null;
    if (currentMethod === _purchaseMethodsValues2.default.FINANCE || currentMethod === _purchaseMethodsValues2.default.LEASE) {
        paymentMethod = _react2.default.createElement(
            _Financing2.default,
            { purchaseMethods: purchaseMethods, taxCodes: taxCodes, isUsed: isUsed },
            tradeIn,
            electricRebate
        );
    } else if (currentMethod === _purchaseMethodsValues2.default.CASH) {
        var disclaimers = purchaseMethods.disclaimers;

        var taxesExcludedDisclaimer = disclaimers ? disclaimers.taxesExcluded : '';
        var cashPurchaseAmounts = purchaseMethods.getCashPurchaseAmounts();

        var includedDisclaimerCzLocation = isUsed ? 'disclaimer.price.included.used.cash' : 'disclaimer.price.included.new';
        var includedDisclaimer = _widgetCommonsCoreServices.ContentZonesService.getContentZone('widget.commons', includedDisclaimerCzLocation) ? _widgetCommonsCoreServices.ContentZonesService.getContentZone('widget.commons', includedDisclaimerCzLocation).getValue() : '';

        var rebatesAmount = isThereElectricRebate ? cashPurchaseAmounts.rebates - modelElectricRebate.rebate : cashPurchaseAmounts.rebates;

        var rebates = rebatesAmount > 0 && _react2.default.createElement(_PaymentDetailRebate2.default, {
            amount: rebatesAmount,
            i18nKey: isUsed ? 'PAYMENTS_REBATES.USED_REBATE' : 'PAYMENTS_REBATES.MANUFACTURER_REBATE',
            data: { 'data-sr': 'Rebate' },
            iconClass: 'icon-promo2'
        });

        var dealerRebates = cashPurchaseAmounts.dealerDiscounts > 0 && _react2.default.createElement(_PaymentDetailRebate2.default, {
            amount: cashPurchaseAmounts.dealerDiscounts,
            i18nKey: 'PAYMENTS_REBATES.DEALER_REBATE',
            data: { 'data-sr': 'Rebate' },
            iconClass: 'icon-promo2'
        });

        paymentMethod = _react2.default.createElement(
            'div',
            { className: 'payment-summary-section' },
            _react2.default.createElement(
                _CashPayment2.default,
                {
                    isUsed: isUsed,
                    msrp: purchaseMethods.cashPurchase.getRetail() + cashPurchaseAmounts.dealerDiscounts
                },
                includedDisclaimer && _react2.default.createElement(
                    'span',
                    { className: 'payment-row disclaimer is-light sr-text' },
                    includedDisclaimer
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'payment-rebates' },
                    rebates,
                    dealerRebates,
                    electricRebate
                )
            ),
            _react2.default.createElement(_Price2.default, {
                amount: purchaseMethods.cashPurchase.getRetail() - purchaseMethods.cashPurchase.getTotalRebates(),
                taxCodes: taxCodes,
                taxesExcludedDisclaimer: taxesExcludedDisclaimer
            })
        );
    }
    return paymentMethod;
};

PaymentDetail.defaultTypes = {
    forcedPurchaseMethod: null
};

PaymentDetail.propTypes = {
    purchaseMethods: _propTypes2.default.shape({
        cashPurchase: _propTypes2.default.object.isRequired,
        financing: _propTypes2.default.object.isRequired
    }).isRequired,
    forcedPurchaseMethod: _propTypes2.default.string,
    isUsed: _propTypes2.default.bool.isRequired,
    taxCodes: _propTypes2.default.string.isRequired
};

PaymentDetail.displayName = 'PaymentDetail';

exports.default = PaymentDetail;

/***/ }),

/***/ "./src/Vehicle/components/Payment/PaymentDetail/PaymentDetailRebate.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _currencyFormats = __webpack_require__("./src/constants/currencyFormats.js");

__webpack_require__("./src/Vehicle/components/Payment/PaymentDetail/PaymentDetailRebate.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaymentDetailRebate = function PaymentDetailRebate(_ref) {
    var amount = _ref.amount,
        i18nKey = _ref.i18nKey,
        data = _ref.data,
        iconClass = _ref.iconClass;

    var currentClass = [iconClass, 'is-primary'];
    return _react2.default.createElement(
        'div',
        _extends({ className: 'payment-rebate' }, data),
        _react2.default.createElement(
            'div',
            { className: 'rebate-title' },
            _react2.default.createElement('icon', { className: currentClass.join(' ') }),
            _react2.default.createElement(
                'span',
                null,
                _widgetCommonsCoreServices.LocaleService.t(i18nKey)
            )
        ),
        amount && _react2.default.createElement(
            'div',
            { className: 'rebate-amount is-bold' },
            _react2.default.createElement(
                'span',
                null,
                '- ',
                _widgetCommonsCoreServices.LocaleService.l(amount, _currencyFormats.CURRENCY_0)
            )
        )
    );
};

PaymentDetailRebate.defaultProps = {
    amount: null
};

PaymentDetailRebate.propTypes = {
    amount: _propTypes2.default.number,
    i18nKey: _propTypes2.default.string.isRequired,
    data: _propTypes2.default.shape({
        'sr-data': _propTypes2.default.string.isRequired
    }),
    iconClass: _propTypes2.default.string.isRequired
};

PaymentDetailRebate.displayName = 'PaymentDetailRebate';

exports.default = PaymentDetailRebate;

/***/ }),

/***/ "./src/Vehicle/components/Payment/PaymentDetail/PaymentDetailRebate.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/Vehicle/components/Payment/Price/Price.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__("lodash");

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _currencyFormats = __webpack_require__("./src/constants/currencyFormats.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Price = function Price(_ref) {
    var amount = _ref.amount,
        taxCodes = _ref.taxCodes,
        retail = _ref.retail,
        taxesExcludedDisclaimer = _ref.taxesExcludedDisclaimer,
        includedDisclaimer = _ref.includedDisclaimer;

    var taxesDisclaimer = taxesExcludedDisclaimer || _widgetCommonsCoreServices.LocaleService.t('VEHICLE_TILE.TAXES', { taxCodes: taxCodes });
    return _react2.default.createElement(
        'div',
        { className: 'listing-tile-all-price' },
        _react2.default.createElement(
            'div',
            { className: 'listing-tile-all-price-title sr-text' },
            _react2.default.createElement(
                'div',
                { className: 'is-bold' },
                _widgetCommonsCoreServices.LocaleService.t('VEHICLE_TILE.PRICE')
            ),
            includedDisclaimer && _react2.default.createElement(
                'div',
                { className: 'disclaimer-included is-light' },
                includedDisclaimer
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'listing-tile-all-price-info' },
            retail > 0 && retail > amount && _react2.default.createElement(
                'p',
                { className: 'listing-tile-all-price-retails rebated' },
                _widgetCommonsCoreServices.LocaleService.l(retail, _currencyFormats.CURRENCY_0)
            ),
            _react2.default.createElement(
                'div',
                { className: 'price is-bold is-price' },
                (0, _lodash.isFinite)(amount) && _widgetCommonsCoreServices.LocaleService.l(amount, _currencyFormats.CURRENCY_0)
            ),
            taxesDisclaimer && _react2.default.createElement(
                'div',
                { className: 'disclaimer-price is-light' },
                taxesDisclaimer
            )
        )
    );
};

Price.defaultProps = {
    retail: 0,
    taxesExcludedDisclaimer: '',
    includedDisclaimer: ''
};

Price.propTypes = {
    amount: _propTypes2.default.number.isRequired,
    taxCodes: _propTypes2.default.string.isRequired,
    retail: _propTypes2.default.number,
    taxesExcludedDisclaimer: _propTypes2.default.string,
    includedDisclaimer: _propTypes2.default.string
};

Price.displayName = 'Price';

exports.default = Price;

/***/ }),

/***/ "./src/Vehicle/components/PaymentOptionFilters/InitialCashDown/InitialCashDown.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("lodash");

var _widgetCommonsForms = __webpack_require__("@sm360/widget-commons-forms");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

__webpack_require__("./src/Vehicle/components/PaymentOptionFilters/InitialCashDown/InitialCashDown.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InitialCashDown = function InitialCashDown(_ref) {
    var initialCashDown = _ref.initialCashDown,
        setCashDown = _ref.setCashDown,
        onClick = _ref.onClick;

    return _react2.default.createElement(
        'div',
        { className: 'listing-used-cash-down target-payment', onClick: onClick },
        _react2.default.createElement(_widgetCommonsForms.InputNumber, {
            min: 0,
            step: 100,
            onChange: function onChange(value) {
                return setCashDown(parseFloat(value));
            },
            decimalCount: 2,
            value: initialCashDown ? initialCashDown.toFixed(2) : '0',
            label: _widgetCommonsCoreServices.LocaleService.t('FILTERS.INITIAL_CASHDOWN'),
            showLabel: true,
            lightTheme: true
        })
    );
};

InitialCashDown.defaultProps = {
    onClick: _lodash.noop
};

InitialCashDown.propTypes = {
    initialCashDown: _propTypes2.default.number.isRequired,
    setCashDown: _propTypes2.default.func.isRequired,
    onClick: _propTypes2.default.func
};

InitialCashDown.displayName = 'InitialCashDown';

exports.default = InitialCashDown;

/***/ }),

/***/ "./src/Vehicle/components/PaymentOptionFilters/InitialCashDown/InitialCashDown.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/Vehicle/components/PaymentOptionFilters/MethodButton/MethodButton.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("lodash");

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _index = __webpack_require__("./src/PurchaseMethods/index.js");

__webpack_require__("./src/Vehicle/components/PaymentOptionFilters/MethodButton/MethodButton.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MethodButton = function (_React$Component) {
    _inherits(MethodButton, _React$Component);

    function MethodButton(props) {
        _classCallCheck(this, MethodButton);

        var _this = _possibleConstructorReturn(this, (MethodButton.__proto__ || Object.getPrototypeOf(MethodButton)).call(this, props));

        var isFinance = _this.props.currentMethod === _index.PurchaseMethodsConstant.FINANCE;
        var isLease = _this.props.currentMethod === _index.PurchaseMethodsConstant.LEASE;
        var isPayCash = _this.props.currentMethod === _index.PurchaseMethodsConstant.CASH_PURCHASE;

        _this.state = {
            paymentMethod: {
                finance: {
                    value: _index.PurchaseMethodsConstant.FINANCE,
                    translation: 'METHOD_PAYMENT.FINANCE',
                    current: isFinance
                },
                lease: {
                    value: _index.PurchaseMethodsConstant.LEASE,
                    translation: 'METHOD_PAYMENT.LEASE',
                    current: isLease
                },
                payCash: {
                    value: _index.PurchaseMethodsConstant.CASH_PURCHASE,
                    translation: 'METHOD_PAYMENT.PAY_CASH',
                    current: isPayCash
                }
            }
        };

        _this.changePayment = _this.changePayment.bind(_this);
        _this.updateCurrentMethod = _this.updateCurrentMethod.bind(_this);
        return _this;
    }

    _createClass(MethodButton, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            if (!this.props.hasLease) {
                var isFinance = this.props.currentMethod === _index.PurchaseMethodsConstant.FINANCE;
                var isPayCash = this.props.currentMethod === _index.PurchaseMethodsConstant.CASH_PURCHASE;
                var newMethod = {
                    finance: {
                        value: _index.PurchaseMethodsConstant.FINANCE,
                        translation: 'METHOD_PAYMENT.FINANCE',
                        current: isFinance
                    },
                    payCash: {
                        value: _index.PurchaseMethodsConstant.CASH_PURCHASE,
                        translation: 'METHOD_PAYMENT.PAY_CASH',
                        current: isPayCash
                    }
                };
                this.setState({
                    paymentMethod: newMethod
                });
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(newProps) {
            if (!newProps.currentMethod) {
                return;
            }

            this.updateCurrentMethod(newProps.currentMethod);
        }
    }, {
        key: 'updateCurrentMethod',
        value: function updateCurrentMethod(payment) {
            var _this2 = this;

            var paymentMethod = _extends({}, this.state.paymentMethod);

            Object.keys(this.state.paymentMethod).forEach(function (method) {
                paymentMethod[method].current = false;
                if (_this2.state.paymentMethod[method].value === payment) {
                    paymentMethod[method].current = true;
                }
            });

            this.setState({ paymentMethod: paymentMethod });
        }
    }, {
        key: 'changePayment',
        value: function changePayment(e) {
            var payment = e.target.value;

            this.updateCurrentMethod(payment);
            this.props.selectPreferredPurchaseMethod(payment);
            this.props.onSelection(payment);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var payment = this.state.paymentMethod;

            var buttons = (0, _lodash.map)(payment, function (currentButton) {
                return _react2.default.createElement(
                    'button',
                    {
                        key: currentButton.value,
                        onClick: function onClick(e) {
                            return _this3.changePayment(e);
                        },
                        value: currentButton.value,
                        className: currentButton.current ? 'current' : ''
                    },
                    _widgetCommonsCoreServices.LocaleService.t(currentButton.translation)
                );
            });

            return _react2.default.createElement(
                'div',
                { className: 'method-button-payment-bar' },
                buttons
            );
        }
    }]);

    return MethodButton;
}(_react2.default.Component);

MethodButton.defaultProps = {
    hasLease: false
};

MethodButton.propTypes = {
    currentMethod: _propTypes2.default.string.isRequired,
    hasLease: _propTypes2.default.bool,
    onSelection: _propTypes2.default.func.isRequired,
    selectPreferredPurchaseMethod: _propTypes2.default.func.isRequired
};

MethodButton.displayName = 'MethodButton';

exports.default = MethodButton;

/***/ }),

/***/ "./src/Vehicle/components/PaymentOptionFilters/MethodButton/MethodButton.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/Vehicle/components/PaymentOptionFilters/PaymentOptionFilters.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsForms = __webpack_require__("@sm360/widget-commons-forms");

var _PaymentOptionsModel = __webpack_require__("./src/Vehicle/models/PaymentOptionsModel.js");

var _PaymentOptionsModel2 = _interopRequireDefault(_PaymentOptionsModel);

var _TradeInVehicleModel = __webpack_require__("./src/Vehicle/models/TradeInVehicleModel.js");

var _TradeInVehicleModel2 = _interopRequireDefault(_TradeInVehicleModel);

var _InitialCashDown = __webpack_require__("./src/Vehicle/components/PaymentOptionFilters/InitialCashDown/InitialCashDown.jsx");

var _InitialCashDown2 = _interopRequireDefault(_InitialCashDown);

var _MethodButton = __webpack_require__("./src/Vehicle/components/PaymentOptionFilters/MethodButton/MethodButton.jsx");

var _MethodButton2 = _interopRequireDefault(_MethodButton);

var _PaymentRange = __webpack_require__("./src/Vehicle/components/PaymentOptionFilters/PaymentRange/PaymentRange.jsx");

var _PaymentRange2 = _interopRequireDefault(_PaymentRange);

var _TradeInValue = __webpack_require__("./src/Vehicle/components/PaymentOptionFilters/TradeInValue/TradeInValue.jsx");

var _TradeInValue2 = _interopRequireDefault(_TradeInValue);

__webpack_require__("./src/Vehicle/components/PaymentOptionFilters/PaymentOptionFilters.scss");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var gaTrigger = _widgetCommonsGeneral.AnalyticsService.gaTrigger.bind(_widgetCommonsGeneral.AnalyticsService);

var possibleFrequency = {
    CASHDOWN: 'cashdown',
    PAYMENT: 'payment'
};

var PaymentOptionFilters = function (_React$Component) {
    _inherits(PaymentOptionFilters, _React$Component);

    function PaymentOptionFilters(props) {
        _classCallCheck(this, PaymentOptionFilters);

        var _this = _possibleConstructorReturn(this, (PaymentOptionFilters.__proto__ || Object.getPrototypeOf(PaymentOptionFilters)).call(this, props));

        var _this$props$paymentOp = _this.props.paymentOptions,
            initialTargetPayment = _this$props$paymentOp.initialTargetPayment,
            maximumTerm = _this$props$paymentOp.maximumTerm,
            preferredPaymentFrequency = _this$props$paymentOp.preferredPaymentFrequency,
            purchaseMethod = _this$props$paymentOp.purchaseMethod;

        var isEmptyPayment = initialTargetPayment > 0;

        _this.state = {
            paymentOpened: false,
            currentMethod: purchaseMethod,
            purchaseMethodSort: {
                value: preferredPaymentFrequency,
                label: preferredPaymentFrequency
            },
            paymentTypeSelection: {
                value: isEmptyPayment ? possibleFrequency.PAYMENT : possibleFrequency.CASHDOWN,
                label: isEmptyPayment ? _widgetCommonsCoreServices.LocaleService.t('FILTERS.INITIAL_PAYMENT') : _widgetCommonsCoreServices.LocaleService.t('FILTERS.INITIAL_CASHDOWN')
            },
            selectedTerms: {
                value: maximumTerm,
                label: maximumTerm
            }
        };

        _this.handleCollapse = _this.handleCollapse.bind(_this);
        _this.handleInputChange = _this.handleInputChange.bind(_this);
        _this.handlePaymentChange = _this.handlePaymentChange.bind(_this);
        _this.openCashdown = _this.openCashdown.bind(_this);
        _this.openPayment = _this.openPayment.bind(_this);
        _this.selectMethod = _this.handleMethodSelection.bind(_this);
        _this.handleMethodSelection = _this.handleMethodSelection.bind(_this);
        return _this;
    }

    _createClass(PaymentOptionFilters, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(newProps) {
            if (this.props.hasLease !== newProps.hasLease || this.props.paymentOptions !== newProps.paymentOptions || this.props.tradeInVehicle !== newProps.tradeInVehicle) {
                var _newProps$paymentOpti = newProps.paymentOptions,
                    maximumTerm = _newProps$paymentOpti.maximumTerm,
                    preferredPaymentFrequency = _newProps$paymentOpti.preferredPaymentFrequency,
                    purchaseMethod = _newProps$paymentOpti.purchaseMethod;


                this.setState({
                    currentMethod: purchaseMethod,
                    purchaseMethodSort: {
                        value: preferredPaymentFrequency,
                        label: preferredPaymentFrequency
                    },
                    selectedTerms: {
                        value: maximumTerm,
                        label: maximumTerm
                    }
                });
            }
        }
    }, {
        key: 'openCashdown',
        value: function openCashdown() {
            if (this.state.paymentTypeSelection.value === possibleFrequency.CASHDOWN) {
                this.props.actions.setTargetPayment(0);
                this.props.actions.setCashDown(0);
            }
        }
    }, {
        key: 'openPayment',
        value: function openPayment() {
            if (this.state.paymentTypeSelection.value === possibleFrequency.PAYMENT) {
                this.props.actions.setCashDown(0);
            }
        }
    }, {
        key: 'handleCollapse',
        value: function handleCollapse() {
            var _this2 = this;

            var windowProxy = _widgetCommonsCoreServices.WindowProxy.get();
            this.setState(function (oldState) {
                return {
                    paymentOpened: !oldState.paymentOpened
                };
            }, function () {
                if (windowProxy) {
                    windowProxy.document.body.classList.toggle('paymentPanelOpen-no-scroll', _this2.state.paymentOpened);
                }
            });
        }
    }, {
        key: 'handleInputChange',
        value: function handleInputChange(inputValue, name) {
            var _this3 = this;

            var inputs = void 0;
            var actionPromise = void 0;
            if (name === 'purchaseMethodSort') {
                inputs = this.state.purchaseMethodSort;
            } else if (name === 'selectTerms') {
                inputs = this.state.selectedTerms;
            }
            if (inputs.value !== inputValue.value) {
                inputs.value = inputValue.value;
                inputs.label = inputValue.label;

                if (name === 'purchaseMethodSort') {
                    actionPromise = this.props.actions.selectPreferredPaymentFrequency(inputValue.value);
                } else if (name === 'selectTerms') {
                    actionPromise = this.props.actions.selectMaximumTerm(inputValue.value);
                }
            }
            var initialTargetPayment = this.props.paymentOptions.initialTargetPayment;

            actionPromise.then(function () {
                if (initialTargetPayment > 0) {
                    _this3.props.actions.setTargetPayment(initialTargetPayment);
                }
            });
        }
    }, {
        key: 'handlePaymentChange',
        value: function handlePaymentChange(dropdownValue) {
            var _this4 = this;

            this.setState({
                paymentTypeSelection: dropdownValue
            }, function () {
                if (dropdownValue.value === possibleFrequency.CASHDOWN) {
                    _this4.openCashdown();
                } else if (dropdownValue.value === possibleFrequency.PAYMENT) {
                    _this4.openPayment();
                }
            });
        }
    }, {
        key: 'handleMethodSelection',
        value: function handleMethodSelection(paymentMethod) {
            gaTrigger(_widgetCommonsGeneral.TRACKING_TAGS.PAYMENT_TYPE(paymentMethod));
            this.setState({
                currentMethod: paymentMethod
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var paymentOpened = this.state.paymentOpened;

            var paymentFrequenciesButtons = this.props.paymentOptions.frequencyValues.map(function (paymentFrequency) {
                return {
                    value: paymentFrequency.value,
                    label: paymentFrequency.label
                };
            });

            var paymentTypeOptions = [{
                value: possibleFrequency.CASHDOWN,
                label: _widgetCommonsCoreServices.LocaleService.t('FILTERS.INITIAL_CASHDOWN')
            }, {
                value: possibleFrequency.PAYMENT,
                label: _widgetCommonsCoreServices.LocaleService.t('FILTERS.INITIAL_PAYMENT')
            }];

            var termsButtons = this.props.paymentOptions.terms.map(function (term) {
                return {
                    value: term,
                    label: _widgetCommonsCoreServices.LocaleService.t('MONTH_TERMS', { terms: term })
                };
            });

            var trackTradeInValueClick = function trackTradeInValueClick() {
                return gaTrigger(_widgetCommonsGeneral.TRACKING_TAGS.EXCHANGE_VALUE__USED_CAR(_widgetCommonsCoreServices.WindowProxy.location().pathname));
            };
            var trackOweOnTradeClick = function trackOweOnTradeClick() {
                return gaTrigger(_widgetCommonsGeneral.TRACKING_TAGS.OWE_ON_TRADE(_widgetCommonsCoreServices.WindowProxy.location().pathname));
            };
            var trackInitialCashDownClick = function trackInitialCashDownClick() {
                return gaTrigger(_widgetCommonsGeneral.TRACKING_TAGS.INITIAL_CASH_DOWN());
            };
            var trackPreferredFrequencyClick = function trackPreferredFrequencyClick() {
                return gaTrigger(_widgetCommonsGeneral.TRACKING_TAGS.PREFERRED_FREQUENCY());
            };
            var trackMaximumTermClick = function trackMaximumTermClick() {
                return gaTrigger(_widgetCommonsGeneral.TRACKING_TAGS.MAXIMUM_TERM());
            };

            var paymentClass = ['listing-used-payment-wrap', this.state.currentMethod];
            var paymentBloc = _react2.default.createElement(
                'div',
                { className: paymentClass.join(' ') },
                _react2.default.createElement('button', {
                    className: 'listing-used-filters-head-mobile-close picto-showroom icon-X-rouge',
                    onClick: this.handleCollapse
                }),
                _react2.default.createElement(_MethodButton2.default, {
                    selectPreferredPurchaseMethod: this.props.actions.selectPreferredPurchaseMethod,
                    hasLease: this.props.hasLease,
                    currentMethod: this.state.currentMethod,
                    onSelection: this.handleMethodSelection
                }),
                _react2.default.createElement(
                    'div',
                    { className: 'listing-used-payment-wrap-range' },
                    _react2.default.createElement(_widgetCommonsForms.InputDropDown, {
                        name: 'paymentTypeSelect',
                        value: this.state.paymentTypeSelection.value,
                        options: paymentTypeOptions,
                        placeholder: _widgetCommonsCoreServices.LocaleService.t('FILTERS.PAYMENT_SELECTION'),
                        valueChange: this.handlePaymentChange,
                        classNames: ['input-dropdown not-empty payment-selector']
                    }),
                    this.state.paymentTypeSelection.value === possibleFrequency.CASHDOWN ? _react2.default.createElement(_InitialCashDown2.default, {
                        initialCashDown: this.props.paymentOptions.initialCashDown,
                        setInitialCashDown: this.props.actions.setInitialCashDown,
                        setCashDown: this.props.actions.setCashDown,
                        onClick: trackInitialCashDownClick
                    }) : _react2.default.createElement(_PaymentRange2.default, {
                        paymentRangeBoundaries: this.props.paymentOptions.rangeBoundaries,
                        setPaymentRange: this.props.actions.setPaymentRange,
                        setInitialTargetPayment: this.props.actions.setInitialTargetPayment,
                        setTargetPayment: this.props.actions.setTargetPayment,
                        initialTargetPayment: this.props.paymentOptions.initialTargetPayment
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'listing-used-payment-wrap-range' },
                    _react2.default.createElement(
                        'div',
                        { className: 'listing-used-payment-frequency' },
                        _react2.default.createElement(_widgetCommonsForms.InputDropDown, {
                            name: 'purchaseMethodSort',
                            value: this.state.purchaseMethodSort.value,
                            options: paymentFrequenciesButtons,
                            placeholder: _widgetCommonsCoreServices.LocaleService.t('PREFERRED_FREQUENCY'),
                            valueChange: this.handleInputChange,
                            classNames: ['input-dropdown not-empty'],
                            onClick: trackPreferredFrequencyClick
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'listing-used-max-term' },
                        _react2.default.createElement(_widgetCommonsForms.InputDropDown, {
                            name: 'selectTerms',
                            value: this.state.selectedTerms.value,
                            options: termsButtons,
                            placeholder: _widgetCommonsCoreServices.LocaleService.t('MAXIMUM_TERM'),
                            valueChange: this.handleInputChange,
                            classNames: ['input-dropdown not-empty'],
                            onClick: trackMaximumTermClick
                        })
                    )
                ),
                _react2.default.createElement(_TradeInValue2.default, {
                    tradeInVehicle: this.props.tradeInVehicle,
                    setTradeIn: this.props.actions.setTradeIn,
                    setLien: this.props.actions.setLien,
                    setTargetPayment: this.props.actions.setTargetPayment,
                    initialTargetPayment: this.props.paymentOptions.initialTargetPayment,
                    saveTradeInVehicle: this.props.tradeInActions.saveTradeInVehicle,
                    onValueClick: trackTradeInValueClick,
                    onLienClick: trackOweOnTradeClick
                })
            );

            var userPaymentClass = ['listing-used-payment clearfix'];
            if (paymentOpened) {
                userPaymentClass.push('payment-open');
            }

            return _react2.default.createElement(
                'div',
                { className: userPaymentClass.join(' ') },
                _react2.default.createElement(
                    'div',
                    { className: 'listing-used-set-budget' },
                    _react2.default.createElement(
                        'button',
                        { className: 'picto-showroom-after', onClick: this.handleCollapse },
                        _widgetCommonsCoreServices.LocaleService.t('SET_MY_BUDGET')
                    )
                ),
                paymentBloc
            );
        }
    }]);

    return PaymentOptionFilters;
}(_react2.default.Component);

PaymentOptionFilters.defaultProps = {
    hasLease: false,
    tradeInVehicle: null
};

PaymentOptionFilters.propTypes = {
    actions: _propTypes2.default.shape({
        filterPayments: _propTypes2.default.func.isRequired,
        selectMaximumTerm: _propTypes2.default.func.isRequired,
        selectPreferredPaymentFrequency: _propTypes2.default.func.isRequired,
        selectPreferredPurchaseMethod: _propTypes2.default.func.isRequired,
        selectPurchaseMethod: _propTypes2.default.func.isRequired,
        setCashDown: _propTypes2.default.func.isRequired,
        setInitialCashDown: _propTypes2.default.func.isRequired,
        setInitialTargetPayment: _propTypes2.default.func.isRequired,
        setLien: _propTypes2.default.func.isRequired,
        setPaymentRange: _propTypes2.default.func.isRequired,
        setTargetPayment: _propTypes2.default.func.isRequired,
        setTradeIn: _propTypes2.default.func.isRequired
    }).isRequired,
    hasLease: _propTypes2.default.bool,
    paymentOptions: _propTypes2.default.instanceOf(_PaymentOptionsModel2.default).isRequired,
    tradeInActions: _propTypes2.default.shape({
        saveTradeInVehicle: _propTypes2.default.func.isRequired
    }).isRequired,
    tradeInVehicle: _propTypes2.default.instanceOf(_TradeInVehicleModel2.default)
};

PaymentOptionFilters.displayName = 'PaymentOptionFilters';

exports.default = PaymentOptionFilters;

/***/ }),

/***/ "./src/Vehicle/components/PaymentOptionFilters/PaymentOptionFilters.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/Vehicle/components/PaymentOptionFilters/PaymentRange/PaymentRange.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _widgetCommonsForms = __webpack_require__("@sm360/widget-commons-forms");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

__webpack_require__("./src/Vehicle/components/PaymentOptionFilters/PaymentRange/PaymentRange.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaymentRange = function PaymentRange(_ref) {
    var initialTargetPayment = _ref.initialTargetPayment,
        paymentRangeBoundaries = _ref.paymentRangeBoundaries,
        setTargetPayment = _ref.setTargetPayment;

    var step = paymentRangeBoundaries[1] === 2000 ? 25 : paymentRangeBoundaries[1] / 100;

    return _react2.default.createElement(
        'div',
        { className: 'listing-used-desired-payment target-payment' },
        _react2.default.createElement(_widgetCommonsForms.InputNumber, {
            min: paymentRangeBoundaries[0],
            max: paymentRangeBoundaries[1],
            step: step,
            decimalCount: 2,
            value: Number.parseFloat(initialTargetPayment).toFixed(2),
            onChange: function onChange(value) {
                return setTargetPayment(value > 0 ? parseFloat(value) : 5);
            },
            label: _widgetCommonsCoreServices.LocaleService.t('FILTERS.INITIAL_PAYMENT'),
            showLabel: true,
            lightTheme: true
        })
    );
};

PaymentRange.propTypes = {
    initialTargetPayment: _propTypes2.default.number.isRequired,
    paymentRangeBoundaries: _propTypes2.default.arrayOf(_propTypes2.default.number),
    setTargetPayment: _propTypes2.default.func.isRequired
};

PaymentRange.displayName = 'PaymentRange';

exports.default = PaymentRange;

/***/ }),

/***/ "./src/Vehicle/components/PaymentOptionFilters/PaymentRange/PaymentRange.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/Vehicle/components/PaymentOptionFilters/TradeInValue/TradeInValue.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsForms = __webpack_require__("@sm360/widget-commons-forms");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _lodash = __webpack_require__("lodash");

var _currencyFormats = __webpack_require__("./src/constants/currencyFormats.js");

var _currencyFormats2 = _interopRequireDefault(_currencyFormats);

var _TradeInVehicleModel = __webpack_require__("./src/Vehicle/models/TradeInVehicleModel.js");

var _TradeInVehicleModel2 = _interopRequireDefault(_TradeInVehicleModel);

var _TradeInVehicleAPIService = __webpack_require__("./src/Vehicle/services/TradeInVehicleAPIService/TradeInVehicleAPIService.js");

var _TradeInVehicleAPIService2 = _interopRequireDefault(_TradeInVehicleAPIService);

var _events = __webpack_require__("./src/constants/events.js");

var _events2 = _interopRequireDefault(_events);

__webpack_require__("./src/Vehicle/components/PaymentOptionFilters/TradeInValue/TradeInValue.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TradeInValue = function (_React$Component) {
    _inherits(TradeInValue, _React$Component);

    function TradeInValue(props) {
        _classCallCheck(this, TradeInValue);

        var _this = _possibleConstructorReturn(this, (TradeInValue.__proto__ || Object.getPrototypeOf(TradeInValue)).call(this, props));

        _this.state = {
            inputs: {
                tradeIn: 0,
                lien: 0
            },
            formValidation: {
                tradeIn: false,
                lien: false
            },
            hasTradeIn: true
        };

        _this.debounceTradeIn = (0, _lodash.debounce)(_this.props.setTradeIn, 300);
        _this.debounceLien = (0, _lodash.debounce)(_this.props.setLien, 300);

        _this.handleInputChange = _this.handleInputChange.bind(_this);
        _this.ignoreInput = _this.ignoreInput.bind(_this);
        _this.saveTradeInVehicle = _this.saveTradeInVehicle.bind(_this);
        _this.setLien = _this.setLien.bind(_this);
        _this.setTradeIn = _this.setTradeIn.bind(_this);
        _this.onAuthentication = _this.onAuthentication.bind(_this);
        _this.updateTradeInStateValues = _this.updateTradeInStateValues.bind(_this);
        _this.fetchTradeInValuesFromLocalStorage = _this.fetchTradeInValuesFromLocalStorage.bind(_this);
        _this.renderCreditTaxes = _this.renderCreditTaxes.bind(_this);
        return _this;
    }

    _createClass(TradeInValue, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.fetchTradeInValuesFromAPI().catch(this.fetchTradeInValuesFromLocalStorage).then(this.updateTradeInStateValues);

            var $window = _widgetCommonsCoreServices.WindowProxy.get();
            if ($window) {
                $window.addEventListener(_events2.default.AUTHENTICATED, this.onAuthentication);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            var $window = _widgetCommonsCoreServices.WindowProxy.get();
            if ($window) {
                $window.removeEventListener(_events2.default.AUTHENTICATED, this.onAuthentication);
            }
        }
    }, {
        key: 'onAuthentication',
        value: function onAuthentication() {
            return this.fetchTradeInValuesFromAPI().catch(this.fetchTradeInValuesFromLocalStorage).then(this.updateTradeInStateValues);
        }
    }, {
        key: 'setTradeIn',
        value: function setTradeIn(value) {
            this.debounceTradeIn(value);
            if (value <= 0) {
                this.setLien(0);
            }
        }
    }, {
        key: 'setLien',
        value: function setLien(value) {
            this.debounceLien(value);
        }
    }, {
        key: 'fetchTradeInValuesFromLocalStorage',
        value: function fetchTradeInValuesFromLocalStorage() {
            var windowProxy = _widgetCommonsCoreServices.WindowProxy.get();
            if (!windowProxy || !windowProxy.localStorage) {
                return Promise.resolve({
                    tradeIn: 0,
                    lien: 0
                });
            }

            var _windowProxy$localSto = windowProxy.localStorage,
                tradeIn = _windowProxy$localSto.tradeIn,
                lien = _windowProxy$localSto.lien;


            return Promise.resolve({
                tradeIn: Number.parseInt(tradeIn, 10) || 0,
                lien: Number.parseInt(lien, 10) || 0
            });
        }
    }, {
        key: 'fetchTradeInValuesFromAPI',
        value: function fetchTradeInValuesFromAPI() {
            var isAuthenticated = _widgetCommonsGeneral.AccountService.isAuthenticated();
            if (!isAuthenticated) {
                return Promise.reject();
            }

            return _TradeInVehicleAPIService2.default.loadTradeInVehicle().then(function (_ref) {
                var amount = _ref.amount,
                    lien = _ref.lien;

                if (!amount) {
                    return Promise.reject();
                }
                return {
                    lien: lien,
                    tradeIn: amount
                };
            });
        }
    }, {
        key: 'updateTradeInStateValues',
        value: function updateTradeInStateValues(values) {
            this.setState({ inputs: values });
            this.props.setTradeIn(values.tradeIn);
            this.props.setLien(values.lien);
        }
    }, {
        key: 'saveTradeInVehicle',
        value: function saveTradeInVehicle() {
            if (!(0, _lodash.isFunction)(this.props.tradeInVehicle.checkIsUpdatable) || this.props.tradeInVehicle.checkIsUpdatable()) {
                this.props.saveTradeInVehicle(this.props.tradeInVehicle);
            }
        }
    }, {
        key: 'ignoreInput',
        value: function ignoreInput() {
            if (this.state.hasTradeIn) {
                this.setTradeIn(0);
            } else {
                this.setTradeIn(this.state.inputs.tradeIn);
                if (this.state.inputs.tradeIn > 0) {
                    this.setLien(this.state.inputs.lien);
                }
            }
            this.setState({
                hasTradeIn: !this.state.hasTradeIn
            });
        }
    }, {
        key: 'handleInputChange',
        value: function handleInputChange(value, name) {
            var parseValue = parseInt(value, 10);
            parseValue = !Number.isNaN(parseValue) ? parseValue : 0;

            var _state = this.state,
                formValidation = _state.formValidation,
                inputs = _state.inputs;


            if (inputs[name] !== value) {
                inputs[name] = value;
                formValidation[name] = true;

                if (name === 'tradeIn') {
                    if (parseValue <= 0) {
                        inputs.lien = 0;
                    }
                    this.setTradeIn(parseValue);
                }
                if (name === 'lien') {
                    this.setLien(inputs.tradeIn > 0 ? parseValue : 0);
                }
                if (this.props.initialTargetPayment > 0) {
                    this.props.setTargetPayment(this.props.initialTargetPayment);
                }
            }
            this.setState({
                inputs: inputs,
                formValidation: formValidation
            });
        }
    }, {
        key: 'renderCreditTaxes',
        value: function renderCreditTaxes() {
            return _react2.default.createElement(
                'small',
                null,
                _widgetCommonsCoreServices.LocaleService.t('PAYMENT_OPTIONS_FILTERS.TRADE_IN_TAXES_CREDIT_DETAILS', {
                    tradeInWithTaxCreditsAmount: _widgetCommonsCoreServices.LocaleService.l(parseInt(this.state.inputs.tradeIn, 10) + this.props.tradeInVehicle.getTaxCredits() || 0, _currencyFormats2.default.CURRENCY_2),
                    taxCreditsAmount: _widgetCommonsCoreServices.LocaleService.l(this.props.tradeInVehicle.getTaxCredits() || 0, _currencyFormats2.default.CURRENCY_2)
                })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var tradeInVehicleIsLocked = (0, _lodash.isFunction)(this.props.tradeInVehicle.checkIsLocked) && this.props.tradeInVehicle.checkIsLocked();
            var hasTradeInValue = !!Number.parseInt(this.state.inputs.tradeIn, 10);
            var isLienAvailableClass = ['trade-in__input'];
            var isTradeinAvailable = ['trade-in__input'];
            var isDisabled = false;

            if (this.state.inputs.tradeIn <= 0 || !this.state.hasTradeIn || tradeInVehicleIsLocked) {
                isLienAvailableClass.push('forms_disabled');
                isDisabled = true;
            }
            if (!this.state.hasTradeIn || tradeInVehicleIsLocked) {
                isTradeinAvailable.push('forms_disabled');
            }
            /* TODO: Put this back
            const isBtnToggle = !this.state.hasTradeIn ? (
                'disabled-btn btn-toggle-input'
            ) : (
            '   btn-toggle-input'
            ); */

            return _react2.default.createElement(
                'div',
                { className: 'listing-used-payment-wrap-range' },
                _react2.default.createElement(
                    'div',
                    { className: isTradeinAvailable.join(' '), onClick: this.props.onValueClick },
                    _react2.default.createElement(_widgetCommonsForms.InputText, {
                        type: 'number',
                        name: 'tradeIn',
                        classNames: ['styled-placeholder', 'half', 'currency'],
                        label: _widgetCommonsCoreServices.LocaleService.t('FILTERS.ESTIMATED_EXCHANGE'),
                        value: this.state.inputs.tradeIn !== 0 ? this.state.inputs.tradeIn : '',
                        isValid: this.state.formValidation.tradeIn,
                        valueChange: this.handleInputChange,
                        onBlur: this.saveTradeInVehicle,
                        maxLength: _widgetCommonsForms.FIELD_LENGTH.DEFAULT_NUMBER_MAX
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: isLienAvailableClass.join(' '), onClick: this.props.onLienClick },
                    _react2.default.createElement(_widgetCommonsForms.InputText, {
                        type: 'number',
                        name: 'lien',
                        classNames: ['styled-placeholder', 'half', 'currency'],
                        label: _widgetCommonsCoreServices.LocaleService.t('FILTERS.ESTIMATED_DEBTS'),
                        value: this.state.inputs.lien !== 0 ? this.state.inputs.lien : '',
                        isValid: this.state.formValidation.lien,
                        valueChange: this.handleInputChange,
                        onBlur: this.saveTradeInVehicle,
                        isDisabled: isDisabled,
                        maxLength: _widgetCommonsForms.FIELD_LENGTH.DEFAULT_NUMBER_MAX
                    })
                ),
                _react2.default.createElement(
                    'div',
                    null,
                    hasTradeInValue && this.renderCreditTaxes()
                )
            );
        }
    }]);

    return TradeInValue;
}(_react2.default.Component);

TradeInValue.defaultProps = {
    setTargetPayment: _lodash.noop,
    tradeInVehicle: new _TradeInVehicleModel2.default(),
    onValueClick: _lodash.noop,
    onLienClick: _lodash.noop
};

TradeInValue.propTypes = {
    initialTargetPayment: _propTypes2.default.number.isRequired,
    saveTradeInVehicle: _propTypes2.default.func.isRequired,
    setLien: _propTypes2.default.func.isRequired,
    setTargetPayment: _propTypes2.default.func,
    setTradeIn: _propTypes2.default.func.isRequired,
    tradeInVehicle: _propTypes2.default.instanceOf(_TradeInVehicleModel2.default),
    onValueClick: _propTypes2.default.func,
    onLienClick: _propTypes2.default.func
};

TradeInValue.displayName = 'TradeInValue';

exports.default = TradeInValue;

/***/ }),

/***/ "./src/Vehicle/components/PaymentOptionFilters/TradeInValue/TradeInValue.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/Vehicle/components/TileTag/TileTag.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

__webpack_require__("./src/Vehicle/components/TileTag/TileTag.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TileTag = function TileTag(_ref) {
    var shouldRender = _ref.shouldRender,
        icon = _ref.icon,
        background = _ref.background,
        color = _ref.color,
        text = _ref.text;

    if (!shouldRender) {
        return null;
    }

    var style = {
        background: background,
        color: color
    };

    return _react2.default.createElement(
        'div',
        { className: 'tile-tag picto-showroom is-bold', style: style },
        icon && _react2.default.createElement('icon', { className: icon }),
        _react2.default.createElement(
            'span',
            null,
            text
        )
    );
};

TileTag.defaultProps = {
    icon: null,
    background: '#fff',
    color: '#000'
};

TileTag.propTypes = {
    shouldRender: _propTypes2.default.bool.isRequired,
    icon: _propTypes2.default.string,
    background: _propTypes2.default.string,
    color: _propTypes2.default.string,
    text: _propTypes2.default.string.isRequired
};

TileTag.displayName = 'TileTag';

exports.default = TileTag;

/***/ }),

/***/ "./src/Vehicle/components/TileTag/TileTag.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/Vehicle/components/VehicleBannerWithCarrousel/ExpandPhoto/ExpandPhoto.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__("./src/Vehicle/components/VehicleBannerWithCarrousel/Photos/Photos.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExpandPhoto = function (_React$Component) {
    _inherits(ExpandPhoto, _React$Component);

    function ExpandPhoto(props) {
        _classCallCheck(this, ExpandPhoto);

        var _this = _possibleConstructorReturn(this, (ExpandPhoto.__proto__ || Object.getPrototypeOf(ExpandPhoto)).call(this, props));

        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }

    _createClass(ExpandPhoto, [{
        key: 'handleClick',
        value: function handleClick(event) {
            event.preventDefault();
            this.props.togglePhotoLightBox(0);
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'vehicleBanner-photos-expand clearfix' },
                _react2.default.createElement(
                    'button',
                    { type: 'button', className: 'photo-expand', onClick: this.handleClick },
                    _react2.default.createElement('icon', { className: 'icon-expand' })
                )
            );
        }
    }]);

    return ExpandPhoto;
}(_react2.default.Component);

ExpandPhoto.propTypes = {
    togglePhotoLightBox: _propTypes2.default.func.isRequired
};

ExpandPhoto.displayName = 'ExpandPhoto';

exports.default = ExpandPhoto;

/***/ }),

/***/ "./src/Vehicle/components/VehicleBannerWithCarrousel/Photo/Photo.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Photo = function (_React$Component) {
    _inherits(Photo, _React$Component);

    function Photo(props) {
        _classCallCheck(this, Photo);

        var _this = _possibleConstructorReturn(this, (Photo.__proto__ || Object.getPrototypeOf(Photo)).call(this, props));

        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }

    _createClass(Photo, [{
        key: 'handleClick',
        value: function handleClick(event) {
            event.preventDefault();
            this.props.openPhotoLightBox(this.props.index);
        }
    }, {
        key: 'render',
        value: function render() {
            var photo = this.props.photo;

            return _react2.default.createElement(
                'a',
                {
                    className: 'vehicleBanner-photo',
                    onClick: this.handleClick,
                    href: photo,
                    title: _widgetCommonsCoreServices.LocaleService.t('IMAGE_NUMBER', { number: this.props.index + 1 })
                },
                _react2.default.createElement('img', { src: photo, alt: _widgetCommonsCoreServices.LocaleService.t('IMAGE_NUMBER', { number: this.props.index + 1 }) })
            );
        }
    }]);

    return Photo;
}(_react2.default.Component);

Photo.propTypes = {
    photo: _propTypes2.default.string.isRequired,
    index: _propTypes2.default.number.isRequired,
    openPhotoLightBox: _propTypes2.default.func.isRequired
};

Photo.displayName = 'Photo';

exports.default = Photo;

/***/ }),

/***/ "./src/Vehicle/components/VehicleBannerWithCarrousel/Photos/MediaButton.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MediaButton = function (_React$Component) {
    _inherits(MediaButton, _React$Component);

    function MediaButton(props) {
        _classCallCheck(this, MediaButton);

        var _this = _possibleConstructorReturn(this, (MediaButton.__proto__ || Object.getPrototypeOf(MediaButton)).call(this, props));

        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }

    _createClass(MediaButton, [{
        key: 'handleClick',
        value: function handleClick(e) {
            e.preventDefault();
            this.props.handleClick();
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'button',
                { type: 'button', className: this.props.className, onClick: this.handleClick },
                _react2.default.createElement('icon', { className: this.props.icon }),
                _react2.default.createElement(
                    'p',
                    { className: 'photo-available is-util sr-text' },
                    this.props.text
                )
            );
        }
    }]);

    return MediaButton;
}(_react2.default.Component);

MediaButton.defaultProps = {
    text: '',
    icon: ''
};

MediaButton.propTypes = {
    handleClick: _propTypes2.default.func.isRequired,
    className: _propTypes2.default.string.isRequired,
    icon: _propTypes2.default.string,
    text: _propTypes2.default.string
};

exports.default = MediaButton;

/***/ }),

/***/ "./src/Vehicle/components/VehicleBannerWithCarrousel/Photos/Photos.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _Photo = __webpack_require__("./src/Vehicle/components/VehicleBannerWithCarrousel/Photo/Photo.jsx");

var _Photo2 = _interopRequireDefault(_Photo);

var _MediaButton = __webpack_require__("./src/Vehicle/components/VehicleBannerWithCarrousel/Photos/MediaButton.jsx");

var _MediaButton2 = _interopRequireDefault(_MediaButton);

__webpack_require__("./src/Vehicle/components/VehicleBannerWithCarrousel/Photos/Photos.scss");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Photos = function (_React$Component) {
    _inherits(Photos, _React$Component);

    function Photos(props) {
        _classCallCheck(this, Photos);

        var _this = _possibleConstructorReturn(this, (Photos.__proto__ || Object.getPrototypeOf(Photos)).call(this, props));

        _this.onVideoButtonClick = _this.onVideoButtonClick.bind(_this);
        _this.onPhotoButtonClick = _this.onPhotoButtonClick.bind(_this);
        return _this;
    }

    _createClass(Photos, [{
        key: 'onVideoButtonClick',
        value: function onVideoButtonClick() {
            this.props.toggleVideoModal();
        }
    }, {
        key: 'onPhotoButtonClick',
        value: function onPhotoButtonClick() {
            _widgetCommonsGeneral.AnalyticsService.gaTrigger(_widgetCommonsGeneral.TRACKING_TAGS.USED_VDP_PICTURES(_widgetCommonsCoreServices.WindowProxy.location().pathname));
            this.props.togglePhotoLightBox(0);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var pictures = this.props.pictures;
            var gallery = pictures.slice(0, 3);
            var hasVideo = this.props.video.url.length !== 0;

            var photos = gallery.map(function (photo, i) {
                return _react2.default.createElement(_Photo2.default, {
                    key: photo.url || 'vehicle-picture-' + i,
                    photo: photo.url,
                    index: i,
                    openPhotoLightBox: _this2.props.togglePhotoLightBox
                });
            });

            var moreMediaButton = hasVideo ? _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_MediaButton2.default, {
                    handleClick: this.onPhotoButtonClick,
                    className: 'vehicleBanner-video-button',
                    icon: 'icon-gallery',
                    text: _widgetCommonsCoreServices.LocaleService.t('PHOTO_AVAILABLE', { number: this.props.pictures.length })
                }),
                _react2.default.createElement(_MediaButton2.default, {
                    handleClick: this.onVideoButtonClick,
                    className: 'vehicleBanner-video-button',
                    icon: 'icon-play-button',
                    text: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.PLAY_VIDEO')
                })
            ) : _react2.default.createElement(_MediaButton2.default, {
                handleClick: this.onPhotoButtonClick,
                className: 'vehicleBanner-photo-button',
                icon: 'icon-gallery',
                text: _widgetCommonsCoreServices.LocaleService.t('PHOTO_AVAILABLE', { number: this.props.pictures.length })
            });

            return _react2.default.createElement(
                'div',
                { className: 'vehicleBanner-photos clearfix' },
                photos,
                moreMediaButton
            );
        }
    }]);

    return Photos;
}(_react2.default.Component);

Photos.propTypes = {
    pictures: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        src: _propTypes2.default.string,
        url: _propTypes2.default.string
    })).isRequired,
    video: _propTypes2.default.shape({
        url: _propTypes2.default.string
    }).isRequired,
    togglePhotoLightBox: _propTypes2.default.func.isRequired,
    toggleVideoModal: _propTypes2.default.func.isRequired
};

Photos.displayName = 'Photos';

exports.default = Photos;

/***/ }),

/***/ "./src/Vehicle/components/VehicleBannerWithCarrousel/Photos/Photos.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/Vehicle/components/VehicleBannerWithCarrousel/VehicleBanner/VehicleBanner.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _VehicleModel = __webpack_require__("./src/Vehicle/models/VehicleModel.js");

var _VehicleModel2 = _interopRequireDefault(_VehicleModel);

var _ExpandPhoto = __webpack_require__("./src/Vehicle/components/VehicleBannerWithCarrousel/ExpandPhoto/ExpandPhoto.jsx");

var _ExpandPhoto2 = _interopRequireDefault(_ExpandPhoto);

var _Photos = __webpack_require__("./src/Vehicle/components/VehicleBannerWithCarrousel/Photos/Photos.jsx");

var _Photos2 = _interopRequireDefault(_Photos);

var _VideoWrapper = __webpack_require__("./src/Vehicle/components/VehicleBannerWithCarrousel/Video/VideoWrapper.jsx");

var _VideoWrapper2 = _interopRequireDefault(_VideoWrapper);

var _VehicleBannerOverlay = __webpack_require__("./src/Vehicle/components/VehicleBannerWithCarrousel/VehicleBanner/VehicleBannerOverlay/VehicleBannerOverlay.jsx");

var _VehicleBannerOverlay2 = _interopRequireDefault(_VehicleBannerOverlay);

__webpack_require__("./src/Vehicle/components/VehicleBannerWithCarrousel/VehicleBanner/VehicleBanner.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VehicleBanner = function (_React$Component) {
    _inherits(VehicleBanner, _React$Component);

    function VehicleBanner(props) {
        _classCallCheck(this, VehicleBanner);

        var _this = _possibleConstructorReturn(this, (VehicleBanner.__proto__ || Object.getPrototypeOf(VehicleBanner)).call(this, props));

        _this.modal = _widgetCommonsGeneral.ModalService.get(_this.constructor.MODAL);

        _this.state = {
            lightBoxIsOpen: false,
            lightBoxStartIndex: 0
        };

        _this.toggleLightBox = _this.toggleLightBox.bind(_this);
        _this.handleClickEvent = _this.handleClickEvent.bind(_this);
        _this.handleMobileClickEvent = _this.handleMobileClickEvent.bind(_this);
        _this.showVideoModal = _this.showVideoModal.bind(_this);
        return _this;
    }

    _createClass(VehicleBanner, [{
        key: 'showVideoModal',
        value: function showVideoModal() {
            this.modal.open();
        }
    }, {
        key: 'handleClickEvent',
        value: function handleClickEvent(event) {
            event.preventDefault();

            if (this.props.vehicle.multimedia.video && this.props.vehicle.multimedia.video.url) {
                this.showVideoModal();
            } else {
                this.toggleLightBox();
            }
        }
    }, {
        key: 'handleMobileClickEvent',
        value: function handleMobileClickEvent(event) {
            event.preventDefault();
            event.stopPropagation();

            this.toggleLightBox();
        }
    }, {
        key: 'toggleLightBox',
        value: function toggleLightBox(index) {
            if (this.props.vehicle.multimedia.hasPictures()) {
                this.setState(function (previousState) {
                    return {
                        lightBoxIsOpen: !previousState.lightBoxIsOpen,
                        lightBoxStartIndex: !previousState.lightBoxIsOpen && index ? index : 0
                    };
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var loading = this.props.loading;

            if (loading) {
                return null;
            }

            var vehicleHasPictures = this.props.vehicle.multimedia.hasPictures();
            var vehicleHasVideo = this.props.vehicle.multimedia.hasVideo();

            var isLocked = this.props.vehicle.locked && _react2.default.createElement(_VehicleBannerOverlay2.default, { icon: 'icon-lock', content: _widgetCommonsCoreServices.LocaleService.t('VEHICLE_STATUS.IS_LOCKED') });

            var isSold = this.props.vehicle.sold && _react2.default.createElement(_VehicleBannerOverlay2.default, { icon: 'icon-lock', content: _widgetCommonsCoreServices.LocaleService.t('VEHICLE_STATUS.IS_SOLD') });

            var isComingSoon = this.props.vehicle.flags.reduce(function (resolver, _ref) {
                var type = _ref.type;

                return resolver || type === 'COMING_SOON';
            }, false);

            var isComingSoonFilter = isComingSoon && !this.props.vehicle.locked && _react2.default.createElement(_VehicleBannerOverlay2.default, { icon: 'icon-stopwatch', content: _widgetCommonsCoreServices.LocaleService.t('VEHICLE_STATUS.COMING_SOON') });

            var personsViewed = this.props.vehicle.recentViewCount > 0 && _react2.default.createElement(
                'div',
                { className: 'vehicleBanner-personsViewed' },
                _react2.default.createElement('icon', { className: 'icon-eye picto-showroom' }),
                _react2.default.createElement(
                    'span',
                    { className: 'amount is-price' },
                    this.props.vehicle.recentViewCount
                ),
                _react2.default.createElement(
                    'span',
                    { className: 'label' },
                    _widgetCommonsCoreServices.LocaleService.t(this.props.vehicle.recentViewCount === 1 ? 'VDP_BANNER_PERSON_LOOKING' : 'VDP_BANNER_PERSONS_LOOKING')
                )
            );

            var contentZoneDefaultPicture = _widgetCommonsCoreServices.ContentZonesService.getContentZone('widget.vdp.used.similar.cars', 'default.picture');

            var imageUrl = '';
            if (this.props.vehicle.multimedia.getMainImage() !== '') {
                imageUrl = this.props.vehicle.multimedia.getMainImage();
            } else if (contentZoneDefaultPicture) {
                imageUrl = contentZoneDefaultPicture.getValue();
            } else {
                imageUrl = '';
            }

            var yearMakeModel = this.props.vehicle.getYearMakeModel();

            var thumbnail = _react2.default.createElement('img', { src: imageUrl, alt: yearMakeModel });
            if (vehicleHasVideo) {
                thumbnail = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement('icon', { className: 'icon-play-button vehicleBanner-playVideoThumbnail-button' }),
                    _react2.default.createElement('img', { src: imageUrl, alt: yearMakeModel })
                );
            }

            var expandPhoto = !vehicleHasVideo && vehicleHasPictures && _react2.default.createElement(_ExpandPhoto2.default, { togglePhotoLightBox: this.toggleLightBox });

            var wrapperClasses = ['vehicleBanner--image-wrapper'];
            if (vehicleHasPictures || vehicleHasVideo) {
                wrapperClasses.push('is-clickable');
            }

            var photos = vehicleHasPictures && _react2.default.createElement(_Photos2.default, {
                video: this.props.vehicle.multimedia.video,
                pictures: this.props.vehicle.multimedia.pictures,
                togglePhotoLightBox: this.toggleLightBox,
                toggleVideoModal: this.showVideoModal
            });

            var carouselBtn = vehicleHasPictures && _react2.default.createElement(
                'div',
                { className: 'carouselBtn sr-button-1 is-small', onClick: this.handleMobileClickEvent },
                _react2.default.createElement('icon', { className: 'icon-gallery' }),
                this.props.vehicle.multimedia.pictures.length
            );

            var trackLightboxNextBtn = function trackLightboxNextBtn() {
                return _widgetCommonsGeneral.AnalyticsService.gaTrigger(_widgetCommonsGeneral.TRACKING_TAGS.USED_VDP_PICTURES__NEXT(_widgetCommonsCoreServices.WindowProxy.location().pathname));
            };

            return _react2.default.createElement(
                'div',
                { className: wrapperClasses.join(' ') },
                _react2.default.createElement(
                    'div',
                    { className: 'vehicleBanner--image', onClick: this.handleClickEvent },
                    isSold || isLocked,
                    isComingSoonFilter,
                    carouselBtn,
                    thumbnail
                ),
                expandPhoto,
                photos,
                personsViewed,
                vehicleHasVideo && _react2.default.createElement(_VideoWrapper2.default, { videoURL: this.props.vehicle.multimedia.video.url }),
                this.state.lightBoxIsOpen && _react2.default.createElement(_widgetCommonsGeneral.LightBox, {
                    pictures: this.props.vehicle.multimedia.pictures,
                    toggleLightBox: this.toggleLightBox,
                    imageIndex: this.state.lightBoxStartIndex,
                    onGoToNext: trackLightboxNextBtn
                })
            );
        }
    }]);

    return VehicleBanner;
}(_react2.default.Component);

VehicleBanner.MODAL = 'VehicleBanner/VehicleVideo';

VehicleBanner.propTypes = {
    vehicle: _propTypes2.default.instanceOf(_VehicleModel2.default).isRequired,
    loading: _propTypes2.default.bool.isRequired
};

VehicleBanner.displayName = 'VehicleBanner';

exports.default = VehicleBanner;

/***/ }),

/***/ "./src/Vehicle/components/VehicleBannerWithCarrousel/VehicleBanner/VehicleBanner.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/Vehicle/components/VehicleBannerWithCarrousel/VehicleBanner/VehicleBannerOverlay/VehicleBannerOverlay.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VehicleBannerOverlay = function VehicleBannerOverlay(_ref) {
    var icon = _ref.icon,
        content = _ref.content;

    var iconClasses = ['vehicleBanner-filter-icon'];
    if (icon) {
        iconClasses.push(icon);
    }

    return _react2.default.createElement(
        'div',
        { className: 'vehicleBanner--filter' },
        _react2.default.createElement(
            'div',
            { className: 'vehicleBanner--filter__content' },
            _react2.default.createElement('icon', { className: iconClasses.join(' ') }),
            content
        )
    );
};

VehicleBannerOverlay.defaultProps = {
    icon: ''
};

VehicleBannerOverlay.propTypes = {
    icon: _propTypes2.default.string,
    content: _propTypes2.default.string.isRequired
};

VehicleBannerOverlay.displayName = 'VehicleBannerOverlay';

exports.default = VehicleBannerOverlay;

/***/ }),

/***/ "./src/Vehicle/components/VehicleBannerWithCarrousel/Video/Video.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Video = undefined;

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

__webpack_require__("./src/Vehicle/components/VehicleBannerWithCarrousel/Video/Video.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODAL = 'VehicleBanner/VehicleVideo';

var Video = function Video(_ref) {
    var videoURL = _ref.videoURL,
        modal = _ref.modal;

    return _react2.default.createElement(
        'div',
        { className: 'VehicleVideoModal' },
        _react2.default.createElement(
            'button',
            { onClick: modal.close },
            _react2.default.createElement('icon', { className: 'icon-X-rouge' })
        ),
        _react2.default.createElement(_widgetCommonsGeneral.YoutubePlayer, { videoURL: videoURL, autoplay: 1 })
    );
};

Video.propTypes = {
    videoURL: _propTypes2.default.string.isRequired,
    modal: _propTypes2.default.shape.isRequired
};

Video.displayName = 'VehicleVideoModal';

exports.Video = Video;
exports.default = (0, _widgetCommonsGeneral.withModal)(MODAL)(Video);

/***/ }),

/***/ "./src/Vehicle/components/VehicleBannerWithCarrousel/Video/Video.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/Vehicle/components/VehicleBannerWithCarrousel/Video/VideoWrapper.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Video = __webpack_require__("./src/Vehicle/components/VehicleBannerWithCarrousel/Video/Video.jsx");

var _Video2 = _interopRequireDefault(_Video);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VideoWrapper = function VideoWrapper(_ref) {
    var videoURL = _ref.videoURL;

    var modalStyles = {
        overlay: {
            zIndex: 9999,
            backgroundColor: 'rgba(0, 0, 0, 0.8)'
        },
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            width: '90%',
            height: '90%',
            padding: '0',
            overflow: 'visible',
            maxHeight: '500px',
            maxWidth: '890px',
            border: '0',
            backgroundColor: 'rgba(255, 255, 255, 1)'
        }
    };

    var modalOptions = {
        contentLabel: 'videoModal section dialog',
        style: modalStyles,
        shouldCloseOnOverlayClick: true
    };

    return _react2.default.createElement(_Video2.default, { videoURL: videoURL, modal: modalOptions });
};

VideoWrapper.propTypes = {
    videoURL: _propTypes2.default.string.isRequired // eslint-disable-line react/no-unused-prop-types
};

exports.default = VideoWrapper;

/***/ }),

/***/ "./src/Vehicle/components/VehicleDisclaimersContent/VehicleDisclaimersContent.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("lodash");

__webpack_require__("./src/Vehicle/components/VehicleDisclaimersContent/VehicleDisclaimersContent.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isDisclaimerValid(disclaimerValue) {
    return disclaimerValue && disclaimerValue.trim();
}

function disclaimerTemplateFromList(disclaimers) {
    return Object.values(disclaimers).map(function (disclaimer) {
        return isDisclaimerValid(disclaimer) && _react2.default.createElement(
            'span',
            { key: disclaimer },
            disclaimer,
            '\xA0'
        );
    });
}

var VehicleDisclaimersContent = function VehicleDisclaimersContent(_ref) {
    var disclaimers = _ref.disclaimers,
        disclaimersContentZone = _ref.disclaimersContentZone,
        genericDisclaimers = _ref.genericDisclaimers;

    return _react2.default.createElement(
        'div',
        { className: 'VehicleDisclaimersContent' },
        disclaimers && _react2.default.createElement(
            'p',
            null,
            disclaimerTemplateFromList(disclaimers)
        ),
        !(0, _lodash.isEmpty)(genericDisclaimers) && _react2.default.createElement(
            'p',
            null,
            disclaimerTemplateFromList(genericDisclaimers)
        ),
        isDisclaimerValid(disclaimersContentZone) && _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
                'span',
                null,
                disclaimersContentZone
            )
        )
    );
};

VehicleDisclaimersContent.defaultProps = {
    disclaimers: null,
    disclaimersContentZone: '',
    genericDisclaimers: []
};

VehicleDisclaimersContent.propTypes = {
    /** Disclaimers from the Showroom API */
    disclaimers: _propTypes2.default.shape({
        vehicleDescription: _propTypes2.default.string,
        sellingPrice: _propTypes2.default.string,
        priceInclusions: _propTypes2.default.string,
        priceExclusions: _propTypes2.default.string,
        termAndApr: _propTypes2.default.string,
        paymentAndCash: _propTypes2.default.string,
        obligationAndInterest: _propTypes2.default.string,
        creditApproval: _propTypes2.default.string
    }),
    genericDisclaimers: _propTypes2.default.arrayOf(_propTypes2.default.string),
    disclaimersContentZone: _propTypes2.default.string
};

exports.default = VehicleDisclaimersContent;

/***/ }),

/***/ "./src/Vehicle/components/VehicleDisclaimersContent/VehicleDisclaimersContent.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/Vehicle/components/VehicleRebate/VehicleRebate.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _currencyFormats = __webpack_require__("./src/constants/currencyFormats.js");

var _currencyFormats2 = _interopRequireDefault(_currencyFormats);

__webpack_require__("./src/Vehicle/components/VehicleRebate/VehicleRebate.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VehicleRebate = function VehicleRebate(_ref) {
    var rebate = _ref.rebate,
        electricRebate = _ref.electricRebate;

    var hasValidRebate = rebate && rebate > 0 || electricRebate && electricRebate > 0;
    if (!hasValidRebate) {
        return null;
    }
    return _react2.default.createElement(
        'div',
        { className: 'vehicle-rebate' },
        rebate > 0 && _react2.default.createElement(
            'div',
            { className: 'vehicle-rebate-single' },
            _react2.default.createElement('icon', { className: 'icon-promo2 is-price' }),
            _react2.default.createElement(
                'span',
                null,
                _widgetCommonsCoreServices.LocaleService.t('VEHICLE_STATUS.REBATE', {
                    rebate: _widgetCommonsCoreServices.LocaleService.l(rebate, _currencyFormats2.default.CURRENCY_0)
                })
            )
        ),
        electricRebate > 0 && _react2.default.createElement(
            'div',
            { className: 'vehicle-rebate-single' },
            _react2.default.createElement('icon', { className: 'icon-electric-vehicle sr-sucessColor' }),
            _react2.default.createElement(
                'span',
                null,
                _widgetCommonsCoreServices.LocaleService.t('VEHICLE_STATUS.ELECTRIC_REBATE')
            )
        )
    );
};

VehicleRebate.defaultProps = {
    rebate: 0,
    electricRebate: 0
};
VehicleRebate.propTypes = {
    rebate: _propTypes2.default.number,
    electricRebate: _propTypes2.default.number
};

VehicleRebate.displayName = 'VehicleRebate';

exports.default = VehicleRebate;

/***/ }),

/***/ "./src/Vehicle/components/VehicleRebate/VehicleRebate.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/Vehicle/components/VehicleTitleSpecs/VehicleTitleSpecs.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _VehicleModel = __webpack_require__("./src/Vehicle/models/VehicleModel.js");

var _VehicleModel2 = _interopRequireDefault(_VehicleModel);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

__webpack_require__("./src/Vehicle/components/VehicleTitleSpecs/VehicleTitleSpecs.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VehicleTitleSpecs = function VehicleTitleSpecs(_ref) {
    var className = _ref.className,
        url = _ref.url,
        vehicle = _ref.vehicle,
        isAvailable = _ref.isAvailable;

    var truthy = function truthy(value) {
        return !!value;
    };
    var specs = [vehicle.getOdometer(), vehicle.getDriveTrain(), vehicle.getTransmission(_widgetCommonsCoreServices.LocaleService), !!vehicle.cabSizeCode && _widgetCommonsCoreServices.LocaleService.capitalizeTitle(vehicle.cabSize[0]), !!vehicle.boxSizeCode && _widgetCommonsCoreServices.LocaleService.t('VEHICLE_TILE.BOX_SIZE', { boxSize: vehicle.boxSize[0] })].filter(truthy);
    var vehicleTitleSpecsClasses = isAvailable ? 'vehicle-title-specs' : 'vehicle-title-specs unavailable';

    return _react2.default.createElement(
        'div',
        { className: vehicleTitleSpecsClasses },
        _react2.default.createElement(
            'div',
            { className: 'vehicle-title' },
            url ? _react2.default.createElement(
                'a',
                { className: className, href: url },
                vehicle.getYearMakeModelTrim()
            ) : _react2.default.createElement(
                'span',
                { className: className },
                vehicle.getYearMakeModelTrim()
            )
        ),
        _react2.default.createElement(
            'ul',
            { className: 'vehicle-specs' },
            specs.map(function (spec) {
                return _react2.default.createElement(
                    'li',
                    { className: 'is-light' },
                    spec
                );
            })
        )
    );
};

VehicleTitleSpecs.defaultProps = {
    isAvailable: true,
    url: ''
};

VehicleTitleSpecs.propTypes = {
    vehicle: _propTypes2.default.instanceOf(_VehicleModel2.default).isRequired,
    url: _propTypes2.default.string,
    className: _propTypes2.default.string.isRequired,
    isAvailable: _propTypes2.default.bool
};

VehicleTitleSpecs.displayName = 'VehicleTitleSpecs';

exports.default = VehicleTitleSpecs;

/***/ }),

/***/ "./src/Vehicle/components/VehicleTitleSpecs/VehicleTitleSpecs.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/Vehicle/constants/badgeStatus.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var AVAIBLE_FLAGS = {
    AS_TRADED: 'AS_TRADED',
    CERTIFIED: 'CERTIFIED',
    EXTENDED_WARANTY: 'EXTENDED_WARANTY',
    INSPECTED: 'INSPECTED'
};

exports.default = AVAIBLE_FLAGS;

/***/ }),

/***/ "./src/Vehicle/constants/tradeInVehicleStatuses.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var AVAILABILITY_FLAGS = exports.AVAILABILITY_FLAGS = {
    ACTIVE: 0x0,
    EXPIRED: 0x1,
    DELETED: 0x2
};

var DATA_CONTENT_FLAGS = exports.DATA_CONTENT_FLAGS = {
    DESCRIPTION: 0x10,
    HISTORY: 0x20
};

var VALUE_SOURCE_FLAGS = exports.VALUE_SOURCE_FLAGS = {
    ESTIMATED: 0x100,
    OFFICIAL: 0x200
};

var UPDATE_STATUS = exports.UPDATE_STATUS = {
    ACTIVATED: AVAILABILITY_FLAGS.ACTIVE,
    DESCRIBED: DATA_CONTENT_FLAGS.DESCRIPTION,
    ESTIMATED: VALUE_SOURCE_FLAGS.ESTIMATED,
    ESTIMATED_EXPIRED: VALUE_SOURCE_FLAGS.ESTIMATED | AVAILABILITY_FLAGS.EXPIRED,
    OFFICIAL: VALUE_SOURCE_FLAGS.OFFICIAL,
    OFFICIAL_EXPIRED: VALUE_SOURCE_FLAGS.OFFICIAL | AVAILABILITY_FLAGS.EXPIRED
};

exports.default = {
    AVAILABILITY_FLAGS: AVAILABILITY_FLAGS,
    VALUE_SOURCE_FLAGS: VALUE_SOURCE_FLAGS,
    DATA_CONTENT_FLAGS: DATA_CONTENT_FLAGS,
    UPDATE_STATUS: UPDATE_STATUS
};

/***/ }),

/***/ "./src/Vehicle/constants/url.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var URL = {
    NO_PHOTO: '/widget/showroom/asset/non-photo.png'
};

exports.default = URL;

/***/ }),

/***/ "./src/Vehicle/i18n/en.json":
/***/ (function(module, exports) {

module.exports = {"SAVE_MONEY":"Save","DISCOUNT":"Lease Discount","MAX_DISCOUNT":"Up to %{price} discount","VEHICLE_STATUS":{"PRICING":"$ %{price}","ADD_FAVORITE":"Add to Favorite","CLEARANCE":"Clearance","COMING_SOON":"Coming Soon","RESERVED":"Reserved","NEW":"New Vehicle","DEMO":"Demo Vehicle","USED":"Pre-Owned Vehicle","REBATE":"Up to %{rebate} rebate","ELECTRIC_REBATE":"Government Electric Rebate","N/A":"N/A","BONI":"BONI","TAXES_DUTY":{"N/A":"N/A"},"IS_LOCKED":"Reserved Vehicle","IS_SOLD":"Sold Vehicle"},"VEHICLE_MODEL":{"YEAR_MAKE_MODEL":"%{year} %{make} %{model}","YEAR_MAKE_MODEL_TRIM":"%{year} %{make} %{model} %{modelTrim}","YEAR_MODEL":"%{year} %{model}","YEAR_MODEL_TRIM":"%{year} %{model} %{modelTrim}"},"VEHICLE_TILE":{"TAXES_AND_PRICE":"+ $%{taxe} ( %{taxCodes}) = $%{totalPrice}","TAXES":"+ %{taxCodes} & licence","PRICE":"Selling Price","CASH":"Cash","CASH_BUY":"Purchase Price","DISCLAIMER":"%{totalObligation} total obligation. %{costOfCredit} cost of credit. %{taxCodes} & licence fees not included.","PDSF":"MSRP","USED_PDSF":"Regular Price","TRANSPORT":"Freight & Preparation","OTHERS_TAXES":"Other Taxes & Licence","TRANSPORT_TAXES":"Freight and Preparation","TAXES_DUTY":"Other Taxes and Duties","PAY_LESS_FINANCING":"%{method} Available at %{amount}","FINANCING_METHOD_NAME":"Financing","LEASE_METHOD_NAME":"Leasing","ORIGIN":"Available at %{organizationUnitName}","BOX_SIZE":"%{boxSize} Box"},"VEHICLE_TILE_DISCLAIMER":{"OPEN":"Show Legal","HIDE":"Hide Legal"},"NOT_AVAILABLE":"Contact us for more details.","PAYMENT_OPTIONS_FILTERS":{"TRADE_IN_TAXES_CREDIT_DETAILS":"+ %{taxCreditsAmount} (Tax Credit) = %{tradeInWithTaxCreditsAmount}"},"TERMS":{"MONTH":"Months"},"CARFAX":{"TITLE":"Carfax","LINK":"/en/form/inventory/carproof-request/27?desired_make=%{make}&desired_model=%{model}&desired_year=%{year}&desired_trim=%{trim}&desired=inventory&stocknumber=%{stock}&carId=%{id}"},"SUMMARY":{"TRANSACTION_TITLE_CASH_PURCHASE":"Purchase Details","TRANSACTION_TITLE_FINANCE":"Finance Details","TRANSACTION_TITLE_LEASE":"Lease Details","SUMMARY_FINANCE_TITLE":"%{finance} Details","DELIVERY_TITLE":"Due at Delivery","BUY_BACK_TITLE":"Lease End","SELLING_PRICE":"Starting Price","DISCOUNTS":"Discounts","EXTERIOR_COLOUR":"Selected exterior colour","OPTIONS":"Selected Options & Accessories","FREIGHT_PDI":"Freight & PDI","TAXES_AND_DUTIES":"Other Taxes & Duties","OTHER_FEES":"Other fees","PROTECTIONS":"Selected Protections","REBATES":"Rebates","TOTAL_PRICE_BEFORE_TAXES":"Total Price","TAXES":"Taxes","CASHDOWN":"Cash Down","TRADE_IN":"Trade-In Value","LIEN":"Balance Due on Trade-In","TOTAL_PRICE_AFTER_TAXES":"Price After Taxes","FINANCED_AMOUNT":"Amount to Finance","CAPITALIZED_AMOUNT":"Capitalized Amount","BUY_BACK":"Buy Back Value","UPFRON_PAYMENT":"First Payment","TOTAL_DUE_AT_DELIVERY":"Total Due at Delivery (Plus Licence Fees)","TOTAL_REFUND_AT_DELIVERY":"Total Refund at Delivery (Less Licence Fees)","TERM":"Term (Month)","APR":"APR","EDIT_PAYMENTS":"Edit Payments","SIDEBAR_DELIVERY_TITLE":"Due at Delivery","BUTTON_TOGGLE":"Transaction details","PAYMENT":"Payment","PAYMENT_WITH_FREQUENCY":"Payment (%{frequency})","PRICE_ON_DEMAND":"Price on demand (we will contact you)","DEPOSIT":"Deposit","STOCK_NUMBER":"Stock #%{stock}","SEE_DETAILS":"Details","CLOSE_DETAILS":"Close","SUMMARY_PROTECTIONS_TITLE":"Protections","SUMMARY_ACCESSORIES_TITLE":"Accessories and options","SELECTED_PROTECTIONS_AMOUNT":"%{amount} Protection(s) Selected","SELECTED_ACCESSORIES_AMOUNT":"%{amount} Accessory(s) Selected","TOTAL":"Total","PLAY_VIDEO":"Play Video","OPTION_HEADER":"Installed Options","OPTION_COUNT_SINGLE":"1 additional option","OPTION_COUNT_PLURAL":"%{count} additional options"},"CALL_TO_ACTION":{"BTN_GARAGE_TITLE":"Add to Garage","BTN_GARAGE_TEXT":"Save Your Transaction","BTN_BOOK_APPOINTMENT_TITLE":"Prepare Your Visit","BTN_BOOK_APPOINTMENT_TEXT":"Save Time on Site","BTN_BUY_ONLINE_TITLE":"Buy Online","BTN_BUY_ONLINE_TEXT":"Live the Online Experience","BTN_EXCHANGE_TITLE":"Evaluate My Vehicle","BTN_EXCHANGE_TEXT":"Get Your Market Value","BTN_PRICE_QUOTE_TEXT":"Get the best price"},"MISSING_PHOTO":{"REFERENCE_PHOTO":"Photo for illustrative purposes only."},"FILTERS":{"ESTIMATED_EXCHANGE":"Trade-In Value","ESTIMATED_DEBTS":"Owe on Trade","NOT_AVAILABLE":"Not Available","INITIAL_CASHDOWN":"Initial Cash Down","INITIAL_PAYMENT":"Target Payment","PAYMENT_SELECTION":"Show"},"PAYMENTS_REBATES":{"ELECTRIC_REBATE":"Government Electric Rebate","TRADEIN":"Includes a trade-in of ","MANUFACTURER_REBATE":"OEM rebate","DEALER_REBATE":"Dealer rebate","USED_REBATE":"Rebate"}}

/***/ }),

/***/ "./src/Vehicle/i18n/fr.json":
/***/ (function(module, exports) {

module.exports = {"SAVE_MONEY":"Économisez","DISCOUNT":"de rabais location","MAX_DISCOUNT":"Jusqu'à %{price} de rabais","VEHICLE_STATUS":{"PRICING":"%{price} $","ADD_FAVORITE":"Ajouté aux favoris","CLEARANCE":"Liquidation","COMING_SOON":"En préparation","RESERVED":"Réservé","NEW":"Véhicule neuf","DEMO":"Véhicule démonstrateur","USED":"Véhicule d'occasion","REBATE":"Jusqu'à %{rebate} de rabais","ELECTRIC_REBATE":"Rabais écolo gouvernemental","N/A":"N/D","BONI":"BONI","TAXES_DUTY":{"N/A":"N/A"},"IS_LOCKED":"Véhicule réservé","IS_SOLD":"Véhicule vendu"},"VEHICLE_MODEL":{"YEAR_MAKE_MODEL":"%{make} %{model} %{year}","YEAR_MAKE_MODEL_TRIM":"%{make} %{model} %{modelTrim} %{year}","YEAR_MODEL":"%{model} %{year}","YEAR_MODEL_TRIM":"%{model} %{modelTrim} %{year}"},"VEHICLE_TILE":{"TAXES_AND_PRICE":"+ %{taxe}$ ( %{taxCodes}) = %{totalPrice}$","TAXES":"+ %{taxCodes} & immatriculation","PRICE":"Prix de vente","CASH":"Prix à l'achat","CASH_BUY":"Prix à l'achat","DISCLAIMER":"Obligation totale de %{totalObligation}. Coût de financement de %{costOfCredit}. %{taxCodes} & frais d'immatriculation en sus.","PDSF":"PDSF","USED_PDSF":"Prix régulier","TRANSPORT":"Transport & préparation","OTHERS_TAXES":"Autres taxes & droits","TRANSPORT_TAXES":"Transport & préparation","TAXES_DUTY":"Autres taxes & droits","PAY_LESS_FINANCING":"Payez %{amount} en %{method}","FINANCING_METHOD_NAME":"financement","LEASE_METHOD_NAME":"location","ORIGIN":"Disponible chez %{organizationUnitName}","BOX_SIZE":"Boîte de %{boxSize}"},"VEHICLE_TILE_DISCLAIMER":{"OPEN":"Afficher le texte légal","HIDE":"Réduire le texte légal"},"NOT_AVAILABLE":"Contactez-nous pour plus de détails.","PAYMENT_OPTIONS_FILTERS":{"TRADE_IN_TAXES_CREDIT_DETAILS":"+ %{taxCreditsAmount} (crédit taxes) = %{tradeInWithTaxCreditsAmount}"},"TERMS":{"MONTH":"mois"},"CARFAX":{"TITLE":"Carfax","LINK":"/fr/formulaire/demande-de-carproof-occasion/27?desired_make=%{make}&desired_model=%{model}&desired_year=%{year}&desired_trim=%{trim}&desired=inventory&stocknumber=%{stock}&carId=%{id}"},"SUMMARY":{"TRANSACTION_TITLE_CASH_PURCHASE":"Détails d'achat","TRANSACTION_TITLE_FINANCE":"Détails de financement","TRANSACTION_TITLE_LEASE":"Détails de location","SUMMARY_FINANCE_TITLE":"Détails de %{finance}","DELIVERY_TITLE":"Dû à la livraison","BUY_BACK_TITLE":"Fin de bail","SELLING_PRICE":"Prix de départ","DISCOUNTS":"Escomptes","EXTERIOR_COLOUR":"Couleur extérieure selectionnée","OPTIONS":"Options et accessoires selectionnés","FREIGHT_PDI":"Transport et préparation","TAXES_AND_DUTIES":"Autres taxes et droits","OTHER_FEES":"Autres frais","PROTECTIONS":"Protections selectionnées","REBATES":"Rabais","TOTAL_PRICE_BEFORE_TAXES":"Prix total","TAXES":"Taxes","CASHDOWN":"Acompte","TRADE_IN":"Valeur d'échange","LIEN":"Montant dû sur échange","TOTAL_PRICE_AFTER_TAXES":"Prix après taxes","FINANCED_AMOUNT":"Montant financé","CAPITALIZED_AMOUNT":"Montant capitalisé","BUY_BACK":"Valeur de rachat","UPFRON_PAYMENT":"Premier paiement","TOTAL_DUE_AT_DELIVERY":"Total dû à la livraison (plus immatriculation)","TOTAL_REFUND_AT_DELIVERY":"Total remboursable à la livraison (moins immatriculation)","TERM":"Terme (mois)","APR":"Taux d'intérêt","EDIT_PAYMENTS":"Éditer mon paiement","SIDEBAR_DELIVERY_TITLE":"Détails de la livraison","BUTTON_TOGGLE":"Détails de la transaction","PAYMENT":"Paiement","PAYMENT_WITH_FREQUENCY":"Paiement (%{frequency})","PRICE_ON_DEMAND":"Prix sur demande (nous vous contacterons)","DEPOSIT":"Dépôt","STOCK_NUMBER":"inventaire #%{stock}","SEE_DETAILS":"Détails","CLOSE_DETAILS":"Fermer","SUMMARY_PROTECTIONS_TITLE":"Protections","SUMMARY_ACCESSORIES_TITLE":"Accessoires et options","SELECTED_PROTECTIONS_AMOUNT":"%{amount} Protection(s) sélectionnée(s)","SELECTED_ACCESSORIES_AMOUNT":"%{amount} Accessoire(s) sélectionné(s)","TOTAL":"Total","PLAY_VIDEO":"Voir la vidéo","OPTION_HEADER":"Options installées","OPTION_COUNT_SINGLE":"1 option ajoutée","OPTION_COUNT_PLURAL":"%{count} options ajoutées"},"CALL_TO_ACTION":{"BTN_GARAGE_TITLE":"Ajouter au garage","BTN_GARAGE_TEXT":"Enregistrer votre transaction","BTN_BOOK_APPOINTMENT_TITLE":"Préparez votre visite","BTN_BOOK_APPOINTMENT_TEXT":"Sauvez du temps en concession","BTN_BUY_ONLINE_TITLE":"Achetez en ligne","BTN_BUY_ONLINE_TEXT":"Vivez l'expérience en ligne","BTN_EXCHANGE_TITLE":"Évaluer mon véhicule","BTN_EXCHANGE_TEXT":"Obtenez votre valeur du marché","BTN_PRICE_QUOTE_TEXT":"Obtenez le meilleur prix"},"MISSING_PHOTO":{"REFERENCE_PHOTO":"Photo à titre indicatif seulement."},"FILTERS":{"ESTIMATED_EXCHANGE":"Valeur d'échange","ESTIMATED_DEBTS":"Dette sur échange","NOT_AVAILABLE":"Non disponible","INITIAL_CASHDOWN":"Comptant initial","INITIAL_PAYMENT":"Paiement desiré","PAYMENT_SELECTION":"Afficher"},"PAYMENTS_REBATES":{"ELECTRIC_REBATE":"Rabais écolo gouvernemental","TRADEIN":"Incluant échange de ","MANUFACTURER_REBATE":"Rabais du manufacturier","DEALER_REBATE":"Rabais du concessionnaire","USED_REBATE":"Rabais"}}

/***/ }),

/***/ "./src/Vehicle/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TileTag = exports.VehicleTitleSpecs = exports.VehicleDisclaimersContent = exports.LightboxCarrousel = exports.VehicleRebate = exports.VehicleBannerWithCarrousel = exports.PaymentOptionFilters = exports.PaymentOptionsModel = exports.PriceQuoteCTA = exports.BuyOnlineCTA = exports.AppointmentCTA = exports.TradeInCTA = exports.URL = exports.TRADEIN_STATUSES = exports.BADGE_STATUS = exports.CertificationIconService = exports.TradeInVehicleAPIService = exports.TradeInVehicleService = exports.TradeInVehicleReducer = exports.TradeInVehicleModel = exports.TradeInValue = exports.MultiMediaModel = exports.VehicleAPIService = exports.VehicleService = exports.VehicleReducer = exports.VehicleModel = exports.Translation = exports.VehicleSummary = exports.Overview = exports.PaymentDetail = exports.Price = exports.CashPayment = exports.Payment = exports.CallToActionBar = exports.TradeInVehicleActionTypes = exports.TradeInVehicleActions = exports.VehicleActionTypes = exports.VehicleActions = undefined;

var _VehicleModel = __webpack_require__("./src/Vehicle/models/VehicleModel.js");

var _VehicleModel2 = _interopRequireDefault(_VehicleModel);

var _TradeInVehicleModel = __webpack_require__("./src/Vehicle/models/TradeInVehicleModel.js");

var _TradeInVehicleModel2 = _interopRequireDefault(_TradeInVehicleModel);

var _MultiMediaModel = __webpack_require__("./src/Vehicle/models/MultiMediaModel.js");

var _MultiMediaModel2 = _interopRequireDefault(_MultiMediaModel);

var _PaymentOptionsModel = __webpack_require__("./src/Vehicle/models/PaymentOptionsModel.js");

var _PaymentOptionsModel2 = _interopRequireDefault(_PaymentOptionsModel);

var _vehicleActions = __webpack_require__("./src/Vehicle/actions/vehicleActions.js");

var _vehicleActions2 = _interopRequireDefault(_vehicleActions);

var _vehicleActionTypes = __webpack_require__("./src/Vehicle/actions/vehicleActionTypes.js");

var _vehicleActionTypes2 = _interopRequireDefault(_vehicleActionTypes);

var _TradeInValue = __webpack_require__("./src/Vehicle/components/PaymentOptionFilters/TradeInValue/TradeInValue.jsx");

var _TradeInValue2 = _interopRequireDefault(_TradeInValue);

var _tradeInVehicleActions = __webpack_require__("./src/Vehicle/actions/tradeInVehicleActions.js");

var _tradeInVehicleActions2 = _interopRequireDefault(_tradeInVehicleActions);

var _tradeInVehicleActionTypes = __webpack_require__("./src/Vehicle/actions/tradeInVehicleActionTypes.js");

var _tradeInVehicleActionTypes2 = _interopRequireDefault(_tradeInVehicleActionTypes);

var _vehicleReducer = __webpack_require__("./src/Vehicle/reducers/vehicleReducer.js");

var _vehicleReducer2 = _interopRequireDefault(_vehicleReducer);

var _tradeInVehicleReducer = __webpack_require__("./src/Vehicle/reducers/tradeInVehicleReducer.js");

var _tradeInVehicleReducer2 = _interopRequireDefault(_tradeInVehicleReducer);

var _VehicleService = __webpack_require__("./src/Vehicle/services/VehicleService/VehicleService.js");

var _VehicleService2 = _interopRequireDefault(_VehicleService);

var _VehicleAPIService = __webpack_require__("./src/Vehicle/services/VehicleAPIService/VehicleAPIService.js");

var _VehicleAPIService2 = _interopRequireDefault(_VehicleAPIService);

var _TradeInVehicleService = __webpack_require__("./src/Vehicle/services/TradeInVehicleService/TradeInVehicleService.js");

var _TradeInVehicleService2 = _interopRequireDefault(_TradeInVehicleService);

var _TradeInVehicleAPIService = __webpack_require__("./src/Vehicle/services/TradeInVehicleAPIService/TradeInVehicleAPIService.js");

var _TradeInVehicleAPIService2 = _interopRequireDefault(_TradeInVehicleAPIService);

var _CertificationIconService = __webpack_require__("./src/Vehicle/services/CertificationIconService/CertificationIconService.js");

var _CertificationIconService2 = _interopRequireDefault(_CertificationIconService);

var _badgeStatus = __webpack_require__("./src/Vehicle/constants/badgeStatus.js");

var _badgeStatus2 = _interopRequireDefault(_badgeStatus);

var _tradeInVehicleStatuses = __webpack_require__("./src/Vehicle/constants/tradeInVehicleStatuses.js");

var _tradeInVehicleStatuses2 = _interopRequireDefault(_tradeInVehicleStatuses);

var _url = __webpack_require__("./src/Vehicle/constants/url.js");

var _url2 = _interopRequireDefault(_url);

var _Financing = __webpack_require__("./src/Vehicle/components/Payment/Financing/Financing.jsx");

var _Financing2 = _interopRequireDefault(_Financing);

var _CashPayment = __webpack_require__("./src/Vehicle/components/Payment/CashPayment/CashPayment.jsx");

var _CashPayment2 = _interopRequireDefault(_CashPayment);

var _PaymentDetail = __webpack_require__("./src/Vehicle/components/Payment/PaymentDetail/PaymentDetail.jsx");

var _PaymentDetail2 = _interopRequireDefault(_PaymentDetail);

var _Overview = __webpack_require__("./src/Vehicle/components/Overview/Overview.jsx");

var _Overview2 = _interopRequireDefault(_Overview);

var _VehicleSummary = __webpack_require__("./src/Vehicle/components/Overview/VehicleSummary/VehicleSummary.jsx");

var _VehicleSummary2 = _interopRequireDefault(_VehicleSummary);

var _Price = __webpack_require__("./src/Vehicle/components/Payment/Price/Price.jsx");

var _Price2 = _interopRequireDefault(_Price);

var _AppointmentCTA = __webpack_require__("./src/Vehicle/components/CallToAction/Appointment/AppointmentCTA.jsx");

var _AppointmentCTA2 = _interopRequireDefault(_AppointmentCTA);

var _BuyOnlineCTA = __webpack_require__("./src/Vehicle/components/CallToAction/BuyOnline/BuyOnlineCTA.jsx");

var _BuyOnlineCTA2 = _interopRequireDefault(_BuyOnlineCTA);

var _PriceQuoteCTA = __webpack_require__("./src/Vehicle/components/CallToAction/PriceQuote/PriceQuoteCTA.jsx");

var _PriceQuoteCTA2 = _interopRequireDefault(_PriceQuoteCTA);

var _TradeInCTA = __webpack_require__("./src/Vehicle/components/CallToAction/TradeIn/TradeInCTA.jsx");

var _TradeInCTA2 = _interopRequireDefault(_TradeInCTA);

var _VehicleCtaBar = __webpack_require__("./src/Vehicle/components/CallToAction/VehicleCtaBar/VehicleCtaBar.jsx");

var _VehicleCtaBar2 = _interopRequireDefault(_VehicleCtaBar);

var _PaymentOptionFilters = __webpack_require__("./src/Vehicle/components/PaymentOptionFilters/PaymentOptionFilters.jsx");

var _PaymentOptionFilters2 = _interopRequireDefault(_PaymentOptionFilters);

var _VehicleBanner = __webpack_require__("./src/Vehicle/components/VehicleBannerWithCarrousel/VehicleBanner/VehicleBanner.jsx");

var _VehicleBanner2 = _interopRequireDefault(_VehicleBanner);

var _VehicleRebate = __webpack_require__("./src/Vehicle/components/VehicleRebate/VehicleRebate.jsx");

var _VehicleRebate2 = _interopRequireDefault(_VehicleRebate);

var _LightboxCarrousel = __webpack_require__("./src/Vehicle/components/LightboxCarrousel/LightboxCarrousel.jsx");

var _LightboxCarrousel2 = _interopRequireDefault(_LightboxCarrousel);

var _VehicleDisclaimersContent = __webpack_require__("./src/Vehicle/components/VehicleDisclaimersContent/VehicleDisclaimersContent.jsx");

var _VehicleDisclaimersContent2 = _interopRequireDefault(_VehicleDisclaimersContent);

var _VehicleTitleSpecs = __webpack_require__("./src/Vehicle/components/VehicleTitleSpecs/VehicleTitleSpecs.jsx");

var _VehicleTitleSpecs2 = _interopRequireDefault(_VehicleTitleSpecs);

var _TileTag = __webpack_require__("./src/Vehicle/components/TileTag/TileTag.jsx");

var _TileTag2 = _interopRequireDefault(_TileTag);

var _en = __webpack_require__("./src/Vehicle/i18n/en.json");

var _en2 = _interopRequireDefault(_en);

var _fr = __webpack_require__("./src/Vehicle/i18n/fr.json");

var _fr2 = _interopRequireDefault(_fr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Translation = { en: _en2.default, fr: _fr2.default };

exports.VehicleActions = _vehicleActions2.default;
exports.VehicleActionTypes = _vehicleActionTypes2.default;
exports.TradeInVehicleActions = _tradeInVehicleActions2.default;
exports.TradeInVehicleActionTypes = _tradeInVehicleActionTypes2.default;
exports.CallToActionBar = _VehicleCtaBar2.default;
exports.Payment = _Financing2.default;
exports.CashPayment = _CashPayment2.default;
exports.Price = _Price2.default;
exports.PaymentDetail = _PaymentDetail2.default;
exports.Overview = _Overview2.default;
exports.VehicleSummary = _VehicleSummary2.default;
exports.Translation = Translation;
exports.VehicleModel = _VehicleModel2.default;
exports.VehicleReducer = _vehicleReducer2.default;
exports.VehicleService = _VehicleService2.default;
exports.VehicleAPIService = _VehicleAPIService2.default;
exports.MultiMediaModel = _MultiMediaModel2.default;
exports.TradeInValue = _TradeInValue2.default;
exports.TradeInVehicleModel = _TradeInVehicleModel2.default;
exports.TradeInVehicleReducer = _tradeInVehicleReducer2.default;
exports.TradeInVehicleService = _TradeInVehicleService2.default;
exports.TradeInVehicleAPIService = _TradeInVehicleAPIService2.default;
exports.CertificationIconService = _CertificationIconService2.default;
exports.BADGE_STATUS = _badgeStatus2.default;
exports.TRADEIN_STATUSES = _tradeInVehicleStatuses2.default;
exports.URL = _url2.default;
exports.TradeInCTA = _TradeInCTA2.default;
exports.AppointmentCTA = _AppointmentCTA2.default;
exports.BuyOnlineCTA = _BuyOnlineCTA2.default;
exports.PriceQuoteCTA = _PriceQuoteCTA2.default;
exports.PaymentOptionsModel = _PaymentOptionsModel2.default;
exports.PaymentOptionFilters = _PaymentOptionFilters2.default;
exports.VehicleBannerWithCarrousel = _VehicleBanner2.default;
exports.VehicleRebate = _VehicleRebate2.default;
exports.LightboxCarrousel = _LightboxCarrousel2.default;
exports.VehicleDisclaimersContent = _VehicleDisclaimersContent2.default;
exports.VehicleTitleSpecs = _VehicleTitleSpecs2.default;
exports.TileTag = _TileTag2.default;
exports.default = {
    VehicleActions: _vehicleActions2.default,
    VehicleActionTypes: _vehicleActionTypes2.default,
    TradeInVehicleActions: _tradeInVehicleActions2.default,
    TradeInVehicleActionTypes: _tradeInVehicleActionTypes2.default,
    BADGE_STATUS: _badgeStatus2.default,
    URL: _url2.default,

    CallToActionBar: _VehicleCtaBar2.default,
    Payment: _Financing2.default,
    CashPayment: _CashPayment2.default,
    Price: _Price2.default,
    PaymentDetail: _PaymentDetail2.default,
    Overview: _Overview2.default,
    VehicleSummary: _VehicleSummary2.default,
    Translation: Translation,
    VehicleModel: _VehicleModel2.default,
    VehicleReducer: _vehicleReducer2.default,
    VehicleService: _VehicleService2.default,
    VehicleAPIService: _VehicleAPIService2.default,
    MultiMediaModel: _MultiMediaModel2.default,
    CertificationIconService: _CertificationIconService2.default,

    TradeInValue: _TradeInValue2.default,
    TradeInVehicleModel: _TradeInVehicleModel2.default,
    TradeInVehicleReducer: _tradeInVehicleReducer2.default,
    TradeInVehicleService: _TradeInVehicleService2.default,
    TradeInVehicleAPIService: _TradeInVehicleAPIService2.default,
    TRADEIN_STATUSES: _tradeInVehicleStatuses2.default,

    TradeInCTA: _TradeInCTA2.default,
    AppointmentCTA: _AppointmentCTA2.default,
    BuyOnlineCTA: _BuyOnlineCTA2.default,
    PriceQuoteCTA: _PriceQuoteCTA2.default,
    PaymentOptionsModel: _PaymentOptionsModel2.default,
    PaymentOptionFilters: _PaymentOptionFilters2.default,
    VehicleBannerWithCarrousel: _VehicleBanner2.default,
    VehicleRebate: _VehicleRebate2.default,
    LightboxCarrousel: _LightboxCarrousel2.default,
    VehicleDisclaimersContent: _VehicleDisclaimersContent2.default,
    VehicleTitleSpecs: _VehicleTitleSpecs2.default,
    TileTag: _TileTag2.default
};

/***/ }),

/***/ "./src/Vehicle/models/MultiMediaModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.imageInventoryPath = exports.imagesBasePath = exports.imagesServer = exports.buildCatalogWithMatchedCatalogVehicle = exports.buildInventoryBasePath = exports.buildImageUrls = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = __webpack_require__("immutable");

var _lodash = __webpack_require__("lodash");

var _index = __webpack_require__("./src/config/index.js");

var _index2 = _interopRequireDefault(_index);

var _url = __webpack_require__("./src/Vehicle/constants/url.js");

var _url2 = _interopRequireDefault(_url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var imagesServer = _index2.default.source.image;
var imagesBasePath = '/images';
var imageInventoryPath = '/inventory';

function buildImageUrls(imagePath) {
    return {
        url: '' + imagesServer + (imagePath || ''),
        url360x270: imagesServer + '/ir/w360h270' + (imagePath || ''),
        url360x240: imagesServer + '/ir/w360h197c' + (imagePath || ''),
        url440: imagesServer + '/ir/w440' + (imagePath || '')
    };
}

function buildInventoryBasePath() {
    return '' + imagesBasePath + imageInventoryPath;
}

function buildCatalogWithMatchedCatalogVehicle(matchedCatalogVehicle) {
    if (matchedCatalogVehicle && matchedCatalogVehicle.multimedia && matchedCatalogVehicle.multimedia.exteriorPictures) {
        return {
            catalog: matchedCatalogVehicle.multimedia.exteriorPictures
        };
    }
    return null;
}

var MultiMediaRecord = (0, _immutable.Record)({
    pictures: [],
    mainPicture: {
        url: '',
        url360x270: '',
        url440: ''
    },
    catalog: {
        side: {
            url: '',
            url360x197: '',
            exactMatch: false
        }
    },
    video: {
        url: ''
    }
});

var MultiMedia = function (_MultiMediaRecord) {
    _inherits(MultiMedia, _MultiMediaRecord);

    function MultiMedia(obj, matchedCatalogVehicle) {
        _classCallCheck(this, MultiMedia);

        var args = (0, _lodash.pickBy)(obj);
        var newArgs = {};

        if (args) {
            if (args.pictures && args.pictures.length) {
                newArgs.pictures = args.pictures.map(function (picture) {
                    var newUrl = '';

                    if (picture.url) {
                        newUrl = '' + imagesServer + buildInventoryBasePath() + picture.url;
                    }

                    return _extends({}, picture, {
                        url: newUrl,
                        src: newUrl
                    });
                });
            }

            if (args.mainPicture && args.mainPicture.url) {
                var imagePath = '' + buildInventoryBasePath() + args.mainPicture.url;

                newArgs.mainPicture = _extends({}, args.mainPicture, buildImageUrls(imagePath));
            }

            if (args.catalog) {
                var _imagePath = args.catalog.side && args.catalog.side.url ? args.catalog.side.url : _url2.default.NO_PHOTO;
                var imageUrl = imagesBasePath + '/' + _imagePath;
                newArgs.catalog = {
                    side: buildImageUrls(imageUrl)
                };
            }
        }

        if (matchedCatalogVehicle) {
            var multimediaCatalog = buildCatalogWithMatchedCatalogVehicle(matchedCatalogVehicle);
            if (multimediaCatalog) {
                newArgs.catalog = multimediaCatalog.catalog;
            }
        }

        return _possibleConstructorReturn(this, (MultiMedia.__proto__ || Object.getPrototypeOf(MultiMedia)).call(this, _extends({}, args, newArgs)));
    }

    _createClass(MultiMedia, [{
        key: 'getMainImage',
        value: function getMainImage() {
            return this.mainPicture && this.mainPicture.url ? this.mainPicture.url : '';
        }
    }, {
        key: 'getMainImage360x270',
        value: function getMainImage360x270() {
            return this.mainPicture && this.mainPicture.url360x270 ? this.mainPicture.url360x270 : '';
        }
    }, {
        key: 'getMainImage440',
        value: function getMainImage440() {
            return this.mainPicture && this.mainPicture.url440 ? this.mainPicture.url440 : '';
        }
    }, {
        key: 'getCatalogSideImage',
        value: function getCatalogSideImage() {
            return this.catalog && this.catalog.side && this.catalog.side.url ? this.catalog.side.url : '';
        }
    }, {
        key: 'getCatalogSideImage360x197',
        value: function getCatalogSideImage360x197() {
            return this.catalog && this.catalog.side && this.catalog.side.url360x240 ? this.catalog.side.url360x240 : '';
        }
    }, {
        key: 'getPicture',
        value: function getPicture(index) {
            // eslint-disable-next-line no-restricted-globals
            if (!isFinite(index) || index < 0 || !this.pictures.length || index > this.pictures.length) {
                return '';
            }

            var picture = this.pictures[index];

            return picture && picture.url ? picture.url : '';
        }
    }, {
        key: 'getVideo',
        value: function getVideo() {
            return this.hasVideo() ? this.video.url : '';
        }
    }, {
        key: 'hasPictures',
        value: function hasPictures() {
            return !(0, _lodash.isEmpty)(this.pictures);
        }
    }, {
        key: 'hasVideo',
        value: function hasVideo() {
            return !!(this.video && this.video.url);
        }
    }]);

    return MultiMedia;
}(MultiMediaRecord);

exports.buildImageUrls = buildImageUrls;
exports.buildInventoryBasePath = buildInventoryBasePath;
exports.buildCatalogWithMatchedCatalogVehicle = buildCatalogWithMatchedCatalogVehicle;
exports.imagesServer = imagesServer;
exports.imagesBasePath = imagesBasePath;
exports.imageInventoryPath = imageInventoryPath;
exports.default = MultiMedia;

/***/ }),

/***/ "./src/Vehicle/models/PaymentOptionsModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = __webpack_require__("immutable");

var _index = __webpack_require__("./src/PurchaseMethods/index.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaymentOptionsRecord = (0, _immutable.Record)({
    purchaseMethod: _index.PurchaseMethodsConstant.CASH_PURCHASE,
    frequencyValues: [],
    preferredPaymentFrequency: _index.PaymentFrequencies.WEEKLY,
    preferredPurchaseMethod: '',
    terms: [24, 36, 48, 60, 72, 84, 96],
    maximumTerm: 96,
    initialCashDown: 0,
    initialTargetPayment: 0,
    rangeEnabled: false,
    rangeStep: 25,
    rangeBoundaries: [0, 500],
    range: [0, 500]
});

var PaymentOptions = function (_PaymentOptionsRecord) {
    _inherits(PaymentOptions, _PaymentOptionsRecord);

    function PaymentOptions() {
        _classCallCheck(this, PaymentOptions);

        return _possibleConstructorReturn(this, (PaymentOptions.__proto__ || Object.getPrototypeOf(PaymentOptions)).apply(this, arguments));
    }

    return PaymentOptions;
}(PaymentOptionsRecord);

exports.default = PaymentOptions;

/***/ }),

/***/ "./src/Vehicle/models/TradeInVehicleModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = __webpack_require__("immutable");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _VehicleModel = __webpack_require__("./src/Vehicle/models/VehicleModel.js");

var _VehicleModel2 = _interopRequireDefault(_VehicleModel);

var _tradeInVehicleStatuses = __webpack_require__("./src/Vehicle/constants/tradeInVehicleStatuses.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TradeInVehicleRecord = (0, _immutable.Record)({
    id: '',
    status: 0,
    accountId: '',
    dealerId: '',
    taxesFactor: 0,
    taxCodes: [],
    vehicle: new _VehicleModel2.default(),
    lien: {
        owner: '',
        amount: 0
    },
    amount: 0,
    evaluationQuestion: null,
    modified: false
});

var TradeInVehicle = function (_TradeInVehicleRecord) {
    _inherits(TradeInVehicle, _TradeInVehicleRecord);

    function TradeInVehicle() {
        _classCallCheck(this, TradeInVehicle);

        return _possibleConstructorReturn(this, (TradeInVehicle.__proto__ || Object.getPrototypeOf(TradeInVehicle)).apply(this, arguments));
    }

    _createClass(TradeInVehicle, [{
        key: 'getTradeInAmount',
        value: function getTradeInAmount() {
            return this.amount;
        }
    }, {
        key: 'getLienAmount',
        value: function getLienAmount() {
            return this.lien.amount;
        }
    }, {
        key: 'getShowroomTradeInVehicle',
        value: function getShowroomTradeInVehicle() {
            var id = this.id,
                status = this.status,
                lien = this.lien,
                amount = this.amount,
                evaluationQuestion = this.evaluationQuestion;

            var showroomVehicle = this.vehicle.getShowroomVehicle();

            return {
                id: id,
                status: status,
                vehicle: showroomVehicle,
                lien: lien,
                amount: amount,
                evaluationQuestion: evaluationQuestion
            };
        }
    }, {
        key: 'getUpdateStatus',
        value: function getUpdateStatus() {
            if ((this.status & _tradeInVehicleStatuses.UPDATE_STATUS.OFFICIAL_EXPIRED) === _tradeInVehicleStatuses.UPDATE_STATUS.OFFICIAL_EXPIRED) {
                return _tradeInVehicleStatuses.UPDATE_STATUS.OFFICIAL_EXPIRED;
            } else if ((this.status & _tradeInVehicleStatuses.UPDATE_STATUS.OFFICIAL) === _tradeInVehicleStatuses.UPDATE_STATUS.OFFICIAL) {
                return _tradeInVehicleStatuses.UPDATE_STATUS.OFFICIAL;
            } else if ((this.status & _tradeInVehicleStatuses.UPDATE_STATUS.ESTIMATED_EXPIRED) === _tradeInVehicleStatuses.UPDATE_STATUS.ESTIMATED_EXPIRED) {
                return _tradeInVehicleStatuses.UPDATE_STATUS.ESTIMATED_EXPIRED;
            } else if ((this.status & _tradeInVehicleStatuses.UPDATE_STATUS.ESTIMATED) === _tradeInVehicleStatuses.UPDATE_STATUS.ESTIMATED) {
                return _tradeInVehicleStatuses.UPDATE_STATUS.ESTIMATED;
            } else if ((this.status & _tradeInVehicleStatuses.UPDATE_STATUS.DESCRIBED) === _tradeInVehicleStatuses.UPDATE_STATUS.DESCRIBED && (this.status & _tradeInVehicleStatuses.AVAILABILITY_FLAGS.DELETED) === 0) {
                return _tradeInVehicleStatuses.UPDATE_STATUS.DESCRIBED;
            }
            return _tradeInVehicleStatuses.UPDATE_STATUS.ACTIVATED;
        }
    }, {
        key: 'checkIsLocked',
        value: function checkIsLocked() {
            var updateStatus = this.getUpdateStatus();
            return updateStatus !== _tradeInVehicleStatuses.UPDATE_STATUS.DESCRIBED && updateStatus !== _tradeInVehicleStatuses.UPDATE_STATUS.ACTIVATED;
        }
    }, {
        key: 'checkIsUpdatable',
        value: function checkIsUpdatable() {
            return _widgetCommonsGeneral.AccountService.isAuthenticated() && !this.checkIsLocked() && this.id && this.modified;
        }
    }, {
        key: 'getTaxCredits',
        value: function getTaxCredits() {
            return Math.round(this.amount * this.taxesFactor * 100) / 100;
        }
    }]);

    return TradeInVehicle;
}(TradeInVehicleRecord);

exports.default = TradeInVehicle;

/***/ }),

/***/ "./src/Vehicle/models/VehicleModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = __webpack_require__("immutable");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _dataTypes = __webpack_require__("./src/constants/dataTypes.js");

var _vehicle = __webpack_require__("./src/constants/vehicle.js");

var _vehicle2 = _interopRequireDefault(_vehicle);

var _currencyFormats = __webpack_require__("./src/constants/currencyFormats.js");

var _PurchaseMethodsModel = __webpack_require__("./src/PurchaseMethods/models/PurchaseMethodsModel.js");

var _PurchaseMethodsModel2 = _interopRequireDefault(_PurchaseMethodsModel);

var _MultiMediaModel = __webpack_require__("./src/Vehicle/models/MultiMediaModel.js");

var _MultiMediaModel2 = _interopRequireDefault(_MultiMediaModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VehicleRecord = (0, _immutable.Record)({
    bodyStyle: null,
    bodyStyleCode: '',
    bodyColour: null,
    exteriorColourStatus: 0,
    boxSizeCode: '',
    boxSize: '',
    cabSizeCode: '',
    cabSize: '',
    catalogVehicleId: 0,
    clearance: false,
    configuration: null,
    configurationId: 0,
    configurationToken: '',
    discount: 0,
    doors: 0,
    driveTrain: '',
    driveTrainCode: '',
    engine: '',
    exteriorColour: '',
    favorite: false,
    features: [],
    flags: [],
    fuelCity: 0.0,
    fuelHighway: 0.0,
    fuelType: '',
    id: '',
    interiorColour: '',
    organizationUnitName: '',
    locked: false,
    make: '',
    model: '',
    modelTrim: '',
    modelTrimCode: '',
    modelTrimStyle: [],
    multimedia: new _MultiMediaModel2.default(),
    newCarTrimId: 0, // V2.5
    note: '',
    odometer: null,
    purchaseMethods: new _PurchaseMethodsModel2.default(),
    recentViewCount: 0,
    seating: 0,
    sellingPrice: 0,
    stockNumber: '',
    sold: false,
    tagLine: '',
    transmission: '',
    trim: '',
    vehicleConditionType: _vehicle2.default.CONDITIONS.USED,
    vehicleId: 0,
    vin: '',
    warranty: {},
    year: 0,
    discontinued: false,
    online: true
});

var Vehicle = function (_VehicleRecord) {
    _inherits(Vehicle, _VehicleRecord);

    function Vehicle() {
        _classCallCheck(this, Vehicle);

        return _possibleConstructorReturn(this, (Vehicle.__proto__ || Object.getPrototypeOf(Vehicle)).apply(this, arguments));
    }

    _createClass(Vehicle, [{
        key: 'isAvailable',
        value: function isAvailable() {
            return !(this.sold || this.locked || this.discontinued || !this.online);
        }
    }, {
        key: 'getIsVehicleNew',
        value: function getIsVehicleNew() {
            return this.vehicleConditionType === _vehicle2.default.CONDITIONS.NEW || this.vehicleConditionType === _vehicle2.default.CONDITIONS.DEMO;
        }
    }, {
        key: 'getMake',
        value: function getMake() {
            return !this.model.includes(this.make) ? this.make : '';
        }
    }, {
        key: 'getVehicleConditionType',
        value: function getVehicleConditionType() {
            switch (this.vehicleConditionType) {
                case _vehicle2.default.CONDITIONS.NEW:
                    return _widgetCommonsCoreServices.LocaleService.t('VEHICLE_STATUS.NEW');
                case _vehicle2.default.CONDITIONS.DEMO:
                    return _widgetCommonsCoreServices.LocaleService.t('VEHICLE_STATUS.DEMO');
                default:
                    return _widgetCommonsCoreServices.LocaleService.t('VEHICLE_STATUS.USED');
            }
        }
    }, {
        key: 'getYearMakeModel',
        value: function getYearMakeModel() {
            return this.year > 0 ? _widgetCommonsCoreServices.LocaleService.t('VEHICLE_MODEL.YEAR_MAKE_MODEL', {
                year: this.year,
                make: this.getMake(),
                model: this.model
            }) : '';
        }
    }, {
        key: 'getYearMakeModelTrim',
        value: function getYearMakeModelTrim() {
            if (this.year === 0) {
                return '';
            }

            var modelTrim = this.configuration !== null ? this.configuration.modelTrim.description : this.modelTrim;

            return this.modelTrim && !this.model.includes(this.modelTrim) ? _widgetCommonsCoreServices.LocaleService.t('VEHICLE_MODEL.YEAR_MAKE_MODEL_TRIM', {
                year: this.year,
                make: this.getMake(),
                model: this.model,
                modelTrim: modelTrim
            }) : _widgetCommonsCoreServices.LocaleService.t('VEHICLE_MODEL.YEAR_MAKE_MODEL', {
                year: this.year,
                make: this.getMake(),
                model: this.model
            });
        }
    }, {
        key: 'getYearModel',
        value: function getYearModel() {
            if (this.year === 0) {
                return '';
            }

            return _widgetCommonsCoreServices.LocaleService.t('VEHICLE_MODEL.YEAR_MODEL', { year: this.year, model: this.model });
        }
    }, {
        key: 'getYearModelTrim',
        value: function getYearModelTrim() {
            if (this.year === 0) {
                return '';
            }

            var modelTrim = this.configuration !== null ? this.configuration.modelTrim.description : this.modelTrim;
            return this.modelTrim && this.modelTrim !== this.model ? _widgetCommonsCoreServices.LocaleService.t('VEHICLE_MODEL.YEAR_MODEL_TRIM', {
                year: this.year,
                model: this.model,
                modelTrim: modelTrim
            }) : _widgetCommonsCoreServices.LocaleService.t('VEHICLE_MODEL.YEAR_MODEL', {
                year: this.year,
                model: this.model
            });
        }
    }, {
        key: 'getDiscount',
        value: function getDiscount() {
            return this.discount > 250 ? this.discount : 0;
        }
    }, {
        key: 'getOdometer',
        value: function getOdometer() {
            if (!this.odometer) {
                return '';
            }

            var odometer = _widgetCommonsCoreServices.LocaleService.l(this.odometer, _currencyFormats.ODOMETER);
            return odometer + ' km';
        }
    }, {
        key: 'getFuelConsumptionAverage',
        value: function getFuelConsumptionAverage() {
            return Math.round((this.fuelCity + this.fuelHighway) / 2 * 10) / 10;
        }
    }, {
        key: 'getDriveTrain',
        value: function getDriveTrain() {
            if (this.configuration !== null) {
                return this.configuration.driveTrain.longDescription;
            }
            return this.driveTrain;
        }
    }, {
        key: 'getEngine',
        value: function getEngine() {
            if (this.configuration !== null) {
                return this.configuration.engine.getSizeSpecifications();
            }
            return this.engine;
        }
    }, {
        key: 'getTransmission',
        value: function getTransmission() {
            if (this.configuration !== null) {
                return this.configuration.transmission.getTransmission();
            }
            return this.transmission;
        }
    }, {
        key: 'getPaymentCalculatorVehicleParameters',
        value: function getPaymentCalculatorVehicleParameters() {
            return {
                vehicleConditionType: this.vehicleConditionType,
                year: this.year,
                make: this.make,
                model: this.model,
                bodyStyleCode: this.bodyStyleCode,
                driveTrainCode: this.driveTrainCode,
                odometer: this.odometer,
                sellingPrice: this.sellingPrice
            };
        }
    }, {
        key: 'getDefaultVehicleQuoteItem',
        value: function getDefaultVehicleQuoteItem() {
            return {
                dataType: _dataTypes.DATA_TYPES.FEATURE.DATA_TYPE_ID,
                typeID: _dataTypes.DATA_TYPES.FEATURE.TYPES.MODEL_TRIM,
                code: _dataTypes.DEFAULT_MODEL_TRIM_CODE,
                flag: _dataTypes.ITEM_FLAG.SELECTED,
                amounts: {
                    retail: this.sellingPrice
                },
                description: {
                    descriptions: [this.model]
                }
            };
        }
    }, {
        key: 'getShowroomVehicle',
        value: function getShowroomVehicle() {
            var bodyColour = this.bodyColour,
                bodyStyle = this.bodyStyle,
                id = this.id,
                vehicleId = this.vehicleId,
                catalogVehicleId = this.catalogVehicleId,
                newCarTrimId = this.newCarTrimId,
                vehicleConditionType = this.vehicleConditionType,
                vin = this.vin,
                year = this.year,
                make = this.make,
                model = this.model,
                modelTrim = this.modelTrim,
                modelTrimCode = this.modelTrimCode,
                modelTrimStyle = this.modelTrimStyle,
                stockNumber = this.stockNumber,
                sold = this.sold,
                odometer = this.odometer,
                configuration = this.configuration,
                configurationId = this.configurationId,
                configurationToken = this.configurationToken;


            var isNewFromConfiguration = configuration !== null && (vehicleConditionType === _vehicle2.default.CONDITIONS.NEW || vehicleConditionType === _vehicle2.default.CONDITIONS.DEMO);

            return {
                bodyColour: bodyColour,
                bodyStyle: bodyStyle,
                id: id,
                vehicleId: String(vehicleId),
                catalogVehicleId: String(catalogVehicleId),
                newCarTrimId: String(newCarTrimId), // V2.5
                vehicleCondition: vehicleConditionType,
                vin: vin,
                year: year,
                make: make,
                model: model,
                modelTrim: modelTrim,
                modelTrimCode: isNewFromConfiguration ? configuration.modelTrimCode : modelTrimCode,
                modelTrimStyle: isNewFromConfiguration ? configuration.modelTrimStyle : modelTrimStyle,
                configurationID: isNewFromConfiguration ? configuration.id : configurationId,
                configurationToken: configurationToken || '',
                odometer: odometer,
                sold: sold,
                inventory: {
                    stock: stockNumber
                }
            };
        }
    }]);

    return Vehicle;
}(VehicleRecord);

exports.default = Vehicle;

/***/ }),

/***/ "./src/Vehicle/reducers/tradeInVehicleReducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = tradeInVehicleReducer;

var _tradeInVehicleActionTypes = __webpack_require__("./src/Vehicle/actions/tradeInVehicleActionTypes.js");

var tradeInVehicleTypes = _interopRequireWildcard(_tradeInVehicleActionTypes);

var _purchaseMethodsActionTypes = __webpack_require__("./src/PurchaseMethods/actions/purchaseMethodsActionTypes.js");

var _purchaseMethodsActionTypes2 = _interopRequireDefault(_purchaseMethodsActionTypes);

var _TradeInVehicleModel = __webpack_require__("./src/Vehicle/models/TradeInVehicleModel.js");

var _TradeInVehicleModel2 = _interopRequireDefault(_TradeInVehicleModel);

var _TradeInVehicleService = __webpack_require__("./src/Vehicle/services/TradeInVehicleService/TradeInVehicleService.js");

var TradeInVehicleService = _interopRequireWildcard(_TradeInVehicleService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function tradeInVehicleReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _TradeInVehicleModel2.default();
    var action = arguments[1];

    switch (action.type) {
        case _purchaseMethodsActionTypes2.default.LOAD_PURCHASE_METHODS_SUCCESS:
            return TradeInVehicleService.setTaxesFactor(state, action.purchaseMethods);

        case tradeInVehicleTypes.SET_TRADE_IN_VEHICLE:
            return action.tradeInVehicle;

        case _purchaseMethodsActionTypes2.default.SET_TRADE_IN:
            return TradeInVehicleService.setTradeIn(state, action.tradeIn);

        case _purchaseMethodsActionTypes2.default.SET_LIEN:
            return TradeInVehicleService.setLien(state, action.lien);

        default:
            return state;
    }
}

/***/ }),

/***/ "./src/Vehicle/reducers/vehicleReducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = vehicleReducer;

var _vehicleActionTypes = __webpack_require__("./src/Vehicle/actions/vehicleActionTypes.js");

var vehicleTypes = _interopRequireWildcard(_vehicleActionTypes);

var _purchaseMethodsActionTypes = __webpack_require__("./src/PurchaseMethods/actions/purchaseMethodsActionTypes.js");

var _purchaseMethodsActionTypes2 = _interopRequireDefault(_purchaseMethodsActionTypes);

var _VehicleModel = __webpack_require__("./src/Vehicle/models/VehicleModel.js");

var _VehicleModel2 = _interopRequireDefault(_VehicleModel);

var _PurchaseMethodsService = __webpack_require__("./src/PurchaseMethods/services/PurchaseMethodsService/PurchaseMethodsService.js");

var PurchaseMethodsService = _interopRequireWildcard(_PurchaseMethodsService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function vehicleReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _VehicleModel2.default();
    var action = arguments[1];

    switch (action.type) {
        case vehicleTypes.SET_VEHICLE:
            return action.vehicle;

        case vehicleTypes.SET_VEHICLE_PURCHASE_METHODS:
            return state.set('purchaseMethods', action.purchaseMethods);

        case _purchaseMethodsActionTypes2.default.SELECT_PURCHASE_METHOD:
            return state.set('purchaseMethods', PurchaseMethodsService.selectPurchaseMethod(state.purchaseMethods, action.purchaseMethod));

        case _purchaseMethodsActionTypes2.default.SELECT_TERM:
            return state.set('purchaseMethods', PurchaseMethodsService.selectTerm(state.purchaseMethods, action.term));

        case _purchaseMethodsActionTypes2.default.SELECT_PAYMENT_FREQUENCY:
            return state.set('purchaseMethods', PurchaseMethodsService.selectPaymentFrequency(state.purchaseMethods, action.paymentFrequency.value));

        case _purchaseMethodsActionTypes2.default.SET_CASH_DOWN:
            return state.set('purchaseMethods', PurchaseMethodsService.setCashDown(state.purchaseMethods, action.cashDown));

        case _purchaseMethodsActionTypes2.default.SET_TRADE_IN:
            return state.set('purchaseMethods', PurchaseMethodsService.setTradeIn(state.purchaseMethods, action.tradeIn));

        case _purchaseMethodsActionTypes2.default.SET_LIEN:
            return state.set('purchaseMethods', PurchaseMethodsService.setLien(state.purchaseMethods, action.lien));

        case _purchaseMethodsActionTypes2.default.SET_EXTERIOR_COLOUR_AMOUNTS:
            return state.set('purchaseMethods', PurchaseMethodsService.setExteriorColourAmounts(state.purchaseMethods, action.exteriorColourAmounts));

        case _purchaseMethodsActionTypes2.default.SET_INTERIOR_COLOUR_AMOUNTS:
            return state.set('purchaseMethods', PurchaseMethodsService.setInteriorColourAmounts(state.purchaseMethods, action.interiorColourAmounts));

        case _purchaseMethodsActionTypes2.default.SET_OPTIONS_AMOUNTS:
            return state.set('purchaseMethods', PurchaseMethodsService.setOptionsAmounts(state.purchaseMethods, action.optionsAmounts));

        case _purchaseMethodsActionTypes2.default.SET_TAXES_INCLUDED:
            return state.set('purchaseMethods', PurchaseMethodsService.setTaxesIncluded(state.purchaseMethods, action.taxesIncluded));

        case _purchaseMethodsActionTypes2.default.SELECT_KM_PLAN:
            return state.set('purchaseMethods', PurchaseMethodsService.selectKMPlan(state.purchaseMethods, action.kmPlan.value));

        default:
            return state;
    }
}

/***/ }),

/***/ "./src/Vehicle/services/CertificationIconService/CertificationIconService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getCertificationIcon;

var _lodash = __webpack_require__("lodash");

var _index = __webpack_require__("./src/config/index.js");

var _index2 = _interopRequireDefault(_index);

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getCertificationIcon(make) {
    if ((0, _lodash.isEmpty)(make) || (0, _lodash.isNull)(make)) {
        return '';
    }
    var serverUrl = _index2.default.source.image;
    var certificationUrl = serverUrl + _widgetCommonsGeneral.REDIRECTIONS[_widgetCommonsCoreServices.LocaleService.getSimpleLocale()].certified;
    certificationUrl = _widgetCommonsCoreServices.UrlService.replaceParamWithValue(certificationUrl, '{make}', make.toLowerCase());
    return certificationUrl;
}

/***/ }),

/***/ "./src/Vehicle/services/TradeInVehicleAPIService/TradeInVehicleAPIService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TradeInVehicleAPIService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("lodash");

var _axios = __webpack_require__("../../node_modules/axios/index.js");

var _axios2 = _interopRequireDefault(_axios);

var _index = __webpack_require__("./src/config/index.js");

var _index2 = _interopRequireDefault(_index);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _TradeInVehicleService = __webpack_require__("./src/Vehicle/services/TradeInVehicleService/TradeInVehicleService.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Groups Trade In Vehicle api calls to ShowroomAPI
 */
var TradeInVehicleAPIService = function () {
    function TradeInVehicleAPIService() {
        _classCallCheck(this, TradeInVehicleAPIService);

        /**
         * The base path for Trade In Vehicle ShowroomAPI
         * @type {string}
         */
        this.basePath = _index2.default.endpoint.showroom + '/service/v1/TradeInVehicle';
    }

    /**
     * Returns the axios request configuration object to load a Trade In Vehicle Model
     * @param {string} tradeInVehicleId
     */


    _createClass(TradeInVehicleAPIService, [{
        key: 'getLoadTradeInVehicleRequestConfig',
        value: function getLoadTradeInVehicleRequestConfig(tradeInVehicleId) {
            var requestTradeInVehicleId = (0, _lodash.isString)(tradeInVehicleId) ? tradeInVehicleId : '';
            var orgId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
            var orgUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
            var language = _widgetCommonsCoreServices.LocaleService.getLocale();
            var location = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitLocation();

            var token = _widgetCommonsGeneral.CookieService.getToken(_widgetCommonsGeneral.COOKIES.ACCOUNT.AUTHENTICATE_TOKEN);
            var tradeInVehicleIdParam = requestTradeInVehicleId ? '/' + requestTradeInVehicleId : '';

            var requestConfig = {
                url: '' + this.basePath + tradeInVehicleIdParam,
                method: 'get'
            };

            requestConfig.headers = {
                'x-jwt': (0, _lodash.isEmpty)(token) ? '' : token
            };

            requestConfig.params = {
                context: ((0, _lodash.isNull)(orgId) ? '' : orgId) + '.' + ((0, _lodash.isNull)(orgUnitId) ? '' : orgUnitId),
                language: (0, _lodash.isEmpty)(language) ? '' : language,
                location: (0, _lodash.isEmpty)(location) ? '' : location
            };

            return requestConfig;
        }

        /**
         * Returns a Trade In Vehicle Model from an id or from the authenticated account
         * @param {string} tradeInVehicleId
         */

    }, {
        key: 'loadTradeInVehicle',
        value: function loadTradeInVehicle(tradeInVehicleId) {
            var requestConfig = this.getLoadTradeInVehicleRequestConfig(tradeInVehicleId);
            return _axios2.default.request(requestConfig).then(function (result) {
                return (0, _TradeInVehicleService.resetTradeInVehicleFromShowroomTradeInVehicle)(result.data);
            }).catch(function () {
                console.error('Unable to get trade in vehicle for id ' + tradeInVehicleId);
                return Promise.reject();
            });
        }

        /**
         * Saves a Trade In Vehicle Model back in the showroom database
         * @param {TradeInVehicleModel} tradeInVehicle
         */

    }, {
        key: 'saveTradeInVehicle',
        value: function saveTradeInVehicle(tradeInVehicle) {
            if (!tradeInVehicle || !(0, _lodash.isObjectLike)(tradeInVehicle)) {
                return Promise.reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('missing or invalid parameters'));
            } else if (!_widgetCommonsGeneral.AccountService.isAuthenticated()) {
                return Promise.reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('user not authenticated'));
            }

            var orgId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
            var orgUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
            var context = 'context=' + orgId + '.' + orgUnitId;

            var token = _widgetCommonsGeneral.CookieService.getToken(_widgetCommonsGeneral.COOKIES.ACCOUNT.AUTHENTICATE_TOKEN);
            var showroomTradeInVehicle = tradeInVehicle.getShowroomTradeInVehicle();

            return _axios2.default.put(this.basePath + '?' + context + '&updateQuotes=true', showroomTradeInVehicle, {
                headers: { 'x-jwt': token }
            }).then(function (result) {
                return result;
            }).catch(function () {
                console.error('Unable to save trade in vehicle');
                return Promise.reject();
            });
        }
    }]);

    return TradeInVehicleAPIService;
}();

exports.TradeInVehicleAPIService = TradeInVehicleAPIService;
exports.default = new TradeInVehicleAPIService();

/***/ }),

/***/ "./src/Vehicle/services/TradeInVehicleService/TradeInVehicleService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.resetTradeInVehicleFromShowroomTradeInVehicle = resetTradeInVehicleFromShowroomTradeInVehicle;
exports.setTaxesFactor = setTaxesFactor;
exports.setTradeIn = setTradeIn;
exports.setLien = setLien;

var _lodash = __webpack_require__("lodash");

var _VehicleService = __webpack_require__("./src/Vehicle/services/VehicleService/VehicleService.js");

var _TradeInVehicleModel = __webpack_require__("./src/Vehicle/models/TradeInVehicleModel.js");

var _TradeInVehicleModel2 = _interopRequireDefault(_TradeInVehicleModel);

var _VehicleModel = __webpack_require__("./src/Vehicle/models/VehicleModel.js");

var _VehicleModel2 = _interopRequireDefault(_VehicleModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function parseAmount(amount) {
    var parsedAmount = 0;
    if (amount) {
        parsedAmount = parseInt(amount, 10);
    }
    return !(0, _lodash.isNaN)(parsedAmount) ? parsedAmount : 0;
}

function resetTradeInVehicleFromShowroomTradeInVehicle(tradeInVehicle) {
    if (!(0, _lodash.isObjectLike)(tradeInVehicle)) {
        return new _TradeInVehicleModel2.default();
    }

    var id = tradeInVehicle.id,
        status = tradeInVehicle.status,
        lien = tradeInVehicle.lien,
        amount = tradeInVehicle.amount,
        evaluationQuestion = tradeInVehicle.evaluationQuestion,
        taxesFactor = tradeInVehicle.taxesFactor,
        taxCodes = tradeInVehicle.taxCodes;


    var vehicle = new _VehicleModel2.default();
    if ((0, _lodash.isObjectLike)(tradeInVehicle.vehicle)) {
        vehicle = (0, _VehicleService.resetVehicleFromShowroomVehicle)(tradeInVehicle.vehicle);
    }

    return new _TradeInVehicleModel2.default({
        id: id,
        status: status,
        taxesFactor: (0, _lodash.isUndefined)(taxesFactor) ? 0 : taxesFactor,
        taxCodes: (0, _lodash.isUndefined)(taxCodes) ? [] : taxCodes,
        vehicle: vehicle,
        lien: lien,
        amount: amount,
        evaluationQuestion: evaluationQuestion,
        modified: false
    });
}

function setTaxesFactor(tradeInVehicle, purchaseMethods) {
    var lien = _extends({}, tradeInVehicle.lien, { amount: purchaseMethods.lien });
    return tradeInVehicle.set('amount', purchaseMethods.tradeIn).set('lien', lien).set('taxesFactor', purchaseMethods.taxesFactor).set('taxCodes', purchaseMethods.taxCodes);
}

function setTradeIn(tradeInVehicle, tradeInAmount) {
    var parsedTradeInAmount = parseAmount(tradeInAmount);
    if (tradeInVehicle.amount === parsedTradeInAmount) {
        return tradeInVehicle;
    }

    return tradeInVehicle.set('amount', parsedTradeInAmount).set('modified', true);
}

function setLien(tradeInVehicle, lienAmount) {
    var lien = tradeInVehicle.lien;

    var parsedLienAmount = parseAmount(lienAmount);
    if (lien.amount === parsedLienAmount) {
        return tradeInVehicle;
    }

    lien.amount = parsedLienAmount;
    return tradeInVehicle.set('lien', lien).set('modified', true);
}

exports.default = {
    resetTradeInVehicleFromShowroomTradeInVehicle: resetTradeInVehicleFromShowroomTradeInVehicle,
    setTradeIn: setTradeIn,
    setLien: setLien
};

/***/ }),

/***/ "./src/Vehicle/services/VehicleAPIService/VehicleAPIService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.VehicleAPIService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _axios = __webpack_require__("../../node_modules/axios/index.js");

var _axios2 = _interopRequireDefault(_axios);

var _index = __webpack_require__("./src/config/index.js");

var _index2 = _interopRequireDefault(_index);

var _lodash = __webpack_require__("lodash");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Groups Vehicle api calls to ShowroomAPI
 */
var VehicleAPIService = function () {
    function VehicleAPIService() {
        _classCallCheck(this, VehicleAPIService);

        /**
         * The base path for Vehicle ShowroomAPI
         * @type {string}
         */
        this.basePath = _index2.default.endpoint.showroom + '/service/v1/Vehicles';

        /**
         * The auth queryParams to call ShowroomAPI as a public user
         * @type {string}
         */
        this.publicAuthParams = 'userName=public&password=public';
    }

    /**
     * Gives the vehicles details from a list of ids
     * @param {string[]} vehicleIds
     */


    _createClass(VehicleAPIService, [{
        key: 'findVehicleByIds',
        value: function findVehicleByIds(vehicleIds) {
            if (!(0, _lodash.isArray)(vehicleIds)) {
                throw new TypeError('param [vehicleIds] must be an array');
            }
            var location = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitLocation();
            var language = _widgetCommonsCoreServices.LocaleService.getLocale();
            var organizationId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
            var organizationUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();

            // old `dataLevel=3` indicated the payment without any items
            // 'dataLevel=19' indicates that we include all items (options, dealer items) in the payment
            var url = this.basePath + '?language=' + language + '&location=' + location + '&refresh=1&datalevel=19&context=' + organizationId + '.' + organizationUnitId + '&' + this.publicAuthParams;

            return _axios2.default.post(url, vehicleIds).then(function (result) {
                return result.data;
            }).catch(function () {
                console.error('Unable to get vehicle details for ids [' + (0, _lodash.join)(vehicleIds) + ']');
                return Promise.reject();
            });
        }
    }]);

    return VehicleAPIService;
}();

exports.VehicleAPIService = VehicleAPIService;
exports.default = new VehicleAPIService();

/***/ }),

/***/ "./src/Vehicle/services/VehicleService/VehicleService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetVehicleFromWebAutoInventory = resetVehicleFromWebAutoInventory;
exports.resetVehicleFromShowroomVehicle = resetVehicleFromShowroomVehicle;
exports.resetVehicleFromShowroomQuoteVehicle = resetVehicleFromShowroomQuoteVehicle;
exports.setVehiclePurchaseMethods = setVehiclePurchaseMethods;
exports.setBestPaymentTerm = setBestPaymentTerm;
exports.selectPaymentFrequency = selectPaymentFrequency;
exports.setCashDown = setCashDown;
exports.setTradeIn = setTradeIn;
exports.setLien = setLien;
exports.setTargetPayment = setTargetPayment;
exports.isVehicleNew = isVehicleNew;

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _lodash = __webpack_require__("lodash");

var _index = __webpack_require__("./src/config/index.js");

var _index2 = _interopRequireDefault(_index);

var _PurchaseMethodsService = __webpack_require__("./src/PurchaseMethods/services/PurchaseMethodsService/PurchaseMethodsService.js");

var PurchaseMethodsService = _interopRequireWildcard(_PurchaseMethodsService);

var _VehicleModel = __webpack_require__("./src/Vehicle/models/VehicleModel.js");

var _VehicleModel2 = _interopRequireDefault(_VehicleModel);

var _MultiMediaModel = __webpack_require__("./src/Vehicle/models/MultiMediaModel.js");

var _MultiMediaModel2 = _interopRequireDefault(_MultiMediaModel);

var _EngineModel = __webpack_require__("./src/ModelYear/models/EngineModel.js");

var _EngineModel2 = _interopRequireDefault(_EngineModel);

var _TransmissionModel = __webpack_require__("./src/ModelYear/models/TransmissionModel.js");

var _TransmissionModel2 = _interopRequireDefault(_TransmissionModel);

var _vehicle = __webpack_require__("./src/constants/vehicle.js");

var _vehicle2 = _interopRequireDefault(_vehicle);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var imagesServer = _index2.default.source.image;
var imagesBasePath = '/images/newcar';

function resetVehicleFromWebAutoInventory(inventory) {
    if (!(0, _lodash.isObjectLike)(inventory)) {
        return new _VehicleModel2.default();
    }

    var driveTrain = '';
    var engine = '';
    var fuelType = '';
    var fuelCity = 0.0;
    var fuelHighway = 0.0;
    var transmission = '';
    var exteriorColour = '';
    var interiorColour = '';
    var bodyStyle = '';
    var doors = 0;
    var seating = 0;

    if (!(0, _lodash.isEmpty)(inventory.characteristics)) {
        if (!(0, _lodash.isEmpty)(inventory.characteristics.transmission)) {
            transmission = inventory.characteristics.transmission.label;
            if (!(0, _lodash.isEmpty)(inventory.characteristics.transmission.driveTrain)) {
                driveTrain = inventory.characteristics.transmission.driveTrain.label;
            }
        }

        if (!(0, _lodash.isEmpty)(inventory.characteristics.engine)) {
            engine = inventory.characteristics.engine.description;
            fuelType = inventory.characteristics.engine.fuel ? inventory.characteristics.engine.fuel.label : '';
        }

        if (!(0, _lodash.isEmpty)(inventory.characteristics.exteriorColor)) {
            exteriorColour = inventory.characteristics.exteriorColor.label;
        }

        if (!(0, _lodash.isEmpty)(inventory.characteristics.interiorColor)) {
            interiorColour = inventory.characteristics.interiorColor.label;
        }

        if (!(0, _lodash.isEmpty)(inventory.characteristics.body)) {
            doors = inventory.characteristics.body.doors;
            seating = inventory.characteristics.body.passengers;
            bodyStyle = inventory.characteristics.body.frameStyle ? inventory.characteristics.body.frameStyle.label : '';
        }

        if (!(0, _lodash.isEmpty)(inventory.characteristics.consumptions)) {
            (0, _lodash.forEach)(inventory.characteristics.consumptions, function (consumption) {
                if (consumption.type === 'IN_CITY') {
                    fuelCity = consumption.quantity;
                } else if (consumption.type === 'ON_HIGHWAY') {
                    fuelHighway = consumption.quantity;
                }
            });
        }
    }

    var flags = [];
    var vehicleConditionType = _vehicle2.default.CONDITIONS.USED;
    if (!(0, _lodash.isEmpty)(inventory.flags)) {
        flags = inventory.flags;

        var isCertified = flags.filter(function (flag) {
            return flag.type === 'CERTIFIED';
        }).length > 0;

        var isNew = flags.filter(function (flag) {
            return flag.type === 'NEW';
        }).length > 0;

        if (isCertified) vehicleConditionType = _vehicle2.default.CONDITIONS.CERTIFIED;
        if (isNew) vehicleConditionType = _vehicle2.default.CONDITIONS.NEW;
    }

    return new _VehicleModel2.default({
        vehicleId: inventory.id,
        vehicleConditionType: vehicleConditionType,
        vin: inventory.vin,
        stockNumber: inventory.stockNo || '',
        sold: inventory.sold,
        year: inventory.year,
        make: inventory.make ? inventory.make.name : '',
        model: inventory.model ? inventory.model.name : '',
        trim: inventory.trim ? inventory.trim.name : '',
        bodyStyle: bodyStyle,
        driveTrain: driveTrain,
        engine: engine,
        fuelType: fuelType,
        flags: flags,
        fuelCity: fuelCity,
        fuelHighway: fuelHighway,
        transmission: transmission,
        exteriorColour: exteriorColour,
        interiorColour: interiorColour,
        doors: doors,
        seating: seating,
        odometer: inventory.odometer,
        sellingPrice: inventory.prices ? inventory.prices.sale : 0,
        discount: inventory.prices ? inventory.prices.regular - inventory.prices.sale : 0,
        features: !(0, _lodash.isEmpty)(inventory.options) ? inventory.options.labels : [],
        multimedia: new _MultiMediaModel2.default(inventory.multimedia),
        tagLine: inventory.tagline || '',
        note: inventory.description,
        recentViewCount: inventory.pageViewSummary ? inventory.pageViewSummary.recentViewCount : 0,
        locked: inventory.onHold,
        warranty: inventory.warranty,
        online: inventory.online
    });
}

function resetVehicleFromShowroomVehicle(vehicle) {
    if (!(0, _lodash.isObjectLike)(vehicle) || (0, _lodash.isEmpty)(vehicle)) {
        return new _VehicleModel2.default();
    }

    var id = vehicle.id,
        vehicleId = vehicle.vehicleId,
        catalogVehicleId = vehicle.catalogVehicleId,
        newCarTrimId = vehicle.newCarTrimId,
        vin = vehicle.vin,
        vehicleCondition = vehicle.vehicleCondition,
        year = vehicle.year,
        make = vehicle.make,
        model = vehicle.model,
        bodyColourStatus = vehicle.bodyColourStatus,
        bodyStyleCode = vehicle.bodyStyleCode,
        bodyStyle = vehicle.bodyStyle,
        cabSizeCode = vehicle.cabSizeCode,
        cabSize = vehicle.cabSize,
        boxSizeCode = vehicle.boxSizeCode,
        boxSize = vehicle.boxSize,
        driveTrainDescription = vehicle.driveTrainDescription,
        modelTrim = vehicle.modelTrim,
        modelTrimCode = vehicle.modelTrimCode,
        modelTrimStyle = vehicle.modelTrimStyle,
        bodyColour = vehicle.bodyColour,
        engineFeatures = vehicle.engineFeatures,
        transmissionFeatures = vehicle.transmissionFeatures,
        configurationID = vehicle.configurationID,
        configurationToken = vehicle.configurationToken,
        odometer = vehicle.odometer,
        inventory = vehicle.inventory,
        sold = vehicle.sold;


    var engine = '';
    if (engineFeatures) {
        var engineModel = new _EngineModel2.default({
            fuelTypeCode: engineFeatures.fuelType,
            cylinders: engineFeatures.cylinders,
            displacement: engineFeatures.displacement,
            isTurbo: engineFeatures.isTurbo,
            hp: engineFeatures.hp,
            hpRpm: engineFeatures.hpRpm,
            torque: engineFeatures.torque,
            torqueRpm: engineFeatures.torqueRpm
        });
        engine = engineModel.getSizeSpecifications(_widgetCommonsCoreServices.LocaleService);
    }

    var transmission = '';
    if (transmissionFeatures) {
        var transmissionModel = new _TransmissionModel2.default({
            typeCode: transmissionFeatures.transmissionTypeCode,
            type: transmissionFeatures.transmissionType,
            speeds: transmissionFeatures.speeds,
            isCVT: transmissionFeatures.isCVT,
            description: transmissionFeatures.transmissionTypeDescription[0]
        });
        transmission = transmissionModel.getTransmission(_widgetCommonsCoreServices.LocaleService);
    }

    var multimedia = new _MultiMediaModel2.default();
    if (!(0, _lodash.isEmpty)(bodyColour)) {
        var url = '' + imagesServer + imagesBasePath + '/' + bodyColour.vehiclePhotoUrl;
        var url360x270 = imagesServer + '/ir/w360h270' + imagesBasePath + '/' + bodyColour.vehiclePhotoUrl;
        var url360x240 = imagesServer + '/ir/w360h197c' + imagesBasePath + '/' + bodyColour.vehiclePhotoUrl;
        var url440 = imagesServer + '/ir/w440' + imagesBasePath + '/' + bodyColour.vehiclePhotoUrl;

        multimedia = multimedia.set('mainPicture', { url: url, url360x270: url360x270 }).set('catalog', {
            side: {
                url: url,
                url360x240: url360x240,
                url360x270: url360x270,
                url440: url440
            }
        });
    }

    var vehicleIdInt = parseInt(vehicleId, 10);
    var catalogVehicleIdInt = parseInt(catalogVehicleId, 10);
    var newCarTrimIdInt = parseInt(newCarTrimId, 10);
    return new _VehicleModel2.default({
        id: id,
        vehicleId: (0, _lodash.isNaN)(vehicleIdInt) ? 0 : vehicleIdInt,
        catalogVehicleId: (0, _lodash.isNaN)(catalogVehicleIdInt) ? 0 : catalogVehicleIdInt,
        newCarTrimId: (0, _lodash.isNaN)(newCarTrimIdInt) ? 0 : newCarTrimIdInt,
        vehicleConditionType: vehicleCondition,
        vin: vin,
        stockNumber: inventory ? inventory.stock : '',
        year: year,
        make: make,
        model: model,
        modelTrim: modelTrim,
        modelTrimStyle: modelTrimStyle,
        bodyColour: bodyColour,
        exteriorColourStatus: bodyColourStatus,
        bodyStyle: bodyStyle,
        bodyStyleCode: bodyStyleCode,
        cabSizeCode: cabSizeCode,
        cabSize: cabSize,
        boxSizeCode: boxSizeCode,
        boxSize: boxSize,
        driveTrain: driveTrainDescription,
        modelTrimCode: modelTrimCode,
        engine: engine,
        transmission: transmission,
        odometer: odometer,
        multimedia: multimedia,
        configurationToken: configurationToken,
        configurationId: configurationID,
        sold: sold
    });
}

function resetVehicleFromShowroomQuoteVehicle(quote) {
    if (!(0, _lodash.isObjectLike)(quote) || !quote.vehicle || !(0, _lodash.isObjectLike)(quote.vehicle)) {
        return new _VehicleModel2.default();
    }

    return resetVehicleFromShowroomVehicle(quote.vehicle);
}

function setVehiclePurchaseMethods(vehicle, purchaseMethods) {
    if (!(0, _lodash.isObjectLike)(purchaseMethods)) {
        return vehicle.set('purchaseMethods', PurchaseMethodsService.selectPurchaseMethod(vehicle.purchaseMethods, purchaseMethods));
    }
    return vehicle.set('purchaseMethods', purchaseMethods);
}

function setBestPaymentTerm(vehicle, maximumTerm) {
    var selectedFinanceTerm = vehicle.purchaseMethods.getSelectedFinanceTerm();
    if (!selectedFinanceTerm) {
        return vehicle;
    }

    return vehicle.set('purchaseMethods', PurchaseMethodsService.setSelectedFinanceBestPaymentTerm(vehicle.purchaseMethods, maximumTerm));
}

function selectPaymentFrequency(vehicle, paymentFrequency) {
    return vehicle.set('purchaseMethods', PurchaseMethodsService.selectPaymentFrequency(vehicle.purchaseMethods, paymentFrequency));
}

function setCashDown(vehicle, cashDown) {
    return vehicle.set('purchaseMethods', PurchaseMethodsService.setCashDown(vehicle.purchaseMethods, cashDown));
}

function setTradeIn(vehicle, tradeIn) {
    return vehicle.set('purchaseMethods', PurchaseMethodsService.setTradeIn(vehicle.purchaseMethods, tradeIn));
}

function setLien(vehicle, lien) {
    return vehicle.set('purchaseMethods', PurchaseMethodsService.setLien(vehicle.purchaseMethods, lien));
}

function setTargetPayment(vehicle, targetPayment) {
    var targetCashDown = vehicle.purchaseMethods.getCashDownFromTargetPayment(targetPayment);
    return vehicle.set('purchaseMethods', PurchaseMethodsService.setCashDown(vehicle.purchaseMethods, targetCashDown));
}

function isVehicleNew(vehicle) {
    if (vehicle && vehicle.vehicleConditionType) {
        if (vehicle.vehicleConditionType === _vehicle2.default.CONDITIONS.NEW || vehicle.vehicleConditionType === _vehicle2.default.CONDITIONS.DEMO) {
            return true;
        }
    }
    return false;
}

exports.default = {
    resetVehicleFromWebAutoInventory: resetVehicleFromWebAutoInventory,
    resetVehicleFromShowroomQuoteVehicle: resetVehicleFromShowroomQuoteVehicle,
    resetVehicleFromShowroomVehicle: resetVehicleFromShowroomVehicle,
    setVehiclePurchaseMethods: setVehiclePurchaseMethods,
    setBestPaymentTerm: setBestPaymentTerm,
    selectPaymentFrequency: selectPaymentFrequency,
    setCashDown: setCashDown,
    setTradeIn: setTradeIn,
    setLien: setLien,
    setTargetPayment: setTargetPayment,
    isVehicleNew: isVehicleNew
};

/***/ }),

/***/ "./src/config/dev.json":
/***/ (function(module, exports) {

module.exports = {"endpoint":{"widget":"https://service.backbones.widget-supplier.dev.office.n360.io","account":"https://service.backbones.account.dev.office.n360.io/api","showroom":"https://dev-api.showroom360.ca:9443","graphql":"https://service.backbones.webauto-supplier.dev.office.n360.io/webauto/graphql"},"source":{"image":"http://img-dev.sm360.ca","widget":"https://service.backbones.widget-supplier.dev.office.n360.io/client"},"secureCookies":false,"sentry":{"url":"","sentryLevel":"NONE","consoleLevel":"DEBUG","whitelistUrls":["^.*(widgets-dev-cdn.sm360.ca).*$"],"includePaths":["^.*(widgets-dev-cdn.sm360.ca).*$"]}}

/***/ }),

/***/ "./src/config/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _dev = __webpack_require__("./src/config/dev.json");

var _dev2 = _interopRequireDefault(_dev);

var _int = __webpack_require__("./src/config/int.json");

var _int2 = _interopRequireDefault(_int);

var _local = __webpack_require__("./src/config/local.json");

var _local2 = _interopRequireDefault(_local);

var _prod = __webpack_require__("./src/config/prod.json");

var _prod2 = _interopRequireDefault(_prod);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = {};

if (true) {
    config = _prod2.default;
} else if (process.env.BUILD_ENV === 'development') {
    config = _dev2.default;
} else if (process.env.BUILD_ENV === 'integration') {
    config = _int2.default;
} else {
    config = _local2.default;
}

exports.default = _extends({}, config);

/***/ }),

/***/ "./src/config/int.json":
/***/ (function(module, exports) {

module.exports = {"endpoint":{"widget":"https://widget-int.sm360.ca","account":"https://account-int.sm360.ca/api","showroom":"https://int-api.showroom360.ca:8443","graphql":"https://webauto-supplier-api-int.sm360.ca/webauto/graphql"},"source":{"image":"http://img-int.sm360.ca","widget":"https://widget-int.sm360.ca/client"},"secureCookies":false,"sentry":{"url":"","sentryLevel":"NONE","consoleLevel":"DEBUG","whitelistUrls":["^.*(widgets-int-cdn.sm360.ca).*$"],"includePaths":["^.*(widgets-int-cdn.sm360.ca).*$"]}}

/***/ }),

/***/ "./src/config/local.json":
/***/ (function(module, exports) {

module.exports = {"endpoint":{"widget":"https://widget-int.sm360.ca","account":"https://account-api-int.sm360.ca/api","showroom":"https://int-api.showroom360.ca:8443","graphql":"https://webauto-supplier-api-int.sm360.ca/webauto/graphql"},"source":{"image":"http://img-int.sm360.ca","widget":"http://localhost:3360/client"},"secureCookies":false,"sentry":{"url":"","sentryLevel":"NONE","consoleLevel":"DEBUG","whitelistUrls":["^.*(widgets-int-cdn.sm360.ca).*$"],"includePaths":["^.*(widgets-int-cdn.sm360.ca).*$"]}}

/***/ }),

/***/ "./src/config/prod.json":
/***/ (function(module, exports) {

module.exports = {"endpoint":{"widget":"https://widget.sm360.ca","account":"https://account.sm360.ca/api","showroom":"https://api.showroom360.ca","graphql":"https://webauto-supplier-api.sm360.ca/webauto/graphql"},"source":{"image":"https://img.sm360.ca","widget":"https://widget.sm360.ca/client"},"secureCookies":true,"sentry":{"url":"","sentryLevel":"WARNING","consoleLevel":"ERROR","whitelistUrls":["^.*(widgets-cdn.sm360.ca).*$"],"includePaths":["^.*(widgets-cdn.sm360.ca).*$"]}}

/***/ }),

/***/ "./src/constants/apiDataConversionConstants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var DESCRIPTION_LANGUAGE_INDEX = exports.DESCRIPTION_LANGUAGE_INDEX = 0;

var VIEW_1 = exports.VIEW_1 = {
    VEHICLE: {
        HIGH_PRICE: 'highPrice',
        HIGH_PRICE_INDEX: 0,
        URL_EXTERIOR_COLOUR: 7,
        EXTERIOR_COLOUR_STATUS: 9,

        REBATE: 'rebate',
        REBATE_INDEX: 0,
        REBATE_RETAIL: 6,

        HIGH_REBATE: 'highRebate',
        HIGH_REBATE_INDEX: 0,
        HIGH_REBATE_RETAIL: 6,
        HIGH_REBATE_PURCHASE_METHOD: 8,
        HIGH_REBATE_REBATES_TAXES: 9,

        PRICE: 'price',
        PRICE_INDEX: 0,
        PRICE_YEAR: 0,
        PRICE_MODEL_TRIM_CODE: 3,
        PRICE_CONFIGURATION_ID: 4,
        PRICE_RETAIL: 6,
        PRICE_AMOUNTS: 9,
        PRICE_DISCLAIMER: 10,

        LEASE: 'lease',
        LEASE_INDEX: 0,
        LEASE_YEAR: 0,
        LEASE_MODEL_TRIM_CODE: 3,
        LEASE_CONFIGURATION_ID: 4,
        LEASE_TERMS: 6,
        LEASE_DISCLAIMER: 18,

        FINANCE: 'finance',
        FINANCE_INDEX: 0,
        FINANCE_YEAR: 0,
        FINANCE_MODEL_TRIM_CODE: 3,
        FINANCE_CONFIGURATION_ID: 4,
        FINANCE_TERMS: 6,
        FINANCE_DISCLAIMER: 12
    },

    COLOUR_IMAGE: {
        PHOTO_1: 0,
        PHOTO_2: 1,
        PHOTO_3: 2
    },

    FINANCE: {
        PAYMENT_FREQUENCY: 0,
        BASE_PAYMENT: 1,
        FEES_PAYMENT: 2,
        DUTIES_PAYMENT: 3,
        PAYMENT_TAXES: 4,
        FINANCE_FACTOR: 5,
        BALLOON_FACTOR: 6
    },

    PRICE_DISCLAIMER: {
        MODEL_SHORT: 0,
        MODEL_LONG: 1,
        MODEL_PRICE: 2,
        INCLUSIONS: 3,
        EXCLUSIONS: 4
    },

    FINANCE_DISCLAIMER: {
        MODEL_SHORT: 0,
        MODEL_LONG: 1
    },

    PRICING: {
        BASE_RETAIL: 0,
        FREIGHT_PDI: 1,
        TAXES_DUTIES: 2
    }
};

var VIEW_2_1 = exports.VIEW_2_1 = {
    VEHICLE: {
        MODEL_YEARS: 0,

        MODEL_YEAR: {
            BIT_FIELD: 0,
            YEAR: 1,
            FEATURES: 2,
            CABS: 3,
            DRIVES: 4,
            TRANSMISSIONS: 5,
            BOXES: 6,
            TRIMS: 7
        },

        FEATURES: {
            BIT_FIELD: 0,
            LIST: 1,

            FEATURE: {
                CODE: 0,
                TYPE: 1,
                KEY_ORDER: 2,
                IS_STANDARD: 3,
                DATA_TYPE_ID: 4,
                TYPE_ID: 5,
                DESCRIPTION: 6,
                TYPE_IDS: 7,
                TYPE_ICONS: 8,
                COLOUR_FEATURES: 9,

                ICON: {
                    KEY_ORDER: 0,
                    VALUE: 1,
                    CODE: 2,
                    DESCRIPTION: 3
                }
            }
        },

        CAB: {
            BIT_FIELD: 0,
            ID_CODE: 1,
            CODE: 3,
            DESCRIPTION: 2
        },

        DRIVE: {
            BIT_FIELD: 0,
            ID_CODE: 2,
            DESCRIPTION: 1,
            CODE: 3,
            LONG_DESCRIPTION: 4
        },

        TRANSMISSION: {
            BIT_FIELD: 0,
            CODE: 1,
            DESCRIPTION: 2
        },

        BOX: {
            BIT_FIELD: 0,
            ID_CODE: 1,
            CODE: 3,
            DESCRIPTION: 2
        },

        TRIM: {
            BIT_FIELD: 0,
            CODE: 1,
            DESCRIPTION: 2,
            CONFIGURATIONS: 3,
            EXTENSION_DESCRIPTION: 4,
            EXTENSION_CODE: 5,
            HAS_OPTIONS: 6,

            CONFIGURATION: {
                BIT_FIELD: 0,
                TRIM_CODE: 1,
                TRIM_RANK: 2,
                ID: 3,
                RANK: 4,
                DESCRIPTION: 5,
                SEATING: 6,
                FUEL_CONSUMPTION: 7,
                ENGINE: 8,
                TRANSMISSION: 9,
                PACKAGE_CODE: 10,
                PACKAGE: 11,
                OPTION_CODES: 12,
                URL_EXTERIOR_COLOUR: 13,
                URL_INTERIOR_TRIM: 14,
                PRICING: 15,
                FINANCE: 16,
                LEASE: 17,
                CAR_ID: 18,
                VEH_ID: 19
            },

            ENGINE: {
                FUEL: 0,
                CYLINDERS: 1,
                DISPLACEMENT: 2,
                IS_TURBO: 3,
                HP: 4,
                HP_RPM: 5,
                TORQUE: 6,
                TORQUE_RPM: 7
            },

            TRANSMISSION: {
                TYPE_CODE: 0,
                TYPE: 1,
                SPEEDS: 2,
                IS_CVT: 3,
                DESCRIPTION: 4
            },

            COLOUR_IMAGE: {
                CODE: 0,
                TILE: 1,
                PHOTO_1: 2,
                PHOTO_2: 3,
                PHOTO_3: 4,
                PRICING: 5,

                AMOUNTS: {
                    RETAIL: 0,
                    RESIDUAL_RETAIL: 1
                }
            },

            PRICING: {
                RETAIL: 0,
                REBATE: 1
            }
        },

        LEASE_TERMS: 0,

        FINANCE_TERMS: 0
    },

    FINANCE: {
        APR: 0,
        TERM: 1,
        DISCOUNT: 3,
        REBATE: 4,
        REBATE_AT_DELIVERY: 5,
        CASH_DOWN: 6,
        PAYMENT_FREQUENCIES: 7,

        PAYMENT_FREQUENCY: 0,
        PAYMENT: 1,
        PAYMENT_TAXES: 2,
        FINANCE_FACTOR: 3,
        BALLOON_FACTOR: 4
    },

    DATA_TYPES: {
        FEATURE: 1,
        TAX_AND_DUTY: 2,
        FEE: 3,
        PROTECTION: 4,
        REBATE: 5,
        FEATURE_TYPE_MECHANICAL: 1,
        FEATURE_TYPE_EXTERIOR: 2,
        FEATURE_TYPE_COMMUNICATION: 3,
        FEATURE_TYPE_INTERIOR: 4,
        FEATURE_TYPE_SAFETY: 5,
        FEATURE_TYPE_MODEL_TRIM: 50,
        FEATURE_TYPE_PACKAGE: 51,
        FEATURE_TYPE_ENGINE: 52,
        FEATURE_TYPE_TRANSMISSION: 53,
        FEATURE_TYPE_EXTERIOR_COLOUR: 54,
        FEATURE_TYPE_INTERIOR_TRIM: 55,
        TAX_AND_DUTY_TYPE_AIR: 1,
        TAX_AND_DUTY_TYPE_WEIGHT: 2,
        TAX_AND_DUTY_TYPE_BATTERY: 3,
        TAX_AND_DUTY_TYPE_TIRE: 4,
        TAX_AND_DUTY_TYPE_ENVIRONMENTAL: 5,
        TAX_AND_DUTY_TYPE_LICENCE: 6,
        TAX_AND_DUTY_TYPE_RECOVERY: 7,
        TAX_AND_DUTY_TYPE_LEVY: 8,
        FEE_TYPE_FREIGHT: 1,
        FEE_TYPE_PREPARATION: 2,
        FEE_TYPE_MARKETING: 3,
        FEE_TYPE_REGISTRATION: 4,
        FEE_TYPE_ADMINISTRATION_DEALER: 5,
        FEE_TYPE_DOCUMENT: 6,
        FEE_TYPE_ACQUISITION: 7,
        FEE_TYPE_ADMINISTRATION_CREDITOR: 8,
        FEE_TYPE_RECOVERY: 9,
        FEE_TYPE_RECYCLING: 10,
        FEE_TYPE_SECURITY_DEPOSIT: 11,
        FEE_TYPE_LEASE_BUY_BACK: 12
    },

    DEFAULT_ICON: 'E917'
};

exports.default = {
    DESCRIPTION_LANGUAGE_INDEX: DESCRIPTION_LANGUAGE_INDEX,
    VIEW_1: VIEW_1,
    VIEW_2_1: VIEW_2_1
};

/***/ }),

/***/ "./src/constants/currencyFormats.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var CURRENCY_0 = exports.CURRENCY_0 = {
    style: 'currency',
    currency: 'CAD',
    currencyDisplay: 'symbol',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
};

var CURRENCY_2 = exports.CURRENCY_2 = {
    style: 'currency',
    currency: 'CAD',
    currencyDisplay: 'symbol',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
};

var CURRENCY_MIN_0_MAX_2 = exports.CURRENCY_MIN_0_MAX_2 = {
    style: 'currency',
    currency: 'CAD',
    currencyDisplay: 'symbol',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
};

var ODOMETER = exports.ODOMETER = {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
};

var FUEL_CONSUMPTION = exports.FUEL_CONSUMPTION = {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1
};

exports.default = {
    CURRENCY_0: CURRENCY_0,
    CURRENCY_2: CURRENCY_2,
    CURRENCY_MIN_0_MAX_2: CURRENCY_MIN_0_MAX_2,
    ODOMETER: ODOMETER,
    FUEL_CONSUMPTION: FUEL_CONSUMPTION
};

/***/ }),

/***/ "./src/constants/dataConversions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var DEFAULT_KEY_ORDER = exports.DEFAULT_KEY_ORDER = 9999999;
var CASH_PURCHASE_ONLY_DISCOUNT = exports.CASH_PURCHASE_ONLY_DISCOUNT = '%';
var DRIVE_TRAIN_4WD = exports.DRIVE_TRAIN_4WD = '4WD';
var CAB_SIZE_REGULAR = exports.CAB_SIZE_REGULAR = 'RC';
var CAB_SIZE_EXTENDED = exports.CAB_SIZE_EXTENDED = 'XC';
var CAB_SIZE_CREW = exports.CAB_SIZE_CREW = 'CC';
var BOX_SIZE_SHORT = exports.BOX_SIZE_SHORT = 'SB';
var BOX_SIZE_LONG = exports.BOX_SIZE_LONG = 'LB';

var CAB_SIZE_DATA = exports.CAB_SIZE_DATA = {
    BIT_FIELD: 0,
    ID_CODE: 1,
    DESCRIPTION: 2,
    CODE: 3
};

var BOX_SIZE_DATA = exports.BOX_SIZE_DATA = {
    BIT_FIELD: 0,
    ID_CODE: 1,
    DESCRIPTION: 2,
    CODE: 3
};

var DRIVE_TRAIN_DATA = exports.DRIVE_TRAIN_DATA = {
    BIT_FIELD: 0,
    ID_CODE: 2,
    DESCRIPTION: 1,
    CODE: 3,
    LONG_DESCRIPTION: 4
};

var ENGINE_DATA = exports.ENGINE_DATA = {
    FUEL: 0,
    CYLINDERS: 1,
    DISPLACEMENT: 2,
    IS_TURBO: 3,
    HP: 4,
    HP_RPM: 5,
    TORQUE: 6,
    TORQUE_RPM: 7
};

var TRANSMISSION_DATA = exports.TRANSMISSION_DATA = {
    TYPE_CODE: 0,
    TYPE: 1,
    SPEEDS: 2,
    IS_CVT: 3,
    DESCRIPTION: 4
};

var COLOUR_DATA = exports.COLOUR_DATA = {
    CODE: 0,
    TILE: 1,
    PHOTO_1: 2,
    PHOTO_2: 3,
    PHOTO_3: 4,
    PRICING: 5,

    AMOUNTS: {
        RETAIL: 0,
        RESIDUAL_RETAIL: 1
    },

    FEATURE_FABRIC: 0,
    FEATURE_INTERIOR: 1,
    FEATURE_SEAT: 2
};

var MODEL_CONFIGURATION = exports.MODEL_CONFIGURATION = {
    BIT_FIELD: 0,
    TRIM_CODE: 1,
    TRIM_RANK: 2,
    ID: 3,
    RANK: 4,
    DESCRIPTION: 5,
    SEATING: 6,
    FUEL_CONSUMPTION: 7,
    ENGINE: 8,
    TRANSMISSION: 9,
    PACKAGE_CODE: 10,
    PACKAGE: 11,
    OPTION_CODES: 12,
    URL_EXTERIOR_COLOUR: 13,
    URL_INTERIOR_TRIM: 14,
    PRICING: 15,
    FINANCE: 16,
    LEASE: 17,
    CAR_ID: 18,
    VEH_ID: 19,
    EXTERIOR_COLOUR_STATUS: 20,
    TAXES_FACTOR: 21,
    TAX_CODES: 22
};

exports.default = {
    DEFAULT_KEY_ORDER: DEFAULT_KEY_ORDER,
    CASH_PURCHASE_ONLY_DISCOUNT: CASH_PURCHASE_ONLY_DISCOUNT,
    DRIVE_TRAIN_4WD: DRIVE_TRAIN_4WD,
    CAB_SIZE_REGULAR: CAB_SIZE_REGULAR,
    CAB_SIZE_EXTENDED: CAB_SIZE_EXTENDED,
    CAB_SIZE_CREW: CAB_SIZE_CREW,
    CAB_SIZE_DATA: CAB_SIZE_DATA,
    BOX_SIZE_DATA: BOX_SIZE_DATA,
    BOX_SIZE_SHORT: BOX_SIZE_SHORT,
    BOX_SIZE_LONG: BOX_SIZE_LONG,
    DRIVE_TRAIN_DATA: DRIVE_TRAIN_DATA,
    ENGINE_DATA: ENGINE_DATA,
    TRANSMISSION_DATA: TRANSMISSION_DATA,
    COLOUR_DATA: COLOUR_DATA,
    MODEL_CONFIGURATION: MODEL_CONFIGURATION
};

/***/ }),

/***/ "./src/constants/dataOrigins.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var MODELS_COLLECTION = exports.MODELS_COLLECTION = 'MODELS_COLLECTION';
var MODEL_YEARS = exports.MODEL_YEARS = 'MODEL_YEARS';
var MODEL_YEAR_POWERS_TRIMS = exports.MODEL_YEAR_POWERS_TRIMS = 'MODEL_YEAR_POWERS_TRIMS';
var PAYMENT_CALCULATOR = exports.PAYMENT_CALCULATOR = 'PAYMENT_CALCULATOR';
var VEHICLE_PAYMENTS = exports.VEHICLE_PAYMENTS = 'VEHICLE_PAYMENTS';
var OPTIONS_VALIDATION = exports.OPTIONS_VALIDATION = 'OPTIONS_VALIDATION';

exports.default = {
    MODELS_COLLECTION: MODELS_COLLECTION,
    MODEL_YEARS: MODEL_YEARS,
    MODEL_YEAR_POWERS_TRIMS: MODEL_YEAR_POWERS_TRIMS,
    PAYMENT_CALCULATOR: PAYMENT_CALCULATOR,
    VEHICLE_PAYMENTS: VEHICLE_PAYMENTS,
    OPTIONS_VALIDATION: OPTIONS_VALIDATION
};

/***/ }),

/***/ "./src/constants/dataTypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var SUPPLIER_OPTION = exports.SUPPLIER_OPTION = 'O';
var SUPPLIER_INCENTIVE = exports.SUPPLIER_INCENTIVE = 'I';
var DEALER_OPTION = exports.DEALER_OPTION = 'D';

var ITEM_FLAG = exports.ITEM_FLAG = {
    NOT_SELECTED: 0x0,
    SELECTED: 0x1,
    USER_SELECTED: 0x2,
    CONFIGURATION_SELECTED: 0x4,
    INCLUDED_IN_OTHER_ITEM: 0x8,
    AVAILABLE: 0x80,
    CONFIGURATION_AVAILABLE: 0x100,
    DYNAMIC_ITEM: 0x2000,
    IGNORE_ITEM: 0x4000,
    NON_TAXABLE_FEDERAL: 0x10000,
    NON_TAXABLE_PROVINCIAL: 0x20000
};

var ITEM_DATA_LEVEL = exports.ITEM_DATA_LEVEL = {
    AVAILABLE: 0x1,
    PRICING: 0x2,
    DESCRIPTIONS: 0x4,
    DEALER_ITEMS: 0x4000
};

var DATA_TYPES = exports.DATA_TYPES = {
    FEATURE: {
        DATA_TYPE_ID: 1,
        TYPES: {
            MECHANICAL: 1,
            EXTERIOR: 2,
            COMMUNICATION: 3,
            INTERIOR: 4,
            SAFETY: 5,
            MODEL_TRIM: 50,
            PACKAGE: 51,
            ENGINE: 52,
            TRANSMISSION: 53,
            EXTERIOR_COLOUR: 54,
            INTERIOR_TRIM: 55,
            DEALER_INVENTORY: 2
        }
    },
    TAX_AND_DUTY: {
        DATA_TYPE_ID: 2,
        TYPES: {
            AIR: 1,
            WEIGHT: 2,
            BATTERY: 3,
            TIRE: 4,
            ENVIRONMENTAL: 5,
            LICENCE: 6,
            RECOVERY: 7,
            LEVY: 8
        }
    },
    FEE: {
        DATA_TYPE_ID: 3,
        TYPES: {
            FREIGHT: 1,
            PREPARATION: 2,
            MARKETING: 3,
            REGISTRATION: 4,
            ADMINISTRATION_DEALER: 8,
            DOCUMENT: 6,
            ACQUISITION: 7,
            ADMINISTRATION_CREDITOR: 5,
            RECOVERY: 9,
            RECYCLING: 10,
            SECURITY_DEPOSIT: 11,
            LEASE_BUY_BACK: 12,
            DELIVERY: 13,
            CHECKOUT_DEPOSIT: 14,
            RESERVATION_DEPOSIT: 15
        }
    },
    PROTECTION: {
        DATA_TYPE_ID: 4,
        TYPES: {
            OEM_EXTENDED_WARRANTY: 1,
            EXTENDED_WARRANTY: 2,
            WARRANTY_PACKAGE: 11,
            PROTECTION_REPLACEMENT_WARRANTY: 21,
            PROTECTION_REPLACEMENT_INSURANCE: 22,
            PROTECTION_GAP: 41,
            ROAD_HAZARD_PACKAGE: 60,
            ROAD_HAZARD_PLAN: 61,
            APPEARANCE_PACKAGE: 100,
            APPEARANCE_INTERIOR: 101,
            APPEARANCE_PAINT: 102,
            APPEARANCE_RUST: 103,
            APPEARANCE_EXTERIOR: 104,
            THEFT_DETERRENT: 201,
            INSURANCE_LIFE: 301,
            INSURANCE_CRITICAL_ILLNESS: 302,
            INSURANCE_DISABILITY: 303,
            INSURANCE_LOSS_EMPLOYMENT: 304,
            INSURANCE_RESIDUAL: 305
        },
        CATEGORIES: {
            WARRANTY: 1,
            INSURANCE: 2,
            APPEARANCE: 3,
            THEFT_DETERRENT: 4,
            SAFETY: 5,
            PROTECTION: 6
        }
    },
    REBATE: {
        DATA_TYPE_ID: 5,
        TYPES: {
            DEALER_DISCOUNT: 1,
            DAA_CASH_DOWN: 4,
            EMPLOYEE: 5,
            ELECTRIC: 7,
            MSRP_PERCENTAGE: 9,
            BONUS: 10
        }
    }
};

var DEFAULT_MODEL_TRIM_CODE = exports.DEFAULT_MODEL_TRIM_CODE = '_MT';
var DEFAULT_KEY_ORDER = exports.DEFAULT_KEY_ORDER = 9999999;
var SYSTEM_PACKAGE_CODE = exports.SYSTEM_PACKAGE_CODE = '_P_';

exports.default = {
    SUPPLIER_OPTION: SUPPLIER_OPTION,
    SUPPLIER_INCENTIVE: SUPPLIER_INCENTIVE,
    DEALER_OPTION: DEALER_OPTION,
    ITEM_FLAG: ITEM_FLAG,
    ITEM_DATA_LEVEL: ITEM_DATA_LEVEL,
    DATA_TYPES: DATA_TYPES,
    DEFAULT_MODEL_TRIM_CODE: DEFAULT_MODEL_TRIM_CODE,
    DEFAULT_KEY_ORDER: DEFAULT_KEY_ORDER,
    SYSTEM_PACKAGE_CODE: SYSTEM_PACKAGE_CODE
};

/***/ }),

/***/ "./src/constants/events.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var EVENTS = {
    AUTHENTICATED: 'authenticated'
};

exports.default = EVENTS;

/***/ }),

/***/ "./src/constants/vehicle.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var VEHICLE = {
    CONDITIONS: {
        NEW: 0x1,
        DEMO: 0x3,
        USED: 0x100,
        CERTIFIED: 0x300
    }
};

exports.default = VEHICLE;

/***/ }),

/***/ "./src/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Vehicle = exports.Quote = exports.PurchaseMethods = exports.ModelYear = exports.ShowroomService = exports.VehicleConstants = exports.EVENTS = exports.DataTypes = exports.DataOrigins = exports.DataConversions = exports.CurrencyFormats = exports.ApiDataConversionConstants = undefined;

var _apiDataConversionConstants = __webpack_require__("./src/constants/apiDataConversionConstants.js");

var _apiDataConversionConstants2 = _interopRequireDefault(_apiDataConversionConstants);

var _currencyFormats = __webpack_require__("./src/constants/currencyFormats.js");

var _currencyFormats2 = _interopRequireDefault(_currencyFormats);

var _dataConversions = __webpack_require__("./src/constants/dataConversions.js");

var _dataConversions2 = _interopRequireDefault(_dataConversions);

var _dataOrigins = __webpack_require__("./src/constants/dataOrigins.js");

var _dataOrigins2 = _interopRequireDefault(_dataOrigins);

var _dataTypes = __webpack_require__("./src/constants/dataTypes.js");

var _dataTypes2 = _interopRequireDefault(_dataTypes);

var _events = __webpack_require__("./src/constants/events.js");

var _events2 = _interopRequireDefault(_events);

var _vehicle = __webpack_require__("./src/constants/vehicle.js");

var _vehicle2 = _interopRequireDefault(_vehicle);

var _ShowroomService = __webpack_require__("./src/services/ShowroomService/ShowroomService.js");

var _ShowroomService2 = _interopRequireDefault(_ShowroomService);

var _index = __webpack_require__("./src/ModelYear/index.js");

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__("./src/PurchaseMethods/index.js");

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__("./src/Quote/index.js");

var _index6 = _interopRequireDefault(_index5);

var _index7 = __webpack_require__("./src/Vehicle/index.js");

var _index8 = _interopRequireDefault(_index7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ApiDataConversionConstants = _apiDataConversionConstants2.default;
exports.CurrencyFormats = _currencyFormats2.default;
exports.DataConversions = _dataConversions2.default;
exports.DataOrigins = _dataOrigins2.default;
exports.DataTypes = _dataTypes2.default;
exports.EVENTS = _events2.default;
exports.VehicleConstants = _vehicle2.default;
exports.ShowroomService = _ShowroomService2.default;
exports.ModelYear = _index2.default;
exports.PurchaseMethods = _index4.default;
exports.Quote = _index6.default;
exports.Vehicle = _index8.default;
exports.default = {
    ApiDataConversionConstants: _apiDataConversionConstants2.default,
    CurrencyFormats: _currencyFormats2.default,
    DataConversions: _dataConversions2.default,
    DataOrigins: _dataOrigins2.default,
    DataTypes: _dataTypes2.default,
    EVENTS: _events2.default,
    VehicleConstants: _vehicle2.default,

    ShowroomService: _ShowroomService2.default,

    ModelYear: _index2.default,
    PurchaseMethods: _index4.default,
    Quote: _index6.default,
    Vehicle: _index8.default
};

/***/ }),

/***/ "./src/services/ShowroomService/ShowroomAPIService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _axios = __webpack_require__("../../node_modules/axios/index.js");

var _axios2 = _interopRequireDefault(_axios);

var _index = __webpack_require__("./src/config/index.js");

var _index2 = _interopRequireDefault(_index);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ShowroomAPIService = function () {
    function ShowroomAPIService() {
        _classCallCheck(this, ShowroomAPIService);

        this.basePath = _index2.default.endpoint.showroom + '/service/v1';
    }

    _createClass(ShowroomAPIService, [{
        key: 'getPublicToken',
        value: function getPublicToken() {
            return _axios2.default.get(this.basePath + '/jwt?userName=public&password=public');
        }
    }, {
        key: 'saveQuote',
        value: function saveQuote(quote, token, quoteContext) {
            if (!quote || !token) {
                return Promise.reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('missing parameters'));
            }

            var orgId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
            var orgUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
            var location = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitLocation().toLowerCase();
            var locale = _widgetCommonsCoreServices.LocaleService.getLocale();

            var context = 'refresh=1&location=' + location + '&datalevel=1&context=' + orgId + '.' + orgUnitId + '&language=' + locale;

            if (quote.securityToken) {
                context += '&securityToken=' + quote.securityToken;
            }

            if (quoteContext) {
                context += '&' + quoteContext;
            }

            return _axios2.default.put(this.basePath + '/Quote?' + context, quote, { headers: { 'x-jwt': token } }).then(function (result) {
                return Promise.resolve(result.data);
            });
        }
    }]);

    return ShowroomAPIService;
}();

exports.default = new ShowroomAPIService();

/***/ }),

/***/ "./src/services/ShowroomService/ShowroomService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _axios = __webpack_require__("../../node_modules/axios/index.js");

var _axios2 = _interopRequireDefault(_axios);

var _immutable = __webpack_require__("immutable");

var _lodash = __webpack_require__("lodash");

var _index = __webpack_require__("./src/config/index.js");

var _index2 = _interopRequireDefault(_index);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _modelTrimItemCategories = __webpack_require__("./src/Quote/constants/modelTrimItemCategories.js");

var _vehicle = __webpack_require__("./src/constants/vehicle.js");

var _vehicle2 = _interopRequireDefault(_vehicle);

var _dataTypes = __webpack_require__("./src/constants/dataTypes.js");

var dataTypes = _interopRequireWildcard(_dataTypes);

var _dataOrigins = __webpack_require__("./src/constants/dataOrigins.js");

var DataOrigins = _interopRequireWildcard(_dataOrigins);

var _ModelYearService = __webpack_require__("./src/ModelYear/services/ModelYearService/ModelYearService.js");

var _QuoteService = __webpack_require__("./src/Quote/services/QuoteService/QuoteService.js");

var _QuoteItemCategoryService = __webpack_require__("./src/Quote/services/QuoteItemCategoryService/QuoteItemCategoryService.js");

var _QuoteModel = __webpack_require__("./src/Quote/models/QuoteModel.js");

var _QuoteModel2 = _interopRequireDefault(_QuoteModel);

var _QuoteItemCategoryModel = __webpack_require__("./src/Quote/models/QuoteItemCategoryModel.js");

var _QuoteItemCategoryModel2 = _interopRequireDefault(_QuoteItemCategoryModel);

var _PurchaseMethodsService = __webpack_require__("./src/PurchaseMethods/services/PurchaseMethodsService/PurchaseMethodsService.js");

var _VehicleService = __webpack_require__("./src/Vehicle/services/VehicleService/VehicleService.js");

var _ModelYearModel = __webpack_require__("./src/ModelYear/models/ModelYearModel.js");

var _ModelYearModel2 = _interopRequireDefault(_ModelYearModel);

var _PurchaseMethodsModel = __webpack_require__("./src/PurchaseMethods/models/PurchaseMethodsModel.js");

var _PurchaseMethodsModel2 = _interopRequireDefault(_PurchaseMethodsModel);

var _ShowroomAPIService = __webpack_require__("./src/services/ShowroomService/ShowroomAPIService.js");

var _ShowroomAPIService2 = _interopRequireDefault(_ShowroomAPIService);

var _DisclaimerAPIService = __webpack_require__("./src/PurchaseMethods/services/PurchaseMethodsAPIService/DisclaimerAPIService.js");

var _DisclaimerAPIService2 = _interopRequireDefault(_DisclaimerAPIService);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Util to uppercase the given value and encode the result to be URI compliant
 * @param {String} value String to modify
 * @returns {String} value or empty string if given param is not a string
 */
function upperEncodedString(value) {
    if ((0, _lodash.isString)(value)) {
        return (0, _lodash.toUpper)(encodeURIComponent(value));
    }
    return '';
}

function resetPurchaseMethodsDiscount(purchaseMethods, sellingPrice, discount) {
    var newCashPurchase = purchaseMethods.cashPurchase;
    newCashPurchase = newCashPurchase.set('retail', sellingPrice + discount).set('discounts', discount);

    var newFinanceTerms = (0, _lodash.map)(purchaseMethods.finance.terms, function (term) {
        return term.set('discounts', discount);
    });
    var newFinance = purchaseMethods.finance.set('terms', newFinanceTerms);

    var newLeaseTerms = (0, _lodash.map)(purchaseMethods.lease.terms, function (term) {
        return term.set('discounts', discount);
    });
    var newLease = purchaseMethods.lease.set('terms', newLeaseTerms);

    return purchaseMethods.set('cashPurchase', newCashPurchase).set('finance', newFinance).set('lease', newLease);
}

// TODO: #complete - documentation & tests

var ShowroomService = function () {
    function ShowroomService() {
        _classCallCheck(this, ShowroomService);

        this.basePath = _index2.default.endpoint.showroom + '/service/v1';
    }

    _createClass(ShowroomService, [{
        key: 'getModelYear',
        value: function getModelYear(callType, year, make, model, bodyStyleCode, modelTrimCode, locale) {
            var _this = this;

            var urlMakeModelSection = 'make=' + upperEncodedString(make) + '&model=' + upperEncodedString(model) + ('&bodyStyleCode=' + upperEncodedString(bodyStyleCode));

            var modelString = callType === DataOrigins.MODEL_YEARS ? urlMakeModelSection + '&subGrouping=year&datalevel=768' : 'year=' + year + '&' + urlMakeModelSection + '&datalevel=256';

            var organizationId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
            var organizationUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
            var location = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitLocation();
            var context = 'location=' + location + ('&language=' + locale) + ('&context=' + organizationId + '.' + organizationUnitId) + ('&' + modelString) + '&compact=false&userName=public&password=public';

            return new Promise(function (resolve) {
                switch (callType) {
                    case DataOrigins.MODELS_COLLECTION:
                        _axios2.default.get(_this.basePath + '/view/1?' + context).then(function (result) {
                            var vehicles = (0, _ModelYearService.resetModelYearFromOriginData)(callType, result.data.view, locale);
                            resolve(vehicles[0].purchaseMethods);
                        });
                        break;

                    case DataOrigins.MODEL_YEARS:
                        _axios2.default.get(_this.basePath + '/view/1.1?' + context).then(function (result) {
                            resolve((0, _ModelYearService.resetModelYearFromOriginData)(callType, result.data.view, locale));
                        });
                        break;

                    case DataOrigins.MODEL_YEAR_POWERS_TRIMS:
                        _axios2.default.get(_this.basePath + '/view/2.1?unfiltered=true&' + context).then(function (result) {
                            resolve((0, _ModelYearService.resetModelYearFromOriginData)(callType, result.data.view, locale));
                        });
                        break;

                    default:
                        resolve({
                            modelYear: new _ModelYearModel2.default(),
                            purchaseMethods: new _PurchaseMethodsModel2.default()
                        });
                }
            });
        }
    }, {
        key: 'getModels',
        value: function getModels(callType, makes, locale) {
            var _this2 = this;

            var makesQuery = (0, _lodash.join)(makes, '|');
            var modelString = 'make=' + makesQuery + '&datalevel=256';

            var organizationId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
            var organizationUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
            var location = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitLocation();
            var context = 'location=' + location + ('&language=' + locale) + ('&context=' + organizationId + '.' + organizationUnitId) + ('&' + modelString) + '&compact=false&userName=public&password=public';

            return _DisclaimerAPIService2.default.getGenericDisclaimers().then(function (disclaimers) {
                switch (callType) {
                    case DataOrigins.MODELS_COLLECTION:
                        return _axios2.default.get(_this2.basePath + '/view/1?' + context).then(function (result) {
                            return (0, _immutable.fromJS)((0, _ModelYearService.resetModelYearFromOriginData)(callType, result.data.view, locale, disclaimers));
                        });

                    default:
                        return Promise.resolve((0, _immutable.List)([]));
                }
            });
        }
    }, {
        key: 'validateSelectedOptions',
        value: function validateSelectedOptions(callType, year, make, configuration, locale, optionSelectionCode, selectionResolutions) {
            var _this3 = this;

            var organizationUnitLocation = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitLocation();
            var organizationId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
            var organizationUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
            var parameters = 'location=' + organizationUnitLocation + ('&language=' + locale) + '&includeNonManufacturerItems=true&datalevel=65535&userName=public&password=public' + ('&context=' + organizationId + '.' + organizationUnitId);

            var selectedItems = configuration.getValidationSelectedOptions();
            if (selectionResolutions) {
                selectedItems = selectionResolutions.getResolutionActionOptions(selectedItems);
            }

            return new Promise(function (resolve, reject) {
                switch (callType) {
                    case DataOrigins.OPTIONS_VALIDATION:
                        _axios2.default.post(_this3.basePath + '/builder?' + parameters, {
                            year: year,
                            make: make,
                            modelTrimCode: configuration.get('modelTrimCode'),
                            configurationID: configuration.get('id'),
                            purchaseMethod: configuration.get('purchaseMethods').getSelectedPurchaseMethodValue(),
                            term: configuration.get('purchaseMethods').getSelectedFinanceTermValue(),
                            items: selectedItems
                        }).then(function (result) {
                            if (result.data.resolutions) {
                                reject({
                                    optionSelectionCode: optionSelectionCode,
                                    errors: result.data.errors,
                                    resolutions: result.data.resolutions
                                });
                            }
                            resolve(result.data);
                        });
                        break;

                    default:
                        resolve([]);
                }
            });
        }
    }, {
        key: 'getVehicleId',
        value: function getVehicleId(vehicle) {
            var vehicleConditionType = vehicle.vehicleConditionType,
                year = vehicle.year,
                make = vehicle.make,
                model = vehicle.model,
                bodyStyleCode = vehicle.bodyStyleCode,
                driveTrainCode = vehicle.driveTrainCode,
                odometer = vehicle.odometer,
                sellingPrice = vehicle.sellingPrice;


            return vehicleConditionType + '|' + year + '|' + make + '|' + model + '|' + (bodyStyleCode + '|' + driveTrainCode + '|' + ((0, _lodash.isNull)(odometer) ? 0 : odometer) + '|' + sellingPrice);
        }
    }, {
        key: 'getVehiclePayments',
        value: function getVehiclePayments(vehicle, oldPurchaseMethods) {
            var _this4 = this;

            var organizationId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
            var organizationUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
            var location = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitLocation();
            var context = 'location=' + location + ('&language=' + _widgetCommonsCoreServices.LocaleService.getLocale()) + ('&context=' + organizationId + '.' + organizationUnitId) + '&datalevel=65535&userName=public&password=public';

            var year = vehicle.year,
                make = vehicle.make,
                model = vehicle.model,
                bodyStyleCode = vehicle.bodyStyleCode,
                driveTrainCode = vehicle.driveTrainCode,
                odometer = vehicle.odometer,
                vehicleConditionType = vehicle.vehicleConditionType,
                sellingPrice = vehicle.sellingPrice,
                discount = vehicle.discount;


            var isUsed = vehicleConditionType === _vehicle2.default.CONDITIONS.USED || vehicleConditionType === _vehicle2.default.CONDITIONS.CERTIFIED;
            var paymentParameters = {
                year: year,
                make: make,
                model: model,
                bodyStyleCode: bodyStyleCode,
                driveTrainCode: driveTrainCode,
                odometer: odometer,
                vehicleCondition: vehicleConditionType,
                amounts: isUsed ? { retail: sellingPrice } : null
            };

            return _DisclaimerAPIService2.default.getGenericDisclaimers().then(function (disclaimers) {
                return _axios2.default.post(_this4.basePath + '/vehiclePayments?' + context, paymentParameters).then(function (result) {
                    var purchaseMethods = (0, _PurchaseMethodsService.resetPurchaseMethodsFromOriginData)(DataOrigins.VEHICLE_PAYMENTS, result.data, oldPurchaseMethods, disclaimers);
                    if (isUsed) {
                        purchaseMethods = (0, _PurchaseMethodsService.resetPurchaseMethodsOptionsFromQuoteItems)(purchaseMethods, [vehicle.getDefaultVehicleQuoteItem()]);
                        if (discount) {
                            purchaseMethods = resetPurchaseMethodsDiscount(purchaseMethods, sellingPrice, discount);
                        }
                    }
                    var vehicleWithPurchaseMethods = (0, _VehicleService.setVehiclePurchaseMethods)(vehicle, purchaseMethods);

                    return _DisclaimerAPIService2.default.getVehiclesDisclaimers([vehicleWithPurchaseMethods]).then(function (vehiclesWithDisclaimers) {
                        return Promise.resolve(vehiclesWithDisclaimers[0]);
                    });
                });
            });
        }
    }, {
        key: 'getVehiclesPayments',
        value: function getVehiclesPayments(vehicles, purchaseMethod, termMinimum, termMaximum) {
            var _this5 = this;

            var organizationId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
            var organizationUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
            var location = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitLocation();
            var language = _widgetCommonsCoreServices.LocaleService.getLocale();
            var context = 'language=' + language + '&location=' + location + '&context=' + organizationId + '.' + organizationUnitId + '&userName=public&password=public';

            var paymentParameters = {
                termMinimum: termMinimum,
                termMaximum: termMaximum,
                purchaseMethod: purchaseMethod,
                vehicles: vehicles.map(function (vehicle) {
                    return vehicle.getPaymentCalculatorVehicleParameters();
                })
            };

            return _DisclaimerAPIService2.default.getGenericDisclaimers().then(function (disclaimers) {
                return _axios2.default.post(_this5.basePath + '/sm360core.paymentCalculator?' + context, paymentParameters).then(function (result) {
                    var newVehicles = [];
                    (0, _lodash.forEach)(vehicles, function (vehicle) {
                        var matchVehicle = (0, _lodash.find)(result.data.vehicles, function (resultVehicle) {
                            return _this5.getVehicleId(resultVehicle) === _this5.getVehicleId(vehicle);
                        });

                        if (matchVehicle) {
                            result.data.vehicle = matchVehicle;
                            var newPurchaseMethods = (0, _PurchaseMethodsService.resetPurchaseMethodsFromOriginData)(DataOrigins.PAYMENT_CALCULATOR, result.data);
                            newPurchaseMethods = newPurchaseMethods.set('disclaimers', disclaimers);

                            if (!vehicle.getIsVehicleNew() && vehicle.discount) {
                                newPurchaseMethods = resetPurchaseMethodsDiscount(newPurchaseMethods, vehicle.sellingPrice, vehicle.discount);
                            }
                            var newVehicle = (0, _VehicleService.setVehiclePurchaseMethods)(vehicle, newPurchaseMethods);
                            newVehicles.push(newVehicle);
                        } else {
                            newVehicles.push(vehicle);
                        }
                    });

                    return _DisclaimerAPIService2.default.getVehiclesDisclaimers(newVehicles);
                });
            });
        }
    }, {
        key: 'loadQuote',
        value: function loadQuote(quoteId) {
            var _this6 = this;

            return _DisclaimerAPIService2.default.getGenericDisclaimers().then(function (disclaimers) {
                return _ShowroomAPIService2.default.getPublicToken().then(function (response) {
                    var userCookie = _widgetCommonsGeneral.CookieService.getToken(_widgetCommonsGeneral.COOKIES.ACCOUNT.AUTHENTICATE_TOKEN);
                    var organizationId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
                    var organizationUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
                    var location = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitLocation();
                    var language = _widgetCommonsCoreServices.LocaleService.getLocale();
                    var context = 'datalevel=7&source=4&dataTypes=3&context=' + organizationId + '.' + organizationUnitId + ('&location=' + location + '&language=' + language);

                    return _axios2.default.get(_this6.basePath + '/Quote/' + quoteId + '?' + context, {
                        headers: {
                            'x-jwt': userCookie || response.data
                        }
                    }).then(function (result) {
                        var quote = (0, _QuoteService.resetQuoteFromShowroomLoad)(new _QuoteModel2.default(), result.data, disclaimers);

                        return Promise.resolve(quote);
                    });
                });
            });
        }

        // SHOWROOM V2.5

    }, {
        key: 'loadQuoteV25',
        value: function loadQuoteV25(quoteId) {
            var _this7 = this;

            return _DisclaimerAPIService2.default.getGenericDisclaimers().then(function (disclaimers) {
                var organizationId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
                var organizationUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
                var location = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitLocation();
                var language = _widgetCommonsCoreServices.LocaleService.getLocale();
                var context = 'datalevel=7&source=4&dataTypes=3&context=' + organizationId + '.' + organizationUnitId + ('&location=' + location + '&language=' + language + '&userName=public&password=public');
                return _axios2.default.get(_this7.basePath + '/Quote/' + quoteId + '?' + context, {}).then(function (result) {
                    var data = result.data;

                    data.accountId = '';
                    data.id = '';
                    var quote = (0, _QuoteService.resetQuoteFromShowroomLoad)(new _QuoteModel2.default(), data, disclaimers);

                    return Promise.resolve(quote);
                });
            });
        }
    }, {
        key: 'loadQuotes',
        value: function loadQuotes() {
            var token = _widgetCommonsGeneral.CookieService.getToken(_widgetCommonsGeneral.COOKIES.ACCOUNT.AUTHENTICATE_TOKEN);
            return this.searchQuotes(token);
        }
    }, {
        key: 'loadQuotesByLeadId',
        value: function loadQuotesByLeadId(leadId) {
            if (!(0, _lodash.isNumber)(leadId)) {
                throw TypeError('param [leadId] must be a number');
            }
            var token = _widgetCommonsCoreServices.ConfigsService.getDeskingToken();
            return this.searchQuotes(token, { leadId: leadId });
        }
    }, {
        key: 'searchQuotes',
        value: function searchQuotes(token, searchParams) {
            var organizationId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
            var organizationUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
            var location = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitLocation();
            var language = _widgetCommonsCoreServices.LocaleService.getLocale();
            var context = (location ? 'location=' + location + '&' : '') + 'language=' + language + '&context=' + organizationId + '.' + organizationUnitId;

            var searchParamsString = '';
            if (searchParams) {
                searchParamsString = Object.entries(searchParams).map(function (_ref) {
                    var _ref2 = _slicedToArray(_ref, 2),
                        key = _ref2[0],
                        val = _ref2[1];

                    return key + '=' + val;
                }).join('&');
            }

            var url = this.basePath + '/Quotes?' + context + '&offset=0&limit=10&quoteDetail=true&datalevel=3' + ('' + (searchParamsString ? '&' + searchParamsString : ''));

            return _axios2.default.get(url, {
                headers: {
                    'x-jwt': token
                }
            }).then(function (result) {
                var quotes = [];
                if ((0, _lodash.isEmpty)(result.data)) {
                    return Promise.resolve(quotes);
                }

                (0, _lodash.forEach)(result.data, function (showroomQuote) {
                    quotes.push((0, _QuoteService.resetQuoteFromShowroomLoad)(new _QuoteModel2.default(), showroomQuote));
                });
                return Promise.resolve(quotes);
            });
        }
    }, {
        key: 'saveQuote',
        value: function saveQuote(quote, validateOnly) {
            if (!_widgetCommonsGeneral.AccountService.isAuthenticated()) {
                return this.saveQuoteToPublic(quote, validateOnly);
            }

            return this.saveQuoteToUser(quote, validateOnly);
        }
    }, {
        key: 'saveQuoteToUser',
        value: function saveQuoteToUser(quote) {
            var validateOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var quoteContext = validateOnly && 'validateOnly=1';
            var userCookie = _widgetCommonsGeneral.CookieService.getToken(_widgetCommonsGeneral.COOKIES.ACCOUNT.AUTHENTICATE_TOKEN);

            return _ShowroomAPIService2.default.saveQuote(quote, userCookie, quoteContext);
        }
    }, {
        key: 'saveQuoteToPublic',
        value: function saveQuoteToPublic(quote) {
            var validateOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var quoteContext = validateOnly ? 'validateOnly=1' : !quote.securityToken && 'createWriteToken=true';

            return _ShowroomAPIService2.default.getPublicToken().then(function (response) {
                return _ShowroomAPIService2.default.saveQuote(quote, response.data, quoteContext);
            });
        }
    }, {
        key: 'deleteQuote',
        value: function deleteQuote(quote) {
            if (!quote) {
                return Promise.reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('missing parameters'));
            }
            return this.saveQuote(quote, false);
        }
    }, {
        key: 'getIdentificationTypes',
        value: function getIdentificationTypes() {
            var locale = _widgetCommonsCoreServices.LocaleService.getLocale();
            return _axios2.default.get(this.basePath + '/IdentificationTypes?language=' + locale + '&userName=public&password=public').then(function (result) {
                return Promise.resolve(result.data);
            });
        }
    }, {
        key: 'loadQuoteProtections',
        value: function loadQuoteProtections(quoteId) {
            var _this8 = this;

            var token = _widgetCommonsGeneral.CookieService.getToken(_widgetCommonsGeneral.COOKIES.ACCOUNT.AUTHENTICATE_TOKEN);
            var organizationId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
            var organizationUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
            var locale = _widgetCommonsCoreServices.LocaleService.getLocale();
            var source = _modelTrimItemCategories.ITEM_SOURCE.DEALER + '|' + _modelTrimItemCategories.ITEM_SOURCE.SUPPLIER;
            var context = 'source=' + source + '&context=' + organizationId + '.' + organizationUnitId + '&language=' + locale;

            return this.getIdentificationTypes().then(function (identificationTypes) {
                var protectionCategories = [];
                if ((0, _lodash.isEmpty)(identificationTypes) || (0, _lodash.isEmpty)(identificationTypes.identificationDataTypes)) {
                    return Promise.reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('no protections categories'));
                }
                var protectionDataType = (0, _lodash.find)(identificationTypes.identificationDataTypes, function (resultDataType) {
                    return resultDataType.dataType === dataTypes.DATA_TYPES.PROTECTION.DATA_TYPE_ID;
                });
                if (!protectionDataType) {
                    return Promise.reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('no protections categories'));
                }

                protectionCategories = (0, _lodash.orderBy)((0, _lodash.map)(protectionDataType.categories, function (category) {
                    return (0, _QuoteItemCategoryService.resetQuoteItemCategoryFromCategory)(new _QuoteItemCategoryModel2.default(), dataTypes.DATA_TYPES.PROTECTION.DATA_TYPE_ID, category);
                }), ['order']);

                return _axios2.default.get(_this8.basePath + '/QuoteItems/' + quoteId + '?' + context, {
                    headers: {
                        'x-jwt': token
                    }
                }).then(function (result) {
                    if ((0, _lodash.isEmpty)(result.data)) {
                        return Promise.resolve([]);
                    }
                    return Promise.resolve((0, _QuoteItemCategoryService.resetQuoteItemCategoriesFromQuoteProtections)(protectionCategories, result.data));
                });
            });
        }
    }, {
        key: 'loadModelTrimOptions',
        value: function loadModelTrimOptions(year, make, configuration) {
            var ITEM_DATA_LEVEL = dataTypes.ITEM_DATA_LEVEL;

            var datalevel = ITEM_DATA_LEVEL.AVAILABLE | ITEM_DATA_LEVEL.PRICING | ITEM_DATA_LEVEL.DESCRIPTIONS | ITEM_DATA_LEVEL.DEALER_ITEMS;
            var organizationId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
            var organizationUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
            var location = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitLocation();
            var locale = _widgetCommonsCoreServices.LocaleService.getLocale();
            var context = 'datalevel=' + datalevel + '&context=' + organizationId + '.' + organizationUnitId + '&location=' + location + '&language=' + locale + '&userName=public&password=public';

            return _axios2.default.post(this.basePath + '/modelTrimItems?' + context, {
                year: year,
                make: make,
                modelTrimCode: configuration.modelTrimCode,
                configurationID: configuration.id
            }).then(function (result) {
                return Promise.resolve(result.data.items);
            });
        }
    }, {
        key: 'getQuoteVehiclePayments',
        value: function getQuoteVehiclePayments(vehicle, locale) {
            var _this9 = this;

            var organizationId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
            var organizationUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
            var location = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitLocation();
            var context = 'location=' + location + ('&language=' + locale) + ('&context=' + organizationId + '.' + organizationUnitId) + '&datalevel=65535&userName=public&password=public';

            var year = vehicle.year,
                make = vehicle.make,
                model = vehicle.model,
                modelTrimCode = vehicle.modelTrimCode,
                configurationID = vehicle.configurationID,
                vehicleCondition = vehicle.vehicleCondition,
                retail = vehicle.retail;


            var isUsed = vehicleCondition === _vehicle2.default.CONDITIONS.USED || vehicleCondition === _vehicle2.default.CONDITIONS.CERTIFIED;
            var paymentParameters = {
                year: year,
                make: make,
                model: model,
                modelTrimCode: modelTrimCode,
                configurationID: configurationID,
                vehicleCondition: vehicleCondition,
                amounts: isUsed ? { retail: retail } : null
            };

            return new Promise(function (resolve) {
                _axios2.default.post(_this9.basePath + '/vehiclePayments?' + context, paymentParameters).then(function (result) {
                    resolve((0, _PurchaseMethodsService.resetPurchaseMethodsFromOriginData)(DataOrigins.VEHICLE_PAYMENTS, result.data));
                });
            });
        }
    }, {
        key: 'getQuoteVehicleModelYear',
        value: function getQuoteVehicleModelYear(vehicle, locale) {
            var _this10 = this;

            var year = vehicle.year,
                make = vehicle.make,
                model = vehicle.model,
                modelTrimCode = vehicle.modelTrimCode,
                configurationID = vehicle.configurationID;


            var modelString = 'year=' + year + '&make=' + make + '&model=' + model + '&modelTrimCode=' + modelTrimCode + '&datalevel=256';

            var organizationId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
            var organizationUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
            var location = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitLocation();
            var context = 'location=' + location + ('&language=' + locale) + ('&context=' + organizationId + '.' + organizationUnitId) + ('&' + modelString) + '&compact=false&userName=public&password=public';

            return new Promise(function (resolve) {
                _axios2.default.get(_this10.basePath + '/view/2.1?' + context).then(function (result) {
                    var modelYear = (0, _ModelYearService.resetModelYearFromOriginData)(DataOrigins.MODEL_YEAR_POWERS_TRIMS, result.data.view, locale);
                    modelYear = (0, _ModelYearService.setSelectedOptionsPackage)(modelYear.modelYear, modelYear.modelYear.getOptionsPackageFromConfigurationId(configurationID), true);
                    resolve(modelYear.getVehicleFromConfiguration());
                });
            });
        }
    }, {
        key: 'saveCreditApplication',
        value: function saveCreditApplication(creditApplication) {
            var _this11 = this;

            if (!creditApplication) {
                return Promise.reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('missing parameters'));
            } else if (!_widgetCommonsGeneral.AccountService.isAuthenticated()) {
                return Promise.reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('not connected'));
            }
            var organizationId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
            var organizationUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
            var context = 'context=' + organizationId + '.' + organizationUnitId;
            var userCookie = _widgetCommonsGeneral.CookieService.getToken(_widgetCommonsGeneral.COOKIES.ACCOUNT.AUTHENTICATE_TOKEN);
            return new Promise(function (resolve) {
                return _axios2.default.put(_this11.basePath + '/CreditApplication?' + context, creditApplication, {
                    headers: { 'x-jwt': userCookie }
                }).then(function (result) {
                    resolve(result.data);
                });
            });
        }
    }, {
        key: 'loadCreditApplication',
        value: function loadCreditApplication(creditApplicationId) {
            var _this12 = this;

            var organizationId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
            var organizationUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
            var context = 'context=' + organizationId + '.' + organizationUnitId;
            var userCookie = _widgetCommonsGeneral.CookieService.getToken(_widgetCommonsGeneral.COOKIES.ACCOUNT.AUTHENTICATE_TOKEN);
            var creditApplicationIdParam = creditApplicationId ? '/' + creditApplicationId : '';

            return new Promise(function (resolve) {
                return _axios2.default.get(_this12.basePath + '/CreditApplication' + creditApplicationIdParam + '?' + context, {
                    headers: { 'x-jwt': userCookie }
                }).then(function (result) {
                    resolve(result.data);
                });
            });
        }
    }, {
        key: 'saveTradeInVehicle',
        value: function saveTradeInVehicle(tradeIn) {
            var _this13 = this;

            if (!tradeIn) {
                return Promise.reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('missing parameters'));
            } else if (!_widgetCommonsGeneral.AccountService.isAuthenticated()) {
                return Promise.reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('user not authenticated'));
            }
            var organizationId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
            var organizationUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
            var context = 'context=' + organizationId + '.' + organizationUnitId;
            var userCookie = _widgetCommonsGeneral.CookieService.getToken(_widgetCommonsGeneral.COOKIES.ACCOUNT.AUTHENTICATE_TOKEN);
            return new Promise(function (resolve) {
                return _axios2.default.put(_this13.basePath + '/TradeInVehicle?' + context + '&updateQuotes=true', tradeIn, {
                    headers: { 'x-jwt': userCookie }
                }).then(function (result) {
                    resolve(result.data);
                });
            });
        }
    }, {
        key: 'loadTradeInVehicle',
        value: function loadTradeInVehicle(tradeInVehicleId) {
            var _this14 = this;

            if (!_widgetCommonsGeneral.AccountService.isAuthenticated()) {
                return Promise.reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('user not authenticated'));
            }
            var organizationId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
            var organizationUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
            var context = 'context=' + organizationId + '.' + organizationUnitId;
            var language = 'locale=' + _widgetCommonsCoreServices.LocaleService.getLocale();
            var location = 'location=' + _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitLocation();
            var userCookie = _widgetCommonsGeneral.CookieService.getToken(_widgetCommonsGeneral.COOKIES.ACCOUNT.AUTHENTICATE_TOKEN);
            var tradeInVehicleIdParam = tradeInVehicleId ? '/' + tradeInVehicleId : '';

            return new Promise(function (resolve) {
                return _axios2.default.get(_this14.basePath + '/TradeInVehicle' + tradeInVehicleIdParam + '?' + [context, language, location].join('&'), { headers: { 'x-jwt': userCookie } }).then(function (result) {
                    resolve(result.data);
                });
            });
        }
    }]);

    return ShowroomService;
}();

exports.default = new ShowroomService();

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./src/index.js");


/***/ }),

/***/ "@sm360/widget-commons-basic-components":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__sm360_widget_commons_basic_components__;

/***/ }),

/***/ "@sm360/widget-commons-core-services":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__sm360_widget_commons_core_services__;

/***/ }),

/***/ "@sm360/widget-commons-forms":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__sm360_widget_commons_forms__;

/***/ }),

/***/ "@sm360/widget-commons-general":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__sm360_widget_commons_general__;

/***/ }),

/***/ "immutable":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_immutable__;

/***/ }),

/***/ "lodash":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_lodash__;

/***/ }),

/***/ "react":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_react__;

/***/ })

/******/ });
});


// WEBPACK FOOTER //
// widget-6.25.3.min.js